//----------------------
// <auto-generated>
//     Do not modify ApiClient.ts directly. It is autogenerated from the backend build.
//
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* prettier-ignore */
/* eslint-disable */

import axios, { type AxiosError, type AxiosInstance, type AxiosRequestConfig } from 'axios';

/**
 * Writes a dictionary query parameter the way ASP.NET's model binder reads it back: the key in
 * brackets, then arrays by index and object properties by name — `Ranges[eu].min=10`,
 * `OptionIds[7][0]=42`. Without this a dictionary would be interpolated as `[object Object]`.
 */
function appendDictionaryQuery(name: string, value: { [key: string]: any; }): string {
  const pairs: string[] = [];

  const write = (prefix: string, current: any) => {
    if (current === undefined) return;
    // An empty value binds to null; the literal text "null" would not.
    if (current === null) return void pairs.push(prefix + "=");
    if (Array.isArray(current)) {
      current.forEach((item, index) => write(prefix + "[" + index + "]", item));
    } else if (typeof current === "object") {
      for (const key in current) write(prefix + "." + key, current[key]);
    } else {
      pairs.push(prefix + "=" + encodeURIComponent("" + current));
    }
  };

  for (const key in value) write(name + "[" + encodeURIComponent(key) + "]", value[key]);

  return pairs.length ? pairs.join("&") + "&" : "";
}

export interface ArtboardLink_GetSuggestedArtboardArticlesArgs {
  brandId: number;
  productId: number;
  productFileId: number;
  artboardId?: string;
  /** The part's left edge in points, with y, width and
            height; leave all four out for the whole artboard. */
  x?: number | null;
  y?: number | null;
  width?: number | null;
  height?: number | null;
}

export interface ArtboardLink_SetArtboardLinkRegionArgs {
  brandId: number;
  productId: number;
  productFileId: number;
  renderId: number;
  region: ArtboardRect;
}

export interface ArtboardLink_SetArtboardLinkArticlesArgs {
  brandId: number;
  productId: number;
  productFileId: number;
  renderId: number;
  articleIds: number[];
}

export interface ArtboardLink_ResolveArtboardLinkConflictArgs {
  brandId: number;
  productId: number;
  productFileId: number;
  renderId: number;
  /** True renders the artboard over the image again; false keeps the image as it is
            and stops it following the artboard. */
  overwrite: boolean;
}

export interface Article_NudgeGateArgs {
  brandId: number;
  id: number;
  seasonId: number;
  gateId: number;
  nudgeArgs: NudgeGateArgs;
}

export interface Article_ExportArticlesCsvArgs {
  brandId: number;
  hierarchyNodeIds?: number[] | null;
  productCategoryIds?: number[] | null;
  genders?: Gender[] | null;
  seasonIds?: number[] | null;
  colors?: FiltersColor[] | null;
  supplierIds?: number[] | null;
  dropDateRange?: {
    from?: string | null;
    to?: string | null;
  };
  dropNames?: string[] | null;
  statusIds?: number[] | null;
  tagIds?: number[] | null;
  searchTerm?: string | null;
  customFieldOptionIds?: { [key: string]: number[]; } | null;
  createdByUserIds?: string[] | null;
  assignedUserIds?: string[] | null;
  colorGroupIds?: number[] | null;
  outPriceAmounts?: { [key: string]: number[]; } | null;
  outPriceRanges?: { [key: string]: OutPriceRange; } | null;
  sizeSystemIds?: number[] | null;
  timelineHealth?: TimelineHealthFilter[] | null;
  nextGateRoleIds?: number[] | null;
  nextGateNames?: string[] | null;
  activeSeasonId?: number | null;
}

export interface Bom_SearchComponentsArgs {
  brandId: number;
  bomId: number;
  query?: string | null;
  offset?: number;
  limit?: number;
}

export interface BomSectionTemplate_ListSectionTemplatesArgs {
  brandId: number;
  hierarchyNodeId?: number | null;
  searchQuery?: string | null;
  limit?: number;
  offset?: number;
}

export interface BomSectionTemplate_ListBomsToCopyArgs {
  brandId: number;
  bomId?: number | null;
  searchQuery?: string | null;
  limit?: number;
  offset?: number;
}

export interface BrandColor_SearchLibraryColorsArgs {
  brandId: number;
  searchTerm: string | null;
  libraryId?: number;
  take?: number;
  offset?: number;
}

export interface Color_SearchColorsArgs {
  brandId: number;
  searchTerm: string | null;
  paletteId?: number;
  libraryId?: number;
  take?: number;
  offset?: number;
}

export interface Component_GetComponentsListArgs {
  brandId: number;
  filters?: {
    searchTerm?: string | null;
    extendedSearch?: boolean;
    materialIds?: number[] | null;
    seasonIds?: number[] | null;
    tagIds?: number[] | null;
    supplierIds?: number[] | null;
    typeIds?: number[] | null;
    subTypeIds?: number[] | null;
    statusIds?: (number | undefined)[] | null;
    createdByUserIds?: string[] | null;
    customFieldOptionIds?: { [key: string]: number[]; } | null;
    certificateIds?: number[] | null;
    attributeFilters?: AttributeFilter[] | null;
    treatmentIds?: number[] | null;
    colorGroupIds?: number[] | null;
    countryOfOriginIds?: number[] | null;
    articleIds?: number[] | null;
  };
  limit?: number;
  offset?: number;
}

export interface Component_GetExcelFileForFilteredComponentsArgs {
  brandId: number;
  filters?: {
    searchTerm?: string | null;
    extendedSearch?: boolean;
    materialIds?: number[] | null;
    seasonIds?: number[] | null;
    tagIds?: number[] | null;
    supplierIds?: number[] | null;
    typeIds?: number[] | null;
    subTypeIds?: number[] | null;
    statusIds?: (number | undefined)[] | null;
    createdByUserIds?: string[] | null;
    customFieldOptionIds?: { [key: string]: number[]; } | null;
    certificateIds?: number[] | null;
    attributeFilters?: AttributeFilter[] | null;
    treatmentIds?: number[] | null;
    colorGroupIds?: number[] | null;
    countryOfOriginIds?: number[] | null;
    articleIds?: number[] | null;
  };
  imageSize?: ExcelImageSize;
}

export interface History_GetArticleArgs {
  brandId: number;
  articleNumber: string;
  includeProduct?: boolean;
  seasonId?: number | null;
  since?: string | null;
}

export interface InboundEmail_HandleInboundEmailArgs {
  secret: string;
  to?: string | null;
  from?: string | null;
  text?: string | null;
  headers?: string | null;
  dkim?: string | null;
}

export interface Order_GetOrdersArgs {
  brandId: number;
  supplierIds?: number[] | null;
  seasonIds?: number[] | null;
  tagIds?: number[] | null;
  statusIds?: number[] | null;
  hierarchyNodeIds?: number[] | null;
  productCategoryIds?: number[] | null;
  customFieldOptionIds?: number[] | null;
  searchTerm?: string | null;
}

export interface Overview_GetBucketsArgs {
  brandId: number;
  hierarchyNodeIds?: number[] | null;
  productCategoryIds?: number[] | null;
  genders?: Gender[] | null;
  seasonIds?: number[] | null;
  colors?: FiltersColor[] | null;
  supplierIds?: number[] | null;
  dropDateRange?: {
    from?: string | null;
    to?: string | null;
  };
  dropNames?: string[] | null;
  statusIds?: number[] | null;
  tagIds?: number[] | null;
  searchTerm?: string | null;
  customFieldOptionIds?: { [key: string]: number[]; } | null;
  createdByUserIds?: string[] | null;
  assignedUserIds?: string[] | null;
  colorGroupIds?: number[] | null;
  outPriceAmounts?: { [key: string]: number[]; } | null;
  outPriceRanges?: { [key: string]: OutPriceRange; } | null;
  sizeSystemIds?: number[] | null;
  timelineHealth?: TimelineHealthFilter[] | null;
  nextGateRoleIds?: number[] | null;
  nextGateNames?: string[] | null;
  grouping?: Grouping;
  descending?: boolean;
  tagCategoryId?: number | null;
  backwards?: number;
  forward?: number;
  referenceKey?: string | null;
  includeReferenceKey?: boolean;
  activeSeasonId?: number | null;
}

export interface Overview_GetFilteredBucketsArgs {
  brandId: number;
  activeSeasonId?: number | null;
  hierarchyNodeIds?: number[] | null;
  productCategoryIds?: number[] | null;
  genders?: Gender[] | null;
  seasonIds?: number[] | null;
  colors?: FiltersColor[] | null;
  supplierIds?: number[] | null;
  dropDateRange?: {
    from?: string | null;
    to?: string | null;
  };
  dropNames?: string[] | null;
  statusIds?: number[] | null;
  tagIds?: number[] | null;
  searchTerm?: string | null;
  customFieldOptionIds?: { [key: string]: number[]; } | null;
  createdByUserIds?: string[] | null;
  assignedUserIds?: string[] | null;
  colorGroupIds?: number[] | null;
  outPriceAmounts?: { [key: string]: number[]; } | null;
  outPriceRanges?: { [key: string]: OutPriceRange; } | null;
  sizeSystemIds?: number[] | null;
  timelineHealth?: TimelineHealthFilter[] | null;
  nextGateRoleIds?: number[] | null;
  nextGateNames?: string[] | null;
  grouping?: Grouping;
  descending?: boolean;
  tagCategoryId?: number | null;
  startBucketKey?: string | null;
  centerBucketKey?: string | null;
  endBucketKey?: string | null;
  minimumForward?: number;
  minimumBackwards?: number;
}

export interface Overview_GetUnfilteredBucketsArgs {
  brandId: number;
  hierarchyNodeIds?: number[] | null;
  productCategoryIds?: number[] | null;
  genders?: Gender[] | null;
  seasonIds?: number[] | null;
  colors?: FiltersColor[] | null;
  supplierIds?: number[] | null;
  dropDateRange?: {
    from?: string | null;
    to?: string | null;
  };
  dropNames?: string[] | null;
  statusIds?: number[] | null;
  tagIds?: number[] | null;
  searchTerm?: string | null;
  customFieldOptionIds?: { [key: string]: number[]; } | null;
  createdByUserIds?: string[] | null;
  assignedUserIds?: string[] | null;
  colorGroupIds?: number[] | null;
  outPriceAmounts?: { [key: string]: number[]; } | null;
  outPriceRanges?: { [key: string]: OutPriceRange; } | null;
  sizeSystemIds?: number[] | null;
  timelineHealth?: TimelineHealthFilter[] | null;
  nextGateRoleIds?: number[] | null;
  nextGateNames?: string[] | null;
  grouping?: Grouping;
  descending?: boolean;
  tagCategoryId?: number | null;
  startBucketKey?: string | null;
  centerBucketKey?: string | null;
  endBucketKey?: string | null;
  activeSeasonId?: number | null;
  maximumBackwards?: number;
  maximumForward?: number;
}

export interface Overview_GetBucketArticlesArgs {
  brandId: number;
  bucketKeys?: string[] | null;
  filters?: {
    hierarchyNodeIds?: number[] | null;
    productCategoryIds?: number[] | null;
    genders?: Gender[] | null;
    seasonIds?: number[] | null;
    colors?: FiltersColor[] | null;
    supplierIds?: number[] | null;
    dropDateRange?: {
      from?: string | null;
      to?: string | null;
    };
    dropNames?: string[] | null;
    statusIds?: number[] | null;
    tagIds?: number[] | null;
    searchTerm?: string | null;
    customFieldOptionIds?: { [key: string]: number[]; } | null;
    createdByUserIds?: string[] | null;
    assignedUserIds?: string[] | null;
    colorGroupIds?: number[] | null;
    outPriceAmounts?: { [key: string]: number[]; } | null;
    outPriceRanges?: { [key: string]: OutPriceRange; } | null;
    sizeSystemIds?: number[] | null;
    timelineHealth?: TimelineHealthFilter[] | null;
    nextGateRoleIds?: number[] | null;
    nextGateNames?: string[] | null;
  };
  groupingOptions?: {
    grouping?: Grouping;
    descending?: boolean;
    tagCategoryId?: number | null;
  };
  sortingOptions?: {
    sorting?: Sorting;
    descending?: boolean;
    fieldId?: number | null;
    tagCategoryId?: number | null;
    seasonId?: number | null;
    today?: string | null;
    destinationId?: number | null;
    priceKey?: string | null;
  };
  destinationId?: number;
  activeSeasonId?: number | null;
  limit?: number;
  offset?: number;
}

export interface Overview_GetUndefinedArticlesCountArgs {
  brandId: number;
  hierarchyNodeIds?: number[] | null;
  productCategoryIds?: number[] | null;
  genders?: Gender[] | null;
  seasonIds?: number[] | null;
  colors?: FiltersColor[] | null;
  supplierIds?: number[] | null;
  dropDateRange?: {
    from?: string | null;
    to?: string | null;
  };
  dropNames?: string[] | null;
  statusIds?: number[] | null;
  tagIds?: number[] | null;
  searchTerm?: string | null;
  customFieldOptionIds?: { [key: string]: number[]; } | null;
  createdByUserIds?: string[] | null;
  assignedUserIds?: string[] | null;
  colorGroupIds?: number[] | null;
  outPriceAmounts?: { [key: string]: number[]; } | null;
  outPriceRanges?: { [key: string]: OutPriceRange; } | null;
  sizeSystemIds?: number[] | null;
  timelineHealth?: TimelineHealthFilter[] | null;
  nextGateRoleIds?: number[] | null;
  nextGateNames?: string[] | null;
  grouping?: Grouping;
  descending?: boolean;
  tagCategoryId?: number | null;
  activeSeasonId?: number | null;
}

export interface Overview_GetUndefinedArticlesArgs {
  brandId: number;
  filters?: {
    hierarchyNodeIds?: number[] | null;
    productCategoryIds?: number[] | null;
    genders?: Gender[] | null;
    seasonIds?: number[] | null;
    colors?: FiltersColor[] | null;
    supplierIds?: number[] | null;
    dropDateRange?: {
      from?: string | null;
      to?: string | null;
    };
    dropNames?: string[] | null;
    statusIds?: number[] | null;
    tagIds?: number[] | null;
    searchTerm?: string | null;
    customFieldOptionIds?: { [key: string]: number[]; } | null;
    createdByUserIds?: string[] | null;
    assignedUserIds?: string[] | null;
    colorGroupIds?: number[] | null;
    outPriceAmounts?: { [key: string]: number[]; } | null;
    outPriceRanges?: { [key: string]: OutPriceRange; } | null;
    sizeSystemIds?: number[] | null;
    timelineHealth?: TimelineHealthFilter[] | null;
    nextGateRoleIds?: number[] | null;
    nextGateNames?: string[] | null;
  };
  groupingOptions?: {
    grouping?: Grouping;
    descending?: boolean;
    tagCategoryId?: number | null;
  };
  sortingOptions?: {
    sorting?: Sorting;
    descending?: boolean;
    fieldId?: number | null;
    tagCategoryId?: number | null;
    seasonId?: number | null;
    today?: string | null;
    destinationId?: number | null;
    priceKey?: string | null;
  };
  destinationId?: number;
  activeSeasonId?: number | null;
  limit?: number;
  offset?: number;
}

export interface Overview_GetUndefinedArticleArgs {
  brandId: number;
  articleId: number;
  destinationId?: number;
  seasonId?: number | null;
  hierarchyNodeIds?: number[] | null;
  productCategoryIds?: number[] | null;
  genders?: Gender[] | null;
  seasonIds?: number[] | null;
  colors?: FiltersColor[] | null;
  supplierIds?: number[] | null;
  dropDateRange?: {
    from?: string | null;
    to?: string | null;
  };
  dropNames?: string[] | null;
  statusIds?: number[] | null;
  tagIds?: number[] | null;
  searchTerm?: string | null;
  customFieldOptionIds?: { [key: string]: number[]; } | null;
  createdByUserIds?: string[] | null;
  assignedUserIds?: string[] | null;
  colorGroupIds?: number[] | null;
  outPriceAmounts?: { [key: string]: number[]; } | null;
  outPriceRanges?: { [key: string]: OutPriceRange; } | null;
  sizeSystemIds?: number[] | null;
  timelineHealth?: TimelineHealthFilter[] | null;
  nextGateRoleIds?: number[] | null;
  nextGateNames?: string[] | null;
}

export interface Overview_GetProductWithArticlesArgs {
  brandId: number;
  grouping?: Grouping;
  bucketKey?: string | null;
  limit?: number;
  offset?: number;
  activeSeasonId?: number | null;
}

export interface Overview_GetInitialTableArticlesArgs {
  brandId: number;
  activeSeasonId?: number | null;
  filters?: {
    hierarchyNodeIds?: number[] | null;
    productCategoryIds?: number[] | null;
    genders?: Gender[] | null;
    seasonIds?: number[] | null;
    colors?: FiltersColor[] | null;
    supplierIds?: number[] | null;
    dropDateRange?: {
      from?: string | null;
      to?: string | null;
    };
    dropNames?: string[] | null;
    statusIds?: number[] | null;
    tagIds?: number[] | null;
    searchTerm?: string | null;
    customFieldOptionIds?: { [key: string]: number[]; } | null;
    createdByUserIds?: string[] | null;
    assignedUserIds?: string[] | null;
    colorGroupIds?: number[] | null;
    outPriceAmounts?: { [key: string]: number[]; } | null;
    outPriceRanges?: { [key: string]: OutPriceRange; } | null;
    sizeSystemIds?: number[] | null;
    timelineHealth?: TimelineHealthFilter[] | null;
    nextGateRoleIds?: number[] | null;
    nextGateNames?: string[] | null;
  };
  sortingOptions?: {
    sorting?: Sorting;
    descending?: boolean;
    fieldId?: number | null;
    tagCategoryId?: number | null;
    seasonId?: number | null;
    today?: string | null;
    destinationId?: number | null;
    priceKey?: string | null;
  };
  reference?: {
    primary?: string | null;
    articleNumber?: string;
    numericPrimary?: number | null;
  };
  items?: number;
}

export interface Overview_GetIncrementalTableArticlesArgs {
  brandId: number;
  activeSeasonId?: number | null;
  offset?: number;
  limit?: number;
  filters?: {
    hierarchyNodeIds?: number[] | null;
    productCategoryIds?: number[] | null;
    genders?: Gender[] | null;
    seasonIds?: number[] | null;
    colors?: FiltersColor[] | null;
    supplierIds?: number[] | null;
    dropDateRange?: {
      from?: string | null;
      to?: string | null;
    };
    dropNames?: string[] | null;
    statusIds?: number[] | null;
    tagIds?: number[] | null;
    searchTerm?: string | null;
    customFieldOptionIds?: { [key: string]: number[]; } | null;
    createdByUserIds?: string[] | null;
    assignedUserIds?: string[] | null;
    colorGroupIds?: number[] | null;
    outPriceAmounts?: { [key: string]: number[]; } | null;
    outPriceRanges?: { [key: string]: OutPriceRange; } | null;
    sizeSystemIds?: number[] | null;
    timelineHealth?: TimelineHealthFilter[] | null;
    nextGateRoleIds?: number[] | null;
    nextGateNames?: string[] | null;
  };
  sortingOptions?: {
    sorting?: Sorting;
    descending?: boolean;
    fieldId?: number | null;
    tagCategoryId?: number | null;
    seasonId?: number | null;
    today?: string | null;
    destinationId?: number | null;
    priceKey?: string | null;
  };
}

export interface Overview_GetTimelineSeasonGroupsArgs {
  brandId: number;
  activeSeasonId?: number | null;
  filters?: {
    hierarchyNodeIds?: number[] | null;
    productCategoryIds?: number[] | null;
    genders?: Gender[] | null;
    seasonIds?: number[] | null;
    colors?: FiltersColor[] | null;
    supplierIds?: number[] | null;
    dropDateRange?: {
      from?: string | null;
      to?: string | null;
    };
    dropNames?: string[] | null;
    statusIds?: number[] | null;
    tagIds?: number[] | null;
    searchTerm?: string | null;
    customFieldOptionIds?: { [key: string]: number[]; } | null;
    createdByUserIds?: string[] | null;
    assignedUserIds?: string[] | null;
    colorGroupIds?: number[] | null;
    outPriceAmounts?: { [key: string]: number[]; } | null;
    outPriceRanges?: { [key: string]: OutPriceRange; } | null;
    sizeSystemIds?: number[] | null;
    timelineHealth?: TimelineHealthFilter[] | null;
    nextGateRoleIds?: number[] | null;
    nextGateNames?: string[] | null;
  };
}

export interface Overview_GetTableArticleIdsArgs {
  brandId: number;
  activeSeasonId?: number | null;
  offset?: number;
  limit?: number;
  filters?: {
    hierarchyNodeIds?: number[] | null;
    productCategoryIds?: number[] | null;
    genders?: Gender[] | null;
    seasonIds?: number[] | null;
    colors?: FiltersColor[] | null;
    supplierIds?: number[] | null;
    dropDateRange?: {
      from?: string | null;
      to?: string | null;
    };
    dropNames?: string[] | null;
    statusIds?: number[] | null;
    tagIds?: number[] | null;
    searchTerm?: string | null;
    customFieldOptionIds?: { [key: string]: number[]; } | null;
    createdByUserIds?: string[] | null;
    assignedUserIds?: string[] | null;
    colorGroupIds?: number[] | null;
    outPriceAmounts?: { [key: string]: number[]; } | null;
    outPriceRanges?: { [key: string]: OutPriceRange; } | null;
    sizeSystemIds?: number[] | null;
    timelineHealth?: TimelineHealthFilter[] | null;
    nextGateRoleIds?: number[] | null;
    nextGateNames?: string[] | null;
  };
  sortingOptions?: {
    sorting?: Sorting;
    descending?: boolean;
    fieldId?: number | null;
    tagCategoryId?: number | null;
    seasonId?: number | null;
    today?: string | null;
    destinationId?: number | null;
    priceKey?: string | null;
  };
}

export interface Overview_GenerateJsonFileForFilteredArticlesArgs {
  brandId: number;
  hierarchyNodeIds?: number[] | null;
  productCategoryIds?: number[] | null;
  genders?: Gender[] | null;
  seasonIds?: number[] | null;
  colors?: FiltersColor[] | null;
  supplierIds?: number[] | null;
  dropDateRange?: {
    from?: string | null;
    to?: string | null;
  };
  dropNames?: string[] | null;
  statusIds?: number[] | null;
  tagIds?: number[] | null;
  searchTerm?: string | null;
  customFieldOptionIds?: { [key: string]: number[]; } | null;
  createdByUserIds?: string[] | null;
  assignedUserIds?: string[] | null;
  colorGroupIds?: number[] | null;
  outPriceAmounts?: { [key: string]: number[]; } | null;
  outPriceRanges?: { [key: string]: OutPriceRange; } | null;
  sizeSystemIds?: number[] | null;
  timelineHealth?: TimelineHealthFilter[] | null;
  nextGateRoleIds?: number[] | null;
  nextGateNames?: string[] | null;
  isAllSelected?: boolean;
  selectedIds?: number[] | null;
  excludedIds?: number[] | null;
  activeSeasonId?: number | null;
}

export interface Overview_GetSamplesExportForFilteredArticlesArgs {
  brandId: number;
  hierarchyNodeIds?: number[] | null;
  productCategoryIds?: number[] | null;
  genders?: Gender[] | null;
  seasonIds?: number[] | null;
  colors?: FiltersColor[] | null;
  supplierIds?: number[] | null;
  dropDateRange?: {
    from?: string | null;
    to?: string | null;
  };
  dropNames?: string[] | null;
  statusIds?: number[] | null;
  tagIds?: number[] | null;
  searchTerm?: string | null;
  customFieldOptionIds?: { [key: string]: number[]; } | null;
  createdByUserIds?: string[] | null;
  assignedUserIds?: string[] | null;
  colorGroupIds?: number[] | null;
  outPriceAmounts?: { [key: string]: number[]; } | null;
  outPriceRanges?: { [key: string]: OutPriceRange; } | null;
  sizeSystemIds?: number[] | null;
  timelineHealth?: TimelineHealthFilter[] | null;
  nextGateRoleIds?: number[] | null;
  nextGateNames?: string[] | null;
  isAllSelected?: boolean;
  selectedIds?: number[] | null;
  excludedIds?: number[] | null;
  activeSeasonId?: number | null;
}

export interface Overview_ExportBomsArgs {
  brandId: number;
  hierarchyNodeIds?: number[] | null;
  productCategoryIds?: number[] | null;
  genders?: Gender[] | null;
  seasonIds?: number[] | null;
  colors?: FiltersColor[] | null;
  supplierIds?: number[] | null;
  dropDateRange?: {
    from?: string | null;
    to?: string | null;
  };
  dropNames?: string[] | null;
  statusIds?: number[] | null;
  tagIds?: number[] | null;
  searchTerm?: string | null;
  customFieldOptionIds?: { [key: string]: number[]; } | null;
  createdByUserIds?: string[] | null;
  assignedUserIds?: string[] | null;
  colorGroupIds?: number[] | null;
  outPriceAmounts?: { [key: string]: number[]; } | null;
  outPriceRanges?: { [key: string]: OutPriceRange; } | null;
  sizeSystemIds?: number[] | null;
  timelineHealth?: TimelineHealthFilter[] | null;
  nextGateRoleIds?: number[] | null;
  nextGateNames?: string[] | null;
  isAllSelected?: boolean;
  selectedIds?: number[] | null;
  excludedIds?: number[] | null;
  activeSeasonId?: number | null;
}

export interface Overview_GetCustomExportForFilteredArticlesArgs {
  brandId: number;
  exportType: string;
  activeSeasonId?: number | null;
  hierarchyNodeIds?: number[] | null;
  productCategoryIds?: number[] | null;
  genders?: Gender[] | null;
  seasonIds?: number[] | null;
  colors?: FiltersColor[] | null;
  supplierIds?: number[] | null;
  dropDateRange?: {
    from?: string | null;
    to?: string | null;
  };
  dropNames?: string[] | null;
  statusIds?: number[] | null;
  tagIds?: number[] | null;
  searchTerm?: string | null;
  customFieldOptionIds?: { [key: string]: number[]; } | null;
  createdByUserIds?: string[] | null;
  assignedUserIds?: string[] | null;
  colorGroupIds?: number[] | null;
  outPriceAmounts?: { [key: string]: number[]; } | null;
  outPriceRanges?: { [key: string]: OutPriceRange; } | null;
  sizeSystemIds?: number[] | null;
  timelineHealth?: TimelineHealthFilter[] | null;
  nextGateRoleIds?: number[] | null;
  nextGateNames?: string[] | null;
  isAllSelected?: boolean;
  selectedIds?: number[] | null;
  excludedIds?: number[] | null;
}

export interface Product_ListProductsArgs {
  brandId: number;
  activeSeasonId?: number | null;
  hierarchyNodeIds?: number[] | null;
  productCategoryIds?: number[] | null;
  genders?: Gender[] | null;
  seasonIds?: number[] | null;
  colors?: FiltersColor[] | null;
  supplierIds?: number[] | null;
  dropDateRange?: {
    from?: string | null;
    to?: string | null;
  };
  dropNames?: string[] | null;
  statusIds?: number[] | null;
  tagIds?: number[] | null;
  searchTerm?: string | null;
  customFieldOptionIds?: { [key: string]: number[]; } | null;
  createdByUserIds?: string[] | null;
  assignedUserIds?: string[] | null;
  colorGroupIds?: number[] | null;
  outPriceAmounts?: { [key: string]: number[]; } | null;
  outPriceRanges?: { [key: string]: OutPriceRange; } | null;
  sizeSystemIds?: number[] | null;
  timelineHealth?: TimelineHealthFilter[] | null;
  nextGateRoleIds?: number[] | null;
  nextGateNames?: string[] | null;
  selectedArticleIds?: number[];
  startIndex?: number;
  items?: number;
}

export interface Product_BulkCompleteGateArgs {
  brandId: number;
  productId: number;
  seasonId: number;
  gateId: number;
  gateArgs: BulkCompleteGateArgs;
}

export interface Product_BulkUndoGateArgs {
  brandId: number;
  productId: number;
  seasonId: number;
  gateId: number;
  gateArgs: BulkUndoGateArgs;
}

export interface Product_BulkSetGateNoteArgs {
  brandId: number;
  productId: number;
  seasonId: number;
  gateId: number;
  gateArgs: BulkSetGateNoteArgs;
}

export interface Product_BulkSetGateEstimateArgs {
  brandId: number;
  productId: number;
  seasonId: number;
  gateId: number;
  gateArgs: BulkSetGateEstimateArgs;
}

export interface Product_GetBomGroupingDifferencesArgs {
  brandId: number;
  productId: number;
  seasonId?: number | null;
  compareToSeasonId?: number | null;
  groupSeasonIds?: number[] | null;
  compareToGroupSeasonIds?: number[] | null;
}

export interface Product_GetOrCreateCurrentVersionBomArgs {
  brandId: number;
  productId: number;
  seasonId?: number | null;
  groupSeasonIds?: number[] | null;
  includeBaseInGroup?: boolean;
}

export interface SampleRound_ListAllSampleRoundsArgs {
  brandId: number;
  supplierIds?: number[] | null;
  seasonIds?: number[] | null;
  sampleRoundTypeIds?: number[] | null;
  sampleStatusIds?: number[] | null;
  measurementStatusIds?: number[] | null;
  createdByUserIds?: string[] | null;
  searchTerm?: string | null;
  excludeClosed?: boolean;
  articleFilters?: {
    hierarchyNodeIds?: number[] | null;
    productCategoryIds?: number[] | null;
    genders?: Gender[] | null;
    seasonIds?: number[] | null;
    colors?: FiltersColor[] | null;
    supplierIds?: number[] | null;
    dropDateRange?: {
      from?: string | null;
      to?: string | null;
    };
    dropNames?: string[] | null;
    statusIds?: number[] | null;
    tagIds?: number[] | null;
    searchTerm?: string | null;
    customFieldOptionIds?: { [key: string]: number[]; } | null;
    createdByUserIds?: string[] | null;
    assignedUserIds?: string[] | null;
    colorGroupIds?: number[] | null;
    outPriceAmounts?: { [key: string]: number[]; } | null;
    outPriceRanges?: { [key: string]: OutPriceRange; } | null;
    sizeSystemIds?: number[] | null;
    timelineHealth?: TimelineHealthFilter[] | null;
    nextGateRoleIds?: number[] | null;
    nextGateNames?: string[] | null;
  };
  peopleEmails?: string[] | null;
}

export interface SampleRound_ListAllSampleRoundsLightArgs {
  brandId: number;
  supplierIds?: number[] | null;
  seasonIds?: number[] | null;
  sampleRoundTypeIds?: number[] | null;
  sampleStatusIds?: number[] | null;
  measurementStatusIds?: number[] | null;
  createdByUserIds?: string[] | null;
  searchTerm?: string | null;
  excludeClosed?: boolean;
  articleFilters?: {
    hierarchyNodeIds?: number[] | null;
    productCategoryIds?: number[] | null;
    genders?: Gender[] | null;
    seasonIds?: number[] | null;
    colors?: FiltersColor[] | null;
    supplierIds?: number[] | null;
    dropDateRange?: {
      from?: string | null;
      to?: string | null;
    };
    dropNames?: string[] | null;
    statusIds?: number[] | null;
    tagIds?: number[] | null;
    searchTerm?: string | null;
    customFieldOptionIds?: { [key: string]: number[]; } | null;
    createdByUserIds?: string[] | null;
    assignedUserIds?: string[] | null;
    colorGroupIds?: number[] | null;
    outPriceAmounts?: { [key: string]: number[]; } | null;
    outPriceRanges?: { [key: string]: OutPriceRange; } | null;
    sizeSystemIds?: number[] | null;
    timelineHealth?: TimelineHealthFilter[] | null;
    nextGateRoleIds?: number[] | null;
    nextGateNames?: string[] | null;
  };
  peopleEmails?: string[] | null;
}

export interface SampleRound_GetSampleRoundsTableArgs {
  brandId: number;
  supplierIds?: number[] | null;
  seasonIds?: number[] | null;
  sampleRoundTypeIds?: number[] | null;
  sampleStatusIds?: number[] | null;
  measurementStatusIds?: number[] | null;
  createdByUserIds?: string[] | null;
  searchTerm?: string | null;
  excludeClosed?: boolean;
  articleFilters?: {
    hierarchyNodeIds?: number[] | null;
    productCategoryIds?: number[] | null;
    genders?: Gender[] | null;
    seasonIds?: number[] | null;
    colors?: FiltersColor[] | null;
    supplierIds?: number[] | null;
    dropDateRange?: {
      from?: string | null;
      to?: string | null;
    };
    dropNames?: string[] | null;
    statusIds?: number[] | null;
    tagIds?: number[] | null;
    searchTerm?: string | null;
    customFieldOptionIds?: { [key: string]: number[]; } | null;
    createdByUserIds?: string[] | null;
    assignedUserIds?: string[] | null;
    colorGroupIds?: number[] | null;
    outPriceAmounts?: { [key: string]: number[]; } | null;
    outPriceRanges?: { [key: string]: OutPriceRange; } | null;
    sizeSystemIds?: number[] | null;
    timelineHealth?: TimelineHealthFilter[] | null;
    nextGateRoleIds?: number[] | null;
    nextGateNames?: string[] | null;
  };
  peopleEmails?: string[] | null;
  offset?: number;
  limit?: number;
  groupBy?: SampleTableGrouping;
  sortBy?: SampleTableSorting;
  sortDescending?: boolean;
}

export interface Search_QuickSearchArgs {
  brandId: number;
  query?: string | null;
  take?: number;
  skip?: number;
  activeSeasonId?: number | null;
}

export interface SkuCodeImages_GenerateEanBarcodeImageArgs {
  eanCode: string;
  height?: number;
  scaling?: number;
  margins?: number;
  font?: string;
  renderText?: boolean;
}

export interface SkuCodeImages_GenerateEanBarcodeImage2Args {
  eanCode: string;
  height?: number;
  scaling?: number;
  margins?: number;
  font?: string;
  renderText?: boolean;
}

export interface SkuCodeImages_GenerateUpcBarcodeImageArgs {
  upcCode: string;
  height?: number;
  scaling?: number;
  margins?: number;
  font?: string;
  renderText?: boolean;
}

export interface SkuCodeImages_GenerateCode128BarcodeImageArgs {
  filename: string;
  code?: string;
  height?: number;
  width?: number;
  scaling?: number;
  margins?: number;
}

export interface Sku_ExportSkusCsvArgs {
  brandId: number;
  hierarchyNodeIds?: number[] | null;
  productCategoryIds?: number[] | null;
  genders?: Gender[] | null;
  seasonIds?: number[] | null;
  colors?: FiltersColor[] | null;
  supplierIds?: number[] | null;
  dropDateRange?: {
    from?: string | null;
    to?: string | null;
  };
  dropNames?: string[] | null;
  statusIds?: number[] | null;
  tagIds?: number[] | null;
  searchTerm?: string | null;
  customFieldOptionIds?: { [key: string]: number[]; } | null;
  createdByUserIds?: string[] | null;
  assignedUserIds?: string[] | null;
  colorGroupIds?: number[] | null;
  outPriceAmounts?: { [key: string]: number[]; } | null;
  outPriceRanges?: { [key: string]: OutPriceRange; } | null;
  sizeSystemIds?: number[] | null;
  timelineHealth?: TimelineHealthFilter[] | null;
  nextGateRoleIds?: number[] | null;
  nextGateNames?: string[] | null;
  activeSeasonId?: number | null;
}

export interface SupplierPortal_ListSampleRoundsArgs {
  companyId: number;
  closed?: boolean;
  search?: string | null;
  brandIds?: number[] | null;
  people?: string[] | null;
  offset?: number;
  limit?: number;
}

export interface SupplierPortal_ListOrderDeliveriesArgs {
  companyId: number;
  states?: OrderState[] | null;
  search?: string | null;
  brandIds?: number[] | null;
  minQuantity?: number | null;
  maxQuantity?: number | null;
  placedFrom?: string | null;
  placedTo?: string | null;
  placedIncludesUndated?: boolean;
  shipmentFrom?: string | null;
  shipmentTo?: string | null;
  arrivalFrom?: string | null;
  arrivalTo?: string | null;
  sort?: SupplierPortalOrderDeliverySort;
  descending?: boolean;
  offset?: number;
  limit?: number;
}

export interface SupplierPortal_GetOrderDeliveryFacetsArgs {
  companyId: number;
  states?: OrderState[] | null;
  search?: string | null;
  brandIds?: number[] | null;
  minQuantity?: number | null;
  maxQuantity?: number | null;
  placedFrom?: string | null;
  placedTo?: string | null;
  placedIncludesUndated?: boolean;
  shipmentFrom?: string | null;
  shipmentTo?: string | null;
  arrivalFrom?: string | null;
  arrivalTo?: string | null;
}

export interface Timeline_SetDropAnchorArgs {
  brandId: number;
  timelineId: number;
  seasonId: number;
  dropId: number;
  anchorArgs: SetDropAnchorArgs;
}

export interface Timeline_PutDropGateDatesArgs {
  brandId: number;
  timelineId: number;
  seasonId: number;
  dropId: number;
  dateArgs: PutGateDatesArgs;
}

export class ApiClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  async users_HandlePhoto(brandId: number, photo: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<string> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/users/handle-photo";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (photo !== null && photo !== undefined)
        content_.append("Photo", photo, photo.name ? photo.name : "Photo");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async users_CreateBrandUser(brandId: number, newUser: AdminRegisterUserArgs, options: AxiosRequestConfig = {}): Promise<UserDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/users/create-user";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = newUser;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async users_DetachUser(userId: string, brandId: number, options: AxiosRequestConfig = {}): Promise<boolean> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/users/detach-user/{userId}";
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async users_ChangePassword(brandId: number, changePassword: AdminChangePasswordArgs, options: AxiosRequestConfig = {}): Promise<boolean> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/users/change-password";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = changePassword;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the people on this brand — id, name, email, roleIds. Every userId in the API resolves here: product role assignments carry a bare userId, and the overview filters createdByUserIds / assignedUserIds take them too. Ids are strings, not integers.
 */
  async users_ListBrandUsers(brandId: number, options: AxiosRequestConfig = {}): Promise<UserDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/users/list-users";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async account_Login(companyGuid: string | null | undefined, model: LoginViewModel, options: AxiosRequestConfig = {}): Promise<LoginResponse> {
    let url_ = this.baseUrl + "/api/account/Login?";
    if (companyGuid !== undefined && companyGuid !== null)
        url_ += "companyGuid=" + encodeURIComponent("" + companyGuid) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = model;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async account_Logout(options: AxiosRequestConfig = {}): Promise<LogoutResponse> {
    let url_ = this.baseUrl + "/api/account/Logout";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async account_ForgotPassword(model: ForgotPasswordViewModel, options: AxiosRequestConfig = {}): Promise<ForgotPasswordResponse> {
    let url_ = this.baseUrl + "/api/account/ForgotPassword";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = model;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async account_ResetPassword(model: ResetPasswordViewModel, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/account/ResetPassword";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = model;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async account_ChangeAdminUser(name: string | null | undefined, image: FileParameter | null | undefined, password: string | null | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/account/ChangeAdminUser";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (name !== null && name !== undefined)
        content_.append("Name", name.toString());
    if (image !== null && image !== undefined)
        content_.append("Image", image, image.name ? image.name : "Image");
    if (password !== null && password !== undefined)
        content_.append("Password", password.toString());

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async agentChat_Status(options: AxiosRequestConfig = {}): Promise<AgentChatStatusDto> {
    let url_ = this.baseUrl + "/api/agent/status";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async agentChat_ListThreads(brandId: number | undefined, includeArchived: boolean | undefined, options: AxiosRequestConfig = {}): Promise<AgentThreadSummaryDto[]> {
    let url_ = this.baseUrl + "/api/agent/threads?";
    if (brandId === null)
        throw new Error("The parameter 'brandId' cannot be null.");
    else if (brandId !== undefined)
        url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
    if (includeArchived === null)
        throw new Error("The parameter 'includeArchived' cannot be null.");
    else if (includeArchived !== undefined)
        url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async agentChat_CreateThread(args: CreateAgentThreadArgs, options: AxiosRequestConfig = {}): Promise<AgentThreadDto> {
    let url_ = this.baseUrl + "/api/agent/threads";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async agentChat_GetThread(threadId: number, brandId: number | undefined, options: AxiosRequestConfig = {}): Promise<AgentThreadDto> {
    let url_ = this.baseUrl + "/api/agent/threads/{threadId}?";
    if (threadId === undefined || threadId === null)
        throw new Error("The parameter 'threadId' must be defined.");
    url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
    if (brandId === null)
        throw new Error("The parameter 'brandId' cannot be null.");
    else if (brandId !== undefined)
        url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async agentChat_UpdateThread(threadId: number, brandId: number | undefined, args: UpdateAgentThreadArgs, options: AxiosRequestConfig = {}): Promise<AgentThreadSummaryDto> {
    let url_ = this.baseUrl + "/api/agent/threads/{threadId}?";
    if (threadId === undefined || threadId === null)
        throw new Error("The parameter 'threadId' must be defined.");
    url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
    if (brandId === null)
        throw new Error("The parameter 'brandId' cannot be null.");
    else if (brandId !== undefined)
        url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async agentChat_SendMessage(threadId: number, args: SendAgentMessageArgs, options: AxiosRequestConfig = {}): Promise<AgentThreadDto> {
    let url_ = this.baseUrl + "/api/agent/threads/{threadId}/messages";
    if (threadId === undefined || threadId === null)
        throw new Error("The parameter 'threadId' must be defined.");
    url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async agentChat_Approve(threadId: number, brandId: number | undefined, args: AgentApprovalArgs, options: AxiosRequestConfig = {}): Promise<AgentThreadDto> {
    let url_ = this.baseUrl + "/api/agent/threads/{threadId}/approvals?";
    if (threadId === undefined || threadId === null)
        throw new Error("The parameter 'threadId' must be defined.");
    url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
    if (brandId === null)
        throw new Error("The parameter 'brandId' cannot be null.");
    else if (brandId !== undefined)
        url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async agentChat_Cancel(threadId: number, brandId: number | undefined, options: AxiosRequestConfig = {}): Promise<AgentThreadDto> {
    let url_ = this.baseUrl + "/api/agent/threads/{threadId}/cancel?";
    if (threadId === undefined || threadId === null)
        throw new Error("The parameter 'threadId' must be defined.");
    url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
    if (brandId === null)
        throw new Error("The parameter 'brandId' cannot be null.");
    else if (brandId !== undefined)
        url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async agentChat_ArchiveThread(threadId: number, brandId: number | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/agent/threads/{threadId}/archive?";
    if (threadId === undefined || threadId === null)
        throw new Error("The parameter 'threadId' must be defined.");
    url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
    if (brandId === null)
        throw new Error("The parameter 'brandId' cannot be null.");
    else if (brandId !== undefined)
        url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async apiKey_List(options: AxiosRequestConfig = {}): Promise<ApiKeyDto[]> {
    let url_ = this.baseUrl + "/api/api-keys";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async apiKey_Create(args: CreateApiKeyArgs, options: AxiosRequestConfig = {}): Promise<CreatedApiKeyDto> {
    let url_ = this.baseUrl + "/api/api-keys";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async apiKey_Rename(keyId: number, args: RenameApiKeyArgs, options: AxiosRequestConfig = {}): Promise<ApiKeyDto> {
    let url_ = this.baseUrl + "/api/api-keys/{keyId}/name";
    if (keyId === undefined || keyId === null)
        throw new Error("The parameter 'keyId' must be defined.");
    url_ = url_.replace("{keyId}", encodeURIComponent("" + keyId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async apiKey_SetExpiry(keyId: number, args: SetApiKeyExpiryArgs, options: AxiosRequestConfig = {}): Promise<ApiKeyDto> {
    let url_ = this.baseUrl + "/api/api-keys/{keyId}/expiry";
    if (keyId === undefined || keyId === null)
        throw new Error("The parameter 'keyId' must be defined.");
    url_ = url_.replace("{keyId}", encodeURIComponent("" + keyId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async apiKey_Revoke(keyId: number, options: AxiosRequestConfig = {}): Promise<ApiKeyDto> {
    let url_ = this.baseUrl + "/api/api-keys/{keyId}/revoke";
    if (keyId === undefined || keyId === null)
        throw new Error("The parameter 'keyId' must be defined.");
    url_ = url_.replace("{keyId}", encodeURIComponent("" + keyId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async artboardLink_GetArtboardBomTargets(brandId: number, productId: number, productFileId: number, options: AxiosRequestConfig = {}): Promise<ArtboardBomTarget[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/files/{productFileId}/artboard-links/bom-targets";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (productFileId === undefined || productFileId === null)
        throw new Error("The parameter 'productFileId' must be defined.");
    url_ = url_.replace("{productFileId}", encodeURIComponent("" + productFileId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Queues a new image rendered from the artboard. It shows up on the product's files once made.
 */
  async artboardLink_LinkArtboard(brandId: number, productId: number, productFileId: number, args: LinkArtboardArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/files/{productFileId}/artboard-links";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (productFileId === undefined || productFileId === null)
        throw new Error("The parameter 'productFileId' must be defined.");
    url_ = url_.replace("{productFileId}", encodeURIComponent("" + productFileId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The articles the text on the artboard, or on a part of it, names: the ones to tick when linking it.
 * @param artboardId (optional) 
 * @param x (optional) The part's left edge in points, with y, width and
            height; leave all four out for the whole artboard.
 * @param y (optional) 
 * @param width (optional) 
 * @param height (optional) 
 */
  async artboardLink_GetSuggestedArtboardArticles(args: ArtboardLink_GetSuggestedArtboardArticlesArgs, options: AxiosRequestConfig = {}): Promise<number[]> {
    const { brandId, productId, productFileId, artboardId, x, y, width, height, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/files/{productFileId}/artboard-links/suggested-articles?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (productFileId === undefined || productFileId === null)
        throw new Error("The parameter 'productFileId' must be defined.");
    url_ = url_.replace("{productFileId}", encodeURIComponent("" + productFileId));
    if (artboardId === null)
        throw new Error("The parameter 'artboardId' cannot be null.");
    else if (artboardId !== undefined)
        url_ += "artboardId=" + encodeURIComponent("" + artboardId) + "&";
    if (x !== undefined && x !== null)
        url_ += "x=" + encodeURIComponent("" + x) + "&";
    if (y !== undefined && y !== null)
        url_ += "y=" + encodeURIComponent("" + y) + "&";
    if (width !== undefined && width !== null)
        url_ += "width=" + encodeURIComponent("" + width) + "&";
    if (height !== undefined && height !== null)
        url_ += "height=" + encodeURIComponent("" + height) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Changes which part of the artboard the image shows; the image is rendered again.
 */
  async artboardLink_SetArtboardLinkRegion(args: ArtboardLink_SetArtboardLinkRegionArgs, options: AxiosRequestConfig = {}): Promise<ProductFileDto[]> {
    const { brandId, productId, productFileId, renderId, region, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/files/{productFileId}/artboard-links/{renderId}/region";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (productFileId === undefined || productFileId === null)
        throw new Error("The parameter 'productFileId' must be defined.");
    url_ = url_.replace("{productFileId}", encodeURIComponent("" + productFileId));
    if (renderId === undefined || renderId === null)
        throw new Error("The parameter 'renderId' must be defined.");
    url_ = url_.replace("{renderId}", encodeURIComponent("" + renderId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = region;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async artboardLink_SetArtboardLinkArticles(args: ArtboardLink_SetArtboardLinkArticlesArgs, options: AxiosRequestConfig = {}): Promise<ProductFileDto[]> {
    const { brandId, productId, productFileId, renderId, articleIds, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/files/{productFileId}/artboard-links/{renderId}/articles";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (productFileId === undefined || productFileId === null)
        throw new Error("The parameter 'productFileId' must be defined.");
    url_ = url_.replace("{productFileId}", encodeURIComponent("" + productFileId));
    if (renderId === undefined || renderId === null)
        throw new Error("The parameter 'renderId' must be defined.");
    url_ = url_.replace("{renderId}", encodeURIComponent("" + renderId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = articleIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async artboardLink_UnlinkArtboard(brandId: number, productId: number, productFileId: number, renderId: number, options: AxiosRequestConfig = {}): Promise<ProductFileDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/files/{productFileId}/artboard-links/{renderId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (productFileId === undefined || productFileId === null)
        throw new Error("The parameter 'productFileId' must be defined.");
    url_ = url_.replace("{productFileId}", encodeURIComponent("" + productFileId));
    if (renderId === undefined || renderId === null)
        throw new Error("The parameter 'renderId' must be defined.");
    url_ = url_.replace("{renderId}", encodeURIComponent("" + renderId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * @param overwrite True renders the artboard over the image again; false keeps the image as it is
            and stops it following the artboard.
 */
  async artboardLink_ResolveArtboardLinkConflict(args: ArtboardLink_ResolveArtboardLinkConflictArgs, options: AxiosRequestConfig = {}): Promise<ProductFileDto[]> {
    const { brandId, productId, productFileId, renderId, overwrite, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/files/{productFileId}/artboard-links/{renderId}/resolve-conflict";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (productFileId === undefined || productFileId === null)
        throw new Error("The parameter 'productFileId' must be defined.");
    url_ = url_.replace("{productFileId}", encodeURIComponent("" + productFileId));
    if (renderId === undefined || renderId === null)
        throw new Error("The parameter 'renderId' must be defined.");
    url_ = url_.replace("{renderId}", encodeURIComponent("" + renderId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = overwrite;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Reads the file's artboards and brings its links up to date again, as a new version would.
 */
  async artboardLink_SyncArtboardLinks(brandId: number, productId: number, productFileId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/files/{productFileId}/artboard-links/sync";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (productFileId === undefined || productFileId === null)
        throw new Error("The parameter 'productFileId' must be defined.");
    url_ = url_.replace("{productFileId}", encodeURIComponent("" + productFileId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Which timelines may plan this article-season, best first, as ids only. A manual pick chooses among these — it cannot escape the filter and anchor rules, so a timeline absent here cannot be set on this article at all.
 */
  async article_GetEligibleTimelines(brandId: number, id: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<number[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}/seasons/{seasonId}/timeline/eligible";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Pin this article-season to one of its eligible timelines, or pass timelineId:null to hand it back to automatic resolution. Moving it to a different timeline CLEARS its gate ticks, estimates and notes — the gates belonged to the old plan.
 */
  async article_SetArticleSeasonTimeline(brandId: number, id: number, seasonId: number, args: SetArticleSeasonTimelineArgs, options: AxiosRequestConfig = {}): Promise<ArticleSeasonTimelineDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}/seasons/{seasonId}/timeline";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Write several gates' progress on one article-season at once — completedOn, estimatedOn and note, each as you mean to leave it. Gates you leave out are UNTOUCHED, which is the opposite of most collection writes here; within a gate, null clears the field. Fails with "No timeline" if the article has no plan for that season, and names any gate id that is not part of its timeline.
 */
  async article_PutGateStates(brandId: number, id: number, seasonId: number, args: PutGateStatesArgs, options: AxiosRequestConfig = {}): Promise<ArticleSeasonTimelineDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}/seasons/{seasonId}/timeline/gates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Raise a task in chat asking whoever owns a late gate to move it along. The gate names a role, so the people are resolved for you. `today` is yours to send: whether a gate reads as late is the user's day, not the server's timezone.
 */
  async article_NudgeGate(args: Article_NudgeGateArgs, options: AxiosRequestConfig = {}): Promise<NudgeResultDto> {
    const { brandId, id, seasonId, gateId, nudgeArgs, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}/seasons/{seasonId}/timeline/gates/{gateId}/nudge";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    if (gateId === undefined || gateId === null)
        throw new Error("The parameter 'gateId' must be defined.");
    url_ = url_.replace("{gateId}", encodeURIComponent("" + gateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = nudgeArgs;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read one article in full, including SKUs and per-season values. Seasons come back as `seasonalities`, one entry per season plus one with a null id for the base values — not as the flat `seasonIds` the overview rows use. Filter the null out before counting seasons, and do not expect a write made with article_MassAddRemoveSeasons to show up under a `seasons` field; it will not exist.
 */
  async article_GetArticle(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async article_GetArticleOptions(brandId: number, articleIds: number[] | null | undefined, options: AxiosRequestConfig = {}): Promise<ArticleOptionDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/options?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleIds !== undefined && articleIds !== null)
        articleIds && articleIds.forEach(item => { url_ += "articleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read many articles in full by id. Prefer this over repeated article_GetArticle. Seasons come back as `seasonalities`, one entry per season plus one with a null id for the base values — not as the flat `seasonIds` the overview rows use. Filter the null out before counting seasons, and do not expect a write made with article_MassAddRemoveSeasons to show up under a `seasons` field; it will not exist.
 */
  async article_GetArticles(brandId: number, ids: number[], options: AxiosRequestConfig = {}): Promise<ArticleDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/batch";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = ids;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create an article under an existing product.
 */
  async article_AddArticle(brandId: number, articleArgs: AddArticleArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = articleArgs;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete one article.
 */
  async article_DeleteArticle(brandId: number, articleId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Duplicate articles verbatim. Cloning copies values as-is and never re-seeds them.
 */
  async article_CloneArticles(brandId: number, ids: number[], options: AxiosRequestConfig = {}): Promise<ArticleDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/clone";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = ids;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set genders and their size ranges together.
 */
  async article_UpdateGenderAndSizes(brandId: number, id: number, args: UpdateGenderAndSizesArgs, options: AxiosRequestConfig = {}): Promise<UpdateGenderAndSizesResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}/gender-and-size";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the genders an article is made for.
 */
  async article_UpdateGenders(brandId: number, id: number, args: UpdateGendersArgs, options: AxiosRequestConfig = {}): Promise<UpdateGendersReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}/gender";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the description on one article.
 */
  async article_UpdateDescription(brandId: number, id: number, args: UpdateDescriptionArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}/description";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set an article number manually, overriding the generated one.
 */
  async article_UpdateArticleNumber(brandId: number, articleId: number, args: UpdateArticleNumberArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/article-number";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Regenerate SKU numbers for an article from the brand number template.
 */
  async article_RegenerateSkuNumbers(brandId: number, articleId: number, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/regenerate-sku-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Explain how an article number was generated and whether it is manual.
 */
  async article_GetArticleNumberInfo(brandId: number, articleId: number, options: AxiosRequestConfig = {}): Promise<ArticleNumberInfoResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/number-info";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async article_UpdateTags(brandId: number, articleId: number, args: UpdateArticleTagsArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Add and/or remove tags on one or more articles by id.
SeasonId names the season whose tags are edited and is required for any article that has
seasons; the call fails if it is missing for such an article or names a season the article is
not on. Omit it only for articles without seasons, whose tags live on the base seasonality.
This never adds a season to an article; error if trying to set tags for non-existing seasons.
 * @param articleIdList (optional) 
 */
  async article_MassAddRemoveTags(brandId: number, articleIdList: number[] | undefined, args: MassAddRemoveTagsArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/add-remove-tags?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleIdList === null)
        throw new Error("The parameter 'articleIdList' cannot be null.");
    else if (articleIdList !== undefined)
        articleIdList && articleIdList.forEach(item => { url_ += "articleIdList=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async article_UpdateDrops(brandId: number, id: number, dropData: UpdateDropsArgsItem[], options: AxiosRequestConfig = {}): Promise<UpdateDropsReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}/drops";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = dropData;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Add and/or remove drops on one or more articles by id.
 * @param articleIdList (optional) 
 */
  async article_MassAddRemoveDrop(brandId: number, articleIdList: number[] | undefined, args: MassAddRemoveDropsArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/add-remove-drop?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleIdList === null)
        throw new Error("The parameter 'articleIdList' cannot be null.");
    else if (articleIdList !== undefined)
        articleIdList && articleIdList.forEach(item => { url_ += "articleIdList=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async article_UpdateSeasons(brandId: number, id: number, args: UpdateSeasonsArgs, options: AxiosRequestConfig = {}): Promise<UpdateSeasonsReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}/seasons";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Add and/or remove seasons on one or more articles by id. Verify with article_GetArticle: the result lands under `seasonalities` (a null-id entry is the base values), never under a `seasons` field. overview_GetTableArticle exposes the same thing as a flat `seasonIds` array.
 * @param articleIdList (optional) 
 */
  async article_MassAddRemoveSeasons(brandId: number, articleIdList: number[] | undefined, args: MassAddRemoveSeasonsArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/add-remove-seasons?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleIdList === null)
        throw new Error("The parameter 'articleIdList' cannot be null.");
    else if (articleIdList !== undefined)
        articleIdList && articleIdList.forEach(item => { url_ += "articleIdList=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Move an article in the hierarchy and set its product category. The hierarchy node lives on the PRODUCT, so this moves every colourway of it, not just this article — hierarchyNodeId is required for that reason. Omitting productCategoryId clears the category.
 */
  async article_UpdateHierarchyAndProductCategory(brandId: number, id: number, args: UpdateHierarchyAndProductCategoryArgs, options: AxiosRequestConfig = {}): Promise<UpdateHierarchyAndProductCategoryReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}/hierarchy-and-product-category";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set weight on one article. Weight belongs on the SKU: this seeds the article only while it has no SKUs, and otherwise overwrites every SKU under it.
 */
  async article_UpdateWeight(brandId: number, articleId: number, newWeight: WeightPatchDto, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/weight";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = newWeight;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set tariff codes on one article.
 */
  async article_UpdateTariffCodes(brandId: number, articleId: number, newTariffCodeIds: number[], options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/tariff-codes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = newTariffCodeIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set certifications on one article.
 */
  async article_UpdateArticleCertifications(brandId: number, articleId: number, args: ArticleCertificationDto[], options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/certifications";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set compliances on one article.
 */
  async article_UpdateArticleCompliances(brandId: number, articleId: number, args: ArticleComplianceDto[], options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/compliances";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set suppliers on one article.
 * @param seasonId (optional) 
 */
  async article_UpdateSuppliers(brandId: number, articleId: number, seasonId: number | null | undefined, updateSupplierArgs: UpdateSupplierArgs[], options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/suppliers?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    if (seasonId !== undefined && seasonId !== null)
        url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = updateSupplierArgs;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async article_UpdateDelivery(brandId: number, articleId: number, deliveryId: number, args: UpdateDeliveryArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/orders/{deliveryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async article_UpdateDeliveries(brandId: number, articleId: number, deliveriesToUpdate: UpdateDeliveriesArgsOrder[], options: AxiosRequestConfig = {}): Promise<UpdateDeliveriesReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/orders";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = deliveriesToUpdate;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Attach order deliveries to one or more articles by id.
 */
  async article_MassAddDeliveries(brandId: number, args: MassAddDeliveriesArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/add-orders";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Detach order deliveries from one or more articles by id.
 * @param articleIdList (optional) 
 */
  async article_MassRemoveDeliveries(brandId: number, articleIdList: number[] | undefined, args: MassRemoveDeliveriesArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/remove-orders?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleIdList === null)
        throw new Error("The parameter 'articleIdList' cannot be null.");
    else if (articleIdList !== undefined)
        articleIdList && articleIdList.forEach(item => { url_ += "articleIdList=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the comment on one article.
 */
  async article_UpdateComment(brandId: number, id: number, args: UpdateCommentArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}/comment";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async article_UpdateStatus(brandId: number, id: number, args: UpdateStatusArgs, options: AxiosRequestConfig = {}): Promise<UpdateStatusReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}/status";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set status on one or more articles by id. Use for a single article too.
 * @param articleIdList (optional) 
 */
  async article_MassUpdateStatus(brandId: number, articleIdList: number[] | undefined, args: MassUpdateStatusArgs, options: AxiosRequestConfig = {}): Promise<MassUpdateStatusReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/update-status?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleIdList === null)
        throw new Error("The parameter 'articleIdList' cannot be null.");
    else if (articleIdList !== undefined)
        articleIdList && articleIdList.forEach(item => { url_ += "articleIdList=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the article colour.
 * @param args (optional) 
 */
  async article_UpdateColor(brandId: number, articleID: number, args: SetColorArgs | undefined, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleID}/color";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleID === undefined || articleID === null)
        throw new Error("The parameter 'articleID' must be defined.");
    url_ = url_.replace("{articleID}", encodeURIComponent("" + articleID));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the images on ONE article. Same replace-the-whole-set rule as article_MassUpdateImages: pass every image you want to keep, each with its id, plus any new one without an id (a file id — from file_Upload, or a file already in the PLM). Use article_MassUpdateImages to put the same set on several articles of one product. To replace the picture of an existing image, add a version to its file with file_AddVersion, or file_AddVersionFromFile when the new picture is already a file.
 */
  async article_UpdateImages(brandId: number, articleID: number, images: UpdateImagesImage[], options: AxiosRequestConfig = {}): Promise<UpdateImagesReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleID}/images";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleID === undefined || articleID === null)
        throw new Error("The parameter 'articleID' must be defined.");
    url_ = url_.replace("{articleID}", encodeURIComponent("" + articleID));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = images;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the images on one or more articles of the SAME product (a mix from two products is rejected). This REPLACES the set: pass every image you want to keep, each as {id, azureBlobFileId}, plus any new one WITHOUT an id. Omitting an existing image deletes it — read the article's current images and append. To add an image, pass its file id: a file already in the PLM as it is, otherwise get it in with the request_upload tool delivering to file_Upload and pass the file id it returns. This operation does NOT set image tags — its arguments deliberately have no tagIds. Set tags through article_UpdateImages or the product image endpoints.
 */
  async article_MassUpdateImages(brandId: number, args: MassUpdateImagesArgs, options: AxiosRequestConfig = {}): Promise<MassUpdateImagesReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/add-remove-images";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set custom field values on an article. valueDtos is a list of {id, value} where id is the CUSTOM FIELD id and value is a discriminated union: {type:'TextCustomValueDto', value, linked} and likewise MoneyCustomValueDto, NumberWithUnitCustomValueDto, SingleSelectCustomValueDto, MultiSelectCustomValueDto, FilesCustomValueDto, PhysicalDimensions — expand it with search_api({type:'CustomFieldValueDto'}). The field must be scoped to Article (CustomFieldEntityType.Article = 2 in its `entities` bitmask) or the call fails. seasonId picks the seasonality each value lands on, and null does not mean 'base' for every field: a seasonal field's value goes to that season, or with null to the entity's latest season (its base only if it has no season); a non-seasonal field's value always goes to the base, whatever seasonId says. A seasonId the entity does not carry yet adds that season to it, even when only non-seasonal fields are sent. One call must be all seasonal or all non-seasonal fields. A lookup table keyed on a seasonal field reads each season's own value and never falls back to the base, so write such a key field to every season it should apply in.
 * @param seasonId (optional) 
 */
  async article_UpdateCustomFieldValues(brandId: number, articleId: number, seasonId: number | null | undefined, valueDtos: CustomFieldIdWithValueDto[], options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/custom-fields?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    if (seasonId !== undefined && seasonId !== null)
        url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = valueDtos;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the article principal material.
 */
  async article_UpdatePrincipalMaterial(brandId: number, articleId: number, args: UpdatePrincipalMaterialArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/principal-type";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async article_GenerateSkuCodeValuesForSkus(brandId: number, articleId: number, args: GenerateSkuCodeValuesForSkusArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{articleId}/sku-code-values";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Generate SKU code values across a set of articles.
 */
  async article_GenerateSkuCodeValuesForSkusForSelection(brandId: number, args: GenerateSkuCodeValuesForSkusForSelectionArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/sku-code-values";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async article_ImportArticlesFromExcel(brandId: number, uploadFile: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/import-excel-file";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (uploadFile !== null && uploadFile !== undefined)
        content_.append("UploadFile", uploadFile, uploadFile.name ? uploadFile.name : "UploadFile");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async article_ImportSkusFromExcel(brandId: number, uploadFile: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/import-skus-excel-file";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (uploadFile !== null && uploadFile !== undefined)
        content_.append("UploadFile", uploadFile, uploadFile.name ? uploadFile.name : "UploadFile");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async article_ExportArticlesCsv(args: Article_ExportArticlesCsvArgs, options: AxiosRequestConfig = {}): Promise<string> {
    const { brandId, hierarchyNodeIds, productCategoryIds, genders, seasonIds, colors, supplierIds, dropNames, statusIds, tagIds, searchTerm, customFieldOptionIds, createdByUserIds, assignedUserIds, colorGroupIds, outPriceAmounts, outPriceRanges, sizeSystemIds, timelineHealth, nextGateRoleIds, nextGateNames, activeSeasonId, } = args;
    const dropDateRange_From = args.dropDateRange?.from;
    const dropDateRange_To = args.dropDateRange?.to;
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/export-csv?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (hierarchyNodeIds !== undefined && hierarchyNodeIds !== null)
        hierarchyNodeIds && hierarchyNodeIds.forEach(item => { url_ += "HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (productCategoryIds !== undefined && productCategoryIds !== null)
        productCategoryIds && productCategoryIds.forEach(item => { url_ += "ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (genders !== undefined && genders !== null)
        genders && genders.forEach(item => { url_ += "Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colors !== undefined && colors !== null)
        colors && colors.forEach(item => { url_ += "Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (dropDateRange_From !== undefined && dropDateRange_From !== null)
        url_ += "DropDateRange.From=" + encodeURIComponent("" + dropDateRange_From) + "&";
    if (dropDateRange_To !== undefined && dropDateRange_To !== null)
        url_ += "DropDateRange.To=" + encodeURIComponent("" + dropDateRange_To) + "&";
    if (dropNames !== undefined && dropNames !== null)
        dropNames && dropNames.forEach(item => { url_ += "DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (statusIds !== undefined && statusIds !== null)
        statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (customFieldOptionIds !== undefined && customFieldOptionIds !== null)
        url_ += appendDictionaryQuery("CustomFieldOptionIds", customFieldOptionIds);
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (assignedUserIds !== undefined && assignedUserIds !== null)
        assignedUserIds && assignedUserIds.forEach(item => { url_ += "AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colorGroupIds !== undefined && colorGroupIds !== null)
        colorGroupIds && colorGroupIds.forEach(item => { url_ += "ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (outPriceAmounts !== undefined && outPriceAmounts !== null)
        url_ += appendDictionaryQuery("OutPriceAmounts", outPriceAmounts);
    if (outPriceRanges !== undefined && outPriceRanges !== null)
        url_ += appendDictionaryQuery("OutPriceRanges", outPriceRanges);
    if (sizeSystemIds !== undefined && sizeSystemIds !== null)
        sizeSystemIds && sizeSystemIds.forEach(item => { url_ += "SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (timelineHealth !== undefined && timelineHealth !== null)
        timelineHealth && timelineHealth.forEach(item => { url_ += "TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateRoleIds !== undefined && nextGateRoleIds !== null)
        nextGateRoleIds && nextGateRoleIds.forEach(item => { url_ += "NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateNames !== undefined && nextGateNames !== null)
        nextGateNames && nextGateNames.forEach(item => { url_ += "NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async article_UpdateMChart(brandId: number, id: number, args: UpdateMChartArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/{id}/mchart";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set measurement charts on one or more articles by id.
 */
  async article_BulkUpdateMChart(brandId: number, items: BulkUpdateMChartItem[], options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/articles/bulk-mchart";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = items;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's article statuses and their order.
 */
  async articleStatus_ListStatuses(brandId: number, options: AxiosRequestConfig = {}): Promise<ArticleStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/article-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async articleStatus_AddStatus(brandId: number, createStatus: CreateArticleStatus, options: AxiosRequestConfig = {}): Promise<ArticleStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/article-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = createStatus;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async articleStatus_UpdateStatus(brandId: number, articleStatusId: number, updateStatus: UpdateArticleStatus, options: AxiosRequestConfig = {}): Promise<ArticleStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/article-statuses/{articleStatusId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleStatusId === undefined || articleStatusId === null)
        throw new Error("The parameter 'articleStatusId' must be defined.");
    url_ = url_.replace("{articleStatusId}", encodeURIComponent("" + articleStatusId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = updateStatus;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async articleStatus_DeleteStatus(brandId: number, articleStatusId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/article-statuses/{articleStatusId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleStatusId === undefined || articleStatusId === null)
        throw new Error("The parameter 'articleStatusId' must be defined.");
    url_ = url_.replace("{articleStatusId}", encodeURIComponent("" + articleStatusId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async articleStatus_UpdateOrder(brandId: number, articleStatusIds: number[], options: AxiosRequestConfig = {}): Promise<ArticleStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/article-statuses/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = articleStatusIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async articleStatus_GetUsage(brandId: number, articleStatusId: number, options: AxiosRequestConfig = {}): Promise<ArticleStatusUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/article-statuses/{articleStatusId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleStatusId === undefined || articleStatusId === null)
        throw new Error("The parameter 'articleStatusId' must be defined.");
    url_ = url_.replace("{articleStatusId}", encodeURIComponent("" + articleStatusId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Retire an article status by moving every article on it to a replacement status, then deleting it. Prefer this over articleStatus_DeleteStatus when the status is still in use — Delete does not reassign.
 */
  async articleStatus_Replace(brandId: number, articleStatusId: number, args: ReplaceArticleStatusArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/article-statuses/{articleStatusId}/replace";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleStatusId === undefined || articleStatusId === null)
        throw new Error("The parameter 'articleStatusId' must be defined.");
    url_ = url_.replace("{articleStatusId}", encodeURIComponent("" + articleStatusId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Replace a BOM's WHOLE structure — sections, placements and slots — in one payload. Anything omitted is DELETED, an element without an id is created, and ids that move between parents are reparented. Read the BOM first and send it all back, including `id` at the top level (the path id is not enough) and every field of each slot's component. Sections and placements are named by string, not id. The images array cannot add or remove images, but it DOES set their order and their annotations. Read search_api({entity:"bom"}) before using this. Update bom structure - handles create, update and delete sections, placements and slots
 */
  async bom_UpdateStructure(bomId: number, newStructure: UpdateStructureArgs, options: AxiosRequestConfig = {}): Promise<BomDto> {
    let url_ = this.baseUrl + "/api/boms/{bomId}/structure";
    if (bomId === undefined || bomId === null)
        throw new Error("The parameter 'bomId' must be defined.");
    url_ = url_.replace("{bomId}", encodeURIComponent("" + bomId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = newStructure;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Apply one structure to several seasons' BOMs at once. Same whole-structure replace as bom_UpdateStructure, fanned out over seasonIds BY POSITION — so only use it across seasons product_GetBomGrouping reports as one group. Looping bom_UpdateStructure per season is fine and safer for edits to existing structure; use this one when the payload creates a NEW component, or a loop makes a duplicate component per season.
Each target's own article connections are preserved on surviving slots.
 */
  async bom_UpdateStructureGrouped(bomId: number, args: UpdateStructureGroupedArgs, options: AxiosRequestConfig = {}): Promise<BomDto> {
    let url_ = this.baseUrl + "/api/boms/{bomId}/structure-grouped";
    if (bomId === undefined || bomId === null)
        throw new Error("The parameter 'bomId' must be defined.");
    url_ = url_.replace("{bomId}", encodeURIComponent("" + bomId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Append a section to a BOM, optionally from a saved section template. Safer than bom_UpdateStructure when you only want to add — it touches nothing else.
 */
  async bom_AddSection(bomId: number, args: AddSectionArgs, options: AxiosRequestConfig = {}): Promise<BomDto> {
    let url_ = this.baseUrl + "/api/boms/{bomId}/add-section";
    if (bomId === undefined || bomId === null)
        throw new Error("The parameter 'bomId' must be defined.");
    url_ = url_.replace("{bomId}", encodeURIComponent("" + bomId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * APPEND another BOM's sections onto this one — same append-not-replace behaviour as bom_CopyFromSeason, plus copied placements lose their principal flag and annotation name, and copied slots arrive with no article connections. Use bom_UpdateStructure to replace.
 */
  async bom_CopyFromBom(bomId: number, args: CopyBomArgs, options: AxiosRequestConfig = {}): Promise<BomDto> {
    let url_ = this.baseUrl + "/api/boms/{bomId}/copy-from-bom";
    if (bomId === undefined || bomId === null)
        throw new Error("The parameter 'bomId' must be defined.");
    url_ = url_.replace("{bomId}", encodeURIComponent("" + bomId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * APPEND another season's BOM sections onto this one. It does NOT replace: run it twice and the target has two of every section, with no warning and a healthy-looking response. The target's existing sections always survive. The source's images and annotations are appended too, re-linked to the copied placements. To refresh a season from another, read both, then send the wanted structure through bom_UpdateStructure, whose omit-means-delete semantics actually replace.
 */
  async bom_CopyFromSeason(bomId: number, args: CopyFromSeasonArgs, options: AxiosRequestConfig = {}): Promise<BomDto> {
    let url_ = this.baseUrl + "/api/boms/{bomId}/copy-from-season";
    if (bomId === undefined || bomId === null)
        throw new Error("The parameter 'bomId' must be defined.");
    url_ = url_.replace("{bomId}", encodeURIComponent("" + bomId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Connect articles to BOM slots, optionally setting a colour on each cell. Add/edit multiple SlotArticleConnection
 */
  async bom_MassUpdateSlotArticleConnections(bomId: number, args: MassUpdateConnectionsArgs, options: AxiosRequestConfig = {}): Promise<BomDto> {
    let url_ = this.baseUrl + "/api/boms/{bomId}/articleconnections";
    if (bomId === undefined || bomId === null)
        throw new Error("The parameter 'bomId' must be defined.");
    url_ = url_.replace("{bomId}", encodeURIComponent("" + bomId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Disconnect articles from BOM slots.
 */
  async bom_MassRemoveSlotArticleConnections(bomId: number, args: MassRemoveConnectionsArgs, options: AxiosRequestConfig = {}): Promise<BomDto> {
    let url_ = this.baseUrl + "/api/boms/{bomId}/articleconnections";
    if (bomId === undefined || bomId === null)
        throw new Error("The parameter 'bomId' must be defined.");
    url_ = url_.replace("{bomId}", encodeURIComponent("" + bomId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Apply a coalesced batch of connection actions (mixed colours + set-article-colour + removes)
            Connect and disconnect articles to BOM slots in one call — the cells of the BOM grid. Actions apply in order, so a later one moves a connection an earlier one made. Within a placement an article can occupy only ONE slot: connecting it to a second slot moves it off the first. setArticleColor:true means "use the article's own colour" and the `color` you pass is IGNORED — to set a cell colour that differs from the article, send setArticleColor:false with the colour. Prefer this over the single-purpose connection operations; it does both and preserves their semantics.
            in one transaction. Lets the client collapse a burst of edits into a single call while preserving the
            per-action semantics of the standalone mass endpoints.
 */
  async bom_BatchUpdateSlotArticleConnections(bomId: number, args: BatchConnectionsArgs, options: AxiosRequestConfig = {}): Promise<BomDto> {
    let url_ = this.baseUrl + "/api/boms/{bomId}/articleconnections/batch";
    if (bomId === undefined || bomId === null)
        throw new Error("The parameter 'bomId' must be defined.");
    url_ = url_.replace("{bomId}", encodeURIComponent("" + bomId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Attach images to a BOM, by file id (`azureBlobFileIds`: a request_upload delivered to file_Upload, a file in the chat, or file_CreateFromPath for a stored path) or by copying existing product images (`productImageIdList`).
 */
  async bom_AddBomImages(bomId: number, args: AddBomImagesArgs, options: AxiosRequestConfig = {}): Promise<BomDto> {
    let url_ = this.baseUrl + "/api/boms/{bomId}/images";
    if (bomId === undefined || bomId === null)
        throw new Error("The parameter 'bomId' must be defined.");
    url_ = url_.replace("{bomId}", encodeURIComponent("" + bomId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Give this BOM's image a file private to the seasons being edited, so the edit that follows doesn't
reach seasons outside them. Called by the client before editing an image; a no-op (and a plain
re-fetch) when no season outside the edit holds the file.
 */
  async bom_DetachBomImage(bomId: number, imageId: number, args: DetachBomImageArgs, options: AxiosRequestConfig = {}): Promise<BomDto> {
    let url_ = this.baseUrl + "/api/boms/{bomId}/images/{imageId}/detach";
    if (bomId === undefined || bomId === null)
        throw new Error("The parameter 'bomId' must be defined.");
    url_ = url_.replace("{bomId}", encodeURIComponent("" + bomId));
    if (imageId === undefined || imageId === null)
        throw new Error("The parameter 'imageId' must be defined.");
    url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a BOM image and its annotations.
 */
  async bom_DeleteBomImage(imageId: number, options: AxiosRequestConfig = {}): Promise<BomDto> {
    let url_ = this.baseUrl + "/api/boms/images/{imageId}";
    if (imageId === undefined || imageId === null)
        throw new Error("The parameter 'imageId' must be defined.");
    url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Copy a BOM's images onto the same product's BOMs on other seasons. Replicate this BOM's images + annotations to every other grouped season's BOM.
 */
  async bom_SyncImagesToSeasons(bomId: number, args: SyncImagesToSeasonsArgs, options: AxiosRequestConfig = {}): Promise<BomDto> {
    let url_ = this.baseUrl + "/api/boms/{bomId}/sync-images-to-seasons";
    if (bomId === undefined || bomId === null)
        throw new Error("The parameter 'bomId' must be defined.");
    url_ = url_.replace("{bomId}", encodeURIComponent("" + bomId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Export a BOM to Excel.
 * @param activeSeasonId (optional) 
 */
  async bom_GetBomExcel(bomId: number, activeSeasonId: number | null | undefined, args: GetBomExcelArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/boms/{bomId}/excel?";
    if (bomId === undefined || bomId === null)
        throw new Error("The parameter 'bomId' must be defined.");
    url_ = url_.replace("{bomId}", encodeURIComponent("" + bomId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Search components for use on a BOM, ranked for this BOM's context. Use this rather than component_GetComponentsList when picking a component to put in a slot.
 * @param query (optional) 
 * @param offset (optional) 
 * @param limit (optional) 
 */
  async bom_SearchComponents(args: Bom_SearchComponentsArgs, options: AxiosRequestConfig = {}): Promise<SearchComponentsResponse> {
    const { brandId, bomId, query, offset, limit, } = args;
    let url_ = this.baseUrl + "/api/boms/{bomId}/components/search/{brandId}?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (bomId === undefined || bomId === null)
        throw new Error("The parameter 'bomId' must be defined.");
    url_ = url_.replace("{bomId}", encodeURIComponent("" + bomId));
    if (query !== undefined && query !== null)
        url_ += "query=" + encodeURIComponent("" + query) + "&";
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a component from the BOM editor and return it in BOM shape.
 */
  async bom_AddComponent(brandId: number, args: AddComponentArgs, options: AxiosRequestConfig = {}): Promise<BomComponentDto> {
    let url_ = this.baseUrl + "/api/boms/{brandId}/components";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async bom_ImportBomsFromExcel(brandId: number, uploadFile: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/boms/brand/{brandId}/import-excel-file";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (uploadFile !== null && uploadFile !== undefined)
        content_.append("UploadFile", uploadFile, uploadFile.name ? uploadFile.name : "UploadFile");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Save a BOM section as a reusable template.
Creates a new named template for a section. If the section-name + template-name combination already exists, overwrite if the overwrite flag is set.
 */
  async bomSectionTemplate_CreateSectionTemplate(brandId: number, args: CreateTemplateArgs, options: AxiosRequestConfig = {}): Promise<CreateSectionTemplateResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/bom-section-templates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's saved BOM section templates.
 * @param hierarchyNodeId (optional) 
 * @param searchQuery (optional) 
 * @param limit (optional) 
 * @param offset (optional) 
 */
  async bomSectionTemplate_ListSectionTemplates(args: BomSectionTemplate_ListSectionTemplatesArgs, options: AxiosRequestConfig = {}): Promise<SectionTemplateDto[]> {
    const { brandId, hierarchyNodeId, searchQuery, limit, offset, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/bom-section-templates?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (hierarchyNodeId !== undefined && hierarchyNodeId !== null)
        url_ += "hierarchyNodeId=" + encodeURIComponent("" + hierarchyNodeId) + "&";
    if (searchQuery !== undefined && searchQuery !== null)
        url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List every saved section available to copy onto a BOM.
 */
  async bomSectionTemplate_ListAllSavedSections(brandId: number, options: AxiosRequestConfig = {}): Promise<SectionTemplateDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/bom-section-templates/all-saved-sections";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Update a saved BOM section template.
 * @param overwrite (optional) 
 */
  async bomSectionTemplate_UpdateSavedSection(brandId: number, sectionTemplateId: number, overwrite: boolean | undefined, args: UpdateSavedSectionArgs, options: AxiosRequestConfig = {}): Promise<SectionTemplateDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/bom-section-templates/{sectionTemplateId}?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sectionTemplateId === undefined || sectionTemplateId === null)
        throw new Error("The parameter 'sectionTemplateId' must be defined.");
    url_ = url_.replace("{sectionTemplateId}", encodeURIComponent("" + sectionTemplateId));
    if (overwrite === null)
        throw new Error("The parameter 'overwrite' cannot be null.");
    else if (overwrite !== undefined)
        url_ += "overwrite=" + encodeURIComponent("" + overwrite) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async bomSectionTemplate_DeleteSectionTemplate(brandId: number, sectionTemplateId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/bom-section-templates/{sectionTemplateId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sectionTemplateId === undefined || sectionTemplateId === null)
        throw new Error("The parameter 'sectionTemplateId' must be defined.");
    url_ = url_.replace("{sectionTemplateId}", encodeURIComponent("" + sectionTemplateId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List BOMs whose structure can be copied onto this one.
 * @param bomId (optional) 
 * @param searchQuery (optional) 
 * @param limit (optional) 
 * @param offset (optional) 
 */
  async bomSectionTemplate_ListBomsToCopy(args: BomSectionTemplate_ListBomsToCopyArgs, options: AxiosRequestConfig = {}): Promise<CopyableBomDto[]> {
    const { brandId, bomId, searchQuery, limit, offset, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/bom-section-templates/boms-to-copy?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (bomId !== undefined && bomId !== null)
        url_ += "bomId=" + encodeURIComponent("" + bomId) + "&";
    if (searchQuery !== undefined && searchQuery !== null)
        url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async bomTemplate_CreateBomTemplate(brandId: number, args: CreateBomTemplateArgs, options: AxiosRequestConfig = {}): Promise<NamedBomTemplateDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/bom-templates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async bomTemplate_ListBomTemplates(brandId: number, options: AxiosRequestConfig = {}): Promise<NamedBomTemplateDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/bom-templates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async bomTemplate_UpdateBomTemplate(brandId: number, templateId: number, args: CreateBomTemplateArgs, options: AxiosRequestConfig = {}): Promise<NamedBomTemplateDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/bom-templates/{templateId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (templateId === undefined || templateId === null)
        throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async bomTemplate_DeleteBomTemplate(brandId: number, templateId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/bom-templates/{templateId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (templateId === undefined || templateId === null)
        throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Every colour the brand has, with its custom field values and usage counts.
 */
  async brandColor_GetColors(brandId: number, options: AxiosRequestConfig = {}): Promise<ColorWithUsageDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Creates a colour of the brand's own from `values` (name required; code optional; CMYK and RGB
0–255; groupId optional) and returns it with its generated number. Always creates, even when
the brand already has a colour with the same values — look first with color_SearchColors or
color_LookupColors to reuse one. To start from a library colour use brandColor_AdoptLibraryColor.
 */
  async brandColor_CreateColor(brandId: number, args: CreateColorArgs, options: AxiosRequestConfig = {}): Promise<ColorDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Deletes the listed colours. Refused as a whole when any of them is still used by an article,
component, BOM connection or colour code — brandColor_GetUsage names what uses one; merge it
into another colour with brandColor_MergeColors instead. Palette memberships go with the colour.
 */
  async brandColor_DeleteColors(brandId: number, colorIds: number[], options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = colorIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Names everything using one colour — articles, BOM connections, components and colour codes —
as references, for drilling into the counts GetColors returns. colorId is a brand colour's id.
 */
  async brandColor_GetUsage(brandId: number, colorId: number, options: AxiosRequestConfig = {}): Promise<ColorUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/{colorId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (colorId === undefined || colorId === null)
        throw new Error("The parameter 'colorId' must be defined.");
    url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Turns a colour picked in the colour picker into one of the brand's colours and returns it.
`ExistingColor` returns that colour; `AdoptedLibraryColor` returns the brand's adoption of the
library colour, creating it if needed; `NewColor` creates a colour; `EditedColor` renames the
colour in place when nothing uses it, and otherwise creates a new colour with the edited values
beside it, leaving everything that uses the original untouched. `NoColorSelected` is a 400.
Nothing is pointed at the returned colour — the caller does that with its own endpoint.
 */
  async brandColor_ResolveColor(brandId: number, args: SetColorArgs, options: AxiosRequestConfig = {}): Promise<ColorDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/resolve";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Adopts a library colour into the brand. Without values, returns the brand's existing plain
adoption of it where there is one; with values, always creates a new colour.
 */
  async brandColor_AdoptLibraryColor(brandId: number, args: AdoptLibraryColorArgs, options: AxiosRequestConfig = {}): Promise<ColorDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/adopt";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Edits a colour in place, which changes it everywhere it is used — that being the point of
colours being shared. The body replaces the colour's whole value set: send every value, as a
code or group left out is cleared. For a colour adopted from a library, values equal to the
library's clear the override so it keeps tracking the library, and different CMYK/RGB values
make it a colour of the brand's own.
 */
  async brandColor_UpdateColor(brandId: number, colorId: number, values: BrandColorValues, options: AxiosRequestConfig = {}): Promise<ColorDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/{colorId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (colorId === undefined || colorId === null)
        throw new Error("The parameter 'colorId' must be defined.");
    url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = values;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Edits several colours in one save and returns them. `updates` replaces each listed colour's
values (the whole value set, as brandColor_UpdateColor) — a colour is shared, so the change
shows on every article, component and BOM connection using it. `numberUpdates` sets a colour's
number by hand, or with a null number hands it back to the brand's number template. Numbers
are unique within the brand and checked after the whole batch is applied, so a colour may
take the number another listed colour is moving off; two colours trading numbers in one call
is refused, as is a number another colour keeps. `groupSequentialNumberUpdates` sets a
colour's number within its colour group (the template's `group_sequential_number`), unique
within the group and checked the same way; a null takes the next one in the group, and a
colour without a group is refused. A colour whose group `updates` changes gets the next
number in its new group unless this call sets one. `customValueUpdates` writes custom field
values: an UPSERT per field, so fields a colour's entry does not name are left as they are. All
or nothing.
 */
  async brandColor_UpdateColors(brandId: number, args: UpdateColorsArgs, options: AxiosRequestConfig = {}): Promise<ColorDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/batch";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Sets the images of one or more colours, and whether a colour's first image stands in for its swatch
(`imageAsSwatch`; off, the swatch is the flat colour). Each colour holds files
of its own, so a picture is matched across colours by what it shows now (its newest version), not by
file id. REPLACES the set: on each colour, an image showing a listed picture stays and any other is
removed (its file is kept). A picture with `onEveryColor` is added to every colour not showing it yet —
set it on a new upload, or to spread a picture one colour has to all of them; a listed picture without
it is only kept where it already is. A colour that gets a picture another colour shows gets its own
copy of the file, without the history. To change the picture of an existing image, add a version to
its file with file_AddVersion (and brandColor_SpreadImageVersion for the other colours showing it).
Returns every listed colour's images.
 */
  async brandColor_UpdateImages(brandId: number, args: UpdateColorImagesArgs, options: AxiosRequestConfig = {}): Promise<ColorImagesDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/images";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * After file_AddVersion gave one colour's image a new picture, gives the same new version to every
image of `colorIds` still showing `replacedUrl`, each on its own file and history. Images showing
anything else are left alone. Returns every listed colour's images.
 */
  async brandColor_SpreadImageVersion(brandId: number, args: SpreadImageVersionArgs, options: AxiosRequestConfig = {}): Promise<ColorImagesDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/images/versions";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Tags and untags a set of colours across palettes in one go, the way the table's palette cell
edits them: a multi-row selection says which palettes to add and which to take away rather
than replacing each colour's list, so palettes it does not mention are left alone.
 */
  async brandColor_SetColorPalettes(brandId: number, args: SetColorPalettesArgs, options: AxiosRequestConfig = {}): Promise<ColorDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/palettes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The first sheet of an uploaded .xlsx as rows of cell text, for the import to map columns from.
Saves nothing. A sheet whose rows each sit in one cell (comma-separated text) comes back as one
column — split it into columns first.
 * @param file (optional) 
 */
  async brandColor_ReadImportSheet(brandId: number, file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<PlainSheetRow[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/import/read-sheet";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * What importing these rows would do, without saving anything: per row whether it creates a
colour, updates the one with that number, changes nothing, or has errors — and why. Colours
are matched by number. A number that is what the brand's template gives for the row's group
and group number is kept as generated; any other number is kept as typed.
 */
  async brandColor_PreviewImport(brandId: number, args: ImportColorsArgs, options: AxiosRequestConfig = {}): Promise<ColorImportPreview> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/import/preview";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Imports colours from rows: creates the ones whose number the brand does not have and updates
the ones it does, in one save. Refused if any row has errors (see brandColor_PreviewImport)
unless `skipInvalidRows`, which leaves those rows out. An update writes only the listed columns
and only adds palettes — it never takes a colour out of one.
 */
  async brandColor_Import(brandId: number, args: ImportColorsArgs, options: AxiosRequestConfig = {}): Promise<ColorImportResult> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/import";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Moves a set of colours to one colour status (colorStatus_GetList lists them). A colour in a
status hidden from colour search is no longer offered by the colour pickers, but stays on
every article, component and BOM already using it. Returns the colours.
 */
  async brandColor_SetColorStatus(brandId: number, args: SetColorStatusArgs, options: AxiosRequestConfig = {}): Promise<ColorDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/status";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Gives a set of colours one colour type (colorType_GetList lists them) — what kind of colour each
is, such as Solid or Print. Returns the colours.
 */
  async brandColor_SetColorType(brandId: number, args: SetColorTypeArgs, options: AxiosRequestConfig = {}): Promise<ColorDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/type";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Drops an override so an adopted colour tracks its library entry again. `field` is `Name` or
`Code` to put back just that value, leaving the other override alone; null puts back every
value. Refused for a colour that does not come from a library. Returns the colour.
 */
  async brandColor_ResetToLibrary(brandId: number, colorId: number, args: ResetToLibraryArgs, options: AxiosRequestConfig = {}): Promise<ColorDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/{colorId}/reset-to-library";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (colorId === undefined || colorId === null)
        throw new Error("The parameter 'colorId' must be defined.");
    url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Links existing colours to a library colour (from a library the brand has enabled; find one
with brandColor_SearchLibraryColors). Each colour takes the library's CMYK/RGB from then on.
Its name and code stay as the brand's own, unless they equal the library's exactly; a colour
with no code of its own shows the library's. Colours already linked move to the new entry.
Number, group, status, palettes and usages are untouched. Returns the colours.
 */
  async brandColor_LinkToLibrary(brandId: number, args: LinkToLibraryArgs, options: AxiosRequestConfig = {}): Promise<ColorDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/link-to-library";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Unlinks the listed colours from their library colours. Each keeps the name, code and CMYK/RGB
it shows now, as its own values, so nothing using it changes; it only stops following the
library. Listed colours that are not linked to a library are left as they are. Returns the colours.
 */
  async brandColor_UnlinkFromLibrary(brandId: number, colorIds: number[], options: AxiosRequestConfig = {}): Promise<ColorDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/unlink-from-library";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = colorIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Reads, changes nothing: the articles brandColor_MergeColors would refuse to renumber for the same
`keepId` and `mergeIds`, because their status locks the article number and the brand's number
template reads something that differs between the colours (`color_number` always does). Only
articles on the `mergeIds` colours move, so keeping a different colour changes the answer. An empty
list means the merge will not be refused for locked numbers.
 */
  async brandColor_PreviewMerge(brandId: number, args: MergeColorsArgs, options: AxiosRequestConfig = {}): Promise<LockedArticleDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/merge-preview";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Merges `mergeIds` into `keepId`: every article, BOM connection, component colour, colour code,
palette membership and recently-used entry using a merged colour is moved to the kept colour,
then the merged colours are deleted. Article numbers built from the colour regenerate; when that
would renumber an article whose status locks its number, the whole merge is refused naming every
such article (brandColor_PreviewMerge lists them up front). The kept colour's own values are unchanged; a custom field it has no value for takes the first merged colour's that has one. `keepId` must not be in `mergeIds`. Returns the kept colour.
 */
  async brandColor_MergeColors(brandId: number, args: MergeColorsArgs, options: AxiosRequestConfig = {}): Promise<ColorDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/merge";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Every colour library (Pantone and the like), with whether this brand has it enabled. Only an
enabled library's colours show up in colour search.
 */
  async brandColor_GetLibraries(brandId: number, options: AxiosRequestConfig = {}): Promise<ColorLibraryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/libraries";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Every colour in one library, for browsing it. A book runs to a few thousand colours, which is
one payload rather than a search per keystroke; the page filters what it has.
 */
  async brandColor_GetLibraryColors(brandId: number, libraryId: number, options: AxiosRequestConfig = {}): Promise<LibraryColorDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/libraries/{libraryId}/colors";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (libraryId === undefined || libraryId === null)
        throw new Error("The parameter 'libraryId' must be defined.");
    url_ = url_.replace("{libraryId}", encodeURIComponent("" + libraryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Searches the colours of the brand's enabled libraries only — never the brand's own colours —
for linking a colour with brandColor_LinkToLibrary. Every word of `searchTerm` must appear in
the colour's name or code; an exact name match comes first. `libraryId` (0 for all, ids from
brandColor_GetLibraries) keeps to one library. Page with `take` and `offset`.
 * @param libraryId (optional) 
 * @param take (optional) 
 * @param offset (optional) 
 */
  async brandColor_SearchLibraryColors(args: BrandColor_SearchLibraryColorsArgs, options: AxiosRequestConfig = {}): Promise<LibraryColorDto[]> {
    const { brandId, searchTerm, libraryId, take, offset, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/libraries/colors/search?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (searchTerm === undefined)
        throw new Error("The parameter 'searchTerm' must be defined.");
    else if(searchTerm !== null)
        url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (libraryId === null)
        throw new Error("The parameter 'libraryId' cannot be null.");
    else if (libraryId !== undefined)
        url_ += "libraryId=" + encodeURIComponent("" + libraryId) + "&";
    if (take === null)
        throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined)
        url_ += "take=" + encodeURIComponent("" + take) + "&";
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Turns a colour library (Pantone TCX and the like, listed by brandColor_GetLibraries) on or off
for this brand. Only an enabled library's colours appear in colour search and the picker. The
library and colours the brand already adopted from it are not changed. Returns every library
with its new state.
 */
  async brandColor_SetLibraryEnabled(brandId: number, libraryId: number, args: SetLibraryEnabledArgs, options: AxiosRequestConfig = {}): Promise<ColorLibraryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-colors/libraries/{libraryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (libraryId === undefined || libraryId === null)
        throw new Error("The parameter 'libraryId' must be defined.");
    url_ = url_.replace("{libraryId}", encodeURIComponent("" + libraryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read brand settings: number templates, enabled features, defaults.
 */
  async brand_GetBrand(brandId: number, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the brand's PLM flag, 2FA requirement and integration data. Read brand_GetBrand first and send back the current value of every field you are not changing — this replaces all of them. One trap: when this call is what first enables PLM on a brand that has never been configured, it also provisions the brand — auto-populating default configuration, or, given initialization.sourceBrandId with copyConfig, starting a background copy from that brand (brand_GetCopySourceCandidates lists the legal sources). Pass initialization.skip = true to change the flags and provision nothing.
 */
  async brand_Update(brandId: number, args: UpdateArgs, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * What this brand has written into PLM's own code — number generators that run instead of its
templates, and integrations that are not configurable in admin. Drives the banner on
admin > article numbers, so support can see why a template isn't taking effect.
 */
  async brand_GetCustomizations(brandId: number, options: AxiosRequestConfig = {}): Promise<BrandCustomizationsDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/customizations";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List this brand's cross-brand foreign-key violations. An empty list means the brand is self-contained; every entry is a reference pointing into another brand's data. Run it after copying configuration from another brand. Requires the global Admin role.
 */
  async brand_CheckContainment(brandId: number, options: AxiosRequestConfig = {}): Promise<CheckResult> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/check-containment";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Dump the brand's full configuration as a JSON file download.
Filename: brand-config-{slug}-{brandId}-{yyyy-MM-dd-HHmmss}.json.
 */
  async brand_ConfigExport(brandId: number, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/config-export";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brands whose PLM configuration could be copied into this one — the user's other configured brands, excluding this brand. These are the ids brand_Update's initialization accepts.
 */
  async brand_GetCopySourceCandidates(brandId: number, options: AxiosRequestConfig = {}): Promise<BrandReference[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/copy-source-candidates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Replace the brand's logo image. The endpoint takes the file itself, not a path, so it is NOT callable from run(): reach it through request_upload with deliverTo {operation: "brand_UpdateLogo"}. Nothing to attach afterwards — the upload is the write.
 * @param file (optional) 
 */
  async brand_UpdateLogo(brandId: number, file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/logo";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the template new product numbers are generated from. Affects entities created from now on; brand_RegenerateNumbers is what applies it to products that already exist. Preview it against a real product with brand_PreviewProductTemplates before saving. The body is a bare string.
 * @param template (optional) 
 */
  async brand_UpdateProductNumberTemplate(brandId: number, template: string | undefined, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/product-number-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = template;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the template new article numbers are generated from. Affects entities created from now on; brand_RegenerateNumbers is what applies it to articles that already exist. Preview it against a real product with brand_PreviewProductTemplates before saving. The body is a bare string.
 * @param template (optional) 
 */
  async brand_UpdateArticleNumberTemplate(brandId: number, template: string | undefined, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/article-number-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = template;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the template new SKU numbers are generated from. Affects entities created from now on; brand_RegenerateNumbers is what applies it to SKUs that already exist. Preview it against a real product with brand_PreviewProductTemplates before saving. The body is a bare string.
 * @param template (optional) 
 */
  async brand_UpdateSkuNumberTemplate(brandId: number, template: string | undefined, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-number-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = template;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Turn development numbers on or off for the brand. Turning it on stores a starting template in any development number template not yet set. While on, products, articles and SKUs are created with a number from the development templates and keep it until an article reaches a status marked as promoting development numbers, at which point that article and its product take their number from the ordinary templates. Which statuses those are is set per status with articleStatus_UpdateStatus. Existing entities are unaffected; they count as already promoted. The body is a bare boolean.
 */
  async brand_UpdateDevelopmentNumbers(brandId: number, useDevelopmentNumbers: boolean, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/development-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = useDevelopmentNumbers;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the template development product numbers are generated from, used while a product has not been promoted. Cannot be empty. The body is a bare string.
 */
  async brand_UpdateDevelopmentProductNumberTemplate(brandId: number, template: string, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/development-product-number-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = template;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the template development article numbers are generated from, used while an article has not been promoted. Its development_product_number variable is the product's development number; product_number is the same until the product is promoted, then its live number. Cannot be empty. The body is a bare string.
 */
  async brand_UpdateDevelopmentArticleNumberTemplate(brandId: number, template: string, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/development-article-number-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = template;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the template development SKU numbers are generated from, used while the SKU's article has not been promoted. Cannot be empty. The body is a bare string.
 */
  async brand_UpdateDevelopmentSkuNumberTemplate(brandId: number, template: string, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/development-sku-number-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = template;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the floor for auto-assigned internal product numbers — the counter never allocates below it. The body is a bare number.
 */
  async brand_UpdateMinimumProductInternalNumber(brandId: number, minimumNumber: number, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/minimum-product-internal-number";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = minimumNumber;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the template new component numbers are generated from. Affects components created from now on; brand_RegenerateComponentNumbers applies it to those that already exist. Preview it against a real component with brand_PreviewComponentTemplate before saving. The body is a bare string and may not be null.
 */
  async brand_UpdateComponentNumberTemplate(brandId: number, template: string, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-number-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = template;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the floor for auto-assigned internal component numbers — the counter never allocates below it. The body is a bare number.
 */
  async brand_UpdateMinimumComponentInternalNumber(brandId: number, minimumNumber: number, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/minimum-component-internal-number";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = minimumNumber;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the lowest sequential_number a new supplier can get. A new supplier gets the next number after the brand's highest, or this one if that is lower; existing suppliers are not renumbered. The body is a bare number.
 */
  async brand_UpdateMinimumSupplierSequentialNumber(brandId: number, minimumNumber: number, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/minimum-supplier-sequential-number";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = minimumNumber;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the template colour numbers are generated from. Existing colours keep their number until one of the values the template reads changes; a manually set number is never regenerated. The body is a bare string and may not be null.
 */
  async brand_UpdateColorNumberTemplate(brandId: number, template: string, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-number-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = template;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the floor for auto-assigned internal colour numbers — the counter never allocates below it. The body is a bare number.
 */
  async brand_UpdateMinimumColorInternalNumber(brandId: number, minimumNumber: number, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/minimum-color-internal-number";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = minimumNumber;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Whether a new colour takes the lowest free number in its sequences (true) or the one after
the highest (false, the default). Applies to `sequential_number`, floored at the minimum
colour internal number, and to `group_sequential_number`, counted from 1 within each colour
group. Only numbers handed out from now on are affected; no existing colour is renumbered.
The body is a bare boolean.
 */
  async brand_UpdateFillColorNumberGaps(brandId: number, fillGaps: boolean, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/fill-color-number-gaps";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = fillGaps;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the template supplier numbers are generated from. A new supplier is numbered from it when created; existing suppliers keep their number until brand_RegenerateSupplierNumbers is run. Variables: `sequential_number` and `country_code` (the two-letter code of the supplier's country, from its own address or else its company's). Every supplier must end up with a distinct number, so a template should normally include `sequential_number`. Preview with brand_PreviewSupplierTemplate first. The body is a bare string and may not be empty.
 */
  async brand_UpdateSupplierNumberTemplate(brandId: number, template: string, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/supplier-number-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = template;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Dry-run a supplier number template against every supplier in the brand without saving anything. Returns how many numbers would change, any number the template would give to more than one supplier (brand_RegenerateSupplierNumbers refuses while there are any), and the current and new number of up to 50 suppliers. A template that does not render comes back as Success:false with the reason in Error.
 */
  async brand_PreviewSupplierTemplate(brandId: number, template: string, options: AxiosRequestConfig = {}): Promise<SupplierTemplatePreviewResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/preview-supplier-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = template;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Renumber every supplier in the brand from the saved supplier number template and return how many numbers changed. All or nothing: if the template would give two suppliers the same number, nothing is changed and the error names the duplicates.
 */
  async brand_RegenerateSupplierNumbers(brandId: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/regenerate-supplier-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Dry-runs a colour number template against one of the brand's colours without saving anything. Returns the colour's current number and what `colorNumberTemplate` would give it; a template that does not render comes back as Success:false with the reason in Error. Check here before brand_UpdateColorNumberTemplate.
 */
  async brand_PreviewColorTemplate(brandId: number, args: ColorTemplatePreviewArgs, options: AxiosRequestConfig = {}): Promise<ColorTemplatePreviewResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/preview-color-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Dry-run a component number template against one real component without saving anything. Returns its current number, what the saved template produces and what the candidate produces, plus whether that component's number was set by hand. Check here before brand_UpdateComponentNumberTemplate.
 */
  async brand_PreviewComponentTemplate(brandId: number, args: ComponentTemplatePreviewArgs, options: AxiosRequestConfig = {}): Promise<ComponentTemplatePreviewResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/preview-component-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the numeric range colour codes are allocated from. The upper bound must be greater than the lower one, or the call is rejected.
 */
  async brand_UpdateColorCodeRange(brandId: number, args: UpdateColorCodeRangeArgs, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-code-range";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Dry-run product, article and SKU number templates against one real product without saving anything. Returns, per entity, its current number, what the saved template produces and what the candidate template produces — including the error when a template cannot be resolved. For a brand using development numbers, the same is returned for the development number and the development templates. This is the safe way to check a template before brand_UpdateProductNumberTemplate and its siblings.
 */
  async brand_PreviewProductTemplates(brandId: number, args: ProductTemplatesPreviewArgs, options: AxiosRequestConfig = {}): Promise<ProductTemplatesPreviewResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/preview-product-templates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Flag every product, article and SKU whose number does not match the current template as manually set, so a later regenerate leaves them alone. Runs as a background job: the call returns nothing and completion arrives as a PLM notification, so confirm by re-reading an entity rather than from the response. Run this before brand_RegenerateNumbers if hand-typed numbers must survive.
 */
  async brand_MarkManualNumbers(brandId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mark-manual-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Rewrite product, article and SKU numbers across the whole brand from the current templates, for every entity not marked as manually set. Runs as a background job: the call returns nothing and progress arrives as a PLM notification, so confirm by re-reading a number. This renumbers live data — preview with brand_PreviewProductTemplates, protect hand-typed numbers with brand_MarkManualNumbers, and put it to the user before calling.
 */
  async brand_RegenerateNumbers(brandId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/regenerate-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Rewrite component numbers across the whole brand from the current template, for every component not marked as manually set. Runs as a background job: the call returns nothing and progress arrives as a PLM notification, so confirm by re-reading a number. This renumbers live data — preview with brand_PreviewComponentTemplate and put it to the user before calling.
 */
  async brand_RegenerateComponentNumbers(brandId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/regenerate-component-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Turn SKU-level pricing on or off for the brand. Enabling is rejected with the affected field names while Article calculated templates still read shared prices; move those fields to SKU level or remove their price references first. The body is a bare boolean.
 */
  async brand_UpdateSkuLevelPricingEnabled(brandId: number, enabled: boolean, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-level-pricing-enabled";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = enabled;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Turn SKU-level weight on or off for the brand — this decides whether weight is held per SKU or once on the article above it. Changing it changes where every existing weight is read from, so confirm with the user before flipping it. The body is a bare boolean.
 */
  async brand_UpdateSkuLevelWeightEnabled(brandId: number, enabled: boolean, options: AxiosRequestConfig = {}): Promise<BrandDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-level-weight-enabled";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = enabled;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async brandSpecific_BrandSpecificEndpoints(brandId: number, options: AxiosRequestConfig = {}): Promise<BrandEndpointInfo[]> {
    let url_ = this.baseUrl + "/api/brand-specific/{brandId}/endpoints";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async brandSpecific_BrandSpecificEndpoint(brandId: number, urlEnding: string, options: AxiosRequestConfig = {}): Promise<string> {
    let url_ = this.baseUrl + "/api/brand-specific/{brandId}/{urlEnding}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (urlEnding === undefined || urlEnding === null)
        throw new Error("The parameter 'urlEnding' must be defined.");
    url_ = url_.replace("{urlEnding}", encodeURIComponent("" + urlEnding));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async brandStatistics_GetCurrentStatistics(brandId: number, options: AxiosRequestConfig = {}): Promise<CurrentStatisticsResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/statistics/current";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async brandStatistics_GetHistoricalStatistics(brandId: number, options: AxiosRequestConfig = {}): Promise<HistoricalStatisticsResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/statistics/historical";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Search the PLATFORM-WIDE company directory for a supplier to attach to this brand — not this brand's own list. Use it before creating a supplier by name: attaching an existing company inherits what the platform already knows about it (address, country, and the company-level manufacturer and OS ids), so those arrive for free instead of being retyped. Results span every brand's companies, and `ownedByBrand: true` marks the ones already on this brand's list. The `id` is a COMPANY id — it is what brandSupplier_AddBrandSupplierFromCompany takes, and it is NOT the brandSupplier id the brandSupplier_Update* operations want; get that from brandSupplier_BrandSuppliers after attaching. `name` and `country` show this brand's own override where one exists, otherwise the company's own.
 * @param searchTerm (optional) 
 * @param count (optional) 
 * @param offset (optional) 
 */
  async brandSupplier_Search(searchTerm: string | null | undefined, brandId: number, count: number | undefined, offset: number | undefined, options: AxiosRequestConfig = {}): Promise<CompanyWithEmailDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/search?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (count === null)
        throw new Error("The parameter 'count' cannot be null.");
    else if (count !== undefined)
        url_ += "count=" + encodeURIComponent("" + count) + "&";
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async brandSupplier_Usage(brandId: number, options: AxiosRequestConfig = {}): Promise<BrandSupplierUsageDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's suppliers in full. Use brandSupplier_Search instead when looking one up by name — this returns every supplier with all fields.
 */
  async brandSupplier_BrandSuppliers(brandId: number, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Add a supplier this brand names itself, creating the company if none of that name exists. Takes `name` and an optional `countryId`. To attach a company that is already on the platform use brandSupplier_AddBrandSupplierFromCompany instead — search for it with brandSupplier_Search first, since attaching inherits its details rather than making you retype them. Returns the BrandSupplierDto, whose `id` is what every brandSupplier_Update* operation takes from then on.
 */
  async brandSupplier_AddBrandSupplier(brandId: number, args: AddBrandSupplierArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Deletes the suppliers `ids` (a bare JSON array of brandSupplier ids). Refused as a whole, deleting
nothing, while any of them is still used by a component, product, order, sample round, BOM
template slot, BOM slot or as another supplier's sub-supplier — brandSupplier_GetUsageCounts names
the counts. To fold a duplicate supplier into another instead, use brandSupplier_MergeBrandSuppliers.
The suppliers' own sub-supplier links and supplier-portal access go with them.
 */
  async brandSupplier_DeleteBrandSuppliers(brandId: number, ids: number[], options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = ids;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Attach a company that already exists on the platform to this brand as a supplier. Takes the COMPANY id brandSupplier_Search returns, so whatever that company already carries — country, address, contact details, certifications, and the company-level manufacturer and OS ids — comes with it. Refuses a buyer, and a company already on this brand's list. To create a supplier the platform does not know yet, use brandSupplier_AddBrandSupplier with a name. Returns the BrandSupplierDto, whose `id` is what the brandSupplier_Update* operations take.
 */
  async brandSupplier_AddBrandSupplierFromCompany(brandId: number, companyId: number, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/from-company";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = companyId;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the supplier's name as this brand knows it on one or more suppliers. `ids` is which suppliers, `value` the value to write to all of them; omit it to clear.
 */
  async brandSupplier_UpdateName(brandId: number, args: UpdateBrandSupplierSingleTextArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/name";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the country on one or more suppliers. UpdateBrandSupplierSingleIdArgs is shared with six other supplier updates, so its `setId` is typed as optional — but this endpoint rejects a null one with "Country must not be empty". Send ids plus setId; removedIds is required by the type and can be empty.
 */
  async brandSupplier_UpdateCountry(brandId: number, args: UpdateBrandSupplierSingleIdArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/country";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the factory address on one or more suppliers. `ids` is which suppliers, `value` the value to write to all of them; omit it to clear.
 */
  async brandSupplier_UpdateFullAddress(brandId: number, args: UpdateBrandSupplierSingleTextArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/full-address";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the contact email addresses on one or more suppliers. `ids` is which suppliers, `value` the value to write to all of them; omit it to clear.
            `value` is a list of addresses separated by commas, semicolons or whitespace ("Name <addr>" is accepted and stored as the bare address); it is stored normalised as "a@x.com, b@y.se".
            The whole request is rejected with 400 if any address is invalid — nothing is saved. These addresses become the default To recipients of new sample rounds with the supplier.
 */
  async brandSupplier_UpdateContactEmail(brandId: number, args: UpdateBrandSupplierSingleTextArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/contact-email";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the external number (the brand's own reference for the supplier, e.g. an ERP id) on one or more suppliers. Not the supplier number, which brandSupplier_SetSupplierNumber sets. `ids` is which suppliers, `value` the value to write to all of them; omit it to clear.
 */
  async brandSupplier_UpdateExternalNumber(brandId: number, args: UpdateBrandSupplierSingleTextArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/external-number";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read a supplier's number, whether it was set by hand, and the number the brand's supplier number template would give it.
 */
  async brandSupplier_GetSupplierNumberInfo(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<SupplierNumberInfoResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/{id}/supplier-number-info";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set one supplier's supplier number by hand, or send null to go back to the number the template generates. A manual number must be unique within the brand, and Regenerate leaves it alone. Not the external number, which brandSupplier_UpdateExternalNumber sets. The body is a bare string or null.
 * @param supplierNumber (optional) 
 */
  async brandSupplier_SetSupplierNumber(brandId: number, id: number, supplierNumber: string | undefined, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/{id}/supplier-number";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = supplierNumber;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the manufacturer id, falling back to the company-level one when unset on one or more suppliers. `ids` is which suppliers, `value` the value to write to all of them; omit it to clear.
 */
  async brandSupplier_UpdateManufacturerId(brandId: number, args: UpdateBrandSupplierSingleTextArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/manufacturer-id";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the Open Supply Hub (OS) id, falling back to the company-level one when unset on one or more suppliers. `ids` is which suppliers, `value` the value to write to all of them; omit it to clear.
 */
  async brandSupplier_UpdateOshId(brandId: number, args: UpdateBrandSupplierSingleTextArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/osh-id";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the internal comment — visible to the brand, not to the supplier on one or more suppliers. `ids` is which suppliers, `value` the value to write to all of them; omit it to clear.
 */
  async brandSupplier_UpdateInternalComment(brandId: number, args: UpdateBrandSupplierSingleTextArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/internal-comment";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the lead time in days on one or more suppliers. `ids` is which suppliers, `value` the value to write to all of them; omit it to clear.
 */
  async brandSupplier_UpdateLeadTime(brandId: number, args: UpdateBrandSupplierSingleIntArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/lead-time";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the incoterms (delivery term) on one or more suppliers. `ids` is which suppliers; `setId` is the delivery term id to apply to all of them. With `setId` omitted, `removedIds` clears the value on any of those suppliers currently holding one of the delivery term ids it lists — it names values, not suppliers. Sending neither does nothing.
 */
  async brandSupplier_UpdateIncoterms(brandId: number, args: UpdateBrandSupplierSingleIdArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/incoterms";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the payment terms on one or more suppliers. `ids` is which suppliers; `setId` is the payment term id to apply to all of them. With `setId` omitted, `removedIds` clears the value on any of those suppliers currently holding one of the payment term ids it lists — it names values, not suppliers. Sending neither does nothing.
 */
  async brandSupplier_UpdatePaymentTerms(brandId: number, args: UpdateBrandSupplierSingleIdArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/payment-terms";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the default mode of transport on one or more suppliers. `ids` is which suppliers; `setId` is the mode of transport id to apply to all of them. With `setId` omitted, `removedIds` clears the value on any of those suppliers currently holding one of the mode of transport ids it lists — it names values, not suppliers. Sending neither does nothing.
 */
  async brandSupplier_UpdateMot(brandId: number, args: UpdateBrandSupplierSingleIdArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/mot";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the default currency on one or more suppliers. `ids` is which suppliers; `setId` is the currency id to apply to all of them. With `setId` omitted, `removedIds` clears the value on any of those suppliers currently holding one of the currency ids it lists — it names values, not suppliers. Sending neither does nothing.
 */
  async brandSupplier_UpdateDefaultCurrency(brandId: number, args: UpdateBrandSupplierSingleIdArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/default-currency";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the default country of origin on one or more suppliers. `ids` is which suppliers; `setId` is the country id to apply to all of them. With `setId` omitted, `removedIds` clears the value on any of those suppliers currently holding one of the country ids it lists — it names values, not suppliers. Sending neither does nothing.
 */
  async brandSupplier_UpdateDefaultCountryOfOrigin(brandId: number, args: UpdateBrandSupplierSingleIdArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/default-country-of-origin";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the supplier status on one or more suppliers. `ids` is which suppliers; `setId` is the status id to apply to all of them. With `setId` omitted, `removedIds` clears the value on any of those suppliers currently holding one of the status ids it lists — it names values, not suppliers. Sending neither does nothing.
 */
  async brandSupplier_UpdateStatus(brandId: number, args: UpdateBrandSupplierSingleIdArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/status";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a text custom field's value on one or more suppliers. The field is named in the route; omit `value` to clear it.
 */
  async brandSupplier_UpdateTextCustomField(brandId: number, customFieldId: number, args: UpdateBrandSupplierTextCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/custom-field-text/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a money custom field's value on one or more suppliers. Takes an amount and the numeric currencyId — never a currency code. Omit both to clear.
 */
  async brandSupplier_UpdateMoneyCustomField(brandId: number, customFieldId: number, args: UpdateBrandSupplierMoneyCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/custom-field-money/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a number-with-unit custom field's value on one or more suppliers. Takes a number and the numeric unitId. Omit both to clear.
 */
  async brandSupplier_UpdateNumberWithUnitCustomField(brandId: number, customFieldId: number, args: UpdateBrandSupplierNumberWithUnitCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/custom-field-number-with-unit/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a single-select custom field on one or more suppliers. `addedOptionId` is the option to select — always an optionId, never the label. `clear:true` empties the field; `removedOptionIds` deselects only where one of those options is currently chosen.
 */
  async brandSupplier_UpdateSingleSelectCustomField(brandId: number, customFieldId: number, args: UpdateBrandSupplierSingleSelectCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/custom-field-single-select/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a multi-select custom field on one or more suppliers. Merges: `addedOptionIds` selects, `removedOptionIds` deselects, `clear:true` empties the field first. Options are ids, never labels.
 */
  async brandSupplier_UpdateMultiSelectCustomField(brandId: number, customFieldId: number, args: UpdateBrandSupplierMultiSelectCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/custom-field-multi-select/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Attach or remove files on a files custom field across one or more suppliers. Merges: `addFiles` attaches, `removeFiles` detaches, anything unmentioned is left alone.
 */
  async brandSupplier_UpdateFilesCustomField(brandId: number, customFieldId: number, args: UpdateBrandSupplierFilesCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/custom-field-files/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Repoint a supplier custom-field value at a different custom-field definition.
 */
  async brandSupplier_RelinkCustomField(brandId: number, customFieldId: number, args: RelinkBrandSupplierCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/custom-field-relink/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Attach or detach sub-suppliers on one or more suppliers. Merges: `addedSubSupplierIds` links, `removedSubSupplierIds` unlinks, anything unmentioned is left alone.
 */
  async brandSupplier_UpdateSubSuppliers(brandId: number, args: UpdateBrandSupplierSubSuppliersArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/sub-suppliers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read this supplier's supplier-portal state for the brand: whether the portal is on
            (and since when and why), the people at the supplier who see this brand's sample rounds there,
            pending invitations, and suggested addresses from the rounds already sent to this supplier.
            Read only.
 */
  async brandSupplier_GetPortalStatus(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<SupplierPortalStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/{id}/portal";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Switch the supplier portal on or off for this supplier. Off hides this brand's sample
            rounds from everyone at the supplier without removing anyone's access, so switching it back on
            restores what they saw. The body is a bare boolean. Returns the relationship's portal state.
 */
  async brandSupplier_SetPortalEnabled(brandId: number, id: number, enabled: boolean, options: AxiosRequestConfig = {}): Promise<SupplierPortalStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/{id}/portal";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = enabled;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the people at this supplier who see this brand's sample rounds in the supplier
            portal: name, email, photo, role, and how they got access. Only the people; the portal state,
            pending invitations and suggestions are brandSupplier_GetPortalStatus. Read only.
 */
  async brandSupplier_GetPortalPeople(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<SupplierPortalAccessDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/{id}/portal/people";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Give people at this supplier access to this brand's sample rounds in the supplier
            portal, by email address ("Name <addr>" forms are accepted). Someone already in the
            portal for the supplier's company is given access at once and emailed that they have it;
            anyone else is emailed a single-use invitation link, unless one is already pending, so the
            same list can be sent again. One unparseable address refuses the whole call. This also lifts
            an earlier revoke for these people. Access covers this brand only: the supplier's other
            brands stay invisible to them. Returns the relationship's portal state, people and pending
            invitations included.
 */
  async brandSupplier_InvitePortalPeople(brandId: number, id: number, args: InvitePortalPeopleArgs, options: AxiosRequestConfig = {}): Promise<SupplierPortalStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/{id}/portal/invitations";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Take one person's access to this brand's sample rounds in the supplier portal away.
            It stays away: being on a round's emails or a colleague's tick does not give it back, only
            this brand inviting them again with brandSupplier_InvitePortalPeople. Their account, their
            place at the supplier company and their access to other brands are untouched. To hide this
            brand from everyone at once, switch the portal off with brandSupplier_SetPortalEnabled instead.
 */
  async brandSupplier_RevokePortalAccess(brandId: number, id: number, userId: string, options: AxiosRequestConfig = {}): Promise<SupplierPortalStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/{id}/portal/people/{userId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Reads, changes nothing: for each of the suppliers `ids` (a bare JSON array of brandSupplier ids),
how many components, products, orders, sample rounds, BOM template slots, BOM slots and parent
suppliers (asSubSupplier) still use it. Any non-zero count makes brandSupplier_DeleteBrandSuppliers
refuse. Counts the ids as a set about to be deleted together: a sub-supplier link from a parent
that is also in `ids` is not counted, since it goes with the parent. One entry per id.
 */
  async brandSupplier_GetUsageCounts(brandId: number, ids: number[], options: AxiosRequestConfig = {}): Promise<BrandSupplierUsageCountsDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/usage-counts";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = ids;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async brandSupplier_DeleteBrandSupplier(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Reads, changes nothing: what would make brandSupplier_MergeBrandSuppliers refuse the same
`keepId` and `mergeIds`. Each entry is a product season, BOM slot, component, BOM
template or saved section that lists more than one of these suppliers, with a link to it and the
names of the suppliers it lists — merging would list the kept supplier there twice, and only a
person can choose which entry stays. Remove all but one of them there, then merge. The answer
does not depend on which supplier is kept. An empty list means the merge will go through.
 */
  async brandSupplier_PreviewMergeBrandSuppliers(brandId: number, args: MergeBrandSuppliersArgs, options: AxiosRequestConfig = {}): Promise<SupplierMergeConflictDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/merge-preview";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Merges the suppliers `mergeIds` into `keepId`, for when one supplier has been entered more than
once. Every product, BOM, component, template, order, sample round and m-chart export using a
merged supplier is moved to the kept one, which also gains the certifications, compliances and
sub-supplier links it lacks; then the merged suppliers are deleted. The kept supplier's own
fields (name, number, address, terms, custom fields) are unchanged. Refused as a whole when
something lists more than one of the suppliers — brandSupplier_PreviewMergeBrandSuppliers names
each one. `keepId` must not be in `mergeIds`. Returns the kept supplier.
 */
  async brandSupplier_MergeBrandSuppliers(brandId: number, args: MergeBrandSuppliersArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/merge";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async brandSupplier_GetExcel(brandId: number, args: GetExcelArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/export";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Attach, update or detach certificates on one or more suppliers. Unlike most collection writes this MERGES: `upserts` adds or updates, `removedCertificateIds` detaches, and a certificate you do not mention is left alone. An upsert is matched by certificateId. `ids` is which suppliers to apply it to.
 */
  async brandSupplier_UpdateCertifications(brandId: number, args: UpdateBrandSupplierCertificationsArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/certifications";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Attach, update or detach compliances on one or more suppliers. Unlike most collection writes this MERGES: `upserts` adds or updates, `removedComplianceIds` detaches, and a compliance you do not mention is left alone. An upsert is matched by complianceId. `ids` is which suppliers to apply it to.
 */
  async brandSupplier_UpdateCompliances(brandId: number, args: UpdateBrandSupplierCompliancesArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/compliances";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async brandSupplier_ImportBrandSuppliers(brandId: number, file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brandsuppliers/import";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the supplier statuses this brand has defined — the values brandSupplier_UpdateStatus takes.
 */
  async brandSupplierStatus_GetList(brandId: number, options: AxiosRequestConfig = {}): Promise<BrandSupplierStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-supplier-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async brandSupplierStatus_Create(brandId: number, args: CreateBrandSupplierStatusArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-supplier-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async brandSupplierStatus_Update(brandId: number, statusId: number, args: UpdateBrandSupplierStatusArgs, options: AxiosRequestConfig = {}): Promise<BrandSupplierStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-supplier-statuses/{statusId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async brandSupplierStatus_Delete(brandId: number, statusId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-supplier-statuses/{statusId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async brandSupplierStatus_GetUsage(brandId: number, statusId: number, options: AxiosRequestConfig = {}): Promise<BrandSupplierStatusUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-supplier-statuses/{statusId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Retire a supplier status by moving every supplier on it to a replacement, then deleting it. Prefer this over brandSupplierStatus_Delete when the status is still in use.
 */
  async brandSupplierStatus_Replace(brandId: number, statusId: number, args: ReplaceBrandSupplierStatusArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-supplier-statuses/{statusId}/replace";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async brandSupplierStatus_UpdateOrder(brandId: number, statusIds: number[], options: AxiosRequestConfig = {}): Promise<BrandSupplierStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/brand-supplier-statuses/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = statusIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async certificate_ListCertificates(brandId: number, options: AxiosRequestConfig = {}): Promise<CertificateDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/certificates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async certificate_CreateCertificate(brandId: number, certificateDto: CertificateDto, options: AxiosRequestConfig = {}): Promise<CertificateDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/certificates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = certificateDto;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async certificate_GetCertificateUsage(brandId: number, certificateId: number, options: AxiosRequestConfig = {}): Promise<CertificateUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/certificates/{certificateId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (certificateId === undefined || certificateId === null)
        throw new Error("The parameter 'certificateId' must be defined.");
    url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async certificate_DeleteCertificate(brandId: number, certificateId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/certificates/{certificateId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (certificateId === undefined || certificateId === null)
        throw new Error("The parameter 'certificateId' must be defined.");
    url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async certificate_UpdateCertificate(brandId: number, certificateId: number, certificateDto: CertificateDto, options: AxiosRequestConfig = {}): Promise<CertificateDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/certificates/{certificateId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (certificateId === undefined || certificateId === null)
        throw new Error("The parameter 'certificateId' must be defined.");
    url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = certificateDto;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async certificateReminder_GetReminders(brandId: number, options: AxiosRequestConfig = {}): Promise<CertificateReminderDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/certificate-reminders";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async certificateReminder_CreateReminder(brandId: number, args: AddCertificateReminderArgs, options: AxiosRequestConfig = {}): Promise<CertificateReminderDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/certificate-reminders";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async certificateReminder_UpdateReminder(brandId: number, reminderId: number, args: UpdateCertificateReminderArgs, options: AxiosRequestConfig = {}): Promise<CertificateReminderDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/certificate-reminders/{reminderId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (reminderId === undefined || reminderId === null)
        throw new Error("The parameter 'reminderId' must be defined.");
    url_ = url_.replace("{reminderId}", encodeURIComponent("" + reminderId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async certificateReminder_DeleteReminder(brandId: number, reminderId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/certificate-reminders/{reminderId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (reminderId === undefined || reminderId === null)
        throw new Error("The parameter 'reminderId' must be defined.");
    url_ = url_.replace("{reminderId}", encodeURIComponent("" + reminderId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async channel_ListChannels(brandId: number, options: AxiosRequestConfig = {}): Promise<ChannelDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/channels";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a sales channel. `strict` matters only to what the Integration API sends for this channel: strict resolves an article to a season whose window has already started, non-strict also falls forward to upcoming seasons and finally to the article's base values. It changes nothing inside PLM and does not gate which articles the channel carries.
 */
  async channel_CreateChannel(brandId: number, args: CreateChannelArgs, options: AxiosRequestConfig = {}): Promise<ChannelDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/channels";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Update a sales channel. `strict` matters only to what the Integration API sends for this channel: strict resolves an article to a season whose window has already started, non-strict also falls forward to upcoming seasons and finally to the article's base values. It changes nothing inside PLM and does not gate which articles the channel carries.
 */
  async channel_UpdateChannel(brandId: number, channelId: number, args: UpdateChannelArgs, options: AxiosRequestConfig = {}): Promise<ChannelDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/channels/{channelId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (channelId === undefined || channelId === null)
        throw new Error("The parameter 'channelId' must be defined.");
    url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async channel_DeleteChannel(brandId: number, channelId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/channels/{channelId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (channelId === undefined || channelId === null)
        throw new Error("The parameter 'channelId' must be defined.");
    url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async channel_ReorderChannels(brandId: number, channelIds: number[], options: AxiosRequestConfig = {}): Promise<ChannelDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/channels/reorder";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = channelIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List chat messages and tasks. Returns ONLY those you authored or are a recipient of — there is no brand-wide view, so you cannot survey or audit other people's tasks. To be able to check on a task later, include yourself in its recipients when creating it.
 */
  async chat_GetChatMessages(brandId: number, options: AxiosRequestConfig = {}): Promise<ChatMessageDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/chat";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Post a message or an assignable task to other brand users. Kind:1 is a Task (has a deadline and an Open/Ongoing/Done status); Kind:0 is a plain message. Set contextUrl and contextLabel to the article or product it concerns, or the recipient gets no link back. Three things to know: a task's status is SHARED — whoever marks it done closes it for every recipient, so use one task per person if you want individual accountability; an EMPTY recipientIds list silently files it to yourself instead of erroring; and there is no idempotency key, so running the same instruction twice creates duplicate tasks. Resolve recipient user ids first — an unknown id is rejected outright.
 */
  async chat_CreateChatMessage(brandId: number, args: CreateChatMessageArgs, options: AxiosRequestConfig = {}): Promise<ChatMessageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/chat";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Edit the body, and for tasks the deadline, of a message you authored. Author-only; a deadline set on a plain message is silently dropped.
 */
  async chat_Edit(brandId: number, chatMessageId: number, args: EditChatMessageArgs, options: AxiosRequestConfig = {}): Promise<ChatMessageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/chat/{chatMessageId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (chatMessageId === undefined || chatMessageId === null)
        throw new Error("The parameter 'chatMessageId' must be defined.");
    url_ = url_.replace("{chatMessageId}", encodeURIComponent("" + chatMessageId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a task's status (0 Open, 1 Ongoing, 2 Done). Shared across all recipients: this closes the task for everyone. Only the author or a recipient may call it.
 */
  async chat_UpdateStatus(brandId: number, chatMessageId: number, args: UpdateChatStatusArgs, options: AxiosRequestConfig = {}): Promise<ChatMessageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/chat/{chatMessageId}/status";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (chatMessageId === undefined || chatMessageId === null)
        throw new Error("The parameter 'chatMessageId' must be defined.");
    url_ = url_.replace("{chatMessageId}", encodeURIComponent("" + chatMessageId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Mark every message addressed to you as seen. Affects only your own unread state.
 */
  async chat_MarkAllSeen(brandId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/chat/seen";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async color_GetPalettes(brandId: number, options: AxiosRequestConfig = {}): Promise<ColorPaletteDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/palettes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async color_AddPalette(brandId: number, args: AddPaletteArgs, options: AxiosRequestConfig = {}): Promise<ColorPaletteDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/palettes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List colour palettes with their colours.
 */
  async color_GetPalettesWithColors(brandId: number, options: AxiosRequestConfig = {}): Promise<ColorPaletteWithColorsDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/palettes-with-colors";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * What every palette holds, in one request: per palette, how many colours it has and a spread
of up to 24 of them (name and RGB). For a palette's full list of colours, use
color_GetPaletteWithColors.
 */
  async color_GetPaletteContents(brandId: number, options: AxiosRequestConfig = {}): Promise<ColorPaletteContentsDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/palettes/contents";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * One palette with every colour in it.
 */
  async color_GetPaletteWithColors(brandId: number, paletteId: number, options: AxiosRequestConfig = {}): Promise<ColorPaletteWithColorsDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/palettes/{paletteId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (paletteId === undefined || paletteId === null)
        throw new Error("The parameter 'paletteId' must be defined.");
    url_ = url_.replace("{paletteId}", encodeURIComponent("" + paletteId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Deletes a palette. A palette is a tag on colours, so only the palette and its memberships go:
every colour in it stays, and so does everything using those colours.
 */
  async color_DeletePalette(brandId: number, paletteId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/palettes/{paletteId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (paletteId === undefined || paletteId === null)
        throw new Error("The parameter 'paletteId' must be defined.");
    url_ = url_.replace("{paletteId}", encodeURIComponent("" + paletteId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async color_UpdatePalette(brandId: number, paletteId: number, args: UpdatePaletteArgs, options: AxiosRequestConfig = {}): Promise<ColorPaletteDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/palettes/{paletteId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (paletteId === undefined || paletteId === null)
        throw new Error("The parameter 'paletteId' must be defined.");
    url_ = url_.replace("{paletteId}", encodeURIComponent("" + paletteId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Finds colours by part of their name or code — use it to resolve a colour the user names. Each
result is one of two kinds: `color`, a colour the brand has, whose id can be set on articles,
components and BOMs as it is; or `libraryColor`, a colour from a library the brand has enabled
but has not adopted, which has to be adopted with brandColor_AdoptLibraryColor (or sent as an
adopted library colour wherever a colour is set) before anything can use it. The brand's own
colours come first, most used first; library colours fill the rest of the page, and a library
colour the brand has adopted unchanged appears only as the brand's colour. `paletteId` (0 for
all) keeps to one palette, and a leading word naming a palette does the same ("solid blue"
looks for "blue" in the Solid Colors palette); either leaves library colours out.
`libraryId` (0 for all) keeps to one library's colours, adopted or not. Page with `take` and
`offset`.
 * @param paletteId (optional) 
 * @param libraryId (optional) 
 * @param take (optional) 
 * @param offset (optional) 
 */
  async color_SearchColors(args: Color_SearchColorsArgs, options: AxiosRequestConfig = {}): Promise<ColorSearchResultDto[]> {
    const { brandId, searchTerm, paletteId, libraryId, take, offset, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/search?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (searchTerm === undefined)
        throw new Error("The parameter 'searchTerm' must be defined.");
    else if(searchTerm !== null)
        url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (paletteId === null)
        throw new Error("The parameter 'paletteId' cannot be null.");
    else if (paletteId !== undefined)
        url_ += "paletteId=" + encodeURIComponent("" + paletteId) + "&";
    if (libraryId === null)
        throw new Error("The parameter 'libraryId' cannot be null.");
    else if (libraryId !== undefined)
        url_ += "libraryId=" + encodeURIComponent("" + libraryId) + "&";
    if (take === null)
        throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined)
        url_ += "take=" + encodeURIComponent("" + take) + "&";
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Exact colour lookup for a batch of entries, one result per entry in order. An entry naming a
palette is looked for in that palette; one naming none, among all of the brand's colours.
Unlike SearchColors — a paginated fuzzy search built for type-ahead —
this matches the way the importers do, so text that resolves here resolves there too.
            
Ambiguity is reported rather than resolved: the importers take the first match, which
is not stable across requests, and a caller writing the wrong colour without being told
is worse than being handed nothing.
            
Read-only: the matching half of ImportHelpers only, with no colour-group inference and
nothing saved.
 */
  async color_LookupColors(brandId: number, args: LookupColorsArgs, options: AxiosRequestConfig = {}): Promise<ColorLookupResult[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/lookup";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Merges palettes into one: every colour in `paletteIds` is tagged into `intoPaletteId`, and
the palettes in `paletteIds` are deleted. `intoPaletteId` keeps its name, icon and season.
Only palette membership changes — the colours themselves, and everything using them, stay.
 */
  async color_MergePalettes(brandId: number, args: MergePalettesArgs, options: AxiosRequestConfig = {}): Promise<ColorPaletteWithColorsDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/palettes/merge";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Tags an existing colour into a palette. Palettes are tags over colours, so a
            colour can sit in several at once.
 */
  async color_AddColorToPalette(brandId: number, paletteId: number, colorId: number, options: AxiosRequestConfig = {}): Promise<ColorPaletteWithColorsDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/palettes/{paletteId}/colors/{colorId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (paletteId === undefined || paletteId === null)
        throw new Error("The parameter 'paletteId' must be defined.");
    url_ = url_.replace("{paletteId}", encodeURIComponent("" + paletteId));
    if (colorId === undefined || colorId === null)
        throw new Error("The parameter 'colorId' must be defined.");
    url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Untags a colour from a palette. The colour itself is untouched.
 */
  async color_RemoveColorFromPalette(brandId: number, paletteId: number, colorId: number, options: AxiosRequestConfig = {}): Promise<ColorPaletteWithColorsDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/palettes/{paletteId}/colors/{colorId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (paletteId === undefined || paletteId === null)
        throw new Error("The parameter 'paletteId' must be defined.");
    url_ = url_.replace("{paletteId}", encodeURIComponent("" + paletteId));
    if (colorId === undefined || colorId === null)
        throw new Error("The parameter 'colorId' must be defined.");
    url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Bulk-adds colours to a palette, reusing any that already exist on the brand.
 */
  async color_AddPaletteColorsToPalette(brandId: number, paletteId: number, args: AddMultiplePaletteColorsArgs, options: AxiosRequestConfig = {}): Promise<ColorPaletteWithColorsDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/palettes/{paletteId}/add-multiple-colors";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (paletteId === undefined || paletteId === null)
        throw new Error("The parameter 'paletteId' must be defined.");
    url_ = url_.replace("{paletteId}", encodeURIComponent("" + paletteId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async color_GetColorCodes(brandId: number, options: AxiosRequestConfig = {}): Promise<ColorCodeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/codes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a colour code. The body is a DISCRIMINATED union — send `type` ("BrandColor" with `brandColorId` to key the code to one of the brand's colours, "CustomName" with `name` and optional `colorGroupId` to key it to a colour name, "NoColor" for a bare code). Omitting it is a 500, not a 400.
 */
  async color_CreateColorCode(brandId: number, args: SetColorCodeArgs, options: AxiosRequestConfig = {}): Promise<ColorCodeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/codes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Update a colour code. The body is a DISCRIMINATED union — send `type` ("BrandColor", "CustomName" or "NoColor") alongside the fields, as for color_CreateColorCode. Omitting it is a 500, not a 400. The read hands back a flat shape carrying `type`; echo that value.
 */
  async color_UpdateColorCode(brandId: number, codeId: number, args: SetColorCodeArgs, options: AxiosRequestConfig = {}): Promise<ColorCodeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/codes/{codeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (codeId === undefined || codeId === null)
        throw new Error("The parameter 'codeId' must be defined.");
    url_ = url_.replace("{codeId}", encodeURIComponent("" + codeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * No usage pre-check: nothing references a ColorCode, it only maps a
colour to a code for external systems.
 */
  async color_DeleteColorCode(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/codes/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the colours most recently applied to articles in this brand. A shortcut for pickers, not a definition — the palettes are the source of truth.
 */
  async color_GetRecentlyUsed(brandId: number, options: AxiosRequestConfig = {}): Promise<ColorDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/colors/recently-used";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async colorGroup_GetColorGroups(brandId: number, options: AxiosRequestConfig = {}): Promise<ColorGroupDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-groups";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async colorGroup_CreateColorGroup(brandId: number, args: CreateColorGroupArgs, options: AxiosRequestConfig = {}): Promise<ColorGroupDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-groups";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * What every group holds, in one request — the counts and sample swatches the groups page
draws on each card.
 */
  async colorGroup_GetColorGroupContents(brandId: number, options: AxiosRequestConfig = {}): Promise<ColorGroupLibraryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-groups/contents";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Every colour filed in the named groups, with the group each one would land in today.
What the reclassify list is built from: two groups sitting close together file new colours
between them almost at random, and this is the list of what that has actually done.
            
With allGroups and includeUngrouped it answers for the whole brand at once,
which is how the page offers to file the colours that belong to no group.
 * @param colorGroupIds (optional) 
 * @param allGroups (optional) 
 * @param includeUngrouped (optional) 
 */
  async colorGroup_GetColorGroupMembers(brandId: number, colorGroupIds: number[] | undefined, allGroups: boolean | undefined, includeUngrouped: boolean | undefined, options: AxiosRequestConfig = {}): Promise<ColorGroupMemberDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-groups/members?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (colorGroupIds === null)
        throw new Error("The parameter 'colorGroupIds' cannot be null.");
    else if (colorGroupIds !== undefined)
        colorGroupIds && colorGroupIds.forEach(item => { url_ += "colorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (allGroups === null)
        throw new Error("The parameter 'allGroups' cannot be null.");
    else if (allGroups !== undefined)
        url_ += "allGroups=" + encodeURIComponent("" + allGroups) + "&";
    if (includeUngrouped === null)
        throw new Error("The parameter 'includeUngrouped' cannot be null.");
    else if (includeUngrouped !== undefined)
        url_ += "includeUngrouped=" + encodeURIComponent("" + includeUngrouped) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Files the named colours into the groups given for them. One request for the lot, so
a list sorted out in the dialog lands as one change rather than one per colour.
 */
  async colorGroup_RefileColors(brandId: number, args: RefileColorsArgs, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-groups/refile";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * A colour for a name — "Moss Green" — so a group can be coloured from what it is called.
Deliberately the shared suggestion rather than the one the import uses: a colour group is a
definition, and reading it off the brand's own articles hands back their mistakes. Null when
nothing could be suggested, which is a normal answer rather than a failure.
 */
  async colorGroup_SuggestColorForName(brandId: number, name: string, options: AxiosRequestConfig = {}): Promise<SuggestedColorDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-groups/suggest-color?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (name === undefined || name === null)
        throw new Error("The parameter 'name' must be defined and cannot be null.");
    else
        url_ += "name=" + encodeURIComponent("" + name) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async colorGroup_ReorderColorGroups(brandId: number, colorGroupIds: number[], options: AxiosRequestConfig = {}): Promise<ColorGroupDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-groups/reorder";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = colorGroupIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async colorGroup_UpdateColorGroup(brandId: number, colorGroupId: number, args: CreateColorGroupArgs, options: AxiosRequestConfig = {}): Promise<ColorGroupDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-groups/{colorGroupId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (colorGroupId === undefined || colorGroupId === null)
        throw new Error("The parameter 'colorGroupId' must be defined.");
    url_ = url_.replace("{colorGroupId}", encodeURIComponent("" + colorGroupId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async colorGroup_DeleteColorGroup(brandId: number, colorGroupId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-groups/{colorGroupId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (colorGroupId === undefined || colorGroupId === null)
        throw new Error("The parameter 'colorGroupId' must be defined.");
    url_ = url_.replace("{colorGroupId}", encodeURIComponent("" + colorGroupId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async colorGroup_CountUsages(brandId: number, colorGroupId: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-groups/{colorGroupId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (colorGroupId === undefined || colorGroupId === null)
        throw new Error("The parameter 'colorGroupId' must be defined.");
    url_ = url_.replace("{colorGroupId}", encodeURIComponent("" + colorGroupId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Moves every colour in the brand from one colour group to another (the body is the new group's id). A colour is shared, so this reaches every article, component and BOM connection using those colours, in every season. To move only some colours, use overview_MassEditColorGroup on the articles holding them.
 */
  async colorGroup_ReplaceColorGroup(brandId: number, colorGroupId: number, newColorGroupId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-groups/{colorGroupId}/replace";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (colorGroupId === undefined || colorGroupId === null)
        throw new Error("The parameter 'colorGroupId' must be defined.");
    url_ = url_.replace("{colorGroupId}", encodeURIComponent("" + colorGroupId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = newColorGroupId;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Move every color off one color group onto whichever remaining group is closest in RGB, chosen per color. Brand-wide and not season-scoped; the target differs per color and is not reported back, so the result cannot be predicted or undone from the response. Prefer colorGroup_ReplaceColorGroup with an explicit target.
 */
  async colorGroup_ReplaceColorGroupWithNearest(brandId: number, colorGroupId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-groups/{colorGroupId}/replace-with-nearest";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (colorGroupId === undefined || colorGroupId === null)
        throw new Error("The parameter 'colorGroupId' must be defined.");
    url_ = url_.replace("{colorGroupId}", encodeURIComponent("" + colorGroupId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Folds one colour group into another: every colour filed under it moves, and the group itself
is deleted. Unlike replacing, nothing is left behind — a merged group is gone.
 */
  async colorGroup_MergeColorGroup(brandId: number, colorGroupId: number, args: MergeColorGroupArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-groups/{colorGroupId}/merge";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (colorGroupId === undefined || colorGroupId === null)
        throw new Error("The parameter 'colorGroupId' must be defined.");
    url_ = url_.replace("{colorGroupId}", encodeURIComponent("" + colorGroupId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the colour palette statuses this brand has defined, in order — the `statusId` a palette
takes in color_AddPalette and color_UpdatePalette. The first is the status a new palette starts
in. `hideInColorPicker` means palettes in that status are not offered as a filter in the
colour pickers; their colours can still be found and used.
 */
  async colorPaletteStatus_GetList(brandId: number, options: AxiosRequestConfig = {}): Promise<ColorPaletteStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-palette-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Add a palette status at the end of the list. `color` is a CSS colour such as `rgb(90, 213, 121)`.
 */
  async colorPaletteStatus_Create(brandId: number, args: ColorPaletteStatusArgs, options: AxiosRequestConfig = {}): Promise<ColorPaletteStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-palette-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Replace a palette status's name, colour and flag.
 */
  async colorPaletteStatus_Update(brandId: number, statusId: number, args: ColorPaletteStatusArgs, options: AxiosRequestConfig = {}): Promise<ColorPaletteStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-palette-statuses/{statusId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a palette status no palette is in. Refused while palettes use it (see colorPaletteStatus_Replace) and for the brand's last status.
 */
  async colorPaletteStatus_Delete(brandId: number, statusId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-palette-statuses/{statusId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The palettes in a palette status.
 */
  async colorPaletteStatus_GetUsage(brandId: number, statusId: number, options: AxiosRequestConfig = {}): Promise<ColorPaletteStatusUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-palette-statuses/{statusId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Retire a palette status by moving every palette in it to a replacement status, then deleting it.
 */
  async colorPaletteStatus_Replace(brandId: number, statusId: number, args: ReplaceColorPaletteStatusArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-palette-statuses/{statusId}/replace";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Reorder the palette statuses. `statusIds` must list every status exactly once; the first becomes the status new palettes start in.
 */
  async colorPaletteStatus_UpdateOrder(brandId: number, statusIds: number[], options: AxiosRequestConfig = {}): Promise<ColorPaletteStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-palette-statuses/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = statusIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the colour statuses this brand has defined, in order — the values brandColor_SetColorStatus
takes. The first is the status every new colour starts in. `hideInColorSearch` means colours in
that status are not offered by the colour pickers.
 */
  async colorStatus_GetList(brandId: number, options: AxiosRequestConfig = {}): Promise<ColorStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Add a colour status at the end of the list. `color` is a CSS colour such as `rgb(90, 213, 121)`.
 */
  async colorStatus_Create(brandId: number, args: ColorStatusArgs, options: AxiosRequestConfig = {}): Promise<ColorStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Replace a colour status's name, colour and flags.
 */
  async colorStatus_Update(brandId: number, statusId: number, args: ColorStatusArgs, options: AxiosRequestConfig = {}): Promise<ColorStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-statuses/{statusId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a colour status no colour is in. Refused while colours use it (see colorStatus_Replace) and for the brand's last status.
 */
  async colorStatus_Delete(brandId: number, statusId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-statuses/{statusId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The colours in a colour status.
 */
  async colorStatus_GetUsage(brandId: number, statusId: number, options: AxiosRequestConfig = {}): Promise<ColorStatusUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-statuses/{statusId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Retire a colour status by moving every colour in it to a replacement status, then deleting it.
 */
  async colorStatus_Replace(brandId: number, statusId: number, args: ReplaceColorStatusArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-statuses/{statusId}/replace";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Reorder the colour statuses. `statusIds` must list every status exactly once; the first becomes the status new colours start in.
 */
  async colorStatus_UpdateOrder(brandId: number, statusIds: number[], options: AxiosRequestConfig = {}): Promise<ColorStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-statuses/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = statusIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the colour types this brand has defined, in order — what kind of colour each is, such as
Solid, Print or Artwork, and the values brandColor_SetColorType takes. The first is the type every
new colour starts in. `code` is what a colour number template's `color_type_code` writes.
 */
  async colorType_GetList(brandId: number, options: AxiosRequestConfig = {}): Promise<ColorTypeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Add a colour type at the end of the list.
 */
  async colorType_Create(brandId: number, args: ColorTypeArgs, options: AxiosRequestConfig = {}): Promise<ColorTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Replace a colour type's name and code. An empty code clears it.
 */
  async colorType_Update(brandId: number, typeId: number, args: ColorTypeArgs, options: AxiosRequestConfig = {}): Promise<ColorTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-types/{typeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a colour type no colour has. Refused while colours have it (see colorType_Replace) and for the brand's last type.
 */
  async colorType_Delete(brandId: number, typeId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-types/{typeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The colours of a colour type.
 */
  async colorType_GetUsage(brandId: number, typeId: number, options: AxiosRequestConfig = {}): Promise<ColorTypeUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-types/{typeId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Retire a colour type by moving every colour of it to a replacement type, then deleting it.
 */
  async colorType_Replace(brandId: number, typeId: number, args: ReplaceColorTypeArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-types/{typeId}/replace";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Reorder the colour types. `typeIds` must list every type exactly once; the first becomes the type new colours start in.
 */
  async colorType_UpdateOrder(brandId: number, typeIds: number[], options: AxiosRequestConfig = {}): Promise<ColorTypeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/color-types/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = typeIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Store bytes in the brand's blob container and return the path they landed at. Nothing is recorded in the database, and nothing is inspected — width, height and type are whatever the caller later claims. Use the request_upload tool rather than calling this directly: a script cannot build a file, and request_upload puts the bytes in place for you.
 * @param file (optional) 
 */
  async company_UploadFile(file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<string> {
    let url_ = this.baseUrl + "/api/company/upload-file";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read back bytes stored through UploadFile, under a filename of the caller's
choosing. Only the two containers that endpoint writes to are reachable — both are already
served publicly over AzureStorage:PublicPath, so this is a nicer filename on an open URL and
not a way into the rest of blob storage.
 * @param filePath (optional) 
 * @param downloadFileName (optional) 
 */
  async company_DownloadFile(filePath: string | null | undefined, downloadFileName: string | null | undefined, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/company/download-file?";
    if (filePath !== undefined && filePath !== null)
        url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
    if (downloadFileName !== undefined && downloadFileName !== null)
        url_ += "downloadFileName=" + encodeURIComponent("" + downloadFileName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async compliance_ListCompliances(brandId: number, options: AxiosRequestConfig = {}): Promise<ComplianceDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/compliances";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async compliance_CreateCompliance(brandId: number, complianceDto: ComplianceDto, options: AxiosRequestConfig = {}): Promise<ComplianceDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/compliances";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = complianceDto;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async compliance_GetComplianceUsage(brandId: number, complianceId: number, options: AxiosRequestConfig = {}): Promise<ComplianceUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/compliances/{complianceId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (complianceId === undefined || complianceId === null)
        throw new Error("The parameter 'complianceId' must be defined.");
    url_ = url_.replace("{complianceId}", encodeURIComponent("" + complianceId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async compliance_DeleteCompliance(brandId: number, complianceId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/compliances/{complianceId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (complianceId === undefined || complianceId === null)
        throw new Error("The parameter 'complianceId' must be defined.");
    url_ = url_.replace("{complianceId}", encodeURIComponent("" + complianceId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async compliance_UpdateCompliance(brandId: number, complianceId: number, complianceDto: ComplianceDto, options: AxiosRequestConfig = {}): Promise<ComplianceDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/compliances/{complianceId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (complianceId === undefined || complianceId === null)
        throw new Error("The parameter 'complianceId' must be defined.");
    url_ = url_.replace("{complianceId}", encodeURIComponent("" + complianceId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = complianceDto;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentAttributeType_ListComponentAttributeTypes(brandId: number, options: AxiosRequestConfig = {}): Promise<ComponentAttributeTypeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-attribute-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentAttributeType_CreateComponentAttributeType(brandId: number, componentAttributeTypeDto: ComponentAttributeTypeDto, options: AxiosRequestConfig = {}): Promise<ComponentAttributeTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-attribute-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = componentAttributeTypeDto;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentAttributeType_UpdateComponentAttributeType(brandId: number, typeId: number, componentAttributeTypeDto: ComponentAttributeTypeDto, options: AxiosRequestConfig = {}): Promise<ComponentAttributeTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-attribute-types/{typeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = componentAttributeTypeDto;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentAttributeType_DeleteComponentAttributeType(brandId: number, typeId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-attribute-types/{typeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read one component in full.
 */
  async component_GetComponent(brandId: number, componentId: number, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The filtered, paged list of components. Start here — filter by type, status, supplier, season or tag to find a component before using it on a BOM.
 * @param filters_SearchTerm (optional) 
 * @param filters_ExtendedSearch (optional) 
 * @param filters_MaterialIds (optional) 
 * @param filters_SeasonIds (optional) 
 * @param filters_TagIds (optional) 
 * @param filters_SupplierIds (optional) 
 * @param filters_TypeIds (optional) 
 * @param filters_SubTypeIds (optional) 
 * @param filters_StatusIds (optional) 
 * @param filters_CreatedByUserIds (optional) 
 * @param filters_CustomFieldOptionIds (optional) 
 * @param filters_CertificateIds (optional) 
 * @param filters_AttributeFilters (optional) 
 * @param filters_TreatmentIds (optional) 
 * @param filters_ColorGroupIds (optional) 
 * @param filters_CountryOfOriginIds (optional) 
 * @param filters_ArticleIds (optional) 
 * @param limit (optional) 
 * @param offset (optional) 
 */
  async component_GetComponentsList(args: Component_GetComponentsListArgs, options: AxiosRequestConfig = {}): Promise<ComponentListResponse> {
    const { brandId, limit, offset, } = args;
    const filters_SearchTerm = args.filters?.searchTerm;
    const filters_ExtendedSearch = args.filters?.extendedSearch;
    const filters_MaterialIds = args.filters?.materialIds;
    const filters_SeasonIds = args.filters?.seasonIds;
    const filters_TagIds = args.filters?.tagIds;
    const filters_SupplierIds = args.filters?.supplierIds;
    const filters_TypeIds = args.filters?.typeIds;
    const filters_SubTypeIds = args.filters?.subTypeIds;
    const filters_StatusIds = args.filters?.statusIds;
    const filters_CreatedByUserIds = args.filters?.createdByUserIds;
    const filters_CustomFieldOptionIds = args.filters?.customFieldOptionIds;
    const filters_CertificateIds = args.filters?.certificateIds;
    const filters_AttributeFilters = args.filters?.attributeFilters;
    const filters_TreatmentIds = args.filters?.treatmentIds;
    const filters_ColorGroupIds = args.filters?.colorGroupIds;
    const filters_CountryOfOriginIds = args.filters?.countryOfOriginIds;
    const filters_ArticleIds = args.filters?.articleIds;
    let url_ = this.baseUrl + "/api/brand/{brandId}/components?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (filters_SearchTerm !== undefined && filters_SearchTerm !== null)
        url_ += "Filters.SearchTerm=" + encodeURIComponent("" + filters_SearchTerm) + "&";
    if (filters_ExtendedSearch === null)
        throw new Error("The parameter 'filters_ExtendedSearch' cannot be null.");
    else if (filters_ExtendedSearch !== undefined)
        url_ += "Filters.ExtendedSearch=" + encodeURIComponent("" + filters_ExtendedSearch) + "&";
    if (filters_MaterialIds !== undefined && filters_MaterialIds !== null)
        filters_MaterialIds && filters_MaterialIds.forEach(item => { url_ += "Filters.MaterialIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SeasonIds !== undefined && filters_SeasonIds !== null)
        filters_SeasonIds && filters_SeasonIds.forEach(item => { url_ += "Filters.SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TagIds !== undefined && filters_TagIds !== null)
        filters_TagIds && filters_TagIds.forEach(item => { url_ += "Filters.TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SupplierIds !== undefined && filters_SupplierIds !== null)
        filters_SupplierIds && filters_SupplierIds.forEach(item => { url_ += "Filters.SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TypeIds !== undefined && filters_TypeIds !== null)
        filters_TypeIds && filters_TypeIds.forEach(item => { url_ += "Filters.TypeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SubTypeIds !== undefined && filters_SubTypeIds !== null)
        filters_SubTypeIds && filters_SubTypeIds.forEach(item => { url_ += "Filters.SubTypeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_StatusIds !== undefined && filters_StatusIds !== null)
        filters_StatusIds && filters_StatusIds.forEach(item => { url_ += "Filters.StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_CreatedByUserIds !== undefined && filters_CreatedByUserIds !== null)
        filters_CreatedByUserIds && filters_CreatedByUserIds.forEach(item => { url_ += "Filters.CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_CustomFieldOptionIds !== undefined && filters_CustomFieldOptionIds !== null)
        url_ += appendDictionaryQuery("Filters.CustomFieldOptionIds", filters_CustomFieldOptionIds);
    if (filters_CertificateIds !== undefined && filters_CertificateIds !== null)
        filters_CertificateIds && filters_CertificateIds.forEach(item => { url_ += "Filters.CertificateIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_AttributeFilters !== undefined && filters_AttributeFilters !== null)
        filters_AttributeFilters && filters_AttributeFilters.forEach((item, index) => {
            for (const attr in item)
    			if (item.hasOwnProperty(attr)) {
    				url_ += "Filters.AttributeFilters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
    			}
        });
    if (filters_TreatmentIds !== undefined && filters_TreatmentIds !== null)
        filters_TreatmentIds && filters_TreatmentIds.forEach(item => { url_ += "Filters.TreatmentIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ColorGroupIds !== undefined && filters_ColorGroupIds !== null)
        filters_ColorGroupIds && filters_ColorGroupIds.forEach(item => { url_ += "Filters.ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_CountryOfOriginIds !== undefined && filters_CountryOfOriginIds !== null)
        filters_CountryOfOriginIds && filters_CountryOfOriginIds.forEach(item => { url_ += "Filters.CountryOfOriginIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ArticleIds !== undefined && filters_ArticleIds !== null)
        filters_ArticleIds && filters_ArticleIds.forEach(item => { url_ += "Filters.ArticleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete components. Refused while a component is used on a BOM — check with component_GetComponentsList or component_Replace first.
 */
  async component_DeleteComponents(brandId: number, args: DeleteComponentsArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a blank component and return it. Everything else is set afterwards with the component_Update and component_Set operations — there is no create-with-fields call.
 */
  async component_CreateEmptyComponent(brandId: number, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/empty";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Copy components, with their attributes, composition and suppliers.
 */
  async component_CloneComponents(brandId: number, args: CloneComponentArgs, options: AxiosRequestConfig = {}): Promise<ClonedComponent[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/clone";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's name and reference number.
 */
  async component_UpdateNameAndRefNumber(brandId: number, componentId: number, args: UpdateNameAndRefNumberArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/name-and-ref-number";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's sub-type, which determines which attributes apply to it.
 */
  async component_UpdateSubType(brandId: number, componentId: number, args: AssignSubTypeArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/subtype";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's typed attributes. Which attributes exist is decided by its sub-type.
 */
  async component_UpdateAttributes(brandId: number, componentId: number, args: UpdateAttributesArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/attributes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's material composition (the percentage breakdown).
 */
  async component_UpdateComposition(brandId: number, componentId: number, args: UpdateCompositionArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/composition";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set which suppliers offer this component, and their prices.
 */
  async component_UpdateSuppliers(brandId: number, componentId: number, args: UpdateSuppliersArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/suppliers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's own price, used when it has no supplier price.
 */
  async component_UpdatePrice(brandId: number, componentId: number, args: UpdatePriceArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/price";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's country of origin. Resolve countryId with country_List.
 */
  async component_UpdateOrigin(brandId: number, componentId: number, args: UpdateOriginArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/origin";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the colourways a component is available in, replacing the whole list — any existing colour left out is removed. BOM cells reference these by componentColorId. A new colour is one with `id` omitted or `id: 0`; several new colours may be added in one call.
 */
  async component_SetComponentColors(brandId: number, componentId: number, args: SetComponentColorsArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/colors";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's free-text categories.
 */
  async component_SetComponentCategories(brandId: number, componentId: number, args: SetComponentCategoriesArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/categories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's comment.
 */
  async component_SetComponentComment(brandId: number, componentId: number, comment: CommentArg, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/comment";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = comment;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set which seasons a component belongs to.
 */
  async component_SetComponentSeasons(brandId: number, componentId: number, args: SetComponentSeasonsArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/seasons";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the free-text categories components are grouped under on this brand.
 */
  async component_GetComponentCategories(brandId: number, options: AxiosRequestConfig = {}): Promise<string[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/categories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's status.
 */
  async component_SetComponentStatus(brandId: number, componentId: number, args: SetComponentStatusArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/status";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the treatments applied to a component.
 */
  async component_UpdateComponentTreatments(brandId: number, componentId: number, args: UpdateComponentTreatmentsArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/treatments";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's tariff codes.
 */
  async component_UpdateComponentTariffCodes(brandId: number, componentId: number, newTariffCodeIds: number[], options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/tariffcodes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = newTariffCodeIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's minimum order quantity.
 */
  async component_UpdateComponentMoq(brandId: number, componentId: number, args: UpdateComponentMoqArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/moq";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's lead times, in days.
 */
  async component_UpdateComponentLeadTimes(brandId: number, componentId: number, newLeadTimesInDays: UpdateComponentLeadTimeArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/lead-time";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = newLeadTimesInDays;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Replace one component with another everywhere it is used, then delete the original. The way to retire a component that is still on BOMs.
 */
  async component_Replace(brandId: number, args: ReplaceComponentsArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/replace";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Swap a component for another on a chosen set of BOMs only, leaving it in place elsewhere.
 */
  async component_ReplaceOnBoms(brandId: number, componentId: number, args: ReplaceOnBomsArg, options: AxiosRequestConfig = {}): Promise<ReplaceOnBomsResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/replace-on-boms";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the certificates held for a component.
 */
  async component_UpdateComponentCertifications(brandId: number, componentId: number, argsComponentCertifications: ComponentCertificationDto[], options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/certifications";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = argsComponentCertifications;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the compliance requirements tracked against a component.
 */
  async component_UpdateComponentCompliances(brandId: number, componentId: number, argsComponentCompliances: ComponentComplianceDto[], options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/compliances";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = argsComponentCompliances;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set which tags are on a component. Replaces the set.
 */
  async component_UpdateComponentTags(brandId: number, componentId: number, args: UpdateComponentTagsArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's images. Replaces the set — pass every image you want to keep.
 */
  async component_UpdateComponentImages(brandId: number, componentId: number, args: UpdateImagesArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/images";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the files attached to a component. Replaces the set.
 */
  async component_UpdateComponentFiles(brandId: number, componentId: number, args: UpdateFilesArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/files";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read how a component's number is generated and whether it is manually set.
 */
  async component_GetComponentNumberInfo(brandId: number, componentId: number, options: AxiosRequestConfig = {}): Promise<ComponentNumberInfoResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/component-number-info";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's number manually, overriding generation.
 * @param componentNumber (optional) 
 */
  async component_SetComponentNumber(brandId: number, componentId: number, componentNumber: string | undefined, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/component-number";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = componentNumber;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async component_GetExcelFileForFilteredComponents(args: Component_GetExcelFileForFilteredComponentsArgs, options: AxiosRequestConfig = {}): Promise<void> {
    const { brandId, imageSize, } = args;
    const filters_SearchTerm = args.filters?.searchTerm;
    const filters_ExtendedSearch = args.filters?.extendedSearch;
    const filters_MaterialIds = args.filters?.materialIds;
    const filters_SeasonIds = args.filters?.seasonIds;
    const filters_TagIds = args.filters?.tagIds;
    const filters_SupplierIds = args.filters?.supplierIds;
    const filters_TypeIds = args.filters?.typeIds;
    const filters_SubTypeIds = args.filters?.subTypeIds;
    const filters_StatusIds = args.filters?.statusIds;
    const filters_CreatedByUserIds = args.filters?.createdByUserIds;
    const filters_CustomFieldOptionIds = args.filters?.customFieldOptionIds;
    const filters_CertificateIds = args.filters?.certificateIds;
    const filters_AttributeFilters = args.filters?.attributeFilters;
    const filters_TreatmentIds = args.filters?.treatmentIds;
    const filters_ColorGroupIds = args.filters?.colorGroupIds;
    const filters_CountryOfOriginIds = args.filters?.countryOfOriginIds;
    const filters_ArticleIds = args.filters?.articleIds;
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/excelfile?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (filters_SearchTerm !== undefined && filters_SearchTerm !== null)
        url_ += "Filters.SearchTerm=" + encodeURIComponent("" + filters_SearchTerm) + "&";
    if (filters_ExtendedSearch === null)
        throw new Error("The parameter 'filters_ExtendedSearch' cannot be null.");
    else if (filters_ExtendedSearch !== undefined)
        url_ += "Filters.ExtendedSearch=" + encodeURIComponent("" + filters_ExtendedSearch) + "&";
    if (filters_MaterialIds !== undefined && filters_MaterialIds !== null)
        filters_MaterialIds && filters_MaterialIds.forEach(item => { url_ += "Filters.MaterialIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SeasonIds !== undefined && filters_SeasonIds !== null)
        filters_SeasonIds && filters_SeasonIds.forEach(item => { url_ += "Filters.SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TagIds !== undefined && filters_TagIds !== null)
        filters_TagIds && filters_TagIds.forEach(item => { url_ += "Filters.TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SupplierIds !== undefined && filters_SupplierIds !== null)
        filters_SupplierIds && filters_SupplierIds.forEach(item => { url_ += "Filters.SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TypeIds !== undefined && filters_TypeIds !== null)
        filters_TypeIds && filters_TypeIds.forEach(item => { url_ += "Filters.TypeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SubTypeIds !== undefined && filters_SubTypeIds !== null)
        filters_SubTypeIds && filters_SubTypeIds.forEach(item => { url_ += "Filters.SubTypeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_StatusIds !== undefined && filters_StatusIds !== null)
        filters_StatusIds && filters_StatusIds.forEach(item => { url_ += "Filters.StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_CreatedByUserIds !== undefined && filters_CreatedByUserIds !== null)
        filters_CreatedByUserIds && filters_CreatedByUserIds.forEach(item => { url_ += "Filters.CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_CustomFieldOptionIds !== undefined && filters_CustomFieldOptionIds !== null)
        url_ += appendDictionaryQuery("Filters.CustomFieldOptionIds", filters_CustomFieldOptionIds);
    if (filters_CertificateIds !== undefined && filters_CertificateIds !== null)
        filters_CertificateIds && filters_CertificateIds.forEach(item => { url_ += "Filters.CertificateIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_AttributeFilters !== undefined && filters_AttributeFilters !== null)
        filters_AttributeFilters && filters_AttributeFilters.forEach((item, index) => {
            for (const attr in item)
    			if (item.hasOwnProperty(attr)) {
    				url_ += "Filters.AttributeFilters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
    			}
        });
    if (filters_TreatmentIds !== undefined && filters_TreatmentIds !== null)
        filters_TreatmentIds && filters_TreatmentIds.forEach(item => { url_ += "Filters.TreatmentIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ColorGroupIds !== undefined && filters_ColorGroupIds !== null)
        filters_ColorGroupIds && filters_ColorGroupIds.forEach(item => { url_ += "Filters.ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_CountryOfOriginIds !== undefined && filters_CountryOfOriginIds !== null)
        filters_CountryOfOriginIds && filters_CountryOfOriginIds.forEach(item => { url_ += "Filters.CountryOfOriginIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ArticleIds !== undefined && filters_ArticleIds !== null)
        filters_ArticleIds && filters_ArticleIds.forEach(item => { url_ += "Filters.ArticleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (imageSize === null)
        throw new Error("The parameter 'imageSize' cannot be null.");
    else if (imageSize !== undefined)
        url_ += "ImageSize=" + encodeURIComponent("" + imageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a text custom field value on components.
 */
  async component_UpdateTextCustomField(brandId: number, customFieldId: number, args: UpdateComponentTextCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/custom-field-text/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a money custom field value on components.
 */
  async component_UpdateMoneyCustomField(brandId: number, customFieldId: number, args: UpdateComponentMoneyCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/custom-field-money/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a number-with-unit custom field value on components.
 */
  async component_UpdateNumberWithUnitCustomField(brandId: number, customFieldId: number, args: UpdateComponentNumberWithUnitCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/custom-field-number-with-unit/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a single-select custom field value on components. Pass optionId, never the label.
 */
  async component_UpdateSingleSelectCustomField(brandId: number, customFieldId: number, args: UpdateComponentSingleSelectCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/custom-field-single-select/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a multi-select custom field value on components. Pass optionIds, never labels.
 */
  async component_UpdateMultiSelectCustomField(brandId: number, customFieldId: number, args: UpdateComponentMultiSelectCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/custom-field-multi-select/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a files custom field value on components.
 */
  async component_UpdateFilesCustomField(brandId: number, customFieldId: number, args: UpdateComponentFilesCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/custom-field-files/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Point a component's custom field values at a different field definition.
 */
  async component_RelinkCustomField(brandId: number, customFieldId: number, args: RelinkComponentCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/custom-field-relink/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async component_ImportComponentsFromExcel(brandId: number, uploadFile: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/import-excel-file";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (uploadFile !== null && uploadFile !== undefined)
        content_.append("UploadFile", uploadFile, uploadFile.name ? uploadFile.name : "UploadFile");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a component's supply chain steps.
 */
  async component_UpdateSupplyChain(brandId: number, componentId: number, args: UpdateSupplyChainArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/supply-chain";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Count the BOM slots a component's supplier is used on.
 */
  async component_GetSupplierBomUsageCount(brandId: number, componentId: number, supplierId: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/{componentId}/suppliers/{supplierId}/bom-usage-count";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentId === undefined || componentId === null)
        throw new Error("The parameter 'componentId' must be defined.");
    url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
    if (supplierId === undefined || supplierId === null)
        throw new Error("The parameter 'supplierId' must be defined.");
    url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set supply chain steps on many components at once. Prefer this over component_UpdateSupplyChain for more than one.
 */
  async component_BatchUpdateSupplyChain(brandId: number, args: BatchUpdateSupplyChainArgs, options: AxiosRequestConfig = {}): Promise<ComponentDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/batch/supply-chain";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async component_DownloadComponentImportTemplate(brandId: string, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/components/import-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the component statuses this brand has defined, in the brand's own order.
 */
  async componentStatus_ListComponentStatuses(brandId: number, options: AxiosRequestConfig = {}): Promise<ComponentStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentStatus_CreateComponentStatus(brandId: number, args: CreateComponentStatusArgs, options: AxiosRequestConfig = {}): Promise<ComponentStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentStatus_UpdateComponentStatus(brandId: number, id: number, args: UpdateComponentStatusArgs, options: AxiosRequestConfig = {}): Promise<ComponentStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-statuses/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentStatus_DeleteComponentStatus(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-statuses/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentStatus_UpdateOrder(brandId: number, componentStatusIds: number[], options: AxiosRequestConfig = {}): Promise<ComponentStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-statuses/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = componentStatusIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentStatus_GetUsage(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<ComponentStatusUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-statuses/{id}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Retire a component status by moving every component on it to a replacement, then deleting it. Prefer this over componentStatus_DeleteComponentStatus when the status is still in use.
 */
  async componentStatus_Replace(brandId: number, id: number, args: ReplaceComponentStatusArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-statuses/{id}/replace";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List component tag categories with their tags.
 */
  async componentTag_GetCategories(brandId: number, options: AxiosRequestConfig = {}): Promise<ComponentTagCategoryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a tag in a component tag category. Custom fields synced from the category get an option for it.
 */
  async componentTag_AddTag(brandId: number, args: AddTagArgs, options: AxiosRequestConfig = {}): Promise<ComponentTagDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a component tag category. `key` is how calculated field templates read its tags (`bom.tags.<key>`): lowercase letters, digits and hyphens, unique within the brand. Returns every category of the brand.
 */
  async componentTag_AddCategory(brandId: number, args: AddCategoryArgs, options: AxiosRequestConfig = {}): Promise<ComponentTagCategoryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-tags/categories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Rename a component tag category, or change its key (how templates name it: bom.tags.<key>). A null
leaves that part unchanged. Renaming keeps the key; changing the key is refused while a template reads it.
 */
  async componentTag_UpdateCategory(brandId: number, tagCategoryId: number, args: UpdateCategoryArgs, options: AxiosRequestConfig = {}): Promise<ComponentTagCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-tags/categories/{tagCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a component tag category and its tags, taking them off the components carrying them. Custom fields synced from it keep their options, and the values holding them, as ordinary options. Refused while a calculated field's template reads the category; call componentTag_GetCategoryUsage first.
 */
  async componentTag_DeleteCategory(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-tags/categories/{tagCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * What deleting a component tag category touches: the components carrying its tags, the custom fields synced from it, and the calculated fields whose template reads it (these refuse the delete). Call before deleting it.
 */
  async componentTag_GetCategoryUsage(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<ComponentTagUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-tags/categories/{tagCategoryId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Rename, recolour or recode a component tag. Replaces all three, and updates the options mirroring it in synced custom fields.
 */
  async componentTag_UpdateTag(brandId: number, componentTagId: number, args: UpdateTagArgs, options: AxiosRequestConfig = {}): Promise<ComponentTagDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-tags/{componentTagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentTagId === undefined || componentTagId === null)
        throw new Error("The parameter 'componentTagId' must be defined.");
    url_ = url_.replace("{componentTagId}", encodeURIComponent("" + componentTagId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a component tag and the options mirroring it, taking it off the components carrying it. Lookup table rows keyed by those options are removed with it. Refused while a custom value still holds one of the options; values filled from the BOM are recalculated without the tag first, so only hand-picked and overridden ones count. Call componentTag_GetTagUsage first.
 */
  async componentTag_DeleteTag(brandId: number, componentTagId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-tags/{componentTagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentTagId === undefined || componentTagId === null)
        throw new Error("The parameter 'componentTagId' must be defined.");
    url_ = url_.replace("{componentTagId}", encodeURIComponent("" + componentTagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * What deleting a component tag touches: the components carrying it, and the custom fields where values hold its option (these refuse the delete), and the lookup tables whose rows keyed by it are removed. Call before deleting it.
 */
  async componentTag_GetTagUsage(brandId: number, componentTagId: number, options: AxiosRequestConfig = {}): Promise<ComponentTagUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-tags/{componentTagId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentTagId === undefined || componentTagId === null)
        throw new Error("The parameter 'componentTagId' must be defined.");
    url_ = url_.replace("{componentTagId}", encodeURIComponent("" + componentTagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentType_GetComponentTypes(brandId: number, options: AxiosRequestConfig = {}): Promise<ComponentTypeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Deletes whole types and single sub-types in one request and one transaction. Refused as a
whole if any of them is in use, naming which.
 */
  async componentType_DeleteMany(brandId: number, args: DeleteComponentTypesArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentType_AddType(brandId: number, args: AddTypeArgs, options: AxiosRequestConfig = {}): Promise<ComponentTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * What uses the given sub-types — a count and a few linked components each — so the deletion
dialog can say what stands in the way before anything is tried.
 * @param subTypeIds (optional) 
 */
  async componentType_GetUsages(brandId: number, subTypeIds: number[] | undefined, options: AxiosRequestConfig = {}): Promise<ComponentSubTypeUsageDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-types/usages?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (subTypeIds === null)
        throw new Error("The parameter 'subTypeIds' cannot be null.");
    else if (subTypeIds !== undefined)
        subTypeIds && subTypeIds.forEach(item => { url_ += "subTypeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Writes many cells in one request, each with its own value — what an edit or a clipboard
paste over the table produces. Cells are grouped by entity so each is updated once however
many of its fields the block touched, and the name checks see the block's final state.
            
Returns the same list the GET does, so the caller can show the saved values without waiting
for the SignalR round trip — and without a reload that started before this write landing
after it and putting the old values back for a moment.
 */
  async componentType_SetFieldsBulk(brandId: number, args: SetComponentTypeFieldsBulkArgs, options: AxiosRequestConfig = {}): Promise<ComponentTypeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-types/bulk/fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Copies whole types as types and single sub-types within their own type, in one request.
Answers with every type touched, so the copies can be shown and picked out.
 */
  async componentType_Copy(brandId: number, args: CopyComponentTypesArgs, options: AxiosRequestConfig = {}): Promise<ComponentTypeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-types/copy";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentType_UpdateType(brandId: number, typeId: number, args: UpdateTypeArgs, options: AxiosRequestConfig = {}): Promise<ComponentTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-types/{typeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentType_DeleteType(brandId: number, typeId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-types/{typeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentType_AddSubType(brandId: number, typeId: number, args: AddSubTypeArgs, options: AxiosRequestConfig = {}): Promise<ComponentTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-types/{typeId}/subtypes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentType_UpdateSubType(brandId: number, subTypeId: number, args: UpdateSubTypeArgs, options: AxiosRequestConfig = {}): Promise<ComponentTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-types/subtypes/{subTypeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (subTypeId === undefined || subTypeId === null)
        throw new Error("The parameter 'subTypeId' must be defined.");
    url_ = url_.replace("{subTypeId}", encodeURIComponent("" + subTypeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async componentType_DeleteSubType(brandId: number, subTypeId: number, options: AxiosRequestConfig = {}): Promise<ComponentTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/component-types/subtypes/{subTypeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (subTypeId === undefined || subTypeId === null)
        throw new Error("The parameter 'subTypeId' must be defined.");
    url_ = url_.replace("{subTypeId}", encodeURIComponent("" + subTypeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's composition materials — the fibres and materials a component's composition is built from.
 */
  async compositionMaterial_GetCompositionMaterials(brandId: number, options: AxiosRequestConfig = {}): Promise<CompositionMaterialDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/composition-materials";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async compositionMaterial_AddCompositionMaterial(brandId: number, args: AddCompositionMaterialArgs, options: AxiosRequestConfig = {}): Promise<CompositionMaterialDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/composition-materials";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async compositionMaterial_DeleteCompositionMaterial(brandId: number, compositionMaterialId: number | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/composition-materials?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (compositionMaterialId === null)
        throw new Error("The parameter 'compositionMaterialId' cannot be null.");
    else if (compositionMaterialId !== undefined)
        url_ += "compositionMaterialId=" + encodeURIComponent("" + compositionMaterialId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read one composition material in full, with its detail values.
 */
  async compositionMaterial_GetCompositionMaterial(brandId: number, compositionMaterialId: number, options: AxiosRequestConfig = {}): Promise<CompositionMaterialDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/composition-materials/{compositionMaterialId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (compositionMaterialId === undefined || compositionMaterialId === null)
        throw new Error("The parameter 'compositionMaterialId' must be defined.");
    url_ = url_.replace("{compositionMaterialId}", encodeURIComponent("" + compositionMaterialId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async compositionMaterial_UpdateCompositionMaterial(brandId: number, compositionMaterialId: number, args: AddCompositionMaterialArgs, options: AxiosRequestConfig = {}): Promise<CompositionMaterialDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/composition-materials/{compositionMaterialId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (compositionMaterialId === undefined || compositionMaterialId === null)
        throw new Error("The parameter 'compositionMaterialId' must be defined.");
    url_ = url_.replace("{compositionMaterialId}", encodeURIComponent("" + compositionMaterialId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async compositionMaterial_GetCompositionMaterialDetailTypes(brandId: number, options: AxiosRequestConfig = {}): Promise<CompositionMaterialDetailTypeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/composition-materials/detail-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async compositionMaterial_AddCompositionMaterialDetailType(brandId: number, args: AddDetailTypeArgs, options: AxiosRequestConfig = {}): Promise<CompositionMaterialDetailTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/composition-materials/detail-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async compositionMaterial_UpdateCompositionMaterialDetailType(brandId: number, detailTypeId: number, args: AddDetailTypeArgs, options: AxiosRequestConfig = {}): Promise<CompositionMaterialDetailTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/composition-materials/detail-types/{detailTypeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (detailTypeId === undefined || detailTypeId === null)
        throw new Error("The parameter 'detailTypeId' must be defined.");
    url_ = url_.replace("{detailTypeId}", encodeURIComponent("" + detailTypeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async compositionMaterial_DeleteCompositionMaterialDetailType(brandId: number, detailTypeId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/composition-materials/detail-types/{detailTypeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (detailTypeId === undefined || detailTypeId === null)
        throw new Error("The parameter 'detailTypeId' must be defined.");
    url_ = url_.replace("{detailTypeId}", encodeURIComponent("" + detailTypeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List every country with its id, name and alpha-3 code. Any countryId in the API resolves here — countries of origin, destinations, supplier locations, duty rows.
 */
  async country_List(options: AxiosRequestConfig = {}): Promise<CountryDto[]> {
    let url_ = this.baseUrl + "/api/country";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List currencies enabled for the brand.
 */
  async currency_GetAllCurrencies(brandId: number, options: AxiosRequestConfig = {}): Promise<CurrencyDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/currencies";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async currency_AddBrandMainCurrency(brandId: number, args: AddBrandMainCurrencyArgs, options: AxiosRequestConfig = {}): Promise<CurrencyDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/currencies/maincurrencies";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async currency_RemoveBrandMainCurrency(brandId: number, currencyId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/currencies/maincurrencies/{currencyId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (currencyId === undefined || currencyId === null)
        throw new Error("The parameter 'currencyId' must be defined.");
    url_ = url_.replace("{currencyId}", encodeURIComponent("" + currencyId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async currency_GetMostUsedCurrencies(brandId: number, options: AxiosRequestConfig = {}): Promise<IdAndCount[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/currencies/most-used";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async currency_GetAllCurrencyExchangeRatesForBrand(brandId: number, options: AxiosRequestConfig = {}): Promise<CurrencyExchangeRateDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/currencies/exchange-rates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async currency_AddCurrencyExchangeRate(brandId: number, args: CreateCurrencyExchangeRateArgs, options: AxiosRequestConfig = {}): Promise<CurrencyExchangeRateDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/currencies/exchange-rates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set many exchange rates into one target currency at once. `toId` is that currency; each cell names the currency converted from, optionally a season, and the rate. Prefer this over repeated single writes.
A null rate clears the cell. Returns the same list the GET does, including the
recalculated derived rates.
 */
  async currency_SetExchangeRatesBulk(brandId: number, args: SetExchangeRatesBulkArgs, options: AxiosRequestConfig = {}): Promise<CurrencyExchangeRateDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/currencies/exchange-rates/bulk";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async currency_UpdateCurrencyExchangeRate(brandId: number, currencyExchangeRateId: number, args: UpdateCurrencyExchangeRateArgs, options: AxiosRequestConfig = {}): Promise<CurrencyExchangeRateDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/currencies/exchange-rates/{currencyExchangeRateId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (currencyExchangeRateId === undefined || currencyExchangeRateId === null)
        throw new Error("The parameter 'currencyExchangeRateId' must be defined.");
    url_ = url_.replace("{currencyExchangeRateId}", encodeURIComponent("" + currencyExchangeRateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async currency_RemoveCurrencyExchangeRate(brandId: number, currencyExchangeRateId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/currencies/exchange-rates/{currencyExchangeRateId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (currencyExchangeRateId === undefined || currencyExchangeRateId === null)
        throw new Error("The parameter 'currencyExchangeRateId' must be defined.");
    url_ = url_.replace("{currencyExchangeRateId}", encodeURIComponent("" + currencyExchangeRateId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async currency_ExportCurrencyExchangeRates(brandId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/currencies/export";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List custom field definitions, their types, and which entity each applies to.
 */
  async customField_GetCustomFields(brandId: number, options: AxiosRequestConfig = {}): Promise<CustomFieldDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a custom field. A calculated field then has its values calculated in the background. `key` is the field's slug in templates and integrations (`customfields.price-per-sqm`), and must be unique for the brand among fields on the same kind of entity, using only letters, digits, `-` and `_`. Send it empty to have it derived from the title (lowercased, spaces to `-`, other characters dropped) — the same key the admin page suggests. Uniqueness is checked by the API, so a dry run cannot tell you a key is taken; read customField_GetCustomFields first.
 */
  async customField_AddCustomField(brandId: number, dto: CustomFieldDto, options: AxiosRequestConfig = {}): Promise<CustomFieldDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = dto;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async customField_AddCustomFieldSelectOption(brandId: number, fieldId: number, args: AddCustomFieldSelectOptionArgs, options: AxiosRequestConfig = {}): Promise<CustomFieldDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-fields/{fieldId}/select-options";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (fieldId === undefined || fieldId === null)
        throw new Error("The parameter 'fieldId' must be defined.");
    url_ = url_.replace("{fieldId}", encodeURIComponent("" + fieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Update a custom field from its full definition. It replaces, never merges: the options (select fields), units or currencies sent become the whole list, and hierarchyNodeIds replaces the field's node restrictions (empty = follows its group). An option, unit or currency left out that is still in use (an option keying a lookup-table row counts) is kept, and then the whole update is refused and returns UpdateCustomFieldFailure with the usage count: nothing else in the edit is saved either. Check customField_GetCustomFieldOptionUsage before dropping an option. An option's icon is its iconPath: send the path a plain request_upload of the picture gives you to set or replace it (a replaced picture is kept as an older version), and null to remove it. Making a field calculated is refused while a lookup table keys on it.
 */
  async customField_UpdateCustomField(brandId: number, customFieldId: number, updatedCustomFieldDto: CustomFieldDto, options: AxiosRequestConfig = {}): Promise<UpdateCustomFieldResult> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-fields/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = updatedCustomFieldDto;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a custom field and every value it holds. Refused while a lookup table keys on it; remove that key column first. Check customField_GetCustomFieldUsage beforehand: it counts the values this deletes, names the lookup tables in the way, and lists the Shopify connections it would turn off.
 */
  async customField_DeleteCustomField(brandId: number, customFieldId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-fields/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set whether a custom field starts out shown or hidden on new entities. Omitting startingState clears it.
 * @param startingState (optional) 
 */
  async customField_SetFieldStartingState(brandId: number, fieldId: number, startingState: StartingState | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-fields/{fieldId}/starting-state?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (fieldId === undefined || fieldId === null)
        throw new Error("The parameter 'fieldId' must be defined.");
    url_ = url_.replace("{fieldId}", encodeURIComponent("" + fieldId));
    if (startingState === null)
        throw new Error("The parameter 'startingState' cannot be null.");
    else if (startingState !== undefined)
        url_ += "startingState=" + encodeURIComponent("" + startingState) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * How many of each entity type hold a value of this field, the first few of each by name, the Shopify connections using it (to store product ids, or as their sync flag), and the lookup tables keyed on it — which keep it from being deleted.
 */
  async customField_GetCustomFieldUsage(brandId: number, customFieldId: number, options: AxiosRequestConfig = {}): Promise<GetCustomFieldUsageResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-fields/{customFieldId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * What still uses one option of a single- or multi-select field: how many products, articles, SKUs and so on hold it, and which lookup tables have rows keyed on it (with the row count). Read-only. An option with any usage survives removal from the field's option list, and the field update that tried to remove it is refused as a whole.
 */
  async customField_GetCustomFieldOptionUsage(brandId: number, customFieldId: number, optionId: number, options: AxiosRequestConfig = {}): Promise<GetCustomFieldOptionUsageResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-fields/{customFieldId}/options/{optionId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    if (optionId === undefined || optionId === null)
        throw new Error("The parameter 'optionId' must be defined.");
    url_ = url_.replace("{optionId}", encodeURIComponent("" + optionId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async customField_GetCustomFieldEntityUsage(brandId: number, customFieldId: number, entityType: CustomFieldEntityType, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-fields/{customFieldId}/entities/{entityType}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    if (entityType === undefined || entityType === null)
        throw new Error("The parameter 'entityType' must be defined.");
    url_ = url_.replace("{entityType}", encodeURIComponent("" + entityType));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Make an existing custom field apply to one more entity type of its own family, such as a product-family field defined for articles also appearing on SKUs. A type from another family is refused. Also refused when the wider set puts a lookup table out of reach: of this field's own template, or, for a table keyed on this field (which then needs the new deepest level), of a reader that cannot reach it.
 */
  async customField_AddEntityToField(brandId: number, customFieldId: number, entityType: CustomFieldEntityType, options: AxiosRequestConfig = {}): Promise<CustomFieldDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-fields/{customFieldId}/entities/{entityType}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    if (entityType === undefined || entityType === null)
        throw new Error("The parameter 'entityType' must be defined.");
    url_ = url_.replace("{entityType}", encodeURIComponent("" + entityType));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Stop a custom field applying to one entity type, deleting every value it holds on that type. customField_GetCustomFieldEntityUsage for the same type counts exactly the values this deletes. Refused, with nothing saved, when the change puts a lookup table keyed on this field out of reach of a reader, or when a Shopify connection uses the field (as its id store, or as its sync flag when the article type is removed) — point the connection at another field first.
 */
  async customField_RemoveEntityFromField(brandId: number, customFieldId: number, entityType: CustomFieldEntityType, options: AxiosRequestConfig = {}): Promise<CustomFieldDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-fields/{customFieldId}/entities/{entityType}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    if (entityType === undefined || entityType === null)
        throw new Error("The parameter 'entityType' must be defined.");
    url_ = url_.replace("{entityType}", encodeURIComponent("" + entityType));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview a template using the selected subject and its ancestors. ArticleId identifies the product/article
chain. Subject chooses Product, Article, Sku or their seasonal variant; SKU subjects require SkuId from
that article. Seasonal subjects require the exact SeasonId (null means the base row). Ordinary subjects
never read seasonal values. Returns raw rendered text without saving or recalculating stored values.
 */
  async customField_PreviewTemplate(brandId: number, args: PreviewTemplateArgs, options: AxiosRequestConfig = {}): Promise<PreviewTemplateResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-fields/preview-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Recompute the values of a calculated custom field across the brand. Overwrites current stored values with freshly computed ones. Out-prices and lookup tables reading a recomputed value are not recomputed with it.
 */
  async customField_RunCalculatedValues(brandId: number, args: CalculatedValuesArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-fields/calculated-values";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async customFieldGroup_ListGroups(brandId: number, options: AxiosRequestConfig = {}): Promise<CustomFieldGroupDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-field-groups";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async customFieldGroup_CreateGroup(brandId: number, args: CreateGroupArgs, options: AxiosRequestConfig = {}): Promise<CustomFieldGroupDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-field-groups";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Update a custom field group: icon, title, default entities, the seasonality and non-user flags, and, when hierarchyNodeIds is sent, which hierarchy nodes see it (null leaves that as is; an empty list makes it visible everywhere). seasonalityEnabled and nonUser cannot both be true. Changing seasonalityEnabled moves every field's values, not just a setting: turning it on copies each entity's base value into every season it has and clears the base; turning it off makes the latest season's value the base and deletes every other season's value. Refused, with nothing saved, when that would put a lookup table out of reach of a calculated field reading it.
 */
  async customFieldGroup_UpdateGroup(brandId: number, groupId: number, args: UpdateGroupArgs, options: AxiosRequestConfig = {}): Promise<CustomFieldGroupDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-field-groups/{groupId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (groupId === undefined || groupId === null)
        throw new Error("The parameter 'groupId' must be defined.");
    url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async customFieldGroup_DeleteGroup(brandId: number, groupId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-field-groups/{groupId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (groupId === undefined || groupId === null)
        throw new Error("The parameter 'groupId' must be defined.");
    url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Move a custom field into another group, or reorder it within its current group, at the given order and sub-group. order is a zero-based insertion index among the target group's fields, excluding the moved field: 0 inserts first, the remaining field count appends, and an empty group requires 0. Values outside that inclusive range return HTTP 400 with the allowed range, before any changes are made. Fields remain ordered by sub-group first. Layout only while both groups have the same seasonality; when they differ, the field's values move too: into a seasonal group, each entity's base value is copied into every season it has and the base cleared; into a non-seasonal group, the latest season's value becomes the base and every other season's value is deleted. Refused, with nothing saved, when that would put a lookup table out of reach of a calculated field reading it (a key field turning seasonal while a non-seasonal reader depends on its table, or a reader losing the seasonality its table needs). A group left empty by the move is deleted.
 */
  async customFieldGroup_MoveField(brandId: number, groupId: number, args: MoveFieldArgs, options: AxiosRequestConfig = {}): Promise<CustomFieldGroupDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-field-groups/{groupId}/fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (groupId === undefined || groupId === null)
        throw new Error("The parameter 'groupId' must be defined.");
    url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a custom field group around an existing field, placing that field in it at the given order. Use customFieldGroup_CreateGroup to make an empty group.
 */
  async customFieldGroup_CreateGroupForField(brandId: number, args: CreateGroupForFieldArgs, options: AxiosRequestConfig = {}): Promise<CustomFieldGroupDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-field-groups/for-field";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async customFieldGroup_ReorderGroups(brandId: number, family: CustomFieldEntityFamily, args: ReorderGroupsArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/custom-field-groups/family/{family}/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (family === undefined || family === null)
        throw new Error("The parameter 'family' must be defined.");
    url_ = url_.replace("{family}", encodeURIComponent("" + family));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async deliveryTerm_List(brandId: number, options: AxiosRequestConfig = {}): Promise<DeliveryTermDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/delivery-term";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async deliveryTerm_Create(brandId: number, createDeliveryTerm: CreateDeliveryTerm, options: AxiosRequestConfig = {}): Promise<DeliveryTermDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/delivery-term";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = createDeliveryTerm;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async deliveryTerm_Update(brandId: number, deliveryTermId: number, updateDeliveryTerm: UpdateDeliveryTerm, options: AxiosRequestConfig = {}): Promise<DeliveryTermDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/delivery-term/{deliveryTermId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryTermId === undefined || deliveryTermId === null)
        throw new Error("The parameter 'deliveryTermId' must be defined.");
    url_ = url_.replace("{deliveryTermId}", encodeURIComponent("" + deliveryTermId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = updateDeliveryTerm;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async deliveryTerm_Delete(brandId: number, deliveryTermId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/delivery-term/{deliveryTermId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryTermId === undefined || deliveryTermId === null)
        throw new Error("The parameter 'deliveryTermId' must be defined.");
    url_ = url_.replace("{deliveryTermId}", encodeURIComponent("" + deliveryTermId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async deliveryTerm_GetDeliveryTermUsage(brandId: number, deliveryTermId: number, options: AxiosRequestConfig = {}): Promise<DeliveryTermUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/delivery-term/{deliveryTermId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryTermId === undefined || deliveryTermId === null)
        throw new Error("The parameter 'deliveryTermId' must be defined.");
    url_ = url_.replace("{deliveryTermId}", encodeURIComponent("" + deliveryTermId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async desktopFiles_GetFileTree(brandId: number, grouping: ProductGrouping | undefined, hierarchyLevelId: number | null | undefined, options: AxiosRequestConfig = {}): Promise<FileTreeResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/desktop/file-tree?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (grouping === null)
        throw new Error("The parameter 'grouping' cannot be null.");
    else if (grouping !== undefined)
        url_ += "grouping=" + encodeURIComponent("" + grouping) + "&";
    if (hierarchyLevelId !== undefined && hierarchyLevelId !== null)
        url_ += "hierarchyLevelId=" + encodeURIComponent("" + hierarchyLevelId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The file-tree nodes of just these products and their BOMs, for the drive to reload what a
DesktopFileTreeChanged naming them changed without reloading the whole brand.
 * @param ids (optional) 
 * @param grouping (optional) 
 * @param hierarchyLevelId (optional) 
 */
  async desktopFiles_GetProductsFileTree(brandId: number, ids: number[] | undefined, grouping: ProductGrouping | undefined, hierarchyLevelId: number | null | undefined, options: AxiosRequestConfig = {}): Promise<ProductsFileTreeResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/desktop/file-tree/products?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (ids === null)
        throw new Error("The parameter 'ids' cannot be null.");
    else if (ids !== undefined)
        ids && ids.forEach(item => { url_ += "ids=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (grouping === null)
        throw new Error("The parameter 'grouping' cannot be null.");
    else if (grouping !== undefined)
        url_ += "grouping=" + encodeURIComponent("" + grouping) + "&";
    if (hierarchyLevelId !== undefined && hierarchyLevelId !== null)
        url_ += "hierarchyLevelId=" + encodeURIComponent("" + hierarchyLevelId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async desktopFiles_GetHierarchyLevels(brandId: number, options: AxiosRequestConfig = {}): Promise<HierarchyLevelDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/desktop/hierarchy-levels";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async desktopFiles_UpdateFile(brandId: number, entityType: string, id: number, file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/desktop/file/{entityType}/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (entityType === undefined || entityType === null)
        throw new Error("The parameter 'entityType' must be defined.");
    url_ = url_.replace("{entityType}", encodeURIComponent("" + entityType));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      responseType: "blob",
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async desktopFiles_CreateProductFile(brandId: number, productId: number, file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<CreateFileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/desktop/file/product/{productId}/files";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async desktopFiles_CreateColorImage(brandId: number, colorId: number, file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<CreateFileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/desktop/file/color/{colorId}/images";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (colorId === undefined || colorId === null)
        throw new Error("The parameter 'colorId' must be defined.");
    url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async desktopFiles_CreateColorFieldFile(brandId: number, colorId: number, fieldId: number, file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<CreateFileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/desktop/file/color/{colorId}/fields/{fieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (colorId === undefined || colorId === null)
        throw new Error("The parameter 'colorId' must be defined.");
    url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
    if (fieldId === undefined || fieldId === null)
        throw new Error("The parameter 'fieldId' must be defined.");
    url_ = url_.replace("{fieldId}", encodeURIComponent("" + fieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async desktopFiles_CreateProductImage(brandId: number, productId: number, file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<CreateFileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/desktop/file/product/{productId}/images";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async destination_List(brandId: number, options: AxiosRequestConfig = {}): Promise<DestinationDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/destination";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async destination_Create(brandId: number, args: CreateDestinationArgs, options: AxiosRequestConfig = {}): Promise<DestinationDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/destination";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async destination_Update(brandId: number, destinationId: number, args: UpdateDestinationArgs, options: AxiosRequestConfig = {}): Promise<DestinationDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/destination/{destinationId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (destinationId === undefined || destinationId === null)
        throw new Error("The parameter 'destinationId' must be defined.");
    url_ = url_.replace("{destinationId}", encodeURIComponent("" + destinationId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async destination_Delete(brandId: number, destinationId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/destination/{destinationId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (destinationId === undefined || destinationId === null)
        throw new Error("The parameter 'destinationId' must be defined.");
    url_ = url_.replace("{destinationId}", encodeURIComponent("" + destinationId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async destination_Reorder(brandId: number, destinationIds: number[], options: AxiosRequestConfig = {}): Promise<DestinationDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/destination/reorder";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = destinationIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async destination_GetDestinationUsage(brandId: number, destinationId: number, options: AxiosRequestConfig = {}): Promise<DestinationUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/destination/{destinationId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (destinationId === undefined || destinationId === null)
        throw new Error("The parameter 'destinationId' must be defined.");
    url_ = url_.replace("{destinationId}", encodeURIComponent("" + destinationId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async drop_ListDrops(brandId: number, options: AxiosRequestConfig = {}): Promise<DropDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/drops";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async drop_UpdateDropName(brandId: number, dropId: number, name: string | undefined, options: AxiosRequestConfig = {}): Promise<DropDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/drops/{dropId}/name";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (dropId === undefined || dropId === null)
        throw new Error("The parameter 'dropId' must be defined.");
    url_ = url_.replace("{dropId}", encodeURIComponent("" + dropId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = name;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async drop_DeleteDrop(brandId: number, dropId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/drops/{dropId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (dropId === undefined || dropId === null)
        throw new Error("The parameter 'dropId' must be defined.");
    url_ = url_.replace("{dropId}", encodeURIComponent("" + dropId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async dropGroup_ListDropGroups(brandId: number, options: AxiosRequestConfig = {}): Promise<DropGroupDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/drop-groups";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async dropGroup_AddDropGroup(brandId: number, dropGroupData: AddDropGroupData, options: AxiosRequestConfig = {}): Promise<DropGroupDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/drop-groups";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = dropGroupData;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async dropGroup_DeleteDropGroup(brandId: number, dropGroupId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/drop-groups/{dropGroupId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (dropGroupId === undefined || dropGroupId === null)
        throw new Error("The parameter 'dropGroupId' must be defined.");
    url_ = url_.replace("{dropGroupId}", encodeURIComponent("" + dropGroupId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async excelTemplate_GetList(brandId: number, options: AxiosRequestConfig = {}): Promise<ExcelTemplateDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/excel-templates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async excelTemplate_Download(brandId: number, kind: string, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/excel-templates/{kind}/download";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (kind === undefined || kind === null)
        throw new Error("The parameter 'kind' must be defined.");
    url_ = url_.replace("{kind}", encodeURIComponent("" + kind));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async excelTemplate_DownloadDefault(brandId: number, kind: string, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/excel-templates/{kind}/default/download";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (kind === undefined || kind === null)
        throw new Error("The parameter 'kind' must be defined.");
    url_ = url_.replace("{kind}", encodeURIComponent("" + kind));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async excelTemplate_Upload(brandId: number, kind: string, uploadFile: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/excel-templates/{kind}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (kind === undefined || kind === null)
        throw new Error("The parameter 'kind' must be defined.");
    url_ = url_.replace("{kind}", encodeURIComponent("" + kind));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (uploadFile !== null && uploadFile !== undefined)
        content_.append("UploadFile", uploadFile, uploadFile.name ? uploadFile.name : "UploadFile");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async excelTemplate_Delete(brandId: number, kind: string, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/excel-templates/{kind}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (kind === undefined || kind === null)
        throw new Error("The parameter 'kind' must be defined.");
    url_ = url_.replace("{kind}", encodeURIComponent("" + kind));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's files with their versions. The read side of file_Upload — POST only because the filter travels in the body; it changes nothing.
 */
  async file_GetList(brandId: number, ids: number[], options: AxiosRequestConfig = {}): Promise<AzureBlobFileDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/files/list";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = ids;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a file record — an AzureBlobFile with a first version. NOT callable from run(): the sandbox has no network and a File does not survive the boundary. Reach it through the request_upload tool with deliverTo {operation: "file_Upload", args: {name}}, which hands you back the record's id. You want that id for product and article images, product_AddFiles and bom_AddBomImages; everything else that holds a file takes a path, and a plain request_upload gives you that without creating a record. A file already in the PLM — one produced or attached in the agent chat — has an id already and needs no upload.
 * @param name (optional) 
 * @param uploadFile (optional) 
 */
  async file_Upload(brandId: number, name: string | undefined, uploadFile: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<AzureBlobFileDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/files?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (name === null)
        throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
        url_ += "name=" + encodeURIComponent("" + name) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (uploadFile !== null && uploadFile !== undefined)
        content_.append("UploadFile", uploadFile, uploadFile.name ? uploadFile.name : "UploadFile");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a file record from a file already stored in the PLM, given its store-relative `path` — such as `images/9f2c41d0.png` from an order, a custom field, a certificate or a plain request_upload. Returns the new record, whose `id` is what product and article images, product_AddFiles and bom_AddBomImages take. Nothing is re-uploaded: the record points at the same stored file, and its size and an image's width and height are read from storage. `name` is the file's display name; an extension on it is dropped. Each call creates another record, so reuse the id rather than calling it twice for the same path. To replace an existing file's contents instead, use file_AddVersionFromFile.
 */
  async file_CreateFromPath(brandId: number, args: CreateFromPathArgs, options: AxiosRequestConfig = {}): Promise<AzureBlobFileDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/files/from-path";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Replace an existing file's contents, keeping its id, its attachments and its version history. NOT callable from run(). Reach it through request_upload with deliverTo {operation: "file_AddVersion", args: {id}}. This is the whole job — do not call product_AddFiles again afterwards, and do not "replace" a file by uploading a new one and attaching that, which leaves the old file in place and throws the history away. When the new contents are already a file in the PLM — one you produced in the chat, or one the user attached — use file_AddVersionFromFile instead, which needs no upload.
 * @param uploadFile (optional) 
 */
  async file_AddVersion(brandId: number, id: number, uploadFile: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<AzureBlobFileDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/files/{id}/versions";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (uploadFile !== null && uploadFile !== undefined)
        content_.append("UploadFile", uploadFile, uploadFile.name ? uploadFile.name : "UploadFile");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Replace an existing file's contents with another file already in the PLM, keeping the target's id, its attachments and its version history. `id` is the file to replace; the body is the bare azureBlobFileId whose current contents become its newest version — such as a file you produced in the chat, or one the user attached. Nothing is re-uploaded and the source file is left as it is. Use this instead of request_upload with deliverTo file_AddVersion whenever the new contents are already a file you have an id for. Both files must belong to this brand.
 */
  async file_AddVersionFromFile(brandId: number, id: number, sourceFileId: number, options: AxiosRequestConfig = {}): Promise<AzureBlobFileDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/files/{id}/versions/from-file";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = sourceFileId;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async file_UpdateName(brandId: number, id: number, args: UpdateNameArgs, options: AxiosRequestConfig = {}): Promise<AzureBlobFileDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/files/{id}/name";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async file_DownloadLatestVersion(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/files/{id}/download-latest-version";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async file_DownloadVersion(brandId: number, versionId: number, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/files/versions/{versionId}/download";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (versionId === undefined || versionId === null)
        throw new Error("The parameter 'versionId' must be defined.");
    url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async file_DownloadVersionPreview(brandId: number, versionId: number, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/files/versions/{versionId}/download-preview";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (versionId === undefined || versionId === null)
        throw new Error("The parameter 'versionId' must be defined.");
    url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List every freight rate the brand has set. One entry per country, destination, mode of transport, hierarchy node and season, so expect many rows rather than a short list.
 */
  async freight_GetAll(brandId: number, options: AxiosRequestConfig = {}): Promise<FreightDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/freight";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set one freight rate, identified by the combination of country, destination, mode of transport, hierarchy node and season. Either a rate (percentage) or an amount with a currency, per `type`. Use freight_SetFreightsBulk for more than a couple.
 */
  async freight_SetFreight(brandId: number, args: SetFreightArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/freight";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set many freight rates at once. Each cell is a hierarchy node and country; `hasValue:false` clears that cell rather than setting it to zero.
Returns the same list the GET does, so the caller can show the saved rates without
waiting for the SignalR round trip to fetch them.
 */
  async freight_SetFreightsBulk(brandId: number, args: SetFreightsBulkArgs, options: AxiosRequestConfig = {}): Promise<FreightDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/freight/bulk";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async freight_DeleteFreights(brandId: number, hierarchyNodeId: number, modeOfTransportId: number | undefined, destinationId: number | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/freight/{hierarchyNodeId}?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (hierarchyNodeId === undefined || hierarchyNodeId === null)
        throw new Error("The parameter 'hierarchyNodeId' must be defined.");
    url_ = url_.replace("{hierarchyNodeId}", encodeURIComponent("" + hierarchyNodeId));
    if (modeOfTransportId === null)
        throw new Error("The parameter 'modeOfTransportId' cannot be null.");
    else if (modeOfTransportId !== undefined)
        url_ += "modeOfTransportId=" + encodeURIComponent("" + modeOfTransportId) + "&";
    if (destinationId === null)
        throw new Error("The parameter 'destinationId' cannot be null.");
    else if (destinationId !== undefined)
        url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async hierarchyLevels_GetHierarchyLevels(brandId: number, options: AxiosRequestConfig = {}): Promise<HierarchyLevelDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/hierarchy-levels";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Insert a level into the product hierarchy at `index`. Existing nodes keep their depth: when the new level lands above nodes that already exist, every one of them gets a placeholder parent named "<node name> (Parent)" on the new level, so a tree read after this call contains nodes that were not in the request. Rename or merge those placeholders afterwards; deleting the original nodes leaves them behind.
 */
  async hierarchyLevels_CreateHierarchyLevel(brandId: number, args: AddHierarchyLevelArgs, options: AxiosRequestConfig = {}): Promise<HierarchyLevelDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/hierarchy-levels";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async hierarchyLevels_UpdateHierarchyLevel(brandId: number, levelId: number, args: UpdateHierarchyLevelArgs, options: AxiosRequestConfig = {}): Promise<HierarchyLevelDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/hierarchy-levels/{levelId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (levelId === undefined || levelId === null)
        throw new Error("The parameter 'levelId' must be defined.");
    url_ = url_.replace("{levelId}", encodeURIComponent("" + levelId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async hierarchyLevels_DeleteHierarchyLevel(brandId: number, levelId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/hierarchy-levels/{levelId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (levelId === undefined || levelId === null)
        throw new Error("The parameter 'levelId' must be defined.");
    url_ = url_.replace("{levelId}", encodeURIComponent("" + levelId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read the brand's product tree — every node with its id, parentId, name and fullName (the full path). Resolve any hierarchyNodeId here before writing freight, VAT, markup targets or lookup-table rows scoped by one.
 */
  async hierarchyNodes_GetHierarchyNodes(brandId: number, options: AxiosRequestConfig = {}): Promise<HierarchyNodeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/hierarchy-nodes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Add a node to the brand's product tree, under an existing parent — parentId is required and there is always a root, so read hierarchyNodes_GetHierarchyNodes first to find it. Its depth comes from the parent, not from an argument. The four id lists (sizeSystemIds, tagCategoryIds, customFieldGroupIds, productCategoryIds) are required: send [] for the ones you do not mean to set.
 */
  async hierarchyNodes_AddHierarchyNode(brandId: number, args: AddHierarchyNodeArgs, options: AxiosRequestConfig = {}): Promise<HierarchyNodeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/hierarchy-nodes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Rename or reconfigure one node. This REPLACES the node's settings, including all four id lists — an omitted list is not left alone, it is emptied, so read the node and send it back with your change applied. Use hierarchyNodes_MoveHierarchyNode to change where it sits; this cannot.
 */
  async hierarchyNodes_UpdateHierarchyNode(brandId: number, nodeId: number, args: UpdateHierarchyNodeArgs, options: AxiosRequestConfig = {}): Promise<HierarchyNodeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/hierarchy-nodes/{nodeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (nodeId === undefined || nodeId === null)
        throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace("{nodeId}", encodeURIComponent("" + nodeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a node AND everything under it. Every product in the subtree is reassigned to the deleted node's parent rather than blocking the delete, and BOM section templates attached to any node in it are detached. Nothing reports that count beforehand, so read the subtree with hierarchyNodes_GetHierarchyNodes and confirm with the user first. The root cannot be deleted.
 */
  async hierarchyNodes_DeleteHierarchyNode(brandId: number, nodeId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/hierarchy-nodes/{nodeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (nodeId === undefined || nodeId === null)
        throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace("{nodeId}", encodeURIComponent("" + nodeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Move a node, and the whole subtree under it, to a different parent. Its depth follows the new parent, and every product beneath it is re-checked against that branch's restrictions — a product the new branch does not allow fails the move. The root cannot be moved. newParentId reads as optional in the signature and is not: omitted, it binds as 0 and the call 404s on a parent that does not exist.
 * @param newParentId (optional) 
 */
  async hierarchyNodes_MoveHierarchyNode(brandId: number, nodeId: number, newParentId: number | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/hierarchy-nodes/{nodeId}/move?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (nodeId === undefined || nodeId === null)
        throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace("{nodeId}", encodeURIComponent("" + nodeId));
    if (newParentId === null)
        throw new Error("The parameter 'newParentId' cannot be null.");
    else if (newParentId !== undefined)
        url_ += "newParentId=" + encodeURIComponent("" + newParentId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the order of one node's children. childIds must be exactly that node's current children, all of them, in the order you want — a partial list is a 400, not a partial reorder. nodeId reads as optional and is not — omitted it binds as 0 and 404s.
 * @param nodeId (optional) 
 */
  async hierarchyNodes_ReorderChildren(brandId: number, nodeId: number | undefined, childIds: number[], options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/hierarchy-nodes/reorder-children?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (nodeId === null)
        throw new Error("The parameter 'nodeId' cannot be null.");
    else if (nodeId !== undefined)
        url_ += "nodeId=" + encodeURIComponent("" + nodeId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = childIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async hierarchyNodes_SetRoleAssignments(brandId: number, nodeId: number, args: SetNodeRoleAssignmentsArgs, options: AxiosRequestConfig = {}): Promise<HierarchyNodeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/hierarchy-nodes/{nodeId}/role-assignments";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (nodeId === undefined || nodeId === null)
        throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace("{nodeId}", encodeURIComponent("" + nodeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async hierarchyNodes_ExportHierarchy(brandId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/hierarchy-nodes/export";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async history_GetArticle(args: History_GetArticleArgs, options: AxiosRequestConfig = {}): Promise<ArticleHistoryEntryDto[]> {
    const { brandId, articleNumber, includeProduct, seasonId, since, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/history/articles/{articleNumber}?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleNumber === undefined || articleNumber === null)
        throw new Error("The parameter 'articleNumber' must be defined.");
    url_ = url_.replace("{articleNumber}", encodeURIComponent("" + articleNumber));
    if (includeProduct === null)
        throw new Error("The parameter 'includeProduct' cannot be null.");
    else if (includeProduct !== undefined)
        url_ += "includeProduct=" + encodeURIComponent("" + includeProduct) + "&";
    if (seasonId !== undefined && seasonId !== null)
        url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
    if (since !== undefined && since !== null)
        url_ += "since=" + encodeURIComponent("" + since) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async history_SearchArticles(brandId: number, q: string | undefined, take: number | undefined, options: AxiosRequestConfig = {}): Promise<ArticleSearchHitDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/history/search-articles?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (q === null)
        throw new Error("The parameter 'q' cannot be null.");
    else if (q !== undefined)
        url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (take === null)
        throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined)
        url_ += "take=" + encodeURIComponent("" + take) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async inboundEmail_HandleInboundEmail(args: InboundEmail_HandleInboundEmailArgs, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    const { secret, to, from, text, headers, dkim, } = args;
    let url_ = this.baseUrl + "/api/inbound-email/{secret}";
    if (secret === undefined || secret === null)
        throw new Error("The parameter 'secret' must be defined.");
    url_ = url_.replace("{secret}", encodeURIComponent("" + secret));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (to !== null && to !== undefined)
        content_.append("to", to.toString());
    if (from !== null && from !== undefined)
        content_.append("from", from.toString());
    if (text !== null && text !== undefined)
        content_.append("text", text.toString());
    if (headers !== null && headers !== undefined)
        content_.append("headers", headers.toString());
    if (dkim !== null && dkim !== undefined)
        content_.append("dkim", dkim.toString());

    const options_: AxiosRequestConfig = {
      data: content_,
      responseType: "blob",
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's in-price configurations, one per season, each with its cost-buildup steps. The steps carry the calculation templates, so this is what to read before changing any of them.
 */
  async inPriceConfig_GetAll(brandId: number, options: AxiosRequestConfig = {}): Promise<InPriceConfigDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/in-price-configs";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async inPriceConfig_CreateInPriceConfig(brandId: number, args: CreateInPriceConfigArgs, options: AxiosRequestConfig = {}): Promise<InPriceConfigDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/in-price-configs";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * What removing in-price steps would clear: the products holding a value for any of them. Products where someone entered a value by hand are listed; products whose values only follow the step (its default, or its calculation template) are counted. Pass the ids of the same step in each season's config to get one answer for all of them, or every step of the configs about to be deleted. Removing a step through the config update, or deleting its config, deletes these values.
 * @param stepIds (optional) 
 */
  async inPriceConfig_GetStepUsage(brandId: number, stepIds: number[] | undefined, options: AxiosRequestConfig = {}): Promise<InPriceStepUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/in-price-configs/steps/usage?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (stepIds === null)
        throw new Error("The parameter 'stepIds' cannot be null.");
    else if (stepIds !== undefined)
        stepIds && stepIds.forEach(item => { url_ += "stepIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Replace an in-price config's settings and its whole step list. A step left out of `steps` is removed together with every product's value for it (see steps/usage for what that clears); a step with an id of 0 or below is created.
 */
  async inPriceConfig_UpdateInPriceConfig(brandId: number, inPriceConfigId: number, args: UpdateInPriceConfigArgs, options: AxiosRequestConfig = {}): Promise<InPriceConfigDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/in-price-configs/{inPriceConfigId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (inPriceConfigId === undefined || inPriceConfigId === null)
        throw new Error("The parameter 'inPriceConfigId' must be defined.");
    url_ = url_.replace("{inPriceConfigId}", encodeURIComponent("" + inPriceConfigId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async inPriceConfig_DeleteInPriceConfig(brandId: number, inPriceConfigId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/in-price-configs/{inPriceConfigId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (inPriceConfigId === undefined || inPriceConfigId === null)
        throw new Error("The parameter 'inPriceConfigId' must be defined.");
    url_ = url_.replace("{inPriceConfigId}", encodeURIComponent("" + inPriceConfigId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Recalculate landed cost after a currency change. Rewrites stored landed-cost figures across the brand.
 */
  async inPriceConfig_RecalculateLandedCostCurrency(brandId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/in-price-configs/recalculate-landed-cost-currency";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Identity Verification token for booting the Intercom Messenger. Only ever signs
the logged-in user's own identity. Jwt is null when no secret is configured,
in which case the frontend boots unsigned (fine until enforcement is enabled
on the Intercom side).
 */
  async intercom_GetJwt(options: AxiosRequestConfig = {}): Promise<IntercomJwtResponse> {
    let url_ = this.baseUrl + "/api/intercom/jwt";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async lookupTable_ExportLookupTable(brandId: number, id: number, mode: LookupExportMode, args: ExportLookupTableArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table/{id}/export/{mode}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (mode === undefined || mode === null)
        throw new Error("The parameter 'mode' must be defined.");
    url_ = url_.replace("{mode}", encodeURIComponent("" + mode));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async lookupTable_ImportLookupTable(brandId: number, id: number, file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table/{id}/import";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async lookupTable_ListLookupTables(brandId: number, options: AxiosRequestConfig = {}): Promise<LookupTableDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async lookupTable_CreateLookupTable(brandId: number, args: LookupTableDto, options: AxiosRequestConfig = {}): Promise<LookupTableDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async lookupTable_GetLookupConsumers(brandId: number, options: AxiosRequestConfig = {}): Promise<LookupConsumerDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table/consumers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async lookupTable_UpdateLookupTable(brandId: number, id: number, args: LookupTableDto, options: AxiosRequestConfig = {}): Promise<LookupTableDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async lookupTable_DeleteLookupTable(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Write values into a lookup table's cells, merging: only the cells named change. Each write addresses one cell by its result set (seasonGroupId; null = Default, which answers for every season no group covers), its key and its output column, not by row index. The key has exactly one entry per key column of the table, holding its id in the slot that column's dimension reads (hierarchyNodeId, tagId, sizeSystemVersionSizeId, genders, selectCustomFieldOptionId, which must be an option of that column's own field, or tariffCodeId, which must be one of the codes that column offers) with every other slot null; all slots null is the wildcard row. A write carries whichever of amount/stringValue/boolValue matches the column's type, plus currencyId or unitId where the column has them (a unit must be one the column allows). A write without a value clears that cell, and a row left with no values is deleted; a key with no row yet creates one, but only when the write has a value. Season groups are not created here.
 */
  async lookupTable_SetLookupValues(brandId: number, id: number, args: SetLookupValuesArgs, options: AxiosRequestConfig = {}): Promise<LookupTableDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table/{id}/values";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async lookupTable_CreateSeasonGroup(brandId: number, id: number, args: CreateSeasonGroupArgs, options: AxiosRequestConfig = {}): Promise<LookupTableDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table/{id}/season-group";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Re-scope a season group: set exactly which seasons read its values. The values themselves are untouched.
 */
  async lookupTable_SetSeasonGroupSeasons(brandId: number, id: number, seasonGroupId: number, args: SetSeasonGroupSeasonsArgs, options: AxiosRequestConfig = {}): Promise<LookupTableDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table/{id}/season-group/{seasonGroupId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (seasonGroupId === undefined || seasonGroupId === null)
        throw new Error("The parameter 'seasonGroupId' must be defined.");
    url_ = url_.replace("{seasonGroupId}", encodeURIComponent("" + seasonGroupId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async lookupTable_RemoveSeasonGroup(brandId: number, id: number, seasonGroupId: number, options: AxiosRequestConfig = {}): Promise<LookupTableDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table/{id}/season-group/{seasonGroupId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (seasonGroupId === undefined || seasonGroupId === null)
        throw new Error("The parameter 'seasonGroupId' must be defined.");
    url_ = url_.replace("{seasonGroupId}", encodeURIComponent("" + seasonGroupId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Split a season group in two, the new group starting as a copy of the original's whole result set. keepSeasonIds and newGroupSeasonIds must partition the group's current seasons exactly — every season in one half or the other, none in both, neither half empty — and anything else is refused rather than repaired.
 */
  async lookupTable_SplitSeasonGroup(brandId: number, id: number, seasonGroupId: number, args: SplitSeasonGroupArgs, options: AxiosRequestConfig = {}): Promise<LookupTableDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table/{id}/season-group/{seasonGroupId}/split";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (seasonGroupId === undefined || seasonGroupId === null)
        throw new Error("The parameter 'seasonGroupId' must be defined.");
    url_ = url_.replace("{seasonGroupId}", encodeURIComponent("" + seasonGroupId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Rename a lookup table, change its key, or replace its description, leaving its columns and rows untouched. All three are sent every time: the description replaces the old one, and null or blank clears it. Templates name the table by key, so a key change is refused while a calculated field or price still reads the table; the key is lowercase letters, digits and hyphens, unique within the brand.
 */
  async lookupTable_UpdateLookupTableDetails(brandId: number, id: number, args: UpdateLookupTableDetailsArgs, options: AxiosRequestConfig = {}): Promise<LookupTableDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table/{id}/details";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async lookupTable_GetLookupTableUsages(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<LookupUsageDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/lookup-table/{id}/usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The caller's own account and its company connections. Prefer the list_brands tool: it filters to the brands this server can actually serve and reports separately on the ones it cannot, which this raw list does not distinguish.
 */
  async manage_GetUserData(options: AxiosRequestConfig = {}): Promise<UserInfoDto> {
    let url_ = this.baseUrl + "/api/manage/get-user-data";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The caller's own account and its company connections. Prefer the list_brands tool: it filters to the brands this server can actually serve and reports separately on the ones it cannot, which this raw list does not distinguish.
 */
  async manage_GetUserData2(options: AxiosRequestConfig = {}): Promise<UserInfoDto> {
    let url_ = this.baseUrl + "/api/manage/getUserData";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Find measurement charts by text, status, tag, size system, gender, season or hierarchy. `searchText` matches a chart's name or its reference number. Pass `items` and `startIndex` explicitly — omitted paging arguments bind as 0, not as their declared defaults, and you get an empty list with a non-zero totalCount.
 */
  async mChart_SearchMCharts(brandId: number, args: SearchMChartsArgs, options: AxiosRequestConfig = {}): Promise<SearchMChartsResult> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mcharts/search";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read several measurement charts by id.
 */
  async mChart_GetMChartsByIds(brandId: number, ids: number[], options: AxiosRequestConfig = {}): Promise<MChartDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mcharts/by-ids";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = ids;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read one measurement chart with its versions and measurements.
 */
  async mChart_GetMChart(brandId: number, mChartId: number, options: AxiosRequestConfig = {}): Promise<MChartDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mcharts/{mChartId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (mChartId === undefined || mChartId === null)
        throw new Error("The parameter 'mChartId' must be defined.");
    url_ = url_.replace("{mChartId}", encodeURIComponent("" + mChartId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Replace a measurement chart WHOLESALE — versions, sections, measurements, values, gradings, files and images all travel in this one payload, and anything omitted is deleted. Sections are in order and there is always at least one; each measurement names its section by SectionIndex into Sections, and a section without an id (or with one the chart doesn't have) is created. Read the chart with mChart_GetMChart, change only what you mean, send it all back. Image annotations use normalised 0-1 coordinates and a GUID id; read search_api({entity:"mChart"}) before writing.
 */
  async mChart_UpdateMChart(brandId: number, mChartId: number, args: UpdateMChartArgs2, options: AxiosRequestConfig = {}): Promise<MChartDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mcharts/{mChartId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (mChartId === undefined || mChartId === null)
        throw new Error("The parameter 'mChartId' must be defined.");
    url_ = url_.replace("{mChartId}", encodeURIComponent("" + mChartId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a measurement chart and its versions.
 */
  async mChart_DeleteMChart(brandId: number, mChartId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mcharts/{mChartId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (mChartId === undefined || mChartId === null)
        throw new Error("The parameter 'mChartId' must be defined.");
    url_ = url_.replace("{mChartId}", encodeURIComponent("" + mChartId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a measurement chart. Its first version carries the initial status; resolve statuses with mChartStatus_GetMChartStatuses. Sections are in order with at least one, and each measurement names its section by SectionIndex into Sections.
 */
  async mChart_AddMChart(brandId: number, args: AddMChartArgs, options: AxiosRequestConfig = {}): Promise<MChartDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mcharts";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChart_AddMChartAndExport(brandId: number, supplierId: number | null | undefined, args: AddMChartArgs, options: AxiosRequestConfig = {}): Promise<MChartDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mcharts/save-and-export?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (supplierId !== undefined && supplierId !== null)
        url_ += "supplierId=" + encodeURIComponent("" + supplierId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChart_UpdateMChartAndExport(brandId: number, mChartId: number, supplierId: number | null | undefined, args: UpdateMChartArgs2, options: AxiosRequestConfig = {}): Promise<MChartDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mcharts/{mChartId}/save-and-export?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (mChartId === undefined || mChartId === null)
        throw new Error("The parameter 'mChartId' must be defined.");
    url_ = url_.replace("{mChartId}", encodeURIComponent("" + mChartId));
    if (supplierId !== undefined && supplierId !== null)
        url_ += "supplierId=" + encodeURIComponent("" + supplierId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Render a measurement chart image with its annotations drawn on, as a PNG. Returning it from run() shows it to you — this is how you check that annotations landed where you meant, which the coordinates alone cannot tell you.
 */
  async mChartImage_GetAnnotatedImage(imageId: number, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/mcharts/images/{imageId}/annotated";
    if (imageId === undefined || imageId === null)
        throw new Error("The parameter 'imageId' must be defined.");
    url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Same as mChartImage_GetAnnotatedImage but for a sample round report image. Takes the SampleRoundImage id, not the mChart image id.
 */
  async mChartImage_GetAnnotatedReportImage(imageId: number, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/mcharts/images/report/{imageId}/annotated";
    if (imageId === undefined || imageId === null)
        throw new Error("The parameter 'imageId' must be defined.");
    url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the measurement chart statuses this brand has defined, in the brand's own order.
 */
  async mChartStatus_GetMChartStatuses(brandId: number, options: AxiosRequestConfig = {}): Promise<MChartStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChartStatus_CreateMChartStatus(brandId: number, args: CreateMChartStatusArgs, options: AxiosRequestConfig = {}): Promise<MChartStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChartStatus_UpdateMChartStatus(brandId: number, statusId: number, args: UpdateMChartStatusArgs, options: AxiosRequestConfig = {}): Promise<MChartStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-statuses/{statusId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChartStatus_DeleteMChartStatus(brandId: number, statusId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-statuses/{statusId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChartStatus_UpdateOrder(brandId: number, mChartStatusIds: number[], options: AxiosRequestConfig = {}): Promise<MChartStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-statuses/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = mChartStatusIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChartStatus_GetUsage(brandId: number, statusId: number, options: AxiosRequestConfig = {}): Promise<MChartStatusUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-statuses/{statusId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChartTag_GetMChartTagCategories(brandId: number, options: AxiosRequestConfig = {}): Promise<MChartTagCategoryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-tags/categories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChartTag_CreateMChartTagCategory(brandId: number, args: CreateTagCategoryArgs, options: AxiosRequestConfig = {}): Promise<MChartTagCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-tags/categories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChartTag_UpdateMChartTagCategory(brandId: number, tagCategoryId: number, args: UpdateTagCategoryArgs, options: AxiosRequestConfig = {}): Promise<MChartTagCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-tags/categories/{tagCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChartTag_DeleteMChartTagCategory(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-tags/categories/{tagCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Count the measurement charts currently tagged from this category. Call this before deleting one.
 */
  async mChartTag_GetTagCategoryUsageCount(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-tags/categories/{tagCategoryId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChartTag_CreateMChartTag(brandId: number, args: AddTagArgs2, options: AxiosRequestConfig = {}): Promise<MChartTagDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChartTag_UpdateMChartTag(brandId: number, tagId: number, args: UpdateTagArgs2, options: AxiosRequestConfig = {}): Promise<MChartTagDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChartTag_DeleteMChartTag(brandId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async mChartTag_GetTagUsageCount(brandId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mchart-tags/{tagId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async measurement_GetMeasurements(brandId: number, options: AxiosRequestConfig = {}): Promise<MeasurementDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/measurements";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async measurement_CreateMeasurement(brandId: number, args: CreateMeasurementArgs, options: AxiosRequestConfig = {}): Promise<MeasurementDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/measurements";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async measurement_UpdateMeasurement(brandId: number, measurementId: number, args: UpdateMeasurementArgs, options: AxiosRequestConfig = {}): Promise<MeasurementDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/measurements/{measurementId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (measurementId === undefined || measurementId === null)
        throw new Error("The parameter 'measurementId' must be defined.");
    url_ = url_.replace("{measurementId}", encodeURIComponent("" + measurementId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async measurement_DeleteMeasurement(brandId: number, measurementId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/measurements/{measurementId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (measurementId === undefined || measurementId === null)
        throw new Error("The parameter 'measurementId' must be defined.");
    url_ = url_.replace("{measurementId}", encodeURIComponent("" + measurementId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async measurement_GetMeasurementUsage(brandId: number, measurementId: number, options: AxiosRequestConfig = {}): Promise<EntityReference[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/measurements/{measurementId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (measurementId === undefined || measurementId === null)
        throw new Error("The parameter 'measurementId' must be defined.");
    url_ = url_.replace("{measurementId}", encodeURIComponent("" + measurementId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async measurement_UpdateMeasurementGradings(brandId: number, measurementId: number, args: UpdateMeasurementGradingsArgs, options: AxiosRequestConfig = {}): Promise<MeasurementDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/measurements/{measurementId}/gradings";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (measurementId === undefined || measurementId === null)
        throw new Error("The parameter 'measurementId' must be defined.");
    url_ = url_.replace("{measurementId}", encodeURIComponent("" + measurementId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async measurement_ExportMeasurements(brandId: number, sizeSystemVersionId: number | undefined, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/measurements/export?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sizeSystemVersionId === null)
        throw new Error("The parameter 'sizeSystemVersionId' cannot be null.");
    else if (sizeSystemVersionId !== undefined)
        url_ += "sizeSystemVersionId=" + encodeURIComponent("" + sizeSystemVersionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the measurement statuses this brand has defined, in the brand's own order.
 */
  async measurementStatus_ListMeasurementStatuses(brandId: number, options: AxiosRequestConfig = {}): Promise<MeasurementStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/measurement-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async measurementStatus_CreateMeasurementStatus(brandId: number, args: CreateMeasurementStatusArgs, options: AxiosRequestConfig = {}): Promise<MeasurementStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/measurement-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async measurementStatus_UpdateMeasurementStatus(brandId: number, id: number, args: UpdateMeasurementStatusArgs, options: AxiosRequestConfig = {}): Promise<MeasurementStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/measurement-statuses/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async measurementStatus_DeleteMeasurementStatus(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/measurement-statuses/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async measurementStatus_UpdateOrder(brandId: number, measurementStatusIds: number[], options: AxiosRequestConfig = {}): Promise<MeasurementStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/measurement-statuses/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = measurementStatusIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async measurementStatus_GetUsage(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<MeasurementStatusUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/measurement-statuses/{id}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's modes of transport — sea, air, rail and whatever else it has defined. These are the ids freight rates and orders refer to.
 */
  async modeOfTransport_List(brandId: number, options: AxiosRequestConfig = {}): Promise<ModeOfTransportDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mode-of-transport";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async modeOfTransport_Create(brandId: number, createModeOfTransport: CreateModeOfTransport, options: AxiosRequestConfig = {}): Promise<ModeOfTransportDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mode-of-transport";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = createModeOfTransport;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async modeOfTransport_Update(brandId: number, modeOfTransportId: number, updateModeOfTransport: UpdateModeOfTransport, options: AxiosRequestConfig = {}): Promise<ModeOfTransportDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mode-of-transport/{modeOfTransportId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (modeOfTransportId === undefined || modeOfTransportId === null)
        throw new Error("The parameter 'modeOfTransportId' must be defined.");
    url_ = url_.replace("{modeOfTransportId}", encodeURIComponent("" + modeOfTransportId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = updateModeOfTransport;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async modeOfTransport_Delete(brandId: number, modeOfTransportId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mode-of-transport/{modeOfTransportId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (modeOfTransportId === undefined || modeOfTransportId === null)
        throw new Error("The parameter 'modeOfTransportId' must be defined.");
    url_ = url_.replace("{modeOfTransportId}", encodeURIComponent("" + modeOfTransportId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async modeOfTransport_GetModeOfTransportUsage(brandId: number, modeOfTransportId: number, options: AxiosRequestConfig = {}): Promise<ModeOfTransportUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/mode-of-transport/{modeOfTransportId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (modeOfTransportId === undefined || modeOfTransportId === null)
        throw new Error("The parameter 'modeOfTransportId' must be defined.");
    url_ = url_.replace("{modeOfTransportId}", encodeURIComponent("" + modeOfTransportId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async notification_PostNotification(brandId: number, args: PostNotificationArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/notifications/brand/{brandId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read the current user's notifications, newest first, excluding dismissed. Background jobs report completion here — there is no job-status endpoint, so this is how you find out an import or export finished.
 */
  async notification_GetNotifications(options: AxiosRequestConfig = {}): Promise<NotificationDto[]> {
    let url_ = this.baseUrl + "/api/notifications";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async notification_Inactivate(notificationId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/notifications/{notificationId}/inactivate";
    if (notificationId === undefined || notificationId === null)
        throw new Error("The parameter 'notificationId' must be defined.");
    url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async notification_MarkAsViewed(notificationId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/notifications/{notificationId}/viewed";
    if (notificationId === undefined || notificationId === null)
        throw new Error("The parameter 'notificationId' must be defined.");
    url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async notification_InactivateAll(options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/notifications/inactivate";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async onboardingChecklist_SyncItemTask(brandId: number, args: SyncItemTaskArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/onboarding-checklist/sync-item-task";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List orders for the brand.
 * @param supplierIds (optional) 
 * @param seasonIds (optional) 
 * @param tagIds (optional) 
 * @param statusIds (optional) 
 * @param hierarchyNodeIds (optional) 
 * @param productCategoryIds (optional) 
 * @param customFieldOptionIds (optional) 
 * @param searchTerm (optional) 
 */
  async order_GetOrders(args: Order_GetOrdersArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto[]> {
    const { brandId, supplierIds, seasonIds, tagIds, statusIds, hierarchyNodeIds, productCategoryIds, customFieldOptionIds, searchTerm, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (statusIds !== undefined && statusIds !== null)
        statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (hierarchyNodeIds !== undefined && hierarchyNodeIds !== null)
        hierarchyNodeIds && hierarchyNodeIds.forEach(item => { url_ += "HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (productCategoryIds !== undefined && productCategoryIds !== null)
        productCategoryIds && productCategoryIds.forEach(item => { url_ += "ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (customFieldOptionIds !== undefined && customFieldOptionIds !== null)
        customFieldOptionIds && customFieldOptionIds.forEach(item => { url_ += "CustomFieldOptionIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create an order. Resolve its type with orderType_GetOrderTypes and its supplier with brandSupplier_Search. The Resourced `orderNumber` is assigned here from the brand's counter and cannot be chosen; to carry your own reference, follow this with order_UpdateExternalNumbers.
 */
  async order_CreateOrder(brandId: number, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete deliveries from an order, with the quantities booked against them. Deleting a delivery deletes its own quantities, prices and dates; deleting the last delivery of an order deletes the order itself, so this is how a half-written order is cleaned up. Locked deliveries and deliveries with allocations are refused.
 */
  async order_DeleteDeliveries(brandId: number, deliveryIds: number[], options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = deliveryIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set an order's mode of transport.
 */
  async order_UpdateModeOfTransport(brandId: number, deliveryId: number, args: UpdateModeOfTransportArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/mot";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set an order's status. Resolve statuses with orderStatus_GetOrderStatuses.
 */
  async order_UpdateStatus(brandId: number, deliveryId: number, args: UpdateStatusArgs2, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/status";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Change an order's supplier.
 */
  async order_UpdateSupplier(brandId: number, deliveryId: number, args: UpdateSupplierArgs2, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/supplier";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set placement details on an order line.
 */
  async order_UpdatePlacement(brandId: number, deliveryId: number, args: UpdateDatePairArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/placement";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set shipment details on an order.
 */
  async order_UpdateShipment(brandId: number, deliveryId: number, args: UpdateDatePairArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/shipment";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a delivery's date and details on an order.
 */
  async order_UpdateDelivery(brandId: number, deliveryId: number, args: UpdateDatePairArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/delivery";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set tags on an order delivery.
 */
  async order_SetDeliveryTags(brandId: number, deliveryId: number, tagIds: number[], options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = tagIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The article/quantity table for orders — what is being ordered, per SKU.
 */
  async order_GetArticleTable(brandId: number, deliveryId: number, options: AxiosRequestConfig = {}): Promise<OrderArticleTableDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/article-table";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set which seasons an order covers.
 */
  async order_SetSeasons(brandId: number, deliveryId: number, seasonIds: number[], options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/seasons";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = seasonIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set an order's type.
 * @param typeId (optional) 
 */
  async order_SetType(brandId: number, deliveryId: number, typeId: number | undefined, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/type";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = typeId;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set ordered quantities across a product's SKUs in one call. The product must already be on the delivery — this does not add it; use order_UpdateQuantity to put articles on the delivery first. Prefer this over repeated order_UpdateQuantity.
 */
  async order_SetProductQuantity(brandId: number, deliveryId: number, args: SetProductQuantityArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/product-quantity";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the ordered quantities on a delivery. This replaces the delivery's rows: an article left out of `rows` is removed, and a SKU left out of a row's `skus` is removed. Nothing is derived — every level you want filled must be sent. With `linked: true` the levels must agree: a row's `quantity` must equal the sum of its `skus` quantities, and `total` must equal the sum of the row quantities, or the call is rejected. With `linked: false` the levels are independent and are stored as sent. Either way, a row `quantity` or a `total` left null is stored as null, and the order then reads as empty in the UI however many SKU quantities it carries.
 */
  async order_UpdateQuantity(brandId: number, deliveryId: number, args: UpdateQuantityArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/quantity";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the agreed price for a SKU on an order.
 */
  async order_SetSkuPrice(brandId: number, deliveryId: number, args: SetSkuPriceArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/sku-price";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set an order's currency. This does not convert existing prices.
 */
  async order_UpdateCurrency(brandId: number, deliveryId: number, args: UpdateCurrencyArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/currency";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set which files are attached to an order delivery, matched by path. Listed paths not yet attached are added
under the given filename, attached paths missing from the list are removed, and a file already attached keeps
its stored filename: this endpoint does not rename files.
 */
  async order_UpdateFiles(brandId: number, deliveryId: number, args: UpdateFilesArgs2, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/files";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async order_AddFiles(brandId: number, deliveryId: number, args: AddFilesArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/files";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set an order's comment.
 */
  async order_UpdateComment(brandId: number, deliveryId: number, args: UpdateCommentArgs2, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/comment";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the external order and delivery numbers — the counterparty's or the source system's own references, shown alongside the Resourced order number. The Resourced `orderNumber` itself is assigned by the brand's counter at creation and cannot be set. Both fields are replaced by what is sent, so pass the value you want to keep; null clears.
 */
  async order_UpdateExternalNumbers(brandId: number, deliveryId: number, args: UpdateExternalNumbersArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/external-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set custom field values on an order delivery.
 */
  async order_UpdateDeliveryCustomFieldValues(brandId: number, deliveryId: number, valueDtos: CustomFieldIdWithValueDto[], options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/custom-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = valueDtos;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set custom field values on an order.
 */
  async order_UpdateOrderCustomFieldValues(brandId: number, deliveryId: number, valueDtos: CustomFieldIdWithValueDto[], options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/{deliveryId}/order-custom-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = valueDtos;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async order_UpdateTextCustomField(brandId: number, customFieldId: number, args: UpdateOrderTextCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/custom-field-text/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async order_UpdateMoneyCustomField(brandId: number, customFieldId: number, args: UpdateOrderMoneyCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/custom-field-money/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async order_UpdateNumberWithUnitCustomField(brandId: number, customFieldId: number, args: UpdateOrderNumberWithUnitCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/custom-field-number-with-unit/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async order_UpdateSingleSelectCustomField(brandId: number, customFieldId: number, args: UpdateOrderSingleSelectCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/custom-field-single-select/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async order_UpdateMultiSelectCustomField(brandId: number, customFieldId: number, args: UpdateOrderMultiSelectCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/custom-field-multi-select/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async order_UpdateFilesCustomField(brandId: number, customFieldId: number, args: UpdateOrderFilesCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/custom-field-files/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Repoint an order custom-field value at a different field definition.
 */
  async order_RelinkCustomField(brandId: number, customFieldId: number, args: RelinkOrderCustomFieldArgs, options: AxiosRequestConfig = {}): Promise<OrderDeliveryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/custom-field-relink/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async order_StartExcelExportOrders(brandId: number, args: StartExcelExportOrdersArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/export-excel/orders";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async order_StartExcelExportAnalysis(brandId: number, activeSeasonId: number | null | undefined, deliveryIds: number[], options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/export-excel/analysis?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = deliveryIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async order_StartPdfExportOrderSheet(brandId: number, activeSeasonId: number | null | undefined, deliveryIds: number[], options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/export-excel/order-sheet?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = deliveryIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async order_StartExcelExportInspectionDoc(brandId: number, activeSeasonId: number | null | undefined, deliveryIds: number[], options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/export-excel/inspection-doc?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = deliveryIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async order_DownloadOrderImportTemplate(brandId: string, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/import-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async order_ImportOrdersFromExcel(brandId: number, uploadFile: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/import-excel-file";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (uploadFile !== null && uploadFile !== undefined)
        content_.append("UploadFile", uploadFile, uploadFile.name ? uploadFile.name : "UploadFile");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the suppliers that can be ordered from.
 */
  async order_GetSuppliers(brandId: number, options: AxiosRequestConfig = {}): Promise<number[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/orders/filters/suppliers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderStatus_AddOrderStatus(brandId: number, args: AddOrderStatusArgs, options: AxiosRequestConfig = {}): Promise<OrderStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the order statuses this brand has defined, in the brand's own order.
 */
  async orderStatus_GetOrderStatuses(brandId: number, options: AxiosRequestConfig = {}): Promise<OrderStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderStatus_UpdateOrderStatus(brandId: number, orderStatusId: number, args: UpdateOrderStatusArgs, options: AxiosRequestConfig = {}): Promise<OrderStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-statuses/{orderStatusId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (orderStatusId === undefined || orderStatusId === null)
        throw new Error("The parameter 'orderStatusId' must be defined.");
    url_ = url_.replace("{orderStatusId}", encodeURIComponent("" + orderStatusId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderStatus_DeleteOrderStatus(brandId: number, orderStatusId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-statuses/{orderStatusId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (orderStatusId === undefined || orderStatusId === null)
        throw new Error("The parameter 'orderStatusId' must be defined.");
    url_ = url_.replace("{orderStatusId}", encodeURIComponent("" + orderStatusId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderStatus_UpdateOrdering(brandId: number, orderStatusIds: number[], options: AxiosRequestConfig = {}): Promise<OrderStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-statuses/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = orderStatusIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderStatus_GetUsage(brandId: number, orderStatusId: number, options: AxiosRequestConfig = {}): Promise<OrderStatusUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-statuses/{orderStatusId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (orderStatusId === undefined || orderStatusId === null)
        throw new Error("The parameter 'orderStatusId' must be defined.");
    url_ = url_.replace("{orderStatusId}", encodeURIComponent("" + orderStatusId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderTag_GetOrderTagCategories(brandId: number, options: AxiosRequestConfig = {}): Promise<OrderTagCategoryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-tag-categories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderTag_AddOrderTagCategory(brandId: number, args: AddOrderTagCategoryArgs, options: AxiosRequestConfig = {}): Promise<OrderTagCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-tag-categories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderTag_UpdateOrderTagCategory(brandId: number, tagCategoryId: number, args: UpdateOrderTagCategoryArgs, options: AxiosRequestConfig = {}): Promise<OrderTagCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-tag-categories/{tagCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderTag_DeleteOrderTagCategory(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-tag-categories/{tagCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderTag_GetOrderTagCategoryUsageCount(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-tag-categories/{tagCategoryId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderTag_AddOrderTag(brandId: number, args: AddOrderTagArgs, options: AxiosRequestConfig = {}): Promise<OrderTagDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderTag_UpdateOrderTag(brandId: number, tagId: number, args: UpdateOrderTagArgs, options: AxiosRequestConfig = {}): Promise<OrderTagDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderTag_DeleteOrderTag(brandId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderTag_GetOrderTagUsageCount(brandId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-tags/{tagId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderType_AddOrderType(brandId: number, args: AddOrderTypeArgs, options: AxiosRequestConfig = {}): Promise<OrderTypeSimple> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderType_GetOrderTypes(brandId: number, options: AxiosRequestConfig = {}): Promise<OrderTypeSimple[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderType_GetOrderTypeUsage(brandId: number, orderTypeId: number, options: AxiosRequestConfig = {}): Promise<OrderTypeUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-types/{orderTypeId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (orderTypeId === undefined || orderTypeId === null)
        throw new Error("The parameter 'orderTypeId' must be defined.");
    url_ = url_.replace("{orderTypeId}", encodeURIComponent("" + orderTypeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderType_DeleteOrderType(brandId: number, orderTypeId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-types/{orderTypeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (orderTypeId === undefined || orderTypeId === null)
        throw new Error("The parameter 'orderTypeId' must be defined.");
    url_ = url_.replace("{orderTypeId}", encodeURIComponent("" + orderTypeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async orderType_UpdateOrderType(brandId: number, orderTypeId: number, newOrderType: OrderTypeSimple, options: AxiosRequestConfig = {}): Promise<OrderTypeSimple> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/order-types/{orderTypeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (orderTypeId === undefined || orderTypeId === null)
        throw new Error("The parameter 'orderTypeId' must be defined.");
    url_ = url_.replace("{orderTypeId}", encodeURIComponent("" + orderTypeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = newOrderType;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's out-price configurations, one per season and destination, each with its out-prices and their calculation templates. Read this before any out-price edit — the write replaces the whole set.
 */
  async outPriceConfig_GetAll(brandId: number, options: AxiosRequestConfig = {}): Promise<OutPriceConfigDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/out-price-configs";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async outPriceConfig_GetOutPriceUsageCount(brandId: number, outPriceId: number, options: AxiosRequestConfig = {}): Promise<OutPriceUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/out-price-configs/out-price/{outPriceId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (outPriceId === undefined || outPriceId === null)
        throw new Error("The parameter 'outPriceId' must be defined.");
    url_ = url_.replace("{outPriceId}", encodeURIComponent("" + outPriceId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async outPriceConfig_UpdateOutPriceConfig(brandId: number, outPriceConfigId: number, args: UpdateOutPriceConfigArgs, options: AxiosRequestConfig = {}): Promise<OutPriceConfigDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/out-price-configs/{outPriceConfigId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (outPriceConfigId === undefined || outPriceConfigId === null)
        throw new Error("The parameter 'outPriceConfigId' must be defined.");
    url_ = url_.replace("{outPriceConfigId}", encodeURIComponent("" + outPriceConfigId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetBuckets(args: Overview_GetBucketsArgs, options: AxiosRequestConfig = {}): Promise<GetBucketsReturn> {
    const { brandId, hierarchyNodeIds, productCategoryIds, genders, seasonIds, colors, supplierIds, dropNames, statusIds, tagIds, searchTerm, customFieldOptionIds, createdByUserIds, assignedUserIds, colorGroupIds, outPriceAmounts, outPriceRanges, sizeSystemIds, timelineHealth, nextGateRoleIds, nextGateNames, grouping, descending, tagCategoryId, backwards, forward, referenceKey, includeReferenceKey, activeSeasonId, } = args;
    const dropDateRange_From = args.dropDateRange?.from;
    const dropDateRange_To = args.dropDateRange?.to;
    let url_ = this.baseUrl + "/api/overview/{brandId}/buckets?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (hierarchyNodeIds !== undefined && hierarchyNodeIds !== null)
        hierarchyNodeIds && hierarchyNodeIds.forEach(item => { url_ += "HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (productCategoryIds !== undefined && productCategoryIds !== null)
        productCategoryIds && productCategoryIds.forEach(item => { url_ += "ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (genders !== undefined && genders !== null)
        genders && genders.forEach(item => { url_ += "Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colors !== undefined && colors !== null)
        colors && colors.forEach(item => { url_ += "Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (dropDateRange_From !== undefined && dropDateRange_From !== null)
        url_ += "DropDateRange.From=" + encodeURIComponent("" + dropDateRange_From) + "&";
    if (dropDateRange_To !== undefined && dropDateRange_To !== null)
        url_ += "DropDateRange.To=" + encodeURIComponent("" + dropDateRange_To) + "&";
    if (dropNames !== undefined && dropNames !== null)
        dropNames && dropNames.forEach(item => { url_ += "DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (statusIds !== undefined && statusIds !== null)
        statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (customFieldOptionIds !== undefined && customFieldOptionIds !== null)
        url_ += appendDictionaryQuery("CustomFieldOptionIds", customFieldOptionIds);
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (assignedUserIds !== undefined && assignedUserIds !== null)
        assignedUserIds && assignedUserIds.forEach(item => { url_ += "AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colorGroupIds !== undefined && colorGroupIds !== null)
        colorGroupIds && colorGroupIds.forEach(item => { url_ += "ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (outPriceAmounts !== undefined && outPriceAmounts !== null)
        url_ += appendDictionaryQuery("OutPriceAmounts", outPriceAmounts);
    if (outPriceRanges !== undefined && outPriceRanges !== null)
        url_ += appendDictionaryQuery("OutPriceRanges", outPriceRanges);
    if (sizeSystemIds !== undefined && sizeSystemIds !== null)
        sizeSystemIds && sizeSystemIds.forEach(item => { url_ += "SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (timelineHealth !== undefined && timelineHealth !== null)
        timelineHealth && timelineHealth.forEach(item => { url_ += "TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateRoleIds !== undefined && nextGateRoleIds !== null)
        nextGateRoleIds && nextGateRoleIds.forEach(item => { url_ += "NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateNames !== undefined && nextGateNames !== null)
        nextGateNames && nextGateNames.forEach(item => { url_ += "NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (grouping === null)
        throw new Error("The parameter 'grouping' cannot be null.");
    else if (grouping !== undefined)
        url_ += "Grouping=" + encodeURIComponent("" + grouping) + "&";
    if (descending === null)
        throw new Error("The parameter 'descending' cannot be null.");
    else if (descending !== undefined)
        url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
    if (tagCategoryId !== undefined && tagCategoryId !== null)
        url_ += "TagCategoryId=" + encodeURIComponent("" + tagCategoryId) + "&";
    if (backwards === null)
        throw new Error("The parameter 'backwards' cannot be null.");
    else if (backwards !== undefined)
        url_ += "backwards=" + encodeURIComponent("" + backwards) + "&";
    if (forward === null)
        throw new Error("The parameter 'forward' cannot be null.");
    else if (forward !== undefined)
        url_ += "forward=" + encodeURIComponent("" + forward) + "&";
    if (referenceKey !== undefined && referenceKey !== null)
        url_ += "referenceKey=" + encodeURIComponent("" + referenceKey) + "&";
    if (includeReferenceKey === null)
        throw new Error("The parameter 'includeReferenceKey' cannot be null.");
    else if (includeReferenceKey !== undefined)
        url_ += "includeReferenceKey=" + encodeURIComponent("" + includeReferenceKey) + "&";
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetFilteredBuckets(args: Overview_GetFilteredBucketsArgs, options: AxiosRequestConfig = {}): Promise<GetFilteredBucketsReturn> {
    const { brandId, activeSeasonId, hierarchyNodeIds, productCategoryIds, genders, seasonIds, colors, supplierIds, dropNames, statusIds, tagIds, searchTerm, customFieldOptionIds, createdByUserIds, assignedUserIds, colorGroupIds, outPriceAmounts, outPriceRanges, sizeSystemIds, timelineHealth, nextGateRoleIds, nextGateNames, grouping, descending, tagCategoryId, startBucketKey, centerBucketKey, endBucketKey, minimumForward, minimumBackwards, } = args;
    const dropDateRange_From = args.dropDateRange?.from;
    const dropDateRange_To = args.dropDateRange?.to;
    let url_ = this.baseUrl + "/api/overview/{brandId}/buckets/filtered?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    if (hierarchyNodeIds !== undefined && hierarchyNodeIds !== null)
        hierarchyNodeIds && hierarchyNodeIds.forEach(item => { url_ += "HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (productCategoryIds !== undefined && productCategoryIds !== null)
        productCategoryIds && productCategoryIds.forEach(item => { url_ += "ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (genders !== undefined && genders !== null)
        genders && genders.forEach(item => { url_ += "Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colors !== undefined && colors !== null)
        colors && colors.forEach(item => { url_ += "Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (dropDateRange_From !== undefined && dropDateRange_From !== null)
        url_ += "DropDateRange.From=" + encodeURIComponent("" + dropDateRange_From) + "&";
    if (dropDateRange_To !== undefined && dropDateRange_To !== null)
        url_ += "DropDateRange.To=" + encodeURIComponent("" + dropDateRange_To) + "&";
    if (dropNames !== undefined && dropNames !== null)
        dropNames && dropNames.forEach(item => { url_ += "DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (statusIds !== undefined && statusIds !== null)
        statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (customFieldOptionIds !== undefined && customFieldOptionIds !== null)
        url_ += appendDictionaryQuery("CustomFieldOptionIds", customFieldOptionIds);
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (assignedUserIds !== undefined && assignedUserIds !== null)
        assignedUserIds && assignedUserIds.forEach(item => { url_ += "AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colorGroupIds !== undefined && colorGroupIds !== null)
        colorGroupIds && colorGroupIds.forEach(item => { url_ += "ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (outPriceAmounts !== undefined && outPriceAmounts !== null)
        url_ += appendDictionaryQuery("OutPriceAmounts", outPriceAmounts);
    if (outPriceRanges !== undefined && outPriceRanges !== null)
        url_ += appendDictionaryQuery("OutPriceRanges", outPriceRanges);
    if (sizeSystemIds !== undefined && sizeSystemIds !== null)
        sizeSystemIds && sizeSystemIds.forEach(item => { url_ += "SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (timelineHealth !== undefined && timelineHealth !== null)
        timelineHealth && timelineHealth.forEach(item => { url_ += "TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateRoleIds !== undefined && nextGateRoleIds !== null)
        nextGateRoleIds && nextGateRoleIds.forEach(item => { url_ += "NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateNames !== undefined && nextGateNames !== null)
        nextGateNames && nextGateNames.forEach(item => { url_ += "NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (grouping === null)
        throw new Error("The parameter 'grouping' cannot be null.");
    else if (grouping !== undefined)
        url_ += "Grouping=" + encodeURIComponent("" + grouping) + "&";
    if (descending === null)
        throw new Error("The parameter 'descending' cannot be null.");
    else if (descending !== undefined)
        url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
    if (tagCategoryId !== undefined && tagCategoryId !== null)
        url_ += "TagCategoryId=" + encodeURIComponent("" + tagCategoryId) + "&";
    if (startBucketKey !== undefined && startBucketKey !== null)
        url_ += "startBucketKey=" + encodeURIComponent("" + startBucketKey) + "&";
    if (centerBucketKey !== undefined && centerBucketKey !== null)
        url_ += "centerBucketKey=" + encodeURIComponent("" + centerBucketKey) + "&";
    if (endBucketKey !== undefined && endBucketKey !== null)
        url_ += "endBucketKey=" + encodeURIComponent("" + endBucketKey) + "&";
    if (minimumForward === null)
        throw new Error("The parameter 'minimumForward' cannot be null.");
    else if (minimumForward !== undefined)
        url_ += "minimumForward=" + encodeURIComponent("" + minimumForward) + "&";
    if (minimumBackwards === null)
        throw new Error("The parameter 'minimumBackwards' cannot be null.");
    else if (minimumBackwards !== undefined)
        url_ += "minimumBackwards=" + encodeURIComponent("" + minimumBackwards) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetUnfilteredBuckets(args: Overview_GetUnfilteredBucketsArgs, options: AxiosRequestConfig = {}): Promise<BucketWithoutArticles[]> {
    const { brandId, hierarchyNodeIds, productCategoryIds, genders, seasonIds, colors, supplierIds, dropNames, statusIds, tagIds, searchTerm, customFieldOptionIds, createdByUserIds, assignedUserIds, colorGroupIds, outPriceAmounts, outPriceRanges, sizeSystemIds, timelineHealth, nextGateRoleIds, nextGateNames, grouping, descending, tagCategoryId, startBucketKey, centerBucketKey, endBucketKey, activeSeasonId, maximumBackwards, maximumForward, } = args;
    const dropDateRange_From = args.dropDateRange?.from;
    const dropDateRange_To = args.dropDateRange?.to;
    let url_ = this.baseUrl + "/api/overview/{brandId}/buckets/unfiltered?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (hierarchyNodeIds !== undefined && hierarchyNodeIds !== null)
        hierarchyNodeIds && hierarchyNodeIds.forEach(item => { url_ += "HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (productCategoryIds !== undefined && productCategoryIds !== null)
        productCategoryIds && productCategoryIds.forEach(item => { url_ += "ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (genders !== undefined && genders !== null)
        genders && genders.forEach(item => { url_ += "Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colors !== undefined && colors !== null)
        colors && colors.forEach(item => { url_ += "Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (dropDateRange_From !== undefined && dropDateRange_From !== null)
        url_ += "DropDateRange.From=" + encodeURIComponent("" + dropDateRange_From) + "&";
    if (dropDateRange_To !== undefined && dropDateRange_To !== null)
        url_ += "DropDateRange.To=" + encodeURIComponent("" + dropDateRange_To) + "&";
    if (dropNames !== undefined && dropNames !== null)
        dropNames && dropNames.forEach(item => { url_ += "DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (statusIds !== undefined && statusIds !== null)
        statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (customFieldOptionIds !== undefined && customFieldOptionIds !== null)
        url_ += appendDictionaryQuery("CustomFieldOptionIds", customFieldOptionIds);
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (assignedUserIds !== undefined && assignedUserIds !== null)
        assignedUserIds && assignedUserIds.forEach(item => { url_ += "AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colorGroupIds !== undefined && colorGroupIds !== null)
        colorGroupIds && colorGroupIds.forEach(item => { url_ += "ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (outPriceAmounts !== undefined && outPriceAmounts !== null)
        url_ += appendDictionaryQuery("OutPriceAmounts", outPriceAmounts);
    if (outPriceRanges !== undefined && outPriceRanges !== null)
        url_ += appendDictionaryQuery("OutPriceRanges", outPriceRanges);
    if (sizeSystemIds !== undefined && sizeSystemIds !== null)
        sizeSystemIds && sizeSystemIds.forEach(item => { url_ += "SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (timelineHealth !== undefined && timelineHealth !== null)
        timelineHealth && timelineHealth.forEach(item => { url_ += "TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateRoleIds !== undefined && nextGateRoleIds !== null)
        nextGateRoleIds && nextGateRoleIds.forEach(item => { url_ += "NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateNames !== undefined && nextGateNames !== null)
        nextGateNames && nextGateNames.forEach(item => { url_ += "NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (grouping === null)
        throw new Error("The parameter 'grouping' cannot be null.");
    else if (grouping !== undefined)
        url_ += "Grouping=" + encodeURIComponent("" + grouping) + "&";
    if (descending === null)
        throw new Error("The parameter 'descending' cannot be null.");
    else if (descending !== undefined)
        url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
    if (tagCategoryId !== undefined && tagCategoryId !== null)
        url_ += "TagCategoryId=" + encodeURIComponent("" + tagCategoryId) + "&";
    if (startBucketKey !== undefined && startBucketKey !== null)
        url_ += "startBucketKey=" + encodeURIComponent("" + startBucketKey) + "&";
    if (centerBucketKey !== undefined && centerBucketKey !== null)
        url_ += "centerBucketKey=" + encodeURIComponent("" + centerBucketKey) + "&";
    if (endBucketKey !== undefined && endBucketKey !== null)
        url_ += "endBucketKey=" + encodeURIComponent("" + endBucketKey) + "&";
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    if (maximumBackwards === null)
        throw new Error("The parameter 'maximumBackwards' cannot be null.");
    else if (maximumBackwards !== undefined)
        url_ += "maximumBackwards=" + encodeURIComponent("" + maximumBackwards) + "&";
    if (maximumForward === null)
        throw new Error("The parameter 'maximumForward' cannot be null.");
    else if (maximumForward !== undefined)
        url_ += "maximumForward=" + encodeURIComponent("" + maximumForward) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetBucketArticles(args: Overview_GetBucketArticlesArgs, options: AxiosRequestConfig = {}): Promise<BucketWithArticles[]> {
    const { brandId, bucketKeys, destinationId, activeSeasonId, limit, offset, } = args;
    const filters_HierarchyNodeIds = args.filters?.hierarchyNodeIds;
    const filters_ProductCategoryIds = args.filters?.productCategoryIds;
    const filters_Genders = args.filters?.genders;
    const filters_SeasonIds = args.filters?.seasonIds;
    const filters_Colors = args.filters?.colors;
    const filters_SupplierIds = args.filters?.supplierIds;
    const filters_DropDateRange_From = args.filters?.dropDateRange?.from;
    const filters_DropDateRange_To = args.filters?.dropDateRange?.to;
    const filters_DropNames = args.filters?.dropNames;
    const filters_StatusIds = args.filters?.statusIds;
    const filters_TagIds = args.filters?.tagIds;
    const filters_SearchTerm = args.filters?.searchTerm;
    const filters_CustomFieldOptionIds = args.filters?.customFieldOptionIds;
    const filters_CreatedByUserIds = args.filters?.createdByUserIds;
    const filters_AssignedUserIds = args.filters?.assignedUserIds;
    const filters_ColorGroupIds = args.filters?.colorGroupIds;
    const filters_OutPriceAmounts = args.filters?.outPriceAmounts;
    const filters_OutPriceRanges = args.filters?.outPriceRanges;
    const filters_SizeSystemIds = args.filters?.sizeSystemIds;
    const filters_TimelineHealth = args.filters?.timelineHealth;
    const filters_NextGateRoleIds = args.filters?.nextGateRoleIds;
    const filters_NextGateNames = args.filters?.nextGateNames;
    const groupingOptions_Grouping = args.groupingOptions?.grouping;
    const groupingOptions_Descending = args.groupingOptions?.descending;
    const groupingOptions_TagCategoryId = args.groupingOptions?.tagCategoryId;
    const sortingOptions_Sorting = args.sortingOptions?.sorting;
    const sortingOptions_Descending = args.sortingOptions?.descending;
    const sortingOptions_FieldId = args.sortingOptions?.fieldId;
    const sortingOptions_TagCategoryId = args.sortingOptions?.tagCategoryId;
    const sortingOptions_SeasonId = args.sortingOptions?.seasonId;
    const sortingOptions_Today = args.sortingOptions?.today;
    const sortingOptions_DestinationId = args.sortingOptions?.destinationId;
    const sortingOptions_PriceKey = args.sortingOptions?.priceKey;
    let url_ = this.baseUrl + "/api/overview/{brandId}/buckets/articles?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (bucketKeys !== undefined && bucketKeys !== null)
        bucketKeys && bucketKeys.forEach(item => { url_ += "BucketKeys=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_HierarchyNodeIds !== undefined && filters_HierarchyNodeIds !== null)
        filters_HierarchyNodeIds && filters_HierarchyNodeIds.forEach(item => { url_ += "Filters.HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ProductCategoryIds !== undefined && filters_ProductCategoryIds !== null)
        filters_ProductCategoryIds && filters_ProductCategoryIds.forEach(item => { url_ += "Filters.ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_Genders !== undefined && filters_Genders !== null)
        filters_Genders && filters_Genders.forEach(item => { url_ += "Filters.Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SeasonIds !== undefined && filters_SeasonIds !== null)
        filters_SeasonIds && filters_SeasonIds.forEach(item => { url_ += "Filters.SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_Colors !== undefined && filters_Colors !== null)
        filters_Colors && filters_Colors.forEach(item => { url_ += "Filters.Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SupplierIds !== undefined && filters_SupplierIds !== null)
        filters_SupplierIds && filters_SupplierIds.forEach(item => { url_ += "Filters.SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_DropDateRange_From !== undefined && filters_DropDateRange_From !== null)
        url_ += "Filters.DropDateRange.From=" + encodeURIComponent("" + filters_DropDateRange_From) + "&";
    if (filters_DropDateRange_To !== undefined && filters_DropDateRange_To !== null)
        url_ += "Filters.DropDateRange.To=" + encodeURIComponent("" + filters_DropDateRange_To) + "&";
    if (filters_DropNames !== undefined && filters_DropNames !== null)
        filters_DropNames && filters_DropNames.forEach(item => { url_ += "Filters.DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_StatusIds !== undefined && filters_StatusIds !== null)
        filters_StatusIds && filters_StatusIds.forEach(item => { url_ += "Filters.StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TagIds !== undefined && filters_TagIds !== null)
        filters_TagIds && filters_TagIds.forEach(item => { url_ += "Filters.TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SearchTerm !== undefined && filters_SearchTerm !== null)
        url_ += "Filters.SearchTerm=" + encodeURIComponent("" + filters_SearchTerm) + "&";
    if (filters_CustomFieldOptionIds !== undefined && filters_CustomFieldOptionIds !== null)
        url_ += appendDictionaryQuery("Filters.CustomFieldOptionIds", filters_CustomFieldOptionIds);
    if (filters_CreatedByUserIds !== undefined && filters_CreatedByUserIds !== null)
        filters_CreatedByUserIds && filters_CreatedByUserIds.forEach(item => { url_ += "Filters.CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_AssignedUserIds !== undefined && filters_AssignedUserIds !== null)
        filters_AssignedUserIds && filters_AssignedUserIds.forEach(item => { url_ += "Filters.AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ColorGroupIds !== undefined && filters_ColorGroupIds !== null)
        filters_ColorGroupIds && filters_ColorGroupIds.forEach(item => { url_ += "Filters.ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_OutPriceAmounts !== undefined && filters_OutPriceAmounts !== null)
        url_ += appendDictionaryQuery("Filters.OutPriceAmounts", filters_OutPriceAmounts);
    if (filters_OutPriceRanges !== undefined && filters_OutPriceRanges !== null)
        url_ += appendDictionaryQuery("Filters.OutPriceRanges", filters_OutPriceRanges);
    if (filters_SizeSystemIds !== undefined && filters_SizeSystemIds !== null)
        filters_SizeSystemIds && filters_SizeSystemIds.forEach(item => { url_ += "Filters.SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TimelineHealth !== undefined && filters_TimelineHealth !== null)
        filters_TimelineHealth && filters_TimelineHealth.forEach(item => { url_ += "Filters.TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_NextGateRoleIds !== undefined && filters_NextGateRoleIds !== null)
        filters_NextGateRoleIds && filters_NextGateRoleIds.forEach(item => { url_ += "Filters.NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_NextGateNames !== undefined && filters_NextGateNames !== null)
        filters_NextGateNames && filters_NextGateNames.forEach(item => { url_ += "Filters.NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (groupingOptions_Grouping === null)
        throw new Error("The parameter 'groupingOptions_Grouping' cannot be null.");
    else if (groupingOptions_Grouping !== undefined)
        url_ += "GroupingOptions.Grouping=" + encodeURIComponent("" + groupingOptions_Grouping) + "&";
    if (groupingOptions_Descending === null)
        throw new Error("The parameter 'groupingOptions_Descending' cannot be null.");
    else if (groupingOptions_Descending !== undefined)
        url_ += "GroupingOptions.Descending=" + encodeURIComponent("" + groupingOptions_Descending) + "&";
    if (groupingOptions_TagCategoryId !== undefined && groupingOptions_TagCategoryId !== null)
        url_ += "GroupingOptions.TagCategoryId=" + encodeURIComponent("" + groupingOptions_TagCategoryId) + "&";
    if (sortingOptions_Sorting === null)
        throw new Error("The parameter 'sortingOptions_Sorting' cannot be null.");
    else if (sortingOptions_Sorting !== undefined)
        url_ += "SortingOptions.Sorting=" + encodeURIComponent("" + sortingOptions_Sorting) + "&";
    if (sortingOptions_Descending === null)
        throw new Error("The parameter 'sortingOptions_Descending' cannot be null.");
    else if (sortingOptions_Descending !== undefined)
        url_ += "SortingOptions.Descending=" + encodeURIComponent("" + sortingOptions_Descending) + "&";
    if (sortingOptions_FieldId !== undefined && sortingOptions_FieldId !== null)
        url_ += "SortingOptions.FieldId=" + encodeURIComponent("" + sortingOptions_FieldId) + "&";
    if (sortingOptions_TagCategoryId !== undefined && sortingOptions_TagCategoryId !== null)
        url_ += "SortingOptions.TagCategoryId=" + encodeURIComponent("" + sortingOptions_TagCategoryId) + "&";
    if (sortingOptions_SeasonId !== undefined && sortingOptions_SeasonId !== null)
        url_ += "SortingOptions.SeasonId=" + encodeURIComponent("" + sortingOptions_SeasonId) + "&";
    if (sortingOptions_Today !== undefined && sortingOptions_Today !== null)
        url_ += "SortingOptions.Today=" + encodeURIComponent("" + sortingOptions_Today) + "&";
    if (sortingOptions_DestinationId !== undefined && sortingOptions_DestinationId !== null)
        url_ += "SortingOptions.DestinationId=" + encodeURIComponent("" + sortingOptions_DestinationId) + "&";
    if (sortingOptions_PriceKey !== undefined && sortingOptions_PriceKey !== null)
        url_ += "SortingOptions.PriceKey=" + encodeURIComponent("" + sortingOptions_PriceKey) + "&";
    if (destinationId === null)
        throw new Error("The parameter 'destinationId' cannot be null.");
    else if (destinationId !== undefined)
        url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "ActiveSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetUndefinedArticlesCount(args: Overview_GetUndefinedArticlesCountArgs, options: AxiosRequestConfig = {}): Promise<number> {
    const { brandId, hierarchyNodeIds, productCategoryIds, genders, seasonIds, colors, supplierIds, dropNames, statusIds, tagIds, searchTerm, customFieldOptionIds, createdByUserIds, assignedUserIds, colorGroupIds, outPriceAmounts, outPriceRanges, sizeSystemIds, timelineHealth, nextGateRoleIds, nextGateNames, grouping, descending, tagCategoryId, activeSeasonId, } = args;
    const dropDateRange_From = args.dropDateRange?.from;
    const dropDateRange_To = args.dropDateRange?.to;
    let url_ = this.baseUrl + "/api/overview/{brandId}/undefined/articles/count?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (hierarchyNodeIds !== undefined && hierarchyNodeIds !== null)
        hierarchyNodeIds && hierarchyNodeIds.forEach(item => { url_ += "HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (productCategoryIds !== undefined && productCategoryIds !== null)
        productCategoryIds && productCategoryIds.forEach(item => { url_ += "ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (genders !== undefined && genders !== null)
        genders && genders.forEach(item => { url_ += "Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colors !== undefined && colors !== null)
        colors && colors.forEach(item => { url_ += "Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (dropDateRange_From !== undefined && dropDateRange_From !== null)
        url_ += "DropDateRange.From=" + encodeURIComponent("" + dropDateRange_From) + "&";
    if (dropDateRange_To !== undefined && dropDateRange_To !== null)
        url_ += "DropDateRange.To=" + encodeURIComponent("" + dropDateRange_To) + "&";
    if (dropNames !== undefined && dropNames !== null)
        dropNames && dropNames.forEach(item => { url_ += "DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (statusIds !== undefined && statusIds !== null)
        statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (customFieldOptionIds !== undefined && customFieldOptionIds !== null)
        url_ += appendDictionaryQuery("CustomFieldOptionIds", customFieldOptionIds);
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (assignedUserIds !== undefined && assignedUserIds !== null)
        assignedUserIds && assignedUserIds.forEach(item => { url_ += "AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colorGroupIds !== undefined && colorGroupIds !== null)
        colorGroupIds && colorGroupIds.forEach(item => { url_ += "ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (outPriceAmounts !== undefined && outPriceAmounts !== null)
        url_ += appendDictionaryQuery("OutPriceAmounts", outPriceAmounts);
    if (outPriceRanges !== undefined && outPriceRanges !== null)
        url_ += appendDictionaryQuery("OutPriceRanges", outPriceRanges);
    if (sizeSystemIds !== undefined && sizeSystemIds !== null)
        sizeSystemIds && sizeSystemIds.forEach(item => { url_ += "SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (timelineHealth !== undefined && timelineHealth !== null)
        timelineHealth && timelineHealth.forEach(item => { url_ += "TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateRoleIds !== undefined && nextGateRoleIds !== null)
        nextGateRoleIds && nextGateRoleIds.forEach(item => { url_ += "NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateNames !== undefined && nextGateNames !== null)
        nextGateNames && nextGateNames.forEach(item => { url_ += "NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (grouping === null)
        throw new Error("The parameter 'grouping' cannot be null.");
    else if (grouping !== undefined)
        url_ += "Grouping=" + encodeURIComponent("" + grouping) + "&";
    if (descending === null)
        throw new Error("The parameter 'descending' cannot be null.");
    else if (descending !== undefined)
        url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
    if (tagCategoryId !== undefined && tagCategoryId !== null)
        url_ += "TagCategoryId=" + encodeURIComponent("" + tagCategoryId) + "&";
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetUndefinedArticles(args: Overview_GetUndefinedArticlesArgs, options: AxiosRequestConfig = {}): Promise<GetUndefinedArticlesReturn> {
    const { brandId, destinationId, activeSeasonId, limit, offset, } = args;
    const filters_HierarchyNodeIds = args.filters?.hierarchyNodeIds;
    const filters_ProductCategoryIds = args.filters?.productCategoryIds;
    const filters_Genders = args.filters?.genders;
    const filters_SeasonIds = args.filters?.seasonIds;
    const filters_Colors = args.filters?.colors;
    const filters_SupplierIds = args.filters?.supplierIds;
    const filters_DropDateRange_From = args.filters?.dropDateRange?.from;
    const filters_DropDateRange_To = args.filters?.dropDateRange?.to;
    const filters_DropNames = args.filters?.dropNames;
    const filters_StatusIds = args.filters?.statusIds;
    const filters_TagIds = args.filters?.tagIds;
    const filters_SearchTerm = args.filters?.searchTerm;
    const filters_CustomFieldOptionIds = args.filters?.customFieldOptionIds;
    const filters_CreatedByUserIds = args.filters?.createdByUserIds;
    const filters_AssignedUserIds = args.filters?.assignedUserIds;
    const filters_ColorGroupIds = args.filters?.colorGroupIds;
    const filters_OutPriceAmounts = args.filters?.outPriceAmounts;
    const filters_OutPriceRanges = args.filters?.outPriceRanges;
    const filters_SizeSystemIds = args.filters?.sizeSystemIds;
    const filters_TimelineHealth = args.filters?.timelineHealth;
    const filters_NextGateRoleIds = args.filters?.nextGateRoleIds;
    const filters_NextGateNames = args.filters?.nextGateNames;
    const groupingOptions_Grouping = args.groupingOptions?.grouping;
    const groupingOptions_Descending = args.groupingOptions?.descending;
    const groupingOptions_TagCategoryId = args.groupingOptions?.tagCategoryId;
    const sortingOptions_Sorting = args.sortingOptions?.sorting;
    const sortingOptions_Descending = args.sortingOptions?.descending;
    const sortingOptions_FieldId = args.sortingOptions?.fieldId;
    const sortingOptions_TagCategoryId = args.sortingOptions?.tagCategoryId;
    const sortingOptions_SeasonId = args.sortingOptions?.seasonId;
    const sortingOptions_Today = args.sortingOptions?.today;
    const sortingOptions_DestinationId = args.sortingOptions?.destinationId;
    const sortingOptions_PriceKey = args.sortingOptions?.priceKey;
    let url_ = this.baseUrl + "/api/overview/{brandId}/undefined/articles?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (filters_HierarchyNodeIds !== undefined && filters_HierarchyNodeIds !== null)
        filters_HierarchyNodeIds && filters_HierarchyNodeIds.forEach(item => { url_ += "Filters.HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ProductCategoryIds !== undefined && filters_ProductCategoryIds !== null)
        filters_ProductCategoryIds && filters_ProductCategoryIds.forEach(item => { url_ += "Filters.ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_Genders !== undefined && filters_Genders !== null)
        filters_Genders && filters_Genders.forEach(item => { url_ += "Filters.Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SeasonIds !== undefined && filters_SeasonIds !== null)
        filters_SeasonIds && filters_SeasonIds.forEach(item => { url_ += "Filters.SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_Colors !== undefined && filters_Colors !== null)
        filters_Colors && filters_Colors.forEach(item => { url_ += "Filters.Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SupplierIds !== undefined && filters_SupplierIds !== null)
        filters_SupplierIds && filters_SupplierIds.forEach(item => { url_ += "Filters.SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_DropDateRange_From !== undefined && filters_DropDateRange_From !== null)
        url_ += "Filters.DropDateRange.From=" + encodeURIComponent("" + filters_DropDateRange_From) + "&";
    if (filters_DropDateRange_To !== undefined && filters_DropDateRange_To !== null)
        url_ += "Filters.DropDateRange.To=" + encodeURIComponent("" + filters_DropDateRange_To) + "&";
    if (filters_DropNames !== undefined && filters_DropNames !== null)
        filters_DropNames && filters_DropNames.forEach(item => { url_ += "Filters.DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_StatusIds !== undefined && filters_StatusIds !== null)
        filters_StatusIds && filters_StatusIds.forEach(item => { url_ += "Filters.StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TagIds !== undefined && filters_TagIds !== null)
        filters_TagIds && filters_TagIds.forEach(item => { url_ += "Filters.TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SearchTerm !== undefined && filters_SearchTerm !== null)
        url_ += "Filters.SearchTerm=" + encodeURIComponent("" + filters_SearchTerm) + "&";
    if (filters_CustomFieldOptionIds !== undefined && filters_CustomFieldOptionIds !== null)
        url_ += appendDictionaryQuery("Filters.CustomFieldOptionIds", filters_CustomFieldOptionIds);
    if (filters_CreatedByUserIds !== undefined && filters_CreatedByUserIds !== null)
        filters_CreatedByUserIds && filters_CreatedByUserIds.forEach(item => { url_ += "Filters.CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_AssignedUserIds !== undefined && filters_AssignedUserIds !== null)
        filters_AssignedUserIds && filters_AssignedUserIds.forEach(item => { url_ += "Filters.AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ColorGroupIds !== undefined && filters_ColorGroupIds !== null)
        filters_ColorGroupIds && filters_ColorGroupIds.forEach(item => { url_ += "Filters.ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_OutPriceAmounts !== undefined && filters_OutPriceAmounts !== null)
        url_ += appendDictionaryQuery("Filters.OutPriceAmounts", filters_OutPriceAmounts);
    if (filters_OutPriceRanges !== undefined && filters_OutPriceRanges !== null)
        url_ += appendDictionaryQuery("Filters.OutPriceRanges", filters_OutPriceRanges);
    if (filters_SizeSystemIds !== undefined && filters_SizeSystemIds !== null)
        filters_SizeSystemIds && filters_SizeSystemIds.forEach(item => { url_ += "Filters.SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TimelineHealth !== undefined && filters_TimelineHealth !== null)
        filters_TimelineHealth && filters_TimelineHealth.forEach(item => { url_ += "Filters.TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_NextGateRoleIds !== undefined && filters_NextGateRoleIds !== null)
        filters_NextGateRoleIds && filters_NextGateRoleIds.forEach(item => { url_ += "Filters.NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_NextGateNames !== undefined && filters_NextGateNames !== null)
        filters_NextGateNames && filters_NextGateNames.forEach(item => { url_ += "Filters.NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (groupingOptions_Grouping === null)
        throw new Error("The parameter 'groupingOptions_Grouping' cannot be null.");
    else if (groupingOptions_Grouping !== undefined)
        url_ += "GroupingOptions.Grouping=" + encodeURIComponent("" + groupingOptions_Grouping) + "&";
    if (groupingOptions_Descending === null)
        throw new Error("The parameter 'groupingOptions_Descending' cannot be null.");
    else if (groupingOptions_Descending !== undefined)
        url_ += "GroupingOptions.Descending=" + encodeURIComponent("" + groupingOptions_Descending) + "&";
    if (groupingOptions_TagCategoryId !== undefined && groupingOptions_TagCategoryId !== null)
        url_ += "GroupingOptions.TagCategoryId=" + encodeURIComponent("" + groupingOptions_TagCategoryId) + "&";
    if (sortingOptions_Sorting === null)
        throw new Error("The parameter 'sortingOptions_Sorting' cannot be null.");
    else if (sortingOptions_Sorting !== undefined)
        url_ += "SortingOptions.Sorting=" + encodeURIComponent("" + sortingOptions_Sorting) + "&";
    if (sortingOptions_Descending === null)
        throw new Error("The parameter 'sortingOptions_Descending' cannot be null.");
    else if (sortingOptions_Descending !== undefined)
        url_ += "SortingOptions.Descending=" + encodeURIComponent("" + sortingOptions_Descending) + "&";
    if (sortingOptions_FieldId !== undefined && sortingOptions_FieldId !== null)
        url_ += "SortingOptions.FieldId=" + encodeURIComponent("" + sortingOptions_FieldId) + "&";
    if (sortingOptions_TagCategoryId !== undefined && sortingOptions_TagCategoryId !== null)
        url_ += "SortingOptions.TagCategoryId=" + encodeURIComponent("" + sortingOptions_TagCategoryId) + "&";
    if (sortingOptions_SeasonId !== undefined && sortingOptions_SeasonId !== null)
        url_ += "SortingOptions.SeasonId=" + encodeURIComponent("" + sortingOptions_SeasonId) + "&";
    if (sortingOptions_Today !== undefined && sortingOptions_Today !== null)
        url_ += "SortingOptions.Today=" + encodeURIComponent("" + sortingOptions_Today) + "&";
    if (sortingOptions_DestinationId !== undefined && sortingOptions_DestinationId !== null)
        url_ += "SortingOptions.DestinationId=" + encodeURIComponent("" + sortingOptions_DestinationId) + "&";
    if (sortingOptions_PriceKey !== undefined && sortingOptions_PriceKey !== null)
        url_ += "SortingOptions.PriceKey=" + encodeURIComponent("" + sortingOptions_PriceKey) + "&";
    if (destinationId === null)
        throw new Error("The parameter 'destinationId' cannot be null.");
    else if (destinationId !== undefined)
        url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "ActiveSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetUndefinedArticle(args: Overview_GetUndefinedArticleArgs, options: AxiosRequestConfig = {}): Promise<ArticleCardDto> {
    const { brandId, articleId, destinationId, seasonId, hierarchyNodeIds, productCategoryIds, genders, seasonIds, colors, supplierIds, dropNames, statusIds, tagIds, searchTerm, customFieldOptionIds, createdByUserIds, assignedUserIds, colorGroupIds, outPriceAmounts, outPriceRanges, sizeSystemIds, timelineHealth, nextGateRoleIds, nextGateNames, } = args;
    const dropDateRange_From = args.dropDateRange?.from;
    const dropDateRange_To = args.dropDateRange?.to;
    let url_ = this.baseUrl + "/api/overview/{brandId}/undefined/articles/{articleId}?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    if (destinationId === null)
        throw new Error("The parameter 'destinationId' cannot be null.");
    else if (destinationId !== undefined)
        url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
    if (seasonId !== undefined && seasonId !== null)
        url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
    if (hierarchyNodeIds !== undefined && hierarchyNodeIds !== null)
        hierarchyNodeIds && hierarchyNodeIds.forEach(item => { url_ += "HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (productCategoryIds !== undefined && productCategoryIds !== null)
        productCategoryIds && productCategoryIds.forEach(item => { url_ += "ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (genders !== undefined && genders !== null)
        genders && genders.forEach(item => { url_ += "Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colors !== undefined && colors !== null)
        colors && colors.forEach(item => { url_ += "Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (dropDateRange_From !== undefined && dropDateRange_From !== null)
        url_ += "DropDateRange.From=" + encodeURIComponent("" + dropDateRange_From) + "&";
    if (dropDateRange_To !== undefined && dropDateRange_To !== null)
        url_ += "DropDateRange.To=" + encodeURIComponent("" + dropDateRange_To) + "&";
    if (dropNames !== undefined && dropNames !== null)
        dropNames && dropNames.forEach(item => { url_ += "DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (statusIds !== undefined && statusIds !== null)
        statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (customFieldOptionIds !== undefined && customFieldOptionIds !== null)
        url_ += appendDictionaryQuery("CustomFieldOptionIds", customFieldOptionIds);
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (assignedUserIds !== undefined && assignedUserIds !== null)
        assignedUserIds && assignedUserIds.forEach(item => { url_ += "AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colorGroupIds !== undefined && colorGroupIds !== null)
        colorGroupIds && colorGroupIds.forEach(item => { url_ += "ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (outPriceAmounts !== undefined && outPriceAmounts !== null)
        url_ += appendDictionaryQuery("OutPriceAmounts", outPriceAmounts);
    if (outPriceRanges !== undefined && outPriceRanges !== null)
        url_ += appendDictionaryQuery("OutPriceRanges", outPriceRanges);
    if (sizeSystemIds !== undefined && sizeSystemIds !== null)
        sizeSystemIds && sizeSystemIds.forEach(item => { url_ += "SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (timelineHealth !== undefined && timelineHealth !== null)
        timelineHealth && timelineHealth.forEach(item => { url_ += "TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateRoleIds !== undefined && nextGateRoleIds !== null)
        nextGateRoleIds && nextGateRoleIds.forEach(item => { url_ += "NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateNames !== undefined && nextGateNames !== null)
        nextGateNames && nextGateNames.forEach(item => { url_ += "NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetProductWithArticles(args: Overview_GetProductWithArticlesArgs, options: AxiosRequestConfig = {}): Promise<GetProductAndArticlesResponse> {
    const { brandId, grouping, bucketKey, limit, offset, activeSeasonId, } = args;
    let url_ = this.baseUrl + "/api/overview/{brandId}/products-and-articles?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (grouping === null)
        throw new Error("The parameter 'grouping' cannot be null.");
    else if (grouping !== undefined)
        url_ += "grouping=" + encodeURIComponent("" + grouping) + "&";
    if (bucketKey !== undefined && bucketKey !== null)
        url_ += "bucketKey=" + encodeURIComponent("" + bucketKey) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_AddArticlesToBucketInboundDate(brandId: number, args: AddArticlesToBucketArgs, options: AxiosRequestConfig = {}): Promise<AddArticlesToBucketInboundDateResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/buckets/inbound-date/articles";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_RemoveArticlesFromBucketInboundDate(brandId: number, args: RemoveArticlesFromBucketArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/buckets/inbound-date/remove-articles";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Primary article listing: filter, sort and page through a brand's articles. The filters run in SQL, so use this — not a product-by-product walk with product_GetArticlesForProduct — whenever a selection can be expressed as one: `filters.seasonIds`, `filters.supplierIds`, `filters.statusIds`, `filters.colorGroupIds`, `filters.tagIds` and `filters.hierarchyNodeIds` all narrow the set server-side and combine. Feed the ids it returns to article_GetArticles when you need the full article, including per-season supplier cost prices.
 * @param activeSeasonId (optional) 
 * @param filters_HierarchyNodeIds (optional) 
 * @param filters_ProductCategoryIds (optional) 
 * @param filters_Genders (optional) 
 * @param filters_SeasonIds (optional) 
 * @param filters_Colors (optional) 
 * @param filters_SupplierIds (optional) 
 * @param filters_DropDateRange_From (optional) 
 * @param filters_DropDateRange_To (optional) 
 * @param filters_DropNames (optional) 
 * @param filters_StatusIds (optional) 
 * @param filters_TagIds (optional) 
 * @param filters_SearchTerm (optional) 
 * @param filters_CustomFieldOptionIds (optional) 
 * @param filters_CreatedByUserIds (optional) 
 * @param filters_AssignedUserIds (optional) 
 * @param filters_ColorGroupIds (optional) 
 * @param filters_OutPriceAmounts (optional) 
 * @param filters_OutPriceRanges (optional) 
 * @param filters_SizeSystemIds (optional) 
 * @param filters_TimelineHealth (optional) 
 * @param filters_NextGateRoleIds (optional) 
 * @param filters_NextGateNames (optional) 
 * @param sortingOptions_Sorting (optional) 
 * @param sortingOptions_Descending (optional) 
 * @param sortingOptions_FieldId (optional) 
 * @param sortingOptions_TagCategoryId (optional) 
 * @param sortingOptions_SeasonId (optional) 
 * @param sortingOptions_Today (optional) 
 * @param sortingOptions_DestinationId (optional) 
 * @param sortingOptions_PriceKey (optional) 
 * @param reference_Primary (optional) 
 * @param reference_ArticleNumber (optional) 
 * @param reference_NumericPrimary (optional) 
 * @param items (optional) 
 */
  async overview_GetInitialTableArticles(args: Overview_GetInitialTableArticlesArgs, options: AxiosRequestConfig = {}): Promise<TableArticles> {
    const { brandId, activeSeasonId, items, } = args;
    const filters_HierarchyNodeIds = args.filters?.hierarchyNodeIds;
    const filters_ProductCategoryIds = args.filters?.productCategoryIds;
    const filters_Genders = args.filters?.genders;
    const filters_SeasonIds = args.filters?.seasonIds;
    const filters_Colors = args.filters?.colors;
    const filters_SupplierIds = args.filters?.supplierIds;
    const filters_DropDateRange_From = args.filters?.dropDateRange?.from;
    const filters_DropDateRange_To = args.filters?.dropDateRange?.to;
    const filters_DropNames = args.filters?.dropNames;
    const filters_StatusIds = args.filters?.statusIds;
    const filters_TagIds = args.filters?.tagIds;
    const filters_SearchTerm = args.filters?.searchTerm;
    const filters_CustomFieldOptionIds = args.filters?.customFieldOptionIds;
    const filters_CreatedByUserIds = args.filters?.createdByUserIds;
    const filters_AssignedUserIds = args.filters?.assignedUserIds;
    const filters_ColorGroupIds = args.filters?.colorGroupIds;
    const filters_OutPriceAmounts = args.filters?.outPriceAmounts;
    const filters_OutPriceRanges = args.filters?.outPriceRanges;
    const filters_SizeSystemIds = args.filters?.sizeSystemIds;
    const filters_TimelineHealth = args.filters?.timelineHealth;
    const filters_NextGateRoleIds = args.filters?.nextGateRoleIds;
    const filters_NextGateNames = args.filters?.nextGateNames;
    const sortingOptions_Sorting = args.sortingOptions?.sorting;
    const sortingOptions_Descending = args.sortingOptions?.descending;
    const sortingOptions_FieldId = args.sortingOptions?.fieldId;
    const sortingOptions_TagCategoryId = args.sortingOptions?.tagCategoryId;
    const sortingOptions_SeasonId = args.sortingOptions?.seasonId;
    const sortingOptions_Today = args.sortingOptions?.today;
    const sortingOptions_DestinationId = args.sortingOptions?.destinationId;
    const sortingOptions_PriceKey = args.sortingOptions?.priceKey;
    const reference_Primary = args.reference?.primary;
    const reference_ArticleNumber = args.reference?.articleNumber;
    const reference_NumericPrimary = args.reference?.numericPrimary;
    let url_ = this.baseUrl + "/api/overview/{brandId}/table/articles/initial?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    if (filters_HierarchyNodeIds !== undefined && filters_HierarchyNodeIds !== null)
        filters_HierarchyNodeIds && filters_HierarchyNodeIds.forEach(item => { url_ += "Filters.HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ProductCategoryIds !== undefined && filters_ProductCategoryIds !== null)
        filters_ProductCategoryIds && filters_ProductCategoryIds.forEach(item => { url_ += "Filters.ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_Genders !== undefined && filters_Genders !== null)
        filters_Genders && filters_Genders.forEach(item => { url_ += "Filters.Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SeasonIds !== undefined && filters_SeasonIds !== null)
        filters_SeasonIds && filters_SeasonIds.forEach(item => { url_ += "Filters.SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_Colors !== undefined && filters_Colors !== null)
        filters_Colors && filters_Colors.forEach(item => { url_ += "Filters.Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SupplierIds !== undefined && filters_SupplierIds !== null)
        filters_SupplierIds && filters_SupplierIds.forEach(item => { url_ += "Filters.SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_DropDateRange_From !== undefined && filters_DropDateRange_From !== null)
        url_ += "Filters.DropDateRange.From=" + encodeURIComponent("" + filters_DropDateRange_From) + "&";
    if (filters_DropDateRange_To !== undefined && filters_DropDateRange_To !== null)
        url_ += "Filters.DropDateRange.To=" + encodeURIComponent("" + filters_DropDateRange_To) + "&";
    if (filters_DropNames !== undefined && filters_DropNames !== null)
        filters_DropNames && filters_DropNames.forEach(item => { url_ += "Filters.DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_StatusIds !== undefined && filters_StatusIds !== null)
        filters_StatusIds && filters_StatusIds.forEach(item => { url_ += "Filters.StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TagIds !== undefined && filters_TagIds !== null)
        filters_TagIds && filters_TagIds.forEach(item => { url_ += "Filters.TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SearchTerm !== undefined && filters_SearchTerm !== null)
        url_ += "Filters.SearchTerm=" + encodeURIComponent("" + filters_SearchTerm) + "&";
    if (filters_CustomFieldOptionIds !== undefined && filters_CustomFieldOptionIds !== null)
        url_ += appendDictionaryQuery("Filters.CustomFieldOptionIds", filters_CustomFieldOptionIds);
    if (filters_CreatedByUserIds !== undefined && filters_CreatedByUserIds !== null)
        filters_CreatedByUserIds && filters_CreatedByUserIds.forEach(item => { url_ += "Filters.CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_AssignedUserIds !== undefined && filters_AssignedUserIds !== null)
        filters_AssignedUserIds && filters_AssignedUserIds.forEach(item => { url_ += "Filters.AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ColorGroupIds !== undefined && filters_ColorGroupIds !== null)
        filters_ColorGroupIds && filters_ColorGroupIds.forEach(item => { url_ += "Filters.ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_OutPriceAmounts !== undefined && filters_OutPriceAmounts !== null)
        url_ += appendDictionaryQuery("Filters.OutPriceAmounts", filters_OutPriceAmounts);
    if (filters_OutPriceRanges !== undefined && filters_OutPriceRanges !== null)
        url_ += appendDictionaryQuery("Filters.OutPriceRanges", filters_OutPriceRanges);
    if (filters_SizeSystemIds !== undefined && filters_SizeSystemIds !== null)
        filters_SizeSystemIds && filters_SizeSystemIds.forEach(item => { url_ += "Filters.SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TimelineHealth !== undefined && filters_TimelineHealth !== null)
        filters_TimelineHealth && filters_TimelineHealth.forEach(item => { url_ += "Filters.TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_NextGateRoleIds !== undefined && filters_NextGateRoleIds !== null)
        filters_NextGateRoleIds && filters_NextGateRoleIds.forEach(item => { url_ += "Filters.NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_NextGateNames !== undefined && filters_NextGateNames !== null)
        filters_NextGateNames && filters_NextGateNames.forEach(item => { url_ += "Filters.NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (sortingOptions_Sorting === null)
        throw new Error("The parameter 'sortingOptions_Sorting' cannot be null.");
    else if (sortingOptions_Sorting !== undefined)
        url_ += "SortingOptions.Sorting=" + encodeURIComponent("" + sortingOptions_Sorting) + "&";
    if (sortingOptions_Descending === null)
        throw new Error("The parameter 'sortingOptions_Descending' cannot be null.");
    else if (sortingOptions_Descending !== undefined)
        url_ += "SortingOptions.Descending=" + encodeURIComponent("" + sortingOptions_Descending) + "&";
    if (sortingOptions_FieldId !== undefined && sortingOptions_FieldId !== null)
        url_ += "SortingOptions.FieldId=" + encodeURIComponent("" + sortingOptions_FieldId) + "&";
    if (sortingOptions_TagCategoryId !== undefined && sortingOptions_TagCategoryId !== null)
        url_ += "SortingOptions.TagCategoryId=" + encodeURIComponent("" + sortingOptions_TagCategoryId) + "&";
    if (sortingOptions_SeasonId !== undefined && sortingOptions_SeasonId !== null)
        url_ += "SortingOptions.SeasonId=" + encodeURIComponent("" + sortingOptions_SeasonId) + "&";
    if (sortingOptions_Today !== undefined && sortingOptions_Today !== null)
        url_ += "SortingOptions.Today=" + encodeURIComponent("" + sortingOptions_Today) + "&";
    if (sortingOptions_DestinationId !== undefined && sortingOptions_DestinationId !== null)
        url_ += "SortingOptions.DestinationId=" + encodeURIComponent("" + sortingOptions_DestinationId) + "&";
    if (sortingOptions_PriceKey !== undefined && sortingOptions_PriceKey !== null)
        url_ += "SortingOptions.PriceKey=" + encodeURIComponent("" + sortingOptions_PriceKey) + "&";
    if (reference_Primary !== undefined && reference_Primary !== null)
        url_ += "Reference.Primary=" + encodeURIComponent("" + reference_Primary) + "&";
    if (reference_ArticleNumber === null)
        throw new Error("The parameter 'reference_ArticleNumber' cannot be null.");
    else if (reference_ArticleNumber !== undefined)
        url_ += "Reference.ArticleNumber=" + encodeURIComponent("" + reference_ArticleNumber) + "&";
    if (reference_NumericPrimary !== undefined && reference_NumericPrimary !== null)
        url_ += "Reference.NumericPrimary=" + encodeURIComponent("" + reference_NumericPrimary) + "&";
    if (items === null)
        throw new Error("The parameter 'items' cannot be null.");
    else if (items !== undefined)
        url_ += "Items=" + encodeURIComponent("" + items) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Continue an overview_GetInitialTableArticles listing at an offset.
 * @param activeSeasonId (optional) 
 * @param offset (optional) 
 * @param limit (optional) 
 * @param filters_HierarchyNodeIds (optional) 
 * @param filters_ProductCategoryIds (optional) 
 * @param filters_Genders (optional) 
 * @param filters_SeasonIds (optional) 
 * @param filters_Colors (optional) 
 * @param filters_SupplierIds (optional) 
 * @param filters_DropDateRange_From (optional) 
 * @param filters_DropDateRange_To (optional) 
 * @param filters_DropNames (optional) 
 * @param filters_StatusIds (optional) 
 * @param filters_TagIds (optional) 
 * @param filters_SearchTerm (optional) 
 * @param filters_CustomFieldOptionIds (optional) 
 * @param filters_CreatedByUserIds (optional) 
 * @param filters_AssignedUserIds (optional) 
 * @param filters_ColorGroupIds (optional) 
 * @param filters_OutPriceAmounts (optional) 
 * @param filters_OutPriceRanges (optional) 
 * @param filters_SizeSystemIds (optional) 
 * @param filters_TimelineHealth (optional) 
 * @param filters_NextGateRoleIds (optional) 
 * @param filters_NextGateNames (optional) 
 * @param sortingOptions_Sorting (optional) 
 * @param sortingOptions_Descending (optional) 
 * @param sortingOptions_FieldId (optional) 
 * @param sortingOptions_TagCategoryId (optional) 
 * @param sortingOptions_SeasonId (optional) 
 * @param sortingOptions_Today (optional) 
 * @param sortingOptions_DestinationId (optional) 
 * @param sortingOptions_PriceKey (optional) 
 */
  async overview_GetIncrementalTableArticles(args: Overview_GetIncrementalTableArticlesArgs, options: AxiosRequestConfig = {}): Promise<TableArticleDto[]> {
    const { brandId, activeSeasonId, offset, limit, } = args;
    const filters_HierarchyNodeIds = args.filters?.hierarchyNodeIds;
    const filters_ProductCategoryIds = args.filters?.productCategoryIds;
    const filters_Genders = args.filters?.genders;
    const filters_SeasonIds = args.filters?.seasonIds;
    const filters_Colors = args.filters?.colors;
    const filters_SupplierIds = args.filters?.supplierIds;
    const filters_DropDateRange_From = args.filters?.dropDateRange?.from;
    const filters_DropDateRange_To = args.filters?.dropDateRange?.to;
    const filters_DropNames = args.filters?.dropNames;
    const filters_StatusIds = args.filters?.statusIds;
    const filters_TagIds = args.filters?.tagIds;
    const filters_SearchTerm = args.filters?.searchTerm;
    const filters_CustomFieldOptionIds = args.filters?.customFieldOptionIds;
    const filters_CreatedByUserIds = args.filters?.createdByUserIds;
    const filters_AssignedUserIds = args.filters?.assignedUserIds;
    const filters_ColorGroupIds = args.filters?.colorGroupIds;
    const filters_OutPriceAmounts = args.filters?.outPriceAmounts;
    const filters_OutPriceRanges = args.filters?.outPriceRanges;
    const filters_SizeSystemIds = args.filters?.sizeSystemIds;
    const filters_TimelineHealth = args.filters?.timelineHealth;
    const filters_NextGateRoleIds = args.filters?.nextGateRoleIds;
    const filters_NextGateNames = args.filters?.nextGateNames;
    const sortingOptions_Sorting = args.sortingOptions?.sorting;
    const sortingOptions_Descending = args.sortingOptions?.descending;
    const sortingOptions_FieldId = args.sortingOptions?.fieldId;
    const sortingOptions_TagCategoryId = args.sortingOptions?.tagCategoryId;
    const sortingOptions_SeasonId = args.sortingOptions?.seasonId;
    const sortingOptions_Today = args.sortingOptions?.today;
    const sortingOptions_DestinationId = args.sortingOptions?.destinationId;
    const sortingOptions_PriceKey = args.sortingOptions?.priceKey;
    let url_ = this.baseUrl + "/api/overview/{brandId}/table/articles/incremental?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (filters_HierarchyNodeIds !== undefined && filters_HierarchyNodeIds !== null)
        filters_HierarchyNodeIds && filters_HierarchyNodeIds.forEach(item => { url_ += "Filters.HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ProductCategoryIds !== undefined && filters_ProductCategoryIds !== null)
        filters_ProductCategoryIds && filters_ProductCategoryIds.forEach(item => { url_ += "Filters.ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_Genders !== undefined && filters_Genders !== null)
        filters_Genders && filters_Genders.forEach(item => { url_ += "Filters.Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SeasonIds !== undefined && filters_SeasonIds !== null)
        filters_SeasonIds && filters_SeasonIds.forEach(item => { url_ += "Filters.SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_Colors !== undefined && filters_Colors !== null)
        filters_Colors && filters_Colors.forEach(item => { url_ += "Filters.Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SupplierIds !== undefined && filters_SupplierIds !== null)
        filters_SupplierIds && filters_SupplierIds.forEach(item => { url_ += "Filters.SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_DropDateRange_From !== undefined && filters_DropDateRange_From !== null)
        url_ += "Filters.DropDateRange.From=" + encodeURIComponent("" + filters_DropDateRange_From) + "&";
    if (filters_DropDateRange_To !== undefined && filters_DropDateRange_To !== null)
        url_ += "Filters.DropDateRange.To=" + encodeURIComponent("" + filters_DropDateRange_To) + "&";
    if (filters_DropNames !== undefined && filters_DropNames !== null)
        filters_DropNames && filters_DropNames.forEach(item => { url_ += "Filters.DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_StatusIds !== undefined && filters_StatusIds !== null)
        filters_StatusIds && filters_StatusIds.forEach(item => { url_ += "Filters.StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TagIds !== undefined && filters_TagIds !== null)
        filters_TagIds && filters_TagIds.forEach(item => { url_ += "Filters.TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SearchTerm !== undefined && filters_SearchTerm !== null)
        url_ += "Filters.SearchTerm=" + encodeURIComponent("" + filters_SearchTerm) + "&";
    if (filters_CustomFieldOptionIds !== undefined && filters_CustomFieldOptionIds !== null)
        url_ += appendDictionaryQuery("Filters.CustomFieldOptionIds", filters_CustomFieldOptionIds);
    if (filters_CreatedByUserIds !== undefined && filters_CreatedByUserIds !== null)
        filters_CreatedByUserIds && filters_CreatedByUserIds.forEach(item => { url_ += "Filters.CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_AssignedUserIds !== undefined && filters_AssignedUserIds !== null)
        filters_AssignedUserIds && filters_AssignedUserIds.forEach(item => { url_ += "Filters.AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ColorGroupIds !== undefined && filters_ColorGroupIds !== null)
        filters_ColorGroupIds && filters_ColorGroupIds.forEach(item => { url_ += "Filters.ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_OutPriceAmounts !== undefined && filters_OutPriceAmounts !== null)
        url_ += appendDictionaryQuery("Filters.OutPriceAmounts", filters_OutPriceAmounts);
    if (filters_OutPriceRanges !== undefined && filters_OutPriceRanges !== null)
        url_ += appendDictionaryQuery("Filters.OutPriceRanges", filters_OutPriceRanges);
    if (filters_SizeSystemIds !== undefined && filters_SizeSystemIds !== null)
        filters_SizeSystemIds && filters_SizeSystemIds.forEach(item => { url_ += "Filters.SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TimelineHealth !== undefined && filters_TimelineHealth !== null)
        filters_TimelineHealth && filters_TimelineHealth.forEach(item => { url_ += "Filters.TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_NextGateRoleIds !== undefined && filters_NextGateRoleIds !== null)
        filters_NextGateRoleIds && filters_NextGateRoleIds.forEach(item => { url_ += "Filters.NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_NextGateNames !== undefined && filters_NextGateNames !== null)
        filters_NextGateNames && filters_NextGateNames.forEach(item => { url_ += "Filters.NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (sortingOptions_Sorting === null)
        throw new Error("The parameter 'sortingOptions_Sorting' cannot be null.");
    else if (sortingOptions_Sorting !== undefined)
        url_ += "SortingOptions.Sorting=" + encodeURIComponent("" + sortingOptions_Sorting) + "&";
    if (sortingOptions_Descending === null)
        throw new Error("The parameter 'sortingOptions_Descending' cannot be null.");
    else if (sortingOptions_Descending !== undefined)
        url_ += "SortingOptions.Descending=" + encodeURIComponent("" + sortingOptions_Descending) + "&";
    if (sortingOptions_FieldId !== undefined && sortingOptions_FieldId !== null)
        url_ += "SortingOptions.FieldId=" + encodeURIComponent("" + sortingOptions_FieldId) + "&";
    if (sortingOptions_TagCategoryId !== undefined && sortingOptions_TagCategoryId !== null)
        url_ += "SortingOptions.TagCategoryId=" + encodeURIComponent("" + sortingOptions_TagCategoryId) + "&";
    if (sortingOptions_SeasonId !== undefined && sortingOptions_SeasonId !== null)
        url_ += "SortingOptions.SeasonId=" + encodeURIComponent("" + sortingOptions_SeasonId) + "&";
    if (sortingOptions_Today !== undefined && sortingOptions_Today !== null)
        url_ += "SortingOptions.Today=" + encodeURIComponent("" + sortingOptions_Today) + "&";
    if (sortingOptions_DestinationId !== undefined && sortingOptions_DestinationId !== null)
        url_ += "SortingOptions.DestinationId=" + encodeURIComponent("" + sortingOptions_DestinationId) + "&";
    if (sortingOptions_PriceKey !== undefined && sortingOptions_PriceKey !== null)
        url_ += "SortingOptions.PriceKey=" + encodeURIComponent("" + sortingOptions_PriceKey) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The timeline board's season groupings for a filtered set of articles, plus how many articles match no season at all — those have no anchor and so no plan.
 * @param activeSeasonId (optional) 
 * @param filters_HierarchyNodeIds (optional) 
 * @param filters_ProductCategoryIds (optional) 
 * @param filters_Genders (optional) 
 * @param filters_SeasonIds (optional) 
 * @param filters_Colors (optional) 
 * @param filters_SupplierIds (optional) 
 * @param filters_DropDateRange_From (optional) 
 * @param filters_DropDateRange_To (optional) 
 * @param filters_DropNames (optional) 
 * @param filters_StatusIds (optional) 
 * @param filters_TagIds (optional) 
 * @param filters_SearchTerm (optional) 
 * @param filters_CustomFieldOptionIds (optional) 
 * @param filters_CreatedByUserIds (optional) 
 * @param filters_AssignedUserIds (optional) 
 * @param filters_ColorGroupIds (optional) 
 * @param filters_OutPriceAmounts (optional) 
 * @param filters_OutPriceRanges (optional) 
 * @param filters_SizeSystemIds (optional) 
 * @param filters_TimelineHealth (optional) 
 * @param filters_NextGateRoleIds (optional) 
 * @param filters_NextGateNames (optional) 
 */
  async overview_GetTimelineSeasonGroups(args: Overview_GetTimelineSeasonGroupsArgs, options: AxiosRequestConfig = {}): Promise<TimelineSeasonGroupsDto> {
    const { brandId, activeSeasonId, } = args;
    const filters_HierarchyNodeIds = args.filters?.hierarchyNodeIds;
    const filters_ProductCategoryIds = args.filters?.productCategoryIds;
    const filters_Genders = args.filters?.genders;
    const filters_SeasonIds = args.filters?.seasonIds;
    const filters_Colors = args.filters?.colors;
    const filters_SupplierIds = args.filters?.supplierIds;
    const filters_DropDateRange_From = args.filters?.dropDateRange?.from;
    const filters_DropDateRange_To = args.filters?.dropDateRange?.to;
    const filters_DropNames = args.filters?.dropNames;
    const filters_StatusIds = args.filters?.statusIds;
    const filters_TagIds = args.filters?.tagIds;
    const filters_SearchTerm = args.filters?.searchTerm;
    const filters_CustomFieldOptionIds = args.filters?.customFieldOptionIds;
    const filters_CreatedByUserIds = args.filters?.createdByUserIds;
    const filters_AssignedUserIds = args.filters?.assignedUserIds;
    const filters_ColorGroupIds = args.filters?.colorGroupIds;
    const filters_OutPriceAmounts = args.filters?.outPriceAmounts;
    const filters_OutPriceRanges = args.filters?.outPriceRanges;
    const filters_SizeSystemIds = args.filters?.sizeSystemIds;
    const filters_TimelineHealth = args.filters?.timelineHealth;
    const filters_NextGateRoleIds = args.filters?.nextGateRoleIds;
    const filters_NextGateNames = args.filters?.nextGateNames;
    let url_ = this.baseUrl + "/api/overview/{brandId}/timeline/seasons?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    if (filters_HierarchyNodeIds !== undefined && filters_HierarchyNodeIds !== null)
        filters_HierarchyNodeIds && filters_HierarchyNodeIds.forEach(item => { url_ += "Filters.HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ProductCategoryIds !== undefined && filters_ProductCategoryIds !== null)
        filters_ProductCategoryIds && filters_ProductCategoryIds.forEach(item => { url_ += "Filters.ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_Genders !== undefined && filters_Genders !== null)
        filters_Genders && filters_Genders.forEach(item => { url_ += "Filters.Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SeasonIds !== undefined && filters_SeasonIds !== null)
        filters_SeasonIds && filters_SeasonIds.forEach(item => { url_ += "Filters.SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_Colors !== undefined && filters_Colors !== null)
        filters_Colors && filters_Colors.forEach(item => { url_ += "Filters.Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SupplierIds !== undefined && filters_SupplierIds !== null)
        filters_SupplierIds && filters_SupplierIds.forEach(item => { url_ += "Filters.SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_DropDateRange_From !== undefined && filters_DropDateRange_From !== null)
        url_ += "Filters.DropDateRange.From=" + encodeURIComponent("" + filters_DropDateRange_From) + "&";
    if (filters_DropDateRange_To !== undefined && filters_DropDateRange_To !== null)
        url_ += "Filters.DropDateRange.To=" + encodeURIComponent("" + filters_DropDateRange_To) + "&";
    if (filters_DropNames !== undefined && filters_DropNames !== null)
        filters_DropNames && filters_DropNames.forEach(item => { url_ += "Filters.DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_StatusIds !== undefined && filters_StatusIds !== null)
        filters_StatusIds && filters_StatusIds.forEach(item => { url_ += "Filters.StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TagIds !== undefined && filters_TagIds !== null)
        filters_TagIds && filters_TagIds.forEach(item => { url_ += "Filters.TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SearchTerm !== undefined && filters_SearchTerm !== null)
        url_ += "Filters.SearchTerm=" + encodeURIComponent("" + filters_SearchTerm) + "&";
    if (filters_CustomFieldOptionIds !== undefined && filters_CustomFieldOptionIds !== null)
        url_ += appendDictionaryQuery("Filters.CustomFieldOptionIds", filters_CustomFieldOptionIds);
    if (filters_CreatedByUserIds !== undefined && filters_CreatedByUserIds !== null)
        filters_CreatedByUserIds && filters_CreatedByUserIds.forEach(item => { url_ += "Filters.CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_AssignedUserIds !== undefined && filters_AssignedUserIds !== null)
        filters_AssignedUserIds && filters_AssignedUserIds.forEach(item => { url_ += "Filters.AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ColorGroupIds !== undefined && filters_ColorGroupIds !== null)
        filters_ColorGroupIds && filters_ColorGroupIds.forEach(item => { url_ += "Filters.ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_OutPriceAmounts !== undefined && filters_OutPriceAmounts !== null)
        url_ += appendDictionaryQuery("Filters.OutPriceAmounts", filters_OutPriceAmounts);
    if (filters_OutPriceRanges !== undefined && filters_OutPriceRanges !== null)
        url_ += appendDictionaryQuery("Filters.OutPriceRanges", filters_OutPriceRanges);
    if (filters_SizeSystemIds !== undefined && filters_SizeSystemIds !== null)
        filters_SizeSystemIds && filters_SizeSystemIds.forEach(item => { url_ += "Filters.SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TimelineHealth !== undefined && filters_TimelineHealth !== null)
        filters_TimelineHealth && filters_TimelineHealth.forEach(item => { url_ += "Filters.TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_NextGateRoleIds !== undefined && filters_NextGateRoleIds !== null)
        filters_NextGateRoleIds && filters_NextGateRoleIds.forEach(item => { url_ += "Filters.NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_NextGateNames !== undefined && filters_NextGateNames !== null)
        filters_NextGateNames && filters_NextGateNames.forEach(item => { url_ += "Filters.NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetTableArticleIds(args: Overview_GetTableArticleIdsArgs, options: AxiosRequestConfig = {}): Promise<number[]> {
    const { brandId, activeSeasonId, offset, limit, } = args;
    const filters_HierarchyNodeIds = args.filters?.hierarchyNodeIds;
    const filters_ProductCategoryIds = args.filters?.productCategoryIds;
    const filters_Genders = args.filters?.genders;
    const filters_SeasonIds = args.filters?.seasonIds;
    const filters_Colors = args.filters?.colors;
    const filters_SupplierIds = args.filters?.supplierIds;
    const filters_DropDateRange_From = args.filters?.dropDateRange?.from;
    const filters_DropDateRange_To = args.filters?.dropDateRange?.to;
    const filters_DropNames = args.filters?.dropNames;
    const filters_StatusIds = args.filters?.statusIds;
    const filters_TagIds = args.filters?.tagIds;
    const filters_SearchTerm = args.filters?.searchTerm;
    const filters_CustomFieldOptionIds = args.filters?.customFieldOptionIds;
    const filters_CreatedByUserIds = args.filters?.createdByUserIds;
    const filters_AssignedUserIds = args.filters?.assignedUserIds;
    const filters_ColorGroupIds = args.filters?.colorGroupIds;
    const filters_OutPriceAmounts = args.filters?.outPriceAmounts;
    const filters_OutPriceRanges = args.filters?.outPriceRanges;
    const filters_SizeSystemIds = args.filters?.sizeSystemIds;
    const filters_TimelineHealth = args.filters?.timelineHealth;
    const filters_NextGateRoleIds = args.filters?.nextGateRoleIds;
    const filters_NextGateNames = args.filters?.nextGateNames;
    const sortingOptions_Sorting = args.sortingOptions?.sorting;
    const sortingOptions_Descending = args.sortingOptions?.descending;
    const sortingOptions_FieldId = args.sortingOptions?.fieldId;
    const sortingOptions_TagCategoryId = args.sortingOptions?.tagCategoryId;
    const sortingOptions_SeasonId = args.sortingOptions?.seasonId;
    const sortingOptions_Today = args.sortingOptions?.today;
    const sortingOptions_DestinationId = args.sortingOptions?.destinationId;
    const sortingOptions_PriceKey = args.sortingOptions?.priceKey;
    let url_ = this.baseUrl + "/api/overview/{brandId}/table/articles/ids?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (filters_HierarchyNodeIds !== undefined && filters_HierarchyNodeIds !== null)
        filters_HierarchyNodeIds && filters_HierarchyNodeIds.forEach(item => { url_ += "Filters.HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ProductCategoryIds !== undefined && filters_ProductCategoryIds !== null)
        filters_ProductCategoryIds && filters_ProductCategoryIds.forEach(item => { url_ += "Filters.ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_Genders !== undefined && filters_Genders !== null)
        filters_Genders && filters_Genders.forEach(item => { url_ += "Filters.Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SeasonIds !== undefined && filters_SeasonIds !== null)
        filters_SeasonIds && filters_SeasonIds.forEach(item => { url_ += "Filters.SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_Colors !== undefined && filters_Colors !== null)
        filters_Colors && filters_Colors.forEach(item => { url_ += "Filters.Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SupplierIds !== undefined && filters_SupplierIds !== null)
        filters_SupplierIds && filters_SupplierIds.forEach(item => { url_ += "Filters.SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_DropDateRange_From !== undefined && filters_DropDateRange_From !== null)
        url_ += "Filters.DropDateRange.From=" + encodeURIComponent("" + filters_DropDateRange_From) + "&";
    if (filters_DropDateRange_To !== undefined && filters_DropDateRange_To !== null)
        url_ += "Filters.DropDateRange.To=" + encodeURIComponent("" + filters_DropDateRange_To) + "&";
    if (filters_DropNames !== undefined && filters_DropNames !== null)
        filters_DropNames && filters_DropNames.forEach(item => { url_ += "Filters.DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_StatusIds !== undefined && filters_StatusIds !== null)
        filters_StatusIds && filters_StatusIds.forEach(item => { url_ += "Filters.StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TagIds !== undefined && filters_TagIds !== null)
        filters_TagIds && filters_TagIds.forEach(item => { url_ += "Filters.TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_SearchTerm !== undefined && filters_SearchTerm !== null)
        url_ += "Filters.SearchTerm=" + encodeURIComponent("" + filters_SearchTerm) + "&";
    if (filters_CustomFieldOptionIds !== undefined && filters_CustomFieldOptionIds !== null)
        url_ += appendDictionaryQuery("Filters.CustomFieldOptionIds", filters_CustomFieldOptionIds);
    if (filters_CreatedByUserIds !== undefined && filters_CreatedByUserIds !== null)
        filters_CreatedByUserIds && filters_CreatedByUserIds.forEach(item => { url_ += "Filters.CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_AssignedUserIds !== undefined && filters_AssignedUserIds !== null)
        filters_AssignedUserIds && filters_AssignedUserIds.forEach(item => { url_ += "Filters.AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_ColorGroupIds !== undefined && filters_ColorGroupIds !== null)
        filters_ColorGroupIds && filters_ColorGroupIds.forEach(item => { url_ += "Filters.ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_OutPriceAmounts !== undefined && filters_OutPriceAmounts !== null)
        url_ += appendDictionaryQuery("Filters.OutPriceAmounts", filters_OutPriceAmounts);
    if (filters_OutPriceRanges !== undefined && filters_OutPriceRanges !== null)
        url_ += appendDictionaryQuery("Filters.OutPriceRanges", filters_OutPriceRanges);
    if (filters_SizeSystemIds !== undefined && filters_SizeSystemIds !== null)
        filters_SizeSystemIds && filters_SizeSystemIds.forEach(item => { url_ += "Filters.SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_TimelineHealth !== undefined && filters_TimelineHealth !== null)
        filters_TimelineHealth && filters_TimelineHealth.forEach(item => { url_ += "Filters.TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_NextGateRoleIds !== undefined && filters_NextGateRoleIds !== null)
        filters_NextGateRoleIds && filters_NextGateRoleIds.forEach(item => { url_ += "Filters.NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (filters_NextGateNames !== undefined && filters_NextGateNames !== null)
        filters_NextGateNames && filters_NextGateNames.forEach(item => { url_ += "Filters.NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (sortingOptions_Sorting === null)
        throw new Error("The parameter 'sortingOptions_Sorting' cannot be null.");
    else if (sortingOptions_Sorting !== undefined)
        url_ += "SortingOptions.Sorting=" + encodeURIComponent("" + sortingOptions_Sorting) + "&";
    if (sortingOptions_Descending === null)
        throw new Error("The parameter 'sortingOptions_Descending' cannot be null.");
    else if (sortingOptions_Descending !== undefined)
        url_ += "SortingOptions.Descending=" + encodeURIComponent("" + sortingOptions_Descending) + "&";
    if (sortingOptions_FieldId !== undefined && sortingOptions_FieldId !== null)
        url_ += "SortingOptions.FieldId=" + encodeURIComponent("" + sortingOptions_FieldId) + "&";
    if (sortingOptions_TagCategoryId !== undefined && sortingOptions_TagCategoryId !== null)
        url_ += "SortingOptions.TagCategoryId=" + encodeURIComponent("" + sortingOptions_TagCategoryId) + "&";
    if (sortingOptions_SeasonId !== undefined && sortingOptions_SeasonId !== null)
        url_ += "SortingOptions.SeasonId=" + encodeURIComponent("" + sortingOptions_SeasonId) + "&";
    if (sortingOptions_Today !== undefined && sortingOptions_Today !== null)
        url_ += "SortingOptions.Today=" + encodeURIComponent("" + sortingOptions_Today) + "&";
    if (sortingOptions_DestinationId !== undefined && sortingOptions_DestinationId !== null)
        url_ += "SortingOptions.DestinationId=" + encodeURIComponent("" + sortingOptions_DestinationId) + "&";
    if (sortingOptions_PriceKey !== undefined && sortingOptions_PriceKey !== null)
        url_ += "SortingOptions.PriceKey=" + encodeURIComponent("" + sortingOptions_PriceKey) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read one article as an overview table row (flattened, matches what the UI shows).
 * @param activeSeasonId (optional) 
 */
  async overview_GetTableArticle(brandId: number, articleId: number, activeSeasonId: number | null | undefined, options: AxiosRequestConfig = {}): Promise<TableArticleDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/table/articles/{articleId}?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetTableArticles(brandId: number, activeSeasonId: number | null | undefined, articleIds: number[], options: AxiosRequestConfig = {}): Promise<TableArticleDto[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/table/articles/batch?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = articleIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetColors(brandId: number, options: AxiosRequestConfig = {}): Promise<FiltersColor[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/filters/colors";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The raw facts behind the filter panel's histogram sliders. See
GetFilterFacets.
 */
  async overview_GetFilterFacets(brandId: number, args: FilterFacetsArgs, options: AxiosRequestConfig = {}): Promise<FilterFacets> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/filters/facets";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_CountArticlesForRangePlanExport(brandId: number, args: RangePlanExportArgs, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/range-plan/count";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_StartRangePlanExport(brandId: number, args: RangePlanExportArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/range-plan/start-export";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetExcelFileForFilteredArticles(brandId: number, args: ArticleExcelExportArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/excelfile";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetExcelFileForFilteredSkus(brandId: number, args: SkuExcelExportArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/export-skus";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GenerateJsonFileForFilteredArticles(args: Overview_GenerateJsonFileForFilteredArticlesArgs, options: AxiosRequestConfig = {}): Promise<void> {
    const { brandId, hierarchyNodeIds, productCategoryIds, genders, seasonIds, colors, supplierIds, dropNames, statusIds, tagIds, searchTerm, customFieldOptionIds, createdByUserIds, assignedUserIds, colorGroupIds, outPriceAmounts, outPriceRanges, sizeSystemIds, timelineHealth, nextGateRoleIds, nextGateNames, isAllSelected, selectedIds, excludedIds, activeSeasonId, } = args;
    const dropDateRange_From = args.dropDateRange?.from;
    const dropDateRange_To = args.dropDateRange?.to;
    let url_ = this.baseUrl + "/api/overview/{brandId}/jsonfile?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (hierarchyNodeIds !== undefined && hierarchyNodeIds !== null)
        hierarchyNodeIds && hierarchyNodeIds.forEach(item => { url_ += "HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (productCategoryIds !== undefined && productCategoryIds !== null)
        productCategoryIds && productCategoryIds.forEach(item => { url_ += "ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (genders !== undefined && genders !== null)
        genders && genders.forEach(item => { url_ += "Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colors !== undefined && colors !== null)
        colors && colors.forEach(item => { url_ += "Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (dropDateRange_From !== undefined && dropDateRange_From !== null)
        url_ += "DropDateRange.From=" + encodeURIComponent("" + dropDateRange_From) + "&";
    if (dropDateRange_To !== undefined && dropDateRange_To !== null)
        url_ += "DropDateRange.To=" + encodeURIComponent("" + dropDateRange_To) + "&";
    if (dropNames !== undefined && dropNames !== null)
        dropNames && dropNames.forEach(item => { url_ += "DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (statusIds !== undefined && statusIds !== null)
        statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (customFieldOptionIds !== undefined && customFieldOptionIds !== null)
        url_ += appendDictionaryQuery("CustomFieldOptionIds", customFieldOptionIds);
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (assignedUserIds !== undefined && assignedUserIds !== null)
        assignedUserIds && assignedUserIds.forEach(item => { url_ += "AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colorGroupIds !== undefined && colorGroupIds !== null)
        colorGroupIds && colorGroupIds.forEach(item => { url_ += "ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (outPriceAmounts !== undefined && outPriceAmounts !== null)
        url_ += appendDictionaryQuery("OutPriceAmounts", outPriceAmounts);
    if (outPriceRanges !== undefined && outPriceRanges !== null)
        url_ += appendDictionaryQuery("OutPriceRanges", outPriceRanges);
    if (sizeSystemIds !== undefined && sizeSystemIds !== null)
        sizeSystemIds && sizeSystemIds.forEach(item => { url_ += "SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (timelineHealth !== undefined && timelineHealth !== null)
        timelineHealth && timelineHealth.forEach(item => { url_ += "TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateRoleIds !== undefined && nextGateRoleIds !== null)
        nextGateRoleIds && nextGateRoleIds.forEach(item => { url_ += "NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateNames !== undefined && nextGateNames !== null)
        nextGateNames && nextGateNames.forEach(item => { url_ += "NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (isAllSelected === null)
        throw new Error("The parameter 'isAllSelected' cannot be null.");
    else if (isAllSelected !== undefined)
        url_ += "IsAllSelected=" + encodeURIComponent("" + isAllSelected) + "&";
    if (selectedIds !== undefined && selectedIds !== null)
        selectedIds && selectedIds.forEach(item => { url_ += "SelectedIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (excludedIds !== undefined && excludedIds !== null)
        excludedIds && excludedIds.forEach(item => { url_ += "ExcludedIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetSamplesExportForFilteredArticles(args: Overview_GetSamplesExportForFilteredArticlesArgs, options: AxiosRequestConfig = {}): Promise<void> {
    const { brandId, hierarchyNodeIds, productCategoryIds, genders, seasonIds, colors, supplierIds, dropNames, statusIds, tagIds, searchTerm, customFieldOptionIds, createdByUserIds, assignedUserIds, colorGroupIds, outPriceAmounts, outPriceRanges, sizeSystemIds, timelineHealth, nextGateRoleIds, nextGateNames, isAllSelected, selectedIds, excludedIds, activeSeasonId, } = args;
    const dropDateRange_From = args.dropDateRange?.from;
    const dropDateRange_To = args.dropDateRange?.to;
    let url_ = this.baseUrl + "/api/overview/{brandId}/export-samples?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (hierarchyNodeIds !== undefined && hierarchyNodeIds !== null)
        hierarchyNodeIds && hierarchyNodeIds.forEach(item => { url_ += "HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (productCategoryIds !== undefined && productCategoryIds !== null)
        productCategoryIds && productCategoryIds.forEach(item => { url_ += "ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (genders !== undefined && genders !== null)
        genders && genders.forEach(item => { url_ += "Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colors !== undefined && colors !== null)
        colors && colors.forEach(item => { url_ += "Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (dropDateRange_From !== undefined && dropDateRange_From !== null)
        url_ += "DropDateRange.From=" + encodeURIComponent("" + dropDateRange_From) + "&";
    if (dropDateRange_To !== undefined && dropDateRange_To !== null)
        url_ += "DropDateRange.To=" + encodeURIComponent("" + dropDateRange_To) + "&";
    if (dropNames !== undefined && dropNames !== null)
        dropNames && dropNames.forEach(item => { url_ += "DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (statusIds !== undefined && statusIds !== null)
        statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (customFieldOptionIds !== undefined && customFieldOptionIds !== null)
        url_ += appendDictionaryQuery("CustomFieldOptionIds", customFieldOptionIds);
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (assignedUserIds !== undefined && assignedUserIds !== null)
        assignedUserIds && assignedUserIds.forEach(item => { url_ += "AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colorGroupIds !== undefined && colorGroupIds !== null)
        colorGroupIds && colorGroupIds.forEach(item => { url_ += "ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (outPriceAmounts !== undefined && outPriceAmounts !== null)
        url_ += appendDictionaryQuery("OutPriceAmounts", outPriceAmounts);
    if (outPriceRanges !== undefined && outPriceRanges !== null)
        url_ += appendDictionaryQuery("OutPriceRanges", outPriceRanges);
    if (sizeSystemIds !== undefined && sizeSystemIds !== null)
        sizeSystemIds && sizeSystemIds.forEach(item => { url_ += "SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (timelineHealth !== undefined && timelineHealth !== null)
        timelineHealth && timelineHealth.forEach(item => { url_ += "TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateRoleIds !== undefined && nextGateRoleIds !== null)
        nextGateRoleIds && nextGateRoleIds.forEach(item => { url_ += "NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateNames !== undefined && nextGateNames !== null)
        nextGateNames && nextGateNames.forEach(item => { url_ += "NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (isAllSelected === null)
        throw new Error("The parameter 'isAllSelected' cannot be null.");
    else if (isAllSelected !== undefined)
        url_ += "IsAllSelected=" + encodeURIComponent("" + isAllSelected) + "&";
    if (selectedIds !== undefined && selectedIds !== null)
        selectedIds && selectedIds.forEach(item => { url_ += "SelectedIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (excludedIds !== undefined && excludedIds !== null)
        excludedIds && excludedIds.forEach(item => { url_ += "ExcludedIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_ExportBoms(args: Overview_ExportBomsArgs, options: AxiosRequestConfig = {}): Promise<void> {
    const { brandId, hierarchyNodeIds, productCategoryIds, genders, seasonIds, colors, supplierIds, dropNames, statusIds, tagIds, searchTerm, customFieldOptionIds, createdByUserIds, assignedUserIds, colorGroupIds, outPriceAmounts, outPriceRanges, sizeSystemIds, timelineHealth, nextGateRoleIds, nextGateNames, isAllSelected, selectedIds, excludedIds, activeSeasonId, } = args;
    const dropDateRange_From = args.dropDateRange?.from;
    const dropDateRange_To = args.dropDateRange?.to;
    let url_ = this.baseUrl + "/api/overview/{brandId}/export-boms?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (hierarchyNodeIds !== undefined && hierarchyNodeIds !== null)
        hierarchyNodeIds && hierarchyNodeIds.forEach(item => { url_ += "HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (productCategoryIds !== undefined && productCategoryIds !== null)
        productCategoryIds && productCategoryIds.forEach(item => { url_ += "ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (genders !== undefined && genders !== null)
        genders && genders.forEach(item => { url_ += "Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colors !== undefined && colors !== null)
        colors && colors.forEach(item => { url_ += "Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (dropDateRange_From !== undefined && dropDateRange_From !== null)
        url_ += "DropDateRange.From=" + encodeURIComponent("" + dropDateRange_From) + "&";
    if (dropDateRange_To !== undefined && dropDateRange_To !== null)
        url_ += "DropDateRange.To=" + encodeURIComponent("" + dropDateRange_To) + "&";
    if (dropNames !== undefined && dropNames !== null)
        dropNames && dropNames.forEach(item => { url_ += "DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (statusIds !== undefined && statusIds !== null)
        statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (customFieldOptionIds !== undefined && customFieldOptionIds !== null)
        url_ += appendDictionaryQuery("CustomFieldOptionIds", customFieldOptionIds);
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (assignedUserIds !== undefined && assignedUserIds !== null)
        assignedUserIds && assignedUserIds.forEach(item => { url_ += "AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colorGroupIds !== undefined && colorGroupIds !== null)
        colorGroupIds && colorGroupIds.forEach(item => { url_ += "ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (outPriceAmounts !== undefined && outPriceAmounts !== null)
        url_ += appendDictionaryQuery("OutPriceAmounts", outPriceAmounts);
    if (outPriceRanges !== undefined && outPriceRanges !== null)
        url_ += appendDictionaryQuery("OutPriceRanges", outPriceRanges);
    if (sizeSystemIds !== undefined && sizeSystemIds !== null)
        sizeSystemIds && sizeSystemIds.forEach(item => { url_ += "SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (timelineHealth !== undefined && timelineHealth !== null)
        timelineHealth && timelineHealth.forEach(item => { url_ += "TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateRoleIds !== undefined && nextGateRoleIds !== null)
        nextGateRoleIds && nextGateRoleIds.forEach(item => { url_ += "NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateNames !== undefined && nextGateNames !== null)
        nextGateNames && nextGateNames.forEach(item => { url_ += "NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (isAllSelected === null)
        throw new Error("The parameter 'isAllSelected' cannot be null.");
    else if (isAllSelected !== undefined)
        url_ += "IsAllSelected=" + encodeURIComponent("" + isAllSelected) + "&";
    if (selectedIds !== undefined && selectedIds !== null)
        selectedIds && selectedIds.forEach(item => { url_ += "SelectedIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (excludedIds !== undefined && excludedIds !== null)
        excludedIds && excludedIds.forEach(item => { url_ += "ExcludedIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_RunLabelManagerAction(brandId: number, args: RunLabelManagerActionArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/label-manager-action";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetCustomExportOptions(brandId: number, options: AxiosRequestConfig = {}): Promise<OverviewCustomExportOption[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/custom-exports";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetCustomExportForFilteredArticles(args: Overview_GetCustomExportForFilteredArticlesArgs, options: AxiosRequestConfig = {}): Promise<void> {
    const { brandId, exportType, activeSeasonId, hierarchyNodeIds, productCategoryIds, genders, seasonIds, colors, supplierIds, dropNames, statusIds, tagIds, searchTerm, customFieldOptionIds, createdByUserIds, assignedUserIds, colorGroupIds, outPriceAmounts, outPriceRanges, sizeSystemIds, timelineHealth, nextGateRoleIds, nextGateNames, isAllSelected, selectedIds, excludedIds, } = args;
    const dropDateRange_From = args.dropDateRange?.from;
    const dropDateRange_To = args.dropDateRange?.to;
    let url_ = this.baseUrl + "/api/overview/{brandId}/custom-exports/{exportType}?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (exportType === undefined || exportType === null)
        throw new Error("The parameter 'exportType' must be defined.");
    url_ = url_.replace("{exportType}", encodeURIComponent("" + exportType));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    if (hierarchyNodeIds !== undefined && hierarchyNodeIds !== null)
        hierarchyNodeIds && hierarchyNodeIds.forEach(item => { url_ += "HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (productCategoryIds !== undefined && productCategoryIds !== null)
        productCategoryIds && productCategoryIds.forEach(item => { url_ += "ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (genders !== undefined && genders !== null)
        genders && genders.forEach(item => { url_ += "Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colors !== undefined && colors !== null)
        colors && colors.forEach(item => { url_ += "Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (dropDateRange_From !== undefined && dropDateRange_From !== null)
        url_ += "DropDateRange.From=" + encodeURIComponent("" + dropDateRange_From) + "&";
    if (dropDateRange_To !== undefined && dropDateRange_To !== null)
        url_ += "DropDateRange.To=" + encodeURIComponent("" + dropDateRange_To) + "&";
    if (dropNames !== undefined && dropNames !== null)
        dropNames && dropNames.forEach(item => { url_ += "DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (statusIds !== undefined && statusIds !== null)
        statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (customFieldOptionIds !== undefined && customFieldOptionIds !== null)
        url_ += appendDictionaryQuery("CustomFieldOptionIds", customFieldOptionIds);
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (assignedUserIds !== undefined && assignedUserIds !== null)
        assignedUserIds && assignedUserIds.forEach(item => { url_ += "AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colorGroupIds !== undefined && colorGroupIds !== null)
        colorGroupIds && colorGroupIds.forEach(item => { url_ += "ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (outPriceAmounts !== undefined && outPriceAmounts !== null)
        url_ += appendDictionaryQuery("OutPriceAmounts", outPriceAmounts);
    if (outPriceRanges !== undefined && outPriceRanges !== null)
        url_ += appendDictionaryQuery("OutPriceRanges", outPriceRanges);
    if (sizeSystemIds !== undefined && sizeSystemIds !== null)
        sizeSystemIds && sizeSystemIds.forEach(item => { url_ += "SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (timelineHealth !== undefined && timelineHealth !== null)
        timelineHealth && timelineHealth.forEach(item => { url_ += "TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateRoleIds !== undefined && nextGateRoleIds !== null)
        nextGateRoleIds && nextGateRoleIds.forEach(item => { url_ += "NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateNames !== undefined && nextGateNames !== null)
        nextGateNames && nextGateNames.forEach(item => { url_ += "NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (isAllSelected === null)
        throw new Error("The parameter 'isAllSelected' cannot be null.");
    else if (isAllSelected !== undefined)
        url_ += "IsAllSelected=" + encodeURIComponent("" + isAllSelected) + "&";
    if (selectedIds !== undefined && selectedIds !== null)
        selectedIds && selectedIds.forEach(item => { url_ += "SelectedIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (excludedIds !== undefined && excludedIds !== null)
        excludedIds && excludedIds.forEach(item => { url_ += "ExcludedIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditProductIds(brandId: number, activeSeasonId: number | null | undefined, args: GetProductIdsArgs, options: AxiosRequestConfig = {}): Promise<number[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/selected-product-ids?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set product name across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_MassEditName(brandId: number, args: MassEditNameArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/name";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_MassEditStatus(brandId: number, statusId: number, args: MassEditArgs, options: AxiosRequestConfig = {}): Promise<ApiResponseOfMassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/status/{statusId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (statusId === undefined || statusId === null)
        throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview current statuses across a selection before mass-editing. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 * @param activeSeasonId (optional) 
 */
  async overview_GetMassEditStatuses(brandId: number, activeSeasonId: number | null | undefined, args: GetMassEditArticleStatusesArgs, options: AxiosRequestConfig = {}): Promise<MassEditEntityStatus[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-article-statuses?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Sets the colour group of the colours held by the selected articles. A colour is shared, so every other article, component and BOM connection using one of those colours moves with it — not only the selection. Articles without a colour are skipped. Pin the selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true takes the entire filtered set.
 */
  async overview_MassEditColorGroup(brandId: number, colorGroupId: number, args: MassEditArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/color-group/{colorGroupId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (colorGroupId === undefined || colorGroupId === null)
        throw new Error("The parameter 'colorGroupId' must be defined.");
    url_ = url_.replace("{colorGroupId}", encodeURIComponent("" + colorGroupId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditColorGroups(brandId: number, activeSeasonId: number | null | undefined, args: GetMassEditColorGroupsArgs, options: AxiosRequestConfig = {}): Promise<MassEditEntityColorGroup[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-article-color-groups?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview current tags across a selection before mass-editing. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 * @param activeSeasonId (optional) 
 */
  async overview_GetMassEditTagUsage(brandId: number, activeSeasonId: number | null | undefined, args: GetMassEditTagUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditTagUsageDto[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-tags-usage?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_MassEditTags(brandId: number, args: MassEditTagsArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview current seasons across a selection before mass-editing. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 * @param activeSeasonId (optional) 
 */
  async overview_GetMassEditSeasonUsage(brandId: number, activeSeasonId: number | null | undefined, args: GetMassEditSeasonUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditSeasonUsageDto[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-seasons-usage?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_MassEditSeasons(brandId: number, args: MassEditSeasonsArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/seasons";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview current drops across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 * @param activeSeasonId (optional) 
 */
  async overview_GetMassEditDropUsage(brandId: number, activeSeasonId: number | null | undefined, args: GetMassEditDropUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditDropUsageDto[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-drops-usage?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_MassEditDrops(brandId: number, args: MassEditDropArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/drops";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview current certifications across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 * @param activeSeasonId (optional) 
 */
  async overview_GetMassEditCertificationUsage(brandId: number, activeSeasonId: number | null | undefined, args: GetMassEditCertificationUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditCertificationUsageDto[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-certifications-usage?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Attach, update or detach certificates on the selected articles. MERGES rather than replaces: `upserts` adds or updates, `removedCertificateIds` detaches, anything unmentioned is untouched. An upsert is matched by certificateId; its `id` is ignored, so send 0 for a new attachment.
 */
  async overview_MassEditCertifications(brandId: number, args: MassEditCertificationsArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/certifications";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview current compliances across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 * @param activeSeasonId (optional) 
 */
  async overview_GetMassEditComplianceUsage(brandId: number, activeSeasonId: number | null | undefined, args: GetMassEditComplianceUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditComplianceUsageDto[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-compliances-usage?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Attach, update or detach compliances on the selected articles. MERGES rather than replaces: `upserts` adds or updates, `removedComplianceIds` detaches, anything unmentioned is untouched. An upsert is matched by complianceId; its `id` is ignored, so send 0 for a new attachment.
 */
  async overview_MassEditCompliances(brandId: number, args: MassEditCompliancesArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/compliances";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview current tariff codes across a selection before mass-editing. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 * @param activeSeasonId (optional) 
 */
  async overview_GetMassEditTariffCodeUsage(brandId: number, activeSeasonId: number | null | undefined, args: GetMassEditTariffCodeUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditTariffCodeUsageDto[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-tariff-codes-usage?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set tariff codes across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_MassEditTariffCodes(brandId: number, args: MassEditTariffCodesArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/tariff-codes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview current suppliers across a selection before mass-editing. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 * @param activeSeasonId (optional) 
 */
  async overview_GetMassEditSupplierUsage(brandId: number, activeSeasonId: number | null | undefined, args: GetMassEditSupplierUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditSupplierUsageDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-suppliers-usage?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set suppliers across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_MassEditSuppliers(brandId: number, args: MassEditSuppliersArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/suppliers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditAssigneesUsage(brandId: number, activeSeasonId: number | null | undefined, args: GetMassEditAssigneesUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditAssigneesUsageResponseDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-assignees-usage?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set assignees across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_MassEditAssignees(brandId: number, args: MassEditAssigneesArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/assignees";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set comment across a selection of articles. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 * @param comment (optional) 
 */
  async overview_MassEditComment(brandId: number, comment: string | null | undefined, args: MassEditArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/comment?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (comment !== undefined && comment !== null)
        url_ += "comment=" + encodeURIComponent("" + comment) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set description across a selection of articles. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 * @param description (optional) 
 */
  async overview_MassEditDescription(brandId: number, description: string | null | undefined, args: MassEditArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/description?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (description !== undefined && description !== null)
        url_ += "description=" + encodeURIComponent("" + description) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a text custom field across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_MassEditCustomFieldText(brandId: number, customFieldId: number, args: MassEditCustomFieldTextArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/custom-field-text/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditMoneyUsage(brandId: number, customFieldId: number, args: GetMassEditFieldUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditPriceUsageDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-money-usage/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List articles in a selection that have no SKUs yet.
 */
  async overview_GetArticlesWithoutSkus(brandId: number, args: GetMassEditFieldUsageArgs, options: AxiosRequestConfig = {}): Promise<string[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-articles-without-skus";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditCostAndTargetPriceUsage(brandId: number, args: GetInPriceFieldUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditCostAndTargetPriceUsageDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-cost-and-target-price-usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditOutPriceUsage(brandId: number, args: GetOutPriceUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditPriceUsageDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-out-price-usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditOutPriceMarkupUsage(brandId: number, args: GetOutPriceMarkupUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditMarkupMarginUsageDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-out-price-markup-usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_MassEditCostPrice(brandId: number, args: MassEditCostPriceArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/cost-price";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditDutiesUsage(brandId: number, args: GetInPriceFieldUsageArgs, options: AxiosRequestConfig = {}): Promise<NumberStateDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-duties-usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditFreightUsage(brandId: number, args: GetInPriceFieldUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditFreightUsageDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-freight-usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_MassEditDuties(brandId: number, args: MassEditDutiesArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/duties";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_MassEditFreight(brandId: number, args: MassEditFreightArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/freight";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_MassEditInPriceStep(brandId: number, args: MassEditInPriceStepArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/in-price-step";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditInPriceStepUsage(brandId: number, args: GetInPriceStepUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditInPriceStepUsageDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-in-price-step-usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_MassEditOutPrice(brandId: number, args: MassEditOutPriceArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/out-price";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_MassEditOutPriceMarkup(brandId: number, args: MassEditOutPriceMarkupArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/out-price-markup";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set country of origin across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_MassEditCountryOfOrigin(brandId: number, args: MassEditCountryOfOriginArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/country-of-origin";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview current country of origin across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_GetMassEditCountryOfOriginUsage(brandId: number, args: GetMassEditFieldUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditCountryOfOriginUsageDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-country-of-origin-usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview overview_MassEditTimeline over a selection: per timeline, how many of the selected article-seasons it could be applied to and how many already run on it, plus withGateDataCount — the ones carrying a tick or a note that moving them would erase. Both counts are against articleSeasonCount, since an article not on the season has no plan to change.
 */
  async overview_GetMassEditTimelineUsage(brandId: number, args: GetMassEditFieldUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditTimelineUsageDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-timeline-usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Pin a selection of article-seasons to one timeline. CLEARS the gate progress of every row that moves — call overview_GetMassEditTimelineUsage first and tell the user what withGateDataCount says. Only rows eligible for that timeline are changed.
 */
  async overview_MassEditTimeline(brandId: number, args: MassEditTimelineArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/timeline";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set weight across a selection of articles. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_MassEditWeight(brandId: number, args: MassEditWeightArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/weight";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview current weights across a selection before mass-editing. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_GetMassEditWeightUsage(brandId: number, args: GetMassEditFieldUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditWeightUsageDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-weight-usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a money custom field across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_MassEditCustomFieldMoney(brandId: number, customFieldId: number, args: MassEditCustomFieldMoneyArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/custom-field-money/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditNumberWithUnitUsage(brandId: number, customFieldId: number, args: GetMassEditFieldUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditNumberWithUnitUsageDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-number-with-unit-usage/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a number-with-unit custom field across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_MassEditCustomFieldNumberWithUnit(brandId: number, customFieldId: number, args: MassEditCustomFieldNumberWithUnitArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/custom-field-number-with-unit/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditSingleSelectUsage(brandId: number, customFieldId: number, args: GetMassEditFieldUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditSingleSelectUsageDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-single-select-usage/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a single-select custom field across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_MassEditCustomFieldSingleSelect(brandId: number, customFieldId: number, args: MassEditCustomFieldSingleSelectArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/custom-field-single-select/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditMultiSelectUsage(brandId: number, customFieldId: number, args: GetMassEditFieldUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditMultiSelectUsageDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-multi-select-usage/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a multi-select custom field across a selection. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_MassEditCustomFieldMultiSelect(brandId: number, customFieldId: number, args: MassEditCustomFieldMultiSelectArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/custom-field-multi-select/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_GetMassEditCustomFieldFileUsage(brandId: number, activeSeasonId: number | null | undefined, args: GetMassEditCustomFieldFileUsageArgs, options: AxiosRequestConfig = {}): Promise<MassEditCustomFieldFileUsageDto[]> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/get-custom-files-usage?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_MassEditCustomFieldFiles(brandId: number, customFieldId: number, args: MassEditCustomFieldFilesArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/custom-field-files/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_MassEditCustomFieldRelink(brandId: number, customFieldId: number, args: MassEditArgs, options: AxiosRequestConfig = {}): Promise<MassEditResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-edit/custom-field-relink/{customFieldId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customFieldId === undefined || customFieldId === null)
        throw new Error("The parameter 'customFieldId' must be defined.");
    url_ = url_.replace("{customFieldId}", encodeURIComponent("" + customFieldId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_DownloadArticleImportTemplate(brandId: number, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/article-import-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_DownloadSkuImportTemplate(brandId: number, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/sku-import-template";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_DownloadBomImportTemplate(options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/overview/bom-import-template";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a selection of articles. Pin Selection to explicit ids (isAllSelected:false, selectedIds:[...]); isAllSelected:true edits the entire filtered set.
 */
  async overview_MassDeleteArticles(brandId: number, args: MassDeleteArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-delete/articles";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Check what prevents a set of products from being deleted.
 */
  async overview_GetBulkProductDeletionBlockers(brandId: number, args: MassDeleteArgs, options: AxiosRequestConfig = {}): Promise<BulkProductDeletionBlockersDto> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-delete/products/deletion-blockers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async overview_ForceDeleteProducts(brandId: number, args: MassDeleteArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/overview/{brandId}/mass-delete/products/force";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async paymentTerm_List(brandId: number, options: AxiosRequestConfig = {}): Promise<PaymentTermDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/payment-term";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async paymentTerm_Create(brandId: number, createPaymentTerm: CreatePaymentTerm, options: AxiosRequestConfig = {}): Promise<PaymentTermDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/payment-term";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = createPaymentTerm;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async paymentTerm_Update(brandId: number, paymentTermId: number, updatePaymentTerm: UpdatePaymentTerm, options: AxiosRequestConfig = {}): Promise<PaymentTermDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/payment-term/{paymentTermId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (paymentTermId === undefined || paymentTermId === null)
        throw new Error("The parameter 'paymentTermId' must be defined.");
    url_ = url_.replace("{paymentTermId}", encodeURIComponent("" + paymentTermId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = updatePaymentTerm;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async paymentTerm_Delete(brandId: number, paymentTermId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/payment-term/{paymentTermId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (paymentTermId === undefined || paymentTermId === null)
        throw new Error("The parameter 'paymentTermId' must be defined.");
    url_ = url_.replace("{paymentTermId}", encodeURIComponent("" + paymentTermId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async paymentTerm_GetPaymentTermUsage(brandId: number, paymentTermId: number, options: AxiosRequestConfig = {}): Promise<PaymentTermUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/payment-term/{paymentTermId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (paymentTermId === undefined || paymentTermId === null)
        throw new Error("The parameter 'paymentTermId' must be defined.");
    url_ = url_.replace("{paymentTermId}", encodeURIComponent("" + paymentTermId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async permission_ListPermissions(brandId: number, options: AxiosRequestConfig = {}): Promise<PermissionDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/permissions";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async permission_AddPermission(brandId: number, args: AddPermissionArgs, options: AxiosRequestConfig = {}): Promise<PermissionDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/permissions";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async permission_UpdatePermission(brandId: number, permissionId: number, args: UpdatePermissionArgs, options: AxiosRequestConfig = {}): Promise<PermissionDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/permissions/{permissionId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (permissionId === undefined || permissionId === null)
        throw new Error("The parameter 'permissionId' must be defined.");
    url_ = url_.replace("{permissionId}", encodeURIComponent("" + permissionId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async permission_DeletePermission(brandId: number, permissionId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/permissions/{permissionId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (permissionId === undefined || permissionId === null)
        throw new Error("The parameter 'permissionId' must be defined.");
    url_ = url_.replace("{permissionId}", encodeURIComponent("" + permissionId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set many users' access levels at once. Each cell is a user and an article status; omitting accessLevel removes that user's permission on it.
Writes many cells in one request, each with its own access level — what a clipboard
paste over the permissions grid produces. One SaveChanges, so the table sees a single
update rather than one per cell.
            
Returns the same list the GET does, so the caller can show the saved permissions
without waiting for the SignalR round trip.
 */
  async permission_SetPermissionsBulk(brandId: number, args: SetPermissionsBulkArgs, options: AxiosRequestConfig = {}): Promise<PermissionDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/permissions/bulk";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the people with access to this brand, for assigning roles and permissions to. Use this to resolve a name to the user id the permission and role writes take.
 */
  async permission_ListBrandUsers(brandId: number, options: AxiosRequestConfig = {}): Promise<PermissionUserDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/permissions/brand-users";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async placementName_GetPlacementNames(brandId: number, options: AxiosRequestConfig = {}): Promise<PlacementNameDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-names";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async placementName_Create(brandId: number, args: CreatePlacementNameArgs, options: AxiosRequestConfig = {}): Promise<PlacementNameDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-names";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async placementName_Update(brandId: number, id: number, args: UpdatePlacementNameArgs, options: AxiosRequestConfig = {}): Promise<PlacementNameDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-names/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async placementName_Delete(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-names/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async placementName_GetUsage(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-names/{id}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Retire a placement name by repointing everything using it at a replacement, then deleting it. Prefer this over placementName_Delete when it is still in use.
 */
  async placementName_Replace(brandId: number, id: number, args: ReplacePlacementNameArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-names/{id}/replace";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set which placement tags are applied by default when this placement name is used. Replaces the current set.
 */
  async placementName_SetDefaultTags(brandId: number, id: number, args: SetDefaultTagsArgs, options: AxiosRequestConfig = {}): Promise<PlacementNameDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-names/{id}/default-tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async placementTag_GetPlacementTagCategories(brandId: number, options: AxiosRequestConfig = {}): Promise<PlacementTagCategoryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-tags/categories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async placementTag_CreatePlacementTagCategory(brandId: number, args: CreateTagCategoryArgs2, options: AxiosRequestConfig = {}): Promise<PlacementTagCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-tags/categories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async placementTag_UpdatePlacementTagCategory(brandId: number, tagCategoryId: number, args: UpdateTagCategoryArgs2, options: AxiosRequestConfig = {}): Promise<PlacementTagCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-tags/categories/{tagCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async placementTag_DeletePlacementTagCategory(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-tags/categories/{tagCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Count the placements currently tagged from this category. Call this before deleting one.
 */
  async placementTag_GetTagCategoryUsageCount(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-tags/categories/{tagCategoryId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async placementTag_CreatePlacementTag(brandId: number, args: AddTagArgs3, options: AxiosRequestConfig = {}): Promise<PlacementTagDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async placementTag_UpdatePlacementTag(brandId: number, tagId: number, args: UpdateTagArgs3, options: AxiosRequestConfig = {}): Promise<PlacementTagDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async placementTag_DeletePlacementTag(brandId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async placementTag_GetTagUsageCount(brandId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/placement-tags/{tagId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's VAT rates, one per hierarchy node, destination and season.
 */
  async price_GetAllVats(brandId: number, options: AxiosRequestConfig = {}): Promise<VatDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/price/vat";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the VAT rate for one hierarchy node, destination and season. Omitting `amount` clears it. Use price_SetVatsBulk for more than a few.
 */
  async price_SetVat(brandId: number, args: SetVatArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/price/vat";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set many VAT rates at once — each cell is a hierarchy node and optionally a season. Omitting a cell's `amount` clears that rate.
Writes many cells in one request, each with its own amount (null clears it) — what a
clipboard paste produces. One SaveChanges, so the table sees a single update rather
than one per cell.
            
Returns the same list the GET does, so the caller can show the saved values without
waiting for the SignalR round trip to fetch them.
 */
  async price_SetVatsBulk(brandId: number, args: SetVatsBulkArgs, options: AxiosRequestConfig = {}): Promise<VatDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/price/vats/bulk";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async price_DeleteVats(brandId: number, hierarchyNodeId: number, destinationId: number | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/price/vat/{hierarchyNodeId}?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (hierarchyNodeId === undefined || hierarchyNodeId === null)
        throw new Error("The parameter 'hierarchyNodeId' must be defined.");
    url_ = url_.replace("{hierarchyNodeId}", encodeURIComponent("" + hierarchyNodeId));
    if (destinationId === null)
        throw new Error("The parameter 'destinationId' cannot be null.");
    else if (destinationId !== undefined)
        url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's markup targets — the target markup per hierarchy node and out-price, against which actual margins are measured.
 */
  async price_GetAllMarkupTargets(brandId: number, options: AxiosRequestConfig = {}): Promise<MarkupMarginTargetDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/price/markup-target";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the target markup for one hierarchy node and out-price. Omitting `value` clears the target. Use price_SetMarkupTargetsBulk for more than a few.
 */
  async price_SetMarkupTarget(brandId: number, args: SetMarkupTargetArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/price/markup-target";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set many markup targets at once — each cell is a hierarchy node and an out-price. Omitting a cell's `value` clears that target.
Writes many cells in one request, each with its own value (null clears it) — what a
clipboard paste produces. One SaveChanges, so the table sees one update rather than
one per cell.
            
Returns the same list the GET does, so the caller can show the saved values without
waiting for the SignalR round trip to fetch them.
 */
  async price_SetMarkupTargetsBulk(brandId: number, args: SetMarkupTargetsBulkArgs, options: AxiosRequestConfig = {}): Promise<MarkupMarginTargetDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/price/markup-targets/bulk";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async price_DeleteMarkupTargets(brandId: number, hierarchyNodeId: number, destinationId: number | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/price/markup-target/{hierarchyNodeId}?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (hierarchyNodeId === undefined || hierarchyNodeId === null)
        throw new Error("The parameter 'hierarchyNodeId' must be defined.");
    url_ = url_.replace("{hierarchyNodeId}", encodeURIComponent("" + hierarchyNodeId));
    if (destinationId === null)
        throw new Error("The parameter 'destinationId' cannot be null.");
    else if (destinationId !== undefined)
        url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async priceRecalculation_GetStatus(brandId: number, options: AxiosRequestConfig = {}): Promise<PriceRecalculationStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/price-recalculation";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async priceRecalculation_RunNow(brandId: number, options: AxiosRequestConfig = {}): Promise<PriceRecalculationStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/price-recalculation/run";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's product categories.
 */
  async productCategory_GetBrandProductCategories(brandId: number, options: AxiosRequestConfig = {}): Promise<ProductCategoryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/productcategories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async productCategory_AddProductCategory(brandId: number, args: AddProductCategoryArgs, options: AxiosRequestConfig = {}): Promise<ProductCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/productcategories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async productCategory_UpdateProductCategory(brandId: number, productCategoryId: number, args: UpdateProductCategoryArgs, options: AxiosRequestConfig = {}): Promise<ProductCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/productcategories/{productCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productCategoryId === undefined || productCategoryId === null)
        throw new Error("The parameter 'productCategoryId' must be defined.");
    url_ = url_.replace("{productCategoryId}", encodeURIComponent("" + productCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async productCategory_DeleteProductCategory(brandId: number, productCategoryId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/productcategories/{productCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productCategoryId === undefined || productCategoryId === null)
        throw new Error("The parameter 'productCategoryId' must be defined.");
    url_ = url_.replace("{productCategoryId}", encodeURIComponent("" + productCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async productCategory_GetProductCategoryUsage(brandId: number, productCategoryId: number, options: AxiosRequestConfig = {}): Promise<ProductCategoryUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/productcategories/{productCategoryId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productCategoryId === undefined || productCategoryId === null)
        throw new Error("The parameter 'productCategoryId' must be defined.");
    url_ = url_.replace("{productCategoryId}", encodeURIComponent("" + productCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List products for the brand. For finding articles by season, colour, status or supplier, use the overview_ endpoints instead — they carry the filters.
 * @param activeSeasonId (optional) 
 * @param hierarchyNodeIds (optional) 
 * @param productCategoryIds (optional) 
 * @param genders (optional) 
 * @param seasonIds (optional) 
 * @param colors (optional) 
 * @param supplierIds (optional) 
 * @param dropDateRange_From (optional) 
 * @param dropDateRange_To (optional) 
 * @param dropNames (optional) 
 * @param statusIds (optional) 
 * @param tagIds (optional) 
 * @param searchTerm (optional) 
 * @param customFieldOptionIds (optional) 
 * @param createdByUserIds (optional) 
 * @param assignedUserIds (optional) 
 * @param colorGroupIds (optional) 
 * @param outPriceAmounts (optional) 
 * @param outPriceRanges (optional) 
 * @param sizeSystemIds (optional) 
 * @param timelineHealth (optional) 
 * @param nextGateRoleIds (optional) 
 * @param nextGateNames (optional) 
 * @param selectedArticleIds (optional) 
 * @param startIndex (optional) 
 * @param items (optional) 
 */
  async product_ListProducts(args: Product_ListProductsArgs, options: AxiosRequestConfig = {}): Promise<GetInitialArticlePickerResponse> {
    const { brandId, activeSeasonId, hierarchyNodeIds, productCategoryIds, genders, seasonIds, colors, supplierIds, dropNames, statusIds, tagIds, searchTerm, customFieldOptionIds, createdByUserIds, assignedUserIds, colorGroupIds, outPriceAmounts, outPriceRanges, sizeSystemIds, timelineHealth, nextGateRoleIds, nextGateNames, selectedArticleIds, startIndex, items, } = args;
    const dropDateRange_From = args.dropDateRange?.from;
    const dropDateRange_To = args.dropDateRange?.to;
    let url_ = this.baseUrl + "/api/brand/{brandId}/products?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    if (hierarchyNodeIds !== undefined && hierarchyNodeIds !== null)
        hierarchyNodeIds && hierarchyNodeIds.forEach(item => { url_ += "HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (productCategoryIds !== undefined && productCategoryIds !== null)
        productCategoryIds && productCategoryIds.forEach(item => { url_ += "ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (genders !== undefined && genders !== null)
        genders && genders.forEach(item => { url_ += "Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colors !== undefined && colors !== null)
        colors && colors.forEach(item => { url_ += "Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (dropDateRange_From !== undefined && dropDateRange_From !== null)
        url_ += "DropDateRange.From=" + encodeURIComponent("" + dropDateRange_From) + "&";
    if (dropDateRange_To !== undefined && dropDateRange_To !== null)
        url_ += "DropDateRange.To=" + encodeURIComponent("" + dropDateRange_To) + "&";
    if (dropNames !== undefined && dropNames !== null)
        dropNames && dropNames.forEach(item => { url_ += "DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (statusIds !== undefined && statusIds !== null)
        statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (customFieldOptionIds !== undefined && customFieldOptionIds !== null)
        url_ += appendDictionaryQuery("CustomFieldOptionIds", customFieldOptionIds);
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (assignedUserIds !== undefined && assignedUserIds !== null)
        assignedUserIds && assignedUserIds.forEach(item => { url_ += "AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colorGroupIds !== undefined && colorGroupIds !== null)
        colorGroupIds && colorGroupIds.forEach(item => { url_ += "ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (outPriceAmounts !== undefined && outPriceAmounts !== null)
        url_ += appendDictionaryQuery("OutPriceAmounts", outPriceAmounts);
    if (outPriceRanges !== undefined && outPriceRanges !== null)
        url_ += appendDictionaryQuery("OutPriceRanges", outPriceRanges);
    if (sizeSystemIds !== undefined && sizeSystemIds !== null)
        sizeSystemIds && sizeSystemIds.forEach(item => { url_ += "SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (timelineHealth !== undefined && timelineHealth !== null)
        timelineHealth && timelineHealth.forEach(item => { url_ += "TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateRoleIds !== undefined && nextGateRoleIds !== null)
        nextGateRoleIds && nextGateRoleIds.forEach(item => { url_ += "NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateNames !== undefined && nextGateNames !== null)
        nextGateNames && nextGateNames.forEach(item => { url_ += "NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (selectedArticleIds === null)
        throw new Error("The parameter 'selectedArticleIds' cannot be null.");
    else if (selectedArticleIds !== undefined)
        selectedArticleIds && selectedArticleIds.forEach(item => { url_ += "selectedArticleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (startIndex === null)
        throw new Error("The parameter 'startIndex' cannot be null.");
    else if (startIndex !== undefined)
        url_ += "startIndex=" + encodeURIComponent("" + startIndex) + "&";
    if (items === null)
        throw new Error("The parameter 'items' cannot be null.");
    else if (items !== undefined)
        url_ += "items=" + encodeURIComponent("" + items) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a bare product: name and hierarchy node, optionally a product number (required if the brand has manual product numbers on; must be unique). It creates NO articles and NO SKUs — add each colourway yourself with product_UpdateColors, then sizes with product_UpdateGenderAndSizes.
 */
  async product_AddProduct(brandId: number, args: AddProductArgs, options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read one product in full, including its role assignments, seasons, drops and images.
 */
  async product_GetProduct(brandId: number, productId: number, options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a product and everything under it — every article and SKU. Call product_GetProductDeletionBlockers first, and confirm with the user.
 */
  async product_DeleteProduct(brandId: number, productId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Find the product elsewhere: which other PLM brand of the caller's owns it, when it is not in this one. Null when no brand the caller can reach has it. Only for recovering a deep link that landed on the wrong brand — to read a product, switch brand and use product_GetProduct.
 */
  async product_GetOwningBrand(brandId: number, productId: number, options: AxiosRequestConfig = {}): Promise<ProductOwningBrand> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/owning-brand";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the articles under one product — its colourways. For a selection across the brand (by season, supplier, status, colour, tag or hierarchy) use overview_GetInitialTableArticles instead: it filters server-side in one call, where walking products costs a round trip each.
 */
  async product_GetArticlesForProduct(brandId: number, productId: number, options: AxiosRequestConfig = {}): Promise<ArticleDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/articles";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Attach files to a product. Takes `azureBlobFileIds` — file records, not paths — so get each file in with request_upload and deliverTo {operation: "file_Upload", args: {name}}, which returns the id to pass here. This ADDS to the product's files rather than replacing them; remove one with product_ArchiveFile. To replace a file's contents keep the id it already has and use file_AddVersion instead of attaching a second file.
 */
  async product_AddFiles(brandId: number, productId: number, args: AddFilesArgs2, options: AxiosRequestConfig = {}): Promise<ProductFileDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/files";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the comment on a product file.
 */
  async product_UpdateFileComment(brandId: number, productId: number, fileId: number, args: UpdateFileCommentArgs, options: AxiosRequestConfig = {}): Promise<ProductFileDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/files/{fileId}/comment";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (fileId === undefined || fileId === null)
        throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Archive a product file, hiding it without deleting it. Prefer this over product_DeleteFile.
 */
  async product_ArchiveFile(brandId: number, productId: number, fileId: number, options: AxiosRequestConfig = {}): Promise<ProductFileDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/files/{fileId}/archive";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (fileId === undefined || fileId === null)
        throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Restore an archived product file.
 */
  async product_UnarchiveFile(brandId: number, productId: number, fileId: number, options: AxiosRequestConfig = {}): Promise<ProductFileDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/files/{fileId}/unarchive";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (fileId === undefined || fileId === null)
        throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Permanently delete a product file. Prefer product_ArchiveFile — archiving is reversible and this is not.
 */
  async product_DeleteFile(brandId: number, productId: number, fileId: number, options: AxiosRequestConfig = {}): Promise<ProductFileDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/files/{fileId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (fileId === undefined || fileId === null)
        throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List what would prevent a product being deleted. Call before product_DeleteProduct.
 */
  async product_GetProductDeletionBlockers(brandId: number, productId: number, options: AxiosRequestConfig = {}): Promise<ProductDeletionBlockersDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/deletion-blockers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Duplicate a product with its articles and SKUs. Duplication copies values verbatim and never re-seeds, so the clone keeps the original's per-SKU values rather than recomputing them.
 */
  async product_CloneProduct(brandId: number, productId: number, options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/clone";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a product's number manually, overriding the generated one.
 */
  async product_UpdateProductNumber(brandId: number, productId: number, args: UpdateProductNumberArgs, options: AxiosRequestConfig = {}): Promise<UpdateProductNumberResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/product-number";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Explain how the next product number would be generated, before creating one.
 */
  async product_GetProductNumberInfo(brandId: number, productId: number, options: AxiosRequestConfig = {}): Promise<ProductNumberInfoResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/number-info";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Search products by number or name. Use this to resolve a product reference to an id.
 * @param query (optional) 
 * @param take (optional) 
 */
  async product_QuickSearch(brandId: number, query: string | null | undefined, take: number | undefined, options: AxiosRequestConfig = {}): Promise<QuickSearchProduct[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/quick?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (query !== undefined && query !== null)
        url_ += "query=" + encodeURIComponent("" + query) + "&";
    if (take === null)
        throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined)
        url_ += "take=" + encodeURIComponent("" + take) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the colours of a product's articles. Each colour is one article, so adding a colour adds an article and removing one removes that article and its SKUs.
 * @param removeArticlesEvenIfNoColor (optional) 
 */
  async product_UpdateColors(brandId: number, productId: number, removeArticlesEvenIfNoColor: boolean | undefined, args: UpdateColorsColor[], options: AxiosRequestConfig = {}): Promise<UpdateColorsReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/colors?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (removeArticlesEvenIfNoColor === null)
        throw new Error("The parameter 'removeArticlesEvenIfNoColor' cannot be null.");
    else if (removeArticlesEvenIfNoColor !== undefined)
        url_ += "removeArticlesEvenIfNoColor=" + encodeURIComponent("" + removeArticlesEvenIfNoColor) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Rename a product.
 */
  async product_UpdateName(brandId: number, productId: number, args: UpdateNameArgs2, options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/name";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Replace a product's genders without changing its size system, sizes or SKUs. Intended for gender-only edits when no usable size-system version is resolved. Otherwise, prefer product_UpdateGenderAndSizes to update genders and sizes together. Takes an array of Gender values and updates article genders using the product's synchronization rules.
 */
  async product_UpdateGenders(brandId: number, productId: number, genders: Gender[], options: AxiosRequestConfig = {}): Promise<ProductGendersResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/gender";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = genders;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set gender and sizes together. Prefer this over product_UpdateSizes when gender changes too — gender can change which size system applies. Changing the size system version deletes and recreates every SKU, and is refused (in `updateError`) when product_GetSizeSystemChangeRules lists any rule; use product_SwitchSizeSystem or product_RecreateSizeSystemSkus then.
 */
  async product_UpdateGenderAndSizes(brandId: number, productId: number, args: UpdateGenderAndSizesArgs2, options: AxiosRequestConfig = {}): Promise<UpdateGenderAndSizesReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/gender-and-sizes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a product's sizes. Sizes generate SKUs, so removing a size removes the SKUs on it. Changing the size system version deletes and recreates every SKU, and is refused (in `updateError`) when product_GetSizeSystemChangeRules lists any rule; use product_SwitchSizeSystem or product_RecreateSizeSystemSkus then.
 */
  async product_UpdateSizes(brandId: number, productId: number, args: UpdateSizeArgs, options: AxiosRequestConfig = {}): Promise<UpdateSizeReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/sizes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * What a product's SKUs hold that a plain size system change (product_UpdateGenderAndSizes / product_UpdateSizes with another version), which deletes and recreates every SKU, would lose or is refused for. `blocked` is set when the size system can't change at all. Each rule names its SKUs; `hard` rules (SKUs on orders, a status locking SKU removal) rule out recreating, so those SKUs can only be kept with product_SwitchSizeSystem. Soft rules (SKU codes, prices or weights that differ between sizes, SKU-level seasonality, locked or hand-set SKU numbers and names) are what recreating loses. With no rules, a plain size system change loses nothing; with any, the plain change is refused and product_SwitchSizeSystem or product_RecreateSizeSystemSkus must be used. Changes nothing.
 */
  async product_GetSizeSystemChangeRules(brandId: number, productId: number, options: AxiosRequestConfig = {}): Promise<SizeSystemChangeRules> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/size-system/rules";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview switching a product that has SKUs to another size system version, before calling product_SwitchSizeSystem. Lists the product's current sizes in order, each with its SKU count, and the product's article count (each added size gets one SKU per article) and, if any of its SKUs can't be removed (article status locks SKU removal, or the SKU is on an order), why the size can't be dropped. Also returns m-charts that stay in another size system, the product's size conversion table, `refusal` when the switch isn't allowed at all, and the same `rules` as product_GetSizeSystemChangeRules. Changes nothing.
 */
  async product_PreviewSizeSystemSwitch(brandId: number, productId: number, sizeSystemVersionId: number, options: AxiosRequestConfig = {}): Promise<SizeSwitchPreview> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/size-system/preview";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = sizeSystemVersionId;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Switch a product to another size system version, keeping its SKUs. `mappings` must list every current product size exactly once, with the id of its new size in the target version, or null to drop the size and its SKUs; two sizes can't map to the same new size. `addedSizeSystemVersionSizeIds` are sizes of the target version to add to the product, each getting a new SKU for every article (pass [] to add none); a current size without SKUs mapped onto an added size is reused rather than duplicated. A mapped size keeps its SKUs (ids, EANs and other codes, prices, weights, order rows), and their SKU numbers are regenerated unless the article's status locks them. Refuses, changing nothing, if a SKU that would be dropped is locked by its article status or is on an order.
 */
  async product_SwitchSizeSystem(brandId: number, productId: number, args: SwitchSizeSystemArgs, options: AxiosRequestConfig = {}): Promise<SwitchSizeSystemReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/size-system";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Switch a product to another size system version by deleting all its SKUs and creating new ones for `sizeSystemVersionSizeIds` (sizes of the target version), one per article and size. SKU codes and weights move to the new SKUs by position; everything else product_GetSizeSystemChangeRules lists as a soft rule is lost. Refused, changing nothing, while any hard rule applies (a SKU on an order, or a status locking SKU removal): use product_SwitchSizeSystem then, which keeps the SKUs.
 */
  async product_RecreateSizeSystemSkus(brandId: number, productId: number, args: RecreateSizeSystemSkusArgs, options: AxiosRequestConfig = {}): Promise<SwitchSizeSystemReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/size-system/recreate";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a product's description.
 */
  async product_UpdateDescription(brandId: number, productId: number, args: UpdateDescriptionArgs2, options: AxiosRequestConfig = {}): Promise<UpdateDescriptionReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/description";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Assign users to roles on a product — this is what makes someone the Developer or Buyer of it. Role names are brand-defined; resolve them with role_GetRoles.
 */
  async product_SetRoleAssignments(brandId: number, productId: number, args: SetRoleAssignmentsArgs, options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/role-assignments";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the tags on one product. Only product-level tag categories apply here; article-level tags live on the article.
 */
  async product_UpdateTags(brandId: number, productId: number, args: UpdateTagsArgs, options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Add or remove tags across many products at once. Prefer this over repeated product_UpdateTags.
Atomic tag mass-edit for a product: applies product-level adds/removes to the product
and article-level adds/removes to the given articles' ArticleSeason for the given season,
all in a single transaction.
SeasonId names the season whose article-level tags are edited and is required for any article
that has seasons; the call fails if it is missing for such an article or names a season the
article is not on. Omit it only for articles without seasons, whose tags live on the base
seasonality. Product-level tags are not seasonal and ignore it. This never adds a season to an
article; error if trying to set tags for non-existing seasons.
 */
  async product_MassEditTags(brandId: number, productId: number, args: MassEditTagsArgs2, options: AxiosRequestConfig = {}): Promise<MassEditTagsResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/mass-edit-tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Tick one gate as done across several of a product's articles at once — the product timeline tab's unit of work. One endpoint per action rather than a patch, because null already means "clear" for a note: the action is what says which field is being written.
 */
  async product_BulkCompleteGate(args: Product_BulkCompleteGateArgs, options: AxiosRequestConfig = {}): Promise<ArticleTimelinePlanDto[]> {
    const { brandId, productId, seasonId, gateId, gateArgs, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/seasons/{seasonId}/timeline/gates/{gateId}/complete";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    if (gateId === undefined || gateId === null)
        throw new Error("The parameter 'gateId' must be defined.");
    url_ = url_.replace("{gateId}", encodeURIComponent("" + gateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = gateArgs;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Un-tick one gate across several of a product's articles, clearing the completion. A POST rather than a DELETE because the articles travel in the body.
 */
  async product_BulkUndoGate(args: Product_BulkUndoGateArgs, options: AxiosRequestConfig = {}): Promise<ArticleTimelinePlanDto[]> {
    const { brandId, productId, seasonId, gateId, gateArgs, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/seasons/{seasonId}/timeline/gates/{gateId}/undo";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    if (gateId === undefined || gateId === null)
        throw new Error("The parameter 'gateId' must be defined.");
    url_ = url_.replace("{gateId}", encodeURIComponent("" + gateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = gateArgs;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set (or clear, with null) one gate's note across several of a product's articles.
 */
  async product_BulkSetGateNote(args: Product_BulkSetGateNoteArgs, options: AxiosRequestConfig = {}): Promise<ArticleTimelinePlanDto[]> {
    const { brandId, productId, seasonId, gateId, gateArgs, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/seasons/{seasonId}/timeline/gates/{gateId}/note";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    if (gateId === undefined || gateId === null)
        throw new Error("The parameter 'gateId' must be defined.");
    url_ = url_.replace("{gateId}", encodeURIComponent("" + gateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = gateArgs;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set (or clear, with null) one gate's estimated date across several of a product's articles. An estimate is what you expect; completedOn is what happened.
 */
  async product_BulkSetGateEstimate(args: Product_BulkSetGateEstimateArgs, options: AxiosRequestConfig = {}): Promise<ArticleTimelinePlanDto[]> {
    const { brandId, productId, seasonId, gateId, gateArgs, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/seasons/{seasonId}/timeline/gates/{gateId}/estimate";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    if (gateId === undefined || gateId === null)
        throw new Error("The parameter 'gateId' must be defined.");
    url_ = url_.replace("{gateId}", encodeURIComponent("" + gateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = gateArgs;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Change a product's seasons in one transaction: addSeasonIds and removeSeasonIds act on the articles named in articleIds, while removeFromProductSeasonIds takes a season off the product entirely, with its BOMs and — when it is the last season — its own custom values pushed back to the seasonless values. A season may appear in only one of the three lists, and a removal that would leave a season with no articles at all must be sent as removeFromProductSeasonIds; both are rejected rather than guessed at. Seasons named in no list are untouched.
 */
  async product_UpdateSeasons(brandId: number, productId: number, args: UpdateProductSeasonsArgs, options: AxiosRequestConfig = {}): Promise<UpdateSeasonsReturn2> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/seasons";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a product's suppliers.
 * @param seasonId (optional) 
 */
  async product_UpdateSuppliers(brandId: number, productId: number, seasonId: number | null | undefined, suppliersData: UpdateSuppliersSupplierArgs[], options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/suppliers?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (seasonId !== undefined && seasonId !== null)
        url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = suppliersData;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a product's deliveries.
 */
  async product_UpdateDeliveries(brandId: number, productId: number, deliveriesToUpdate: UpdateDeliveryArg[], options: AxiosRequestConfig = {}): Promise<ProductDtoOrder[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/orders";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = deliveriesToUpdate;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a product's delivery drops.
 */
  async product_UpdateDrops(brandId: number, productId: number, dropData: UpdateProductDropsArgsItem[], options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/drops";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = dropData;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Attach or detach a measurement chart on a product.
 */
  async product_UpdateMChart(brandId: number, productId: number, args: UpdateMChartArgs3, options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/mchart";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Move a product to a different hierarchy node.
 */
  async product_UpdateHierarchy(brandId: number, productId: number, args: UpdateHierarchyArgs, options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/hierarchy";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Move a product and set its product category in one call. The category is written to the product AND every one of its articles, replacing any category an article had of its own; use article_UpdateHierarchyAndProductCategory to set one article's. Prefer this over calling product_UpdateHierarchy and the category separately.
 */
  async product_UpdateHierarchyAndProductCategory(brandId: number, productId: number, args: UpdateHierarchyAndProductCategoryArgs2, options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/hierarchy-and-product-category";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set weight at product level; writes through to every SKU under it, and is kept on the product itself only while it has no articles. The body is a WeightPatchDto directly, not wrapped in an args object: {gross:{value:n}, net:{value:n}, unit:0}. `unit` is the numeric WeightUnit (Kg=0, G=1, Lbs=2) — sending the name gives a 400. Returns the product plus every affected article.
 */
  async product_UpdateWeight(brandId: number, productId: number, newWeight: WeightPatchDto, options: AxiosRequestConfig = {}): Promise<UpdateWeightReturn> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/weight";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = newWeight;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a product's tariff codes, per destination.
 */
  async product_UpdateTariffCodes(brandId: number, productId: number, newTariffCodeIds: number[], options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/tariff-codes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = newTariffCodeIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set which images a product has, their order and their tags. REPLACES the set — an image you omit is deleted from the product and disappears from every article using it. Always send each image with its existing `id`: an entry without one is treated as a brand-new image, so the original is deleted and its article links go with it. A new image is a file id — from file_Upload, or a file already in the PLM; to replace the picture of an existing one, add a version to its file (file_AddVersion, or file_AddVersionFromFile when the new picture is already a file) instead of adding a second image.
 */
  async product_UpdateImages(brandId: number, productId: number, images: UpdateImageArg[], options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/images";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = images;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set custom field values on a product. Resolve the field definitions from get_brand_context first. seasonId picks the seasonality each value lands on, and null does not mean 'base' for every field: a seasonal field's value goes to that season, or with null to the entity's latest season (its base only if it has no season); a non-seasonal field's value always goes to the base, whatever seasonId says. A seasonId the entity does not carry yet adds that season to it, even when only non-seasonal fields are sent. One call must be all seasonal or all non-seasonal fields. A lookup table keyed on a seasonal field reads each season's own value and never falls back to the base, so write such a key field to every season it should apply in.
 * @param seasonId (optional) 
 */
  async product_UpdateCustomFieldValues(brandId: number, productId: number, seasonId: number | null | undefined, valueDtos: CustomFieldIdWithValueDto[], options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/custom-fields?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (seasonId !== undefined && seasonId !== null)
        url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = valueDtos;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Link or unlink a related product.
 * @param maybeRelatedProductId (optional) 
 */
  async product_UpdateRelatedProduct(brandId: number, productId: number, maybeRelatedProductId: number | undefined, options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/related-product";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = maybeRelatedProductId;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Generate SKU code values (EAN and similar) for a product's SKUs from the brand's code ranges.
 */
  async product_GenerateSkuCodeValuesForSkus(brandId: number, productId: number, args: GenerateSkuCodeValuesForSkusArgs2, options: AxiosRequestConfig = {}): Promise<ProductDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/sku-code-values";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read which seasons of a product share a BOM structure. Group the product's seasons whose BOMs are identical, so the BOM tab can edit them together.
 */
  async product_GetBomGrouping(brandId: number, productId: number, options: AxiosRequestConfig = {}): Promise<BomGroupingDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/bom-grouping";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Compare two seasons' BOM structures and list what differs. Call before grouping seasons. Explain why a season's BOM isn't grouped with another (list of differences).
 * @param seasonId (optional) 
 * @param compareToSeasonId (optional) 
 * @param groupSeasonIds (optional) 
 * @param compareToGroupSeasonIds (optional) 
 */
  async product_GetBomGroupingDifferences(args: Product_GetBomGroupingDifferencesArgs, options: AxiosRequestConfig = {}): Promise<string[]> {
    const { brandId, productId, seasonId, compareToSeasonId, groupSeasonIds, compareToGroupSeasonIds, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/bom-grouping/differences?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (seasonId !== undefined && seasonId !== null)
        url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
    if (compareToSeasonId !== undefined && compareToSeasonId !== null)
        url_ += "compareToSeasonId=" + encodeURIComponent("" + compareToSeasonId) + "&";
    if (groupSeasonIds !== undefined && groupSeasonIds !== null)
        groupSeasonIds && groupSeasonIds.forEach(item => { url_ += "groupSeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (compareToGroupSeasonIds !== undefined && compareToGroupSeasonIds !== null)
        compareToGroupSeasonIds && compareToGroupSeasonIds.forEach(item => { url_ += "compareToGroupSeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read a product's active BOM for a season. Despite the name it does NOT create one — it returns null when the product has no BOM on that season; use product_CreateCurrentVersionBom for that. Pass groupSeasonIds to read several seasons merged into one grid.
 * @param seasonId (optional) 
 * @param groupSeasonIds (optional) 
 * @param includeBaseInGroup (optional) 
 */
  async product_GetOrCreateCurrentVersionBom(args: Product_GetOrCreateCurrentVersionBomArgs, options: AxiosRequestConfig = {}): Promise<BomDto> {
    const { brandId, productId, seasonId, groupSeasonIds, includeBaseInGroup, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/bom?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (seasonId !== undefined && seasonId !== null)
        url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
    if (groupSeasonIds !== undefined && groupSeasonIds !== null)
        groupSeasonIds && groupSeasonIds.forEach(item => { url_ += "groupSeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (includeBaseInGroup === null)
        throw new Error("The parameter 'includeBaseInGroup' cannot be null.");
    else if (includeBaseInGroup !== undefined)
        url_ += "includeBaseInGroup=" + encodeURIComponent("" + includeBaseInGroup) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create the active BOM for a product on a season, or return the existing one. Creates the product's season if it does not exist yet.
 * @param seasonId (optional) 
 */
  async product_CreateCurrentVersionBom(brandId: number, productId: number, seasonId: number | null | undefined, options: AxiosRequestConfig = {}): Promise<BomDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/bom?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (seasonId !== undefined && seasonId !== null)
        url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read the component types on the BOM's principal placement — the brand's headline material.
 * @param seasonId (optional) 
 */
  async product_GetCurrentBomPrincipalTypes(brandId: number, productId: number, seasonId: number | null | undefined, options: AxiosRequestConfig = {}): Promise<GetCurrentBomPrincipalTypesResponse[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/bom/principal/types?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (seasonId !== undefined && seasonId !== null)
        url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read the slots on the principal placement of one season's current BOM. A null seasonId means the base (no-season) BOM, not every season's.
 * @param seasonId (optional) 
 */
  async product_GetCurrentBomPrincipalSlots(brandId: number, productId: number, seasonId: number | null | undefined, options: AxiosRequestConfig = {}): Promise<GetCurrentBomPrincipalSlotsResponseSlot[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/bom/principal/slots?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (seasonId !== undefined && seasonId !== null)
        url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async product_UpdatePrincipalTypes(brandId: number, productId: number, args: UpdatePrincipalTypesArgs, options: AxiosRequestConfig = {}): Promise<UpdatePrincipalTypesResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/principal-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Check whether a hierarchy node can take products, before assigning one.
 */
  async product_CheckHierarchyNode(brandId: number, productId: number, hierarchyNodeId: number | null, options: AxiosRequestConfig = {}): Promise<CheckHierarchyNodeResult> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/check-hierarchy-node/{hierarchyNodeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (hierarchyNodeId === undefined || hierarchyNodeId === null)
        throw new Error("The parameter 'hierarchyNodeId' must be defined.");
    url_ = url_.replace("{hierarchyNodeId}", encodeURIComponent("" + hierarchyNodeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's product image tag categories with their tags. These are the ids an image's `tagIds` refers to.
 */
  async productImageTag_GetCategories(brandId: number, options: AxiosRequestConfig = {}): Promise<ProductImageTagCategoryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/product-image-tags/categories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a category of product image tags — the groups an image's tagIds are drawn from.
 */
  async productImageTag_CreateCategory(brandId: number, args: CreateCategoryArgs, options: AxiosRequestConfig = {}): Promise<ProductImageTagCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/product-image-tags/categories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Rename or reconfigure a product image tag category.
 */
  async productImageTag_UpdateCategory(brandId: number, tagCategoryId: number, args: UpdateCategoryArgs2, options: AxiosRequestConfig = {}): Promise<ProductImageTagCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/product-image-tags/categories/{tagCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async productImageTag_DeleteCategory(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/product-image-tags/categories/{tagCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async productImageTag_GetCategoryUsageCount(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/product-image-tags/categories/{tagCategoryId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async productImageTag_CreateTag(brandId: number, args: CreateTagArgs, options: AxiosRequestConfig = {}): Promise<ProductImageTagDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/product-image-tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async productImageTag_UpdateTag(brandId: number, tagId: number, args: UpdateTagArgs4, options: AxiosRequestConfig = {}): Promise<ProductImageTagDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/product-image-tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async productImageTag_DeleteTag(brandId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/product-image-tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async productImageTag_GetTagUsageCount(brandId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/product-image-tags/{tagId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the numbers this brand may never be given again — product, article and SKU ones. Each entry
carries the type it applies to; the three are separate spaces, so the same string can be reserved
as one and free as the others.
 */
  async reservedNumber_GetReservedNumbers(brandId: number, options: AxiosRequestConfig = {}): Promise<ReservedNumberDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/reserved-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Reserve numbers of one type, so generation walks past them and setting one by hand is refused.
Numbers arrive as a single string split on commas, semicolons, newlines and tabs, so a whole
historical catalogue can be sent at once. A number a live product, article or SKU still holds is
not reserved and comes back under inUse; the response also names what was already on the list.
 */
  async reservedNumber_AddReservedNumbers(brandId: number, args: AddReservedNumbersArgs, options: AxiosRequestConfig = {}): Promise<AddReservedNumbersResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/reserved-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Take one number off the reserved list, making it available for generation again. The id comes
from the list endpoint.
 */
  async reservedNumber_DeleteReservedNumber(brandId: number, reservedNumberId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/reserved-numbers/{reservedNumberId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (reservedNumberId === undefined || reservedNumberId === null)
        throw new Error("The parameter 'reservedNumberId' must be defined.");
    url_ = url_.replace("{reservedNumberId}", encodeURIComponent("" + reservedNumberId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Take several numbers off the reserved list at once, making them available for generation again.
The ids come from the list endpoint; an id belonging to another brand is rejected.
 */
  async reservedNumber_MassDeleteReservedNumbers(brandId: number, reservedNumberIds: number[], options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/reserved-numbers/mass-delete";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = reservedNumberIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Every colour library on the platform, in picker order, with how many colours it holds, how many of those brands have adopted (those are frozen), and how many brands search it. These libraries are shared by every brand.
 */
  async resourcedColorLibraries_GetLibraries(options: AxiosRequestConfig = {}): Promise<ManagedLibraryDto[]> {
    let url_ = this.baseUrl + "/api/resourced-admin/color-libraries";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create an empty colour library, placed last. Names are unique. Fill it with resourcedColorLibraries_AddColor or an import. No brand searches it until a brand enables it.
 */
  async resourcedColorLibraries_CreateLibrary(name: string, options: AxiosRequestConfig = {}): Promise<ManagedLibraryDto[]> {
    let url_ = this.baseUrl + "/api/resourced-admin/color-libraries";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = name;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Every colour in one library, ordered by code, each with the brands that adopted it (empty when none — only those colours may be edited or deleted).
 */
  async resourcedColorLibraries_GetColors(libraryId: number, options: AxiosRequestConfig = {}): Promise<ManagedColorDto[]> {
    let url_ = this.baseUrl + "/api/resourced-admin/color-libraries/{libraryId}/colors";
    if (libraryId === undefined || libraryId === null)
        throw new Error("The parameter 'libraryId' must be defined.");
    url_ = url_.replace("{libraryId}", encodeURIComponent("" + libraryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Add one colour to a library. Code must be unique within the library; R, G, B are 0–255 and C, M, Y, K 0–100.
 */
  async resourcedColorLibraries_AddColor(libraryId: number, values: ColorValues, options: AxiosRequestConfig = {}): Promise<LibraryColorDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/color-libraries/{libraryId}/colors";
    if (libraryId === undefined || libraryId === null)
        throw new Error("The parameter 'libraryId' must be defined.");
    url_ = url_.replace("{libraryId}", encodeURIComponent("" + libraryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = values;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Rename a colour library. Every brand sees the new name.
 */
  async resourcedColorLibraries_RenameLibrary(libraryId: number, name: string, options: AxiosRequestConfig = {}): Promise<ManagedLibraryDto[]> {
    let url_ = this.baseUrl + "/api/resourced-admin/color-libraries/{libraryId}/name";
    if (libraryId === undefined || libraryId === null)
        throw new Error("The parameter 'libraryId' must be defined.");
    url_ = url_.replace("{libraryId}", encodeURIComponent("" + libraryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = name;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the order libraries appear in, in every brand's picker: the ids listed come first, in that order; any library left out keeps its relative place after them.
 */
  async resourcedColorLibraries_ReorderLibraries(libraryIds: number[], options: AxiosRequestConfig = {}): Promise<ManagedLibraryDto[]> {
    let url_ = this.baseUrl + "/api/resourced-admin/color-libraries/order";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = libraryIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a library with all its colours and every brand's opt-in to it. Refused while any brand has adopted one of its colours.
 */
  async resourcedColorLibraries_DeleteLibrary(libraryId: number, options: AxiosRequestConfig = {}): Promise<ManagedLibraryDto[]> {
    let url_ = this.baseUrl + "/api/resourced-admin/color-libraries/{libraryId}";
    if (libraryId === undefined || libraryId === null)
        throw new Error("The parameter 'libraryId' must be defined.");
    url_ = url_.replace("{libraryId}", encodeURIComponent("" + libraryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Replace every value of one library colour, code included. Refused when any brand has adopted it — an adopted colour is frozen.
 */
  async resourcedColorLibraries_EditColor(colorId: number, values: ColorValues, options: AxiosRequestConfig = {}): Promise<LibraryColorDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/color-libraries/colors/{colorId}";
    if (colorId === undefined || colorId === null)
        throw new Error("The parameter 'colorId' must be defined.");
    url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = values;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete one library colour. Refused when any brand has adopted it.
 */
  async resourcedColorLibraries_DeleteColor(colorId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/resourced-admin/color-libraries/colors/{colorId}";
    if (colorId === undefined || colorId === null)
        throw new Error("The parameter 'colorId' must be defined.");
    url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Saves nothing: what importing this file into the library would do. The file is .xlsx or .csv whose
first row names the columns Code, Name, R, G, B and optionally C, M, Y, K; rows match existing
colours by code. Returns the colours it would add, the ones it would change, how many rows already
match, and `blocked` — adopted colours it would change. If `blocked` is not empty the import will
be refused whole. The file goes through request_upload.
 * @param file (optional) 
 */
  async resourcedColorLibraries_PreviewImport(libraryId: number, file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<ImportPreview> {
    let url_ = this.baseUrl + "/api/resourced-admin/color-libraries/{libraryId}/import/preview";
    if (libraryId === undefined || libraryId === null)
        throw new Error("The parameter 'libraryId' must be defined.");
    url_ = url_.replace("{libraryId}", encodeURIComponent("" + libraryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Import a file into the library (same format as resourcedColorLibraries_PreviewImport): adds new
codes and updates changed ones, never deletes colours the file leaves out. Refused whole, saving
nothing, if it would change any adopted colour. Preview first. The file goes through request_upload.
 * @param file (optional) 
 */
  async resourcedColorLibraries_ApplyImport(libraryId: number, file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<ImportPreview> {
    let url_ = this.baseUrl + "/api/resourced-admin/color-libraries/{libraryId}/import";
    if (libraryId === undefined || libraryId === null)
        throw new Error("The parameter 'libraryId' must be defined.");
    url_ = url_.replace("{libraryId}", encodeURIComponent("" + libraryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Search every company on the platform, not only yours, one tab at a time: PlmBrands, OtherBrands
(brands without PLM), Suppliers or Agents — or every company when tab is left out. query matches
name or member email (every word must match); withoutUsers keeps companies nobody belongs to;
connectedTo (a company id) keeps, on a supplier tab, that brand's suppliers and, on a brand tab,
the brands that have that supplier. Sort by Name, Members, Created, ConnectedCompanies (a brand's
suppliers, a supplier's brands), Articles or LastActive. Windowed: offset is 0-based, limit at
most 200; `total` counts the tab's matches and `counts` every tab's. A brand's company carries
its brandId and PLM state; the company id is what resourcedUsers_Connect and
resourcedCompanies_AddMembers take.
 */
  async resourcedCompanies_Search(args: CompanySearchArgs, options: AxiosRequestConfig = {}): Promise<CompanyPage> {
    let url_ = this.baseUrl + "/api/resourced-admin/companies/search";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * One company in full: as Search returns it, plus its members (with their roles in its brand) and, for a supplier, every brand that has it.
 */
  async resourcedCompanies_Get(companyId: number, options: AxiosRequestConfig = {}): Promise<CompanyDetailDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/companies/{companyId}";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a company nothing depends on. Refused, naming why, while it has members, a brand, or any supplier relationship.
 */
  async resourcedCompanies_Delete(companyId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/resourced-admin/companies/{companyId}";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a new brand with PLM switched on: its company, the brand, and its PLM configuration —
the default set, or a copy of copyFromBrandId's (any brand whose PLM is configured; the copy
runs in the background). You become a member, and so does everyone in userEmails, each of
which must already have an account (create missing ones with resourcedUsers_Create first).
Names are unique among brands.
 */
  async resourcedCompanies_CreatePlmBrand(args: CreatePlmBrandArgs, options: AxiosRequestConfig = {}): Promise<GlobalCompanyDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/companies/plm-brands";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Rename a company. A brand's name must not be another brand's; other companies may share names.
 */
  async resourcedCompanies_Rename(companyId: number, name: string, options: AxiosRequestConfig = {}): Promise<CompanyDetailDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/companies/{companyId}/name";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = name;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedCompanies_SetRequires2fa(companyId: number, requires2fa: boolean, options: AxiosRequestConfig = {}): Promise<CompanyDetailDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/companies/{companyId}/requires-2fa";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = requires2fa;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Switch PLM on for an existing brand without it (the OtherBrands tab), making you a member. A
brand never configured before is provisioned — the default configuration, or a copy of
copyFromBrandId's (any configured brand; the copy runs in the background). A brand configured
before keeps its configuration, and copyFromBrandId is refused for it.
 */
  async resourcedCompanies_TurnOnPlm(companyId: number, args: TurnOnPlmArgs, options: AxiosRequestConfig = {}): Promise<CompanyDetailDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/companies/{companyId}/plm";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Make several people members of a company at once: everyone in emails (each must have an
account — resourcedUsers_Lookup tells which do) and, created first, everyone in create (email +
name; refused if the email already has an account). All or nothing; existing members are fine.
 */
  async resourcedCompanies_AddMembers(companyId: number, args: AddMembersArgs, options: AxiosRequestConfig = {}): Promise<CompanyDetailDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/companies/{companyId}/members";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The supplier portal at this company: its people with their portal role and the brand
            relationships each may see, every brand relationship of the company (with the portal on or
            not), and pending invitations. People without a portal role are listed too, with role None.
 */
  async resourcedCompanies_GetPortalPeople(companyId: number, options: AxiosRequestConfig = {}): Promise<SupplierPortalPeopleDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/companies/{companyId}/portal";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set one member's supplier portal role and the brand relationships they may see,
            replacing their whole list. Role None takes them out of the portal; it does not remove them
            from the company.
 */
  async resourcedCompanies_SetPortalPerson(companyId: number, userId: string, args: SetPortalPersonArgs, options: AxiosRequestConfig = {}): Promise<SupplierPortalPeopleDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/companies/{companyId}/portal/people/{userId}";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedCompanies_SetLogo(companyId: number, logo: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<CompanyDetailDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/companies/{companyId}/logo";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (logo !== null && logo !== undefined)
        content_.append("Logo", logo, logo.name ? logo.name : "Logo");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedDiagnostics_GetSemaphoreLocks(options: AxiosRequestConfig = {}): Promise<HeldSemaphoreLockDto[]> {
    let url_ = this.baseUrl + "/api/resourced-admin/diagnostics/semaphore-locks";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Usage summary for every brand on the platform: activity, content counts and health per brand. Resourced staff are left out of the activity figures. Global, not scoped to the brands you are a member of.
 */
  async resourcedStatistics_GetAllBrands(options: AxiosRequestConfig = {}): Promise<AllBrandsStatisticsDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/statistics";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Detailed statistics for one brand, any brand on the platform — you need not be a member of it. Brand ids come from resourcedCompanies_Search.
 */
  async resourcedStatistics_GetBrand(brandId: number, options: AxiosRequestConfig = {}): Promise<BrandStatisticsDetailDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/statistics/{brandId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Per-user activity in one brand over the last windowDays (default when omitted), any brand on the platform.
 * @param windowDays (optional) 
 */
  async resourcedStatistics_GetUserActivity(brandId: number, windowDays: number | null | undefined, options: AxiosRequestConfig = {}): Promise<BrandUserActivityDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/statistics/{brandId}/user-activity?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (windowDays !== undefined && windowDays !== null)
        url_ += "windowDays=" + encodeURIComponent("" + windowDays) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Search every user on the platform — not only your brands' — by email or name (every word must
match). Filters: companyId (member of that company — for a brand, its company id from
resourcedCompanies_Search), status (Active, Deactivated, Locked = temporarily locked after failed
sign-ins), signIn (Password, External = a linked login such as LinkedIn, None = cannot sign in),
neverSignedIn, plmOnly (member of a brand with PLM on), apiKeyOnly, adminOnly. Sorted by sort
(Email, Name, LastActive, Created), descending if asked. Windowed: offset is 0-based, limit at
most 200; `total` counts every match. Each user lists all their memberships, PLM brands first.
 */
  async resourcedUsers_Search(args: UserSearchArgs, options: AxiosRequestConfig = {}): Promise<UserPage> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/search";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * One user in full: the user as Search returns it, their roles in each PLM brand they belong to
(beside every role that brand has), and every API key they hold, revoked and system keys included.
 */
  async resourcedUsers_Get(userId: string, options: AxiosRequestConfig = {}): Promise<UserDetailDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/{userId}";
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Resolve a list of emails to accounts, e.g. before adding several people to a company. Returns
the users found and, separately, the emails with no account (create those with
resourcedUsers_Create). Blank and repeated entries are dropped; case does not matter.
 */
  async resourcedUsers_Lookup(emails: string[], options: AxiosRequestConfig = {}): Promise<LookupResult> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/lookup";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = emails;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create an account, optionally a member of companyId straight away. Refused when the email already
has an account — connect that one with resourcedUsers_Connect instead. Without a password the
account can't sign in until one is set in the Users admin page (or the user resets it).
 */
  async resourcedUsers_Create(args: CreateUserArgs, options: AxiosRequestConfig = {}): Promise<GlobalUserDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/users";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Make an existing user (by email) a member of a company — for a brand's company, that gives them
the brand. Already being a member is fine. Company ids come from resourcedCompanies_Search. Brand
roles are not set here; the brand's own user admin does that.
 */
  async resourcedUsers_Connect(args: MembershipArgs, options: AxiosRequestConfig = {}): Promise<GlobalUserDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/connect";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Remove a user (by email) from a company, and with it from that company's brand. Not being a member is fine. The account itself stays.
 */
  async resourcedUsers_Disconnect(args: MembershipArgs, options: AxiosRequestConfig = {}): Promise<GlobalUserDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/disconnect";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedUsers_SetAdmin(userId: string, isAdmin: boolean, options: AxiosRequestConfig = {}): Promise<GlobalUserDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/{userId}/admin";
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = isAdmin;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedUsers_SetPassword(userId: string, password: string, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/{userId}/password";
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = password;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedUsers_SetDeactivated(userId: string, deactivated: boolean, options: AxiosRequestConfig = {}): Promise<GlobalUserDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/{userId}/deactivated";
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = deactivated;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Rename a user. The name is what colleagues see; it is not the sign-in, which stays the email.
 */
  async resourcedUsers_SetName(userId: string, name: string, options: AxiosRequestConfig = {}): Promise<GlobalUserDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/{userId}/name";
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = name;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedUsers_SetPhoto(userId: string, photo: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<GlobalUserDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/{userId}/photo";
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (photo !== null && photo !== undefined)
        content_.append("Photo", photo, photo.name ? photo.name : "Photo");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedUsers_SetBrandRoles(userId: string, brandId: number, args: SetBrandRolesArgs, options: AxiosRequestConfig = {}): Promise<UserDetailDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/{userId}/brands/{brandId}/roles";
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Turn off a user's two-factor sign-in and forget their authenticator key and recovery codes —
for someone who lost their phone. Sessions they already have keep working. If a brand of theirs
requires 2FA, they set it up again at their next sign-in. Doing it for a user without 2FA is fine.
 */
  async resourcedUsers_ResetTwoFactor(userId: string, options: AxiosRequestConfig = {}): Promise<GlobalUserDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/{userId}/reset-two-factor";
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedUsers_RevokeApiKey(userId: string, keyId: number, options: AxiosRequestConfig = {}): Promise<UserDetailDto> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/{userId}/api-keys/{keyId}/revoke";
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    if (keyId === undefined || keyId === null)
        throw new Error("The parameter 'keyId' must be defined.");
    url_ = url_.replace("{keyId}", encodeURIComponent("" + keyId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedUsers_SignInAs(userId: string, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/{userId}/sign-in-as";
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedUsers_GetExcel(args: UserSearchArgs, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/resourced-admin/users/excel";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      responseType: "blob",
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedEmail_SendRequestDemoEmail(args: SendRequestDemoEmailArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/email/demo";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedEmail_SendRequestSignUpEmail(args: SendRequestSignUpEmailArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/email/sign-up";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async resourcedEmail_SendContactEmail(args: SendContactEmailArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/email/contact";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async role_GetRoles(brandId: number, options: AxiosRequestConfig = {}): Promise<RoleDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/roles";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async role_AddRole(brandId: number, args: AddRoleArgs, options: AxiosRequestConfig = {}): Promise<RoleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/roles";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async role_UpdateRole(brandId: number, roleId: number, args: UpdateRoleArgs, options: AxiosRequestConfig = {}): Promise<RoleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/roles/{roleId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (roleId === undefined || roleId === null)
        throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async role_DeleteRole(brandId: number, roleId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/roles/{roleId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (roleId === undefined || roleId === null)
        throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async role_ReorderRoles(brandId: number, roleIds: number[], options: AxiosRequestConfig = {}): Promise<RoleDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/roles/reorder";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = roleIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async role_CountUsages(brandId: number, roleId: number, options: AxiosRequestConfig = {}): Promise<RoleUsagesDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/roles/{roleId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (roleId === undefined || roleId === null)
        throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set which roles one user holds in this brand. Replaces that user's roles with the list given, so send every role they should keep.
 */
  async role_SetUserRoles(brandId: number, args: SetUserRolesArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/roles/user-roles";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRound_GetAnnotatedSampleRoundImage(imageId: number, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/sample-round-images/{imageId}/annotated";
    if (imageId === undefined || imageId === null)
        throw new Error("The parameter 'imageId' must be defined.");
    url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read several sample rounds in full by id.
 * @param ids (optional) 
 */
  async sampleRound_GetSampleRoundsByIds(brandId: number, ids: number[] | undefined, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/by-ids?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (ids === null)
        throw new Error("The parameter 'ids' cannot be null.");
    else if (ids !== undefined)
        ids && ids.forEach(item => { url_ += "ids=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRound_ListAllSampleRounds(args: SampleRound_ListAllSampleRoundsArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    const { brandId, supplierIds, seasonIds, sampleRoundTypeIds, sampleStatusIds, measurementStatusIds, createdByUserIds, searchTerm, excludeClosed, peopleEmails, } = args;
    const articleFilters_HierarchyNodeIds = args.articleFilters?.hierarchyNodeIds;
    const articleFilters_ProductCategoryIds = args.articleFilters?.productCategoryIds;
    const articleFilters_Genders = args.articleFilters?.genders;
    const articleFilters_SeasonIds = args.articleFilters?.seasonIds;
    const articleFilters_Colors = args.articleFilters?.colors;
    const articleFilters_SupplierIds = args.articleFilters?.supplierIds;
    const articleFilters_DropDateRange_From = args.articleFilters?.dropDateRange?.from;
    const articleFilters_DropDateRange_To = args.articleFilters?.dropDateRange?.to;
    const articleFilters_DropNames = args.articleFilters?.dropNames;
    const articleFilters_StatusIds = args.articleFilters?.statusIds;
    const articleFilters_TagIds = args.articleFilters?.tagIds;
    const articleFilters_SearchTerm = args.articleFilters?.searchTerm;
    const articleFilters_CustomFieldOptionIds = args.articleFilters?.customFieldOptionIds;
    const articleFilters_CreatedByUserIds = args.articleFilters?.createdByUserIds;
    const articleFilters_AssignedUserIds = args.articleFilters?.assignedUserIds;
    const articleFilters_ColorGroupIds = args.articleFilters?.colorGroupIds;
    const articleFilters_OutPriceAmounts = args.articleFilters?.outPriceAmounts;
    const articleFilters_OutPriceRanges = args.articleFilters?.outPriceRanges;
    const articleFilters_SizeSystemIds = args.articleFilters?.sizeSystemIds;
    const articleFilters_TimelineHealth = args.articleFilters?.timelineHealth;
    const articleFilters_NextGateRoleIds = args.articleFilters?.nextGateRoleIds;
    const articleFilters_NextGateNames = args.articleFilters?.nextGateNames;
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (sampleRoundTypeIds !== undefined && sampleRoundTypeIds !== null)
        sampleRoundTypeIds && sampleRoundTypeIds.forEach(item => { url_ += "SampleRoundTypeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (sampleStatusIds !== undefined && sampleStatusIds !== null)
        sampleStatusIds && sampleStatusIds.forEach(item => { url_ += "SampleStatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (measurementStatusIds !== undefined && measurementStatusIds !== null)
        measurementStatusIds && measurementStatusIds.forEach(item => { url_ += "MeasurementStatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (excludeClosed === null)
        throw new Error("The parameter 'excludeClosed' cannot be null.");
    else if (excludeClosed !== undefined)
        url_ += "ExcludeClosed=" + encodeURIComponent("" + excludeClosed) + "&";
    if (articleFilters_HierarchyNodeIds !== undefined && articleFilters_HierarchyNodeIds !== null)
        articleFilters_HierarchyNodeIds && articleFilters_HierarchyNodeIds.forEach(item => { url_ += "ArticleFilters.HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_ProductCategoryIds !== undefined && articleFilters_ProductCategoryIds !== null)
        articleFilters_ProductCategoryIds && articleFilters_ProductCategoryIds.forEach(item => { url_ += "ArticleFilters.ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_Genders !== undefined && articleFilters_Genders !== null)
        articleFilters_Genders && articleFilters_Genders.forEach(item => { url_ += "ArticleFilters.Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_SeasonIds !== undefined && articleFilters_SeasonIds !== null)
        articleFilters_SeasonIds && articleFilters_SeasonIds.forEach(item => { url_ += "ArticleFilters.SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_Colors !== undefined && articleFilters_Colors !== null)
        articleFilters_Colors && articleFilters_Colors.forEach(item => { url_ += "ArticleFilters.Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_SupplierIds !== undefined && articleFilters_SupplierIds !== null)
        articleFilters_SupplierIds && articleFilters_SupplierIds.forEach(item => { url_ += "ArticleFilters.SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_DropDateRange_From !== undefined && articleFilters_DropDateRange_From !== null)
        url_ += "ArticleFilters.DropDateRange.From=" + encodeURIComponent("" + articleFilters_DropDateRange_From) + "&";
    if (articleFilters_DropDateRange_To !== undefined && articleFilters_DropDateRange_To !== null)
        url_ += "ArticleFilters.DropDateRange.To=" + encodeURIComponent("" + articleFilters_DropDateRange_To) + "&";
    if (articleFilters_DropNames !== undefined && articleFilters_DropNames !== null)
        articleFilters_DropNames && articleFilters_DropNames.forEach(item => { url_ += "ArticleFilters.DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_StatusIds !== undefined && articleFilters_StatusIds !== null)
        articleFilters_StatusIds && articleFilters_StatusIds.forEach(item => { url_ += "ArticleFilters.StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_TagIds !== undefined && articleFilters_TagIds !== null)
        articleFilters_TagIds && articleFilters_TagIds.forEach(item => { url_ += "ArticleFilters.TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_SearchTerm !== undefined && articleFilters_SearchTerm !== null)
        url_ += "ArticleFilters.SearchTerm=" + encodeURIComponent("" + articleFilters_SearchTerm) + "&";
    if (articleFilters_CustomFieldOptionIds !== undefined && articleFilters_CustomFieldOptionIds !== null)
        url_ += appendDictionaryQuery("ArticleFilters.CustomFieldOptionIds", articleFilters_CustomFieldOptionIds);
    if (articleFilters_CreatedByUserIds !== undefined && articleFilters_CreatedByUserIds !== null)
        articleFilters_CreatedByUserIds && articleFilters_CreatedByUserIds.forEach(item => { url_ += "ArticleFilters.CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_AssignedUserIds !== undefined && articleFilters_AssignedUserIds !== null)
        articleFilters_AssignedUserIds && articleFilters_AssignedUserIds.forEach(item => { url_ += "ArticleFilters.AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_ColorGroupIds !== undefined && articleFilters_ColorGroupIds !== null)
        articleFilters_ColorGroupIds && articleFilters_ColorGroupIds.forEach(item => { url_ += "ArticleFilters.ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_OutPriceAmounts !== undefined && articleFilters_OutPriceAmounts !== null)
        url_ += appendDictionaryQuery("ArticleFilters.OutPriceAmounts", articleFilters_OutPriceAmounts);
    if (articleFilters_OutPriceRanges !== undefined && articleFilters_OutPriceRanges !== null)
        url_ += appendDictionaryQuery("ArticleFilters.OutPriceRanges", articleFilters_OutPriceRanges);
    if (articleFilters_SizeSystemIds !== undefined && articleFilters_SizeSystemIds !== null)
        articleFilters_SizeSystemIds && articleFilters_SizeSystemIds.forEach(item => { url_ += "ArticleFilters.SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_TimelineHealth !== undefined && articleFilters_TimelineHealth !== null)
        articleFilters_TimelineHealth && articleFilters_TimelineHealth.forEach(item => { url_ += "ArticleFilters.TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_NextGateRoleIds !== undefined && articleFilters_NextGateRoleIds !== null)
        articleFilters_NextGateRoleIds && articleFilters_NextGateRoleIds.forEach(item => { url_ += "ArticleFilters.NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_NextGateNames !== undefined && articleFilters_NextGateNames !== null)
        articleFilters_NextGateNames && articleFilters_NextGateNames.forEach(item => { url_ += "ArticleFilters.NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (peopleEmails !== undefined && peopleEmails !== null)
        peopleEmails && peopleEmails.forEach(item => { url_ += "PeopleEmails=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List sample rounds in a light shape. Prefer sampleRound_GetSampleRoundsTable when filtering or paging.
 * @param supplierIds (optional) 
 * @param seasonIds (optional) 
 * @param sampleRoundTypeIds (optional) 
 * @param sampleStatusIds (optional) 
 * @param measurementStatusIds (optional) 
 * @param createdByUserIds (optional) 
 * @param searchTerm (optional) 
 * @param excludeClosed (optional) 
 * @param articleFilters_HierarchyNodeIds (optional) 
 * @param articleFilters_ProductCategoryIds (optional) 
 * @param articleFilters_Genders (optional) 
 * @param articleFilters_SeasonIds (optional) 
 * @param articleFilters_Colors (optional) 
 * @param articleFilters_SupplierIds (optional) 
 * @param articleFilters_DropDateRange_From (optional) 
 * @param articleFilters_DropDateRange_To (optional) 
 * @param articleFilters_DropNames (optional) 
 * @param articleFilters_StatusIds (optional) 
 * @param articleFilters_TagIds (optional) 
 * @param articleFilters_SearchTerm (optional) 
 * @param articleFilters_CustomFieldOptionIds (optional) 
 * @param articleFilters_CreatedByUserIds (optional) 
 * @param articleFilters_AssignedUserIds (optional) 
 * @param articleFilters_ColorGroupIds (optional) 
 * @param articleFilters_OutPriceAmounts (optional) 
 * @param articleFilters_OutPriceRanges (optional) 
 * @param articleFilters_SizeSystemIds (optional) 
 * @param articleFilters_TimelineHealth (optional) 
 * @param articleFilters_NextGateRoleIds (optional) 
 * @param articleFilters_NextGateNames (optional) 
 * @param peopleEmails (optional) 
 */
  async sampleRound_ListAllSampleRoundsLight(args: SampleRound_ListAllSampleRoundsLightArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundListDto[]> {
    const { brandId, supplierIds, seasonIds, sampleRoundTypeIds, sampleStatusIds, measurementStatusIds, createdByUserIds, searchTerm, excludeClosed, peopleEmails, } = args;
    const articleFilters_HierarchyNodeIds = args.articleFilters?.hierarchyNodeIds;
    const articleFilters_ProductCategoryIds = args.articleFilters?.productCategoryIds;
    const articleFilters_Genders = args.articleFilters?.genders;
    const articleFilters_SeasonIds = args.articleFilters?.seasonIds;
    const articleFilters_Colors = args.articleFilters?.colors;
    const articleFilters_SupplierIds = args.articleFilters?.supplierIds;
    const articleFilters_DropDateRange_From = args.articleFilters?.dropDateRange?.from;
    const articleFilters_DropDateRange_To = args.articleFilters?.dropDateRange?.to;
    const articleFilters_DropNames = args.articleFilters?.dropNames;
    const articleFilters_StatusIds = args.articleFilters?.statusIds;
    const articleFilters_TagIds = args.articleFilters?.tagIds;
    const articleFilters_SearchTerm = args.articleFilters?.searchTerm;
    const articleFilters_CustomFieldOptionIds = args.articleFilters?.customFieldOptionIds;
    const articleFilters_CreatedByUserIds = args.articleFilters?.createdByUserIds;
    const articleFilters_AssignedUserIds = args.articleFilters?.assignedUserIds;
    const articleFilters_ColorGroupIds = args.articleFilters?.colorGroupIds;
    const articleFilters_OutPriceAmounts = args.articleFilters?.outPriceAmounts;
    const articleFilters_OutPriceRanges = args.articleFilters?.outPriceRanges;
    const articleFilters_SizeSystemIds = args.articleFilters?.sizeSystemIds;
    const articleFilters_TimelineHealth = args.articleFilters?.timelineHealth;
    const articleFilters_NextGateRoleIds = args.articleFilters?.nextGateRoleIds;
    const articleFilters_NextGateNames = args.articleFilters?.nextGateNames;
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/list?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (sampleRoundTypeIds !== undefined && sampleRoundTypeIds !== null)
        sampleRoundTypeIds && sampleRoundTypeIds.forEach(item => { url_ += "SampleRoundTypeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (sampleStatusIds !== undefined && sampleStatusIds !== null)
        sampleStatusIds && sampleStatusIds.forEach(item => { url_ += "SampleStatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (measurementStatusIds !== undefined && measurementStatusIds !== null)
        measurementStatusIds && measurementStatusIds.forEach(item => { url_ += "MeasurementStatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (excludeClosed === null)
        throw new Error("The parameter 'excludeClosed' cannot be null.");
    else if (excludeClosed !== undefined)
        url_ += "ExcludeClosed=" + encodeURIComponent("" + excludeClosed) + "&";
    if (articleFilters_HierarchyNodeIds !== undefined && articleFilters_HierarchyNodeIds !== null)
        articleFilters_HierarchyNodeIds && articleFilters_HierarchyNodeIds.forEach(item => { url_ += "ArticleFilters.HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_ProductCategoryIds !== undefined && articleFilters_ProductCategoryIds !== null)
        articleFilters_ProductCategoryIds && articleFilters_ProductCategoryIds.forEach(item => { url_ += "ArticleFilters.ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_Genders !== undefined && articleFilters_Genders !== null)
        articleFilters_Genders && articleFilters_Genders.forEach(item => { url_ += "ArticleFilters.Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_SeasonIds !== undefined && articleFilters_SeasonIds !== null)
        articleFilters_SeasonIds && articleFilters_SeasonIds.forEach(item => { url_ += "ArticleFilters.SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_Colors !== undefined && articleFilters_Colors !== null)
        articleFilters_Colors && articleFilters_Colors.forEach(item => { url_ += "ArticleFilters.Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_SupplierIds !== undefined && articleFilters_SupplierIds !== null)
        articleFilters_SupplierIds && articleFilters_SupplierIds.forEach(item => { url_ += "ArticleFilters.SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_DropDateRange_From !== undefined && articleFilters_DropDateRange_From !== null)
        url_ += "ArticleFilters.DropDateRange.From=" + encodeURIComponent("" + articleFilters_DropDateRange_From) + "&";
    if (articleFilters_DropDateRange_To !== undefined && articleFilters_DropDateRange_To !== null)
        url_ += "ArticleFilters.DropDateRange.To=" + encodeURIComponent("" + articleFilters_DropDateRange_To) + "&";
    if (articleFilters_DropNames !== undefined && articleFilters_DropNames !== null)
        articleFilters_DropNames && articleFilters_DropNames.forEach(item => { url_ += "ArticleFilters.DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_StatusIds !== undefined && articleFilters_StatusIds !== null)
        articleFilters_StatusIds && articleFilters_StatusIds.forEach(item => { url_ += "ArticleFilters.StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_TagIds !== undefined && articleFilters_TagIds !== null)
        articleFilters_TagIds && articleFilters_TagIds.forEach(item => { url_ += "ArticleFilters.TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_SearchTerm !== undefined && articleFilters_SearchTerm !== null)
        url_ += "ArticleFilters.SearchTerm=" + encodeURIComponent("" + articleFilters_SearchTerm) + "&";
    if (articleFilters_CustomFieldOptionIds !== undefined && articleFilters_CustomFieldOptionIds !== null)
        url_ += appendDictionaryQuery("ArticleFilters.CustomFieldOptionIds", articleFilters_CustomFieldOptionIds);
    if (articleFilters_CreatedByUserIds !== undefined && articleFilters_CreatedByUserIds !== null)
        articleFilters_CreatedByUserIds && articleFilters_CreatedByUserIds.forEach(item => { url_ += "ArticleFilters.CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_AssignedUserIds !== undefined && articleFilters_AssignedUserIds !== null)
        articleFilters_AssignedUserIds && articleFilters_AssignedUserIds.forEach(item => { url_ += "ArticleFilters.AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_ColorGroupIds !== undefined && articleFilters_ColorGroupIds !== null)
        articleFilters_ColorGroupIds && articleFilters_ColorGroupIds.forEach(item => { url_ += "ArticleFilters.ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_OutPriceAmounts !== undefined && articleFilters_OutPriceAmounts !== null)
        url_ += appendDictionaryQuery("ArticleFilters.OutPriceAmounts", articleFilters_OutPriceAmounts);
    if (articleFilters_OutPriceRanges !== undefined && articleFilters_OutPriceRanges !== null)
        url_ += appendDictionaryQuery("ArticleFilters.OutPriceRanges", articleFilters_OutPriceRanges);
    if (articleFilters_SizeSystemIds !== undefined && articleFilters_SizeSystemIds !== null)
        articleFilters_SizeSystemIds && articleFilters_SizeSystemIds.forEach(item => { url_ += "ArticleFilters.SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_TimelineHealth !== undefined && articleFilters_TimelineHealth !== null)
        articleFilters_TimelineHealth && articleFilters_TimelineHealth.forEach(item => { url_ += "ArticleFilters.TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_NextGateRoleIds !== undefined && articleFilters_NextGateRoleIds !== null)
        articleFilters_NextGateRoleIds && articleFilters_NextGateRoleIds.forEach(item => { url_ += "ArticleFilters.NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_NextGateNames !== undefined && articleFilters_NextGateNames !== null)
        articleFilters_NextGateNames && articleFilters_NextGateNames.forEach(item => { url_ += "ArticleFilters.NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (peopleEmails !== undefined && peopleEmails !== null)
        peopleEmails && peopleEmails.forEach(item => { url_ += "PeopleEmails=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Everyone the brand's sent sample rounds were addressed to, To and Cc, with the name and photo of those who have an account and how many rounds name them. Pass the emails as peopleEmails to the list or table to find the rounds a person is on.
 */
  async sampleRound_GetSampleRoundPeople(brandId: number, options: AxiosRequestConfig = {}): Promise<SampleRoundPersonDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/people";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read one sample round in full, with its events.
 */
  async sampleRound_GetSampleRound(brandId: number, sampleRoundId: number, options: AxiosRequestConfig = {}): Promise<SampleRoundDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a sample round and its events.
 */
  async sampleRound_DeleteSampleRound(brandId: number, sampleRoundId: number, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Edit a sample round that is still a draft. Once published, use the event endpoints instead.
 */
  async sampleRound_UpdateDraftRound(brandId: number, sampleRoundId: number, args: UpdateDraftRoundArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read one sample round by its human-readable display number (e.g. "R17678" or "G10-1") rather than its id.
 */
  async sampleRound_GetSampleRoundByNumber(brandId: number, sampleRoundNumber: string, options: AxiosRequestConfig = {}): Promise<SampleRoundDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/by-number/{sampleRoundNumber}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundNumber === undefined || sampleRoundNumber === null)
        throw new Error("The parameter 'sampleRoundNumber' must be defined.");
    url_ = url_.replace("{sampleRoundNumber}", encodeURIComponent("" + sampleRoundNumber));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The filtered, paged table over sample rounds. Use this to find rounds by status, type, supplier or season — the List endpoints do not filter as richly.
 * @param supplierIds (optional) 
 * @param seasonIds (optional) 
 * @param sampleRoundTypeIds (optional) 
 * @param sampleStatusIds (optional) 
 * @param measurementStatusIds (optional) 
 * @param createdByUserIds (optional) 
 * @param searchTerm (optional) 
 * @param excludeClosed (optional) 
 * @param articleFilters_HierarchyNodeIds (optional) 
 * @param articleFilters_ProductCategoryIds (optional) 
 * @param articleFilters_Genders (optional) 
 * @param articleFilters_SeasonIds (optional) 
 * @param articleFilters_Colors (optional) 
 * @param articleFilters_SupplierIds (optional) 
 * @param articleFilters_DropDateRange_From (optional) 
 * @param articleFilters_DropDateRange_To (optional) 
 * @param articleFilters_DropNames (optional) 
 * @param articleFilters_StatusIds (optional) 
 * @param articleFilters_TagIds (optional) 
 * @param articleFilters_SearchTerm (optional) 
 * @param articleFilters_CustomFieldOptionIds (optional) 
 * @param articleFilters_CreatedByUserIds (optional) 
 * @param articleFilters_AssignedUserIds (optional) 
 * @param articleFilters_ColorGroupIds (optional) 
 * @param articleFilters_OutPriceAmounts (optional) 
 * @param articleFilters_OutPriceRanges (optional) 
 * @param articleFilters_SizeSystemIds (optional) 
 * @param articleFilters_TimelineHealth (optional) 
 * @param articleFilters_NextGateRoleIds (optional) 
 * @param articleFilters_NextGateNames (optional) 
 * @param peopleEmails (optional) 
 * @param offset (optional) 
 * @param limit (optional) 
 * @param groupBy (optional) 
 * @param sortBy (optional) 
 * @param sortDescending (optional) 
 */
  async sampleRound_GetSampleRoundsTable(args: SampleRound_GetSampleRoundsTableArgs, options: AxiosRequestConfig = {}): Promise<SampleTableResponse> {
    const { brandId, supplierIds, seasonIds, sampleRoundTypeIds, sampleStatusIds, measurementStatusIds, createdByUserIds, searchTerm, excludeClosed, peopleEmails, offset, limit, groupBy, sortBy, sortDescending, } = args;
    const articleFilters_HierarchyNodeIds = args.articleFilters?.hierarchyNodeIds;
    const articleFilters_ProductCategoryIds = args.articleFilters?.productCategoryIds;
    const articleFilters_Genders = args.articleFilters?.genders;
    const articleFilters_SeasonIds = args.articleFilters?.seasonIds;
    const articleFilters_Colors = args.articleFilters?.colors;
    const articleFilters_SupplierIds = args.articleFilters?.supplierIds;
    const articleFilters_DropDateRange_From = args.articleFilters?.dropDateRange?.from;
    const articleFilters_DropDateRange_To = args.articleFilters?.dropDateRange?.to;
    const articleFilters_DropNames = args.articleFilters?.dropNames;
    const articleFilters_StatusIds = args.articleFilters?.statusIds;
    const articleFilters_TagIds = args.articleFilters?.tagIds;
    const articleFilters_SearchTerm = args.articleFilters?.searchTerm;
    const articleFilters_CustomFieldOptionIds = args.articleFilters?.customFieldOptionIds;
    const articleFilters_CreatedByUserIds = args.articleFilters?.createdByUserIds;
    const articleFilters_AssignedUserIds = args.articleFilters?.assignedUserIds;
    const articleFilters_ColorGroupIds = args.articleFilters?.colorGroupIds;
    const articleFilters_OutPriceAmounts = args.articleFilters?.outPriceAmounts;
    const articleFilters_OutPriceRanges = args.articleFilters?.outPriceRanges;
    const articleFilters_SizeSystemIds = args.articleFilters?.sizeSystemIds;
    const articleFilters_TimelineHealth = args.articleFilters?.timelineHealth;
    const articleFilters_NextGateRoleIds = args.articleFilters?.nextGateRoleIds;
    const articleFilters_NextGateNames = args.articleFilters?.nextGateNames;
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/table?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (sampleRoundTypeIds !== undefined && sampleRoundTypeIds !== null)
        sampleRoundTypeIds && sampleRoundTypeIds.forEach(item => { url_ += "SampleRoundTypeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (sampleStatusIds !== undefined && sampleStatusIds !== null)
        sampleStatusIds && sampleStatusIds.forEach(item => { url_ += "SampleStatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (measurementStatusIds !== undefined && measurementStatusIds !== null)
        measurementStatusIds && measurementStatusIds.forEach(item => { url_ += "MeasurementStatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (excludeClosed === null)
        throw new Error("The parameter 'excludeClosed' cannot be null.");
    else if (excludeClosed !== undefined)
        url_ += "ExcludeClosed=" + encodeURIComponent("" + excludeClosed) + "&";
    if (articleFilters_HierarchyNodeIds !== undefined && articleFilters_HierarchyNodeIds !== null)
        articleFilters_HierarchyNodeIds && articleFilters_HierarchyNodeIds.forEach(item => { url_ += "ArticleFilters.HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_ProductCategoryIds !== undefined && articleFilters_ProductCategoryIds !== null)
        articleFilters_ProductCategoryIds && articleFilters_ProductCategoryIds.forEach(item => { url_ += "ArticleFilters.ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_Genders !== undefined && articleFilters_Genders !== null)
        articleFilters_Genders && articleFilters_Genders.forEach(item => { url_ += "ArticleFilters.Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_SeasonIds !== undefined && articleFilters_SeasonIds !== null)
        articleFilters_SeasonIds && articleFilters_SeasonIds.forEach(item => { url_ += "ArticleFilters.SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_Colors !== undefined && articleFilters_Colors !== null)
        articleFilters_Colors && articleFilters_Colors.forEach(item => { url_ += "ArticleFilters.Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_SupplierIds !== undefined && articleFilters_SupplierIds !== null)
        articleFilters_SupplierIds && articleFilters_SupplierIds.forEach(item => { url_ += "ArticleFilters.SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_DropDateRange_From !== undefined && articleFilters_DropDateRange_From !== null)
        url_ += "ArticleFilters.DropDateRange.From=" + encodeURIComponent("" + articleFilters_DropDateRange_From) + "&";
    if (articleFilters_DropDateRange_To !== undefined && articleFilters_DropDateRange_To !== null)
        url_ += "ArticleFilters.DropDateRange.To=" + encodeURIComponent("" + articleFilters_DropDateRange_To) + "&";
    if (articleFilters_DropNames !== undefined && articleFilters_DropNames !== null)
        articleFilters_DropNames && articleFilters_DropNames.forEach(item => { url_ += "ArticleFilters.DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_StatusIds !== undefined && articleFilters_StatusIds !== null)
        articleFilters_StatusIds && articleFilters_StatusIds.forEach(item => { url_ += "ArticleFilters.StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_TagIds !== undefined && articleFilters_TagIds !== null)
        articleFilters_TagIds && articleFilters_TagIds.forEach(item => { url_ += "ArticleFilters.TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_SearchTerm !== undefined && articleFilters_SearchTerm !== null)
        url_ += "ArticleFilters.SearchTerm=" + encodeURIComponent("" + articleFilters_SearchTerm) + "&";
    if (articleFilters_CustomFieldOptionIds !== undefined && articleFilters_CustomFieldOptionIds !== null)
        url_ += appendDictionaryQuery("ArticleFilters.CustomFieldOptionIds", articleFilters_CustomFieldOptionIds);
    if (articleFilters_CreatedByUserIds !== undefined && articleFilters_CreatedByUserIds !== null)
        articleFilters_CreatedByUserIds && articleFilters_CreatedByUserIds.forEach(item => { url_ += "ArticleFilters.CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_AssignedUserIds !== undefined && articleFilters_AssignedUserIds !== null)
        articleFilters_AssignedUserIds && articleFilters_AssignedUserIds.forEach(item => { url_ += "ArticleFilters.AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_ColorGroupIds !== undefined && articleFilters_ColorGroupIds !== null)
        articleFilters_ColorGroupIds && articleFilters_ColorGroupIds.forEach(item => { url_ += "ArticleFilters.ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_OutPriceAmounts !== undefined && articleFilters_OutPriceAmounts !== null)
        url_ += appendDictionaryQuery("ArticleFilters.OutPriceAmounts", articleFilters_OutPriceAmounts);
    if (articleFilters_OutPriceRanges !== undefined && articleFilters_OutPriceRanges !== null)
        url_ += appendDictionaryQuery("ArticleFilters.OutPriceRanges", articleFilters_OutPriceRanges);
    if (articleFilters_SizeSystemIds !== undefined && articleFilters_SizeSystemIds !== null)
        articleFilters_SizeSystemIds && articleFilters_SizeSystemIds.forEach(item => { url_ += "ArticleFilters.SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_TimelineHealth !== undefined && articleFilters_TimelineHealth !== null)
        articleFilters_TimelineHealth && articleFilters_TimelineHealth.forEach(item => { url_ += "ArticleFilters.TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_NextGateRoleIds !== undefined && articleFilters_NextGateRoleIds !== null)
        articleFilters_NextGateRoleIds && articleFilters_NextGateRoleIds.forEach(item => { url_ += "ArticleFilters.NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (articleFilters_NextGateNames !== undefined && articleFilters_NextGateNames !== null)
        articleFilters_NextGateNames && articleFilters_NextGateNames.forEach(item => { url_ += "ArticleFilters.NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (peopleEmails !== undefined && peopleEmails !== null)
        peopleEmails && peopleEmails.forEach(item => { url_ += "PeopleEmails=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (groupBy === null)
        throw new Error("The parameter 'groupBy' cannot be null.");
    else if (groupBy !== undefined)
        url_ += "groupBy=" + encodeURIComponent("" + groupBy) + "&";
    if (sortBy === null)
        throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
        url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortDescending === null)
        throw new Error("The parameter 'sortDescending' cannot be null.");
    else if (sortDescending !== undefined)
        url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read table rows for specific sample rounds — the shape the sample table renders.
 * @param roundIds (optional) 
 */
  async sampleRound_GetSampleTableRowsByRoundIds(brandId: number, roundIds: number[] | undefined, options: AxiosRequestConfig = {}): Promise<SampleTableRowDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/table/by-round-ids?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (roundIds === null)
        throw new Error("The parameter 'roundIds' cannot be null.");
    else if (roundIds !== undefined)
        roundIds && roundIds.forEach(item => { url_ += "roundIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read several sample rounds in a lighter list shape. Prefer this over sampleRound_GetSampleRoundsByIds when you only need summary fields.
 * @param ids (optional) 
 */
  async sampleRound_GetSampleRoundListItemsByIds(brandId: number, ids: number[] | undefined, options: AxiosRequestConfig = {}): Promise<SampleRoundListDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/list/by-ids?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (ids === null)
        throw new Error("The parameter 'ids' cannot be null.");
    else if (ids !== undefined)
        ids && ids.forEach(item => { url_ += "ids=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the sample rounds for one product.
 */
  async sampleRound_ListProductSampleRounds(brandId: number, productId: number, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/sample-rounds";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a sample round on an article. Its type decides which templates and statuses apply; resolve types with sampleRoundType_ListTypes.
 */
  async sampleRound_CreateSampleRound(brandId: number, productId: number, args: CreateSampleRoundArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/sample-rounds";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List files attached to a sample round.
 */
  async sampleRound_GetRelatedFiles(brandId: number, productId: number, options: AxiosRequestConfig = {}): Promise<ProductRelatedFileDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/related-files";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a group of sample rounds together.
 */
  async sampleRound_CreateSampleRoundGroup(brandId: number, args: CreateSampleRoundGroupArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-groups";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRound_DownloadSampleRoundAttachmentsZipOld(brandId: number, sampleRoundId: number, zipKey: string | undefined, productId: string, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/sample-rounds/{sampleRoundId}/attachments-zip-old?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (zipKey === null)
        throw new Error("The parameter 'zipKey' cannot be null.");
    else if (zipKey !== undefined)
        url_ += "zipKey=" + encodeURIComponent("" + zipKey) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRound_DownloadSampleRoundGroupAttachmentsZipOld(brandId: number, sampleRoundGroupId: number, zipKey: string | undefined, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-groups/{sampleRoundGroupId}/attachments-zip-old?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundGroupId === undefined || sampleRoundGroupId === null)
        throw new Error("The parameter 'sampleRoundGroupId' must be defined.");
    url_ = url_.replace("{sampleRoundGroupId}", encodeURIComponent("" + sampleRoundGroupId));
    if (zipKey === null)
        throw new Error("The parameter 'zipKey' cannot be null.");
    else if (zipKey !== undefined)
        url_ += "zipKey=" + encodeURIComponent("" + zipKey) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRound_DownloadSampleRoundAttachmentsZip(brandId: number, sampleRoundId: number, zipKey: string | undefined, productId: string, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/products/{productId}/sample-rounds/{sampleRoundId}/attachments-zip?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    if (zipKey === null)
        throw new Error("The parameter 'zipKey' cannot be null.");
    else if (zipKey !== undefined)
        url_ += "zipKey=" + encodeURIComponent("" + zipKey) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRound_DownloadSampleRoundGroupAttachmentsZip(brandId: number, sampleRoundGroupId: number, zipKey: string | undefined, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-groups/{sampleRoundGroupId}/attachments-zip?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundGroupId === undefined || sampleRoundGroupId === null)
        throw new Error("The parameter 'sampleRoundGroupId' must be defined.");
    url_ = url_.replace("{sampleRoundGroupId}", encodeURIComponent("" + sampleRoundGroupId));
    if (zipKey === null)
        throw new Error("The parameter 'zipKey' cannot be null.");
    else if (zipKey !== undefined)
        url_ += "zipKey=" + encodeURIComponent("" + zipKey) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Add a message event to a sample round. Set ReplacesDraftEventId to save an edit of a draft: that draft is replaced wholesale in the same transaction, so a rejected call leaves it untouched.
 */
  async sampleRound_CreateMessageEvent(brandId: number, sampleRoundId: number, args: CreateMessageEventArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/events/message";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Record that a sample was received. Set ReplacesDraftEventId to save an edit of a draft: that draft is replaced wholesale in the same transaction, so a rejected call leaves it untouched.
 */
  async sampleRound_CreateSampleReceivedEvent(brandId: number, sampleRoundId: number, args: CreateSampleReceivedArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/events/sample-received";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Record a sample review, with its comments and verdict. Set ReplacesDraftEventId to save an edit of a draft: that draft is replaced wholesale in the same transaction, so a rejected call leaves it untouched.
 */
  async sampleRound_CreateSampleReviewEvent(brandId: number, sampleRoundId: number, args: CreateSampleReviewArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/events/sample-review";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Record that a sample was sent. Set ReplacesDraftEventId to save an edit of a draft: that draft is replaced wholesale in the same transaction, so a rejected call leaves it untouched.
 */
  async sampleRound_CreateSampleSentEvent(brandId: number, sampleRoundId: number, args: CreateSampleSentArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/events/sample-sent";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Ask the supplier for more samples within the same round, e.g. extra sizes or articles
            that turned out to be needed after the round was sent. Samples maps each article (which must
            belong to the round's product) to size name → quantity; sizes the round lacks are added to it.
            Every entry creates a new sample row, so requesting a size the round already has adds to its
            quantity rather than replacing it. Refused on draft and closed rounds. Emails the supplier
            unless SendEmail is false.
 */
  async sampleRound_CreateSamplesRequestedEvent(brandId: number, sampleRoundId: number, args: CreateSamplesRequestedArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/events/samples-requested";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Close a sample round.
 */
  async sampleRound_CreateRoundClosedEvent(brandId: number, sampleRoundId: number, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/events/close-round";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Move a published sample round's deadline to a new date, recorded as a "deadline changed" event in the round feed that keeps the previous date. Refused for draft rounds (edit the draft instead), closed rounds and an unchanged date. With SendEmail the supplier is emailed about the new date.
 */
  async sampleRound_ChangeDeadline(brandId: number, sampleRoundId: number, args: ChangeDeadlineArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/events/deadline-changed";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Add CC recipients to a sample round's supplier correspondence. These addresses receive real email.
 */
  async sampleRound_AddCcEmails(brandId: number, sampleRoundId: number, args: AddCcEmailsArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/cc-emails";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Remove CC recipients from a sample round's supplier correspondence, so they get no further event emails. Addresses not on the CC list are ignored. Supplier (To) addresses cannot be removed here.
 */
  async sampleRound_RemoveCcEmails(brandId: number, sampleRoundId: number, args: RemoveCcEmailsArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/cc-emails";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Record a measurement report against the round's measurement chart. Set ReplacesDraftEventId to save an edit of a draft: that draft is replaced wholesale in the same transaction, so a rejected call leaves it untouched.
 */
  async sampleRound_CreateMeasurementReportEvent(brandId: number, sampleRoundId: number, args: CreateMeasurementReportArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/events/measurement-report";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Ask the supplier to fill in article data. Each field is {articleId, customFieldId} for an article custom field from sampleRound_GetRequestableFields, or {articleId, builtInField} for built-in article data (Description, GrossWeight, NetWeight, CountryOfOrigin for the round's supplier, HsCode) — never both. Fields are always asked per article; for SKU-level fields (GrossWeight, NetWeight, or a custom field whose entities include Sku) the supplier chooses to answer once for the article or once per SKU. ReplyBy is the date the supplier is asked to answer by, or null. Publishing may email the supplier. Set ReplacesDraftEventId to save an edit of a draft: that draft is replaced wholesale in the same transaction, so a rejected call leaves it untouched.
 */
  async sampleRound_CreateInformationRequestEvent(brandId: number, sampleRoundId: number, args: CreateInformationRequestArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/events/information-request";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Accept or reject values a supplier proposed in an information reply. Accepted values are written onto the article; an entry in EditedValues (keyed by the value id, which must also be in AcceptValueIds) is written instead of the supplier's value. ReopenValueIds turns rejected values back to pending; accepted values cannot be reopened. If any accepted value no longer fits its field, nothing is written and the error names each one.
 */
  async sampleRound_ReviewInformationReply(brandId: number, sampleRoundId: number, eventId: number, args: ReviewInformationReplyArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/events/{eventId}/information-reply/review";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    if (eventId === undefined || eventId === null)
        throw new Error("The parameter 'eventId' must be defined.");
    url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the article and SKU custom fields an information request may ask the supplier to fill in. For a field whose entities include Sku, the supplier may answer per SKU.
 */
  async sampleRound_GetRequestableFields(brandId: number, options: AxiosRequestConfig = {}): Promise<CustomFieldDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/requestable-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Publish a draft sample round, making it visible to the supplier. Not reversible through the API.
 */
  async sampleRound_PublishRound(brandId: number, sampleRoundId: number, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/publish";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Publish a drafted event on a sample round. Publishing may email the supplier. Refused once the round is closed.
 */
  async sampleRound_PublishEvent(brandId: number, sampleRoundId: number, eventId: number, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/events/{eventId}/publish";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    if (eventId === undefined || eventId === null)
        throw new Error("The parameter 'eventId' must be defined.");
    url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete an unpublished draft event from a sample round.
 */
  async sampleRound_RemoveDraftEvent(brandId: number, sampleRoundId: number, eventId: number, options: AxiosRequestConfig = {}): Promise<SampleRoundDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-rounds/{sampleRoundId}/events/{eventId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    if (eventId === undefined || eventId === null)
        throw new Error("The parameter 'eventId' must be defined.");
    url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRoundType_ListTypes(brandId: number, options: AxiosRequestConfig = {}): Promise<SampleRoundTypeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRoundType_AddType(brandId: number, args: IncomingSampleRoundTypeArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRoundType_UpdateType(brandId: number, id: number, args: IncomingSampleRoundTypeArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-types/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRoundType_DeleteType(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-types/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRoundType_GetSampleRoundTypeUsage(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<SampleRoundTypeUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-types/{id}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRoundType_UploadTemplates(brandId: number, typeId: number, files: any[] | null | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-types/{typeId}/templates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (files !== null && files !== undefined)
        files.forEach(item_ => content_.append("files", item_, item_.name));

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRoundType_DeleteTemplate(brandId: number, typeId: number, templateId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-types/{typeId}/templates/{templateId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    if (templateId === undefined || templateId === null)
        throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRoundType_UpdateTemplate(brandId: number, typeId: number, templateId: number, args: UpdateTemplateArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-types/{typeId}/templates/{templateId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    if (templateId === undefined || templateId === null)
        throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Stream a type's Excel template back. Takes the template's id rather than its blob path: the
blobs live in the shared "exceltemplates" container alongside every brand's export templates.
 */
  async sampleRoundType_DownloadTemplate(brandId: number, typeId: number, templateId: number, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-types/{typeId}/templates/{templateId}/download";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    if (templateId === undefined || templateId === null)
        throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Attach static files to a sample round type — the documents that ride along with every round of that type, as opposed to the Excel templates it is summarised into. Takes paths, not bytes: get each file in with the request_upload tool and pass what it returns as {filename, path, size}. This ADDS to the type's static files; remove one with sampleRoundType_DeleteStaticFile, rename or favourite it with sampleRoundType_UpdateStaticFile.
 */
  async sampleRoundType_AttachStaticFiles(brandId: number, typeId: number, args: AttachStaticFilesArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-types/{typeId}/static-files";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRoundType_DeleteStaticFile(brandId: number, typeId: number, fileId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-types/{typeId}/static-files/{fileId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    if (fileId === undefined || fileId === null)
        throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleRoundType_UpdateStaticFile(brandId: number, typeId: number, fileId: number, args: UpdateStaticFileArgs, options: AxiosRequestConfig = {}): Promise<SampleRoundTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-round-types/{typeId}/static-files/{fileId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (typeId === undefined || typeId === null)
        throw new Error("The parameter 'typeId' must be defined.");
    url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
    if (fileId === undefined || fileId === null)
        throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the sample statuses this brand has defined, in the brand's own order.
 */
  async sampleStatus_ListSampleStatuses(brandId: number, options: AxiosRequestConfig = {}): Promise<SampleStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleStatus_CreateSampleStatus(brandId: number, args: CreateSampleStatusArgs, options: AxiosRequestConfig = {}): Promise<SampleStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleStatus_UpdateSampleStatus(brandId: number, id: number, args: UpdateSampleStatusArgs, options: AxiosRequestConfig = {}): Promise<SampleStatusDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-statuses/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleStatus_DeleteSampleStatus(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-statuses/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleStatus_UpdateOrder(brandId: number, sampleStatusIds: number[], options: AxiosRequestConfig = {}): Promise<SampleStatusDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-statuses/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = sampleStatusIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sampleStatus_GetUsage(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<SampleStatusUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sample-statuses/{id}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async search_QuickSearch(args: Search_QuickSearchArgs, options: AxiosRequestConfig = {}): Promise<QuickSearchProductDto[]> {
    const { brandId, query, take, skip, activeSeasonId, } = args;
    let url_ = this.baseUrl + "/api/search/{brandId}/quick?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (query !== undefined && query !== null)
        url_ += "query=" + encodeURIComponent("" + query) + "&";
    if (take === null)
        throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined)
        url_ += "take=" + encodeURIComponent("" + take) + "&";
    if (skip === null)
        throw new Error("The parameter 'skip' cannot be null.");
    else if (skip !== undefined)
        url_ += "skip=" + encodeURIComponent("" + skip) + "&";
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Lean "jump to an entity by name or number" search behind the command palette's sub-menus.
Deliberately not the relevance-ranked QuickSearch: one Contains per field and
a small Take, so it can run on every keystroke.
 * @param type (optional) 
 * @param q (optional) 
 * @param take (optional) 
 */
  async search_SearchEntities(brandId: number, type: EntitySearchType | undefined, q: string | null | undefined, take: number | undefined, options: AxiosRequestConfig = {}): Promise<EntitySearchHitDto[]> {
    let url_ = this.baseUrl + "/api/search/{brandId}/entities?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (type === null)
        throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
        url_ += "type=" + encodeURIComponent("" + type) + "&";
    if (q !== undefined && q !== null)
        url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (take === null)
        throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined)
        url_ += "take=" + encodeURIComponent("" + take) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's seasons. Needed to resolve any per-season value.
 */
  async season_GetSeasons(brandId: number, options: AxiosRequestConfig = {}): Promise<SeasonDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/seasons";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async season_AddSeason(brandId: number, args: AddSeasonArgs, options: AxiosRequestConfig = {}): Promise<SeasonDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/seasons";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async season_UpdateSeason(brandId: number, seasonId: number, args: UpdateSeasonArgs, options: AxiosRequestConfig = {}): Promise<SeasonDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/seasons/{seasonId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a season. Check season_CountUsages first, but do not treat it as the whole blast radius: it reports products and orders only, while deleting also removes the season's channel activity windows, currency rates, price configs, duties and freights, and drops BOM connections on affected articles. The call fails with a BOM-drop warning unless suppressBomDropWarning is true — that flag is the only confirmation step, so put the drop in front of the user before setting it.
 * @param suppressBomDropWarning (optional) 
 */
  async season_DeleteSeason(brandId: number, seasonId: number, suppressBomDropWarning: boolean | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/seasons/{seasonId}?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    if (suppressBomDropWarning === null)
        throw new Error("The parameter 'suppressBomDropWarning' cannot be null.");
    else if (suppressBomDropWarning !== undefined)
        url_ += "suppressBomDropWarning=" + encodeURIComponent("" + suppressBomDropWarning) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set individual season fields across many seasons in one call. Each cell names a season, which field, and the new value as a string — the spreadsheet-style edit behind the season table.
Returns the same list the GET does.
 */
  async season_SetSeasonFieldsBulk(brandId: number, args: SetSeasonFieldsBulkArgs, options: AxiosRequestConfig = {}): Promise<SeasonDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/seasons/bulk/fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async season_CountUsages(brandId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<SeasonUsagesDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/seasons/{seasonId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set one season's activity window on one channel. A season is active on a channel only within this window. Overlaps are not rejected: an existing window on the same channel is silently trimmed to make room, and one wholly covered by the new window is deleted outright. Run season_CheckOverlaps first — it returns the newStart/newEnd that would be applied to each neighbour — and show the user what moves before writing.
 */
  async season_SetChannelActivity(brandId: number, seasonId: number, args: SetChannelActivityArgs, options: AxiosRequestConfig = {}): Promise<SeasonDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/seasons/{seasonId}/channels";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async season_RemoveChannelActivity(brandId: number, seasonId: number, channelId: number, options: AxiosRequestConfig = {}): Promise<SeasonDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/seasons/{seasonId}/channels/{channelId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    if (channelId === undefined || channelId === null)
        throw new Error("The parameter 'channelId' must be defined.");
    url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set per-channel activity windows on seasons in bulk, and remove existing ones by activity id. A season is active on a channel only for the window given here. Prefer this over repeated season_SetChannelActivity calls. Overlaps are not rejected: an existing window on the same channel is silently trimmed to make room, and one wholly covered by the new window is deleted outright. Run season_CheckOverlaps first — it returns the newStart/newEnd that would be applied to each neighbour — and show the user what moves before writing.
 */
  async season_BulkUpdateActivities(brandId: number, actionsByChannels: BulkUpdateActivityChannel[], options: AxiosRequestConfig = {}): Promise<ChannelDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/seasons/activities";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = actionsByChannels;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Report which existing seasons would overlap a window you are about to create. Read-only pre-flight for the channelActivities you pass to season_AddSeason, and for the first season_SetChannelActivity on a new season. Overlaps are not rejected when you write: the neighbouring season is silently truncated to the newStart/newEnd this returns.
 */
  async season_CheckOverlapsForNew(brandId: number, args: CheckOverlapsArgs, options: AxiosRequestConfig = {}): Promise<CheckOverlapsResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/seasons/check-overlaps-new";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Report which existing seasons would overlap a change to this season's dates. Read-only pre-flight for season_SetChannelActivity and season_BulkUpdateActivities — NOT for season_UpdateSeason, which carries no dates. Overlaps are not rejected when you write: the neighbouring season is silently truncated, and this is what tells you which one and to what (newStart/newEnd).
 */
  async season_CheckOverlaps(brandId: number, seasonId: number, args: CheckOverlapsArgs, options: AxiosRequestConfig = {}): Promise<CheckOverlapsResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/seasons/{seasonId}/check-overlaps";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async season_GetExcel(brandId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/seasons/export";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sectionName_GetSectionNames(brandId: number, options: AxiosRequestConfig = {}): Promise<SectionNameDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/section-names";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sectionName_Create(brandId: number, args: CreateSectionNameArgs, options: AxiosRequestConfig = {}): Promise<SectionNameDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/section-names";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sectionName_Update(brandId: number, id: number, args: UpdateSectionNameArgs, options: AxiosRequestConfig = {}): Promise<SectionNameDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/section-names/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sectionName_Delete(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/section-names/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sectionName_GetUsage(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/section-names/{id}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Retire a section name by repointing everything using it at a replacement, then deleting it. Prefer this over sectionName_Delete when it is still in use.
 */
  async sectionName_Replace(brandId: number, id: number, args: ReplaceSectionNameArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/section-names/{id}/replace";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sendGridWebhook_HandleEvents(secret: string, events: SendGridEventArgs[] | undefined, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/sendgrid-webhook/{secret}";
    if (secret === undefined || secret === null)
        throw new Error("The parameter 'secret' must be defined.");
    url_ = url_.replace("{secret}", encodeURIComponent("" + secret));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = events;

    const options_: AxiosRequestConfig = {
      data: content_,
      responseType: "blob",
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_Install(shop: string | undefined, brandId: number | null | undefined, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/shopify/install?";
    if (shop === null)
        throw new Error("The parameter 'shop' cannot be null.");
    else if (shop !== undefined)
        url_ += "shop=" + encodeURIComponent("" + shop) + "&";
    if (brandId !== undefined && brandId !== null)
        url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_Callback(shop: string | undefined, code: string | undefined, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/shopify/callback?";
    if (shop === null)
        throw new Error("The parameter 'shop' cannot be null.");
    else if (shop !== undefined)
        url_ += "shop=" + encodeURIComponent("" + shop) + "&";
    if (code === null)
        throw new Error("The parameter 'code' cannot be null.");
    else if (code !== undefined)
        url_ += "code=" + encodeURIComponent("" + code) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_GetClaim(claimToken: string, options: AxiosRequestConfig = {}): Promise<ShopifyClaimInfo> {
    let url_ = this.baseUrl + "/api/shopify/claim/{claimToken}";
    if (claimToken === undefined || claimToken === null)
        throw new Error("The parameter 'claimToken' must be defined.");
    url_ = url_.replace("{claimToken}", encodeURIComponent("" + claimToken));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_Claim(args: ClaimArgs, options: AxiosRequestConfig = {}): Promise<ClaimResult> {
    let url_ = this.baseUrl + "/api/shopify/claim";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_WebhookAppUninstalled(options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/shopify/webhooks/app/uninstalled";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_WebhookCustomersDataRequest(options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/shopify/webhooks/customers/data-request";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_WebhookCustomersRedact(options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/shopify/webhooks/customers/redact";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_WebhookShopRedact(options: AxiosRequestConfig = {}): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/shopify/webhooks/shop/redact";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_GetConnections(brandId: number, options: AxiosRequestConfig = {}): Promise<ShopifyConnectionDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/shopify/connections";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_DeleteConnection(brandId: number, connectionId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/shopify/connections/{connectionId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (connectionId === undefined || connectionId === null)
        throw new Error("The parameter 'connectionId' must be defined.");
    url_ = url_.replace("{connectionId}", encodeURIComponent("" + connectionId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_ToggleConnection(brandId: number, connectionId: number, enabled: boolean, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/shopify/connections/{connectionId}/toggle";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (connectionId === undefined || connectionId === null)
        throw new Error("The parameter 'connectionId' must be defined.");
    url_ = url_.replace("{connectionId}", encodeURIComponent("" + connectionId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = enabled;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_UpdateCustomField(brandId: number, connectionId: number, customFieldId: number | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/shopify/connections/{connectionId}/custom-field";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (connectionId === undefined || connectionId === null)
        throw new Error("The parameter 'connectionId' must be defined.");
    url_ = url_.replace("{connectionId}", encodeURIComponent("" + connectionId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = customFieldId;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The rollout gate: while a sync-flag field is set, only articles with any option selected
in it sync to this shop. Clearing it opens the gates for every qualifying article.
 * @param customFieldId (optional) 
 */
  async shopify_UpdateSyncFlagField(brandId: number, connectionId: number, customFieldId: number | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/shopify/connections/{connectionId}/sync-flag-field";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (connectionId === undefined || connectionId === null)
        throw new Error("The parameter 'connectionId' must be defined.");
    url_ = url_.replace("{connectionId}", encodeURIComponent("" + connectionId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = customFieldId;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_UpdateConnectionChannel(brandId: number, connectionId: number, channelId: number | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/shopify/connections/{connectionId}/channel";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (connectionId === undefined || connectionId === null)
        throw new Error("The parameter 'connectionId' must be defined.");
    url_ = url_.replace("{connectionId}", encodeURIComponent("" + connectionId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = channelId;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_UpdateAllowedStatuses(brandId: number, connectionId: number, statusIds: number[], options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/shopify/connections/{connectionId}/statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (connectionId === undefined || connectionId === null)
        throw new Error("The parameter 'connectionId' must be defined.");
    url_ = url_.replace("{connectionId}", encodeURIComponent("" + connectionId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = statusIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Which environments may sync this connection. Production reads Prod; QA and a developer
machine both read Qa. Both start false, so a connection that arrives in a non-production
database through a copy of production stays inert until someone ticks it there.
 */
  async shopify_UpdateEnvironments(brandId: number, connectionId: number, args: UpdateEnvironmentsArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/shopify/connections/{connectionId}/environments";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (connectionId === undefined || connectionId === null)
        throw new Error("The parameter 'connectionId' must be defined.");
    url_ = url_.replace("{connectionId}", encodeURIComponent("" + connectionId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_GetMappings(brandId: number, connectionId: number, options: AxiosRequestConfig = {}): Promise<ShopifyMappingTemplateDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/shopify/connections/{connectionId}/mappings";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (connectionId === undefined || connectionId === null)
        throw new Error("The parameter 'connectionId' must be defined.");
    url_ = url_.replace("{connectionId}", encodeURIComponent("" + connectionId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_SaveMapping(brandId: number, connectionId: number, args: SaveMappingArgs, options: AxiosRequestConfig = {}): Promise<ShopifyMappingTemplateDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/shopify/connections/{connectionId}/mappings";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (connectionId === undefined || connectionId === null)
        throw new Error("The parameter 'connectionId' must be defined.");
    url_ = url_.replace("{connectionId}", encodeURIComponent("" + connectionId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_GetMarkets(brandId: number, connectionId: number, options: AxiosRequestConfig = {}): Promise<ShopifyMarketsDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/shopify/connections/{connectionId}/markets";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (connectionId === undefined || connectionId === null)
        throw new Error("The parameter 'connectionId' must be defined.");
    url_ = url_.replace("{connectionId}", encodeURIComponent("" + connectionId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_DeleteMapping(brandId: number, connectionId: number, templateId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/shopify/connections/{connectionId}/mappings/{templateId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (connectionId === undefined || connectionId === null)
        throw new Error("The parameter 'connectionId' must be defined.");
    url_ = url_.replace("{connectionId}", encodeURIComponent("" + connectionId));
    if (templateId === undefined || templateId === null)
        throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async shopify_GetSourceFields(brandId: number, options: AxiosRequestConfig = {}): Promise<ShopifySourceFieldOption[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/shopify/source-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sizeConversionTable_ListSizeConversionTables(brandId: number, options: AxiosRequestConfig = {}): Promise<SizeConversionTableDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sizeConversionTable";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sizeConversionTable_CreateSizeConversionTable(brandId: number, sizeConversionTableToAddArg: AddSizeConversionTableArg, options: AxiosRequestConfig = {}): Promise<SizeConversionTableDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sizeConversionTable";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = sizeConversionTableToAddArg;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List all size conversion tables in this brand, including their columns, size mappings and the number of products assigned to each table. A product count of zero means the table is unused.
 */
  async sizeConversionTable_GetSizeConversionTableUsages(brandId: number, options: AxiosRequestConfig = {}): Promise<SizeConversionTableUsageDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sizeConversionTable/usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the products assigned to this brand's size conversion table, with IDs and display names formatted as "Product Name Product Number". Returns an empty list for an unused table.
 */
  async sizeConversionTable_GetSizeConversionTableProducts(brandId: number, sizeConversionTableId: number, options: AxiosRequestConfig = {}): Promise<SizeConversionTableProductDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sizeConversionTable/{sizeConversionTableId}/products";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sizeConversionTableId === undefined || sizeConversionTableId === null)
        throw new Error("The parameter 'sizeConversionTableId' must be defined.");
    url_ = url_.replace("{sizeConversionTableId}", encodeURIComponent("" + sizeConversionTableId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete an unused size conversion table and its columns and size mappings. Refuses tables assigned to any products. Does not delete the referenced size systems.
 */
  async sizeConversionTable_DeleteSizeConversionTable(brandId: number, sizeConversionTableId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sizeConversionTable/{sizeConversionTableId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sizeConversionTableId === undefined || sizeConversionTableId === null)
        throw new Error("The parameter 'sizeConversionTableId' must be defined.");
    url_ = url_.replace("{sizeConversionTableId}", encodeURIComponent("" + sizeConversionTableId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List size systems and their versions.
 */
  async sizeSystem_GetSizeSystems(brandId: number, options: AxiosRequestConfig = {}): Promise<SizeSystemDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/size-systems";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a size system with one or more versions. Each version needs a name and its `range` of size labels; `defaultSizes` is optional and may be omitted.
 */
  async sizeSystem_AddSizeSystem(brandId: number, args: AddSizeSystemArg, options: AxiosRequestConfig = {}): Promise<SizeSystemDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/size-systems";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read one size system in full, with all its versions and their sizes.
 */
  async sizeSystem_GetSizeSystem(brandId: number, sizeSystemId: number, options: AxiosRequestConfig = {}): Promise<SizeSystemDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/size-systems/{sizeSystemId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sizeSystemId === undefined || sizeSystemId === null)
        throw new Error("The parameter 'sizeSystemId' must be defined.");
    url_ = url_.replace("{sizeSystemId}", encodeURIComponent("" + sizeSystemId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sizeSystem_UpdateSizeSystem(brandId: number, sizeSystemId: number, updatedSizeSystem: SizeSystemDto, options: AxiosRequestConfig = {}): Promise<SizeSystemDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/size-systems/{sizeSystemId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sizeSystemId === undefined || sizeSystemId === null)
        throw new Error("The parameter 'sizeSystemId' must be defined.");
    url_ = url_.replace("{sizeSystemId}", encodeURIComponent("" + sizeSystemId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = updatedSizeSystem;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Deletes a size system with its measurement charts, and the measurement gradings for its sizes.
Refused while products, sample round reports, lookup tables or size conversion tables (as their base
column) use it — see count-usages. Other conversion table columns become custom columns.
 */
  async sizeSystem_DeleteSizeSystem(brandId: number, sizeSystemId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/size-systems/{sizeSystemId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sizeSystemId === undefined || sizeSystemId === null)
        throw new Error("The parameter 'sizeSystemId' must be defined.");
    url_ = url_.replace("{sizeSystemId}", encodeURIComponent("" + sizeSystemId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Lists what uses a size system, and whether that blocks deleting it.
 */
  async sizeSystem_CountUsages(brandId: number, sizeSystemId: number, options: AxiosRequestConfig = {}): Promise<SizeSystemUsagesDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/size-systems/{sizeSystemId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sizeSystemId === undefined || sizeSystemId === null)
        throw new Error("The parameter 'sizeSystemId' must be defined.");
    url_ = url_.replace("{sizeSystemId}", encodeURIComponent("" + sizeSystemId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Lists what uses one version of a size system, and whether that blocks removing it.
 */
  async sizeSystem_CountVersionUsages(brandId: number, sizeSystemId: number, versionId: number, options: AxiosRequestConfig = {}): Promise<SizeSystemUsagesDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/size-systems/{sizeSystemId}/versions/{versionId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (sizeSystemId === undefined || sizeSystemId === null)
        throw new Error("The parameter 'sizeSystemId' must be defined.");
    url_ = url_.replace("{sizeSystemId}", encodeURIComponent("" + sizeSystemId));
    if (versionId === undefined || versionId === null)
        throw new Error("The parameter 'versionId' must be defined.");
    url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async skuCode_GetSkuCodes(brandId: number, options: AxiosRequestConfig = {}): Promise<SkuCodeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-codes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async skuCode_CreateSkuCode(brandId: number, skuCodeIn: AddSkuCodeArgs, options: AxiosRequestConfig = {}): Promise<SkuCodeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-codes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = skuCodeIn;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async skuCode_UpdateSkuCode(brandId: number, skuCodeId: number, skuCodeIn: UpdateSkuCodeArgs, options: AxiosRequestConfig = {}): Promise<SkuCodeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-codes/{skuCodeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (skuCodeId === undefined || skuCodeId === null)
        throw new Error("The parameter 'skuCodeId' must be defined.");
    url_ = url_.replace("{skuCodeId}", encodeURIComponent("" + skuCodeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = skuCodeIn;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async skuCode_DeleteSkuCode(brandId: number, skuCodeId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-codes/{skuCodeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (skuCodeId === undefined || skuCodeId === null)
        throw new Error("The parameter 'skuCodeId' must be defined.");
    url_ = url_.replace("{skuCodeId}", encodeURIComponent("" + skuCodeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async skuCode_UpdateOrder(brandId: number, skuCodeIds: number[], options: AxiosRequestConfig = {}): Promise<SkuCodeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-codes/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = skuCodeIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List SKU code values that violate their code type's rules — wrong length or bad checksum (reason `InvalidFormat`), or the same value on more than one SKU (reason `Duplicated`). Fix what it reports with skuCode_GenerateSkuCodeValuesForSkus using force:true.
 */
  async skuCode_GetBadSkuCodeValues(brandId: number, options: AxiosRequestConfig = {}): Promise<BadSkuCodeValueDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-codes/bad-data";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Generate a batch of unused values for a SKU code type from its ranges, without assigning them to SKUs. To fill or reissue values on actual SKUs use skuCode_GenerateSkuCodeValuesForSkus.
 * @param numberOfCodes (optional) 
 */
  async skuCode_GenerateCodeValues(brandId: number, skuCodeId: number, numberOfCodes: number | undefined, options: AxiosRequestConfig = {}): Promise<string[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-codes/{skuCodeId}/generate-code-values?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (skuCodeId === undefined || skuCodeId === null)
        throw new Error("The parameter 'skuCodeId' must be defined.");
    url_ = url_.replace("{skuCodeId}", encodeURIComponent("" + skuCodeId));
    if (numberOfCodes === null)
        throw new Error("The parameter 'numberOfCodes' cannot be null.");
    else if (numberOfCodes !== undefined)
        url_ += "numberOfCodes=" + encodeURIComponent("" + numberOfCodes) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Generate values for a SKU code type on a chosen set of SKUs. `force: false` (the default) SKIPS any SKU that already has a value for this code — including one holding an empty string — so it only fills gaps. `force: true` REISSUES in place, overwriting what is there: that is how you fix the duplicates and malformed values skuCode_GetBadSkuCodeValues reports. Do not try to clear a value first; an empty string counts as a value for the uniqueness check, so only one SKU in the brand can hold one at a time.
 */
  async skuCode_GenerateSkuCodeValuesForSkus(brandId: number, skuCodeId: number, args: GenerateSkuCodeValuesForSkusArgs3, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-codes/{skuCodeId}/generate-sku-code-values-for-skus";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (skuCodeId === undefined || skuCodeId === null)
        throw new Error("The parameter 'skuCodeId' must be defined.");
    url_ = url_.replace("{skuCodeId}", encodeURIComponent("" + skuCodeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Render an EAN barcode as a PNG. Generates from the code passed in — it does not look up a SKU. The /api/ean-series/images route is a legacy alias with identical output.
 * @param height (optional) 
 * @param scaling (optional) 
 * @param margins (optional) 
 * @param font (optional) 
 * @param renderText (optional) 
 */
  async skuCodeImages_GenerateEanBarcodeImage(args: SkuCodeImages_GenerateEanBarcodeImageArgs, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    const { eanCode, height, scaling, margins, font, renderText, } = args;
    let url_ = this.baseUrl + "/api/sku-codes/ean-images/{eanCode}.png?";
    if (eanCode === undefined || eanCode === null)
        throw new Error("The parameter 'eanCode' must be defined.");
    url_ = url_.replace("{eanCode}", encodeURIComponent("" + eanCode));
    if (height === null)
        throw new Error("The parameter 'height' cannot be null.");
    else if (height !== undefined)
        url_ += "height=" + encodeURIComponent("" + height) + "&";
    if (scaling === null)
        throw new Error("The parameter 'scaling' cannot be null.");
    else if (scaling !== undefined)
        url_ += "scaling=" + encodeURIComponent("" + scaling) + "&";
    if (margins === null)
        throw new Error("The parameter 'margins' cannot be null.");
    else if (margins !== undefined)
        url_ += "margins=" + encodeURIComponent("" + margins) + "&";
    if (font === null)
        throw new Error("The parameter 'font' cannot be null.");
    else if (font !== undefined)
        url_ += "font=" + encodeURIComponent("" + font) + "&";
    if (renderText === null)
        throw new Error("The parameter 'renderText' cannot be null.");
    else if (renderText !== undefined)
        url_ += "renderText=" + encodeURIComponent("" + renderText) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Render an EAN barcode as a PNG. Generates from the code passed in — it does not look up a SKU. The /api/ean-series/images route is a legacy alias with identical output.
 * @param height (optional) 
 * @param scaling (optional) 
 * @param margins (optional) 
 * @param font (optional) 
 * @param renderText (optional) 
 */
  async skuCodeImages_GenerateEanBarcodeImage2(args: SkuCodeImages_GenerateEanBarcodeImage2Args, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    const { eanCode, height, scaling, margins, font, renderText, } = args;
    let url_ = this.baseUrl + "/api/ean-series/images/{eanCode}.png?";
    if (eanCode === undefined || eanCode === null)
        throw new Error("The parameter 'eanCode' must be defined.");
    url_ = url_.replace("{eanCode}", encodeURIComponent("" + eanCode));
    if (height === null)
        throw new Error("The parameter 'height' cannot be null.");
    else if (height !== undefined)
        url_ += "height=" + encodeURIComponent("" + height) + "&";
    if (scaling === null)
        throw new Error("The parameter 'scaling' cannot be null.");
    else if (scaling !== undefined)
        url_ += "scaling=" + encodeURIComponent("" + scaling) + "&";
    if (margins === null)
        throw new Error("The parameter 'margins' cannot be null.");
    else if (margins !== undefined)
        url_ += "margins=" + encodeURIComponent("" + margins) + "&";
    if (font === null)
        throw new Error("The parameter 'font' cannot be null.");
    else if (font !== undefined)
        url_ += "font=" + encodeURIComponent("" + font) + "&";
    if (renderText === null)
        throw new Error("The parameter 'renderText' cannot be null.");
    else if (renderText !== undefined)
        url_ += "renderText=" + encodeURIComponent("" + renderText) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Render a UPC barcode as a PNG from the code passed in.
 * @param height (optional) 
 * @param scaling (optional) 
 * @param margins (optional) 
 * @param font (optional) 
 * @param renderText (optional) 
 */
  async skuCodeImages_GenerateUpcBarcodeImage(args: SkuCodeImages_GenerateUpcBarcodeImageArgs, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    const { upcCode, height, scaling, margins, font, renderText, } = args;
    let url_ = this.baseUrl + "/api/sku-codes/upc-images/{upcCode}.png?";
    if (upcCode === undefined || upcCode === null)
        throw new Error("The parameter 'upcCode' must be defined.");
    url_ = url_.replace("{upcCode}", encodeURIComponent("" + upcCode));
    if (height === null)
        throw new Error("The parameter 'height' cannot be null.");
    else if (height !== undefined)
        url_ += "height=" + encodeURIComponent("" + height) + "&";
    if (scaling === null)
        throw new Error("The parameter 'scaling' cannot be null.");
    else if (scaling !== undefined)
        url_ += "scaling=" + encodeURIComponent("" + scaling) + "&";
    if (margins === null)
        throw new Error("The parameter 'margins' cannot be null.");
    else if (margins !== undefined)
        url_ += "margins=" + encodeURIComponent("" + margins) + "&";
    if (font === null)
        throw new Error("The parameter 'font' cannot be null.");
    else if (font !== undefined)
        url_ += "font=" + encodeURIComponent("" + font) + "&";
    if (renderText === null)
        throw new Error("The parameter 'renderText' cannot be null.");
    else if (renderText !== undefined)
        url_ += "renderText=" + encodeURIComponent("" + renderText) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Render a Code 128 barcode as a PNG from the code passed in.
 * @param code (optional) 
 * @param height (optional) 
 * @param width (optional) 
 * @param scaling (optional) 
 * @param margins (optional) 
 */
  async skuCodeImages_GenerateCode128BarcodeImage(args: SkuCodeImages_GenerateCode128BarcodeImageArgs, options: AxiosRequestConfig = {}): Promise<FileResponse> {
    const { filename, code, height, width, scaling, margins, } = args;
    let url_ = this.baseUrl + "/api/sku-codes/code128-images/{filename}.png?";
    if (filename === undefined || filename === null)
        throw new Error("The parameter 'filename' must be defined.");
    url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
    if (code === null)
        throw new Error("The parameter 'code' cannot be null.");
    else if (code !== undefined)
        url_ += "code=" + encodeURIComponent("" + code) + "&";
    if (height === null)
        throw new Error("The parameter 'height' cannot be null.");
    else if (height !== undefined)
        url_ += "height=" + encodeURIComponent("" + height) + "&";
    if (width === null)
        throw new Error("The parameter 'width' cannot be null.");
    else if (width !== undefined)
        url_ += "width=" + encodeURIComponent("" + width) + "&";
    if (scaling === null)
        throw new Error("The parameter 'scaling' cannot be null.");
    else if (scaling !== undefined)
        url_ += "scaling=" + encodeURIComponent("" + scaling) + "&";
    if (margins === null)
        throw new Error("The parameter 'margins' cannot be null.");
    else if (margins !== undefined)
        url_ += "margins=" + encodeURIComponent("" + margins) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async skuCodeRange_GetRanges(brandId: number, options: AxiosRequestConfig = {}): Promise<SkuCodeNumericRangeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-code-ranges";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async skuCodeRange_CreateRange(brandId: number, rangeIn: AddSkuCodeRangeArgs, options: AxiosRequestConfig = {}): Promise<SkuCodeNumericRangeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-code-ranges";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = rangeIn;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async skuCodeRange_UpdateRange(brandId: number, rangeId: number, rangeIn: UpdateSkuCodeRangeArgs, options: AxiosRequestConfig = {}): Promise<SkuCodeNumericRangeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-code-ranges/{rangeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (rangeId === undefined || rangeId === null)
        throw new Error("The parameter 'rangeId' must be defined.");
    url_ = url_.replace("{rangeId}", encodeURIComponent("" + rangeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = rangeIn;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async skuCodeRange_DeleteRange(brandId: number, rangeId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-code-ranges/{rangeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (rangeId === undefined || rangeId === null)
        throw new Error("The parameter 'rangeId' must be defined.");
    url_ = url_.replace("{rangeId}", encodeURIComponent("" + rangeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async skuCodeRange_UpdateOrder(brandId: number, skuCodeIds: number[], options: AxiosRequestConfig = {}): Promise<SkuCodeNumericRangeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/sku-code-ranges/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = skuCodeIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sku_UpdateCustomFieldValues(brandId: number, skuId: number, seasonId: number | null | undefined, valueDtos: CustomFieldIdWithValueDto[], options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/{skuId}?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (skuId === undefined || skuId === null)
        throw new Error("The parameter 'skuId' must be defined.");
    url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
    if (seasonId !== undefined && seasonId !== null)
        url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = valueDtos;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The authoritative weight write. Returns the whole article so one round trip refreshes both
the SKU and the article-level summary computed from it.
 */
  async sku_SetWeight(brandId: number, skuId: number, weight: WeightPatchDto, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/{skuId}/weight";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (skuId === undefined || skuId === null)
        throw new Error("The parameter 'skuId' must be defined.");
    url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = weight;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async sku_SetSkuCodeValue(brandId: number, skuId: number, skuCodeId: number, args: UpdateSkuCodeValueArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/{skuId}/sku-codes/{skuCodeId}/value";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (skuId === undefined || skuId === null)
        throw new Error("The parameter 'skuId' must be defined.");
    url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
    if (skuCodeId === undefined || skuCodeId === null)
        throw new Error("The parameter 'skuCodeId' must be defined.");
    url_ = url_.replace("{skuCodeId}", encodeURIComponent("" + skuCodeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Update many SKUs at once — the canonical SKU write. `skuCodeValues` is an UPSERT keyed on skuCodeId, not a replace: an empty array changes nothing, and clearing one takes an explicit {skuCodeId, value: ""}. That is the opposite of the image endpoints on this API, which replace the whole set.
Custom values: seasonId picks the seasonality each value lands on, and null does not mean 'base' for every field: a seasonal field's value goes to that season, or with null to the entity's latest season (its base only if it has no season); a non-seasonal field's value always goes to the base, whatever seasonId says. A seasonId the entity does not carry yet adds that season to it, even when only non-seasonal fields are sent. Seasonal and non-seasonal fields may be mixed here; each lands by its own rule. A lookup table keyed on a seasonal field reads each season's own value and never falls back to the base, so write such a key field to every season it should apply in.
Returns the whole article, so the caller can adopt the saved state directly.
 */
  async sku_UpdateSkusBulk(brandId: number, args: UpdateSkusBulkArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/bulk";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Regenerate SKU numbers in bulk, overwriting manually set ones. Numbers may be referenced outside the PLM — confirm with the user first.
 */
  async sku_ForceUpdateSkuNumbers(brandId: number, skuIds: number[], options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/sku-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = skuIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Explain how the next SKU number would be generated.
 */
  async sku_GetSkuNumberInfo(brandId: number, skuId: number, options: AxiosRequestConfig = {}): Promise<SkuNumberInfoResponse> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/{skuId}/number-info";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (skuId === undefined || skuId === null)
        throw new Error("The parameter 'skuId' must be defined.");
    url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set one SKU's number manually, overriding the generated one. Not covered by sku_UpdateSkusBulk.
 */
  async sku_UpdateSkuNumber(brandId: number, skuId: number, args: UpdateSkuNumberArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/{skuId}/sku-number";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (skuId === undefined || skuId === null)
        throw new Error("The parameter 'skuId' must be defined.");
    url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set a SKU's prices for a season. Prices are per season and per destination. The cost price
target and the main out-price's markup/margin target are one value seen from both ends: send
a new cost price target with the markup target unchanged and the markup target follows it;
send a new markup target and the cost price target is derived from it.
 */
  async sku_UpdateSkuSeasonPrices(brandId: number, args: UpdateSkuSeasonPricesArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/season-prices";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set many SKUs' prices in one save, across articles and seasons. Each item is what
`UpdateSkuSeasonPrices` takes — one season, supplier and destination, with any number of SKUs from
any of the brand's articles — and the whole batch is saved together: if one item is refused, none
is written. Like the single endpoint, a price for a season or supplier the SKU's article is not on
adds that season or supplier to the article. Returns every article a SKU in the batch belongs to.
 */
  async sku_UpdateSkuSeasonPricesBatch(brandId: number, items: UpdateSkuSeasonPricesArgs[], options: AxiosRequestConfig = {}): Promise<ArticleDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/season-prices/batch";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = items;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Recompute SKU season prices from the current price configuration, overwriting the stored linked out-prices. Unlinked manual overrides are left alone.
 */
  async sku_RecalculateSkuSeasonPrices(brandId: number, args: RecalculateSkuSeasonPricesArgs, options: AxiosRequestConfig = {}): Promise<ArticleDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/season-prices/recalculate";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Articles whose SKUs disagree on a price field, per season, supplier and destination. Only while SKU-level pricing is off. With includeAgreeing, an article's agreeing fields are returned too.
 * @param articleId (optional) 
 * @param includeAgreeing (optional) 
 */
  async sku_GetSkuPriceDivergences(brandId: number, articleId: number | null | undefined, includeAgreeing: boolean | undefined, options: AxiosRequestConfig = {}): Promise<SkuPriceDivergence[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/price-divergences?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId !== undefined && articleId !== null)
        url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
    if (includeAgreeing === null)
        throw new Error("The parameter 'includeAgreeing' cannot be null.");
    else if (includeAgreeing !== undefined)
        url_ += "includeAgreeing=" + encodeURIComponent("" + includeAgreeing) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Copy one size's prices onto every size of the article and recalculate. Returns every compared field of the article, agreeing ones included.
 */
  async sku_FixSkuPriceDivergence(brandId: number, args: FixSkuPriceDivergenceArgs, options: AxiosRequestConfig = {}): Promise<SkuPriceDivergence[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/price-divergences/fix";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Background job re-deriving the calculated prices on the articles the scan reports. Typed values are left alone.
 */
  async sku_RecalculateSkuPriceDivergences(brandId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/price-divergences/recalculate";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Return the brand's SKUs as CSV text. Useful for a bulk read; returns a string, not a file.
 * @param hierarchyNodeIds (optional) 
 * @param productCategoryIds (optional) 
 * @param genders (optional) 
 * @param seasonIds (optional) 
 * @param colors (optional) 
 * @param supplierIds (optional) 
 * @param dropDateRange_From (optional) 
 * @param dropDateRange_To (optional) 
 * @param dropNames (optional) 
 * @param statusIds (optional) 
 * @param tagIds (optional) 
 * @param searchTerm (optional) 
 * @param customFieldOptionIds (optional) 
 * @param createdByUserIds (optional) 
 * @param assignedUserIds (optional) 
 * @param colorGroupIds (optional) 
 * @param outPriceAmounts (optional) 
 * @param outPriceRanges (optional) 
 * @param sizeSystemIds (optional) 
 * @param timelineHealth (optional) 
 * @param nextGateRoleIds (optional) 
 * @param nextGateNames (optional) 
 * @param activeSeasonId (optional) 
 */
  async sku_ExportSkusCsv(args: Sku_ExportSkusCsvArgs, options: AxiosRequestConfig = {}): Promise<string> {
    const { brandId, hierarchyNodeIds, productCategoryIds, genders, seasonIds, colors, supplierIds, dropNames, statusIds, tagIds, searchTerm, customFieldOptionIds, createdByUserIds, assignedUserIds, colorGroupIds, outPriceAmounts, outPriceRanges, sizeSystemIds, timelineHealth, nextGateRoleIds, nextGateNames, activeSeasonId, } = args;
    const dropDateRange_From = args.dropDateRange?.from;
    const dropDateRange_To = args.dropDateRange?.to;
    let url_ = this.baseUrl + "/api/brand/{brandId}/skus/export-csv?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (hierarchyNodeIds !== undefined && hierarchyNodeIds !== null)
        hierarchyNodeIds && hierarchyNodeIds.forEach(item => { url_ += "HierarchyNodeIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (productCategoryIds !== undefined && productCategoryIds !== null)
        productCategoryIds && productCategoryIds.forEach(item => { url_ += "ProductCategoryIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (genders !== undefined && genders !== null)
        genders && genders.forEach(item => { url_ += "Genders=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (seasonIds !== undefined && seasonIds !== null)
        seasonIds && seasonIds.forEach(item => { url_ += "SeasonIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colors !== undefined && colors !== null)
        colors && colors.forEach(item => { url_ += "Colors=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (supplierIds !== undefined && supplierIds !== null)
        supplierIds && supplierIds.forEach(item => { url_ += "SupplierIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (dropDateRange_From !== undefined && dropDateRange_From !== null)
        url_ += "DropDateRange.From=" + encodeURIComponent("" + dropDateRange_From) + "&";
    if (dropDateRange_To !== undefined && dropDateRange_To !== null)
        url_ += "DropDateRange.To=" + encodeURIComponent("" + dropDateRange_To) + "&";
    if (dropNames !== undefined && dropNames !== null)
        dropNames && dropNames.forEach(item => { url_ += "DropNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (statusIds !== undefined && statusIds !== null)
        statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (searchTerm !== undefined && searchTerm !== null)
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (customFieldOptionIds !== undefined && customFieldOptionIds !== null)
        url_ += appendDictionaryQuery("CustomFieldOptionIds", customFieldOptionIds);
    if (createdByUserIds !== undefined && createdByUserIds !== null)
        createdByUserIds && createdByUserIds.forEach(item => { url_ += "CreatedByUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (assignedUserIds !== undefined && assignedUserIds !== null)
        assignedUserIds && assignedUserIds.forEach(item => { url_ += "AssignedUserIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (colorGroupIds !== undefined && colorGroupIds !== null)
        colorGroupIds && colorGroupIds.forEach(item => { url_ += "ColorGroupIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (outPriceAmounts !== undefined && outPriceAmounts !== null)
        url_ += appendDictionaryQuery("OutPriceAmounts", outPriceAmounts);
    if (outPriceRanges !== undefined && outPriceRanges !== null)
        url_ += appendDictionaryQuery("OutPriceRanges", outPriceRanges);
    if (sizeSystemIds !== undefined && sizeSystemIds !== null)
        sizeSystemIds && sizeSystemIds.forEach(item => { url_ += "SizeSystemIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (timelineHealth !== undefined && timelineHealth !== null)
        timelineHealth && timelineHealth.forEach(item => { url_ += "TimelineHealth=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateRoleIds !== undefined && nextGateRoleIds !== null)
        nextGateRoleIds && nextGateRoleIds.forEach(item => { url_ += "NextGateRoleIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (nextGateNames !== undefined && nextGateNames !== null)
        nextGateNames && nextGateNames.forEach(item => { url_ += "NextGateNames=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (activeSeasonId !== undefined && activeSeasonId !== null)
        url_ += "activeSeasonId=" + encodeURIComponent("" + activeSeasonId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_GetInvitation(token: string, options: AxiosRequestConfig = {}): Promise<SupplierPortalInvitationInfoDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/invitations/{token}";
    if (token === undefined || token === null)
        throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace("{token}", encodeURIComponent("" + token));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_Register(token: string, name: string | null | undefined, password: string | null | undefined, photo: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/supplier-portal/invitations/{token}/register";
    if (token === undefined || token === null)
        throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace("{token}", encodeURIComponent("" + token));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (name !== null && name !== undefined)
        content_.append("Name", name.toString());
    if (password !== null && password !== undefined)
        content_.append("Password", password.toString());
    if (photo !== null && photo !== undefined)
        content_.append("Photo", photo, photo.name ? photo.name : "Photo");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_Accept(token: string, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/supplier-portal/invitations/{token}/accept";
    if (token === undefined || token === null)
        throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace("{token}", encodeURIComponent("" + token));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_Me(options: AxiosRequestConfig = {}): Promise<SupplierPortalMembershipDto[]> {
    let url_ = this.baseUrl + "/api/supplier-portal/me";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_MyAdminCompanies(options: AxiosRequestConfig = {}): Promise<SupplierPortalCompanyRefDto[]> {
    let url_ = this.baseUrl + "/api/supplier-portal/me/admin-companies";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_ListSampleRounds(args: SupplierPortal_ListSampleRoundsArgs, options: AxiosRequestConfig = {}): Promise<SupplierPortalSampleRoundPageDto> {
    const { companyId, closed, search, brandIds, people, offset, limit, } = args;
    let url_ = this.baseUrl + "/api/supplier-portal/companies/{companyId}/sample-rounds?";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    if (closed === null)
        throw new Error("The parameter 'closed' cannot be null.");
    else if (closed !== undefined)
        url_ += "closed=" + encodeURIComponent("" + closed) + "&";
    if (search !== undefined && search !== null)
        url_ += "search=" + encodeURIComponent("" + search) + "&";
    if (brandIds !== undefined && brandIds !== null)
        brandIds && brandIds.forEach(item => { url_ += "brandIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (people !== undefined && people !== null)
        people && people.forEach(item => { url_ += "people=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_GetSampleRoundPeople(companyId: number, options: AxiosRequestConfig = {}): Promise<SampleRoundPersonDto[]> {
    let url_ = this.baseUrl + "/api/supplier-portal/companies/{companyId}/sample-round-people";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_ListOrderDeliveries(args: SupplierPortal_ListOrderDeliveriesArgs, options: AxiosRequestConfig = {}): Promise<SupplierPortalOrderPageDto> {
    const { companyId, states, search, brandIds, minQuantity, maxQuantity, placedFrom, placedTo, placedIncludesUndated, shipmentFrom, shipmentTo, arrivalFrom, arrivalTo, sort, descending, offset, limit, } = args;
    let url_ = this.baseUrl + "/api/supplier-portal/companies/{companyId}/order-deliveries?";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    if (states !== undefined && states !== null)
        states && states.forEach(item => { url_ += "States=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (search !== undefined && search !== null)
        url_ += "Search=" + encodeURIComponent("" + search) + "&";
    if (brandIds !== undefined && brandIds !== null)
        brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (minQuantity !== undefined && minQuantity !== null)
        url_ += "MinQuantity=" + encodeURIComponent("" + minQuantity) + "&";
    if (maxQuantity !== undefined && maxQuantity !== null)
        url_ += "MaxQuantity=" + encodeURIComponent("" + maxQuantity) + "&";
    if (placedFrom !== undefined && placedFrom !== null)
        url_ += "PlacedFrom=" + encodeURIComponent("" + placedFrom) + "&";
    if (placedTo !== undefined && placedTo !== null)
        url_ += "PlacedTo=" + encodeURIComponent("" + placedTo) + "&";
    if (placedIncludesUndated === null)
        throw new Error("The parameter 'placedIncludesUndated' cannot be null.");
    else if (placedIncludesUndated !== undefined)
        url_ += "PlacedIncludesUndated=" + encodeURIComponent("" + placedIncludesUndated) + "&";
    if (shipmentFrom !== undefined && shipmentFrom !== null)
        url_ += "ShipmentFrom=" + encodeURIComponent("" + shipmentFrom) + "&";
    if (shipmentTo !== undefined && shipmentTo !== null)
        url_ += "ShipmentTo=" + encodeURIComponent("" + shipmentTo) + "&";
    if (arrivalFrom !== undefined && arrivalFrom !== null)
        url_ += "ArrivalFrom=" + encodeURIComponent("" + arrivalFrom) + "&";
    if (arrivalTo !== undefined && arrivalTo !== null)
        url_ += "ArrivalTo=" + encodeURIComponent("" + arrivalTo) + "&";
    if (sort === null)
        throw new Error("The parameter 'sort' cannot be null.");
    else if (sort !== undefined)
        url_ += "sort=" + encodeURIComponent("" + sort) + "&";
    if (descending === null)
        throw new Error("The parameter 'descending' cannot be null.");
    else if (descending !== undefined)
        url_ += "descending=" + encodeURIComponent("" + descending) + "&";
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_GetOrderDeliveryFacets(args: SupplierPortal_GetOrderDeliveryFacetsArgs, options: AxiosRequestConfig = {}): Promise<SupplierPortalOrderDeliveryFacetsDto> {
    const { companyId, states, search, brandIds, minQuantity, maxQuantity, placedFrom, placedTo, placedIncludesUndated, shipmentFrom, shipmentTo, arrivalFrom, arrivalTo, } = args;
    let url_ = this.baseUrl + "/api/supplier-portal/companies/{companyId}/order-delivery-facets?";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    if (states !== undefined && states !== null)
        states && states.forEach(item => { url_ += "States=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (search !== undefined && search !== null)
        url_ += "Search=" + encodeURIComponent("" + search) + "&";
    if (brandIds !== undefined && brandIds !== null)
        brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + (item === null || item === undefined ? "" : encodeURIComponent("" + item)) + "&"; });
    if (minQuantity !== undefined && minQuantity !== null)
        url_ += "MinQuantity=" + encodeURIComponent("" + minQuantity) + "&";
    if (maxQuantity !== undefined && maxQuantity !== null)
        url_ += "MaxQuantity=" + encodeURIComponent("" + maxQuantity) + "&";
    if (placedFrom !== undefined && placedFrom !== null)
        url_ += "PlacedFrom=" + encodeURIComponent("" + placedFrom) + "&";
    if (placedTo !== undefined && placedTo !== null)
        url_ += "PlacedTo=" + encodeURIComponent("" + placedTo) + "&";
    if (placedIncludesUndated === null)
        throw new Error("The parameter 'placedIncludesUndated' cannot be null.");
    else if (placedIncludesUndated !== undefined)
        url_ += "PlacedIncludesUndated=" + encodeURIComponent("" + placedIncludesUndated) + "&";
    if (shipmentFrom !== undefined && shipmentFrom !== null)
        url_ += "ShipmentFrom=" + encodeURIComponent("" + shipmentFrom) + "&";
    if (shipmentTo !== undefined && shipmentTo !== null)
        url_ += "ShipmentTo=" + encodeURIComponent("" + shipmentTo) + "&";
    if (arrivalFrom !== undefined && arrivalFrom !== null)
        url_ += "ArrivalFrom=" + encodeURIComponent("" + arrivalFrom) + "&";
    if (arrivalTo !== undefined && arrivalTo !== null)
        url_ += "ArrivalTo=" + encodeURIComponent("" + arrivalTo) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_GetOrderDelivery(brandSupplierId: number, deliveryId: number, options: AxiosRequestConfig = {}): Promise<SupplierPortalOrderDeliveryDetailDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/suppliers/{brandSupplierId}/order-deliveries/{deliveryId}";
    if (brandSupplierId === undefined || brandSupplierId === null)
        throw new Error("The parameter 'brandSupplierId' must be defined.");
    url_ = url_.replace("{brandSupplierId}", encodeURIComponent("" + brandSupplierId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_GetSampleRound(brandSupplierId: number, sampleRoundId: number, options: AxiosRequestConfig = {}): Promise<SupplierSampleRoundDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/suppliers/{brandSupplierId}/sample-rounds/{sampleRoundId}";
    if (brandSupplierId === undefined || brandSupplierId === null)
        throw new Error("The parameter 'brandSupplierId' must be defined.");
    url_ = url_.replace("{brandSupplierId}", encodeURIComponent("" + brandSupplierId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_CreateMessage(brandSupplierId: number, sampleRoundId: number, args: SupplierMessageArgs, options: AxiosRequestConfig = {}): Promise<SupplierSampleRoundDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/suppliers/{brandSupplierId}/sample-rounds/{sampleRoundId}/events/message";
    if (brandSupplierId === undefined || brandSupplierId === null)
        throw new Error("The parameter 'brandSupplierId' must be defined.");
    url_ = url_.replace("{brandSupplierId}", encodeURIComponent("" + brandSupplierId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_CreateSampleSent(brandSupplierId: number, sampleRoundId: number, args: SupplierSampleSentArgs, options: AxiosRequestConfig = {}): Promise<SupplierSampleRoundDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/suppliers/{brandSupplierId}/sample-rounds/{sampleRoundId}/events/sample-sent";
    if (brandSupplierId === undefined || brandSupplierId === null)
        throw new Error("The parameter 'brandSupplierId' must be defined.");
    url_ = url_.replace("{brandSupplierId}", encodeURIComponent("" + brandSupplierId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_CreateMeasurementReport(brandSupplierId: number, sampleRoundId: number, args: SupplierMeasurementReportArgs, options: AxiosRequestConfig = {}): Promise<SupplierSampleRoundDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/suppliers/{brandSupplierId}/sample-rounds/{sampleRoundId}/events/measurement-report";
    if (brandSupplierId === undefined || brandSupplierId === null)
        throw new Error("The parameter 'brandSupplierId' must be defined.");
    url_ = url_.replace("{brandSupplierId}", encodeURIComponent("" + brandSupplierId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_CreateInformationReply(brandSupplierId: number, sampleRoundId: number, args: SupplierInformationReplyArgs, options: AxiosRequestConfig = {}): Promise<SupplierSampleRoundDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/suppliers/{brandSupplierId}/sample-rounds/{sampleRoundId}/events/information-reply";
    if (brandSupplierId === undefined || brandSupplierId === null)
        throw new Error("The parameter 'brandSupplierId' must be defined.");
    url_ = url_.replace("{brandSupplierId}", encodeURIComponent("" + brandSupplierId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_GetRecipients(brandSupplierId: number, sampleRoundId: number, options: AxiosRequestConfig = {}): Promise<SupplierPortalRoundRecipientsDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/suppliers/{brandSupplierId}/sample-rounds/{sampleRoundId}/recipients";
    if (brandSupplierId === undefined || brandSupplierId === null)
        throw new Error("The parameter 'brandSupplierId' must be defined.");
    url_ = url_.replace("{brandSupplierId}", encodeURIComponent("" + brandSupplierId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_AddCcEmails(brandSupplierId: number, sampleRoundId: number, emails: string[], options: AxiosRequestConfig = {}): Promise<SupplierPortalRoundRecipientsDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/suppliers/{brandSupplierId}/sample-rounds/{sampleRoundId}/cc-emails";
    if (brandSupplierId === undefined || brandSupplierId === null)
        throw new Error("The parameter 'brandSupplierId' must be defined.");
    url_ = url_.replace("{brandSupplierId}", encodeURIComponent("" + brandSupplierId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = emails;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_RemoveCcEmails(brandSupplierId: number, sampleRoundId: number, emails: string[], options: AxiosRequestConfig = {}): Promise<SupplierPortalRoundRecipientsDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/suppliers/{brandSupplierId}/sample-rounds/{sampleRoundId}/cc-emails";
    if (brandSupplierId === undefined || brandSupplierId === null)
        throw new Error("The parameter 'brandSupplierId' must be defined.");
    url_ = url_.replace("{brandSupplierId}", encodeURIComponent("" + brandSupplierId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = emails;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_PublishDraft(brandSupplierId: number, sampleRoundId: number, eventId: number, options: AxiosRequestConfig = {}): Promise<SupplierSampleRoundDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/suppliers/{brandSupplierId}/sample-rounds/{sampleRoundId}/events/{eventId}/publish";
    if (brandSupplierId === undefined || brandSupplierId === null)
        throw new Error("The parameter 'brandSupplierId' must be defined.");
    url_ = url_.replace("{brandSupplierId}", encodeURIComponent("" + brandSupplierId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    if (eventId === undefined || eventId === null)
        throw new Error("The parameter 'eventId' must be defined.");
    url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_RemoveDraft(brandSupplierId: number, sampleRoundId: number, eventId: number, options: AxiosRequestConfig = {}): Promise<SupplierSampleRoundDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/suppliers/{brandSupplierId}/sample-rounds/{sampleRoundId}/events/{eventId}";
    if (brandSupplierId === undefined || brandSupplierId === null)
        throw new Error("The parameter 'brandSupplierId' must be defined.");
    url_ = url_.replace("{brandSupplierId}", encodeURIComponent("" + brandSupplierId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    if (eventId === undefined || eventId === null)
        throw new Error("The parameter 'eventId' must be defined.");
    url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_GetMeasurementData(brandSupplierId: number, sampleRoundId: number, options: AxiosRequestConfig = {}): Promise<SupplierMeasurementDataDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/suppliers/{brandSupplierId}/sample-rounds/{sampleRoundId}/measurement-data";
    if (brandSupplierId === undefined || brandSupplierId === null)
        throw new Error("The parameter 'brandSupplierId' must be defined.");
    url_ = url_.replace("{brandSupplierId}", encodeURIComponent("" + brandSupplierId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_UploadFile(brandSupplierId: number, sampleRoundId: number, file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<string> {
    let url_ = this.baseUrl + "/api/supplier-portal/suppliers/{brandSupplierId}/sample-rounds/{sampleRoundId}/upload-file";
    if (brandSupplierId === undefined || brandSupplierId === null)
        throw new Error("The parameter 'brandSupplierId' must be defined.");
    url_ = url_.replace("{brandSupplierId}", encodeURIComponent("" + brandSupplierId));
    if (sampleRoundId === undefined || sampleRoundId === null)
        throw new Error("The parameter 'sampleRoundId' must be defined.");
    url_ = url_.replace("{sampleRoundId}", encodeURIComponent("" + sampleRoundId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_GetPeople(companyId: number, options: AxiosRequestConfig = {}): Promise<SupplierPortalPeopleDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/companies/{companyId}/people";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_SetPerson(companyId: number, userId: string, args: SetPersonArgs, options: AxiosRequestConfig = {}): Promise<SupplierPortalPeopleDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/companies/{companyId}/people/{userId}";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_InviteColleague(companyId: number, args: InviteColleagueArgs, options: AxiosRequestConfig = {}): Promise<SupplierPortalPeopleDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/companies/{companyId}/invitations";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_GetCompanyDetails(companyId: number, options: AxiosRequestConfig = {}): Promise<SupplierPortalCompanyDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/companies/{companyId}/details";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_UpdateCompanyDetails(companyId: number, args: CompanyDetailsArgs, options: AxiosRequestConfig = {}): Promise<SupplierPortalCompanyDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/companies/{companyId}/details";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_SetCompanyLogo(companyId: number, logo: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<SupplierPortalCompanyDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/companies/{companyId}/logo";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (logo !== null && logo !== undefined)
        content_.append("logo", logo, logo.name ? logo.name : "logo");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierPortal_RemoveCompanyLogo(companyId: number, options: AxiosRequestConfig = {}): Promise<SupplierPortalCompanyDto> {
    let url_ = this.baseUrl + "/api/supplier-portal/companies/{companyId}/logo";
    if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierSampleRound_GetSampleRound(token: string, options: AxiosRequestConfig = {}): Promise<SupplierSampleRoundDto> {
    let url_ = this.baseUrl + "/api/supplier/sample-round/{token}";
    if (token === undefined || token === null)
        throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace("{token}", encodeURIComponent("" + token));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierSampleRound_CreateMessage(token: string, args: SupplierMessageArgs, options: AxiosRequestConfig = {}): Promise<SupplierSampleRoundDto> {
    let url_ = this.baseUrl + "/api/supplier/sample-round/{token}/events/message";
    if (token === undefined || token === null)
        throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace("{token}", encodeURIComponent("" + token));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierSampleRound_CreateSampleSent(token: string, args: SupplierSampleSentArgs, options: AxiosRequestConfig = {}): Promise<SupplierSampleRoundDto> {
    let url_ = this.baseUrl + "/api/supplier/sample-round/{token}/events/sample-sent";
    if (token === undefined || token === null)
        throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace("{token}", encodeURIComponent("" + token));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierSampleRound_CreateMeasurementReport(token: string, args: SupplierMeasurementReportArgs, options: AxiosRequestConfig = {}): Promise<SupplierSampleRoundDto> {
    let url_ = this.baseUrl + "/api/supplier/sample-round/{token}/events/measurement-report";
    if (token === undefined || token === null)
        throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace("{token}", encodeURIComponent("" + token));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierSampleRound_CreateInformationReply(token: string, args: SupplierInformationReplyArgs, options: AxiosRequestConfig = {}): Promise<SupplierSampleRoundDto> {
    let url_ = this.baseUrl + "/api/supplier/sample-round/{token}/events/information-reply";
    if (token === undefined || token === null)
        throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace("{token}", encodeURIComponent("" + token));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierSampleRound_GetMeasurementData(token: string, options: AxiosRequestConfig = {}): Promise<SupplierMeasurementDataDto> {
    let url_ = this.baseUrl + "/api/supplier/sample-round/{token}/measurement-data";
    if (token === undefined || token === null)
        throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace("{token}", encodeURIComponent("" + token));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierSampleRound_UploadFile(token: string, file: FileParameter | null | undefined, options: AxiosRequestConfig = {}): Promise<string> {
    let url_ = this.baseUrl + "/api/supplier/sample-round/{token}/upload-file";
    if (token === undefined || token === null)
        throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace("{token}", encodeURIComponent("" + token));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file, file.name ? file.name : "file");

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplierSampleRound_RequestAccount(token: string, email: string, options: AxiosRequestConfig = {}): Promise<RequestAccountResponse> {
    let url_ = this.baseUrl + "/api/supplier/sample-round/{token}/request-account";
    if (token === undefined || token === null)
        throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace("{token}", encodeURIComponent("" + token));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = email;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplyChainStepType_List(brandId: number, options: AxiosRequestConfig = {}): Promise<SupplyChainStepTypeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/supply-chain-step-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplyChainStepType_Create(brandId: number, args: CreateArgs, options: AxiosRequestConfig = {}): Promise<SupplyChainStepTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/supply-chain-step-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplyChainStepType_Update(brandId: number, id: number, args: UpdateArgs2, options: AxiosRequestConfig = {}): Promise<SupplyChainStepTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/supply-chain-step-types/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplyChainStepType_Delete(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/supply-chain-step-types/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async supplyChainStepType_GetUsageCount(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/supply-chain-step-types/{id}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the caller's saved table views — the column sets and filters users work from — for every table at once.
 */
  async tableView_List(brandId: number, options: AxiosRequestConfig = {}): Promise<TableViewDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/table-view";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tableView_Create(brandId: number, args: CreateTableViewArgs, options: AxiosRequestConfig = {}): Promise<TableViewDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/table-view";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Read one shared table view by id. Resolves a shared link, so the view may belong to someone else in the brand.
 */
  async tableView_GetShared(brandId: number, viewId: number, options: AxiosRequestConfig = {}): Promise<TableViewDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/table-view/{viewId}/shared";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (viewId === undefined || viewId === null)
        throw new Error("The parameter 'viewId' must be defined.");
    url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tableView_Fork(brandId: number, viewId: number, options: AxiosRequestConfig = {}): Promise<TableViewDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/table-view/{viewId}/fork";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (viewId === undefined || viewId === null)
        throw new Error("The parameter 'viewId' must be defined.");
    url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tableView_Update(brandId: number, viewId: number, args: UpdateTableViewArgs, options: AxiosRequestConfig = {}): Promise<TableViewDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/table-view/{viewId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (viewId === undefined || viewId === null)
        throw new Error("The parameter 'viewId' must be defined.");
    url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tableView_Delete(brandId: number, viewId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/table-view/{viewId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (viewId === undefined || viewId === null)
        throw new Error("The parameter 'viewId' must be defined.");
    url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tableView_SetDefault(brandId: number, viewId: number, options: AxiosRequestConfig = {}): Promise<TableViewDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/table-view/{viewId}/set-default";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (viewId === undefined || viewId === null)
        throw new Error("The parameter 'viewId' must be defined.");
    url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tableView_Reorder(brandId: number, args: ReorderTableViewsArgs, options: AxiosRequestConfig = {}): Promise<TableViewDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/table-view/reorder";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List the brand's tags and tag categories.
 */
  async tag_GetTags(brandId: number, options: AxiosRequestConfig = {}): Promise<TagCategoryDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tag_AddTag(brandId: number, args: AddTagArgs4, options: AxiosRequestConfig = {}): Promise<TagDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tag_AddTagCategory(brandId: number, args: AddTagCategoryArgs, options: AxiosRequestConfig = {}): Promise<TagCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/category";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Update one tag's name, colour or hierarchy-node visibility. HierarchyNodeIds replaces the whole set and narrows the category: an empty list means the tag follows its category everywhere, and node ids outside the category's own nodes leave the tag visible nowhere. A narrowing that would hide the tag on products/articles still carrying it is refused — call tag_PreviewTagVisibility first to see what is in the way, and clear the tag off those first.
 */
  async tag_UpdateTag(brandId: number, tagId: number, args: UpdateTagArgs5, options: AxiosRequestConfig = {}): Promise<TagDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tag_DeleteTag(brandId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Check whether one tag's hierarchy-node visibility can be narrowed to HierarchyNodeIds. Returns one row per tag still used where it would become invisible; a non-empty list means tag_UpdateTag will refuse the change, and an empty list means it is safe. Always call this before tag_UpdateTag with HierarchyNodeIds.
 */
  async tag_PreviewTagVisibility(brandId: number, tagId: number, args: PreviewVisibilityArgs, options: AxiosRequestConfig = {}): Promise<TagVisibilityLossDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/{tagId}/visibility-preview";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Check whether a tag category's hierarchy-node visibility can be narrowed to HierarchyNodeIds, across every tag in it. Returns one row per tag still used where it would become invisible; a non-empty list means tag_UpdateTagCategory will refuse the change, and an empty list means it is safe. Always call this before tag_UpdateTagCategory with HierarchyNodeIds.
 */
  async tag_PreviewTagCategoryVisibility(brandId: number, tagCategoryId: number, args: PreviewVisibilityArgs, options: AxiosRequestConfig = {}): Promise<TagVisibilityLossDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/category/{tagCategoryId}/visibility-preview";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Update a tag category's name, uniqueness, article-number flag or hierarchy-node visibility. HierarchyNodeIds replaces the whole set; an empty list means the category is visible everywhere. A narrowing is refused when it would hide a tag still in use, or strand a tag restricted to nodes the new selection does not cover — call tag_PreviewTagCategoryVisibility first to see what is in the way.
 */
  async tag_UpdateTagCategory(brandId: number, tagCategoryId: number, args: UpdateTagCategoryArgs3, options: AxiosRequestConfig = {}): Promise<TagCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/category/{tagCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tag_DeleteTagCategory(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/category/{tagCategoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Reorder the brand's tag categories. The order is meaningful and is what users see; send every category id as one brand-wide sequence, product-level section first, then article-level.
 */
  async tag_ReorderTagCategories(brandId: number, args: ReorderTagCategoriesArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/category/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Reorder the tags within one tag category. The order is meaningful and is what users see in the picker; send every tag id in the category, in the order you want.
 */
  async tag_ReorderTags(brandId: number, tagCategoryId: number, args: ReorderTagsArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/category/{tagCategoryId}/tag-order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tag_GetTagUsageCount(brandId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/{tagId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Count the articles and products currently tagged from this tag category. Call this before deleting one.
 */
  async tag_GetTagCategoryUsageCount(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<number> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/category/{tagCategoryId}/count-usages";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tag_GetTagViolations(brandId: number, options: AxiosRequestConfig = {}): Promise<ProductWithTagViolationsDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/violations";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview what promoting a tag category from article level to product level would do, including conflicts needing a resolution. Always call this before tag_PromoteToProductLevel.
 */
  async tag_PreviewPromoteToProductLevel(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<PreviewPromoteResult> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/category/{tagCategoryId}/product-level-preview";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Promote a tag category from article level to product level, so its tags attach to products instead of article-seasons. Run tag_PreviewPromoteToProductLevel first and pass its conflicts back as resolutions.
 */
  async tag_PromoteToProductLevel(brandId: number, tagCategoryId: number, args: PromoteToProductLevelArgs, options: AxiosRequestConfig = {}): Promise<TagCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/category/{tagCategoryId}/promote-to-product-level";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Preview what demoting a tag category from product level to article level would do. Always call this before tag_DemoteToArticleLevel.
 */
  async tag_PreviewDemoteToArticleLevel(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<PreviewDemoteResult> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/category/{tagCategoryId}/article-level-preview";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Demote a tag category from product level to article level, so its tags attach to article-seasons instead of products. Run tag_PreviewDemoteToArticleLevel first.
 */
  async tag_DemoteToArticleLevel(brandId: number, tagCategoryId: number, options: AxiosRequestConfig = {}): Promise<TagCategoryDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tags/category/{tagCategoryId}/demote-to-article-level";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagCategoryId === undefined || tagCategoryId === null)
        throw new Error("The parameter 'tagCategoryId' must be defined.");
    url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Add a tariff code to a tariff code system. Unless the system has validation switched off, the value must match that system's format — an EU/TARIC system takes the 10-digit form, an EU/CN system the 8-digit one — and a value that does not is rejected rather than skipped. Adding a value the system already holds returns the system unchanged.
 */
  async tariffCode_AddTariffCode(brandId: number, args: AddTariffCodeArgs, options: AxiosRequestConfig = {}): Promise<TariffCodeSystemDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-codes";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Copy tariff codes from one tariff code system into another.
 */
  async tariffCode_CopyTariffCodes(brandId: number, args: CopyTariffCodesArgs, options: AxiosRequestConfig = {}): Promise<TariffCodeSystemDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-codes/copy";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tariffCode_UpdateTariffCode(brandId: number, id: number, args: UpdateTariffCodeArgs, options: AxiosRequestConfig = {}): Promise<TariffCodeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-codes/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tariffCode_DeleteTariffCode(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-codes/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Update many tariff codes in one call. Prefer this over repeated tariffCode_UpdateTariffCode.
 */
  async tariffCode_BatchUpdateTariffCodes(brandId: number, args: BatchUpdateTariffCodesArgs, options: AxiosRequestConfig = {}): Promise<TariffCodeSystemDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-codes/batch";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set specific fields across many tariff codes in one call.
 */
  async tariffCode_BatchSetTariffCodeFields(brandId: number, args: BatchSetTariffCodeFieldsArgs, options: AxiosRequestConfig = {}): Promise<TariffCodeSystemDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-codes/batch/fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tariffCode_GetCodeUsage(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<TariffCodeUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-codes/{id}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tariffCode_AddDuty(brandId: number, id: number, args: AddDutyArgs, options: AxiosRequestConfig = {}): Promise<TariffCodeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-codes/{id}/duties";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tariffCode_UpdateDuty(brandId: number, id: number, dutyId: number, args: UpdateDutyArgs, options: AxiosRequestConfig = {}): Promise<TariffCodeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-codes/{id}/duties/{dutyId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (dutyId === undefined || dutyId === null)
        throw new Error("The parameter 'dutyId' must be defined.");
    url_ = url_.replace("{dutyId}", encodeURIComponent("" + dutyId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tariffCode_DeleteDuty(brandId: number, id: number, dutyId: number, options: AxiosRequestConfig = {}): Promise<TariffCodeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-codes/{id}/duties/{dutyId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (dutyId === undefined || dutyId === null)
        throw new Error("The parameter 'dutyId' must be defined.");
    url_ = url_.replace("{dutyId}", encodeURIComponent("" + dutyId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Update many per-destination duty rates in one call. Prefer this over repeated tariffCode_UpdateDuty.
 */
  async tariffCode_BatchUpdateDuties(brandId: number, args: BatchUpdateDutiesArgs, options: AxiosRequestConfig = {}): Promise<TariffCodeSystemDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-codes/duties/batch";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tariffCodeSystem_GetTariffCodeSystems(brandId: number, options: AxiosRequestConfig = {}): Promise<TariffCodeSystemDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-code-systems";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tariffCodeSystem_Create(brandId: number, args: CreateTariffCodeSystemArgs, options: AxiosRequestConfig = {}): Promise<TariffCodeSystemDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-code-systems";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tariffCodeSystem_Update(brandId: number, id: number, args: UpdateTariffCodeSystemArgs, options: AxiosRequestConfig = {}): Promise<TariffCodeSystemDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-code-systems/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tariffCodeSystem_Delete(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-code-systems/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * List this brand's Shopify connections whose saved mappings reference this tariff system by name. Read before renaming to warn that those mappings need updating; changes no data.
 */
  async tariffCodeSystem_GetShopifyMappings(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<EntityReference[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-code-systems/{id}/shopify-mappings";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tariffCodeSystem_GetSystemUsage(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<TariffCodeSystemUsageDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-code-systems/{id}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async tariffCodeSystem_UpdateOrder(brandId: number, tariffCodeSystemIds: number[], options: AxiosRequestConfig = {}): Promise<TariffCodeSystemDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-code-systems/order";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = tariffCodeSystemIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Refresh a tariff code system from the external TARIC dataset. Long-running and rewrites codes in bulk; confirm with the user before calling.
 */
  async tariffCodeSystem_SyncTaric(brandId: number, id: number, args: SyncTaricArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/tariff-code-systems/{id}/sync-taric";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async timeline_ListTimelines(brandId: number, options: AxiosRequestConfig = {}): Promise<TimelineDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async timeline_CreateTimeline(brandId: number, args: CreateTimelineArgs, options: AxiosRequestConfig = {}): Promise<TimelineDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async timeline_UpdateTimeline(brandId: number, timelineId: number, args: UpdateTimelineArgs, options: AxiosRequestConfig = {}): Promise<TimelineDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/{timelineId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (timelineId === undefined || timelineId === null)
        throw new Error("The parameter 'timelineId' must be defined.");
    url_ = url_.replace("{timelineId}", encodeURIComponent("" + timelineId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Delete a timeline, its gates, its anchors and every article's progress on it. Read timeline_GetUsage first — it reports articleCount and completionCount, which is what a confirmation has to say out loud. The freed article-seasons are re-resolved across the brand and may land on another timeline.
 */
  async timeline_DeleteTimeline(brandId: number, timelineId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/{timelineId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (timelineId === undefined || timelineId === null)
        throw new Error("The parameter 'timelineId' must be defined.");
    url_ = url_.replace("{timelineId}", encodeURIComponent("" + timelineId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Copy a timeline, taking the named seasons with it: the clone is anchored to those seasons and the original is no longer. Use it to split one plan into two when seasons start diverging. Both sides then cover different seasons, so the brand is re-resolved.
 */
  async timeline_CloneTimeline(brandId: number, timelineId: number, args: CloneTimelineArgs, options: AxiosRequestConfig = {}): Promise<TimelineDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/{timelineId}/clone";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (timelineId === undefined || timelineId === null)
        throw new Error("The parameter 'timelineId' must be defined.");
    url_ = url_.replace("{timelineId}", encodeURIComponent("" + timelineId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async timeline_GetUsage(brandId: number, timelineId: number, options: AxiosRequestConfig = {}): Promise<TimelineUsage> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/{timelineId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (timelineId === undefined || timelineId === null)
        throw new Error("The parameter 'timelineId' must be defined.");
    url_ = url_.replace("{timelineId}", encodeURIComponent("" + timelineId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set the brand's timeline order, which is the last tiebreak when two timelines are equally eligible for an article — so this can move articles between them. Takes the ids as a bare array and wants EVERY timeline the brand has: a subset is a 400 ("Not the same Ids").
 */
  async timeline_ReorderTimelines(brandId: number, timelineIds: number[], options: AxiosRequestConfig = {}): Promise<TimelineDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/reorder";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = timelineIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * REPLACES the timeline's whole gate list. A gate you leave out is deleted, and every article's tick, estimate and note on that gate goes with it — read the timeline and send the gates back in full, keeping `id` on the ones that already exist and omitting `id` to add one. `offset` is days counted BACK from the season's anchor, so a bigger offset is an earlier date; `roleId` is who owns the gate and `party` says whether that is the brand or the supplier.
 */
  async timeline_PutGates(brandId: number, timelineId: number, args: PutGatesArgs, options: AxiosRequestConfig = {}): Promise<TimelineDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/{timelineId}/gates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (timelineId === undefined || timelineId === null)
        throw new Error("The parameter 'timelineId' must be defined.");
    url_ = url_.replace("{timelineId}", encodeURIComponent("" + timelineId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Give the timeline a date to plan one season from. Until a season is anchored the timeline plans nothing; anchoring it makes every article-season the filters allow eligible, so this re-resolves the brand. Gate dates are computed back from this date and can then be tuned per season with timeline_PutGateDates.
 */
  async timeline_SetAnchor(brandId: number, timelineId: number, seasonId: number, args: SetAnchorArgs, options: AxiosRequestConfig = {}): Promise<TimelineDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/{timelineId}/anchors/{seasonId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (timelineId === undefined || timelineId === null)
        throw new Error("The parameter 'timelineId' must be defined.");
    url_ = url_.replace("{timelineId}", encodeURIComponent("" + timelineId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Un-anchor a season: the timeline stops planning it, and every article-season it covered there loses this plan — the tuned dates and the drops under it go too. Read timeline_GetAnchorUsage first, which reports how many articles and completions are involved. The freed articles are re-resolved and may pick up another timeline that plans their season.
 */
  async timeline_RemoveAnchor(brandId: number, timelineId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<TimelineDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/{timelineId}/anchors/{seasonId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (timelineId === undefined || timelineId === null)
        throw new Error("The parameter 'timelineId' must be defined.");
    url_ = url_.replace("{timelineId}", encodeURIComponent("" + timelineId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Move gates within one season, without touching the template or any other season — this is how a brand works around a factory holiday. Takes a list so several gates can shift together. Gates you leave out keep their dates.
 */
  async timeline_PutGateDates(brandId: number, timelineId: number, seasonId: number, args: PutGateDatesArgs, options: AxiosRequestConfig = {}): Promise<TimelineDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/{timelineId}/anchors/{seasonId}/gates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (timelineId === undefined || timelineId === null)
        throw new Error("The parameter 'timelineId' must be defined.");
    url_ = url_.replace("{timelineId}", encodeURIComponent("" + timelineId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Give one drop inside a season its own date to count back from. It starts from the season's plan slid to that date, so per-season tuning carries over. Articles in that drop follow it instead of the season. Takes ONE named-argument object, not positional arguments — {brandId, timelineId, seasonId, dropId, anchorArgs: {anchorDate}} — and note the payload is `anchorArgs`, not `args`.
 */
  async timeline_SetDropAnchor(args: Timeline_SetDropAnchorArgs, options: AxiosRequestConfig = {}): Promise<TimelineDto> {
    const { brandId, timelineId, seasonId, dropId, anchorArgs, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/{timelineId}/anchors/{seasonId}/drops/{dropId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (timelineId === undefined || timelineId === null)
        throw new Error("The parameter 'timelineId' must be defined.");
    url_ = url_.replace("{timelineId}", encodeURIComponent("" + timelineId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    if (dropId === undefined || dropId === null)
        throw new Error("The parameter 'dropId' must be defined.");
    url_ = url_.replace("{dropId}", encodeURIComponent("" + dropId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = anchorArgs;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Stop the drop overriding its season: its articles fall back to the season's own gate dates. The drop's tuned dates are discarded, not remembered.
 */
  async timeline_RemoveDropAnchor(brandId: number, timelineId: number, seasonId: number, dropId: number, options: AxiosRequestConfig = {}): Promise<TimelineDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/{timelineId}/anchors/{seasonId}/drops/{dropId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (timelineId === undefined || timelineId === null)
        throw new Error("The parameter 'timelineId' must be defined.");
    url_ = url_.replace("{timelineId}", encodeURIComponent("" + timelineId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    if (dropId === undefined || dropId === null)
        throw new Error("The parameter 'dropId' must be defined.");
    url_ = url_.replace("{dropId}", encodeURIComponent("" + dropId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * The same move as timeline_PutGateDates, against one drop's plan rather than the season's. Gates you leave out keep their dates. Takes ONE named-argument object, not positional arguments — {brandId, timelineId, seasonId, dropId, dateArgs: {gateDates}} — and note the payload is `dateArgs`, not `args`.
 */
  async timeline_PutDropGateDates(args: Timeline_PutDropGateDatesArgs, options: AxiosRequestConfig = {}): Promise<TimelineDto> {
    const { brandId, timelineId, seasonId, dropId, dateArgs, } = args;
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/{timelineId}/anchors/{seasonId}/drops/{dropId}/gates";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (timelineId === undefined || timelineId === null)
        throw new Error("The parameter 'timelineId' must be defined.");
    url_ = url_.replace("{timelineId}", encodeURIComponent("" + timelineId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    if (dropId === undefined || dropId === null)
        throw new Error("The parameter 'dropId' must be defined.");
    url_ = url_.replace("{dropId}", encodeURIComponent("" + dropId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = dateArgs;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async timeline_GetAnchorUsage(brandId: number, timelineId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<AnchorUsage> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/{timelineId}/anchors/{seasonId}/usage";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (timelineId === undefined || timelineId === null)
        throw new Error("The parameter 'timelineId' must be defined.");
    url_ = url_.replace("{timelineId}", encodeURIComponent("" + timelineId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Set which articles the timeline may cover, as hierarchy nodes and tags. REPLACES both lists — send the ids you want kept, not just the new ones. Coverage is this crossed with the seasons the timeline is anchored to; it re-resolves the whole brand, so article-seasons can move onto this timeline or off it.
 */
  async timeline_PutFilters(brandId: number, timelineId: number, args: PutFiltersArgs, options: AxiosRequestConfig = {}): Promise<TimelineDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/timelines/{timelineId}/filters";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (timelineId === undefined || timelineId === null)
        throw new Error("The parameter 'timelineId' must be defined.");
    url_ = url_.replace("{timelineId}", encodeURIComponent("" + timelineId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async treatment_GetTreatments(brandId: number, options: AxiosRequestConfig = {}): Promise<TreatmentDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/treatments";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async treatment_CreateTreatment(brandId: number, treatment: CreateTreatmentArgs, options: AxiosRequestConfig = {}): Promise<TreatmentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/treatments";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = treatment;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async treatment_DeleteTreatment(brandId: number, treatmentId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/treatments/{treatmentId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (treatmentId === undefined || treatmentId === null)
        throw new Error("The parameter 'treatmentId' must be defined.");
    url_ = url_.replace("{treatmentId}", encodeURIComponent("" + treatmentId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async treatment_UpdateTreatment(brandId: number, treatmentId: number, args: UpdateTreatmentArgs, options: AxiosRequestConfig = {}): Promise<TreatmentDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/treatments/{treatmentId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (treatmentId === undefined || treatmentId === null)
        throw new Error("The parameter 'treatmentId' must be defined.");
    url_ = url_.replace("{treatmentId}", encodeURIComponent("" + treatmentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async treatmentType_GetTreatmentTypes(brandId: number, options: AxiosRequestConfig = {}): Promise<TreatmentTypeDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/treatment-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async treatmentType_CreateTreatmentType(brandId: number, type: TreatmentTypeArgs, options: AxiosRequestConfig = {}): Promise<TreatmentTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/treatment-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = type;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async treatmentType_UpdateTreatmentType(brandId: number, treatmentTypeId: number, type: TreatmentTypeArgs, options: AxiosRequestConfig = {}): Promise<TreatmentTypeDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/treatment-types/{treatmentTypeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (treatmentTypeId === undefined || treatmentTypeId === null)
        throw new Error("The parameter 'treatmentTypeId' must be defined.");
    url_ = url_.replace("{treatmentTypeId}", encodeURIComponent("" + treatmentTypeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = type;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async treatmentType_DeleteTreatmentType(brandId: number, treatmentTypeId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/treatment-types/{treatmentTypeId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (treatmentTypeId === undefined || treatmentTypeId === null)
        throw new Error("The parameter 'treatmentTypeId' must be defined.");
    url_ = url_.replace("{treatmentTypeId}", encodeURIComponent("" + treatmentTypeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async unit_ListUnits(brandId: number, options: AxiosRequestConfig = {}): Promise<UnitDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/units";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async unit_CreateUnit(brandId: number, args: CreateUnitArgs, options: AxiosRequestConfig = {}): Promise<UnitDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/units";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async unit_UpdateUnit(brandId: number, unitId: number, args: CreateUnitArgs, options: AxiosRequestConfig = {}): Promise<UnitDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/units/{unitId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (unitId === undefined || unitId === null)
        throw new Error("The parameter 'unitId' must be defined.");
    url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async unit_DeleteUnit(brandId: number, unitId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/units/{unitId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (unitId === undefined || unitId === null)
        throw new Error("The parameter 'unitId' must be defined.");
    url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async unit_GetMostUsedUnits(brandId: number, options: AxiosRequestConfig = {}): Promise<UnitIdAndCount[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/units/most-used";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async userConfiguration_GetConfiguration(brandId: number, options: AxiosRequestConfig = {}): Promise<UserConfigSection> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/user-configuration";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async userConfiguration_GetPersonalConfiguration(brandId: number, options: AxiosRequestConfig = {}): Promise<ConfigurationPair[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/user-configuration/raw-personal";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async userConfiguration_GetGlobalConfiguration(brandId: number, options: AxiosRequestConfig = {}): Promise<ConfigurationPair[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/user-configuration/raw-global";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Writes many cells in one request, each with its own value — what a clipboard paste
over the config table produces. Returns both raw lists, which is what the table reads,
so it can show the saved values without re-fetching them.
 */
  async userConfiguration_SetConfigurationBulk(brandId: number, args: SetConfigurationBulkArgs, options: AxiosRequestConfig = {}): Promise<RawConfiguration> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/user-configuration/bulk";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Writes several of the caller's own keys in one request. Applying a saved table view
writes both the columns and the active view, and one request means one save, one
SignalR notification and one answer to read the new configuration from.
 */
  async userConfiguration_SetPersonalConfigurationBulk(brandId: number, args: SetPersonalConfigurationBulkArgs, options: AxiosRequestConfig = {}): Promise<UserConfigSection> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/user-configuration/personal/bulk";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async userConfiguration_SetPersonalConfiguration(brandId: number, args: ConfigurationPair, options: AxiosRequestConfig = {}): Promise<UserConfigSection> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/user-configuration/personal";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async userConfiguration_UnsetPersonalConfiguration(brandId: number, key: string | undefined, options: AxiosRequestConfig = {}): Promise<UserConfigSection> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/user-configuration/personal?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (key === null)
        throw new Error("The parameter 'key' cannot be null.");
    else if (key !== undefined)
        url_ += "key=" + encodeURIComponent("" + key) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async userConfiguration_SetGlobalConfiguration(brandId: number, args: ConfigurationPair, options: AxiosRequestConfig = {}): Promise<UserConfigSection> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/user-configuration/global";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async userConfiguration_UnsetGlobalConfiguration(brandId: number, key: string | undefined, options: AxiosRequestConfig = {}): Promise<UserConfigSection> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/user-configuration/global?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (key === null)
        throw new Error("The parameter 'key' cannot be null.");
    else if (key !== undefined)
        url_ += "key=" + encodeURIComponent("" + key) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async userConfiguration_SetConfigForUser(brandId: number, args: SetUserConfigArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/user-configuration/set-for-user";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async userConfiguration_UnsetConfigForUser(brandId: number, args: UnsetUserConfigArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/user-configuration/unset-for-user";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async webhook_GetWebhooks(brandId: number, options: AxiosRequestConfig = {}): Promise<WebhookDto[]> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/webhooks";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Create a webhook. `basicAuth.key` is write-only: it is stored and sent with each delivery, but
never returned; the returned `basicAuth.hasKey` says whether one is set.
 */
  async webhook_Create(brandId: number, args: CreateWebhookArgs, options: AxiosRequestConfig = {}): Promise<WebhookDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/webhooks";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Update a webhook, replacing every field. `basicAuth.key` is write-only: send null or "" to keep
the stored key, or a value to replace it. `basicAuth: null` removes Basic Auth, key included.
 */
  async webhook_Update(brandId: number, webhookId: number, args: UpdateWebhookArgs, options: AxiosRequestConfig = {}): Promise<WebhookDto> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/webhooks/{webhookId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (webhookId === undefined || webhookId === null)
        throw new Error("The parameter 'webhookId' must be defined.");
    url_ = url_.replace("{webhookId}", encodeURIComponent("" + webhookId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async webhook_Delete(brandId: number, webhookId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/brand/{brandId}/webhooks/{webhookId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (webhookId === undefined || webhookId === null)
        throw new Error("The parameter 'webhookId' must be defined.");
    url_ = url_.replace("{webhookId}", encodeURIComponent("" + webhookId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integrationArticles_GetArticleV3Channels(brandId: number, articleNumber: string, options: AxiosRequestConfig = {}): Promise<{ [key: string]: ArticleIntegrationDtoV3; }> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/v3/articles/{articleNumber}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleNumber === undefined || articleNumber === null)
        throw new Error("The parameter 'articleNumber' must be defined.");
    url_ = url_.replace("{articleNumber}", encodeURIComponent("" + articleNumber));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integrationArticles_GetAllArticlesV3Channels(brandId: number, offset: number | undefined, limit: number | undefined, options: AxiosRequestConfig = {}): Promise<GetArticlesV3Response> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/v3/articles?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integrationArticles_GetArticlesByNumbersV3Channels(brandId: number, args: GetArticlesByNumbersV3Args, options: AxiosRequestConfig = {}): Promise<GetArticlesByNumbersV3Response> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/v3/articles/by-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integrationArticles_GetArticlesBySkuNumbersV3Channels(brandId: number, args: GetArticlesBySkuNumbersV3Args, options: AxiosRequestConfig = {}): Promise<GetArticlesBySkuNumbersV3Response> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/v3/articles/by-sku-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integrationArticles_GetArticleV3Seasons(brandId: number, articleNumber: string, options: AxiosRequestConfig = {}): Promise<ArticleIntegrationDtoV3Seasons> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/v3/articles-with-seasons/{articleNumber}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleNumber === undefined || articleNumber === null)
        throw new Error("The parameter 'articleNumber' must be defined.");
    url_ = url_.replace("{articleNumber}", encodeURIComponent("" + articleNumber));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integrationArticles_GetAllArticlesV3Seasons(brandId: number, offset: number | undefined, limit: number | undefined, options: AxiosRequestConfig = {}): Promise<GetArticlesV3SeasonsResponse> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/v3/articles-with-seasons?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integrationArticles_GetArticlesByNumbersV3Seasons(brandId: number, args: GetArticlesByNumbersV3SeasonsArgs, options: AxiosRequestConfig = {}): Promise<GetArticlesByNumbersV3SeasonsResponse> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/v3/articles-with-seasons/by-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetArticle(brandId: number, articleNumber: string, options: AxiosRequestConfig = {}): Promise<ArticleIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/v2/articles/{articleNumber}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleNumber === undefined || articleNumber === null)
        throw new Error("The parameter 'articleNumber' must be defined.");
    url_ = url_.replace("{articleNumber}", encodeURIComponent("" + articleNumber));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * @deprecated
 */
  async integration_GetArticleOld(brandId: number, articleNumber: string, options: AxiosRequestConfig = {}): Promise<ArticleIntegrationDtoOld> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/articles/{articleNumber}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleNumber === undefined || articleNumber === null)
        throw new Error("The parameter 'articleNumber' must be defined.");
    url_ = url_.replace("{articleNumber}", encodeURIComponent("" + articleNumber));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetArticleNumbers(brandId: number, options: AxiosRequestConfig = {}): Promise<string[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/articles/numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetAllArticles(brandId: number, offset: number | undefined, limit: number | undefined, options: AxiosRequestConfig = {}): Promise<GetArticlesResponse> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/v2/articles?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetArticlesByNumbers(brandId: number, args: GetArticlesByNumbersArgs, options: AxiosRequestConfig = {}): Promise<GetArticlesByNumberResponse> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/v2/articles/by-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetTag(brandId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<TagIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * @deprecated
 */
  async integration_GetSeason(brandId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<SeasonIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/seasons/{seasonId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (seasonId === undefined || seasonId === null)
        throw new Error("The parameter 'seasonId' must be defined.");
    url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetSizeSystemVersions(brandId: number, options: AxiosRequestConfig = {}): Promise<SizeSystemVersionIntegration[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/size-systems";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetSizeConversionTables(brandId: number, options: AxiosRequestConfig = {}): Promise<SizeConversionTableIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/size-conversion-tables";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetSizeConversionTable(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<SizeConversionTableIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/size-conversion-tables/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_TriggerArticleIntegration(brandId: number, articleNumber: string, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/articles/{articleNumber}/integration";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleNumber === undefined || articleNumber === null)
        throw new Error("The parameter 'articleNumber' must be defined.");
    url_ = url_.replace("{articleNumber}", encodeURIComponent("" + articleNumber));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_TriggerAllArticleIntegration(brandId: number, individually: boolean | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/articles/all?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (individually === null)
        throw new Error("The parameter 'individually' cannot be null.");
    else if (individually !== undefined)
        url_ += "individually=" + encodeURIComponent("" + individually) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_TriggerArticleIntegrationForList(brandId: number, individually: boolean | undefined, articleNumbers: string[], options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/articles/integration?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (individually === null)
        throw new Error("The parameter 'individually' cannot be null.");
    else if (individually !== undefined)
        url_ += "individually=" + encodeURIComponent("" + individually) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = articleNumbers;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetCustomers(brandId: number, options: AxiosRequestConfig = {}): Promise<CustomerIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_CreateCustomer(brandId: number, args: CreateCustomerArgs, options: AxiosRequestConfig = {}): Promise<CustomerIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_UpdateCustomer(brandId: number, id: number, args: CreateCustomerArgs, options: AxiosRequestConfig = {}): Promise<CustomerIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customers/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetDeliveryLocations(brandId: number, options: AxiosRequestConfig = {}): Promise<DeliveryLocationIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/delivery-locations";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_CreateDeliveryLocation(brandId: number, args: CreateDeliveryLocationArgs, options: AxiosRequestConfig = {}): Promise<DeliveryLocationIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/delivery-locations";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetDestinations(brandId: number, options: AxiosRequestConfig = {}): Promise<DestinationIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/destinations";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_UpdateDeliveryLocation(brandId: number, id: number, args: CreateDeliveryLocationArgs, options: AxiosRequestConfig = {}): Promise<DeliveryLocationIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/delivery-locations/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetOrderTypes(brandId: number, options: AxiosRequestConfig = {}): Promise<OrderTypeIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-types";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetCustomerOrders(brandId: number, options: AxiosRequestConfig = {}): Promise<CustomerOrderIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customer-orders";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_CreateCustomerOrder(brandId: number, args: CreateCustomerOrderArgs, options: AxiosRequestConfig = {}): Promise<CustomerOrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customer-orders";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_DeleteCustomerOrder(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customer-orders/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_UpdateCustomerOrder(brandId: number, id: number, args: UpdateCustomerOrderArgs, options: AxiosRequestConfig = {}): Promise<CustomerOrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customer-orders/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_AddCustomerOrderDelivery(brandId: number, customerOrderId: number, args: AddDeliveryArgs, options: AxiosRequestConfig = {}): Promise<CustomerOrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customer-orders/{customerOrderId}/deliveries";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (customerOrderId === undefined || customerOrderId === null)
        throw new Error("The parameter 'customerOrderId' must be defined.");
    url_ = url_.replace("{customerOrderId}", encodeURIComponent("" + customerOrderId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_UpdateCustomerOrderDelivery(brandId: number, deliveryId: number, args: UpdateDeliveryArgs2, options: AxiosRequestConfig = {}): Promise<CustomerOrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customer-order-deliveries/{deliveryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_DeleteCustomerOrderDelivery(brandId: number, deliveryId: number, options: AxiosRequestConfig = {}): Promise<CustomerOrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customer-order-deliveries/{deliveryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_AddCustomerOrderRows(brandId: number, deliveryId: number, args: AddRowArgs[], options: AxiosRequestConfig = {}): Promise<CustomerOrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customer-order-deliveries/{deliveryId}/rows";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_UpdateCustomerOrderRow(brandId: number, rowId: number, args: UpdateRowArgs, options: AxiosRequestConfig = {}): Promise<CustomerOrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customer-order-rows/{rowId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (rowId === undefined || rowId === null)
        throw new Error("The parameter 'rowId' must be defined.");
    url_ = url_.replace("{rowId}", encodeURIComponent("" + rowId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_DeleteCustomerOrderRow(brandId: number, rowId: number, options: AxiosRequestConfig = {}): Promise<CustomerOrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customer-order-rows/{rowId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (rowId === undefined || rowId === null)
        throw new Error("The parameter 'rowId' must be defined.");
    url_ = url_.replace("{rowId}", encodeURIComponent("" + rowId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_AddAllocations(brandId: number, rowId: number, args: AddAllocationArgs[], options: AxiosRequestConfig = {}): Promise<CustomerOrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customer-order-rows/{rowId}/allocations";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (rowId === undefined || rowId === null)
        throw new Error("The parameter 'rowId' must be defined.");
    url_ = url_.replace("{rowId}", encodeURIComponent("" + rowId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_UpdateAllocation(brandId: number, allocationId: number, args: UpdateAllocationArgs, options: AxiosRequestConfig = {}): Promise<CustomerOrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customer-order-allocations/{allocationId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (allocationId === undefined || allocationId === null)
        throw new Error("The parameter 'allocationId' must be defined.");
    url_ = url_.replace("{allocationId}", encodeURIComponent("" + allocationId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_DeleteAllocation(brandId: number, allocationId: number, options: AxiosRequestConfig = {}): Promise<CustomerOrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/customer-order-allocations/{allocationId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (allocationId === undefined || allocationId === null)
        throw new Error("The parameter 'allocationId' must be defined.");
    url_ = url_.replace("{allocationId}", encodeURIComponent("" + allocationId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetOrders(brandId: number, options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/orders";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_CreateOrder(brandId: number, args: CreateOrderArgs, options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/orders";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetOrder(brandId: number, orderId: number, options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/orders/{orderId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (orderId === undefined || orderId === null)
        throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_UpdateOrder(brandId: number, orderId: number, args: UpdateOrderArgs, options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/orders/{orderId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (orderId === undefined || orderId === null)
        throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_DeleteOrder(brandId: number, orderId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/orders/{orderId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (orderId === undefined || orderId === null)
        throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_AddOrderDelivery(brandId: number, orderId: number, args: AddOrderDeliveryArgs, options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/orders/{orderId}/deliveries";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (orderId === undefined || orderId === null)
        throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_UpdateOrderDelivery(brandId: number, deliveryId: number, args: UpdateOrderDeliveryArgs, options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-deliveries/{deliveryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_DeleteOrderDelivery(brandId: number, deliveryId: number, options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-deliveries/{deliveryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_AddOrderRows(brandId: number, deliveryId: number, args: AddOrderRowArgs[], options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-deliveries/{deliveryId}/rows";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_UpdateOrderRow(brandId: number, rowId: number, args: UpdateOrderRowArgs, options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-rows/{rowId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (rowId === undefined || rowId === null)
        throw new Error("The parameter 'rowId' must be defined.");
    url_ = url_.replace("{rowId}", encodeURIComponent("" + rowId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_DeleteOrderRow(brandId: number, rowId: number, options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-rows/{rowId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (rowId === undefined || rowId === null)
        throw new Error("The parameter 'rowId' must be defined.");
    url_ = url_.replace("{rowId}", encodeURIComponent("" + rowId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_TriggerOrderIntegration(brandId: number, orderIds: number[], options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/orders/trigger-integration";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = orderIds;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_TriggerAllOrderIntegration(brandId: number, individually: boolean | undefined, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/orders/all?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (individually === null)
        throw new Error("The parameter 'individually' cannot be null.");
    else if (individually !== undefined)
        url_ += "individually=" + encodeURIComponent("" + individually) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetSeasons(brandId: number, options: AxiosRequestConfig = {}): Promise<SeasonIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/seasons";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetSuppliers(brandId: number, options: AxiosRequestConfig = {}): Promise<SupplierIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/suppliers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_CreateSupplier(brandId: number, args: UpsertSupplierArgs, options: AxiosRequestConfig = {}): Promise<SupplierIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/suppliers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_UpdateSupplier(brandId: number, supplierNumber: string, args: UpsertSupplierArgs, options: AxiosRequestConfig = {}): Promise<SupplierIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/suppliers/{supplierNumber}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (supplierNumber === undefined || supplierNumber === null)
        throw new Error("The parameter 'supplierNumber' must be defined.");
    url_ = url_.replace("{supplierNumber}", encodeURIComponent("" + supplierNumber));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_SetNonUserFieldsOnSupplier(brandId: number, supplierNumber: string, args: NonUserFieldValues, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/suppliers/{supplierNumber}/non-user-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (supplierNumber === undefined || supplierNumber === null)
        throw new Error("The parameter 'supplierNumber' must be defined.");
    url_ = url_.replace("{supplierNumber}", encodeURIComponent("" + supplierNumber));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetDeliveryTerms(brandId: number, options: AxiosRequestConfig = {}): Promise<DeliveryTermIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/delivery-terms";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetPaymentTerms(brandId: number, options: AxiosRequestConfig = {}): Promise<PaymentTermIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/payment-terms";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetModesOfTransport(brandId: number, options: AxiosRequestConfig = {}): Promise<ModeOfTransportIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/modes-of-transport";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetSupplierStatuses(brandId: number, options: AxiosRequestConfig = {}): Promise<SupplierStatusIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/supplier-statuses";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetCurrencies(brandId: number, options: AxiosRequestConfig = {}): Promise<CurrencyIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/currencies";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetCountries(brandId: number, options: AxiosRequestConfig = {}): Promise<CountryIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/countries";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * All order tag categories with tags
 */
  async integration_GetOrderTagCategories(brandId: number, options: AxiosRequestConfig = {}): Promise<OrderTagCategoryIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-tag-categories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Rules for Uniqueness listed for the OrderTagCategoryUniqueness enum below, more in docs
 */
  async integration_AddOrderTagCategory(brandId: number, args: AddOrderTagCategoryArgs2, options: AxiosRequestConfig = {}): Promise<OrderTagCategoryIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-tag-categories";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Rules for Uniqueness listed for the OrderTagCategoryUniqueness enum below, more in docs
 */
  async integration_UpdateOrderTagCategory(brandId: number, categoryId: number, args: AddOrderTagCategoryArgs2, options: AxiosRequestConfig = {}): Promise<OrderTagCategoryIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-tag-categories/{categoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (categoryId === undefined || categoryId === null)
        throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Not allowed to delete category containing tags that are assigned to orders/order-deliveries
 */
  async integration_DeleteOrderTagCategory(brandId: number, categoryId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-tag-categories/{categoryId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (categoryId === undefined || categoryId === null)
        throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_AddOrderTag(brandId: number, args: AddOrderTagArgs2, options: AxiosRequestConfig = {}): Promise<OrderTagIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-tags";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_UpdateOrderTag(brandId: number, tagId: number, args: UpdateOrderTagArgs2, options: AxiosRequestConfig = {}): Promise<OrderTagIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Not allowed to delete tag assigned to orders/order-deliveries
 */
  async integration_DeleteOrderTag(brandId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * If all order-deliveries for the order have the same tags, the added tag will be auto-assigned to all order-deliveries
 */
  async integration_AddTagToOrder(brandId: number, orderId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/orders/{orderId}/tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (orderId === undefined || orderId === null)
        throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Also removes the tag from the order's order-deliveries
 */
  async integration_RemoveTagFromOrder(brandId: number, orderId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/orders/{orderId}/tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (orderId === undefined || orderId === null)
        throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * Also auto-assigns the tag to the order
 */
  async integration_AddTagToOrderDelivery(brandId: number, deliveryId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-deliveries/{deliveryId}/tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * If the order-delivery was the only one having this tag it will also be removed from the order's tags list
 */
  async integration_RemoveTagFromOrderDelivery(brandId: number, deliveryId: number, tagId: number, options: AxiosRequestConfig = {}): Promise<OrderIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-deliveries/{deliveryId}/tags/{tagId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    if (tagId === undefined || tagId === null)
        throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * @deprecated
 */
  async integration_GetComponent(brandId: number, id: number, options: AxiosRequestConfig = {}): Promise<ComponentIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/components/{id}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetComponent2(brandId: number, componentNumber: string, options: AxiosRequestConfig = {}): Promise<ComponentIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/v2/components/{componentNumber}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (componentNumber === undefined || componentNumber === null)
        throw new Error("The parameter 'componentNumber' must be defined.");
    url_ = url_.replace("{componentNumber}", encodeURIComponent("" + componentNumber));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  /**
 * @deprecated
 */
  async integration_GetComponentIds(brandId: number, options: AxiosRequestConfig = {}): Promise<number[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/components/all-component-ids";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetComponentNumbers(brandId: number, options: AxiosRequestConfig = {}): Promise<string[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/components/numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetAllComponents(brandId: number, offset: number | undefined, limit: number | undefined, options: AxiosRequestConfig = {}): Promise<GetComponentsResponse> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/v2/components?";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (offset === null)
        throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
        url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
        throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
        url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetComponentsByNumbers(brandId: number, args: GetComponentsByNumbersArgs, options: AxiosRequestConfig = {}): Promise<GetComponentsByNumberResponse> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/v2/components/by-numbers";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetCustomFields(brandId: number, options: AxiosRequestConfig = {}): Promise<CustomFieldsByEntityIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/custom-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_SetNonUserFieldsOnProduct(brandId: number, productId: number, args: NonUserFieldValues, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/products/{productId}/non-user-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (productId === undefined || productId === null)
        throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_SetNonUserFieldsOnArticle(brandId: number, articleId: number, args: NonUserFieldValues, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/articles/{articleId}/non-user-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (articleId === undefined || articleId === null)
        throw new Error("The parameter 'articleId' must be defined.");
    url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_SetNonUserFieldsOnSku(brandId: number, skuId: number, args: NonUserFieldValues, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/skus/{skuId}/non-user-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (skuId === undefined || skuId === null)
        throw new Error("The parameter 'skuId' must be defined.");
    url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_SetNonUserFieldsOnOrder(brandId: number, orderId: number, args: NonUserFieldValues, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/orders/{orderId}/non-user-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (orderId === undefined || orderId === null)
        throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_SetNonUserFieldsOnOrderDelivery(brandId: number, deliveryId: number, args: NonUserFieldValues, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/order-deliveries/{deliveryId}/non-user-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (deliveryId === undefined || deliveryId === null)
        throw new Error("The parameter 'deliveryId' must be defined.");
    url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_BulkSetNonUserField(brandId: number, args: BulkSetNonUserFieldArgs, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/non-user-fields";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetWebhooks(brandId: number, options: AxiosRequestConfig = {}): Promise<WebhookIntegrationDto[]> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/webhooks";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_CreateWebhook(brandId: number, args: IntegrationCreateWebhookArgs, options: AxiosRequestConfig = {}): Promise<WebhookIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/webhooks";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = args;

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_GetWebhook(brandId: number, webhookId: number, options: AxiosRequestConfig = {}): Promise<WebhookIntegrationDto> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/webhooks/{webhookId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (webhookId === undefined || webhookId === null)
        throw new Error("The parameter 'webhookId' must be defined.");
    url_ = url_.replace("{webhookId}", encodeURIComponent("" + webhookId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }

  async integration_DeleteWebhook(brandId: number, webhookId: number, options: AxiosRequestConfig = {}): Promise<void> {
    let url_ = this.baseUrl + "/api/integration/{brandId}/webhooks/{webhookId}";
    if (brandId === undefined || brandId === null)
        throw new Error("The parameter 'brandId' must be defined.");
    url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
    if (webhookId === undefined || webhookId === null)
        throw new Error("The parameter 'webhookId' must be defined.");
    url_ = url_.replace("{webhookId}", encodeURIComponent("" + webhookId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      ...options,
    };

    const { data: _result } = await this.instance.request(options_);
    return _result;
  }
}

export interface UserDto {
    id: string;
    photo?: string | undefined;
    name: string;
    email: string;
    isAdmin: boolean;
    belongsToMultipleBrands: boolean;
    roleIds?: number[] | undefined;
}

export interface AdminRegisterUserArgs {
    email: string;
    password: string;
    name: string;
    photo?: string | undefined;
}

export interface AdminChangePasswordArgs {
    userId: string;
    password: string;
}

export interface LoginResponse {
    status: number;
    data?: LoginViewModel | undefined;
    user?: UserInfoDto | undefined;
}

export interface LoginViewModel {
    email: string;
    password: string;
    rememberMe: boolean;
    twoFactorCode?: string | undefined;
    twoFactorRecoveryCode?: string | undefined;
}

export interface UserInfoDto {
    id: string;
    name?: string | undefined;
    userName?: string | undefined;
    photo?: string | undefined;
    socials: UserInfoDtoSocials[];
    roles: string[];
    isTwoFactorEnabled: boolean;
    companies: UserInfoDtoCompany[];
    quotationRequests: number;
    currentBrandId?: number | undefined;
}

export interface UserInfoDtoSocials {
    type: Types;
    address: string;
}

export enum Types {
    LinkedIn = 0,
    Twitter = 1,
}

export interface UserInfoDtoCompany {
    id: number;
    slug: string;
    name: string;
    email: string;
    type: Types2;
    draft: boolean;
    default: boolean;
    brandID?: number | undefined;
    plm: boolean;
    footwearCapabilities: any[];
    componentCapabilities: any[];
    brandRequires2fa: boolean;
}

export enum Types2 {
    Supplier = 0,
    Buyer = 1,
    Agent = 2,
    TradingCompany = 3,
    SourcingCompany = 4,
}

export interface LogoutResponse {
    status: number;
}

export interface ForgotPasswordResponse {
    status: number;
    data?: ForgotPasswordViewModel | undefined;
}

export interface ForgotPasswordViewModel {
    email: string;
}

export interface ResetPasswordViewModel {
    id: string;
    password: string;
    confirmPassword: string;
    code: string;
}

export interface AgentChatStatusDto {
    enabled: boolean;
}

export interface AgentThreadSummaryDto {
    id: number;
    title: string;
    status: AgentThreadStatus;
    autoApproveWrites: boolean;
    isArchived: boolean;
    createdAt?: string | undefined;
    lastActivityAt: string;
    lastBrandId?: number | undefined;
    lockedBrandId?: number | undefined;
}

export enum AgentThreadStatus {
    Idle = 0,
    Running = 1,
    WaitingForApproval = 2,
    Failed = 3,
}

export interface AgentThreadDto {
    summary: AgentThreadSummaryDto;
    messages: AgentMessageDto[];
}

export interface AgentMessageDto {
    id: number;
    seq: number;
    role: AgentMessageRole;
    kind: AgentMessageKind;
    text?: string | undefined;
    brandId?: number | undefined;
    contextUrl?: string | undefined;
    contextLabel?: string | undefined;
    createdAt?: string | undefined;
    toolName?: string | undefined;
    toolServer?: string | undefined;
    toolInputJson?: string | undefined;
    toolResultText?: string | undefined;
    toolIsError?: boolean | undefined;
    approvalState: AgentApprovalState;
    deliveredAt?: string | undefined;
    attachments: AgentAttachmentDto[];
}

export enum AgentMessageRole {
    User = 0,
    Assistant = 1,
    Tool = 2,
    System = 3,
}

export enum AgentMessageKind {
    Text = 0,
    ToolUse = 1,
    Error = 2,
    Info = 3,
}

export enum AgentApprovalState {
    None = 0,
    Pending = 1,
    Approved = 2,
    Denied = 3,
}

export interface AgentAttachmentDto {
    id: number;
    direction: AgentAttachmentDirection;
    file: AzureBlobFileDto;
}

export enum AgentAttachmentDirection {
    Uploaded = 0,
    Produced = 1,
}

export interface AzureBlobFileDto {
    id: number;
    name: string;
    versions: AzureBlobFileVersionDto[];
}

export interface AzureBlobFileVersionDto {
    id: number;
    createdBy?: UserSimple | undefined;
    createdAt?: string | undefined;
    extension: string;
    size: number;
    path: string;
    previewPdfSize?: number | undefined;
    previewPdfPath?: string | undefined;
    previewPdfStatus: PreviewStatus;
    thumbnailSize?: number | undefined;
    thumbnailPath?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    artboards?: VersionArtboard[] | undefined;
    artboardsError?: string | undefined;
}

export interface UserSimple {
    name: string;
    photo: string;
}

export enum PreviewStatus {
    None = "None",
    Ready = "Ready",
    Pending = "Pending",
    Error = "Error",
}

export interface VersionArtboard {
    id: string;
    name: string;
    pageIndex: number;
    widthPt: number;
    heightPt: number;
    thumbnailPath?: string | undefined;
    blank: boolean;
    previewPath?: string | undefined;
    parts?: ArtboardRect[] | undefined;
}

export interface ArtboardRect {
    x: number;
    y: number;
    width: number;
    height: number;
}

export interface CreateAgentThreadArgs {
    brandId: number;
    title?: string | undefined;
}

export interface SendAgentMessageArgs {
    brandId: number;
    text: string;
    attachmentFileIds: number[];
    contextUrl?: string | undefined;
    contextLabel?: string | undefined;
}

export interface AgentApprovalArgs {
    messageId: number;
    allow: boolean;
}

export interface UpdateAgentThreadArgs {
    title: string;
    autoApproveWrites: boolean;
    lockedBrandId?: number | undefined;
}

export interface ApiKeyDto {
    id: number;
    name: string;
    type: ApiKeyType;
    brandId?: number | undefined;
    prefix: string;
    last4: string;
    createdAt?: string | undefined;
    lastUsedAt?: string | undefined;
    expiresAt?: string | undefined;
    revokedAt?: string | undefined;
}

export enum ApiKeyType {
    Legacy = 0,
    Mcp = 1,
    Labs = 2,
    Integration = 3,
}

export interface CreatedApiKeyDto {
    key: ApiKeyDto;
    token: string;
}

export interface CreateApiKeyArgs {
    name: string;
    type: ApiKeyType;
    brandId?: number | undefined;
    expiresAt?: string | undefined;
}

export interface RenameApiKeyArgs {
    name: string;
}

export interface SetApiKeyExpiryArgs {
    expiresAt: string;
}

export interface ArtboardBomTarget {
    bomIds: number[];
    /** Their seasons, null for the base season. */
    seasonIds: (number | undefined)[];
}

export interface LinkArtboardArgs {
    artboardId: string;
    /** The part of the artboard the image shows, in points from its top left corner; null
            for all of it. */
    region?: ArtboardRect | undefined;
    /** The articles the new image is shown on, last among theirs. */
    articleIds: number[];
    /** The BOMs the new image is a picture on, last on each. They share it. */
    bomIds: number[];
}

export interface ProductFileDto {
    id: number;
    productId: number;
    azureBlobFileId: number;
    name: string;
    extension: string;
    comment: string;
    state: ProductFileState;
    order: number;
    artboardRenders: ArtboardRenderDto[];
}

export enum ProductFileState {
    Active = 0,
    Archived = 1,
    Deleted = 2,
}

export interface ArtboardRenderDto {
    id: number;
    artboardId: string;
    artboardName: string;
    region?: ArtboardRect | undefined;
    autoLinked: boolean;
    imageFileId: number;
    productImageId?: number | undefined;
    articleIds: number[];
    boms: ArtboardRenderBom[];
    status: ArtboardRenderStatus;
    lastError?: string | undefined;
}

export interface ArtboardRenderBom {
    bomId: number;
    seasonId?: number | undefined;
}

export enum ArtboardRenderStatus {
    Ok = 0,
    Conflict = 1,
    ArtboardMissing = 2,
    PartOutsideArtboard = 3,
    Failed = 4,
}

export interface ArticleSeasonTimelineDto {
    timelineId?: number | undefined;
    isManual: boolean;
    dropId?: number | undefined;
    gateStates: ArticleGateStateDto[];
}

export interface ArticleGateStateDto {
    gateId: number;
    completedOn?: string | undefined;
    completedByUserId?: string | undefined;
    completedAt?: string | undefined;
    estimatedOn?: string | undefined;
    note?: string | undefined;
}

export interface SetArticleSeasonTimelineArgs {
    timelineId?: number | undefined;
}

export interface PutGateStatesArgs {
    gates: GateStateArgs[];
}

export interface GateStateArgs {
    gateId: number;
    completedOn?: string | undefined;
    estimatedOn?: string | undefined;
    note?: string | undefined;
}

export interface NudgeResultDto {
    target: NudgeTarget;
    recipientUserIds: string[];
    alreadySent: boolean;
}

export enum NudgeTarget {
    AssignedOnProduct = 0,
    RoleMembers = 1,
    Nobody = 2,
}

export interface NudgeGateArgs {
    today: string;
}

export interface ArticleDto {
    id: number;
    articleNumber: string;
    developmentNumber?: string | undefined;
    sequentialNumber: number;
    product: ArticleDtoProduct;
    hierarchyNodeId: number;
    productCategoryId?: number | undefined;
    statusId: number;
    color?: ColorDto | undefined;
    genders: Gender[];
    skus: SkuDto[];
    comment?: string | undefined;
    description?: string | undefined;
    seasonalities: ArticleDtoSeasonality[];
    images: ArticleDtoImage[];
    tariffCodeIds: number[];
    dropIds: number[];
    weight?: WeightDto | undefined;
    mChartId?: number | undefined;
    mChartName?: string | undefined;
    orders: ArticleDtoOrder[];
    certifications: ArticleCertificationDto[];
    compliances: ArticleComplianceDto[];
    createdAt?: string | undefined;
}

export interface ArticleDtoProduct {
    id: number;
    name: string;
    developmentNumber?: string | undefined;
    hierarchyNodeId: number;
    sizeSystemVersionId?: number | undefined;
    sizeSystemName?: string | undefined;
    images: ArticleDtoProductImage[];
    numberOfArticles: number;
    roleAssignments: ProductDtoRoleAssignment[];
    seasonalities: ArticleDtoProductSeasonality[];
}

export interface ArticleDtoProductImage {
    id: number;
    url: string;
    width: number;
    height: number;
    name: string;
    size: number;
    azureBlobFileId: number;
    articleIDs: number[];
    tagIds: number[];
}

export interface ProductDtoRoleAssignment {
    roleId: number;
    userId?: string | undefined;
}

export interface ArticleDtoProductSeasonality {
    id?: number | undefined;
    customValues: { [key: string]: CustomFieldValueDto; };
}

export type CustomFieldValueDto = TextCustomValueDto | PhysicalDimensions | MoneyCustomValueDto | NumberWithUnitCustomValueDto | SingleSelectCustomValueDto | MultiSelectCustomValueDto | FilesCustomValueDto;
export interface CustomFieldValueDto_Interface {
    type: string;
}

export interface TextCustomValueDto extends CustomFieldValueDto_Interface {
    type: 'TextCustomValueDto';
    value: string;
    linked: boolean;
}
export function isTextCustomValueDto(obj?: CustomFieldValueDto): obj is TextCustomValueDto {
    return obj?.type === 'TextCustomValueDto';
}

export interface PhysicalDimensions extends CustomFieldValueDto_Interface {
    type: 'PhysicalDimensions';
    length: number;
    width: number;
    height: number;
    unit: LengthUnit;
    linked: boolean;
}
export function isPhysicalDimensions(obj?: CustomFieldValueDto): obj is PhysicalDimensions {
    return obj?.type === 'PhysicalDimensions';
}

export enum LengthUnit {
    M = "m",
    Cm = "cm",
    Mm = "mm",
}

export interface MoneyCustomValueDto extends CustomFieldValueDto_Interface {
    type: 'MoneyCustomValueDto';
    amount?: number | undefined;
    currencyId: number;
    linked: boolean;
}
export function isMoneyCustomValueDto(obj?: CustomFieldValueDto): obj is MoneyCustomValueDto {
    return obj?.type === 'MoneyCustomValueDto';
}

export interface NumberWithUnitCustomValueDto extends CustomFieldValueDto_Interface {
    type: 'NumberWithUnitCustomValueDto';
    value?: number | undefined;
    unitId: number;
    linked: boolean;
}
export function isNumberWithUnitCustomValueDto(obj?: CustomFieldValueDto): obj is NumberWithUnitCustomValueDto {
    return obj?.type === 'NumberWithUnitCustomValueDto';
}

export interface SingleSelectCustomValueDto extends CustomFieldValueDto_Interface {
    type: 'SingleSelectCustomValueDto';
    optionId?: number | undefined;
    linked: boolean;
}
export function isSingleSelectCustomValueDto(obj?: CustomFieldValueDto): obj is SingleSelectCustomValueDto {
    return obj?.type === 'SingleSelectCustomValueDto';
}

export interface MultiSelectCustomValueDto extends CustomFieldValueDto_Interface {
    type: 'MultiSelectCustomValueDto';
    optionIds: number[];
    linked: boolean;
}
export function isMultiSelectCustomValueDto(obj?: CustomFieldValueDto): obj is MultiSelectCustomValueDto {
    return obj?.type === 'MultiSelectCustomValueDto';
}

export interface FilesCustomValueDto extends CustomFieldValueDto_Interface {
    type: 'FilesCustomValueDto';
    files: FilesValueFileDto[];
    linked: boolean;
}
export function isFilesCustomValueDto(obj?: CustomFieldValueDto): obj is FilesCustomValueDto {
    return obj?.type === 'FilesCustomValueDto';
}

export interface FilesValueFileDto {
    size: number;
    path: string;
    filename: string;
    extension: string;
    uploadedAt: string;
}

export interface ColorDto {
    id: number;
    number: string;
    groupSequentialNumber?: number | undefined;
    name: string;
    code?: string | undefined;
    groupId?: number | undefined;
    statusId: number;
    typeId: number;
    c: number;
    m: number;
    y: number;
    k: number;
    r: number;
    g: number;
    b: number;
    paletteIds: number[];
    libraryColorId?: number | undefined;
    libraryName?: string | undefined;
    libraryColorName?: string | undefined;
    libraryColorCode?: string | undefined;
    swatchUrl?: string | undefined;
}

export enum Gender {
    Men = 1,
    Women = 2,
    Kids = 4,
    Babies = 8,
}

export interface SkuDto {
    id: number;
    skuNumber: string;
    developmentNumber?: string | undefined;
    size: ProductDtoSize;
    skuCodeValues: SkuCodeValueDto[];
    seasonalities: SkuDtoSeasonality[];
    weight?: WeightDto | undefined;
}

export interface ProductDtoSize {
    id: number;
    sizeId: number;
    value: string;
}

export interface SkuCodeValueDto {
    skuCodeId: number;
    value: string;
}

export interface SkuDtoSeasonality {
    id?: number | undefined;
    customValues: { [key: string]: CustomFieldValueDto; };
    outPriceValues: OutPriceValueDto[];
    suppliers: SkuSeasonSupplierDto[];
}

export interface OutPriceValueDto {
    id: number;
    currencyId?: number | undefined;
    amount?: number | undefined;
    outPriceName: string;
    outPriceKey: string;
    outPriceId: number;
    destinationId: number;
    markupMarginTarget: number;
    markupMarginType: MarkupMarginType;
    linked: boolean;
}

export enum MarkupMarginType {
    Markup = 0,
    Margin = 1,
}

export interface SkuSeasonSupplierDto {
    supplierId?: number | undefined;
    inPriceValues: InPriceValuesDto[];
}

export interface InPriceValuesDto {
    id: number;
    destinationId: number;
    costPrice?: PriceDto | undefined;
    landedCost?: PriceDto | undefined;
    costPriceTarget?: PriceDto | undefined;
    freightPercentage?: number | undefined;
    freightCharge?: PriceDto | undefined;
    dutiesPercentage?: number | undefined;
    dutiesLinked: boolean;
    freightLinked: boolean;
    costPriceLinked: boolean;
    stepValues: InPriceStepValueDto[];
}

export interface PriceDto {
    amount: number;
    currencyId: number;
}

export type InPriceStepValueDto = PercentageInPriceStepValueDto | ChargeInPriceStepValueDto;
export interface InPriceStepValueDto_Interface {
    id: number;
    inPriceStepId: number;
    stepKey: string;
    linked: boolean;
    type: string;
}

export interface PercentageInPriceStepValueDto extends InPriceStepValueDto_Interface {
    type: 'PercentageInPriceStepValueDto';
    percentage?: number | undefined;
}
export function isPercentageInPriceStepValueDto(obj?: InPriceStepValueDto): obj is PercentageInPriceStepValueDto {
    return obj?.type === 'PercentageInPriceStepValueDto';
}

export interface ChargeInPriceStepValueDto extends InPriceStepValueDto_Interface {
    type: 'ChargeInPriceStepValueDto';
    amount?: number | undefined;
    currencyId: number;
}
export function isChargeInPriceStepValueDto(obj?: InPriceStepValueDto): obj is ChargeInPriceStepValueDto {
    return obj?.type === 'ChargeInPriceStepValueDto';
}

export interface WeightDto {
    gross?: number | undefined;
    net?: number | undefined;
    unit?: WeightUnit | undefined;
}

export enum WeightUnit {
    Kg = 0,
    G = 1,
    Lbs = 2,
}

export interface ArticleDtoSeasonality {
    id?: number | undefined;
    customValues: { [key: string]: CustomFieldValueDto; };
    suppliers: ArticleSeasonSupplierDto[];
    principalMaterialIds: number[];
    principalMaterialSlotIds: number[];
    timeline: ArticleSeasonTimelineDto;
    tags: ArticleDtoSeasonalityTag[];
}

export interface ArticleSeasonSupplierDto {
    supplierId?: number | undefined;
    countryOfOrigin?: CountryDto | undefined;
}

export interface CountryDto {
    id: number;
    name: string;
    codeAlpha3: string;
    searchVariants: string[];
}

export interface ArticleDtoSeasonalityTag {
    tagId: number;
    origin: string;
}

export interface ArticleDtoImage {
    id: number;
    url: string;
    width: number;
    height: number;
    name: string;
    size: number;
    azureBlobFileId: number;
    tagIds: number[];
}

export interface ArticleDtoOrder {
    id: number;
    orderNumber: string;
    placementDate?: string | undefined;
    inboundDate?: string | undefined;
    type?: ArticleDtoOrderType | undefined;
    quantity?: number | undefined;
    statusId: number;
}

export interface ArticleDtoOrderType {
    id: number;
    name: string;
}

export interface ArticleCertificationDto {
    id: number;
    certificateId: number;
    file?: string | undefined;
    summary?: string | undefined;
    validUntil?: string | undefined;
}

export interface ArticleComplianceDto {
    id: number;
    complianceId: number;
    file?: string | undefined;
    summary?: string | undefined;
    testResult: ComplianceTestResult;
    conductedAt?: string | undefined;
}

export enum ComplianceTestResult {
    NotSet = 0,
    Pass = 1,
    Fail = 2,
}

export interface ArticleOptionDto {
    id: number;
    articleNumber: string;
    productId: number;
    productName: string;
    color?: ColorSuperSimple | undefined;
}

export interface BaseColorSimple {
    name: string;
    r: number;
    g: number;
    b: number;
}

export interface ColorSuperSimple extends BaseColorSimple {
    swatchUrl?: string | undefined;
}

export interface AddArticleArgs {
    productId: number;
    color?: SetColorArgs | undefined;
    seasonId?: number | undefined;
}

export type SetColorArgs = ExistingColor | AdoptedLibraryColor | NewColor | EditedColor | NoColorSelected;
export interface SetColorArgs_Interface {
    type: string;
}

export interface ExistingColor extends SetColorArgs_Interface {
    type: 'ExistingColor';
    brandColorId: number;
}
export function isExistingColor(obj?: SetColorArgs): obj is ExistingColor {
    return obj?.type === 'ExistingColor';
}

export interface AdoptedLibraryColor extends SetColorArgs_Interface {
    type: 'AdoptedLibraryColor';
    libraryColorId: number;
    values?: BrandColorValues | undefined;
    swatch?: SwatchArg | undefined;
}
export function isAdoptedLibraryColor(obj?: SetColorArgs): obj is AdoptedLibraryColor {
    return obj?.type === 'AdoptedLibraryColor';
}

export interface BrandColorValues {
    name: string;
    code?: string | undefined;
    groupId?: number | undefined;
    c: number;
    m: number;
    y: number;
    k: number;
    r: number;
    g: number;
    b: number;
}

export interface SwatchArg {
    azureBlobFileId?: number | undefined;
}

export interface NewColor extends SetColorArgs_Interface {
    type: 'NewColor';
    values: BrandColorValues;
    swatch?: SwatchArg | undefined;
}
export function isNewColor(obj?: SetColorArgs): obj is NewColor {
    return obj?.type === 'NewColor';
}

export interface EditedColor extends SetColorArgs_Interface {
    type: 'EditedColor';
    brandColorId: number;
    values: BrandColorValues;
    swatch?: SwatchArg | undefined;
}
export function isEditedColor(obj?: SetColorArgs): obj is EditedColor {
    return obj?.type === 'EditedColor';
}

export interface NoColorSelected extends SetColorArgs_Interface {
    type: 'NoColorSelected';
}
export function isNoColorSelected(obj?: SetColorArgs): obj is NoColorSelected {
    return obj?.type === 'NoColorSelected';
}

export interface UpdateGenderAndSizesResponse {
    article: ArticleDto;
    product: ProductDto;
}

export interface ProductDto {
    id: number;
    number: number;
    productNumber: string;
    developmentNumber?: string | undefined;
    name: string;
    hierarchyNodeId: number;
    productCategoryId?: number | undefined;
    description?: string | undefined;
    colors: ProductDtoColor[];
    genders: Gender[];
    sizeSystemVersionId?: number | undefined;
    sizes: ProductDtoSize[];
    sizeConversionTableId?: number | undefined;
    mCharts: ProductDtoMChart[];
    tags: ProductDtoTag[];
    seasonalities: ProductDtoSeasonality[];
    images: ProductDtoImage[];
    files: ProductFileDto[];
    statuses: ProductDtoStatus[];
    orders: ProductDtoOrder[];
    dropIds: number[];
    tariffCodeIds: number[];
    weight?: WeightDto | undefined;
    createdAt?: string | undefined;
    roleAssignments: ProductDtoRoleAssignment[];
    relatedProduct?: ProductDtoRelatedProduct | undefined;
}

export interface ProductDtoColor extends ColorDto {
    articleId: number;
}

export interface ProductDtoMChart {
    id: number;
    name: string;
}

export interface ProductDtoTag {
    id: number;
    name: string;
    color: string;
}

export interface ProductDtoSeasonality {
    id?: number | undefined;
    customValues: { [key: string]: CustomFieldValueDto; };
    articleIds: number[];
    supplierIds: number[];
    bomId?: number | undefined;
    bomHasSections: boolean;
    principalMaterialIds: number[];
}

export interface ProductDtoImage {
    id: number;
    url: string;
    width: number;
    height: number;
    name: string;
    size: number;
    azureBlobFileId: number;
    articleIds: number[];
    tagIds: number[];
    artboardSource?: ProductDtoImageArtboardSource | undefined;
}

export interface ProductDtoImageArtboardSource {
    productFileId: number;
    fileName: string;
    artboardName: string;
    status: ArtboardRenderStatus;
}

export interface ProductDtoStatus {
    statusId: number;
    articleIds: number[];
}

export interface ProductDtoOrder {
    id: number;
    orderNumber: string;
    placementDate?: string | undefined;
    inboundDate?: string | undefined;
    type?: ProductDtoOrderType | undefined;
    locked: boolean;
    statusId: number;
    quantity?: number | undefined;
}

export interface ProductDtoOrderType {
    id: number;
    name: string;
}

export interface ProductDtoRelatedProduct {
    id: number;
    name: string;
    imagePath?: string | undefined;
    hierarchyNodeId: number;
}

export interface UpdateGenderAndSizesArgs {
    genders: Gender[];
    sizeValues?: string[] | undefined;
}

export interface UpdateGendersReturn {
    article?: ArticleDto | undefined;
    product?: ProductDto | undefined;
}

export interface UpdateGendersArgs {
    genders: Gender[];
}

export interface UpdateDescriptionArgs {
    description?: string | undefined;
}

export interface UpdateArticleNumberArgs {
    articleNumber?: string | undefined;
}

export interface ArticleNumberInfoResponse {
    currentNumber: string;
    isManuallySet: boolean;
    systemGeneratedNumber: string;
    developmentNumber?: string | undefined;
}

export interface UpdateArticleTagsArgs {
    tagIds: number[];
    seasonId?: number | undefined;
}

export interface MassAddRemoveTagsArgs {
    tagIdToAddList: number[];
    tagIdToRemoveList: number[];
    seasonId?: number | undefined;
}

export interface UpdateDropsReturn {
    article: ArticleDto;
    productUpdated: boolean;
}

export interface UpdateDropsArgsItem {
    dropDate: string;
    granularity: DropGranularity;
    dropGroupId?: number | undefined;
}

export enum DropGranularity {
    Day = 0,
    Week = 1,
    Month = 2,
    Quarter = 3,
}

export interface MassAddRemoveDropsArgs {
    dropIdToAdd?: number | undefined;
    dropIdToRemove?: number | undefined;
}

export interface UpdateSeasonsReturn {
    article: ArticleDto;
    productUpdated: boolean;
}

export interface UpdateSeasonsArgs {
    seasonIDs: number[];
    suppressBomDropWarning: boolean;
}

export interface MassAddRemoveSeasonsArgs {
    seasonIdToAddList: number[];
    seasonIdToRemoveList: number[];
    suppressBomDropWarning: boolean;
}

export interface UpdateHierarchyAndProductCategoryReturn {
    article: ArticleDto;
    productUpdated: boolean;
}

export interface UpdateHierarchyAndProductCategoryArgs {
    hierarchyNodeId: number;
    productCategoryId?: number | undefined;
}

export interface WeightPatchDto {
    gross?: WeightValueDto | undefined;
    net?: WeightValueDto | undefined;
    unit?: WeightUnit | undefined;
}

export interface WeightValueDto {
    value?: number | undefined;
}

export interface UpdateSupplierArgs {
    countryOfOriginId?: number | undefined;
    supplierId: number;
}

export interface UpdateDeliveryArgs {
    quantity: number;
}

export interface UpdateDeliveriesReturn {
    article: ArticleDto;
    ordersUpdated: boolean;
}

export interface UpdateDeliveriesArgsOrder {
    quantity?: number | undefined;
    id?: number | undefined;
    inboundDate?: string | undefined;
    typeId?: number | undefined;
}

export interface MassAddDeliveriesArgs {
    articlesWithOrders: MassAddDeliveriesArgsItem[];
}

export interface MassAddDeliveriesArgsItem {
    articleId: number;
    deliveryIds: number[];
}

export interface MassRemoveDeliveriesArgs {
    inboundDate: string;
}

export interface UpdateCommentArgs {
    comment: string;
}

export interface UpdateStatusReturn {
    article?: ArticleDto | undefined;
    productUpdated: boolean;
    missingProperties: MissingProperties;
}

export interface MissingProperties {
    required: RequiredProperty[];
}

export type RequiredProperty = RequiredPropertyField | RequiredPropertyTag | RequiredPropertyCustomField | RequiredPropertySkuCode | RequiredHierarchyLevel;
export interface RequiredProperty_Interface {
    type: string;
}

export interface RequiredPropertyField extends RequiredProperty_Interface {
    type: 'RequiredPropertyField';
    field: ArticleField;
}
export function isRequiredPropertyField(obj?: RequiredProperty): obj is RequiredPropertyField {
    return obj?.type === 'RequiredPropertyField';
}

export enum ArticleField {
    Size = "Size",
    Color = "Color",
    ColorCode = "ColorCode",
    ColorGroup = "ColorGroup",
    ColorName = "ColorName",
    Gender = "Gender",
    PrincipalMaterialType = "PrincipalMaterialType",
    Season = "Season",
    Supplier = "Supplier",
    TariffCode = "TariffCode",
    Weight = "Weight",
    FactoryPrice = "FactoryPrice",
    RetailPrice = "RetailPrice",
    TargetPrice = "TargetPrice",
    WholesalePrice = "WholesalePrice",
    ProductName = "ProductName",
    SizeConversionTable = "SizeConversionTable",
    Description = "Description",
    PrincipalMaterialComposition = "PrincipalMaterialComposition",
    PrincipalSlot = "PrincipalSlot",
    StatusPermission = "StatusPermission",
    ProductCategory = "ProductCategory",
    ColorInPalette = "ColorInPalette",
}

export interface RequiredPropertyTag extends RequiredProperty_Interface {
    type: 'RequiredPropertyTag';
    tagCategoryId: number;
}
export function isRequiredPropertyTag(obj?: RequiredProperty): obj is RequiredPropertyTag {
    return obj?.type === 'RequiredPropertyTag';
}

export interface RequiredPropertyCustomField extends RequiredProperty_Interface {
    type: 'RequiredPropertyCustomField';
    customFieldId: number;
}
export function isRequiredPropertyCustomField(obj?: RequiredProperty): obj is RequiredPropertyCustomField {
    return obj?.type === 'RequiredPropertyCustomField';
}

export interface RequiredPropertySkuCode extends RequiredProperty_Interface {
    type: 'RequiredPropertySkuCode';
    skuCodeId: number;
}
export function isRequiredPropertySkuCode(obj?: RequiredProperty): obj is RequiredPropertySkuCode {
    return obj?.type === 'RequiredPropertySkuCode';
}

export interface RequiredHierarchyLevel extends RequiredProperty_Interface {
    type: 'RequiredHierarchyLevel';
    hierarchyRule: HierarchyRule;
    minimumLevelId?: number | undefined;
}
export function isRequiredHierarchyLevel(obj?: RequiredProperty): obj is RequiredHierarchyLevel {
    return obj?.type === 'RequiredHierarchyLevel';
}

export enum HierarchyRule {
    Partial = 0,
    Leaf = 1,
    MinimumLevel = 2,
}

export interface UpdateStatusArgs {
    statusId: number;
}

export interface MassUpdateStatusReturn {
    updatedArticles: number[];
    notUpdatedArticles: ArticleAndMissingProperties[];
}

export interface ArticleAndMissingProperties {
    articleId: number;
    missingProperties: MissingProperties;
}

export interface MassUpdateStatusArgs {
    statusId: number;
}

export interface UpdateImagesReturn {
    article: ArticleDto;
    product: ProductDto;
}

export interface UpdateImagesImage {
    id?: number | undefined;
    /** The versioned file holding the picture: from file_Upload, or any file already in the PLM, such as one produced or attached in the agent chat. A file the
            product already has an image for is connected to the article rather than added twice. */
    azureBlobFileId: number;
    tagIds: number[];
}

export interface MassUpdateImagesReturn {
    articles: ArticleDto[];
    product: ProductDto;
}

export interface MassUpdateImagesArgs {
    images: MassUpdateImagesImage[];
    articleIds: number[];
}

export interface MassUpdateImagesImage {
    id?: number | undefined;
    /** The versioned file holding the picture: from file_Upload, or any file already in the PLM, such as one produced or attached in the agent chat. An
            existing image keeps the file it has — pass the one it already carries. */
    azureBlobFileId: number;
}

export interface CustomFieldIdWithValueDto {
    id: number;
    value?: CustomFieldValueDto | undefined;
    linked?: boolean | undefined;
}

export interface UpdatePrincipalMaterialArgs {
    slotId?: number | undefined;
    subTypeId?: number | undefined;
    seasonId?: number | undefined;
}

export interface GenerateSkuCodeValuesForSkusArgs {
    skuCodeIds?: number[] | undefined;
}

export interface GenerateSkuCodeValuesForSkusForSelectionArgs {
    skuCodeIds?: number[] | undefined;
    statusId?: number | undefined;
    sizeSystemVersionId?: number | undefined;
    sizeValues?: string[] | undefined;
}

export interface FiltersColor extends BaseColorSimple {
    id: number;
    swatchUrl?: string | undefined;
}

export interface OutPriceRange {
    min?: number | undefined;
    max?: number | undefined;
}

export enum TimelineHealthFilter {
    Late = 0,
    OnTrack = 1,
    NoTimeline = 2,
    AtRisk = 3,
}

export interface UpdateMChartArgs {
    mChartId?: number | undefined;
}

export interface BulkUpdateMChartItem {
    articleId: number;
    mChartId?: number | undefined;
}

export interface ArticleStatusDto {
    id: number;
    name: string;
    color: string;
    icon: string;
    externalCode?: string | undefined;
    excludeFromDefaultFiltering: boolean;
    allowDelete: boolean;
    lockArticleAndSkuNumber: boolean;
    lockRemovalOfSkus: boolean;
    promotesDevelopmentNumbers: boolean;
    skuCodes: ArticleStatusSkuCodeDto[];
    requiredFields: RequiredPropertyField[];
    requiredTagCategories: RequiredPropertyTag[];
    requiredCustomFields: RequiredPropertyCustomField[];
    hierarchyRule?: HierarchyRule | undefined;
    minimumLevelId?: number | undefined;
}

export interface ArticleStatusSkuCodeDto {
    skuCodeId: number;
    isLocked: boolean;
    autoGenerate: boolean;
    isRequired: boolean;
}

export interface CreateArticleStatus {
    name: string;
    color: string;
    icon: string;
    skuCodes: ArticleStatusSkuCodeDto[];
    requiredFields: RequiredPropertyField[];
    requiredTagCategories: RequiredPropertyTag[];
    requiredCustomFields: RequiredPropertyCustomField[];
    hierarchyRule?: HierarchyRule | undefined;
    minimumLevelId?: number | undefined;
    externalCode?: string | undefined;
    excludeFromDefaultFiltering: boolean;
    allowDelete: boolean;
    lockArticleAndSkuNumber: boolean;
    lockRemovalOfSkus: boolean;
    promotesDevelopmentNumbers: boolean;
}

export interface UpdateArticleStatus {
    name: string;
    color: string;
    icon: string;
    externalCode?: string | undefined;
    skuCodes: ArticleStatusSkuCodeDto[];
    requiredFields: RequiredPropertyField[];
    requiredTagCategories: RequiredPropertyTag[];
    requiredCustomFields: RequiredPropertyCustomField[];
    excludeFromDefaultFiltering: boolean;
    allowDelete: boolean;
    lockArticleAndSkuNumber: boolean;
    lockRemovalOfSkus: boolean;
    promotesDevelopmentNumbers: boolean;
    hierarchyRule?: HierarchyRule | undefined;
    minimumLevelId?: number | undefined;
}

export interface ArticleStatusUsageDto {
    articles: EntityReference[];
}

export interface EntityReference {
    id: number;
    name: string;
    path?: string | undefined;
}

export interface ReplaceArticleStatusArgs {
    replacementId: number;
}

export interface BomDto {
    id: number;
    productId: number;
    productSeasonId: number;
    seasonId?: number | undefined;
    images: BomImageDto[];
    imageFiles: AzureBlobFileDto[];
    sections: BomSectionDto[];
}

export interface BomImageDto {
    id: number;
    name?: string | undefined;
    url: string;
    azureBlobFileId: number;
    annotations: AnnotationItem[];
    artboardSource?: ProductDtoImageArtboardSource | undefined;
}

export interface AnnotationItem {
    id: string;
    geometry: AnnotationGeometry;
    style?: AnnotationStyle | undefined;
    comment?: string | undefined;
    linkedEntityId?: number | undefined;
}

export type AnnotationGeometry = PointGeometry | LineGeometry | ArrowGeometry | RectangleGeometry | EllipseGeometry | FreehandGeometry | HighlighterGeometry | CurveGeometry;
export interface AnnotationGeometry_Interface {
    type: string;
}

export interface PointGeometry extends AnnotationGeometry_Interface {
    type: 'PointGeometry';
    x: number;
    y: number;
}
export function isPointGeometry(obj?: AnnotationGeometry): obj is PointGeometry {
    return obj?.type === 'PointGeometry';
}

export interface LineGeometry extends AnnotationGeometry_Interface {
    type: 'LineGeometry';
    x1: number;
    y1: number;
    x2: number;
    y2: number;
}
export function isLineGeometry(obj?: AnnotationGeometry): obj is LineGeometry {
    return obj?.type === 'LineGeometry';
}

export interface ArrowGeometry extends AnnotationGeometry_Interface {
    type: 'ArrowGeometry';
    x1: number;
    y1: number;
    x2: number;
    y2: number;
}
export function isArrowGeometry(obj?: AnnotationGeometry): obj is ArrowGeometry {
    return obj?.type === 'ArrowGeometry';
}

export interface RectangleGeometry extends AnnotationGeometry_Interface {
    type: 'RectangleGeometry';
    x: number;
    y: number;
    w: number;
    h: number;
}
export function isRectangleGeometry(obj?: AnnotationGeometry): obj is RectangleGeometry {
    return obj?.type === 'RectangleGeometry';
}

export interface EllipseGeometry extends AnnotationGeometry_Interface {
    type: 'EllipseGeometry';
    cx: number;
    cy: number;
    rx: number;
    ry: number;
}
export function isEllipseGeometry(obj?: AnnotationGeometry): obj is EllipseGeometry {
    return obj?.type === 'EllipseGeometry';
}

export interface FreehandGeometry extends AnnotationGeometry_Interface {
    type: 'FreehandGeometry';
    points: AnnotationPoint[];
}
export function isFreehandGeometry(obj?: AnnotationGeometry): obj is FreehandGeometry {
    return obj?.type === 'FreehandGeometry';
}

export interface AnnotationPoint {
    x: number;
    y: number;
}

export interface HighlighterGeometry extends AnnotationGeometry_Interface {
    type: 'HighlighterGeometry';
    points: AnnotationPoint[];
}
export function isHighlighterGeometry(obj?: AnnotationGeometry): obj is HighlighterGeometry {
    return obj?.type === 'HighlighterGeometry';
}

export interface CurveGeometry extends AnnotationGeometry_Interface {
    type: 'CurveGeometry';
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    cx: number;
    cy: number;
}
export function isCurveGeometry(obj?: AnnotationGeometry): obj is CurveGeometry {
    return obj?.type === 'CurveGeometry';
}

export interface AnnotationStyle {
    color: string;
    strokeWidth: number;
    opacity: number;
}

export interface BomSectionDto {
    id: number;
    name?: string | undefined;
    placements: BomPlacementDto[];
}

export interface BomPlacementDto {
    id: number;
    name?: string | undefined;
    principal: boolean;
    slots: BomSlotDto[];
    annotationName?: string | undefined;
    tagIds: number[];
}

export interface BomSlotDto {
    id: number;
    comment?: string | undefined;
    articles: BomSlotArticleDto[];
    component?: BomComponentDto | undefined;
    suppliers: BomSlotSupplierDto[];
    price?: ComponentPriceDto | undefined;
    quantity?: number | undefined;
}

export interface BomSlotArticleDto {
    id: number;
    slotId: number;
    articleId: number;
    articleSeasonId: number;
    colorIsApproved: boolean;
    color?: ColorDto | undefined;
}

export interface BomComponentDto {
    id?: number | undefined;
    name?: string | undefined;
    refNumber?: string | undefined;
    secondaryRefNumber?: string | undefined;
    componentNumber?: string | undefined;
    comment?: string | undefined;
    suppliers: ComponentSupplierDto[];
    componentSubTypeId?: number | undefined;
    unitId?: number | undefined;
    composition: ComponentCompositionPartDto[];
    attributes: ComponentAttributeDto[];
    price?: ComponentPriceDto | undefined;
    colors: ComponentColorDto[];
    images: ComponentImageDto[];
    locked: boolean;
}

export interface ComponentSupplierDto {
    id: number;
    supplierId?: number | undefined;
    price?: ComponentPriceDto | undefined;
    countryOfOrigin: CountryOfOriginDto;
    rawMaterialOrigin: string;
    isDefault: boolean;
    parentNodeId: number;
}

export interface ComponentPriceDto {
    amount?: number | undefined;
    currencyId: number;
    unitId: number;
    suggestedAmount?: number | undefined;
    locked: boolean;
}

export interface CountryOfOriginDto {
    explicitlySet: boolean;
    country?: string | undefined;
}

export interface ComponentCompositionPartDto {
    id?: number | undefined;
    materialId: number;
    percentage: number;
}

export interface ComponentAttributeDto {
    id?: number | undefined;
    quantity: number;
    unitId: number;
    typeId: number;
}

export interface ComponentColorDto {
    id?: number | undefined;
    color?: ColorDto | undefined;
    approved: boolean;
    isDefault: boolean;
}

export interface ComponentImageDto {
    id: number;
    path: string;
    width: number;
    height: number;
    name: string;
    size: number;
}

export interface BomSlotSupplierDto {
    id: number;
    supplierId: number;
    price?: ComponentPriceDto | undefined;
}

export interface UpdateStructureArgs {
    id?: number | undefined;
    sections?: BomStructureSection[] | undefined;
    images?: BomImageDto[] | undefined;
}

export interface BomStructureSection {
    id?: number | undefined;
    name?: string | undefined;
    placements?: BomStructurePlacement[] | undefined;
}

export interface BomStructurePlacement {
    id?: number | undefined;
    name?: string | undefined;
    principal: boolean;
    annotationName?: string | undefined;
    slots?: BomStructureSlot[] | undefined;
    tagIds?: number[] | undefined;
}

export interface BomStructureSlot {
    id?: number | undefined;
    comment?: string | undefined;
    component?: BomStructureComponent | undefined;
    suppliers: BomStructureSupplier[];
    quantity?: number | undefined;
    price?: ComponentPriceDto | undefined;
}

export interface BomStructureComponent {
    id?: number | undefined;
    name?: string | undefined;
    refNumber?: string | undefined;
    comment?: string | undefined;
    unitId?: number | undefined;
    componentSubTypeId?: number | undefined;
    attributes?: ComponentAttributeDto[] | undefined;
    composition?: ComponentCompositionPartDto[] | undefined;
}

export interface BomStructureSupplier {
    id?: number | undefined;
    price?: ComponentPriceDto | undefined;
    supplierId: number;
}

export interface UpdateStructureGroupedArgs {
    structure: UpdateStructureArgs;
    seasonIds: (number | undefined)[];
}

export interface AddSectionArgs {
    source: SectionSource;
    id: number;
    articleIds: number[];
}

export enum SectionSource {
    Template = "Template",
    Bom = "Bom",
}

export interface CopyBomArgs {
    id: number;
    articleIds: number[];
}

export interface CopyFromSeasonArgs {
    sourceSeasonId?: number | undefined;
}

export interface MassUpdateConnectionsArgs {
    articlesAndSlots: ArticleAndSlot[];
    color?: SetColorArgs | undefined;
    setArticleColor: boolean;
    seasonIds?: (number | undefined)[] | undefined;
}

export interface ArticleAndSlot {
    articleId: number;
    slotId: number;
}

export interface MassRemoveConnectionsArgs {
    articlesAndSlots: ArticleAndSlot[];
    seasonIds?: (number | undefined)[] | undefined;
}

export interface BatchConnectionsArgs {
    actions: BatchConnectionActionArgs[];
    seasonIds?: (number | undefined)[] | undefined;
}

export interface BatchConnectionActionArgs {
    articlesAndSlots: ArticleAndSlot[];
    color?: SetColorArgs | undefined;
    setArticleColor: boolean;
    remove: boolean;
}

export interface AddBomImagesArgs {
    /** Files the client already uploaded through the files endpoints,
            in the order they should appear. */
    azureBlobFileIds: number[];
    /** Product images to copy into the BOM — the blob is copied so the
            BOM image can get versions of its own without touching the product's picture. */
    productImageIdList: number[];
}

export interface DetachBomImageArgs {
    /** The seasons the edit that follows is meant for — the viewed season alone,
            or every member of the group for a grouped edit. */
    seasonIds: (number | undefined)[];
}

export interface SyncImagesToSeasonsArgs {
    seasonIds: (number | undefined)[];
}

export interface GetBomExcelArgs {
    articleIds: number[];
    connectionSeasonIds?: (number | undefined)[] | undefined;
}

export interface SearchComponentsResponse {
    components: BomComponentDto[];
    total: number;
}

export interface AddComponentArgs {
    name?: string | undefined;
    refNumber?: string | undefined;
    unitId?: number | undefined;
    attributes: AddComponentAttribute[];
}

export interface AddComponentAttribute {
    typeId: number;
    unitId: number;
    quantity: number;
}

export type CreateSectionTemplateResponse = Successful | Conflict;
export interface CreateSectionTemplateResponse_Interface {
    type: string;
}

export interface Successful extends CreateSectionTemplateResponse_Interface {
    type: 'Successful';
    template?: SectionTemplateDto | undefined;
}
export function isSuccessful(obj?: CreateSectionTemplateResponse): obj is Successful {
    return obj?.type === 'Successful';
}

export interface SectionTemplateDto {
    id: number;
    savedName: string;
    source: SectionSource;
    sectionName: string;
    placements: TemplatePlacementDto[];
    hierarchyNodeIds: number[];
}

export interface TemplatePlacementDto {
    id: number;
    name?: string | undefined;
    slots: TemplateSlotDto[];
}

export interface TemplateSlotDto {
    id: number;
    componentId?: number | undefined;
    componentName?: string | undefined;
    componentType?: string | undefined;
    quantity?: number | undefined;
    componentUnitId?: number | undefined;
}

export interface Conflict extends CreateSectionTemplateResponse_Interface {
    type: 'Conflict';
    id: number;
    sectionName?: string | undefined;
    templateName?: string | undefined;
}
export function isConflict(obj?: CreateSectionTemplateResponse): obj is Conflict {
    return obj?.type === 'Conflict';
}

export interface CreateTemplateArgs {
    bomSectionId: number;
    name: string;
    hierarchyNodeIds: number[];
    overwrite: boolean;
}

export interface UpdateSavedSectionArgs {
    savedName: string;
    sectionName: string;
}

export interface CopyableBomDto {
    id: number;
    productName: string;
    productNumber: string;
    bomSeasonId?: number | undefined;
    seasonIds: number[];
    genders: Gender[];
    imageUrl?: string | undefined;
    hierarchyNodeId?: number | undefined;
    sectionTemplates: SectionTemplateDto[];
}

export interface NamedBomTemplateDto {
    id: number;
    name: string;
    hierarchyNodeIds: number[];
    sections: TemplateSectionDto[];
}

export interface TemplateSectionDto {
    id: number;
    name?: string | undefined;
    placements: TemplatePlacementDto[];
}

export interface CreateBomTemplateArgs {
    name: string;
    hierarchyNodeIds: number[];
    sections: SectionTemplateArgs[];
}

export interface SectionTemplateArgs {
    id: number;
    source?: SectionSource | undefined;
}

export interface ColorWithUsageDto {
    color: ColorDto;
    customValues: { [key: string]: CustomFieldValueDto; };
    images: ColorImageDto[];
    /** Whether the first image stands in for the colour's swatch. */
    imageAsSwatch: boolean;
    usage: BrandColorUsage;
}

export interface ColorImageDto {
    id: number;
    url: string;
    width: number;
    height: number;
    name: string;
    size: number;
    azureBlobFileId: number;
}

export interface BrandColorUsage {
    articles: number;
    componentColors: number;
    bomConnections: number;
    colorCodes: number;
    recentlyUsed: number;
    blocking: number;
    total: number;
}

export interface ColorUsageDto {
    articles: EntityReference[];
    bomConnections: EntityReference[];
    components: EntityReference[];
    colorCodes: EntityReference[];
}

export interface CreateColorArgs {
    values: BrandColorValues;
}

export interface AdoptLibraryColorArgs {
    libraryColorId: number;
    /** The colour as the user edited it after picking it, if they did. A name, code or group of the
brand's own is kept as an override on a new adoption that stays linked to the library;
different colour values (CMYK/RGB) make it a colour of the brand's own. */
    values?: BrandColorValues | undefined;
}

export interface UpdateColorsArgs {
    updates: ColorUpdateArgs[];
    numberUpdates: ColorNumberUpdateArgs[];
    groupSequentialNumberUpdates: ColorGroupSequentialNumberUpdateArgs[];
    customValueUpdates: ColorCustomValuesUpdateArgs[];
}

export interface ColorUpdateArgs {
    colorId: number;
    values: BrandColorValues;
}

export interface ColorNumberUpdateArgs {
    colorId: number;
    number?: string | undefined;
}

export interface ColorGroupSequentialNumberUpdateArgs {
    colorId: number;
    groupSequentialNumber?: number | undefined;
}

export interface ColorCustomValuesUpdateArgs {
    colorId: number;
    customValues: CustomFieldIdWithValueDto[];
}

export interface ColorImagesDto {
    colorId: number;
    images: ColorImageDto[];
    imageAsSwatch: boolean;
}

export interface UpdateColorImagesArgs {
    colorIds: number[];
    /** The pictures the colours should show, each named by a file showing it now — an image of one of the colours, or a new file from file_Upload. */
    images: ColorImageArg[];
    /** Put each colour's images in the listed order. Off, each keeps its own order and new images go last. */
    reorder: boolean;
    /** Whether each colour's first image stands in for its swatch. Null leaves every colour as it is — what an edit of several colours that differ sends when it doesn't touch it. */
    imageAsSwatch?: boolean | undefined;
}

export interface ColorImageArg {
    azureBlobFileId: number;
    onEveryColor: boolean;
}

export interface SpreadImageVersionArgs {
    colorIds: number[];
    /** One colour's image file, just given a new version with file_AddVersion. */
    azureBlobFileId: number;
    /** The picture it showed before that version — the image's url as it was. */
    replacedUrl: string;
}

export interface SetColorPalettesArgs {
    colorIds: number[];
    addPaletteIds: number[];
    removePaletteIds: number[];
}

export interface PlainSheetRow {
    rowNumber: number;
    cells: (string | undefined)[];
}

export interface ColorImportPreview {
    rows: ColorImportRowResult[];
    create: number;
    update: number;
    unchanged: number;
    invalid: number;
    matching: number;
    notes: string[];
}

export interface ColorImportRowResult {
    rowNumber: number;
    outcome: ColorImportOutcome;
    name?: string | undefined;
    number?: string | undefined;
    numberFromTemplate: boolean;
    groupId?: number | undefined;
    groupSequentialNumber?: number | undefined;
    existingColorId?: number | undefined;
    existingName?: string | undefined;
    renumberedFrom?: string | undefined;
    errors: ColorImportIssue[];
    warnings: ColorImportIssue[];
}

export enum ColorImportOutcome {
    Create = "Create",
    Update = "Update",
    Unchanged = "Unchanged",
    Invalid = "Invalid",
}

export interface ColorImportIssue {
    kind: string;
    message: string;
}

export interface ImportColorsArgs {
    rows: ColorImportRow[];
    columns: ColorImportColumn[];
    skipInvalidRows: boolean;
    renumberMatchingColors: boolean;
}

export interface ColorImportRow {
    rowNumber: number;
    number?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    group?: string | undefined;
    groupSequentialNumber?: string | undefined;
    red?: string | undefined;
    green?: string | undefined;
    blue?: string | undefined;
    hex?: string | undefined;
    status?: string | undefined;
    palettes?: string | undefined;
    type?: string | undefined;
}

export enum ColorImportColumn {
    Number = "Number",
    Name = "Name",
    Code = "Code",
    Group = "Group",
    GroupSequentialNumber = "GroupSequentialNumber",
    Rgb = "Rgb",
    Hex = "Hex",
    Status = "Status",
    Palettes = "Palettes",
    Type = "Type",
}

export interface ColorImportResult {
    created: number;
    updated: number;
    unchanged: number;
    skipped: number;
    colorIds: number[];
}

export interface SetColorStatusArgs {
    colorIds: number[];
    statusId: number;
}

export interface SetColorTypeArgs {
    colorIds: number[];
    typeId: number;
}

export interface ResetToLibraryArgs {
    field?: BrandColorLibraryField | undefined;
}

export enum BrandColorLibraryField {
    Name = 0,
    Code = 1,
}

export interface LinkToLibraryArgs {
    colorIds: number[];
    libraryColorId: number;
}

export interface LockedArticleDto {
    article: EntityReference;
    statusName: string;
    colorId: number;
}

export interface MergeColorsArgs {
    keepId: number;
    mergeIds: number[];
}

export interface ColorLibraryDto {
    id: number;
    name: string;
    order: number;
    enabled: boolean;
    colorCount: number;
}

export interface LibraryColorDto {
    id: number;
    libraryId: number;
    libraryName: string;
    code: string;
    name: string;
    c: number;
    m: number;
    y: number;
    k: number;
    r: number;
    g: number;
    b: number;
}

export interface SetLibraryEnabledArgs {
    enabled: boolean;
}

export interface BrandDto {
    id: number;
    plm: boolean;
    isPlmConfigured: boolean;
    requires2fa: boolean;
    integrationData?: string | undefined;
    logoUrl: string;
    articleNumberTemplate?: string | undefined;
    productNumberTemplate?: string | undefined;
    skuNumberTemplate?: string | undefined;
    useDevelopmentNumbers: boolean;
    developmentProductNumberTemplate?: string | undefined;
    developmentArticleNumberTemplate?: string | undefined;
    developmentSkuNumberTemplate?: string | undefined;
    componentNumberTemplate: string;
    colorNumberTemplate: string;
    supplierNumberTemplate: string;
    minimumProductInternalNumber: number;
    minimumComponentInternalNumber: number;
    minimumColorInternalNumber: number;
    minimumSupplierSequentialNumber: number;
    fillColorNumberGaps: boolean;
    colorCodeFromNumber: number;
    colorCodeToNumber: number;
    skuLevelPricingEnabled: boolean;
    skuLevelWeightEnabled: boolean;
}

export interface BrandCustomizationsDto {
    brandName: string;
    hooksClass?: string | undefined;
    numberLogic: BrandCustomLogicDto[];
    otherLogic: BrandCustomLogicDto[];
    integrations: BrandIntegrationInfoDto[];
    usesTemplatesForAllNumbers: boolean;
    hasCustomCode: boolean;
}

export interface BrandCustomLogicDto {
    kind: BrandCustomLogicKind;
    method: string;
    source: string;
    description?: string | undefined;
}

export enum BrandCustomLogicKind {
    ProductNumber = 0,
    ArticleNumber = 1,
    SkuNumber = 2,
    ComponentNumber = 3,
    SizeCode = 4,
    SkuSequenceNumber = 5,
    ArticleName = 6,
    SkuName = 7,
    OrderNumber = 8,
    OrderDeliveryNumber = 9,
}

export interface BrandIntegrationInfoDto {
    kind: BrandIntegrationKind;
    name: string;
    description: string;
}

export enum BrandIntegrationKind {
    Centra = 0,
    Webhook = 1,
    Export = 2,
    ScheduledFileTransfer = 3,
    Api = 4,
}

export interface CheckResult {
    tablesChecked: number;
    rowsInClosure: number;
    iterations: number;
    errorCount: number;
    warningCount: number;
    violations: Violation[];
}

export interface Violation {
    childTable: string;
    childId: number;
    fkColumn: string;
    parentTable: string;
    parentRefId?: number | undefined;
    isCrossBrand: boolean;
    resolvedBrandId?: number | undefined;
}

export interface BrandReference {
    id: number;
    name: string;
}

export interface UpdateArgs {
    plm: boolean;
    requires2fa: boolean;
    integrationData?: string | undefined;
    initialization?: InitializationChoice | undefined;
}

export interface InitializationChoice {
    sourceBrandId?: number | undefined;
    copyConfig: boolean;
    copySuppliers: boolean;
    copyCatalogs: boolean;
    skip: boolean;
}

export interface SupplierTemplatePreviewResponse {
    success: boolean;
    error?: string | undefined;
    supplierCount: number;
    changedCount: number;
    duplicateNumbers: string[];
    suppliers: SupplierNumberPreview[];
}

export interface SupplierNumberPreview {
    id: number;
    name: string;
    currentNumber: string;
    newNumber: string;
    isManuallySet: boolean;
}

export interface ColorTemplatePreviewResponse {
    success: boolean;
    error?: string | undefined;
    currentNumber?: string | undefined;
    previewNumber?: string | undefined;
}

export interface ColorTemplatePreviewArgs {
    colorId: number;
    colorNumberTemplate?: string | undefined;
}

export interface ComponentTemplatePreviewResponse {
    success: boolean;
    error?: string | undefined;
    componentId?: number | undefined;
    componentName?: string | undefined;
    componentPreview?: ComponentPreview | undefined;
}

export interface ComponentPreview {
    currentNumber: string;
    savedTemplateNumber?: string | undefined;
    previewTemplateNumber?: string | undefined;
    previewTemplateError?: string | undefined;
    isManuallySet: boolean;
}

export interface ComponentTemplatePreviewArgs {
    componentId: number;
    componentNumberTemplate?: string | undefined;
}

export interface UpdateColorCodeRangeArgs {
    colorCodeFromNumber: number;
    colorCodeToNumber: number;
}

export interface ProductTemplatesPreviewResponse {
    success: boolean;
    error?: string | undefined;
    warning?: string | undefined;
    productId?: number | undefined;
    productNumber?: string | undefined;
    productName?: string | undefined;
    productPreview?: NumberPreview | undefined;
    productDevelopmentPreview?: NumberPreview | undefined;
    articles?: ArticlePreview[] | undefined;
}

export interface NumberPreview {
    currentNumber: string;
    savedTemplateNumber?: string | undefined;
    previewTemplateNumber?: string | undefined;
    previewTemplateError?: string | undefined;
    isManuallySet: boolean;
}

export interface ArticlePreview {
    id: number;
    articleNumber: string;
    colorName?: string | undefined;
    preview: NumberPreview;
    developmentPreview?: NumberPreview | undefined;
    skus: SkuPreview[];
}

export interface SkuPreview {
    id: number;
    skuNumber: string;
    sizeValue?: string | undefined;
    preview: NumberPreview;
    developmentPreview?: NumberPreview | undefined;
}

export interface ProductTemplatesPreviewArgs {
    productId: number;
    articleNumberTemplate?: string | undefined;
    productNumberTemplate?: string | undefined;
    skuNumberTemplate?: string | undefined;
    developmentArticleNumberTemplate?: string | undefined;
    developmentProductNumberTemplate?: string | undefined;
    developmentSkuNumberTemplate?: string | undefined;
}

export interface BrandEndpointInfo {
    type: BrandEndPointCategory;
    usesPayload: boolean;
    title: string;
    method: string;
    url: string;
    icon: string;
}

export enum BrandEndPointCategory {
    ExportWithNotification = 0,
    SilentBackgroundJob = 1,
}

export interface CurrentStatisticsResponse {
    productCount: number;
    productsByHierarchyTopNode: { [key: string]: number; };
    articlesByStatus: { [key: string]: number; };
    skuCount: number;
    skusByStatus: { [key: string]: number; };
    userCount: number;
    componentCount: number;
    componentsByStatus: { [key: string]: number; };
    sampleRequestCount: number;
    sampleRequestsByType: { [key: string]: number; };
    orderCount: number;
    ordersByStatus: { [key: string]: number; };
}

export interface HistoricalStatisticsResponse {
    products: MonthlyDataPoint[];
    articles: MonthlyDataPoint[];
    skus: MonthlyDataPoint[];
    users: MonthlyDataPoint[];
    components: MonthlyDataPoint[];
    sampleRequests: MonthlyDataPoint[];
    orders: MonthlyDataPoint[];
}

export interface MonthlyDataPoint {
    year: number;
    month: number;
    count: number;
}

export interface CompanyWithEmailDto {
    id: number;
    name: string;
    country?: string | undefined;
    emailAddress?: string | undefined;
    ownedByBrand: boolean;
}

export interface BrandSupplierUsageDto {
    id: number;
    onArticles: boolean;
    onComponents: boolean;
}

export interface BrandSupplierDto {
    id: number;
    name: string;
    supplierNumber: string;
    contactEmail?: string | undefined;
    externalNumber?: string | undefined;
    leadTime?: number | undefined;
    modeOfTransportId?: number | undefined;
    oarId?: string | undefined;
    manufacturerId?: string | undefined;
    internalComment: string;
    deliveryTermId?: number | undefined;
    paymentTermId?: number | undefined;
    companyId: number;
    address?: string | undefined;
    country: CountryDto;
    defaultCurrencyId?: number | undefined;
    defaultCountryOfOriginId?: number | undefined;
    customFields: { [key: string]: CustomFieldValueDto; };
    subSupplierIds: number[];
    statusId: number;
    certifications: BrandSupplierCertificationDto[];
    compliances: BrandSupplierComplianceDto[];
    portalEnabled: boolean;
    portalPeopleCount: number;
    logo?: string | undefined;
}

export interface BrandSupplierCertificationDto {
    id: number;
    certificateId: number;
    file?: string | undefined;
    summary?: string | undefined;
    validUntil?: string | undefined;
}

export interface BrandSupplierComplianceDto {
    id: number;
    complianceId: number;
    file?: string | undefined;
    summary?: string | undefined;
    testResult: ComplianceTestResult;
    conductedAt?: string | undefined;
}

export interface AddBrandSupplierArgs {
    name: string;
    countryId?: number | undefined;
}

export interface UpdateBrandSupplierSingleTextArgs {
    ids: number[];
    value?: string | undefined;
}

export interface UpdateBrandSupplierSingleIdArgs {
    ids: number[];
    setId?: number | undefined;
    removedIds: number[];
}

export interface SupplierNumberInfoResponse {
    currentNumber: string;
    isManuallySet: boolean;
    systemGeneratedNumber: string;
}

export interface UpdateBrandSupplierSingleIntArgs {
    ids: number[];
    value?: number | undefined;
}

export interface UpdateBrandSupplierTextCustomFieldArgs {
    ids: number[];
    value?: string | undefined;
}

export interface UpdateBrandSupplierMoneyCustomFieldArgs {
    ids: number[];
    amountValue?: AmountValue | undefined;
    currencyId?: number | undefined;
}

export interface AmountValue {
    amount?: number | undefined;
}

export interface UpdateBrandSupplierNumberWithUnitCustomFieldArgs {
    ids: number[];
    numberValue?: NumberValue | undefined;
    unitId?: number | undefined;
}

export interface NumberValue {
    number?: number | undefined;
}

export interface UpdateBrandSupplierSingleSelectCustomFieldArgs {
    ids: number[];
    addedOptionId?: number | undefined;
    removedOptionIds: number[];
    clear: boolean;
}

export interface UpdateBrandSupplierMultiSelectCustomFieldArgs {
    ids: number[];
    addedOptionIds: number[];
    removedOptionIds: number[];
    clear: boolean;
}

export interface UpdateBrandSupplierFilesCustomFieldArgs {
    ids: number[];
    addFiles: CustomFieldFile[];
    removeFiles: CustomFieldFile[];
}

export interface CustomFieldFile {
    path: string;
    filename: string;
    size: number;
}

export interface RelinkBrandSupplierCustomFieldArgs {
    ids: number[];
}

export interface UpdateBrandSupplierSubSuppliersArgs {
    ids: number[];
    addedSubSupplierIds: number[];
    removedSubSupplierIds: number[];
}

export interface SupplierPortalStatusDto {
    brandSupplierId: number;
    enabled: boolean;
    enabledReason?: SupplierPortalEnableReason | undefined;
    enabledAt?: string | undefined;
    people: SupplierPortalAccessDto[];
    pendingInvitations: SupplierPortalInvitationDto[];
    suggestions: SupplierPortalSuggestionDto[];
}

export enum SupplierPortalEnableReason {
    Manual = "Manual",
    InvitationAccepted = "InvitationAccepted",
    RoundSent = "RoundSent",
}

export interface SupplierPortalAccessDto {
    userId: string;
    name?: string | undefined;
    email?: string | undefined;
    photo?: string | undefined;
    role: SupplierPortalRole;
    source: SupplierPortalAccessSource;
    grantedAt?: string | undefined;
}

export enum SupplierPortalRole {
    None = "None",
    AddedByBrand = "AddedByBrand",
    Member = "Member",
    Admin = "Admin",
}

export enum SupplierPortalAccessSource {
    BrandInvitation = "BrandInvitation",
    RoundRecipient = "RoundRecipient",
    MemberDefault = "MemberDefault",
    CompanyAdmin = "CompanyAdmin",
    ResourcedStaff = "ResourcedStaff",
}

export interface SupplierPortalInvitationDto {
    id: number;
    email: string;
    brandSupplierId: number;
    role: SupplierPortalRole;
    createdAt: string;
    expiresAt: string;
}

export interface SupplierPortalSuggestionDto {
    email: string;
    roundCount: number;
    lastSentAt?: string | undefined;
}

export interface InvitePortalPeopleArgs {
    emails: string[];
}

export interface BrandSupplierUsageCountsDto {
    brandSupplierId: number;
    components: number;
    products: number;
    orders: number;
    sampleRounds: number;
    templates: number;
    boms: number;
    asSubSupplier: number;
}

export interface SupplierMergeConflictDto {
    kind: SupplierMergeConflictKind;
    entity: EntityReference;
    suppliers: string[];
}

export enum SupplierMergeConflictKind {
    Product = 0,
    Bom = 1,
    Component = 2,
    BomTemplate = 3,
    SavedSection = 4,
}

export interface MergeBrandSuppliersArgs {
    keepId: number;
    mergeIds: number[];
}

export interface GetExcelArgs {
    brandSupplierIds: number[];
}

export interface UpdateBrandSupplierCertificationsArgs {
    /** The brand suppliers to update. */
    ids: number[];
    /** Certificates to attach or update, matched on CertificateId. These are merged into
each supplier's existing set — certifications not listed here are kept. */
    upserts: BrandSupplierCertificationArgs[];
    /** The only way to detach a certificate. */
    removedCertificateIds: number[];
}

export interface BrandSupplierCertificationArgs {
    certificateId: number;
    file?: string | undefined;
    summary?: string | undefined;
    validUntil?: string | undefined;
}

export interface UpdateBrandSupplierCompliancesArgs {
    /** The brand suppliers to update. */
    ids: number[];
    /** Compliances to attach or update, matched on ComplianceId. These are merged into
each supplier's existing set — compliances not listed here are kept. */
    upserts: BrandSupplierComplianceArgs[];
    /** The only way to detach a compliance. */
    removedComplianceIds: number[];
}

export interface BrandSupplierComplianceArgs {
    complianceId: number;
    file?: string | undefined;
    summary?: string | undefined;
    testResult: ComplianceTestResult;
    conductedAt?: string | undefined;
}

export interface BrandSupplierStatusDto {
    id: number;
    name: string;
    color: string;
    excludeFromDefaultFiltering: boolean;
}

export interface CreateBrandSupplierStatusArgs {
    name: string;
    color: string;
    excludeFromDefaultFiltering: boolean;
}

export interface UpdateBrandSupplierStatusArgs {
    name: string;
    color: string;
    excludeFromDefaultFiltering: boolean;
}

export interface BrandSupplierStatusUsageDto {
    suppliers: EntityReference[];
}

export interface ReplaceBrandSupplierStatusArgs {
    replacementId: number;
}

export interface CertificateDto {
    id: number;
    name: string;
    category: ComplianceCategory;
    iconUrl: string;
}

export enum ComplianceCategory {
    Sustainability = 1,
    Physical = 2,
    Chemical = 3,
}

export interface CertificateUsageDto {
    components?: EntityReference[] | undefined;
    articles?: EntityReference[] | undefined;
    suppliers?: EntityReference[] | undefined;
}

export interface CertificateReminderDto {
    id: number;
    entityType: CertificationEntityType;
    daysInAdvance: number;
    articleScope: ArticleReminderScope;
    recipientIds: string[];
}

export enum CertificationEntityType {
    Component = 1,
    Article = 2,
    Supplier = 3,
}

export enum ArticleReminderScope {
    All = 1,
    AssignedOnly = 2,
}

export interface AddCertificateReminderArgs {
    entityType: CertificationEntityType;
    daysInAdvance: number;
    articleScope: ArticleReminderScope;
    userIds: string[];
}

export interface UpdateCertificateReminderArgs {
    daysInAdvance: number;
    articleScope: ArticleReminderScope;
    userIds: string[];
}

export interface ChannelDto {
    id: number;
    name: string;
    key: string;
    strict: boolean;
    activities: ChannelActivityDto[];
}

export interface ChannelActivityDto {
    id: number;
    seasonId: number;
    start: string;
    end: string;
}

export interface CreateChannelArgs {
    name: string;
    key?: string | undefined;
    strict: boolean;
}

export interface UpdateChannelArgs {
    name: string;
    key: string;
    strict: boolean;
}

export interface ChatMessageDto {
    id: number;
    createdAt: string;
    author?: UserDto | undefined;
    kind: ChatItemKind;
    body: string;
    status: ChatTaskStatus;
    deadline?: string | undefined;
    contextUrl?: string | undefined;
    contextLabel?: string | undefined;
    recipients: ChatRecipientDto[];
    statusChangedBy?: UserDto | undefined;
    statusChangedAt?: string | undefined;
}

export enum ChatItemKind {
    Message = 0,
    Task = 1,
}

export enum ChatTaskStatus {
    Open = 0,
    Ongoing = 1,
    Done = 2,
}

export interface ChatRecipientDto {
    user: UserDto;
    seen: boolean;
}

export interface CreateChatMessageArgs {
    recipientIds: string[];
    kind: ChatItemKind;
    body: string;
    deadline?: string | undefined;
    contextUrl?: string | undefined;
    contextLabel?: string | undefined;
}

export interface EditChatMessageArgs {
    body: string;
    deadline?: string | undefined;
}

export interface UpdateChatStatusArgs {
    status: ChatTaskStatus;
}

export interface ColorPaletteDto {
    id: number;
    name: string;
    seasonId?: number | undefined;
    icon?: string | undefined;
    statusId: number;
}

export interface ColorPaletteWithColorsDto {
    id: number;
    name: string;
    seasonId?: number | undefined;
    icon?: string | undefined;
    statusId: number;
    colors: ColorDto[];
}

export interface ColorPaletteContentsDto {
    paletteId: number;
    colorCount: number;
    sample: ColorDtoMinimal[];
}

export interface ColorDtoMinimal {
    name: string;
    r: number;
    g: number;
    b: number;
    swatchUrl?: string | undefined;
}

export interface ColorSearchResultDto {
    color?: ColorDto | undefined;
    libraryColor?: LibraryColorDto | undefined;
}

export interface ColorLookupResult {
    outcome: ColorLookupOutcome;
    color?: ColorDto | undefined;
    matchCount: number;
}

export enum ColorLookupOutcome {
    Found = 0,
    NotFound = 1,
    Ambiguous = 2,
}

export interface LookupColorsArgs {
    entries: ColorLookupEntry[];
}

export interface ColorLookupEntry {
    name?: string | undefined;
    code?: string | undefined;
    /** Restricts the search to that palette. Without it, every palette is searched. */
    paletteName?: string | undefined;
    r?: number | undefined;
    g?: number | undefined;
    b?: number | undefined;
}

export interface AddPaletteArgs {
    name: string;
    icon?: string | undefined;
    seasonId?: number | undefined;
    statusId?: number | undefined;
}

export interface UpdatePaletteArgs {
    name: string;
    icon?: string | undefined;
    seasonId?: number | undefined;
    statusId: number;
}

export interface MergePalettesArgs {
    paletteIds: number[];
    intoPaletteId: number;
}

export interface AddMultiplePaletteColorsArgs {
    colors: BrandColorValues[];
}

export type ColorCodeDto = BrandColor | CustomName | NoColor;
export interface ColorCodeDto_Interface {
    id: number;
    code: string;
    type: string;
}

export interface BrandColor extends ColorCodeDto_Interface {
    type: 'BrandColor';
    color: ColorDto;
}
export function isBrandColor(obj?: ColorCodeDto): obj is BrandColor {
    return obj?.type === 'BrandColor';
}

export interface CustomName extends ColorCodeDto_Interface {
    type: 'CustomName';
    name: string;
    colorGroupId?: number | undefined;
}
export function isCustomName(obj?: ColorCodeDto): obj is CustomName {
    return obj?.type === 'CustomName';
}

export interface NoColor extends ColorCodeDto_Interface {
    type: 'NoColor';
}
export function isNoColor(obj?: ColorCodeDto): obj is NoColor {
    return obj?.type === 'NoColor';
}

export type SetColorCodeArgs = BrandColor2 | CustomName2 | NoColor2;
export interface SetColorCodeArgs_Interface {
    code: string;
    type: string;
}

export interface BrandColor2 extends SetColorCodeArgs_Interface {
    type: 'BrandColor';
    brandColorId: number;
}
export function isBrandColor2(obj?: SetColorCodeArgs): obj is BrandColor2 {
    return obj?.type === 'BrandColor';
}

export interface CustomName2 extends SetColorCodeArgs_Interface {
    type: 'CustomName';
    name?: string | undefined;
    colorGroupId?: number | undefined;
}
export function isCustomName2(obj?: SetColorCodeArgs): obj is CustomName2 {
    return obj?.type === 'CustomName';
}

export interface NoColor2 extends SetColorCodeArgs_Interface {
    type: 'NoColor';
}
export function isNoColor2(obj?: SetColorCodeArgs): obj is NoColor2 {
    return obj?.type === 'NoColor';
}

export interface ColorGroupDto {
    id: number;
    name: string;
    r: number;
    g: number;
    b: number;
    articleNumberCode?: string | undefined;
}

export interface ColorGroupLibraryDto {
    groups: ColorGroupContentsDto[];
    ungrouped: number;
}

export interface ColorGroupContentsDto {
    colorGroupId: number;
    colorCount: number;
    sample: ColorGroupSwatchDto[];
    betterElsewhere: number;
}

export interface ColorGroupSwatchDto {
    name: string;
    r: number;
    g: number;
    b: number;
}

export interface ColorGroupMemberDto {
    brandColorId: number;
    name: string;
    code?: string | undefined;
    number: string;
    r: number;
    g: number;
    b: number;
    colorGroupId?: number | undefined;
    nearestColorGroupId?: number | undefined;
    distanceFromGroup: number;
}

export interface RefileColorsArgs {
    moves: ColorMoveArgs[];
}

export interface ColorMoveArgs {
    brandColorId: number;
    colorGroupId?: number | undefined;
}

export interface SuggestedColorDto {
    r: number;
    g: number;
    b: number;
}

export interface CreateColorGroupArgs {
    name: string;
    r: number;
    g: number;
    b: number;
    articleNumberCode?: string | undefined;
}

export interface MergeColorGroupArgs {
    intoColorGroupId?: number | undefined;
}

export interface ColorPaletteStatusDto {
    id: number;
    name: string;
    color: string;
    hideInColorPicker: boolean;
}

export interface ColorPaletteStatusArgs {
    name: string;
    color: string;
    hideInColorPicker: boolean;
}

export interface ColorPaletteStatusUsageDto {
    palettes: EntityReference[];
}

export interface ReplaceColorPaletteStatusArgs {
    replacementId: number;
}

export interface ColorStatusDto {
    id: number;
    name: string;
    color: string;
    hideInColorSearch: boolean;
    excludeFromDefaultFiltering: boolean;
}

export interface ColorStatusArgs {
    name: string;
    color: string;
    hideInColorSearch: boolean;
    excludeFromDefaultFiltering: boolean;
}

export interface ColorStatusUsageDto {
    colors: EntityReference[];
}

export interface ReplaceColorStatusArgs {
    replacementId: number;
}

export interface ColorTypeDto {
    id: number;
    name: string;
    code?: string | undefined;
}

export interface ColorTypeArgs {
    name: string;
    code?: string | undefined;
}

export interface ColorTypeUsageDto {
    colors: EntityReference[];
}

export interface ReplaceColorTypeArgs {
    replacementId: number;
}

export interface ComplianceDto {
    id: number;
    name: string;
    category: ComplianceCategory;
}

export interface ComplianceUsageDto {
    components: EntityReference[];
    articles: EntityReference[];
    suppliers: EntityReference[];
}

export interface ComponentAttributeTypeDto {
    id: number;
    name: string;
    unitIds: number[];
}

export interface ComponentDto {
    id: number;
    componentNumber: string;
    statusId?: number | undefined;
    name?: string | undefined;
    refNumber?: string | undefined;
    secondaryRefNumber?: string | undefined;
    comment?: string | undefined;
    unitId?: number | undefined;
    minimumBulkOrderQuantity?: number | undefined;
    minimumSampleOrderQuantity?: number | undefined;
    bulkOrderLeadTimeInDays?: number | undefined;
    sampleOrderLeadTimeInDays?: number | undefined;
    price?: ComponentPriceDto | undefined;
    countryOfOrigin?: string | undefined;
    rawMaterialOrigin?: string | undefined;
    suppliers: ComponentSupplierDto[];
    subTypeId?: number | undefined;
    composition: ComponentCompositionPartDto[];
    colors: ComponentColorDto[];
    products: ComponentDtoProduct[];
    seasonIds: number[];
    categories: ComponentDtoCategory[];
    attributes: ComponentAttributeDto[];
    certifications: ComponentCertificationDto[];
    componentCompliances: ComponentComplianceDto[];
    componentTagIds: number[];
    treatmentIds: number[];
    tariffCodeIds: number[];
    images: ComponentImageDto[];
    files: ComponentFileDto[];
    supplyChainNodes: ComponentSupplyChainNodeDto[];
    createdAt?: string | undefined;
    createdBy?: UserDto | undefined;
    customFields: { [key: string]: CustomFieldValueDto; };
}

export interface ComponentDtoProduct {
    id: number;
    name?: string | undefined;
    articleCount: number;
}

export interface ComponentDtoCategory {
    id: number;
    name: string;
    locked: boolean;
}

export interface ComponentCertificationDto {
    id: number;
    certificateId: number;
    file?: string | undefined;
    summary?: string | undefined;
    validUntil?: string | undefined;
}

export interface ComponentComplianceDto {
    id: number;
    complianceId: number;
    file?: string | undefined;
    summary?: string | undefined;
    testResult: ComplianceTestResult;
    conductedAt?: string | undefined;
}

export interface ComponentFileDto {
    id: number;
    filename?: string | undefined;
    path?: string | undefined;
    uploadedAt: string;
    size: number;
}

export interface ComponentSupplyChainNodeDto {
    id: number;
    parentSupplierId?: number | undefined;
    supplyChainStepTypeId?: number | undefined;
    order: number;
}

export interface ComponentListResponse {
    components: ComponentDto[];
    total: number;
    searchModeUsed?: SearchMode | undefined;
}

export enum SearchMode {
    Fast = "Fast",
    Extended = "Extended",
}

export interface AttributeFilter {
    attributeTypeId: number;
    unitId?: number | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
}

export interface ClonedComponent {
    clonedFromId: number;
    component: ComponentDto;
}

export interface CloneComponentArgs {
    componentIds: number[];
}

export interface UpdateNameAndRefNumberArgs {
    name?: string | undefined;
    refNumber?: string | undefined;
    secondaryRefNumber?: string | undefined;
}

export interface AssignSubTypeArgs {
    subTypeId?: number | undefined;
}

export interface UpdateAttributesArgs {
    attributes: ComponentAttributeDto[];
}

export interface UpdateCompositionArgs {
    composition: ComponentCompositionPartDto[];
}

export interface UpdateSuppliersArgs {
    suppliers: UpdateSuppliersArgsSupplier[];
}

export interface UpdateSuppliersArgsSupplier {
    supplierId: number;
    isDefault: boolean;
}

export interface UpdatePriceArgs {
    componentPrice?: ComponentPriceDto | undefined;
    suppliers: UpdatePriceArgsSupplier[];
}

export interface UpdatePriceArgsSupplier {
    price?: ComponentPriceDto | undefined;
    supplierId: number;
}

export interface UpdateOriginArgs {
    componentCountryOfOrigin?: string | undefined;
    componentRawMaterialOrigin?: string | undefined;
    suppliers: UpdateOriginArgsSupplier[];
}

export interface UpdateOriginArgsSupplier {
    countryOfOrigin: CountryOfOriginDto;
    rawMaterialOrigin?: string | undefined;
    supplierId: number;
}

export interface SetComponentColorsArgs {
    colors: SetComponentColorArgs[];
}

export interface SetComponentColorArgs {
    id?: number | undefined;
    color: SetColorArgs;
    approved: boolean;
    isDefault: boolean;
}

export interface SetComponentCategoriesArgs {
    categories: CategoryArg[];
}

export interface CategoryArg {
    id: number;
    name?: string | undefined;
}

export interface CommentArg {
    comment?: string | undefined;
}

export interface SetComponentSeasonsArgs {
    seasonIds: number[];
}

export interface SetComponentStatusArgs {
    id?: number | undefined;
}

export interface UpdateComponentTreatmentsArgs {
    treatmentIds: number[];
}

export interface UpdateComponentMoqArgs {
    bulk?: number | undefined;
    sample?: number | undefined;
    unitId: number;
}

export interface UpdateComponentLeadTimeArgs {
    bulk?: number | undefined;
    sample?: number | undefined;
}

export interface DeleteComponentsArgs {
    componentIds: number[];
}

export interface ReplaceComponentsArgs {
    componentIdsToReplace: number[];
    componentIdReplaceWith: number;
}

export interface ReplaceOnBomsResponse {
    replacedComponent: ComponentDto;
    replaceWithComponent: ComponentDto;
}

export interface ReplaceOnBomsArg {
    replaceWithComponentId: number;
    bomSlotIds: number[];
}

export interface UpdateComponentTagsArgs {
    tagIds: number[];
}

export interface UpdateImagesArgs {
    images: UpdateImagesArgsImage[];
}

export interface UpdateImagesArgsImage {
    id?: number | undefined;
    path: string;
    width: number;
    height: number;
    name: string;
    size: number;
}

export interface UpdateFilesArgs {
    files: UpdateFilesArgsFile[];
}

export interface UpdateFilesArgsFile {
    id?: number | undefined;
    filename: string;
    path: string;
    size: number;
}

export interface ComponentNumberInfoResponse {
    currentNumber: string;
    isManuallySet: boolean;
    systemGeneratedNumber: string;
}

export enum ExcelImageSize {
    Small = 1,
    Medium = 2,
    Large = 3,
}

export interface UpdateComponentTextCustomFieldArgs {
    componentIds: number[];
    value?: string | undefined;
}

export interface UpdateComponentMoneyCustomFieldArgs {
    componentIds: number[];
    amountValue?: AmountValue | undefined;
    currencyId?: number | undefined;
}

export interface UpdateComponentNumberWithUnitCustomFieldArgs {
    componentIds: number[];
    numberValue?: NumberValue | undefined;
    unitId?: number | undefined;
}

export interface UpdateComponentSingleSelectCustomFieldArgs {
    componentIds: number[];
    addedOptionId?: number | undefined;
    removedOptionIds: number[];
    clear: boolean;
}

export interface UpdateComponentMultiSelectCustomFieldArgs {
    componentIds: number[];
    addedOptionIds: number[];
    removedOptionIds: number[];
    clear: boolean;
}

export interface UpdateComponentFilesCustomFieldArgs {
    componentIds: number[];
    addFiles: CustomFieldFile[];
    removeFiles: CustomFieldFile[];
}

export interface RelinkComponentCustomFieldArgs {
    componentIds: number[];
}

export interface UpdateSupplyChainArgs {
    suppliers?: SupplyChainSupplierArg[] | undefined;
    nodes?: SupplyChainNodeArg[] | undefined;
}

export interface SupplyChainSupplierArg {
    tempId: number;
    parentNodeTempId: number;
    supplierId?: number | undefined;
    order: number;
    isDefault: boolean;
}

export interface SupplyChainNodeArg {
    tempId: number;
    parentSupplierTempId?: number | undefined;
    supplyChainStepTypeId?: number | undefined;
    order: number;
}

export interface BatchUpdateSupplyChainArgs {
    componentIds: number[];
    supplyChain: UpdateSupplyChainArgs;
}

export interface ComponentStatusDto {
    id: number;
    name: string;
    color: string;
    excludeFromDefaultFiltering: boolean;
}

export interface CreateComponentStatusArgs {
    name?: string | undefined;
    color?: string | undefined;
    excludeFromDefaultFiltering: boolean;
}

export interface UpdateComponentStatusArgs {
    name?: string | undefined;
    color?: string | undefined;
    excludeFromDefaultFiltering: boolean;
}

export interface ComponentStatusUsageDto {
    components?: EntityReference[] | undefined;
}

export interface ReplaceComponentStatusArgs {
    replacementId: number;
}

export interface ComponentTagCategoryDto {
    id: number;
    name: string;
    key: string;
    baseCategory: boolean;
    tags: ComponentTagDto[];
}

export interface ComponentTagDto {
    id: number;
    name: string;
    color: string;
    externalCode?: string | undefined;
    tagCategoryId: number;
}

export interface AddCategoryArgs {
    name: string;
    key: string;
    baseCategory: boolean;
}

export interface UpdateCategoryArgs {
    name?: string | undefined;
    key?: string | undefined;
}

export interface ComponentTagUsageDto {
    /** The components carrying the tag, or any tag of the category. Deleting takes it off them. */
    components: EntityReference[];
    /** For a tag: the fields where values hold its option, which refuse the delete. For a category: the fields synced from it, which keep their options as ordinary ones. */
    customFields: EntityReference[];
    /** For a category: the calculated fields whose template reads it, which refuse the delete. */
    templates: EntityReference[];
    /** For a tag: the lookup tables with rows keyed by its option, and how many. Deleting removes those rows. */
    lookupTables: EntityReference[];
}

export interface AddTagArgs {
    name: string;
    color: string;
    externalCode?: string | undefined;
    tagCategoryId: number;
}

export interface UpdateTagArgs {
    name: string;
    color: string;
    externalCode?: string | undefined;
}

export interface ComponentTypeDto {
    id: number;
    name: string;
    componentNumberCode?: string | undefined;
    subTypes: ComponentSubTypeDto[];
}

export interface ComponentSubTypeDto {
    id: number;
    name?: string | undefined;
    componentNumberCode?: string | undefined;
    fullName: string;
}

export interface ComponentSubTypeUsageDto {
    subTypeId: number;
    count: number;
    components: EntityReference[];
}

export interface SetComponentTypeFieldsBulkArgs {
    cells: SetComponentTypeFieldsBulkCell[];
}

export interface SetComponentTypeFieldsBulkCell {
    /** Set for a cell on the type itself — its name or code. */
    typeId?: number | undefined;
    /** Set for a cell on a sub-type. Exactly one of the two ids is set. */
    subTypeId?: number | undefined;
    field: ComponentTypeField;
    /** The field as text. A type must keep its name; a sub-type's name may be cleared, since the nameless sub-type is the type itself. */
    value?: string | undefined;
}

export enum ComponentTypeField {
    Name = 0,
    Code = 1,
}

export interface DeleteComponentTypesArgs {
    typeIds: number[];
    subTypeIds: number[];
}

export interface CopyComponentTypesArgs {
    typeIds: number[];
    subTypeIds: number[];
}

export interface AddTypeArgs {
    name: string;
    componentNumberCode?: string | undefined;
}

export interface UpdateTypeArgs {
    name: string;
    componentNumberCode?: string | undefined;
}

export interface AddSubTypeArgs {
    /** Null makes the nameless sub-type — the one that lets a component be of the type with no sub-type. */
    name?: string | undefined;
    componentNumberCode?: string | undefined;
}

export interface UpdateSubTypeArgs {
    name?: string | undefined;
    componentNumberCode?: string | undefined;
}

export interface CompositionMaterialDto {
    id: number;
    name: string;
    details: CompositionMaterialDetailSimple[];
}

export interface CompositionMaterialDetailSimple {
    value: string;
    typeId: number;
    id: number;
}

export interface AddCompositionMaterialArgs {
    name: string;
    details?: CompositionMaterialDetailSimple[] | undefined;
}

export interface CompositionMaterialDetailTypeDto {
    id: number;
    name: string;
}

export interface AddDetailTypeArgs {
    name?: string | undefined;
}

export interface CurrencyDto {
    id: number;
    code: string;
    symbol: string;
    symbolPosition: CurrencySymbolPosition;
    mainCurrency: boolean;
}

export enum CurrencySymbolPosition {
    Suffix = 0,
    Prefix = 1,
}

export interface AddBrandMainCurrencyArgs {
    currencyId: number;
}

export interface IdAndCount {
    id: number;
    count: number;
}

export interface CurrencyExchangeRateDto {
    id: number;
    fromId: number;
    toId: number;
    exchangeRate: number;
    seasonId?: number | undefined;
    updatedAt?: string | undefined;
    isCalculated: boolean;
}

export interface CreateCurrencyExchangeRateArgs {
    fromId: number;
    toId: number;
    exchangeRate: number;
    seasonId?: number | undefined;
}

export interface SetExchangeRatesBulkArgs {
    toId: number;
    cells: SetExchangeRatesBulkCell[];
}

export interface SetExchangeRatesBulkCell {
    fromId: number;
    /** null is the Default column, a real value — not "unset". */
    seasonId?: number | undefined;
    exchangeRate?: number | undefined;
}

export interface UpdateCurrencyExchangeRateArgs {
    exchangeRate: number;
    seasonId?: number | undefined;
}

export type CustomFieldDto = TextCustomFieldDto | PhysicalDimensionsCustomFieldDto | MoneyCustomFieldDto | NumberWithUnitCustomFieldDto | SingleSelectCustomFieldDto | MultiSelectCustomFieldDto | FilesCustomFieldDto;
export interface CustomFieldDto_Interface {
    id: number;
    key: string;
    groupId: number;
    subGroup: number;
    order: number;
    startingState: StartingState;
    entities: CustomFieldEntityType[];
    title: string;
    fullTitle?: string | undefined;
    copyValuesOnEntityClone: boolean;
    isCalculated: boolean;
    valueTemplate?: string | undefined;
    allowManualOverride: boolean;
    hierarchyNodeIds: number[];
    type: string;
}

export enum StartingState {
    Fixed = 0,
    Hidden = 1,
}

export enum CustomFieldEntityType {
    Product = 1,
    Article = 2,
    Sku = 4,
    BrandSupplier = 8,
    Component = 16,
    Order = 32,
    OrderDelivery = 64,
    Color = 128,
}

export interface TextCustomFieldDto extends CustomFieldDto_Interface {
    type: 'TextCustomFieldDto';
    isMultiLine: boolean;
    placeholder: string;
}
export function isTextCustomFieldDto(obj?: CustomFieldDto): obj is TextCustomFieldDto {
    return obj?.type === 'TextCustomFieldDto';
}

export interface PhysicalDimensionsCustomFieldDto extends CustomFieldDto_Interface {
    type: 'PhysicalDimensionsCustomFieldDto';
}
export function isPhysicalDimensionsCustomFieldDto(obj?: CustomFieldDto): obj is PhysicalDimensionsCustomFieldDto {
    return obj?.type === 'PhysicalDimensionsCustomFieldDto';
}

export interface MoneyCustomFieldDto extends CustomFieldDto_Interface {
    type: 'MoneyCustomFieldDto';
    currencyIds: number[];
    allowedCurrenciesType: AllowedCurrenciesType;
}
export function isMoneyCustomFieldDto(obj?: CustomFieldDto): obj is MoneyCustomFieldDto {
    return obj?.type === 'MoneyCustomFieldDto';
}

export enum AllowedCurrenciesType {
    AllCurrencies = 0,
    MainCurrencies = 1,
    SpecifiedCurrencies = 2,
}

export interface NumberWithUnitCustomFieldDto extends CustomFieldDto_Interface {
    type: 'NumberWithUnitCustomFieldDto';
    unitIds: number[];
}
export function isNumberWithUnitCustomFieldDto(obj?: CustomFieldDto): obj is NumberWithUnitCustomFieldDto {
    return obj?.type === 'NumberWithUnitCustomFieldDto';
}

export interface SingleSelectCustomFieldDto extends CustomFieldDto_Interface {
    type: 'SingleSelectCustomFieldDto';
    options: SelectCustomFieldOptionDto[];
    sortOrder: CustomFieldOptionsSortOrder;
    canAddOptions: boolean;
    isSearchable: boolean;
    style: SingleSelectStyle;
    optionSourceComponentTagCategoryId?: number | undefined;
}
export function isSingleSelectCustomFieldDto(obj?: CustomFieldDto): obj is SingleSelectCustomFieldDto {
    return obj?.type === 'SingleSelectCustomFieldDto';
}

export interface SelectCustomFieldOptionDto {
    id: number;
    value: string;
    code?: string | undefined;
    color?: string | undefined;
    sourceComponentTagId?: number | undefined;
    iconFileId?: number | undefined;
    iconPath?: string | undefined;
}

export enum CustomFieldOptionsSortOrder {
    Manual = 0,
    Alphabetical = 1,
}

export enum SingleSelectStyle {
    Dropdown = 0,
    Labels = 1,
}

export interface MultiSelectCustomFieldDto extends CustomFieldDto_Interface {
    type: 'MultiSelectCustomFieldDto';
    options: SelectCustomFieldOptionDto[];
    sortOrder: CustomFieldOptionsSortOrder;
    canAddOptions: boolean;
    style: MultiSelectStyle;
    optionSourceComponentTagCategoryId?: number | undefined;
}
export function isMultiSelectCustomFieldDto(obj?: CustomFieldDto): obj is MultiSelectCustomFieldDto {
    return obj?.type === 'MultiSelectCustomFieldDto';
}

export enum MultiSelectStyle {
    Checkboxes = 0,
    Checklist = 1,
    Labels = 2,
    Dropdown = 3,
}

export interface FilesCustomFieldDto extends CustomFieldDto_Interface {
    type: 'FilesCustomFieldDto';
    selectableForSampleRound: boolean;
}
export function isFilesCustomFieldDto(obj?: CustomFieldDto): obj is FilesCustomFieldDto {
    return obj?.type === 'FilesCustomFieldDto';
}

export interface AddCustomFieldSelectOptionArgs {
    value: string;
    code?: string | undefined;
}

export type UpdateCustomFieldResult = UpdateCustomFieldSuccess | UpdateCustomFieldFailure;
export interface UpdateCustomFieldResult_Interface {
    type: string;
}

export interface UpdateCustomFieldSuccess extends UpdateCustomFieldResult_Interface {
    type: 'UpdateCustomFieldSuccess';
    result?: CustomFieldDto | undefined;
}
export function isUpdateCustomFieldSuccess(obj?: UpdateCustomFieldResult): obj is UpdateCustomFieldSuccess {
    return obj?.type === 'UpdateCustomFieldSuccess';
}

export interface UpdateCustomFieldFailure extends UpdateCustomFieldResult_Interface {
    type: 'UpdateCustomFieldFailure';
    usageCount: number;
}
export function isUpdateCustomFieldFailure(obj?: UpdateCustomFieldResult): obj is UpdateCustomFieldFailure {
    return obj?.type === 'UpdateCustomFieldFailure';
}

export interface GetCustomFieldUsageResponse {
    product: number;
    article: number;
    sku: number;
    supplier: number;
    component: number;
    order: number;
    orderDelivery: number;
    color: number;
    shopifyConnections: ShopifyConnectionUsage[];
    usedOn: CustomFieldUsageNames[];
    keyedLookupTables: string[];
}

export interface ShopifyConnectionUsage {
    id: number;
    name: string;
    storesIds: boolean;
    isSyncFlag: boolean;
}

export interface CustomFieldUsageNames {
    entity: CustomFieldEntityType;
    /** The first few of them by name, sorted; the type's count says how many there are in all. */
    names: string[];
}

export interface GetCustomFieldOptionUsageResponse {
    values: CustomFieldEntityUsage[];
    lookupTables: LookupTableOptionUsage[];
}

export interface CustomFieldEntityUsage {
    entity: CustomFieldEntityType;
    count: number;
}

export interface LookupTableOptionUsage {
    lookupTableId: number;
    name: string;
    rows: number;
}

export interface PreviewTemplateResponse {
    rendered: string;
}

export interface PreviewTemplateArgs {
    template: string;
    articleId: number;
    seasonId?: number | undefined;
    subject: TemplateSubjectType;
    skuId?: number | undefined;
}

export enum TemplateSubjectType {
    Product = 0,
    ProductSeason = 1,
    Article = 2,
    ArticleSeason = 3,
    Sku = 4,
    SkuSeason = 5,
    SkuSeasonSupplier = 6,
}

export interface CalculatedValuesArgs {
    mode: CalculatedValuesMode;
    seasonId?: number | undefined;
    entityFamily: CustomFieldEntityFamily;
}

export enum CalculatedValuesMode {
    DryRun = 0,
    UpdateLinkedFlag = 1,
    Recalculate = 2,
}

export enum CustomFieldEntityFamily {
    Product = 0,
    BrandSupplier = 1,
    Component = 2,
    Order = 3,
    Color = 4,
}

export interface CustomFieldGroupDto {
    id: number;
    icon: string;
    title: string;
    entityFamily: CustomFieldEntityFamily;
    defaultEntities: CustomFieldEntityType[];
    seasonalityEnabled: boolean;
    nonUser: boolean;
    hierarchyNodeIds: number[];
}

export interface CreateGroupArgs {
    icon: string;
    title: string;
    entityFamily: CustomFieldEntityFamily;
    defaultEntities: CustomFieldEntityType[];
    seasonalityEnabled: boolean;
    nonUser: boolean;
    hierarchyNodeIds?: number[] | undefined;
}

export interface UpdateGroupArgs {
    icon: string;
    title: string;
    defaultEntities: CustomFieldEntityType[];
    seasonalityEnabled: boolean;
    nonUser: boolean;
    hierarchyNodeIds?: number[] | undefined;
}

export interface MoveFieldArgs {
    fieldId: number;
    order: number;
    subGroup: number;
}

export interface CreateGroupForFieldArgs {
    fieldId: number;
    order: number;
}

export interface ReorderGroupsArgs {
    groupIds: number[];
}

export interface DeliveryTermDto {
    id: number;
    name: string;
    fullName?: string | undefined;
    description?: string | undefined;
}

export interface CreateDeliveryTerm {
    name: string;
}

export interface UpdateDeliveryTerm {
    name: string;
    fullName: string;
    description: string;
}

export interface DeliveryTermUsageDto {
    suppliers: EntityReference[];
    orders: EntityReference[];
}

export interface FileTreeResponse {
    blobBaseUrl: string;
    products: ProductNode[];
    components: ComponentNode[];
    orders: OrderNode[];
    sampleRounds: SampleRoundNode[];
    boms: BomNode[];
    mCharts: MChartNode[];
    colors: ColorNode[];
    generatedAt: string;
}

export interface ProductNode {
    id: number;
    productNumber: string;
    name: string;
    createdAt?: string | undefined;
    groups: string[];
    images: FileEntry[];
    files: FileEntry[];
}

export interface FileEntry {
    id: number;
    filename: string;
    storagePath: string;
    size: number;
    entityType: string;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
}

export interface ComponentNode {
    id: number;
    componentNumber: string;
    name: string;
    createdAt?: string | undefined;
    images: FileEntry[];
    files: FileEntry[];
}

export interface OrderNode {
    id: number;
    orderNumber: string;
    createdAt?: string | undefined;
    files: FileEntry[];
}

export interface SampleRoundNode {
    id: number;
    number: string;
    productNumber: string;
    createdAt?: string | undefined;
    files: FileEntry[];
}

export interface BomNode {
    id: number;
    productNumber: string;
    productName: string;
    createdAt?: string | undefined;
    images: FileEntry[];
}

export interface MChartNode {
    id: number;
    name: string;
    versionId: number;
    versionNumber: number;
    createdAt?: string | undefined;
    images: FileEntry[];
    files: FileEntry[];
    exports: FileEntry[];
    productNumbers: string[];
}

export interface ColorNode {
    id: number;
    number: string;
    name: string;
    createdAt?: string | undefined;
    images: FileEntry[];
    fields: ColorFieldNode[];
}

export interface ColorFieldNode {
    fieldId: number;
    title: string;
    files: FileEntry[];
}

export enum ProductGrouping {
    None = 0,
    HierarchyLevel = 1,
    Season = 2,
}

export interface ProductsFileTreeResponse {
    products: ProductNode[];
    boms: BomNode[];
    generatedAt: string;
}

export interface HierarchyLevelDto {
    id: number;
    name: string;
    type: HierarchyLevelType;
}

export enum HierarchyLevelType {
    PrimaryGroup = 0,
    Primary = 1,
    SecondaryGroup = 2,
    Secondary = 3,
    SubSecondary = 4,
    Hidden = 5,
    Root = -1,
}

export interface CreateFileResponse {
    file: FileEntry;
}

export interface DestinationDto {
    id: number;
    name: string;
    color: string;
    tariffCodeSystemId?: number | undefined;
}

export interface CreateDestinationArgs {
    name: string;
    tariffCodeSystemId?: number | undefined;
    color?: string | undefined;
}

export interface UpdateDestinationArgs {
    name: string;
    tariffCodeSystemId?: number | undefined;
    color: string;
}

export interface DestinationUsageDto {
    inPriceValuesCount: number;
    freightCount: number;
    vatCount: number;
    deliveryLocationCount: number;
}

export interface DropDto {
    id: number;
    dropDate: string;
    granularity: DropGranularity;
    dropGroupId?: number | undefined;
    name?: string | undefined;
}

export interface DropGroupDto {
    id: number;
    name: string;
}

export interface AddDropGroupData {
    name: string;
}

export interface ExcelTemplateDto {
    kind: string;
    exists: boolean;
}

export interface CreateFromPathArgs {
    name: string;
    path: string;
}

export interface UpdateNameArgs {
    name: string;
}

export interface FreightDto {
    id: number;
    countryId: number;
    seasonId?: number | undefined;
    modeOfTransportId: number;
    hierarchyNodeId: number;
    destinationId: number;
    rate?: number | undefined;
    amount?: number | undefined;
    currencyId?: number | undefined;
}

export interface SetFreightArgs {
    countryId: number;
    seasonId?: number | undefined;
    modeOfTransportId: number;
    hierarchyNodeId: number;
    destinationId: number;
    /** Which of the two shapes the caller is writing. A row can hold a percentage and a flat charge
at once (the season's InPriceConfig.FreightType picks which one is read), so a null value
clears only the field named here and leaves the other one alone. The row is deleted once
neither is set. */
    type: FreightType;
    rate?: number | undefined;
    amount?: number | undefined;
    currencyId?: number | undefined;
}

export enum FreightType {
    Percentage = 0,
    Charge = 1,
}

export interface SetFreightsBulkArgs {
    seasonId?: number | undefined;
    modeOfTransportId: number;
    destinationId: number;
    type: FreightType;
    rate?: number | undefined;
    amount?: number | undefined;
    currencyId?: number | undefined;
    cells: SetFreightsBulkCell[];
}

export interface SetFreightsBulkCell {
    hierarchyNodeId: number;
    countryId: number;
    /** False leaves the cell untouched. True with a null value clears it. Without this flag
the two cannot be told apart, because null already means "clear the freight". */
    hasValue: boolean;
    rate?: number | undefined;
    amount?: number | undefined;
    currencyId?: number | undefined;
}

export interface AddHierarchyLevelArgs {
    index: number;
    name: string;
    type: HierarchyLevelType;
}

export interface UpdateHierarchyLevelArgs {
    name: string;
    type: HierarchyLevelType;
}

export interface HierarchyNodeDto {
    id: number;
    parentId?: number | undefined;
    levelId: number;
    name: string;
    fullName?: string | undefined;
    icon?: string | undefined;
    productPlaceholderImage?: HierarchyNodeProductPlaceholderImageDto | undefined;
    articleNumberCode?: string | undefined;
    externalCode?: string | undefined;
    description?: string | undefined;
    productCategoryDisplayName?: string | undefined;
    mChartShortName?: string | undefined;
    mChartLongName?: string | undefined;
    defaultUnitId?: number | undefined;
    setUnitAutomatically?: boolean | undefined;
    defaultGenders?: Gender[] | undefined;
    setGendersAutomatically?: boolean | undefined;
    defaultSizeSystemId?: number | undefined;
    setSizeSystemAutomatically?: boolean | undefined;
    sizeSystemIds: number[];
    tagCategoryIds: number[];
    customFieldGroupIds: number[];
    productCategoryIds: number[];
    defaultBomTemplateName?: string | undefined;
    roleAssignments: HierarchyNodeRoleAssignmentDto[];
}

export interface HierarchyNodeProductPlaceholderImageDto {
    path: string;
    name: string;
    size: number;
    width: number;
    height: number;
}

export interface HierarchyNodeRoleAssignmentDto {
    roleId: number;
    userId?: string | undefined;
}

export interface AddHierarchyNodeArgs {
    parentId: number;
    name: string;
    fullName?: string | undefined;
    icon?: string | undefined;
    productPlaceholderImage?: HierarchyNodeProductPlaceholderImageDto | undefined;
    articleNumberCode?: string | undefined;
    externalCode?: string | undefined;
    description?: string | undefined;
    productCategoryDisplayName?: string | undefined;
    mChartShortName?: string | undefined;
    mChartLongName?: string | undefined;
    defaultUnitId?: number | undefined;
    setUnitAutomatically?: boolean | undefined;
    defaultGenders?: Gender[] | undefined;
    setGendersAutomatically?: boolean | undefined;
    defaultSizeSystemId?: number | undefined;
    setSizeSystemAutomatically?: boolean | undefined;
    sizeSystemIds: number[];
    tagCategoryIds: number[];
    customFieldGroupIds: number[];
    productCategoryIds: number[];
}

export interface UpdateHierarchyNodeArgs {
    name: string;
    fullName?: string | undefined;
    icon?: string | undefined;
    productPlaceholderImage?: HierarchyNodeProductPlaceholderImageDto | undefined;
    articleNumberCode?: string | undefined;
    externalCode?: string | undefined;
    description?: string | undefined;
    productCategoryDisplayName?: string | undefined;
    mChartShortName?: string | undefined;
    mChartLongName?: string | undefined;
    defaultUnitId?: number | undefined;
    setUnitAutomatically?: boolean | undefined;
    defaultGenders?: Gender[] | undefined;
    setGendersAutomatically?: boolean | undefined;
    defaultSizeSystemId?: number | undefined;
    setSizeSystemAutomatically?: boolean | undefined;
    sizeSystemIds: number[];
    tagCategoryIds: number[];
    customFieldGroupIds: number[];
    productCategoryIds: number[];
}

export interface SetNodeRoleAssignmentsArgs {
    assignments: SetNodeRoleAssignmentArgs[];
}

export interface SetNodeRoleAssignmentArgs {
    roleId: number;
    userId?: string | undefined;
}

export interface ArticleHistoryEntryDto {
    changedAt: string;
    userId?: string | undefined;
    email?: string | undefined;
    requestId?: string | undefined;
    changes: EntityChangeDto[];
    origin?: ApiKeyOriginDto | undefined;
}

export interface EntityChangeDto {
    entityType: string;
    entityId: number;
    kind: EntityChangeKind;
    fields: FieldChangeDto[];
    meta?: { [key: string]: string; } | undefined;
    atIsReconstructed: boolean;
}

export enum EntityChangeKind {
    Created = 0,
    Updated = 1,
    Deleted = 2,
}

export interface FieldChangeDto {
    field: string;
    before?: string | undefined;
    after?: string | undefined;
}

export interface ApiKeyOriginDto {
    type: ApiKeyType;
    keyName: string;
}

export interface ArticleSearchHitDto {
    id: number;
    articleNumber: string;
    productName?: string | undefined;
    color?: ColorDtoMinimal | undefined;
    statusId: number;
}

export interface InPriceConfigDto {
    id: number;
    seasonId?: number | undefined;
    destinationId: number;
    useFreight: boolean;
    useDuties: boolean;
    copyCostPriceFromDefault: boolean;
    freightType: FreightType;
    landedCostCurrencyMode: LandedCostCurrencyMode;
    landedCostCurrencyId?: number | undefined;
    steps: InPriceStepDto[];
}

export enum LandedCostCurrencyMode {
    InheritFromCostPrice = 0,
    Explicit = 1,
}

export type InPriceStepDto = PercentageInPriceStepDto | ChargeInPriceStepDto;
export interface InPriceStepDto_Interface {
    id: number;
    key: string;
    name: string;
    stage: InPriceStepStage;
    inPriceConfigId: number;
    calculationTemplate?: string | undefined;
    type: string;
}

export enum InPriceStepStage {
    PreFreight = 0,
    PreDuties = 1,
    PreLandedCost = 2,
}

export interface PercentageInPriceStepDto extends InPriceStepDto_Interface {
    type: 'PercentageInPriceStepDto';
    defaultPercentage?: number | undefined;
}
export function isPercentageInPriceStepDto(obj?: InPriceStepDto): obj is PercentageInPriceStepDto {
    return obj?.type === 'PercentageInPriceStepDto';
}

export interface ChargeInPriceStepDto extends InPriceStepDto_Interface {
    type: 'ChargeInPriceStepDto';
    defaultCurrencyId?: number | undefined;
    defaultAmount?: number | undefined;
}
export function isChargeInPriceStepDto(obj?: InPriceStepDto): obj is ChargeInPriceStepDto {
    return obj?.type === 'ChargeInPriceStepDto';
}

export interface CreateInPriceConfigArgs {
    seasonId?: number | undefined;
    destinationId: number;
}

export interface InPriceStepUsageDto {
    productsWithManualValues: EntityReference[];
    productsWithOnlyLinkedValues: number;
}

export interface UpdateInPriceConfigArgs {
    useFreight: boolean;
    useDuties: boolean;
    copyCostPriceFromDefault: boolean;
    freightType: FreightType;
    landedCostCurrencyMode: LandedCostCurrencyMode;
    landedCostCurrencyId?: number | undefined;
    steps: InPriceStepDto[];
}

export interface IntercomJwtResponse {
    jwt?: string | undefined;
}

export enum LookupExportMode {
    ExistingRows = 0,
    AllPossibleRows = 1,
}

export interface ExportLookupTableArgs {
    resultSets: LookupExportResultSet[];
}

export interface LookupExportResultSet {
    seasonGroupId?: number | undefined;
    hierarchyNodeIds: number[];
}

export interface LookupTableDto {
    id: number;
    key: string;
    name: string;
    description?: string | undefined;
    subjectEntityType: LookupSubjectEntityType;
    keyColumns: LookupTableKeyColumnDto[];
    outputColumns: LookupTableOutputColumnDto[];
    rows: LookupTableRowDto[];
    seasonGroups: LookupTableSeasonGroupDto[];
}

export enum LookupSubjectEntityType {
    SkuSeasonSupplier = 0,
    Sku = 1,
    Article = 2,
    Product = 3,
}

export interface LookupTableKeyColumnDto {
    id: number;
    order: number;
    dimensionKey: string;
    tagCategoryId?: number | undefined;
    sizeSystemVersionIds: number[];
    includeUnisex: boolean;
    customFieldId?: number | undefined;
    tariffCodeSystemId?: number | undefined;
    tariffCodeIds: number[];
}

export interface LookupTableOutputColumnDto {
    id: number;
    key: string;
    name: string;
    order: number;
    valueType: LookupValueType;
    currencyMode: LookupCurrencyMode;
    currencyId?: number | undefined;
    unitMode: LookupUnitMode;
    unitIds: number[];
}

export enum LookupValueType {
    Money = 0,
    Number = 1,
    Text = 2,
    Boolean = 3,
    NumberWithUnit = 4,
}

export enum LookupCurrencyMode {
    SingleCurrency = 0,
    AnyCurrency = 1,
}

export enum LookupUnitMode {
    SingleUnit = 0,
    AnyUnit = 1,
}

export interface LookupTableRowDto {
    id: number;
    seasonGroupId?: number | undefined;
    keyCells: LookupTableKeyCellDto[];
    valueCells: LookupTableValueCellDto[];
}

export interface LookupTableKeyCellDto {
    id: number;
    keyColumnId: number;
    hierarchyNodeId?: number | undefined;
    tagId?: number | undefined;
    sizeSystemVersionSizeId?: number | undefined;
    genders?: GenderFlag | undefined;
    selectCustomFieldOptionId?: number | undefined;
    tariffCodeId?: number | undefined;
    stringValue?: string | undefined;
}

export enum GenderFlag {
    None = 0,
    Men = 1,
    Women = 2,
    Kids = 4,
    Babies = 8,
}

export interface LookupTableValueCellDto {
    id: number;
    outputColumnId: number;
    amount?: number | undefined;
    stringValue?: string | undefined;
    boolValue?: boolean | undefined;
    currencyId?: number | undefined;
    unitId?: number | undefined;
}

export interface LookupTableSeasonGroupDto {
    id: number;
    seasonIds: number[];
}

export interface LookupConsumerDto {
    name: string;
    scopes: string[];
    implemented: boolean;
}

export interface SetLookupValuesArgs {
    /** The cell values to write. Null or empty means no writes. */
    cells?: LookupValueWrite[] | undefined;
}

export interface LookupValueWrite {
    seasonGroupId?: number | undefined;
    keys: LookupValueKeyRef[];
    outputColumnId: number;
    amount?: number | undefined;
    stringValue?: string | undefined;
    boolValue?: boolean | undefined;
    currencyId?: number | undefined;
    unitId?: number | undefined;
}

export interface LookupValueKeyRef {
    keyColumnId: number;
    hierarchyNodeId?: number | undefined;
    tagId?: number | undefined;
    sizeSystemVersionSizeId?: number | undefined;
    genders?: GenderFlag | undefined;
    selectCustomFieldOptionId?: number | undefined;
    tariffCodeId?: number | undefined;
}

export interface CreateSeasonGroupArgs {
    /** The seasons the new group covers. At least one — a group is its season set. */
    seasonIds: number[];
}

export interface SetSeasonGroupSeasonsArgs {
    /** The group's complete season set after the change. A season another group owns is refused, not taken:
moving one is a change to that group as well, so it is asked in its own request. */
    seasonIds: number[];
}

export interface SplitSeasonGroupArgs {
    /** The seasons staying in the group being split. */
    keepSeasonIds: number[];
    /** The seasons leaving it for the new group. */
    newGroupSeasonIds: number[];
}

export interface UpdateLookupTableDetailsArgs {
    name: string;
    key: string;
    description?: string | undefined;
}

export interface LookupUsageDto {
    kind: string;
    name: string;
}

export interface SearchMChartsResult {
    mCharts: MChartListItemDto[];
    totalCount: number;
}

export interface MChartListItemDto {
    id: number;
    name: string;
    referenceNumber?: string | undefined;
    latestVersionStatusId: number;
    genders: Gender[];
    sizeSystemVersionId: number;
    sizeSystemVersionSizeIds: number[];
    modelSizeSystemVersionSizeId?: number | undefined;
    tagIds: number[];
    image?: ImageDto | undefined;
    productNames: string[];
    createdAt?: string | undefined;
    comment: string;
    files: MChartDtoFile[];
    hasSampleRoundReports: boolean;
}

export interface ImageDto {
    width: number;
    height: number;
    url: string;
}

export interface MChartDtoFile {
    id: number;
    filename: string;
    path: string;
    uploadedAt: string;
    size: number;
}

export interface SearchMChartsArgs {
    searchText?: string | undefined;
    sizeSystemVersionId?: number | undefined;
    statusIds?: number[] | undefined;
    tagIds?: number[] | undefined;
    sizeSystemIds?: number[] | undefined;
    genders?: Gender[] | undefined;
    seasonIds?: number[] | undefined;
    hierarchyNodeIds?: number[] | undefined;
    productCategoryIds?: number[] | undefined;
    createdByUserIds?: string[] | undefined;
    startIndex: number;
    items: number;
}

export interface MChartDto {
    id: number;
    name: string;
    referenceNumber?: string | undefined;
    latestVersionStatusId: number;
    genders: Gender[];
    sizeSystemVersionId: number;
    sizeSystemVersionSizeIds: number[];
    modelSizeSystemVersionSizeId?: number | undefined;
    tagIds: number[];
    image?: ImageDto | undefined;
    products: MChartProductDto[];
    sections: MChartSectionDto[];
    measurements: MChartMeasurementDto[];
    versions: MChartVersionDto[];
    exports: MChartExportDto[];
}

export interface MChartProductDto {
    id: number;
    name: string;
}

export interface MChartSectionDto {
    id: number;
    name?: string | undefined;
}

export interface MChartMeasurementDto {
    measurementId: number;
    tolerance: MeasurementToleranceDto;
    sectionId: number;
}

export interface MeasurementToleranceDto {
    upperValue: number;
    lowerValue: number;
    unitId: number;
}

export interface MChartVersionDto {
    versionNumber: number;
    name: string;
    comment: string;
    statusId: number;
    createdAt: string;
    measurementValues: { [key: string]: { [key: string]: number; }; };
    files: MChartDtoFile[];
    images: MChartImageDto[];
    measurementComments: { [key: string]: string; };
    reports: MChartVersionReportDto[];
    reportComments: MChartReportCommentDto[];
    reportImages: MChartReportImageDto[];
}

export interface MChartImageDto {
    id: number;
    name: string;
    path: string;
    size: number;
    width: number;
    height: number;
    annotations: AnnotationItem[];
}

export interface MChartVersionReportDto {
    id: number;
    type: MChartReportType;
    sampleRoundId?: number | undefined;
    sampleRoundNumber: string;
    supplierId: number;
    sampleSizeSystemVersionSizeId: number;
    values: { [key: string]: number; };
}

export enum MChartReportType {
    Supplier = 0,
    Brand = 1,
}

export interface MChartReportCommentDto {
    comment: string;
    sampleRoundNumber: string;
    sampleRoundId: number;
    supplierId: number;
    postedAt: string;
}

export interface MChartReportImageDto {
    id: number;
    name: string;
    path: string;
    size: number;
    width: number;
    height: number;
    annotations: AnnotationItem[];
    supplierId: number;
    sampleRoundNumber: string;
    sampleRoundId: number;
    postedAt: string;
}

export interface MChartExportDto {
    id: number;
    versionNumber?: number | undefined;
    supplierId?: number | undefined;
    includeReports: boolean;
    file: AzureBlobFileDto;
}

export interface AddMChartArgs {
    name: string;
    referenceNumber?: string | undefined;
    genders: Gender[];
    sizeSystemVersionId: number;
    sizeSystemVersionSizeIds: number[];
    modelSizeSystemVersionSizeId?: number | undefined;
    tagIds: number[];
    sections: UpdateArgSection[];
    measurements: UpdateArgMeasurement[];
    versions: UpdateArgVersion[];
}

export interface UpdateArgSection {
    id?: number | undefined;
    name?: string | undefined;
}

export interface UpdateArgMeasurement {
    measurementId: number;
    tolerance: MeasurementToleranceDto;
    sectionIndex: number;
}

export interface UpdateArgVersion {
    versionNumber: number;
    name: string;
    comment: string;
    statusId: number;
    measurementValues: { [key: string]: { [key: string]: number; }; };
    files: UpdateArgFile[];
    images: UpdateArgImage[];
    measurementComments: { [key: string]: string; };
}

export interface UpdateArgFile {
    id?: number | undefined;
    filename: string;
    path: string;
    size: number;
}

export interface UpdateArgImage {
    id?: number | undefined;
    name: string;
    path: string;
    size: number;
    width: number;
    height: number;
    annotations: AnnotationItem[];
}

export interface UpdateMChartArgs2 {
    name: string;
    referenceNumber?: string | undefined;
    genders: Gender[];
    sizeSystemVersionId: number;
    sizeSystemVersionSizeIds: number[];
    modelSizeSystemVersionSizeId?: number | undefined;
    tagIds: number[];
    sections: UpdateArgSection[];
    measurements: UpdateArgMeasurement[];
    versions: UpdateArgVersion[];
}

export interface MChartStatusDto {
    id: number;
    name: string;
    color: string;
}

export interface CreateMChartStatusArgs {
    name: string;
    color: string;
}

export interface UpdateMChartStatusArgs {
    name: string;
    color: string;
}

export interface MChartStatusUsageDto {
    measurementCharts: EntityReference[];
}

export interface MChartTagCategoryDto {
    id: number;
    name: string;
    tags: MChartTagDto[];
}

export interface MChartTagDto {
    id: number;
    name: string;
    color: string;
    tagCategoryId: number;
}

export interface CreateTagCategoryArgs {
    name: string;
}

export interface UpdateTagCategoryArgs {
    name: string;
}

export interface AddTagArgs2 {
    name: string;
    color: string;
    tagCategoryId: number;
}

export interface UpdateTagArgs2 {
    name: string;
    color: string;
}

export interface MeasurementDto {
    id: number;
    annotationName: string;
    image?: string | undefined;
    name: string;
    howToTitle: string;
    howToDescription: string;
    tolerance: MeasurementToleranceDto;
    gradings: MeasurementGradingDto[];
}

export interface MeasurementGradingDto {
    id: number;
    sizeSystemVersionSizeId: number;
    genders: GenderFlag;
    gradingValue: number;
}

export interface CreateMeasurementArgs {
    annotationName: string;
    image?: string | undefined;
    name: string;
    howToTitle?: string | undefined;
    howToDescription?: string | undefined;
    tolerance: MeasurementToleranceDto;
}

export interface UpdateMeasurementArgs {
    annotationName: string;
    image?: string | undefined;
    name: string;
    howToTitle?: string | undefined;
    howToDescription?: string | undefined;
    tolerance: MeasurementToleranceDto;
}

export interface UpdateMeasurementGradingsArgs {
    gradingsBySizeAndGender: { [key: string]: { [key in keyof typeof GenderFlag]?: number; }; };
}

export interface MeasurementStatusDto {
    id: number;
    name: string;
    color: string;
    excludeFromDefaultFiltering: boolean;
    sampleRoundTypeIds: number[];
}

export interface CreateMeasurementStatusArgs {
    name: string;
    color: string;
    excludeFromDefaultFiltering: boolean;
    sampleRoundTypeIds?: number[] | undefined;
}

export interface UpdateMeasurementStatusArgs {
    name: string;
    color: string;
    excludeFromDefaultFiltering: boolean;
    sampleRoundTypeIds?: number[] | undefined;
}

export interface MeasurementStatusUsageDto {
    sampleRounds: EntityReference[];
}

export interface ModeOfTransportDto {
    id: number;
    name: string;
    icon: string;
}

export interface CreateModeOfTransport {
    name: string;
    icon: string;
}

export interface UpdateModeOfTransport {
    name: string;
    icon: string;
}

export interface ModeOfTransportUsageDto {
    suppliers: EntityReference[];
    orders: EntityReference[];
}

export interface PostNotificationArgs {
    header: string;
    message: string;
    type: NotificationType;
    actions: PostNotificationArgsAction[];
    userIds: string[];
}

export enum NotificationType {
    Neutral = 0,
    Progress = 1,
    Warning = 2,
    Success = 3,
    Error = 4,
}

export interface PostNotificationArgsAction {
    text: string;
    link: string;
}

export interface NotificationDto {
    id: number;
    createdAt: string;
    status: NotificationStatus;
    header?: string | undefined;
    message?: string | undefined;
    type: NotificationType;
    replacingId?: number | undefined;
    actions?: NotificationActionDto[] | undefined;
}

export enum NotificationStatus {
    Unread = 0,
    Read = 1,
    Dismissed = 2,
}

export interface NotificationActionDto {
    id: number;
    notificationId: number;
    type: NotificationActionType;
    text?: string | undefined;
    link?: string | undefined;
}

export enum NotificationActionType {
    None = 0,
    Button = 1,
    DownloadLink = 2,
    DownloadLinkApiEndpoint = 3,
    NewTabLink = 4,
}

export interface SyncItemTaskArgs {
    itemId: string;
    title: string;
    description?: string | undefined;
    contextUrl?: string | undefined;
    contextLabel?: string | undefined;
    responsibleUserId?: string | undefined;
    deadline?: string | undefined;
    completed: boolean;
    removed: boolean;
}

export interface OrderDeliveryDto {
    id: number;
    orderId: number;
    orderNumber: string;
    deliveryNumber: string;
    number: number;
    externalDeliveryNumber?: string | undefined;
    statusId: number;
    linked: boolean;
    locked: boolean;
    products: OrderProductDto[];
    supplierId?: number | undefined;
    seasonIds: number[];
    tagIds: number[];
    typeId?: number | undefined;
    type?: string | undefined;
    modeOfTransportId?: number | undefined;
    quantity?: number | undefined;
    currencyId?: number | undefined;
    placement: OrderDatePairDto;
    shipment: OrderDatePairDto;
    arrival: OrderDatePairDto;
    files: OrderDeliveryFileDto[];
    comment: string;
    customValues: { [key: string]: CustomFieldValueDto; };
    orderCustomValues: { [key: string]: CustomFieldValueDto; };
    order: OrderDeliveryDtoOrder;
}

export interface OrderProductDto {
    id: number;
    name?: string | undefined;
    hierarchyNodeId?: number | undefined;
    imagePath?: string | undefined;
    quantity?: number | undefined;
    supplierIds: number[];
    articles: OrderArticleDto[];
}

export interface OrderArticleDto {
    id: number;
    articleNumber?: string | undefined;
    color?: ColorSuperSimple | undefined;
    quantity?: number | undefined;
    imagePath?: string | undefined;
    skuQuantities: OrderSkuQuantityDto[];
}

export interface OrderSkuQuantityDto {
    skuId: number;
    sizeId: number;
    sizeValue: string;
    quantity?: number | undefined;
    unitPrice?: number | undefined;
    currencyId?: number | undefined;
}

export interface OrderDatePairDto {
    planned?: string | undefined;
    actual?: string | undefined;
}

export interface OrderDeliveryFileDto {
    id: number;
    filename: string;
    path: string;
    size: number;
    uploadedAt: string;
}

export interface OrderDeliveryDtoOrder {
    orderNumber: string;
    number: number;
    externalOrderNumber?: string | undefined;
    comment: string;
    locked: boolean;
}

export interface UpdateModeOfTransportArgs {
    modeOfTransportId?: number | undefined;
}

export interface UpdateStatusArgs2 {
    statusId: number;
}

export interface UpdateSupplierArgs2 {
    supplierId: number;
}

export interface UpdateDatePairArgs {
    planned?: string | undefined;
    actual?: string | undefined;
}

export interface OrderArticleTableDto {
    articleId: number;
    productId: number;
    sizeSystemVersionId?: number | undefined;
    sizeSystemName?: string | undefined;
    genders: number;
    seasonalities: OrderArticleTableSeasonalityDto[];
    skus: OrderArticleTableSkuDto[];
    costPriceCurrencyId?: number | undefined;
}

export interface OrderArticleTableSeasonalityDto {
    seasonId?: number | undefined;
    principalMaterialId?: number | undefined;
}

export interface OrderArticleTableSkuDto {
    skuId: number;
    sizeId: number;
    ssvSizeId: number;
    sizeValue: string;
    sizeOrder: number;
}

export interface SetProductQuantityArgs {
    productId: number;
    quantity?: number | undefined;
}

export interface UpdateQuantityArgs {
    total?: number | undefined;
    linked: boolean;
    rows: UpdateRowQuantityArgs[];
}

export interface UpdateRowQuantityArgs {
    articleId: number;
    quantity?: number | undefined;
    skus?: SkuQuantityRow[] | undefined;
}

export interface SkuQuantityRow {
    skuId: number;
    quantity?: number | undefined;
}

export interface SetSkuPriceArgs {
    skuId?: number | undefined;
    articleId?: number | undefined;
    productId?: number | undefined;
    unitPrice?: number | undefined;
    currencyId?: number | undefined;
}

export interface UpdateCurrencyArgs {
    currencyId?: number | undefined;
    priceMode: OrderSkuPriceMode;
}

export enum OrderSkuPriceMode {
    Keep = 0,
    Switch = 1,
    Convert = 2,
}

export interface UpdateFilesArgs2 {
    files: UpdateFilesArgsFile2[];
}

export interface UpdateFilesArgsFile2 {
    id?: number | undefined;
    filename: string;
    path: string;
    size: number;
}

export interface AddFilesArgs {
    files: AddFilesArgsFile[];
}

export interface AddFilesArgsFile {
    filename: string;
    path: string;
    size: number;
}

export interface UpdateCommentArgs2 {
    comment: string;
}

export interface UpdateExternalNumbersArgs {
    externalOrderNumber?: string | undefined;
    externalDeliveryNumber?: string | undefined;
}

export interface UpdateOrderTextCustomFieldArgs {
    deliveryIds: number[];
    entityType: CustomFieldEntityType;
    value?: string | undefined;
}

export interface UpdateOrderMoneyCustomFieldArgs {
    deliveryIds: number[];
    entityType: CustomFieldEntityType;
    amountValue?: AmountValue | undefined;
    currencyId?: number | undefined;
}

export interface UpdateOrderNumberWithUnitCustomFieldArgs {
    deliveryIds: number[];
    entityType: CustomFieldEntityType;
    numberValue?: NumberValue | undefined;
    unitId?: number | undefined;
}

export interface UpdateOrderSingleSelectCustomFieldArgs {
    deliveryIds: number[];
    entityType: CustomFieldEntityType;
    addedOptionId?: number | undefined;
    removedOptionIds: number[];
    clear: boolean;
}

export interface UpdateOrderMultiSelectCustomFieldArgs {
    deliveryIds: number[];
    entityType: CustomFieldEntityType;
    addedOptionIds: number[];
    removedOptionIds: number[];
    clear: boolean;
}

export interface UpdateOrderFilesCustomFieldArgs {
    deliveryIds: number[];
    entityType: CustomFieldEntityType;
    addFiles: CustomFieldFile[];
    removeFiles: CustomFieldFile[];
}

export interface RelinkOrderCustomFieldArgs {
    deliveryIds: number[];
    entityType: CustomFieldEntityType;
}

export interface StartExcelExportOrdersArgs {
    deliveryIds: number[];
    filters: OrderFilters;
    activeSeasonId?: number | undefined;
}

export interface OrderFilters {
    supplierIds?: number[] | undefined;
    seasonIds?: number[] | undefined;
    tagIds?: number[] | undefined;
    statusIds?: number[] | undefined;
    hierarchyNodeIds?: number[] | undefined;
    productCategoryIds?: number[] | undefined;
    customFieldOptionIds?: number[] | undefined;
    searchTerm?: string | undefined;
}

export interface OrderStatusDto {
    id: number;
    name: string;
    color: string;
    state: OrderState;
    excludeFromDefaultFiltering: boolean;
}

export enum OrderState {
    Planned = "Planned",
    Placed = "Placed",
    Shipped = "Shipped",
    Arrived = "Arrived",
}

export interface AddOrderStatusArgs {
    name: string;
    color: string;
    state: OrderState;
    excludeFromDefaultFiltering: boolean;
}

export interface UpdateOrderStatusArgs {
    name: string;
    color: string;
    excludeFromDefaultFiltering: boolean;
}

export interface OrderStatusUsageDto {
    orders: EntityReference[];
}

export interface OrderTagCategoryDto {
    id: number;
    name: string;
    uniqueness: OrderTagCategoryUniqueness;
    tags: OrderTagDto[];
}

export enum OrderTagCategoryUniqueness {
    None = 0,
    Order = 1,
    OrderDelivery = 2,
}

export interface OrderTagDto {
    id: number;
    name: string;
    color: string;
    tagCategoryId: number;
}

export interface AddOrderTagCategoryArgs {
    name: string;
    uniqueness: OrderTagCategoryUniqueness;
}

export interface UpdateOrderTagCategoryArgs {
    name?: string | undefined;
    uniqueness: OrderTagCategoryUniqueness;
}

export interface AddOrderTagArgs {
    name: string;
    color: string;
    tagCategoryId: number;
}

export interface UpdateOrderTagArgs {
    color?: string | undefined;
    name?: string | undefined;
}

export interface OrderTypeSimple {
    id: number;
    name: string;
}

export interface AddOrderTypeArgs {
    name: string;
}

export interface OrderTypeUsageDto {
    orders: EntityReference[];
}

export interface OutPriceConfigDto {
    id: number;
    seasonId?: number | undefined;
    destinationId: number;
    outPrices: OutPriceDto[];
}

export interface OutPriceDto {
    id: number;
    name: string;
    key: string;
    currencyId: number;
    order?: number | undefined;
    visibleByDefault: boolean;
    calculationTemplate?: string | undefined;
    preferMarkup: boolean;
    excludeVatFromMarkupCalculation: boolean;
}

export interface OutPriceUsageDto {
    articles: EntityReference[];
    referencedInTemplates: EntityReference[];
}

export interface UpdateOutPriceConfigArgs {
    outPrices: OutPriceArgs[];
}

export interface OutPriceArgs {
    id?: number | undefined;
    name: string;
    key: string;
    currencyId: number;
    visibleByDefault?: boolean | undefined;
    calculationTemplate?: string | undefined;
    preferMarkup: boolean;
    excludeVatFromMarkupCalculation: boolean;
}

export interface GetBucketsReturn {
    buckets?: BucketWithoutArticles[] | undefined;
    centerBucketKey?: any | undefined;
    forwardEnd: boolean;
    backwardsEnd: boolean;
}

export interface BucketWithoutArticles {
    label?: any | undefined;
    key?: any | undefined;
}

export enum Grouping {
    InboundDate = 0,
    Product = 1,
    Status = 2,
    Tag = 3,
    Season = 4,
    Drop = 5,
}

export interface GetFilteredBucketsReturn {
    buckets?: BucketWithoutArticles[] | undefined;
    centerBucketKey?: any | undefined;
    backwardsEnd: boolean;
    forwardEnd: boolean;
}

export interface BucketWithArticles {
    key?: any | undefined;
    articles?: ArticleCardDto[] | undefined;
    totalNumberOfArticles: number;
    totalNumberOfArticlesPerNode?: { [key: string]: number; } | undefined;
}

export interface ArticleCardDto {
    id: number;
    articleNumber: string;
    productName: string;
    productId: number;
    hierarchyNodeId?: number | undefined;
    statusId: number;
    color: ColorSuperSimple;
    principalMaterialIds: number[];
    genders: Gender[];
    tagIds: number[];
    productTagIds: number[];
    seasonIds: number[];
    image?: string | undefined;
    imageFallback?: string | undefined;
    mainOutPrice?: PriceRangeDto | undefined;
    orders: ArticleOrder[];
}

export interface PriceRangeDto {
    minAmount: number;
    maxAmount: number;
    currencyId: number;
}

export interface ArticleOrder {
    type?: string | undefined;
    quantity?: number | undefined;
    statusId: number;
}

export enum Sorting {
    ArticleNumber = 0,
    ColorGroup = 1,
    ColorName = 2,
    ColorCode = 3,
    ColorPalette = 4,
    Comment = 5,
    Created = 6,
    Description = 7,
    Gender = 8,
    Images = 9,
    PrincipalMaterialType = 14,
    ProductName = 15,
    Status = 16,
    Type = 17,
    ProductCategory = 18,
    SupplierName = 20,
    Seasons = 21,
    Drops = 22,
    Tags = 23,
    TextCustomField = 24,
    SingleSelectCustomField = 25,
    MoneyCustomField = 26,
    NumberWithUnitCustomField = 27,
    CountryOfOrigin = 28,
    Size = 29,
    TimelineHealth = 30,
    CostPrice = 31,
    Freight = 32,
    Duties = 33,
    LandedCost = 34,
    InPriceStep = 35,
    OutPrice = 36,
    Markup = 37,
    Margin = 38,
    GrossWeight = 39,
    NetWeight = 40,
}

export interface GetUndefinedArticlesReturn {
    articles?: ArticleCardDto[] | undefined;
    total: number;
}

export interface GetProductAndArticlesResponse {
    products?: GetProductAndArticlesResponseProduct[] | undefined;
    total: number;
}

export interface GetProductAndArticlesResponseProduct {
    productName?: string | undefined;
    productId: number;
    productImageUrl?: string | undefined;
    tagIds?: number[] | undefined;
    articlesCount: number;
    articles?: GetProductAndArticlesResponseArticle[] | undefined;
}

export interface GetProductAndArticlesResponseArticle {
    articleNumber?: string | undefined;
    id: number;
    productName?: string | undefined;
    tagIds?: number[] | undefined;
    imageUrl?: string | undefined;
    color?: ColorSuperSimple | undefined;
    genders?: Gender[] | undefined;
    principalMaterialIds?: number[] | undefined;
    hierarchyNodeId: number;
    inBucket: boolean;
}

export interface AddArticlesToBucketInboundDateResponse {
    updatedArticles?: number[] | undefined;
    noNeedToResolveArticles?: number[] | undefined;
    productsWithArticlesAndPlans?: AddArticlesToBucketProductWithArticlesAndPlansResponse[] | undefined;
}

export interface AddArticlesToBucketProductWithArticlesAndPlansResponse {
    productName?: string | undefined;
    productId: number;
    hierarchyNodeId: number;
    articles?: AddArticlesToBucketResponseArticle[] | undefined;
    plans?: AddArticlesToBucketResponsePlan[] | undefined;
}

export interface AddArticlesToBucketResponseArticle {
    articleNumber?: string | undefined;
    id: number;
    productName?: string | undefined;
    tagIds?: number[] | undefined;
    imageUrl?: string | undefined;
    color?: ColorSuperSimple | undefined;
    genders?: Gender[] | undefined;
    principalMaterialIds?: number[] | undefined;
    hierarchyNodeId: number;
}

export interface AddArticlesToBucketResponsePlan {
    id: number;
    inboundDate?: string | undefined;
    type?: OrderTypeSimple | undefined;
    quantity?: number | undefined;
    supplierId?: number | undefined;
}

export interface AddArticlesToBucketArgs {
    removeFromBucketKey?: string | undefined;
    bucketKey?: string | undefined;
    articleIds?: number[] | undefined;
    activeSeasonId?: number | undefined;
}

export interface RemoveArticlesFromBucketArgs {
    bucketKey: string;
    articleIds: number[];
}

export interface TableArticles {
    before: number;
    articles: TableArticleDto[];
    after: number;
    newReferenceIndex: number;
}

export interface TableArticleDto {
    id: number;
    articleNumber: string;
    developmentNumber?: string | undefined;
    createdAt: string;
    createdBy?: UserDto | undefined;
    product: TableProductDto;
    principalComponent?: TableComponentDto | undefined;
    productCategoryId?: number | undefined;
    statusId: number;
    color: ColorDto;
    genders: Gender[];
    skus: TableSkuDto[];
    comment: string;
    description: string;
    tagIds: number[];
    seasonIds: number[];
    dropIds: number[];
    images: ArticleDtoImage[];
    supplierIds: number[];
    tariffCodeIds: number[];
    weight?: WeightDto | undefined;
    countryOfOrigin?: CountryDto | undefined;
    customFields: { [key: string]: CustomFieldValueDto; };
    certifications: ArticleCertificationDto[];
    compliances: ArticleComplianceDto[];
    outPriceRanges: OutPriceRangeDto[];
    inPriceRangesByDestination: DestinationInPriceRangesDto[];
    timeline?: ArticleTimelineStateDto | undefined;
}

export interface TableProductDto {
    id: number;
    name: string;
    hierarchyNodeId?: number | undefined;
    sizeSystemVersionId?: number | undefined;
    sizeSystemName?: string | undefined;
    images: ProductDtoImage[];
    files: ProductFileDto[];
    tagIds: number[];
    roleAssignments: ProductDtoRoleAssignment[];
    customFields: { [key: string]: CustomFieldValueDto; };
}

export interface TableComponentDto {
    subTypeId?: number | undefined;
    composition: ComponentCompositionPartDto[];
}

export interface TableSkuDto {
    id: number;
    size: ProductDtoSize;
    skuCodeValues: SkuCodeValueDto[];
    weight?: WeightDto | undefined;
}

export interface OutPriceRangeDto {
    outPriceName: string;
    outPriceKey: string;
    destinationId: number;
    minAmount?: number | undefined;
    maxAmount?: number | undefined;
    currencyId?: number | undefined;
    markupMarginTargetMin?: number | undefined;
    markupMarginTargetMax?: number | undefined;
    markupMarginType: MarkupMarginType;
}

export interface DestinationInPriceRangesDto {
    destinationId: number;
    anyCostPriceUnlinked: boolean;
    ranges: InPriceRangesDto;
}

export interface InPriceRangesDto {
    costPriceRange?: PriceRangeDto | undefined;
    costPriceTargetRange?: PriceRangeDto | undefined;
    landedCostRange?: PriceRangeDto | undefined;
    freightPercentageMin?: number | undefined;
    freightPercentageMax?: number | undefined;
    freightChargeRange?: PriceRangeDto | undefined;
    dutiesPercentageMin?: number | undefined;
    dutiesPercentageMax?: number | undefined;
    stepRanges: InPriceStepRangeDto[];
}

export interface InPriceStepRangeDto {
    stepKey: string;
    percentageMin?: number | undefined;
    percentageMax?: number | undefined;
    chargeRange?: PriceRangeDto | undefined;
    anyValueUnlinked: boolean;
}

export interface ArticleTimelineStateDto {
    timelineId: number;
    seasonId: number;
    dropId?: number | undefined;
    isProvisional: boolean;
    health: TimelineHealth;
    nextGateId?: number | undefined;
    nextGateDue?: string | undefined;
    completedGates: number;
    totalGates: number;
    completions: ArticleGateCompletionDto[];
    estimates: ArticleGateEstimateDto[];
}

export enum TimelineHealth {
    OnTrack = 0,
    Late = 1,
    AtRisk = 2,
}

export interface ArticleGateCompletionDto {
    gateId: number;
    completedOn: string;
}

export interface ArticleGateEstimateDto {
    gateId: number;
    estimatedOn: string;
}

export interface TimelineSeasonGroupsDto {
    seasons: TimelineSeasonGroupDto[];
    seasonlessArticleCount: number;
}

export interface TimelineSeasonGroupDto {
    seasonId: number;
    articleCount: number;
    onTrackCount: number;
    atRiskCount: number;
    lateCount: number;
    noTimelineCount: number;
}

export interface FilterFacets {
    outPriceKeys: OutPriceKeyInfo[];
    outPriceRows: OutPriceFacetRow[];
    dropRows: DropFacetRow[];
}

export interface OutPriceKeyInfo {
    key: string;
    name: string;
    currencyId: number;
    destinationId: number;
    allAmounts: number[];
}

export interface OutPriceFacetRow {
    articleId: number;
    key: string;
    destinationId: number;
    amount: number;
}

export interface DropFacetRow {
    articleId: number;
    dropId: number;
}

export interface FilterFacetsArgs {
    activeSeasonId?: number | undefined;
    filters?: ArticleFilters | undefined;
}

export interface ArticleFilters {
    hierarchyNodeIds?: number[] | undefined;
    productCategoryIds?: number[] | undefined;
    genders?: Gender[] | undefined;
    seasonIds?: number[] | undefined;
    colors?: FiltersColor[] | undefined;
    supplierIds?: number[] | undefined;
    dropDateRange?: FiltersDropDateRange | undefined;
    dropNames?: string[] | undefined;
    statusIds?: number[] | undefined;
    tagIds?: number[] | undefined;
    searchTerm?: string | undefined;
    customFieldOptionIds?: { [key: string]: number[]; } | undefined;
    createdByUserIds?: string[] | undefined;
    assignedUserIds?: string[] | undefined;
    colorGroupIds?: number[] | undefined;
    outPriceAmounts?: { [key: string]: number[]; } | undefined;
    outPriceRanges?: { [key: string]: OutPriceRange; } | undefined;
    sizeSystemIds?: number[] | undefined;
    timelineHealth?: TimelineHealthFilter[] | undefined;
    nextGateRoleIds?: number[] | undefined;
    nextGateNames?: string[] | undefined;
}

export interface FiltersDropDateRange {
    from?: string | undefined;
    to?: string | undefined;
}

export interface RangePlanExportArgs {
    groupingOption: RangePlanGroupingOption;
    subGroupingOption?: RangePlanGroupingOption | undefined;
    activeSeasonId?: number | undefined;
    filters: ArticleFilters;
    selection: Selection;
    sortingOptions: SortingOptions;
}

export interface RangePlanGroupingOption {
    grouping: RangePlanGrouping;
    id?: number | undefined;
}

export enum RangePlanGrouping {
    OrderDay = "OrderDay",
    OrderWeek = "OrderWeek",
    OrderMonth = "OrderMonth",
    OrderQuarter = "OrderQuarter",
    OrderYear = "OrderYear",
    DropDay = "DropDay",
    DropWeek = "DropWeek",
    DropMonth = "DropMonth",
    DropQuarter = "DropQuarter",
    Status = "Status",
    Season = "Season",
    Tags = "Tags",
    Supplier = "Supplier",
    Gender = "Gender",
    ProductName = "ProductName",
    PrincipalMaterial = "PrincipalMaterial",
    Hierarchy = "Hierarchy",
    Color = "Color",
}

export interface Selection {
    isAllSelected: boolean;
    selectedIds?: number[] | undefined;
    excludedIds?: number[] | undefined;
}

export interface SortingOptions {
    sorting: Sorting;
    descending: boolean;
    fieldId?: number | undefined;
    tagCategoryId?: number | undefined;
    seasonId?: number | undefined;
    today?: string | undefined;
    destinationId?: number | undefined;
    priceKey?: string | undefined;
}

export interface ArticleExcelExportArgs {
    filters: ArticleFilters;
    sortingOptions: SortingOptions;
    selection: Selection;
    includeSeasonalData: boolean;
    imageSize: ExcelImageSize;
    activeSeasonId?: number | undefined;
}

export interface SkuExcelExportArgs {
    filters: ArticleFilters;
    sortingOptions: SortingOptions;
    selection: Selection;
    includeSeasonalData: boolean;
    activeSeasonId?: number | undefined;
}

export interface RunLabelManagerActionArgs {
    filters: ArticleFilters;
    selection: Selection;
    activeSeasonId?: number | undefined;
    organizationId: string;
    templateId: string;
    format: LabelManagerActionFormat;
    customFieldKey: string;
}

export enum LabelManagerActionFormat {
    PDF = "PDF",
    PNG = "PNG",
    SVG = "SVG",
}

export interface OverviewCustomExportOption {
    exportType: string;
    name: string;
    extension: string;
}

export interface GetProductIdsArgs {
    filters: ArticleFilters;
    selection: Selection;
    sortingOptions: SortingOptions;
}

export interface MassEditResponse {
    before: number;
    articles: TableArticleDto[];
    after: number;
    newReferenceIndex?: number | undefined;
    unselectedIds: number[];
    windowArticleIds?: number[] | undefined;
    pricePatches?: TableArticlePricePatchDto[] | undefined;
}

export interface TableArticlePricePatchDto {
    id: number;
    productCustomFields: { [key: string]: CustomFieldValueDto; };
    customFields: { [key: string]: CustomFieldValueDto; };
    outPriceRanges: OutPriceRangeDto[];
    inPriceRangesByDestination: DestinationInPriceRangesDto[];
}

export interface MassEditNameArgs {
    massEditArgs: MassEditArgs;
    name: string;
}

export interface MassEditArgs {
    filters: ArticleFilters;
    sortingOptions: SortingOptions;
    selection: Selection;
    selectedCount: number;
    anchorArticleId: number;
    activeSeasonId?: number | undefined;
    maxReturned?: number | undefined;
    activeWindowArticleIds?: number[] | undefined;
}

export interface ApiResponseOfMassEditResponse {
    data?: MassEditResponse | undefined;
    status: string;
    code: number;
    errors?: ApiError[] | undefined;
}

export interface ApiError {
    message: string;
    entityId?: number | undefined;
    details?: any | undefined;
}

export interface MassEditEntityStatus {
    statusId: number;
    state: MassEditStatusState;
}

export enum MassEditStatusState {
    None = 0,
    Some = 1,
    All = 2,
}

export interface GetMassEditArticleStatusesArgs {
    filters: ArticleFilters;
    selection: Selection;
}

export interface MassEditEntityColorGroup {
    colorGroupId: number;
    state: MassEditStatusState;
}

export interface GetMassEditColorGroupsArgs {
    filters: ArticleFilters;
    selection: Selection;
}

export interface MassEditTagUsageDto {
    tagId: number;
    applicableToAll: boolean;
    tagUsage: TagUsage;
}

export enum TagUsage {
    None = 0,
    Some = 1,
    All = 2,
}

export interface GetMassEditTagUsageArgs {
    filters: ArticleFilters;
    selection: Selection;
}

export interface MassEditTagsArgs {
    massEditArgs: MassEditArgs;
    removeTagIds: number[];
    addTagIds: number[];
}

export interface MassEditSeasonUsageDto {
    seasonId: number;
    seasonUsage: SeasonUsage;
}

export enum SeasonUsage {
    None = 0,
    Some = 1,
    All = 2,
}

export interface GetMassEditSeasonUsageArgs {
    filters: ArticleFilters;
    selection: Selection;
}

export interface MassEditSeasonsArgs {
    massEditArgs: MassEditArgs;
    addSeasonIds: number[];
    removeSeasonIds: number[];
    suppressBomDropWarning: boolean;
}

export interface MassEditDropUsageDto {
    dropId: number;
    dropUsage: DropUsage;
}

export enum DropUsage {
    None = 0,
    Some = 1,
    All = 2,
}

export interface GetMassEditDropUsageArgs {
    filters: ArticleFilters;
    selection: Selection;
}

export interface MassEditDropArgs {
    massEditArgs: MassEditArgs;
    removeDropIds: number[];
    addDrops: AddDropsArgsItem[];
}

export interface AddDropsArgsItem {
    dropDate: string;
    dropGranularity: DropGranularity;
    dropGroupId?: number | undefined;
}

export interface MassEditCertificationUsageDto {
    certificateId: number;
    usage: CertificationUsage;
    file?: string | undefined;
    summary?: string | undefined;
    validUntil?: string | undefined;
}

export enum CertificationUsage {
    None = "None",
    Some = "Some",
    All = "All",
}

export interface GetMassEditCertificationUsageArgs {
    filters: ArticleFilters;
    selection: Selection;
}

export interface MassEditCertificationsArgs {
    massEditArgs: MassEditArgs;
    upserts: ArticleCertificationDto[];
    removedCertificateIds: number[];
}

export interface MassEditComplianceUsageDto {
    complianceId: number;
    usage: ComplianceUsage;
    file?: string | undefined;
    summary?: string | undefined;
    testResult?: ComplianceTestResult | undefined;
    conductedAt?: string | undefined;
}

export enum ComplianceUsage {
    None = "None",
    Some = "Some",
    All = "All",
}

export interface GetMassEditComplianceUsageArgs {
    filters: ArticleFilters;
    selection: Selection;
}

export interface MassEditCompliancesArgs {
    massEditArgs: MassEditArgs;
    upserts: ArticleComplianceDto[];
    removedComplianceIds: number[];
}

export interface MassEditTariffCodeUsageDto {
    tariffCodeId: number;
    tariffCodeUsage: TariffCodeUsage;
}

export enum TariffCodeUsage {
    None = "None",
    Some = "Some",
    All = "All",
}

export interface GetMassEditTariffCodeUsageArgs {
    filters: ArticleFilters;
    selection: Selection;
}

export interface MassEditTariffCodesArgs {
    massEditArgs: MassEditArgs;
    addTariffCodeIds: number[];
    removeTariffCodeIds: number[];
}

export interface MassEditSupplierUsageDto {
    supplierIds: number[];
    articles: MassEditSupplierUsageDtoArticles[];
}

export interface MassEditSupplierUsageDtoArticles {
    articleId: number;
    supplierIds: number[];
}

export interface GetMassEditSupplierUsageArgs {
    filters: ArticleFilters;
    selection: Selection;
    activeSeasonId?: number | undefined;
}

export interface MassEditSuppliersArgs {
    massEditArgs: MassEditArgs;
    addSupplierIds: number[];
    removeSupplierIds: number[];
    newPrimarySupplierId?: number | undefined;
}

export interface MassEditAssigneesUsageResponseDto {
    totalProductCount: number;
    usages: MassEditAssigneeUsageDto[];
}

export interface MassEditAssigneeUsageDto {
    roleId: number;
    userId?: string | undefined;
    state: MassEditStatusState;
}

export interface GetMassEditAssigneesUsageArgs {
    filters: ArticleFilters;
    selection: Selection;
    activeSeasonId?: number | undefined;
}

export interface MassEditAssigneesArgs {
    massEditArgs: MassEditArgs;
    added: ProductDtoRoleAssignment[];
    removed: ProductDtoRoleAssignment[];
}

export interface MassEditCustomFieldTextArgs {
    massEditArgs: MassEditArgs;
    value?: string | undefined;
}

export interface MassEditPriceUsageDto {
    singleAmount?: number | undefined;
    mixedAmountsPlaceholder?: string | undefined;
    currencyIds: number[];
}

export interface GetMassEditFieldUsageArgs {
    filters: ArticleFilters;
    selection: Selection;
    activeSeasonId?: number | undefined;
}

export interface MassEditCostAndTargetPriceUsageDto {
    costPrice: MassEditPriceUsageDto;
    targetCostPrice: MassEditPriceUsageDto;
}

export interface GetInPriceFieldUsageArgs {
    destinationId: number;
    massEditFieldUsageArgs: GetMassEditFieldUsageArgs;
}

export interface GetOutPriceUsageArgs {
    outPriceKey: string;
    destinationId: number;
    massEditFieldUsageArgs: GetMassEditFieldUsageArgs;
}

export interface MassEditMarkupMarginUsageDto {
    singleValue?: number | undefined;
    mixedValuePlaceholder?: string | undefined;
    markupMarginTarget: NumberStateDto;
}

export interface NumberStateDto {
    singleValue?: number | undefined;
    mixedValuePlaceholder?: string | undefined;
}

export interface GetOutPriceMarkupUsageArgs {
    outPriceKey: string;
    destinationId: number;
    preferMarkup: boolean;
    massEditFieldUsageArgs: GetMassEditFieldUsageArgs;
}

export interface MassEditCostPriceArgs {
    massEditArgs: MassEditArgs;
    costPrice?: MassEditArgsPrice | undefined;
    targetCostPrice?: MassEditArgsPrice | undefined;
    destinationId: number;
    costPriceLinked?: boolean | undefined;
}

export interface MassEditArgsPrice {
    amountValue?: AmountValue | undefined;
    currencyId: number;
}

export interface MassEditFreightUsageDto {
    hasMixedFreightTypes: boolean;
    freightType?: FreightType | undefined;
    percentageState?: NumberStateDto | undefined;
    chargeState?: MassEditPriceUsageDto | undefined;
}

export interface MassEditDutiesArgs {
    massEditArgs: MassEditArgs;
    dutiesPercentage?: number | undefined;
    dutiesLinked?: boolean | undefined;
    destinationId: number;
}

export interface MassEditFreightArgs {
    massEditArgs: MassEditArgs;
    freightPercentage?: number | undefined;
    freightCharge?: MassEditFreightChargeArgs | undefined;
    destinationId: number;
    freightLinked?: boolean | undefined;
}

export interface MassEditFreightChargeArgs {
    amountValue?: AmountValue | undefined;
    currencyId?: number | undefined;
}

export interface MassEditInPriceStepArgs {
    massEditArgs: MassEditArgs;
    stepName: string;
    amountValue?: AmountValue | undefined;
    currencyId?: number | undefined;
    destinationId: number;
    linked?: boolean | undefined;
}

export interface MassEditInPriceStepUsageDto {
    type: InPriceStepType;
    percentageState?: NumberStateDto | undefined;
    chargeState?: MassEditPriceUsageDto | undefined;
    hasMixedTypes: boolean;
    hasUnlinkedArticles: boolean;
}

export enum InPriceStepType {
    Percentage = 0,
    Charge = 1,
}

export interface GetInPriceStepUsageArgs {
    stepName: string;
    massEditFieldUsageArgs: GetMassEditFieldUsageArgs;
    destinationId: number;
}

export interface MassEditOutPriceArgs {
    massEditArgs: MassEditArgs;
    outPriceKey: string;
    destinationId: number;
    price: MassEditArgsPrice;
}

export interface MassEditOutPriceMarkupArgs {
    massEditArgs: MassEditArgs;
    outPriceKey: string;
    destinationId: number;
    markupMargin?: number | undefined;
    targetMarkupMargin?: number | undefined;
    markupMarginType?: MarkupMarginType | undefined;
}

export interface MassEditCountryOfOriginArgs {
    massEditArgs: MassEditArgs;
    countryOfOriginId?: number | undefined;
}

export interface MassEditCountryOfOriginUsageDto {
    countryOfOriginIds: number[];
}

export interface MassEditTimelineUsageDto {
    articleSeasonCount: number;
    withGateDataCount: number;
    timelines: MassEditTimelineOptionDto[];
}

export interface MassEditTimelineOptionDto {
    timelineId: number;
    eligibleCount: number;
    usedCount: number;
}

export interface MassEditTimelineArgs {
    massEditArgs: MassEditArgs;
    timelineId: number;
}

export interface MassEditWeightArgs {
    massEditArgs: MassEditArgs;
    gross?: MassEditWeightValue | undefined;
    net?: MassEditWeightValue | undefined;
    unit?: WeightUnit | undefined;
}

export interface MassEditWeightValue {
    value?: number | undefined;
}

export interface MassEditWeightUsageDto {
    mixedGrossPlaceholder?: string | undefined;
    mixedNetPlaceholder?: string | undefined;
    unitIds: number[];
    totalSkuCount: number;
    skusWithoutGross: number;
    skusWithoutNet: number;
    articlesWithoutSkus: number;
}

export interface MassEditCustomFieldMoneyArgs {
    massEditArgs: MassEditArgs;
    amountValue?: AmountValue | undefined;
    currencyId?: number | undefined;
}

export interface MassEditNumberWithUnitUsageDto {
    singleNumber?: number | undefined;
    mixedNumberPlaceholder?: string | undefined;
    unitIds: number[];
}

export interface MassEditCustomFieldNumberWithUnitArgs {
    massEditArgs: MassEditArgs;
    numberValue?: NumberValue | undefined;
    unitId?: number | undefined;
}

export interface MassEditSingleSelectUsageDto {
    usages: MassEditSingleSelectOptionUsageDto[];
}

export interface MassEditSingleSelectOptionUsageDto {
    optionId?: number | undefined;
    usageCount: number;
}

export interface MassEditCustomFieldSingleSelectArgs {
    massEditArgs: MassEditArgs;
    addedOptionId?: number | undefined;
    removedOptionIds: number[];
    clear: boolean;
}

export interface MassEditMultiSelectUsageDto {
    usages: MassEditMultiSelectOptionUsageDto[];
}

export interface MassEditMultiSelectOptionUsageDto {
    optionId: number;
    totalCount: number;
    selectedCount: number;
}

export interface MassEditCustomFieldMultiSelectArgs {
    massEditArgs: MassEditArgs;
    addedOptionIds: number[];
    removedOptionIds: number[];
    clear: boolean;
}

export interface MassEditCustomFieldFileUsageDto {
    path: string;
    filename: string;
    size: number;
    updatedAt: string;
    fileUsage: CustomFieldFileUsage;
}

export enum CustomFieldFileUsage {
    None = 0,
    Some = 1,
    All = 2,
}

export interface GetMassEditCustomFieldFileUsageArgs {
    customFieldId: number;
    filters: ArticleFilters;
    selection: Selection;
}

export interface MassEditCustomFieldFilesArgs {
    massEditArgs: MassEditArgs;
    addFiles: CustomFieldFile[];
    removeFiles: CustomFieldFile[];
}

export interface MassDeleteArgs {
    filters?: ArticleFilters | undefined;
    sortingOptions?: SortingOptions | undefined;
    selection?: Selection | undefined;
    activeSeasonId?: number | undefined;
    selectedCount: number;
}

export interface BulkProductDeletionBlockersDto {
    productCount: number;
    articleCount: number;
    orderCount: number;
    nonEmptyBomCount: number;
    skuCodeValueCountsByCodeId: { [key: string]: number; };
    sampleRoundCount: number;
    nonDeletableArticleStatusIds: number[];
    customerOrderRowCount: number;
    relatedFromProductCount: number;
}

export interface PaymentTermDto {
    id: number;
    name: string;
}

export interface CreatePaymentTerm {
    name: string;
}

export interface UpdatePaymentTerm {
    name: string;
}

export interface PaymentTermUsageDto {
    suppliers: EntityReference[];
    orders: EntityReference[];
}

export type PermissionDto = CanSetArticleStatusPermissionDto;
export interface PermissionDto_Interface {
    id: number;
    userId: string;
    accessLevel: AccessLevel;
    permissionType: string;
}

export enum AccessLevel {
    Denied = 0,
    Granted = 1,
}

export interface CanSetArticleStatusPermissionDto extends PermissionDto_Interface {
    permissionType: 'CanSetArticleStatusPermissionDto';
    statusId: number;
}
export function isCanSetArticleStatusPermissionDto(obj?: PermissionDto): obj is CanSetArticleStatusPermissionDto {
    return obj?.permissionType === 'CanSetArticleStatusPermissionDto';
}

export interface AddPermissionArgs {
    userId: string;
    statusId: number;
    accessLevel: AccessLevel;
}

export interface UpdatePermissionArgs {
    accessLevel: AccessLevel;
}

export interface SetPermissionsBulkArgs {
    cells: SetPermissionsBulkCell[];
}

export interface SetPermissionsBulkCell {
    userId: string;
    statusId: number;
    /** null removes the permission — the cell's empty state. */
    accessLevel?: AccessLevel | undefined;
}

export interface PermissionUserDto {
    id: string;
    photo: string;
    name: string;
    email?: string | undefined;
}

export interface PlacementNameDto {
    id: number;
    name: string;
    defaultTagIds: number[];
}

export interface CreatePlacementNameArgs {
    name: string;
}

export interface UpdatePlacementNameArgs {
    name: string;
}

export interface ReplacePlacementNameArgs {
    replacementId: number;
}

export interface SetDefaultTagsArgs {
    tagIds: number[];
}

export interface PlacementTagCategoryDto {
    id: number;
    name: string;
    tags: PlacementTagDto[];
}

export interface PlacementTagDto {
    id: number;
    name: string;
    color: string;
    isOncePerBom: boolean;
    tagCategoryId: number;
}

export interface CreateTagCategoryArgs2 {
    name: string;
}

export interface UpdateTagCategoryArgs2 {
    name: string;
}

export interface AddTagArgs3 {
    name: string;
    color: string;
    tagCategoryId: number;
    isOncePerBom: boolean;
}

export interface UpdateTagArgs3 {
    name: string;
    color: string;
    isOncePerBom: boolean;
}

export interface VatDto {
    id: number;
    hierarchyNodeId: number;
    seasonId?: number | undefined;
    destinationId: number;
    amount: number;
}

export interface SetVatsBulkArgs {
    destinationId: number;
    cells: SetVatsBulkCell[];
}

export interface SetVatsBulkCell {
    hierarchyNodeId: number;
    seasonId?: number | undefined;
    amount?: number | undefined;
}

export interface SetVatArgs {
    hierarchyNodeId: number;
    seasonId?: number | undefined;
    destinationId: number;
    amount?: number | undefined;
}

export interface MarkupMarginTargetDto {
    id: number;
    hierarchyNodeId: number;
    outPriceId: number;
    amount: number;
    updatedAt?: string | undefined;
}

export interface SetMarkupTargetArgs {
    hierarchyNodeId: number;
    outPriceId: number;
    value?: number | undefined;
}

export interface SetMarkupTargetsBulkArgs {
    cells: SetMarkupTargetsBulkCell[];
}

export interface SetMarkupTargetsBulkCell {
    hierarchyNodeId: number;
    outPriceId: number;
    value?: number | undefined;
}

export interface PriceRecalculationStatusDto {
    state: PriceRecalculationState;
    seasonIds: (number | undefined)[];
    queuedSeasonIds: (number | undefined)[];
    archivedSeasonIds: (number | undefined)[];
}

export enum PriceRecalculationState {
    Idle = 0,
    Pending = 1,
    Running = 2,
    Failed = 3,
}

export interface ProductCategoryDto {
    id: number;
    name: string;
    icon: string;
}

export interface AddProductCategoryArgs {
    name?: string | undefined;
    icon?: string | undefined;
}

export interface UpdateProductCategoryArgs {
    name?: string | undefined;
    icon?: string | undefined;
}

export interface ProductCategoryUsageDto {
    products?: EntityReference[] | undefined;
    articles?: EntityReference[] | undefined;
    hierarchyNodes?: EntityReference[] | undefined;
}

export interface GetInitialArticlePickerResponse {
    products: ArticlePickerProduct[];
    selectedArticles: ArticlePickerProduct[];
    totalCount: number;
}

export interface ArticlePickerProduct {
    id: number;
    hierarchyNodeId: number;
    name: string;
    imageUrl?: string | undefined;
    sizeSystemVersionId?: number | undefined;
    sizes: string[];
    totalArticles: number;
    articles: ArticlePickerArticle[];
}

export interface ArticlePickerArticle {
    id: number;
    statusId: number;
    articleNumber: string;
    imageUrl?: string | undefined;
    color?: ColorSuperSimple | undefined;
    genders: Gender[];
    seasonIds: number[];
    tagIds: number[];
    supplierIds: number[];
    dropIds: number[];
    productCategoryId?: number | undefined;
    principalMaterialId?: number | undefined;
    skus: SkuDtoMinimal[];
}

export interface SkuDtoMinimal {
    id: number;
    sizeValue: string;
}

export interface ProductOwningBrand {
    brandId: number;
    brandName: string;
    productName: string;
    productNumber: string;
}

export interface AddFilesArgs2 {
    azureBlobFileIds?: number[] | undefined;
}

export interface UpdateFileCommentArgs {
    comment?: string | undefined;
}

export interface AddProductArgs {
    name: string;
    hierarchyNodeId: number;
    productNumber?: string | undefined;
}

export interface ProductDeletionBlockersDto {
    orderCount: number;
    nonEmptyBomCount: number;
    skuCodeValueCountsByCodeId: { [key: string]: number; };
    sampleRoundCount: number;
    nonDeletableArticleStatusIds: number[];
    customerOrderRowCount: number;
    relatedFromProductCount: number;
}

export type UpdateProductNumberResponse = Updated | NumberTaken;
export interface UpdateProductNumberResponse_Interface {
    type: string;
}

export interface Updated extends UpdateProductNumberResponse_Interface {
    type: 'Updated';
    product: ProductDto;
}
export function isUpdated(obj?: UpdateProductNumberResponse): obj is Updated {
    return obj?.type === 'Updated';
}

export interface NumberTaken extends UpdateProductNumberResponse_Interface {
    type: 'NumberTaken';
    productId: number;
    productName: string;
    productNumber: string;
}
export function isNumberTaken(obj?: UpdateProductNumberResponse): obj is NumberTaken {
    return obj?.type === 'NumberTaken';
}

export interface UpdateProductNumberArgs {
    productNumber?: string | undefined;
}

export interface ProductNumberInfoResponse {
    currentNumber: string;
    isManuallySet: boolean;
    systemGeneratedNumber: string;
    developmentNumber?: string | undefined;
}

export interface QuickSearchProduct {
    id: number;
    number: number;
    productNumber: string;
    name: string;
    hierarchyNodeId: number;
    image?: string | undefined;
}

export interface UpdateColorsReturn {
    product: ProductDto;
    articles: ArticleDto[];
}

export interface UpdateColorsColor {
    color: SetColorArgs;
    articleId?: number | undefined;
}

export interface UpdateNameArgs2 {
    name: string;
}

export interface ProductGendersResponse {
    product: ProductDto;
    articles: ArticleDto[];
}

export interface UpdateGenderAndSizesReturn {
    product: ProductDto;
    articles: ArticleDto[];
    updateError?: UpdateSizeSystemError | undefined;
}

export interface UpdateSizeSystemError {
    title?: string | undefined;
    message?: string | undefined;
}

export interface UpdateGenderAndSizesArgs2 {
    genders: Gender[];
    sizeConversionTableId?: number | undefined;
    sizeSystemVersionId: number;
    sizes: ProductDtoSize[];
    articleSkus?: ArticleSkus[] | undefined;
}

export interface ArticleSkus {
    articleId: number;
    skus?: boolean[] | undefined;
}

export interface UpdateSizeReturn {
    product: ProductDto;
    articles: ArticleDto[];
    updateError?: UpdateSizeSystemError | undefined;
}

export interface UpdateSizeArgs {
    sizeSystemVersionId: number;
    sizes: ProductDtoSize[];
    articleSkus?: ArticleSkus[] | undefined;
}

export interface SizeSystemChangeRules {
    blocked?: string | undefined;
    rules: SizeSystemChangeRule[];
    anyHard: boolean;
}

export interface SizeSystemChangeRule {
    kind: SizeSystemChangeRuleKind;
    hard: boolean;
    message: string;
    skuIds: number[];
}

export enum SizeSystemChangeRuleKind {
    OnOrder = 0,
    StatusLocksSkuRemoval = 1,
    StatusLocksSkuNumbers = 2,
    SkuCodes = 3,
    InPrices = 4,
    OutPrices = 5,
    Seasonality = 6,
    Weight = 7,
    ManualSkuNumberOrName = 8,
}

export interface SizeSwitchPreview {
    refusal?: string | undefined;
    sizes: SizeSwitchSize[];
    articleCount: number;
    mCharts: SizeSwitchMChart[];
    sizeConversionTableName?: string | undefined;
    rules: SizeSystemChangeRules;
}

export interface SizeSwitchSize {
    productSizeId: number;
    value: string;
    skuCount: number;
    dropBlocker?: string | undefined;
}

export interface SizeSwitchMChart {
    mChartId: number;
    name: string;
    sizeSystemVersionName: string;
    articleCount: number;
}

export interface SwitchSizeSystemReturn {
    product: ProductDto;
    articles: ArticleDto[];
}

export interface SwitchSizeSystemArgs {
    sizeSystemVersionId: number;
    mappings: SwitchSizeSystemMapping[];
    addedSizeSystemVersionSizeIds: number[];
}

export interface SwitchSizeSystemMapping {
    productSizeId: number;
    sizeSystemVersionSizeId?: number | undefined;
}

export interface RecreateSizeSystemSkusArgs {
    sizeSystemVersionId: number;
    sizeSystemVersionSizeIds: number[];
}

export interface UpdateDescriptionReturn {
    product: ProductDto;
    articleIDs: number[];
}

export interface UpdateDescriptionArgs2 {
    description: string;
}

export interface SetRoleAssignmentsArgs {
    assignments?: ProductDtoRoleAssignment[] | undefined;
}

export interface UpdateTagsArgs {
    tagIds?: number[] | undefined;
}

export interface MassEditTagsResponse {
    product?: ProductDto | undefined;
    articles?: ArticleDto[] | undefined;
}

export interface MassEditTagsArgs2 {
    seasonId?: number | undefined;
    articleIds?: number[] | undefined;
    addTagIds?: number[] | undefined;
    removeTagIds?: number[] | undefined;
}

export interface ArticleTimelinePlanDto {
    articleId: number;
    timeline: ArticleSeasonTimelineDto;
}

export interface BulkCompleteGateArgs {
    articleIds: number[];
    completedOn: string;
    note?: string | undefined;
}

export interface BulkUndoGateArgs {
    articleIds: number[];
}

export interface BulkSetGateNoteArgs {
    articleIds: number[];
    note?: string | undefined;
}

export interface BulkSetGateEstimateArgs {
    articleIds: number[];
    estimatedOn?: string | undefined;
}

export interface UpdateSeasonsReturn2 {
    product?: ProductDto | undefined;
    updatedArticleIds?: number[] | undefined;
}

export interface UpdateProductSeasonsArgs {
    /** The articles AddSeasonIds and RemoveSeasonIds act on. Ignored by RemoveFromProductSeasonIds. An add must name at least one article unless the product has none. */
    articleIds?: number[] | undefined;
    /** Seasons to put on the named articles. Omitted means none. */
    addSeasonIds?: number[] | undefined;
    /** Seasons to take off the named articles. Omitted means none. */
    removeSeasonIds?: number[] | undefined;
    /** Seasons to take off the product entirely. Omitted means none. */
    removeFromProductSeasonIds?: number[] | undefined;
    suppressBomDropWarning: boolean;
}

export interface UpdateSuppliersSupplierArgs {
    supplierId: number;
}

export interface UpdateDeliveryArg {
    id?: number | undefined;
    inboundDate?: string | undefined;
    typeId?: number | undefined;
    quantity?: number | undefined;
}

export interface UpdateProductDropsArgsItem {
    id?: number | undefined;
    dropDate: string;
    granularity: DropGranularity;
    dropGroupId?: number | undefined;
}

export interface UpdateMChartArgs3 {
    mChartId?: number | undefined;
}

export interface UpdateHierarchyArgs {
    hierarchyNodeId?: number | undefined;
}

export interface UpdateHierarchyAndProductCategoryArgs2 {
    hierarchyNodeId: number;
    productCategoryId?: number | undefined;
}

export interface UpdateWeightReturn {
    product?: ProductDto | undefined;
    articles?: ArticleDto[] | undefined;
}

export interface UpdateImageArg {
    id?: number | undefined;
    /** The versioned file holding the picture: from file_Upload, or any file already in the PLM, such as one produced or attached in the agent chat. An
            existing image keeps the file it has — pass the one it already carries. */
    azureBlobFileId: number;
    tagIds: number[];
}

export interface GenerateSkuCodeValuesForSkusArgs2 {
    skuCodeIds?: number[] | undefined;
}

export interface BomGroupingDto {
    groups: BomGroupDto[];
}

export interface BomGroupDto {
    seasonIds: (number | undefined)[];
    representativeSeasonId?: number | undefined;
}

export interface GetCurrentBomPrincipalTypesResponse {
    id: number;
    name?: string | undefined;
    articleCount: number;
    slotCount: number;
}

export interface GetCurrentBomPrincipalSlotsResponseSlot {
    id: number;
    componentName?: string | undefined;
    refNumber?: string | undefined;
    subTypeId?: number | undefined;
    composition?: ComponentCompositionPartDto[] | undefined;
    supplierIds?: number[] | undefined;
    comment?: string | undefined;
}

export interface UpdatePrincipalTypesResponse {
    product: ProductDto;
    updatedArticleIds: number[];
}

export interface UpdatePrincipalTypesArgs {
    componentSubTypeIds: number[];
    seasonId?: number | undefined;
}

export interface CheckHierarchyNodeResult {
    valid: boolean;
    message?: string | undefined;
}

export interface ProductImageTagCategoryDto {
    id: number;
    name: string;
    uniqueness: ProductImageTagCategoryUniqueness;
    tags: ProductImageTagDto[];
}

export enum ProductImageTagCategoryUniqueness {
    None = 0,
    Image = 1,
    Product = 3,
}

export interface ProductImageTagDto {
    id: number;
    name: string;
    color: string;
    tagCategoryId: number;
}

export interface CreateCategoryArgs {
    name: string;
    uniqueness: ProductImageTagCategoryUniqueness;
}

export interface UpdateCategoryArgs2 {
    name?: string | undefined;
    uniqueness?: ProductImageTagCategoryUniqueness | undefined;
}

export interface CreateTagArgs {
    tagCategoryId: number;
    name: string;
    color: string;
}

export interface UpdateTagArgs4 {
    name?: string | undefined;
    color?: string | undefined;
}

export interface ReservedNumberDto {
    id: number;
    type: ReservedNumberType;
    number: string;
    note?: string | undefined;
    createdAt?: string | undefined;
}

export enum ReservedNumberType {
    Article = 0,
    Product = 1,
    Sku = 2,
}

export interface AddReservedNumbersResponse {
    reserved: ReservedNumberDto[];
    added: string[];
    alreadyReserved: string[];
    inUse: string[];
}

export interface AddReservedNumbersArgs {
    type: ReservedNumberType;
    numbers: string;
    note?: string | undefined;
}

export interface ManagedLibraryDto {
    id: number;
    name: string;
    order: number;
    colorCount: number;
    adoptedCount: number;
    enabledByBrands: number;
}

export interface ManagedColorDto {
    color: LibraryColorDto;
    adoptedBy: string[];
}

export interface ColorValues {
    code: string;
    name: string;
    r: number;
    g: number;
    b: number;
    c: number;
    m: number;
    y: number;
    k: number;
}

export interface ImportPreview {
    added: ColorValues[];
    changed: ImportChange[];
    unchanged: number;
    blocked: AdoptedColorDto[];
}

export interface ImportChange {
    row: ColorValues;
    current: LibraryColorDto;
}

export interface AdoptedColorDto {
    code: string;
    brands: string[];
}

export interface CompanyPage {
    companies: GlobalCompanyDto[];
    total: number;
    counts: TabCounts;
}

export interface GlobalCompanyDto {
    id: number;
    name: string;
    type: Types2;
    brandId?: number | undefined;
    plm: boolean;
    plmConfigured: boolean;
    requires2fa: boolean;
    createdAt?: string | undefined;
    country?: string | undefined;
    members: number;
    connectedCompanies: number;
    connectedBrands: CompanyRefDto[];
    articles: number;
    products: number;
    activeUsers: number;
    lastActiveAt?: string | undefined;
    logo?: string | undefined;
}

export interface CompanyRefDto {
    companyId: number;
    name: string;
    brandId?: number | undefined;
}

export interface TabCounts {
    plmBrands: number;
    otherBrands: number;
    suppliers: number;
    agents: number;
}

export interface CompanySearchArgs {
    tab?: CompanyTab | undefined;
    query?: string | undefined;
    withoutUsers: boolean;
    connectedTo?: number | undefined;
    sort: CompanySort;
    descending: boolean;
    offset: number;
    limit: number;
}

export enum CompanyTab {
    PlmBrands = 0,
    OtherBrands = 1,
    Suppliers = 2,
    Agents = 3,
}

export enum CompanySort {
    Name = 0,
    Members = 1,
    Created = 2,
    ConnectedCompanies = 3,
    Articles = 4,
    LastActive = 5,
}

export interface CompanyDetailDto {
    company: GlobalCompanyDto;
    members: CompanyMemberDto[];
    connectedBrands: CompanyRefDto[];
}

export interface CompanyMemberDto {
    userId: string;
    name: string;
    email: string;
    photo?: string | undefined;
    lastActiveAt?: string | undefined;
    isDeactivated: boolean;
    roles: string[];
}

export interface CreatePlmBrandArgs {
    name: string;
    copyFromBrandId?: number | undefined;
    userEmails: string[];
}

export interface TurnOnPlmArgs {
    copyFromBrandId?: number | undefined;
}

export interface AddMembersArgs {
    emails: string[];
    create: NewMember[];
}

export interface NewMember {
    email: string;
    name: string;
}

export interface SupplierPortalPeopleDto {
    companyId: number;
    relationships: SupplierPortalRelationshipDto[];
    people: SupplierPortalPersonDto[];
    pendingInvitations: SupplierPortalInvitationDto[];
}

export interface SupplierPortalRelationshipDto {
    brandSupplierId: number;
    brandId: number;
    brandName: string;
    supplierName: string;
    enabled: boolean;
}

export interface SupplierPortalPersonDto {
    userId: string;
    name?: string | undefined;
    email?: string | undefined;
    photo?: string | undefined;
    role: SupplierPortalRole;
    brandSupplierIds: number[];
}

export interface SetPortalPersonArgs {
    role: SupplierPortalRole;
    brandSupplierIds: number[];
}

export interface HeldSemaphoreLockDto {
    type: string;
    id: number;
    acquiredAtUtc: string;
    heldForSeconds: number;
    requestId?: string | undefined;
}

export interface AllBrandsStatisticsDto {
    activityWindowDays: number;
    newBrandWindowDays: number;
    brands: BrandStatisticsSummaryDto[];
}

export interface BrandStatisticsSummaryDto {
    brandId: number;
    brandName: string;
    health: BrandHealthDto;
    seasons: BrandSeasonsDto;
    products: MetricActivity;
    articles: MetricActivity;
    skus: MetricActivity;
    users: MetricActivity;
    components: MetricActivity;
    sampleRequests: MetricActivity;
    orders: MetricActivity;
}

export interface BrandHealthDto {
    state: BrandHealthState;
    totalUsers: number;
    activeUsers: number;
    recordsTouched: number;
    editors: number;
    lastActiveAt?: string | undefined;
    brandCreatedAt?: string | undefined;
}

export enum BrandHealthState {
    AtRisk = "AtRisk",
    Dormant = "Dormant",
    Active = "Active",
    New = "New",
}

export interface BrandSeasonsDto {
    seasonsWithoutDates: number;
    spans: BrandSeasonSpanDto[];
}

export interface BrandSeasonSpanDto {
    name: string;
    start: string;
    end: string;
    products: number;
}

export interface MetricActivity {
    total: number;
    created: number;
    edited: number;
}

export interface BrandStatisticsDetailDto {
    brandId: number;
    brandName: string;
    productCount: number;
    productsByCategory: NamedCount[];
    articleCount: number;
    articlesByStatus: NamedCount[];
    skuCount: number;
    skusByStatus: NamedCount[];
    userCount: number;
    componentCount: number;
    componentsByStatus: NamedCount[];
    sampleRequestCount: number;
    sampleRequestsByType: NamedCount[];
    orderCount: number;
    ordersByStatus: NamedCount[];
    historical: HistoricalStatisticsResponse;
}

export interface NamedCount {
    name: string;
    count: number;
    color?: string | undefined;
}

export interface BrandUserActivityDto {
    brandId: number;
    windowDays?: number | undefined;
    rows: BrandUserActivityRowDto[];
}

export interface BrandUserActivityRowDto {
    userId: string;
    name?: string | undefined;
    email?: string | undefined;
    isResourcedStaff: boolean;
    products: number;
    articles: number;
    skus: number;
    components: number;
    boms: number;
    sampleRequests: number;
    orders: number;
    total: number;
}

export interface UserPage {
    users: GlobalUserDto[];
    total: number;
}

export interface GlobalUserDto {
    id: string;
    name: string;
    email: string;
    photo?: string | undefined;
    emailConfirmed: boolean;
    memberships: MembershipDto[];
    createdAt?: string | undefined;
    lastActiveAt?: string | undefined;
    hasPassword: boolean;
    externalLogins: string[];
    twoFactorEnabled: boolean;
    hasApiKey: boolean;
    isAdmin: boolean;
    isDeactivated: boolean;
    isLockedOut: boolean;
}

export interface MembershipDto {
    companyId: number;
    name: string;
    type: Types2;
    brandId?: number | undefined;
    plm: boolean;
}

export interface UserSearchArgs {
    query?: string | undefined;
    companyId?: number | undefined;
    status?: UserStatus | undefined;
    signIn?: SignInMethod | undefined;
    neverSignedIn: boolean;
    plmOnly: boolean;
    apiKeyOnly: boolean;
    adminOnly: boolean;
    sort: UserSort;
    descending: boolean;
    offset: number;
    limit: number;
}

export enum UserStatus {
    Active = 0,
    Deactivated = 1,
    Locked = 2,
}

export enum SignInMethod {
    Password = 0,
    External = 1,
    None = 2,
}

export enum UserSort {
    Email = 0,
    Name = 1,
    LastActive = 2,
    Created = 3,
}

export interface UserDetailDto {
    user: GlobalUserDto;
    brandRoles: BrandRolesDto[];
    apiKeys: UserApiKeyDto[];
}

export interface BrandRolesDto {
    companyId: number;
    brandId: number;
    roles: RoleOptionDto[];
    assignedRoleIds: number[];
}

export interface RoleOptionDto {
    id: number;
    name: string;
    color: string;
}

export interface UserApiKeyDto {
    id: number;
    name: string;
    type: ApiKeyType;
    brandId?: number | undefined;
    brandName?: string | undefined;
    prefix: string;
    last4: string;
    createdAt?: string | undefined;
    lastUsedAt?: string | undefined;
    expiresAt?: string | undefined;
    revokedAt?: string | undefined;
    isSystem: boolean;
}

export interface LookupResult {
    found: GlobalUserDto[];
    unknown: string[];
}

export interface CreateUserArgs {
    email: string;
    name: string;
    password?: string | undefined;
    companyId?: number | undefined;
}

export interface MembershipArgs {
    email: string;
    companyId: number;
}

export interface SetBrandRolesArgs {
    roleIds: number[];
}

export interface SendRequestDemoEmailArgs {
    name: string;
    email: string;
    phone: string;
}

export interface SendRequestSignUpEmailArgs {
    name: string;
    email: string;
    phone: string;
}

export interface SendContactEmailArgs {
    name: string;
    email: string;
    phone: string;
    companySize: string;
    message?: string | undefined;
}

export interface RoleDto {
    id: number;
    name: string;
    color: string;
    isProductRole: boolean;
    userIds: string[];
}

export interface AddRoleArgs {
    name: string;
    color?: string | undefined;
}

export interface UpdateRoleArgs {
    name: string;
    color: string;
    isProductRole: boolean;
}

export interface RoleUsagesDto {
    products: number;
    hierarchyNodes: number;
}

export interface SetUserRolesArgs {
    userId: string;
    roleIds: number[];
}

export interface SampleRoundDto {
    id: number;
    roundNumber: number;
    sampleRoundNumber: string;
    isClosed: boolean;
    isDraft: boolean;
    productId: number;
    productImagePath?: string | undefined;
    productHierarchyNodeId?: number | undefined;
    productName: string;
    sampleRoundTypeId: number;
    createdBy: UserSimple;
    createdAt: string;
    sampleReceivalDeadline: string;
    sampleSent?: string | undefined;
    sampleReceived?: string | undefined;
    supplierEmail?: string | undefined;
    ccEmails: string[];
    groupNumber?: number | undefined;
    numberInGroup?: number | undefined;
    groupMessage?: string | undefined;
    groupDeadline?: string | undefined;
    groupSupplierId?: number | undefined;
    articles: SampleRoundDtoArticle[];
    supplierId: number;
    supplierCountryAlpha3?: string | undefined;
    sizes: { [key: string]: { [key: string]: number; }; };
    mChartIds: number[];
    supplierAccessToken: string;
    sampleRows: SampleRowDto[];
    events: SampleRoundEventDto[];
}

export interface SampleRoundDtoArticle {
    id: number;
    color?: ColorSuperSimple | undefined;
    articleNumber: string;
    imageUrl?: string | undefined;
}

export interface SampleRowDto {
    id: number;
    articleId: number;
    size: string;
    requestedQuantity: number;
    receivedQuantity: number;
    sampleStatusId?: number | undefined;
    state: SampleRowState;
    addedByEventId?: number | undefined;
    mChartId?: number | undefined;
    mChartVersionNumber?: number | undefined;
}

export enum SampleRowState {
    Requested = 0,
    Sent = 1,
    Received = 2,
    Reviewed = 3,
}

export type SampleRoundEventDto = RoundOpenedEventDto | MessageEventDto | SampleSentEventDto | SampleReceivedEventDto | RoundClosedEventDto | MeasurementReportEventDto | SampleReviewEventDto | SampleRowsAddedEventDto | SamplesRequestedEventDto | CcAddedEventDto | CcRemovedEventDto | DeadlineChangedEventDto | InformationRequestEventDto | InformationReplyEventDto;
export interface SampleRoundEventDto_Interface {
    id: number;
    postedBy: UserSimple;
    postedAt: string;
    isDraft: boolean;
    eventSource: EventSource;
    supplierContactName?: string | undefined;
    isInternal: boolean;
    eventType: string;
}

export enum EventSource {
    Brand = "Brand",
    SupplierPortal = "SupplierPortal",
    SupplierEmail = "SupplierEmail",
}

export interface RoundOpenedEventDto extends SampleRoundEventDto_Interface {
    eventType: 'RoundOpenedEventDto';
    sampleReceivalDeadline: string;
    originalDeadline?: string | undefined;
    supplierId: number;
    supplierEmailAddress?: string | undefined;
    sampleRoundTypeId: number;
    articles: SampleRoundDtoRounOpenedArticle[];
    sizes: { [key: string]: { [key: string]: number; }; };
    files: SampleRoundFileDto[];
    message: string;
    deliveryStatuses: EmailRecipientDeliveryStatusDto[];
}
export function isRoundOpenedEventDto(obj?: SampleRoundEventDto): obj is RoundOpenedEventDto {
    return obj?.eventType === 'RoundOpenedEventDto';
}

export interface SampleRoundDtoRounOpenedArticle {
    id: number;
    color?: ColorSuperSimple | undefined;
    articleNumber: string;
    imageUrl?: string | undefined;
}

export interface SampleRoundFileDto {
    id: number;
    filename: string;
    url: string;
    source: SampleRoundFileSource;
}

export enum SampleRoundFileSource {
    ProductRelated = 0,
    RoundTypeStatic = 1,
    RoundTypeDynamic = 2,
    RoundUploaded = 3,
    Comment = 4,
}

export interface EmailRecipientDeliveryStatusDto {
    emailAddress: string;
    recipientType: EmailRecipientType;
    status: EmailDeliveryStatus;
}

export enum EmailRecipientType {
    To = "To",
    Cc = "Cc",
}

export enum EmailDeliveryStatus {
    Pending = "Pending",
    Sent = "Sent",
    Delivered = "Delivered",
    Opened = "Opened",
    Bounced = "Bounced",
    Blocked = "Blocked",
    Dropped = "Dropped",
    SpamReported = "SpamReported",
}

export interface MessageEventDto extends SampleRoundEventDto_Interface {
    eventType: 'MessageEventDto';
    message: string;
    attachments: SampleRoundFileDto[];
    images: SampleRoundImageDto[];
    emailStatus?: EmailStatus | undefined;
    deliveryStatuses: EmailRecipientDeliveryStatusDto[];
}
export function isMessageEventDto(obj?: SampleRoundEventDto): obj is MessageEventDto {
    return obj?.eventType === 'MessageEventDto';
}

export interface SampleRoundImageDto {
    id: number;
    name: string;
    path: string;
    size: number;
    width: number;
    height: number;
    annotations: AnnotationItem[];
}

export enum EmailStatus {
    Sending = "Sending",
    Sent = "Sent",
    Failed = "Failed",
}

export interface SampleSentEventDto extends SampleRoundEventDto_Interface {
    eventType: 'SampleSentEventDto';
    sentAt: string;
    trackingNumber?: string | undefined;
    trackingUrl?: string | undefined;
    samples: SampleSentSampleDto[];
    emailStatus?: EmailStatus | undefined;
    deliveryStatuses: EmailRecipientDeliveryStatusDto[];
}
export function isSampleSentEventDto(obj?: SampleRoundEventDto): obj is SampleSentEventDto {
    return obj?.eventType === 'SampleSentEventDto';
}

export interface SampleSentSampleDto {
    articleId: number;
    size: string;
    sentQuantity?: number | undefined;
    sampleRowId?: number | undefined;
}

export interface SampleReceivedEventDto extends SampleRoundEventDto_Interface {
    eventType: 'SampleReceivedEventDto';
    receivedAt: string;
    emailStatus?: EmailStatus | undefined;
    samples: SampleReceivedSampleDto[];
    deliveryStatuses: EmailRecipientDeliveryStatusDto[];
}
export function isSampleReceivedEventDto(obj?: SampleRoundEventDto): obj is SampleReceivedEventDto {
    return obj?.eventType === 'SampleReceivedEventDto';
}

export interface SampleReceivedSampleDto {
    articleId: number;
    size: string;
    receivedAt: string;
    receivedQuantity?: number | undefined;
    sampleRowId?: number | undefined;
}

export interface RoundClosedEventDto extends SampleRoundEventDto_Interface {
    eventType: 'RoundClosedEventDto';
}
export function isRoundClosedEventDto(obj?: SampleRoundEventDto): obj is RoundClosedEventDto {
    return obj?.eventType === 'RoundClosedEventDto';
}

export interface MeasurementReportEventDto extends SampleRoundEventDto_Interface {
    eventType: 'MeasurementReportEventDto';
    mChartId: number;
    mChartVersionNumber: number;
    supplierReport?: MChartVersionReportDto | undefined;
    brandReport?: MChartVersionReportDto | undefined;
    newMChartVersionNumber?: number | undefined;
    targetValues: { [key: string]: { [key: string]: number; }; };
    toBeValues: { [key: string]: { [key: string]: number; }; };
    toBeAnchorSizeIds: { [key: string]: number[]; };
    images: SampleRoundImageDto[];
    comment?: string | undefined;
    sampleRowId?: number | undefined;
    emailStatus?: EmailStatus | undefined;
    deliveryStatuses: EmailRecipientDeliveryStatusDto[];
    samples: MeasurementReportSampleDto[];
}
export function isMeasurementReportEventDto(obj?: SampleRoundEventDto): obj is MeasurementReportEventDto {
    return obj?.eventType === 'MeasurementReportEventDto';
}

export interface MeasurementReportSampleDto {
    sampleRowId?: number | undefined;
    sampleSizeSystemVersionSizeId: number;
    unitIndex: number;
    supplierReport?: MChartVersionReportDto | undefined;
    brandReport?: MChartVersionReportDto | undefined;
    measurementStatusId?: number | undefined;
    articleId?: number | undefined;
    size?: string | undefined;
}

export interface SampleReviewEventDto extends SampleRoundEventDto_Interface {
    eventType: 'SampleReviewEventDto';
    emailStatus?: EmailStatus | undefined;
    samples: SampleReviewSampleDto[];
    comments: SampleReviewCommentDto[];
    deliveryStatuses: EmailRecipientDeliveryStatusDto[];
}
export function isSampleReviewEventDto(obj?: SampleRoundEventDto): obj is SampleReviewEventDto {
    return obj?.eventType === 'SampleReviewEventDto';
}

export interface SampleReviewSampleDto {
    articleId: number;
    size: string;
    sampleStatusId: number;
    sampleRowId?: number | undefined;
}

export interface SampleReviewCommentDto {
    text?: string | undefined;
    images: SampleRoundImageDto[];
    attachments: SampleRoundReviewFileDto[];
    sampleRowId?: number | undefined;
}

export interface SampleRoundReviewFileDto {
    id: number;
    filename: string;
    url: string;
}

export interface SampleRowsAddedEventDto extends SampleRoundEventDto_Interface {
    eventType: 'SampleRowsAddedEventDto';
    addedRows: SampleRowsAddedRowDto[];
}
export function isSampleRowsAddedEventDto(obj?: SampleRoundEventDto): obj is SampleRowsAddedEventDto {
    return obj?.eventType === 'SampleRowsAddedEventDto';
}

export interface SampleRowsAddedRowDto {
    articleId: number;
    size: string;
    requestedQuantity: number;
}

export interface SamplesRequestedEventDto extends SampleRoundEventDto_Interface {
    eventType: 'SamplesRequestedEventDto';
    addedRows: SampleRowsAddedRowDto[];
    message?: string | undefined;
    emailStatus?: EmailStatus | undefined;
    deliveryStatuses: EmailRecipientDeliveryStatusDto[];
}
export function isSamplesRequestedEventDto(obj?: SampleRoundEventDto): obj is SamplesRequestedEventDto {
    return obj?.eventType === 'SamplesRequestedEventDto';
}

export interface CcAddedEventDto extends SampleRoundEventDto_Interface {
    eventType: 'CcAddedEventDto';
    addedEmails: string[];
}
export function isCcAddedEventDto(obj?: SampleRoundEventDto): obj is CcAddedEventDto {
    return obj?.eventType === 'CcAddedEventDto';
}

export interface CcRemovedEventDto extends SampleRoundEventDto_Interface {
    eventType: 'CcRemovedEventDto';
    removedEmails: string[];
}
export function isCcRemovedEventDto(obj?: SampleRoundEventDto): obj is CcRemovedEventDto {
    return obj?.eventType === 'CcRemovedEventDto';
}

export interface DeadlineChangedEventDto extends SampleRoundEventDto_Interface {
    eventType: 'DeadlineChangedEventDto';
    previousDeadline: string;
    newDeadline: string;
    emailStatus?: EmailStatus | undefined;
    deliveryStatuses: EmailRecipientDeliveryStatusDto[];
}
export function isDeadlineChangedEventDto(obj?: SampleRoundEventDto): obj is DeadlineChangedEventDto {
    return obj?.eventType === 'DeadlineChangedEventDto';
}

export interface InformationRequestEventDto extends SampleRoundEventDto_Interface {
    eventType: 'InformationRequestEventDto';
    message?: string | undefined;
    replyBy?: string | undefined;
    seasonId?: number | undefined;
    fields: InformationRequestFieldDto[];
    progress: InformationRequestProgressDto;
    emailStatus?: EmailStatus | undefined;
    deliveryStatuses: EmailRecipientDeliveryStatusDto[];
}
export function isInformationRequestEventDto(obj?: SampleRoundEventDto): obj is InformationRequestEventDto {
    return obj?.eventType === 'InformationRequestEventDto';
}

export interface InformationRequestFieldDto {
    id: number;
    articleId: number;
    customFieldId?: number | undefined;
    builtInField?: InformationRequestBuiltInField | undefined;
}

export enum InformationRequestBuiltInField {
    Description = "Description",
    GrossWeight = "GrossWeight",
    NetWeight = "NetWeight",
    CountryOfOrigin = "CountryOfOrigin",
    HsCode = "HsCode",
}

export interface InformationRequestProgressDto {
    replyBy?: string | undefined;
    fieldsAsked: number;
    fieldsAnswered: number;
    rowsToValidate: number;
    accepted: number;
    rejected: number;
}

export interface InformationReplyEventDto extends SampleRoundEventDto_Interface {
    eventType: 'InformationReplyEventDto';
    informationRequestEventId: number;
    message?: string | undefined;
    values: InformationReplyValueDto[];
    isReviewed: boolean;
    currentValues: { [key: string]: { [key: string]: CustomFieldValueDto; }; };
    currentBuiltInValues: InformationRequestBuiltInCurrentValueDto[];
    currentSkuValues: InformationRequestSkuCurrentValuesDto[];
    attachments: SampleRoundFileDto[];
    emailStatus?: EmailStatus | undefined;
    deliveryStatuses: EmailRecipientDeliveryStatusDto[];
}
export function isInformationReplyEventDto(obj?: SampleRoundEventDto): obj is InformationReplyEventDto {
    return obj?.eventType === 'InformationReplyEventDto';
}

export interface InformationReplyValueDto {
    id: number;
    informationRequestFieldId: number;
    skuId?: number | undefined;
    skuLabel?: string | undefined;
    value?: CustomFieldValueDto | undefined;
    valueText: string;
    editedValue?: CustomFieldValueDto | undefined;
    status: InformationReplyValueStatus;
    reviewedBy?: UserSimple | undefined;
    reviewedAt?: string | undefined;
}

export enum InformationReplyValueStatus {
    Pending = "Pending",
    Accepted = "Accepted",
    Rejected = "Rejected",
}

export interface InformationRequestBuiltInCurrentValueDto {
    articleId: number;
    field: InformationRequestBuiltInField;
    value?: string | undefined;
    skuId?: number | undefined;
}

export interface InformationRequestSkuCurrentValuesDto {
    skuId: number;
    articleId: number;
    values: { [key: string]: CustomFieldValueDto; };
}

export interface SampleRoundListDto {
    id: number;
    roundNumber: number;
    sampleRoundNumber: string;
    isClosed: boolean;
    isDraft: boolean;
    productId: number;
    productName: string;
    sampleRoundTypeId: number;
    createdBy: UserSimple;
    createdAt: string;
    sampleReceivalDeadline: string;
    sampleSent?: string | undefined;
    sampleReceived?: string | undefined;
    supplierId: number;
    articles: SampleRoundDtoArticle[];
    sizes: { [key: string]: { [key: string]: number; }; };
    receivedSampleCount: number;
    informationRequests: InformationRequestProgressDto[];
}

export interface SampleRoundPersonDto {
    email: string;
    name?: string | undefined;
    photo?: string | undefined;
    roundCount: number;
}

export interface SampleTableResponse {
    rows: SampleTableRowDto[];
    totalRowCount: number;
}

export interface SampleTableRowDto {
    roundId: number;
    roundNumber: number;
    sampleRoundNumber: string;
    isClosed: boolean;
    isDraft: boolean;
    productId: number;
    productName: string;
    productNumber: string;
    sampleRoundTypeId: number;
    supplierId: number;
    createdAt: string;
    createdBy: UserDto;
    sampleReceivalDeadline: string;
    sampleSent?: string | undefined;
    sampleReceived?: string | undefined;
    roundSampleRowCount: number;
    articleId: number;
    articleNumber: string;
    articleImageUrl?: string | undefined;
    articleColor: ColorSuperSimple;
    articleSampleRowCount: number;
    articleSeasonIds: number[];
    latestEventType?: string | undefined;
    latestEventPreview?: string | undefined;
    latestEventAt?: string | undefined;
    latestEventPostedBy?: UserDto | undefined;
    sampleRowId: number;
    size: string;
    requestedQuantity: number;
    receivedQuantity: number;
    sampleStatusId?: number | undefined;
    commentCount: number;
    shipments: SampleTableShipmentDto[];
}

export interface SampleTableShipmentDto {
    trackingNumber?: string | undefined;
    trackingUrl?: string | undefined;
    sentAt: string;
}

export enum SampleTableGrouping {
    Round = "Round",
    Supplier = "Supplier",
    Product = "Product",
}

export enum SampleTableSorting {
    CreatedAt = "CreatedAt",
    Deadline = "Deadline",
    SupplierName = "SupplierName",
    Product = "Product",
    RoundNumber = "RoundNumber",
    Status = "Status",
    Type = "Type",
    CreatedBy = "CreatedBy",
    LatestEvent = "LatestEvent",
    ReceivedDate = "ReceivedDate",
    SampleStatus = "SampleStatus",
}

export interface ProductRelatedFileDto {
    path: string;
    thumbnailPath?: string | undefined;
    name: string;
    comment?: string | undefined;
    updatedAt?: string | undefined;
    source: ProductRelatedFileSource;
    sourceId?: number | undefined;
    connectedArticleIds: number[];
    isMChartExport: boolean;
}

export enum ProductRelatedFileSource {
    Product = "Product",
    Component = "Component",
    MChart = "MChart",
    CustomField = "CustomField",
}

export interface CreateSampleRoundArgs {
    message: string;
    sizes: { [key: string]: { [key: string]: number; }; };
    date: string;
    supplierId: number;
    sampleRoundTypeId: number;
    articleIds: number[];
    supplierEmails: string;
    ccEmails: string;
    productAttachments: CreateNewSampleRoundProductAttachment[];
    typeStaticAttachmentIds: number[];
    newRoundAttachments: CreateNewSampleRoundAttachment[];
    typeTemplateIds: number[];
    activeSeasonId?: number | undefined;
    createdFromSampleRoundId?: number | undefined;
    isDraft: boolean;
}

export interface CreateNewSampleRoundProductAttachment {
    name: string;
    url: string;
    source?: ProductRelatedFileSource | undefined;
}

export interface CreateNewSampleRoundAttachment {
    name: string;
    path: string;
}

export interface CreateSampleRoundGroupArgs {
    sampleRoundTypeId: number;
    supplierId: number;
    deadline: string;
    supplierEmails: string;
    ccEmails: string;
    message: string;
    sampleRounds: CreateSampleRoundGroupArgsRound[];
    typeStaticAttachmentIds: number[];
    newRoundAttachments: CreateNewSampleRoundAttachment[];
    typeTemplateIds: number[];
    activeSeasonId?: number | undefined;
}

export interface CreateSampleRoundGroupArgsRound {
    message?: string | undefined;
    sizes: { [key: string]: { [key: string]: number; }; };
    articleIds: number[];
    productAttachments?: CreateNewSampleRoundProductAttachment[] | undefined;
}

export interface CreateMessageEventArgs {
    message: string;
    attachments?: MessageAttachment[] | undefined;
    images?: ReportImageArg[] | undefined;
    isInternal: boolean;
    isDraft: boolean;
    sendEmail: boolean;
    replacesDraftEventId?: number | undefined;
}

export interface MessageAttachment {
    name: string;
    url: string;
}

export interface ReportImageArg {
    name: string;
    path: string;
    size: number;
    width: number;
    height: number;
    annotations: AnnotationItem[];
}

export interface CreateSampleReceivedArgs {
    receivedAt: string;
    samples?: ReceivedSampleParam[] | undefined;
    newSamples?: NewReceivedSampleParam[] | undefined;
    isDraft: boolean;
    sendEmail: boolean;
    replacesDraftEventId?: number | undefined;
}

export interface ReceivedSampleParam {
    articleId: number;
    size: string;
    sampleRowId: number;
    receivedAt: string;
    receivedQuantity?: number | undefined;
}

export interface NewReceivedSampleParam {
    articleId: number;
    size: string;
    requestedQuantity: number;
    receivedAt: string;
    receivedQuantity?: number | undefined;
}

export interface CreateSampleReviewArgs {
    samples: ReviewSampleParam[];
    newSamples?: NewReviewSampleParam[] | undefined;
    isDraft: boolean;
    isInternal: boolean;
    comments?: ReviewCommentParam[] | undefined;
    sendEmail: boolean;
    replacesDraftEventId?: number | undefined;
}

export interface ReviewSampleParam {
    articleId: number;
    size: string;
    sampleRowId: number;
    sampleStatusId: number;
}

export interface NewReviewSampleParam {
    articleId: number;
    size: string;
    requestedQuantity: number;
    sampleStatusId: number;
}

export interface ReviewCommentParam {
    text?: string | undefined;
    images?: ReportImageArg[] | undefined;
    attachments?: MessageAttachment[] | undefined;
    sampleRowId?: number | undefined;
    newSampleArticleId?: number | undefined;
    newSampleSize?: string | undefined;
}

export interface CreateSampleSentArgs {
    sentAt: string;
    trackingNumber?: string | undefined;
    trackingUrl?: string | undefined;
    isDraft: boolean;
    samples?: SentSampleParam[] | undefined;
    sendEmail: boolean;
    replacesDraftEventId?: number | undefined;
}

export interface SentSampleParam {
    articleId: number;
    size: string;
    sampleRowId: number;
    sentQuantity?: number | undefined;
}

export interface CreateSamplesRequestedArgs {
    samples: NewArticleParam[];
    message?: string | undefined;
    sendEmail: boolean;
}

export interface NewArticleParam {
    articleId: number;
    sizes: { [key: string]: number; };
}

export interface ChangeDeadlineArgs {
    deadline: string;
    sendEmail: boolean;
}

export interface AddCcEmailsArgs {
    emails: string[];
}

export interface RemoveCcEmailsArgs {
    emails: string[];
}

export interface CreateMeasurementReportArgs {
    mChartId: number;
    mChartVersionNumber: number;
    samples: MeasurementReportSampleArg[];
    toBeValues?: { [key: string]: { [key: string]: number; }; } | undefined;
    toBeAnchorSizeIds?: { [key: string]: number[]; } | undefined;
    newSamples?: NewMeasurementReportSampleArg[] | undefined;
    images?: ReportImageArg[] | undefined;
    comment?: string | undefined;
    isDraft: boolean;
    isInternal: boolean;
    sendEmail: boolean;
    replacesDraftEventId?: number | undefined;
}

export interface MeasurementReportSampleArg {
    sampleRowId: number;
    sampleSizeId: number;
    supplierValues?: { [key: string]: number; } | undefined;
    brandValues?: { [key: string]: number; } | undefined;
    measurementStatusId?: number | undefined;
}

export interface NewMeasurementReportSampleArg {
    articleId: number;
    size: string;
    supplierValues?: { [key: string]: number; } | undefined;
    brandValues?: { [key: string]: number; } | undefined;
    measurementStatusId?: number | undefined;
}

export interface CreateInformationRequestArgs {
    fields: InformationRequestFieldParam[];
    replyBy?: string | undefined;
    message?: string | undefined;
    activeSeasonId?: number | undefined;
    isDraft: boolean;
    isInternal: boolean;
    sendEmail: boolean;
    replacesDraftEventId?: number | undefined;
}

export interface InformationRequestFieldParam {
    articleId: number;
    customFieldId?: number | undefined;
    builtInField?: InformationRequestBuiltInField | undefined;
}

export interface ReviewInformationReplyArgs {
    acceptValueIds: number[];
    rejectValueIds: number[];
    reopenValueIds: number[];
    editedValues: EditedValueParam[];
}

export interface EditedValueParam {
    informationReplyValueId: number;
    value: CustomFieldValueDto;
}

export interface UpdateDraftRoundArgs {
    message: string;
    sizes: { [key: string]: { [key: string]: number; }; };
    date: string;
    supplierId: number;
    sampleRoundTypeId: number;
    articleIds: number[];
    supplierEmails: string;
    ccEmails: string;
    productAttachments: CreateNewSampleRoundProductAttachment[];
    typeStaticAttachmentIds: number[];
    newRoundAttachments: CreateNewSampleRoundAttachment[];
    typeTemplateIds: number[];
    activeSeasonId?: number | undefined;
}

export interface SampleRoundTypeDto {
    id: number;
    name: string;
    color: string;
    templates: SampleRoundTypeTemplateDto[];
    staticFiles: SampleRoundTypeStaticFileDto[];
    emailDefaults: SampleRoundTypeEmailDefaultsDto;
    defaultSizes: SampleRoundTypeDefaultSizeDto[];
    informationRequestFields: SampleRoundTypeInformationRequestFieldDto[];
}

export interface SampleRoundTypeTemplateDto {
    id: number;
    name: string;
    path: string;
    size: number;
    summaryFileFormat: SummaryFileFormat;
    isFavorite: boolean;
    uploadedAt: string;
}

export enum SummaryFileFormat {
    Excel = 0,
    Pdf = 1,
}

export interface SampleRoundTypeStaticFileDto {
    id: number;
    name: string;
    path: string;
    size: number;
    isFavorite: boolean;
}

export interface SampleRoundTypeEmailDefaultsDto {
    message: boolean;
    sampleReceived: boolean;
    sampleSent: boolean;
    sampleReview: boolean;
    measurementReport: boolean;
    informationRequest: boolean;
}

export interface SampleRoundTypeDefaultSizeDto {
    sizeSystemId: number;
    sizeValue: string;
    quantity: number;
}

export interface SampleRoundTypeInformationRequestFieldDto {
    customFieldId?: number | undefined;
    builtInField?: InformationRequestBuiltInField | undefined;
}

export interface IncomingSampleRoundTypeArgs {
    name: string;
    color: string;
    emailDefaults?: SampleRoundTypeEmailDefaultsDto | undefined;
    defaultSizes?: SampleRoundTypeDefaultSizeDto[] | undefined;
    informationRequestFields?: SampleRoundTypeInformationRequestFieldDto[] | undefined;
}

export interface SampleRoundTypeUsageDto {
    sampleRounds: EntityReference[];
}

export interface UpdateTemplateArgs {
    name: string;
    summaryFileFormat: SummaryFileFormat;
    isFavorite: boolean;
}

export interface AttachStaticFilesArgs {
    files: AttachStaticFilesFile[];
}

export interface AttachStaticFilesFile {
    filename: string;
    path: string;
    size: number;
}

export interface UpdateStaticFileArgs {
    name: string;
    isFavorite: boolean;
}

export interface SampleStatusDto {
    id: number;
    name: string;
    color: string;
    excludeFromDefaultFiltering: boolean;
    sampleRoundTypeIds: number[];
}

export interface CreateSampleStatusArgs {
    name: string;
    color: string;
    excludeFromDefaultFiltering: boolean;
    sampleRoundTypeIds?: number[] | undefined;
}

export interface UpdateSampleStatusArgs {
    name: string;
    color: string;
    excludeFromDefaultFiltering: boolean;
    sampleRoundTypeIds?: number[] | undefined;
}

export interface SampleStatusUsageDto {
    sampleRounds: EntityReference[];
}

export interface QuickSearchProductDto {
    id: number;
    number: number;
    productNumber: string;
    name: string;
    hierarchyNodeId?: number | undefined;
    image?: string | undefined;
    colors: QuickSearchProductColor[];
    totalColorCount: number;
}

export interface QuickSearchProductColor {
    image: string;
    color?: ColorDtoMinimal | undefined;
}

export interface EntitySearchHitDto {
    id: number;
    reference: string;
    title: string;
    subtitle?: string | undefined;
    image?: string | undefined;
    hierarchyNodeId?: number | undefined;
}

export enum EntitySearchType {
    Product = 0,
    Order = 1,
    Component = 2,
    Sample = 3,
    MeasurementChart = 4,
    Supplier = 5,
}

export interface SeasonDto {
    id: number;
    name: string;
    color: string;
    isLive: boolean;
    isArchived: boolean;
    order: number;
}

export interface AddSeasonArgs {
    name: string;
    color: string;
    isLive?: boolean | undefined;
    isArchived?: boolean | undefined;
    channelActivities?: ChannelActivityArgs[] | undefined;
}

export interface ChannelActivityArgs {
    channelId: number;
    start: string;
    end: string;
}

export interface UpdateSeasonArgs {
    name: string;
    color: string;
    isLive: boolean;
    isArchived: boolean;
}

export interface SetSeasonFieldsBulkArgs {
    cells: SetSeasonFieldsBulkCell[];
}

export interface SetSeasonFieldsBulkCell {
    seasonId: number;
    field: SeasonField;
    /** The field as text: a name, a colour, or "true"/"false" for the two flags. Null is
only meaningful for the flags, where it reads as false — a season must keep its
name and colour, so clearing one is refused. */
    value?: string | undefined;
}

export enum SeasonField {
    Name = 0,
    Color = 1,
    IsLive = 2,
    IsArchived = 3,
}

export interface SeasonUsagesDto {
    product: number;
    order: number;
}

export interface SetChannelActivityArgs {
    channelId: number;
    start: string;
    end: string;
}

export interface BulkUpdateActivityChannel {
    channelId: number;
    removed?: number[] | undefined;
    set?: SetActivityAction[] | undefined;
}

export interface SetActivityAction {
    seasonId: number;
    start: string;
    end: string;
}

export interface CheckOverlapsResponse {
    warnings: OverlapWarning[];
}

export interface OverlapWarning {
    seasonId: number;
    currentStart: string;
    currentEnd: string;
    newStart?: string | undefined;
    newEnd?: string | undefined;
}

export interface CheckOverlapsArgs {
    channelId: number;
    start: string;
    end: string;
}

export interface SectionNameDto {
    id: number;
    name: string;
}

export interface CreateSectionNameArgs {
    name: string;
}

export interface UpdateSectionNameArgs {
    name: string;
}

export interface ReplaceSectionNameArgs {
    replacementId: number;
}

export interface SendGridEventArgs {
    email: string;
    event: string;
    sg_message_id?: string | undefined;
    sampleRoundId?: string | undefined;
    sampleRoundGroupId?: string | undefined;
    eventId?: string | undefined;
}

export interface ShopifyClaimInfo {
    shop: string;
    shopName?: string | undefined;
    shopUrl?: string | undefined;
    availableBrands: BrandRef[];
}

export interface BrandRef {
    id: number;
    name: string;
}

export interface ClaimResult {
    brandId: number;
    shop: string;
}

export interface ClaimArgs {
    claimToken: string;
    brandId: number;
}

export interface ShopifyConnectionDto {
    id: number;
    shopDomain: string;
    scopes: string;
    shopName?: string | undefined;
    shopCurrencyCode?: string | undefined;
    shopUrl?: string | undefined;
    enabled: boolean;
    channelId?: number | undefined;
    customFieldId?: number | undefined;
    syncFlagFieldId?: number | undefined;
    allowedStatusIds: number[];
    syncInQa: boolean;
    syncInProd: boolean;
}

export interface UpdateEnvironmentsArgs {
    qa: boolean;
    prod: boolean;
}

export interface ShopifyMappingTemplateDto {
    id: number;
    hierarchyNodeId?: number | undefined;
    shopifyProductLevel: PLMEntityType;
    fields: ShopifyFieldMappingDto[];
    variantOptions: ShopifyVariantOptionMappingDto[];
    mediaSourceTemplate?: string | undefined;
    mediaAltTemplate?: string | undefined;
}

export enum PLMEntityType {
    Product = 0,
    Article = 1,
    Sku = 2,
}

export interface ShopifyFieldMappingDto {
    id: number;
    shopifyFieldPath: string;
    fieldType: ShopifyFieldType;
    valueTemplate: string;
    createOnly: boolean;
}

export enum ShopifyFieldType {
    Base = 0,
    Variant = 1,
    Metafield = 2,
    MarketPrice = 3,
}

export interface ShopifyVariantOptionMappingDto {
    id: number;
    optionName: string;
    valueTemplate: string;
}

export interface ShopifyMarketsDto {
    /** False when the store was connected without the read_markets scope; reconnecting grants it. */
    canReadMarkets: boolean;
    markets: ShopifyMarket[];
}

export interface ShopifyMarket {
    marketGid: string;
    name: string;
    primary: boolean;
    enabled: boolean;
    priceListGid?: string | undefined;
    priceListCurrency?: string | undefined;
}

export interface SaveMappingArgs {
    /** The template to update. 0 creates a new one, which fails if the hierarchy node already has a template. */
    templateId: number;
    hierarchyNodeId?: number | undefined;
    shopifyProductLevel: PLMEntityType;
    fields: SaveMappingFieldArgs[];
    variantOptions: SaveVariantOptionArgs[];
    mediaSourceTemplate?: string | undefined;
    mediaAltTemplate?: string | undefined;
}

export interface SaveMappingFieldArgs {
    shopifyFieldPath: string;
    fieldType: ShopifyFieldType;
    valueTemplate: string;
    createOnly: boolean;
}

export interface SaveVariantOptionArgs {
    optionName: string;
    valueTemplate: string;
}

export interface ShopifySourceFieldOption {
    field: string;
    label: string;
    group: string;
    subGroup?: string | undefined;
}

export interface SizeConversionTableDto {
    id: number;
    name: string;
    columns: SizeConversionTableColumnDto[];
}

export interface SizeConversionTableColumnDto {
    id: number;
    sizeSystemId?: number | undefined;
    customSizeSystemName: string;
    sizes: SizeConversionTableColumnSizeDto[];
}

export interface SizeConversionTableColumnSizeDto {
    id: number;
    value: string;
}

export interface SizeConversionTableUsageDto {
    id: number;
    name: string;
    columns: SizeConversionTableColumnDto[];
    productCount: number;
    singleProduct?: SizeConversionTableProductDto | undefined;
}

export interface SizeConversionTableProductDto {
    id: number;
    name: string;
}

export interface AddSizeConversionTableArg {
    name?: string | undefined;
    columns?: AddSizeConversionTableArgColumn[] | undefined;
}

export interface AddSizeConversionTableArgColumn {
    sizeSystemId?: number | undefined;
    customSizeSystemName?: string | undefined;
    sizes?: string[] | undefined;
}

export interface SizeSystemDto {
    id: number;
    name: string;
    versions: SizeSystemDtoVersion[];
}

export interface SizeSystemDtoVersion {
    id: number;
    name: string;
    range: SizeSystemDtoSize[];
    defaultSizes: SizeSystemDtoDefaultSize[];
    is2D: boolean;
    axisValues: SizeSystemDtoAxisValue[];
    columnMajorOrder: boolean;
}

export interface SizeSystemDtoSize {
    id: number;
    value: string;
    code?: string | undefined;
    isDefaultModelSize: boolean;
    skipSkuCodeAutoGeneration: boolean;
    columnLabel?: string | undefined;
    rowLabel?: string | undefined;
}

export interface SizeSystemDtoDefaultSize {
    gender?: Gender | undefined;
    sizeId: number;
    value: string;
}

export interface SizeSystemDtoAxisValue {
    axis: SizeSystemAxis;
    label: string;
    order: number;
    group?: string | undefined;
}

export enum SizeSystemAxis {
    Column = 0,
    Row = 1,
}

export interface AddSizeSystemArg {
    name: string;
    versions: AddSizeSystemArgVersion[];
}

export interface AddSizeSystemArgVersion {
    name: string;
    range: string[];
    defaultSizes?: SizeSystemDtoDefaultSize[] | undefined;
}

export interface SizeSystemUsagesDto {
    products: EntityReference[];
    /** Rounds whose measurement reports are on one of the charts; those charts can't be deleted while the round exists. */
    sampleRounds: EntityReference[];
    lookupTables: EntityReference[];
    /** Tables using it as their base column. */
    sizeConversionTables: EntityReference[];
    measurementCharts: EntityReference[];
    /** Tables using it in a later column, which becomes a custom column under the same name. */
    convertedSizeConversionTables: EntityReference[];
    blocksDelete: boolean;
}

export interface SkuCodeDto {
    id: number;
    name: string;
    internalComment: string;
    key: string;
    type: SkuCodeType;
    isStrictValidation: boolean;
    allowDuplicates: boolean;
    numericRangeIds: number[];
}

export enum SkuCodeType {
    Ean = "Ean",
    Upc = "Upc",
    Mixed = "Mixed",
}

export interface AddSkuCodeArgs {
    name: string;
    key: string;
    internalComment: string;
    type: SkuCodeType;
    isStrictValidation: boolean;
    allowDuplicates: boolean;
    numericRangeIds: number[];
}

export interface UpdateSkuCodeArgs {
    name: string;
    internalComment: string;
    isStrictValidation: boolean;
    allowDuplicates: boolean;
    numericRangeIds: number[];
}

export interface BadSkuCodeValueDto {
    value: string;
    reason: BadSkuCodeValueType;
    skus: SkuReferenceDto[];
}

export enum BadSkuCodeValueType {
    Duplicated = "Duplicated",
    InvalidFormat = "InvalidFormat",
}

export interface SkuReferenceDto {
    productId: number;
    productName: string;
    articleId: number;
    articleNumber: string;
    skuNumber: string;
    skuCodeId: number;
}

export interface GenerateSkuCodeValuesForSkusArgs3 {
    skuIds: number[];
    force: boolean;
}

export interface SkuCodeNumericRangeDto {
    id: number;
    name: string;
    internalComment: string;
    type: SkuCodeRangeType;
    from: string;
    to: string;
    current: string;
    total: number;
    used: number;
    remaining: number;
    percentUsed: number;
    reminders: SkuCodeNumericRangeReminderDto[];
}

export enum SkuCodeRangeType {
    Ean = "Ean",
    Upc = "Upc",
}

export interface SkuCodeNumericRangeReminderDto {
    id: number;
    threshold: number;
    recipientIds: string[];
}

export interface AddSkuCodeRangeArgs {
    name: string;
    internalComment: string;
    type: SkuCodeRangeType;
    from: string;
    to: string;
    current: string;
    reminders: ReminderArgs[];
}

export interface ReminderArgs {
    id?: number | undefined;
    threshold: number;
    userIds: string[];
}

export interface UpdateSkuCodeRangeArgs {
    name: string;
    internalComment: string;
    from: string;
    to: string;
    current: string;
    reminders: ReminderArgs[];
}

export interface UpdateSkuCodeValueArgs {
    value?: string | undefined;
}

export interface UpdateSkusBulkArgs {
    /** Where the SKUs' custom values land; null is not simply "base" (see the endpoint summary). */
    seasonId?: number | undefined;
    skus: UpdateSkusBulkItem[];
}

export interface UpdateSkusBulkItem {
    skuId: number;
    skuCodeValues: UpdateSkusBulkSkuCodeValue[];
    weight?: WeightPatchDto | undefined;
    customValues: CustomFieldIdWithValueDto[];
}

export interface UpdateSkusBulkSkuCodeValue {
    skuCodeId: number;
    value?: string | undefined;
}

export interface SkuNumberInfoResponse {
    currentNumber: string;
    isManuallySet: boolean;
    systemGeneratedNumber?: string | undefined;
    developmentNumber?: string | undefined;
}

export interface UpdateSkuNumberArgs {
    skuNumber?: string | undefined;
}

export interface UpdateSkuSeasonPricesArgs {
    seasonId?: number | undefined;
    supplierId?: number | undefined;
    destinationId: number;
    skus: UpdateSkuPricesItem[];
}

export interface UpdateSkuPricesItem {
    skuId: number;
    outPriceValues: UpdateSkuOutPriceArgs[];
    inPriceValues?: UpdateSkuInPriceArgs | undefined;
}

export interface UpdateSkuOutPriceArgs {
    outPriceId: number;
    amount?: number | undefined;
    currencyId: number;
    markupMarginTarget?: number | undefined;
    markupMarginType?: MarkupMarginType | undefined;
    linked?: boolean | undefined;
}

export interface UpdateSkuInPriceArgs {
    costPrice?: PriceDto | undefined;
    costPriceTarget?: PriceDto | undefined;
    costPriceLinked?: boolean | undefined;
    freightPercentage?: number | undefined;
    freightCharge?: PriceDto | undefined;
    freightLinked?: boolean | undefined;
    dutiesPercentage?: number | undefined;
    dutiesLinked?: boolean | undefined;
    stepValues?: InPriceStepValueArgs[] | undefined;
}

export type InPriceStepValueArgs = PercentageInPriceStepValueArgs | ChargeInPriceStepValueArgs;
export interface InPriceStepValueArgs_Interface {
    inPriceStepId: number;
    linked?: boolean | undefined;
    type: string;
}

export interface PercentageInPriceStepValueArgs extends InPriceStepValueArgs_Interface {
    type: 'PercentageInPriceStepValueArgs';
    percentage?: number | undefined;
}
export function isPercentageInPriceStepValueArgs(obj?: InPriceStepValueArgs): obj is PercentageInPriceStepValueArgs {
    return obj?.type === 'PercentageInPriceStepValueArgs';
}

export interface ChargeInPriceStepValueArgs extends InPriceStepValueArgs_Interface {
    type: 'ChargeInPriceStepValueArgs';
    amount?: number | undefined;
    currencyId?: number | undefined;
}
export function isChargeInPriceStepValueArgs(obj?: InPriceStepValueArgs): obj is ChargeInPriceStepValueArgs {
    return obj?.type === 'ChargeInPriceStepValueArgs';
}

export interface RecalculateSkuSeasonPricesArgs {
    seasonId?: number | undefined;
    skuIds: number[];
}

export interface SkuPriceDivergence {
    articleId: number;
    seasonId?: number | undefined;
    supplierId?: number | undefined;
    destinationId: number;
    field: SkuPriceDivergenceField;
    inPriceStepId?: number | undefined;
    outPriceId?: number | undefined;
    productId: number;
    productName: string;
    articleNumber: string;
    seasonName: string;
    supplierName?: string | undefined;
    destinationName: string;
    fieldLabel: string;
    derived: boolean;
    valueKind: SkuPriceDivergenceValueKind;
    fallbackCurrencyId: number;
    sizes: SkuPriceDivergenceSize[];
}

export enum SkuPriceDivergenceField {
    CostPrice = "CostPrice",
    CostPriceTarget = "CostPriceTarget",
    FreightPercentage = "FreightPercentage",
    FreightCharge = "FreightCharge",
    DutiesPercentage = "DutiesPercentage",
    StepPercentage = "StepPercentage",
    StepCharge = "StepCharge",
    OutPriceAmount = "OutPriceAmount",
    MarkupMarginTarget = "MarkupMarginTarget",
}

export enum SkuPriceDivergenceValueKind {
    Money = "Money",
    Percentage = "Percentage",
    Factor = "Factor",
}

export interface SkuPriceDivergenceSize {
    skuId: number;
    skuNumber: string;
    size: string;
    sizeOrder: number;
    amount?: number | undefined;
    currencyId?: number | undefined;
    markupMarginType?: MarkupMarginType | undefined;
    matches: boolean;
    linked: boolean;
    templateLinked: boolean;
}

export interface FixSkuPriceDivergenceArgs {
    articleId: number;
    seasonId?: number | undefined;
    supplierId?: number | undefined;
    copyInPrices: boolean;
    destinationId: number;
    sourceSkuId: number;
}

export interface SupplierPortalInvitationInfoDto {
    email: string;
    brandName: string;
    supplierName: string;
    userExists: boolean;
    isExpired: boolean;
    isAccepted: boolean;
}

export interface SupplierPortalMembershipDto {
    brandSupplierId: number;
    brandId: number;
    brandName: string;
    supplierName: string;
    companyId: number;
    companyName: string;
    role: SupplierPortalRole;
}

export interface SupplierPortalCompanyRefDto {
    companyId: number;
    name: string;
}

export interface SupplierPortalSampleRoundPageDto {
    rounds: SupplierPortalSampleRoundListDto[];
    totalCount: number;
}

export interface SupplierPortalSampleRoundListDto {
    id: number;
    brandSupplierId: number;
    brandId: number;
    brandName: string;
    supplierName: string;
    sampleRoundNumber: string;
    productName: string;
    productImagePath?: string | undefined;
    sampleRoundTypeName: string;
    sampleRoundTypeColor: string;
    createdAt: string;
    deadline: string;
    isClosed: boolean;
    lastActivityAt?: string | undefined;
    articleCount: number;
    articleColors: (ColorSuperSimple | undefined)[];
    sampleSent?: string | undefined;
    sampleReceived?: string | undefined;
    receivedCount: number;
    totalCount: number;
}

export interface SupplierPortalOrderPageDto {
    deliveries: SupplierPortalOrderDeliveryDto[];
    totalCount: number;
}

export interface SupplierPortalOrderDeliveryDto {
    id: number;
    orderId: number;
    brandSupplierId: number;
    brandId: number;
    brandName: string;
    orderNumber: string;
    externalOrderNumber?: string | undefined;
    deliveryNumber: string;
    externalDeliveryNumber?: string | undefined;
    placedAt?: string | undefined;
    seasonNames: string[];
    statusName: string;
    statusColor: string;
    state: OrderState;
    quantity?: number | undefined;
    shipmentPlanned?: string | undefined;
    shipmentActual?: string | undefined;
    arrivalPlanned?: string | undefined;
    arrivalActual?: string | undefined;
    products: SupplierPortalOrderProductDto[];
}

export interface SupplierPortalOrderProductDto {
    productName?: string | undefined;
    productImagePath?: string | undefined;
    quantity?: number | undefined;
    articleColors: (ColorSuperSimple | undefined)[];
}

export enum SupplierPortalOrderDeliverySort {
    Placed = "Placed",
    Order = "Order",
    Delivery = "Delivery",
    Status = "Status",
    Quantity = "Quantity",
    Shipment = "Shipment",
    Arrival = "Arrival",
    Product = "Product",
}

export interface SupplierPortalOrderDeliveryFacetsDto {
    quantities: SupplierPortalAmountCountDto[];
    placed: SupplierPortalDateCountDto[];
    shipment: SupplierPortalDateCountDto[];
    arrival: SupplierPortalDateCountDto[];
}

export interface SupplierPortalAmountCountDto {
    amount: number;
    count: number;
}

export interface SupplierPortalDateCountDto {
    date: string;
    count: number;
}

export interface SupplierPortalOrderDeliveryDetailDto {
    delivery: SupplierPortalOrderDeliveryDto;
    articles: SupplierPortalOrderArticleDto[];
}

export interface SupplierPortalOrderArticleDto {
    id: number;
    articleNumber: string;
    productId?: number | undefined;
    productName?: string | undefined;
    imagePath?: string | undefined;
    color?: ColorSuperSimple | undefined;
    quantity?: number | undefined;
    sizes: SupplierPortalOrderSizeDto[];
}

export interface SupplierPortalOrderSizeDto {
    size: string;
    quantity?: number | undefined;
}

export interface SupplierSampleRoundDto {
    id: number;
    productId: number;
    sampleRoundNumber: string;
    isClosed: boolean;
    isExpired: boolean;
    productName: string;
    productImagePath?: string | undefined;
    sampleRoundTypeName: string;
    sampleRoundTypeColor: string;
    createdAt: string;
    deadline: string;
    brandName: string;
    brandId: number;
    supplierId: number;
    createdByEmail?: string | undefined;
    articles: SupplierSampleRoundArticleDto[];
    supplierCountryAlpha3?: string | undefined;
    supplierLogo?: string | undefined;
    sizes: { [key: string]: { [key: string]: number; }; };
    files: SampleRoundFileDto[];
    mChartIds: number[];
    sampleRows: SampleRowDto[];
    events: SampleRoundEventDto[];
    sampleStatuses: SampleStatusDto[];
    measurementStatuses: MeasurementStatusDto[];
    informationRequestFields: SupplierInformationRequestFieldDto[];
}

export interface SupplierSampleRoundArticleDto {
    id: number;
    color?: ColorSuperSimple | undefined;
    articleNumber: string;
    imageUrl?: string | undefined;
    skus: SupplierSkuDto[];
}

export interface SupplierSkuDto {
    id: number;
    size: string;
}

export interface SupplierInformationRequestFieldDto {
    customFieldId?: number | undefined;
    builtInField?: InformationRequestBuiltInField | undefined;
    title: string;
    type: CustomFieldType;
    options: SupplierSelectOptionDto[];
    units: SupplierUnitDto[];
    currencies: SupplierCurrencyDto[];
    canBeAnsweredPerSku: boolean;
}

export enum CustomFieldType {
    Text = 0,
    PhysicalDimensions = 3,
    Money = 6,
    NumberWithUnit = 7,
    SingleSelect = 8,
    MultiSelect = 9,
    Files = 10,
}

export interface SupplierSelectOptionDto {
    id: number;
    value: string;
}

export interface SupplierUnitDto {
    id: number;
    name: string;
    symbol: string;
}

export interface SupplierCurrencyDto {
    id: number;
    code: string;
}

export interface SupplierMessageArgs {
    message: string;
    attachments?: MessageAttachment[] | undefined;
    images?: ReportImageArg[] | undefined;
    contactName?: string | undefined;
    isDraft: boolean;
    replacesDraftEventId?: number | undefined;
}

export interface SupplierSampleSentArgs {
    sentAt: string;
    trackingNumber?: string | undefined;
    trackingUrl?: string | undefined;
    contactName?: string | undefined;
    samples?: SupplierSentSampleParam[] | undefined;
    isDraft: boolean;
    replacesDraftEventId?: number | undefined;
}

export interface SupplierSentSampleParam {
    articleId: number;
    size: string;
    sentQuantity?: number | undefined;
}

export interface SupplierMeasurementReportArgs {
    mChartId: number;
    mChartVersionNumber: number;
    samples: SupplierMeasurementReportSampleArg[];
    images?: ReportImageArg[] | undefined;
    comment?: string | undefined;
    contactName?: string | undefined;
    newSamples?: SupplierNewMeasurementSampleArg[] | undefined;
    isDraft: boolean;
    replacesDraftEventId?: number | undefined;
}

export interface SupplierMeasurementReportSampleArg {
    sampleRowId: number;
    sampleSizeId: number;
    supplierValues?: { [key: string]: number; } | undefined;
}

export interface SupplierNewMeasurementSampleArg {
    articleId: number;
    size: string;
    supplierValues?: { [key: string]: number; } | undefined;
}

export interface SupplierInformationReplyArgs {
    informationRequestEventId: number;
    values: SupplierInformationReplyValueArg[];
    attachments: MessageAttachment[];
    contactName?: string | undefined;
    message?: string | undefined;
}

export interface SupplierInformationReplyValueArg {
    informationRequestFieldId: number;
    value: CustomFieldValueDto;
    skuId?: number | undefined;
}

export interface SupplierPortalRoundRecipientsDto {
    recipients: SupplierPortalRecipientDto[];
    colleagues: SupplierPortalColleagueDto[];
    brandPeople: SupplierPortalColleagueDto[];
}

export interface SupplierPortalRecipientDto {
    email: string;
    name?: string | undefined;
    photo?: string | undefined;
    isCc: boolean;
    isBrand: boolean;
}

export interface SupplierPortalColleagueDto {
    userId: string;
    name?: string | undefined;
    email: string;
    photo?: string | undefined;
}

export interface SupplierMeasurementDataDto {
    mCharts: MChartDto[];
    measurements: MeasurementDto[];
    sizeSystems: SizeSystemDto[];
    units: UnitDto[];
    assignedArticles: SupplierAssignedArticleDto[];
    seasons: SeasonDto[];
}

export interface UnitDto {
    id: number;
    symbol: string;
    name: string;
    physicalQuantity: PhysicalQuantity;
    canUseForComponentUnit: boolean;
    canUseForProductUnit: boolean;
    displayFormat: UnitDisplayFormat;
}

export enum PhysicalQuantity {
    Length = "Length",
    Area = "Area",
    Volume = "Volume",
    Weight = "Weight",
    Quantity = "Quantity",
    Other = "Other",
    Hardness = "Hardness",
    WeightPerLength = "WeightPerLength",
    WeightPerArea = "WeightPerArea",
    WeightPerVolume = "WeightPerVolume",
    QuantityPerWeight = "QuantityPerWeight",
    QuantityPerLength = "QuantityPerLength",
    QuantityPerArea = "QuantityPerArea",
    QuantityPerVolume = "QuantityPerVolume",
    Time = "Time",
}

export enum UnitDisplayFormat {
    Decimal = "Decimal",
    DyadicFraction = "DyadicFraction",
}

export interface SupplierAssignedArticleDto {
    id: number;
    color?: ColorSuperSimple | undefined;
    articleNumber: string;
    imageUrl?: string | undefined;
    mChartId?: number | undefined;
    seasonIds: number[];
}

export interface SetPersonArgs {
    role: SupplierPortalRole;
    brandSupplierIds: number[];
}

export interface InviteColleagueArgs {
    email: string;
    role: SupplierPortalRole;
    brandSupplierId: number;
}

export interface SupplierPortalCompanyDto {
    companyId: number;
    name?: string | undefined;
    countryId?: number | undefined;
    fullAddress?: string | undefined;
    oarId?: string | undefined;
    manufacturerId?: string | undefined;
    logo?: string | undefined;
    brandsWithOwnValues: SupplierPortalBrandOwnValuesDto[];
}

export interface SupplierPortalBrandOwnValuesDto {
    brandName: string;
    fields: SupplierCompanyField[];
}

export enum SupplierCompanyField {
    Name = "Name",
    Address = "Address",
    OarId = "OarId",
    ManufacturerId = "ManufacturerId",
}

export interface CompanyDetailsArgs {
    name: string;
    countryId?: number | undefined;
    fullAddress?: string | undefined;
    oarId?: string | undefined;
    manufacturerId?: string | undefined;
}

export interface RequestAccountResponse {
    email: string;
}

export interface SupplyChainStepTypeDto {
    id: number;
    name: string;
    icon?: string | undefined;
}

export interface CreateArgs {
    name: string;
    icon?: string | undefined;
}

export interface UpdateArgs2 {
    name: string;
    icon?: string | undefined;
}

export interface TableViewDto {
    id: number;
    tableKey: string;
    name: string;
    payload?: string | undefined;
    order: number;
    isDefault: boolean;
}

export interface CreateTableViewArgs {
    tableKey: string;
    name: string;
    payload: string;
}

export interface UpdateTableViewArgs {
    name: string;
    payload: string;
}

export interface ReorderTableViewsArgs {
    tableKey: string;
    viewIds: number[];
}

export interface TagCategoryDto {
    id: number;
    name: string;
    baseCategory: boolean;
    uniqueness: TagCategoryUniqueness;
    includeInArticleNumberGeneration: boolean;
    productLevel: boolean;
    hierarchyNodeIds: number[];
    tags: TagDto[];
}

export enum TagCategoryUniqueness {
    None = 0,
    Article = 2,
}

export interface TagDto {
    id: number;
    name: string;
    color: string;
    tagCategoryId: number;
    hierarchyNodeIds: number[];
}

export interface AddTagCategoryArgs {
    name: string;
    uniqueness: TagCategoryUniqueness;
}

export interface AddTagArgs4 {
    name: string;
    color: string;
    tagCategoryId: number;
}

export interface UpdateTagArgs5 {
    color?: string | undefined;
    name?: string | undefined;
    hierarchyNodeIds?: number[] | undefined;
}

export interface TagVisibilityLossDto {
    tagId: number;
    tagName: string;
    tagCategoryName: string;
    productLevel: boolean;
    usageCount: number;
}

export interface PreviewVisibilityArgs {
    hierarchyNodeIds: number[];
}

export interface UpdateTagCategoryArgs3 {
    name?: string | undefined;
    uniqueness: TagCategoryUniqueness;
    removeAllNodeRestrictions?: boolean | undefined;
    includeInArticleNumberGeneration?: boolean | undefined;
    hierarchyNodeIds?: number[] | undefined;
}

export interface ReorderTagCategoriesArgs {
    tagCategoryIds: number[];
}

export interface ReorderTagsArgs {
    tagIds: number[];
}

export interface ProductWithTagViolationsDto {
    productId: number;
    productNumber: string;
    productName: string;
    hierarchyNodeId?: number | undefined;
    violatingTags: TagViolationDto[];
}

export interface TagViolationDto {
    tagId: number;
    tagName: string;
    tagCategoryName: string;
}

export interface PreviewPromoteResult {
    affectedProducts: AffectedProduct[];
    unaffected: UnaffectedSummary;
}

export interface AffectedProduct {
    productId: number;
    productName: string;
    productNumber: string;
    tags: TagUsage2[];
    articlesGainingTag: number;
    rows: ArticleSeasonRow[];
}

export interface TagUsage2 {
    tagId: number;
    tagName: string;
    usageCount: number;
}

export interface ArticleSeasonRow {
    articleNumber: string;
    colorName?: string | undefined;
    seasonName?: string | undefined;
    tagNames: string[];
}

export interface UnaffectedSummary {
    products: number;
    articles: number;
    articleSeasons: number;
}

export interface PromoteToProductLevelArgs {
    resolutions?: PromoteResolution[] | undefined;
}

export interface PromoteResolution {
    productId: number;
    tagId: number;
}

export interface PreviewDemoteResult {
    affectedProducts: number;
    willFreezeArticleNumbers: boolean;
}

export interface TariffCodeSystemDto {
    id: number;
    type: TariffCodeSystemType;
    name: string;
    skipValidation: boolean;
    tariffCodes: TariffCodeDto[];
}

export enum TariffCodeSystemType {
    EU = 0,
    US = 1,
    EUCN = 2,
    FEDAS = 3,
    NO = 4,
    RU = 5,
    AVALARA = 6,
    CA = 7,
    DE = 8,
}

export interface TariffCodeDto {
    id: number;
    code: string;
    name?: string | undefined;
    description?: string | undefined;
    duties: TariffCodeDutyDto[];
}

export interface TariffCodeDutyDto {
    id: number;
    seasonId?: number | undefined;
    countryId: number;
    dutyPercentage: number;
}

export interface AddTariffCodeArgs {
    tariffCodeSystemId: number;
    value: string;
}

export interface CopyTariffCodesArgs {
    tariffCodeSystemId: number;
    tariffCodeIds: number[];
}

export interface UpdateTariffCodeArgs {
    value: string;
    name?: string | undefined;
    description?: string | undefined;
}

export interface BatchUpdateTariffCodesArgs {
    tariffCodeSystemId: number;
    ids: number[];
    field: TariffCodeField;
    value?: string | undefined;
}

export enum TariffCodeField {
    Name = 0,
    Description = 1,
    Value = 2,
}

export interface BatchSetTariffCodeFieldsArgs {
    tariffCodeSystemId: number;
    entries: BatchSetTariffCodeFieldsEntry[];
}

export interface BatchSetTariffCodeFieldsEntry {
    id: number;
    field: TariffCodeField;
    value?: string | undefined;
}

export interface TariffCodeUsageDto {
    products: EntityReference[];
    components: EntityReference[];
    lookupTables: EntityReference[];
}

export interface AddDutyArgs {
    seasonId?: number | undefined;
    countryId: number;
    dutyPercentage: number;
}

export interface UpdateDutyArgs {
    dutyPercentage: number;
}

export interface BatchUpdateDutiesArgs {
    tariffCodeSystemId: number;
    seasonId?: number | undefined;
    dutyPercentage?: number | undefined;
    entries: BatchUpdateDutiesEntry[];
}

export interface BatchUpdateDutiesEntry {
    tariffCodeId: number;
    countryId: number;
    /** False leaves the cell untouched. True with a null DutyPercentage clears it.
Without this flag the two cannot be told apart, because null already means "remove the duty". */
    hasValue: boolean;
    dutyPercentage?: number | undefined;
}

export interface CreateTariffCodeSystemArgs {
    type: TariffCodeSystemType;
    name: string;
}

export interface UpdateTariffCodeSystemArgs {
    name: string;
    skipValidation: boolean;
}

export interface TariffCodeSystemUsageDto {
    products: EntityReference[];
    components: EntityReference[];
    lookupTables: EntityReference[];
}

export interface SyncTaricArgs {
    /** Seasons to write duty rates to. A null entry is the Default (seasonless) rate. */
    seasonIds: (number | undefined)[];
    countryIds: number[];
    overrideExistingRates: boolean;
    overrideExistingDescriptions: boolean;
    syncRates: boolean;
    syncDescriptions: boolean;
}

export interface TimelineDto {
    id: number;
    name: string;
    gates: TimelineGateDto[];
    seasons: TimelineSeasonDto[];
    hierarchyNodeIds: number[];
    tagIds: number[];
}

export interface TimelineGateDto {
    id: number;
    name: string;
    offset: number;
    duration: number;
    roleId: number;
    party: TimelineParty;
}

export enum TimelineParty {
    Brand = 0,
    Supplier = 1,
}

export interface TimelineSeasonDto {
    seasonId: number;
    anchorDate: string;
    gateDates: TimelineGateDateDto[];
    drops: TimelineSeasonDropDto[];
}

export interface TimelineGateDateDto {
    gateId: number;
    due: string;
    duration: number;
}

export interface TimelineSeasonDropDto {
    dropId: number;
    anchorDate: string;
    gateDates: TimelineGateDateDto[];
}

export interface CreateTimelineArgs {
    name: string;
}

export interface UpdateTimelineArgs {
    name: string;
}

export interface CloneTimelineArgs {
    seasonIds: number[];
}

export interface TimelineUsage {
    articleCount: number;
    completionCount: number;
}

export interface PutGatesArgs {
    gates: GateArgs[];
}

export interface GateArgs {
    id?: number | undefined;
    name: string;
    offset: number;
    duration: number;
    roleId: number;
    party: TimelineParty;
}

export interface SetAnchorArgs {
    anchorDate: string;
}

export interface PutGateDatesArgs {
    gateDates: GateDateArgs[];
}

export interface GateDateArgs {
    gateId: number;
    due: string;
    duration: number;
}

export interface SetDropAnchorArgs {
    anchorDate: string;
}

export interface AnchorUsage {
    articleCount: number;
    completionCount: number;
}

export interface PutFiltersArgs {
    hierarchyNodeIds: number[];
    tagIds: number[];
}

export interface TreatmentDto {
    id: number;
    name?: string | undefined;
    typeId: number;
}

export interface CreateTreatmentArgs {
    name: string;
    typeId: number;
}

export interface UpdateTreatmentArgs {
    name: string;
}

export interface TreatmentTypeDto {
    id: number;
    name: string;
}

export interface TreatmentTypeArgs {
    name: string;
}

export interface CreateUnitArgs {
    name: string;
    symbol: string;
    physicalQuantity: PhysicalQuantity;
    canUseForComponentUnit: boolean;
    canUseForProductUnit: boolean;
    displayFormat: UnitDisplayFormat;
}

export interface UnitIdAndCount {
    id: number;
    count: number;
}

export interface UserConfigSection {
    name?: string | undefined;
    values?: KeyValuePairOfStringAndObject[] | undefined;
    children?: UserConfigSection[] | undefined;
}

export interface KeyValuePairOfStringAndObject {
    key?: string | undefined;
    value?: any | undefined;
}

export interface ConfigurationPair {
    key: string;
    value: string;
}

export interface RawConfiguration {
    personal: ConfigurationPair[];
    global: ConfigurationPair[];
}

export interface SetConfigurationBulkArgs {
    cells: SetConfigurationBulkCell[];
}

export interface SetConfigurationBulkCell {
    key: string;
    /** Whether the cell belongs to the brand's column or the user's own. */
    global: boolean;
    /** null unsets the key — the cell's empty state. */
    value?: string | undefined;
}

export interface SetPersonalConfigurationBulkArgs {
    values: PersonalConfigurationValue[];
}

export interface PersonalConfigurationValue {
    key: string;
    /** null unsets the key, as the single-key endpoints do. */
    value?: string | undefined;
}

export interface SetUserConfigArgs {
    userId: string;
    key: string;
    value: string;
}

export interface UnsetUserConfigArgs {
    userId: string;
    key: string;
}

export interface WebhookDto {
    id: number;
    name: string;
    enabled: boolean;
    url: string;
    environments: WebhookEnvironmentsDto;
    httpMethod: WebhookHttpMethod;
    basicAuth?: WebhookBasicAuthDto | undefined;
    throttleSeconds?: number | undefined;
    includeResourceInPayload: boolean;
    articlesApiVersion: number;
    articleStatusIds: number[];
}

export interface WebhookEnvironmentsDto {
    qa: boolean;
    prod: boolean;
}

export enum WebhookHttpMethod {
    POST = "POST",
    GET = "GET",
    PUT = "PUT",
}

export interface WebhookBasicAuthDto {
    user: string;
    hasKey: boolean;
}

export interface CreateWebhookArgs {
    name: string;
    enabled: boolean;
    url: string;
    environments: WebhookEnvironmentsDto;
    httpMethod: WebhookHttpMethod;
    basicAuth?: WebhookBasicAuthArgs | undefined;
    throttleSeconds?: number | undefined;
    includeResourceInPayload: boolean;
    articleStatusIds: number[];
    articlesApiVersion: number;
}

export interface WebhookBasicAuthArgs {
    user: string;
    key?: string | undefined;
}

export interface UpdateWebhookArgs {
    name: string;
    enabled: boolean;
    url: string;
    environments: WebhookEnvironmentsDto;
    httpMethod: WebhookHttpMethod;
    basicAuth?: WebhookBasicAuthArgs | undefined;
    throttleSeconds?: number | undefined;
    includeResourceInPayload: boolean;
    articlesApiVersion: number;
    articleStatusIds: number[];
}

export interface ArticleIntegrationDtoV3 {
    articleNumber: string;
    product: ProductIntegrationDtoV3;
    createdAt?: string | undefined;
    hierarchy: { [key: string]: ArticleIntegrationDtoHierarchyNode; };
    genders: string[];
    sizeSystemVersion?: SizeSystemVersionIntegrationDtoV3 | undefined;
    sizeConversionTable?: SizeConversionTableIntegrationDtoV3 | undefined;
    currentSeason: string;
    isCurrentChannelSeason: boolean;
    comment?: string | undefined;
    description?: string | undefined;
    customFieldValues: any;
    productCategory?: string | undefined;
    status: string;
    statusExternalCode?: string | undefined;
    color?: ColorIntegrationDtoV3 | undefined;
    bom?: ArticleIntegrationDtoBomV3 | undefined;
    drops: ArticleIntegrationDtoDrop[];
    tags: TagIntegrationDtoV3[];
    seasons: SeasonIntegrationDtoV3[];
    images: ArticleIntegrationDtoImageV3[];
    suppliers: SupplierIntegrationDtoV3[];
    skus: SkuIntegrationDtoV3[];
}

export interface ProductIntegrationDtoV3 {
    productNumber: string;
    name: string;
    customFieldValues: any;
    relatedProductNumber?: string | undefined;
}

export interface ArticleIntegrationDtoHierarchyNode {
    name: string;
    code?: string | undefined;
    description?: string | undefined;
}

export interface SizeSystemVersionIntegrationDtoV3 {
    sizeSystem: SizeSystemIntegrationDtoV3;
    name: string;
    sizes: SizeSystemVersionSizeIntegrationDtoV3[];
}

export interface SizeSystemIntegrationDtoV3 {
    name: string;
}

export interface SizeSystemVersionSizeIntegrationDtoV3 {
    value: string;
    code?: string | undefined;
}

export interface SizeConversionTableIntegrationDtoV3 {
    name: string;
    columns: SizeConversionTableColumnIntegrationDtoV3[];
}

export interface SizeConversionTableColumnIntegrationDtoV3 {
    sizeSystemName?: string | undefined;
    isCustomSizeSystem: boolean;
    sizes: SizeConversionTableColumnSizeIntegrationDtoV3[];
}

export interface SizeConversionTableColumnSizeIntegrationDtoV3 {
    value: string;
}

export interface ColorIntegrationDtoV3 {
    colorPaletteName?: string | undefined;
    group?: ColorGroupIntegrationDto | undefined;
    name?: string | undefined;
    code?: string | undefined;
    groupId?: number | undefined;
    c: number;
    m: number;
    y: number;
    k: number;
    r: number;
    g: number;
    b: number;
    number: string;
    palettes: string[];
}

export interface ColorGroupIntegrationDto {
    id: number;
    name: string;
    code?: string | undefined;
}

export interface ArticleIntegrationDtoBomV3 {
    version?: string | undefined;
    sections: ArticleIntegrationDtoBomSectionV3[];
}

export interface ArticleIntegrationDtoBomSectionV3 {
    name?: string | undefined;
    components: ArticleIntegrationDtoBomPlacementComponentV3[];
}

export interface ArticleIntegrationDtoBomPlacementComponentV3 {
    placement?: string | undefined;
    component?: ArticleIntegrationDtoBomComponentV3 | undefined;
    suppliers: SupplierIntegrationOld[];
    principal: boolean;
    componentSubType?: ComponentSubTypeIntegrationDto | undefined;
    composition: ComponentCompositionPartIntegrationDto[];
    comment?: string | undefined;
    tags: PlacementTagIntegrationDtoV3[];
    color?: ColorIntegrationDto | undefined;
}

export interface ArticleIntegrationDtoBomComponentV3 {
    id: number;
    componentNumber: string;
    name?: string | undefined;
    refNumber?: string | undefined;
    comment?: string | undefined;
    suppliers: SupplierArticleIntegrationDto[];
    componentTypeId?: number | undefined;
    componentType?: ComponentSubTypeIntegrationDto | undefined;
    composition: ComponentCompositionPartIntegrationDto[];
    attributes: ComponentAttributeIntegrationDto[];
    tags: ComponentTagIntegrationDto[];
}

export interface SupplierArticleIntegrationDto {
    id: number;
    name: string;
    country?: string | undefined;
}

export interface ComponentSubTypeIntegrationDto {
    id: number;
    name?: string | undefined;
    fullName: string;
}

export interface ComponentCompositionPartIntegrationDto {
    material: CompositionMaterialIntegrationDto;
    materialId: number;
    percentage: number;
}

export interface CompositionMaterialIntegrationDto {
    name: string;
    details: CompositionMaterialDetailIntegrationDto[];
}

export interface CompositionMaterialDetailIntegrationDto {
    type: string;
    value: string;
}

export interface ComponentAttributeIntegrationDto {
    quantity: number;
    unit: UnitIntegrationDto;
    type: ComponentAttributeTypeIntegrationDto;
}

export interface UnitIntegrationDto {
    symbol: string;
    name: string;
}

export interface ComponentAttributeTypeIntegrationDto {
    name: string;
}

export interface ComponentTagIntegrationDto {
    name: string;
    externalCode?: string | undefined;
    categoryName: string;
}

export interface SupplierIntegrationOld {
    id: number;
    name?: string | undefined;
    country?: CountryIntegrationDto | undefined;
    number?: string | undefined;
    externalNumber?: string | undefined;
}

export interface CountryIntegrationDto {
    code: string;
    codeAlpha3: string;
    name: string;
}

export interface PlacementTagIntegrationDtoV3 {
    name: string;
    category: string;
}

export interface AutomaticDates {
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
}

export interface ColorIntegrationBase extends AutomaticDates {
    name?: string | undefined;
    code?: string | undefined;
    groupId?: number | undefined;
    c: number;
    m: number;
    y: number;
    k: number;
    r: number;
    g: number;
    b: number;
}

export interface ColorIntegrationDto extends ColorIntegrationBase {
    colorPaletteName?: string | undefined;
    group?: ColorGroupIntegrationDto | undefined;
}

export interface ArticleIntegrationDtoDrop {
    date: string;
    period: string;
    name?: string | undefined;
}

export interface TagIntegrationDtoV3 {
    name: string;
    color: string;
    category: string;
}

export interface SeasonIntegrationDtoV3 {
    name: string;
    color: string;
}

export interface ArticleIntegrationDtoImageV3 {
    url: string;
    path: string;
    name: string;
    tags: ArticleIntegrationDtoImageTagV3[];
}

export interface ArticleIntegrationDtoImageTagV3 {
    name: string;
    color: string;
    category: string;
}

export interface SupplierIntegrationDtoV3 {
    id: number;
    supplierNumber?: string | undefined;
    number: string;
    externalNumber?: string | undefined;
    name: string;
    countryOfOrigin?: CountryIntegrationDto | undefined;
    country?: CountryIntegrationDto | undefined;
}

export interface SkuIntegrationDtoV3 {
    skuNumber: string;
    size: SizeSystemVersionSizeIntegrationDtoV3;
    codes: { [key: string]: string; };
    weightUnit: WeightUnit;
    grossWeight?: number | undefined;
    netWeight?: number | undefined;
    tariffCodes: TariffCodeIntegrationDtoV3[];
    customFieldValues: any;
    prices: any;
}

export interface TariffCodeIntegrationDtoV3 {
    system: TariffCodeSystemIntegrationDtoV3;
    code: string;
}

export interface TariffCodeSystemIntegrationDtoV3 {
    type: TariffCodeSystemType;
    name: string;
}

export interface GetArticlesV3Response {
    items: GetArticlesV3Item[];
    pagination: Pagination;
}

export interface GetArticlesV3Item {
    articleNumber: string;
    channels: { [key: string]: ArticleIntegrationDtoV3; };
}

export interface Pagination {
    count: number;
    totalCount: number;
    hasMore: boolean;
    offset: number;
    limit: number;
}

export interface GetArticlesByNumbersV3Response {
    items: GetArticlesV3Item[];
    pagination: Pagination;
    notFoundCount: number;
    notFoundArticleNumbers: string[];
}

export interface GetArticlesByNumbersV3Args {
    articleNumbers: string[];
    offset: number;
    limit: number;
}

export interface GetArticlesBySkuNumbersV3Response {
    items: GetArticlesV3Item[];
    pagination: Pagination;
    notFoundCount: number;
    notFoundSkuNumbers: string[];
}

export interface GetArticlesBySkuNumbersV3Args {
    skuNumbers: string[];
    offset: number;
    limit: number;
}

export interface ArticleIntegrationDtoV3Seasons {
    articleNumber: string;
    seasons: ArticleIntegrationDtoV3[];
}

export interface GetArticlesV3SeasonsResponse {
    items: ArticleIntegrationDtoV3Seasons[];
    pagination: Pagination;
}

export interface GetArticlesByNumbersV3SeasonsResponse {
    items: ArticleIntegrationDtoV3Seasons[];
    pagination: Pagination;
    notFoundCount: number;
    notFoundArticleNumbers: string[];
}

export interface GetArticlesByNumbersV3SeasonsArgs {
    articleNumbers: string[];
    offset: number;
    limit: number;
}

export interface ArticleIntegrationDto {
    id: number;
    articleNumber: string;
    productArticleNumber: number;
    productId: number;
    productNumber: number;
    productIdentifier: string;
    productName: string;
    productCustomFields: any;
    division?: number | undefined;
    productTypeId?: number | undefined;
    productType?: ArticleIntegrationDtoProductType | undefined;
    hierarchy: { [key: string]: ArticleIntegrationDtoHierarchyNode; };
    productCategoryId?: number | undefined;
    productCategory?: ArticleIntegrationDtoProductCategory | undefined;
    status: ArticleIntegrationStatusDto;
    color?: ColorIntegrationDto | undefined;
    genders: Gender[];
    sizeSystem?: SizeSystemMinimalIntegrationDto | undefined;
    sizeSystemVersionId?: number | undefined;
    sizeSystemVersion?: SizeSystemVersionIntegration | undefined;
    sizeConversionTable?: SizeConversionTableIntegrationDto | undefined;
    skus: SkuIntegrationDto[];
    comment?: string | undefined;
    description?: string | undefined;
    tags: TagIntegrationDto[];
    seasons: SeasonIntegrationDto[];
    images: ArticleIntegrationDtoImage[];
    suppliers: ProductSupplierArticleIntegrationDto[];
    tariffCodes: TariffCodeIntegrationDto[];
    prices?: any | undefined;
    weightUnit: WeightUnit;
    grossWeight?: number | undefined;
    netWeight?: number | undefined;
    customFields: any;
    retailPrice?: number | undefined;
    retailPriceCurrencyCode?: string | undefined;
    retailPriceCurrencyId: number;
    wholesalePrice?: number | undefined;
    wholesalePriceCurrencyCode?: string | undefined;
    wholesalePriceCurrencyId: number;
    targetWholesaleMarkup?: number | undefined;
    factoryWholesaleMarkup?: number | undefined;
    targetMarkup?: number | undefined;
    factoryMarkup?: number | undefined;
    targetPrice?: number | undefined;
    targetPriceCurrencyCode?: string | undefined;
    targetPriceCurrencyId: number;
    factoryPrice?: number | undefined;
    factoryPriceCurrencyCode?: string | undefined;
    factoryPriceCurrencyId: number;
    bom?: ArticleIntegrationDtoBom | undefined;
    createdAt?: string | undefined;
    drops: ArticleIntegrationDtoDrop[];
    seasonalData: SeasonalDataIntegrationDto[];
    relatedProduct?: ArticleIntegrationDtoRelatedProduct | undefined;
}

export interface ArticleIntegrationDtoProductType {
    id: number;
    name: string;
}

export interface ArticleIntegrationDtoProductCategory {
    id: number;
    name: string;
}

export interface ArticleIntegrationStatusDto {
    id: number;
    name: string;
}

export interface SizeSystemMinimalIntegrationDto {
    id: number;
    name?: string | undefined;
}

export interface SizeSystemVersionIntegration {
    id: number;
    sizeSystemId: number;
    name?: string | undefined;
    custom: boolean;
    sizes?: SizeSystemVersionIntegrationSize[] | undefined;
}

export interface SizeSystemVersionIntegrationSize {
    value?: string | undefined;
}

export interface SizeConversionTableIntegrationDto {
    id: number;
    name: string;
    columns: SizeConversionTableIntegrationDtoColumn[];
}

export interface SizeConversionTableIntegrationDtoColumn {
    sizeSystemId?: number | undefined;
    sizeSystem?: SizeSystemMinimalIntegrationDto | undefined;
    customSizeSystemName?: string | undefined;
    sizes: SizeConversionTableIntegrationDtoColumnSize[];
}

export interface SizeConversionTableIntegrationDtoColumnSize {
    value: string;
}

export interface SkuIntegrationDto {
    id: number;
    skuNumber: string;
    articleSkuNumber: number;
    size: ProductSizeIntegration;
    ean?: string | undefined;
    codes: { [key: string]: string; };
    customFields: any;
}

export interface ProductSizeIntegration {
    id: number;
    value: string;
    code?: string | undefined;
}

export interface TagIntegrationDto {
    id: number;
    name?: string | undefined;
    color?: string | undefined;
    category?: TagIntegrationDtoTagCategory | undefined;
}

export interface TagIntegrationDtoTagCategory {
    id: number;
    name?: string | undefined;
}

export interface SeasonIntegrationDto {
    id: number;
    name?: string | undefined;
    color?: string | undefined;
    start?: string | undefined;
    end?: string | undefined;
}

export interface ArticleIntegrationDtoImage {
    url: string;
    path: string;
}

export interface ProductSupplierArticleIntegrationDto {
    id: number;
    name: string;
    countryOfOrigin: CountryIntegrationDto;
    country: CountryIntegrationDto;
    number?: string | undefined;
    externalNumber?: string | undefined;
}

export interface TariffCodeIntegrationDto {
    tariffCodeSystem: TariffCodeSystemType;
    value: string;
}

export interface ArticleIntegrationDtoBom {
    version?: string | undefined;
    sections: ArticleIntegrationDtoBomSection[];
}

export interface ArticleIntegrationDtoBomSection {
    name?: string | undefined;
    components: ArticleIntegrationDtoBomPlacementComponent[];
}

export interface ArticleIntegrationDtoBomPlacementComponent {
    placement?: string | undefined;
    component?: ArticleIntegrationDtoBomComponent | undefined;
    suppliers: SupplierIntegrationOld[];
    principal: boolean;
    componentSubType?: ComponentSubTypeIntegrationDto | undefined;
    composition: ComponentCompositionPartIntegrationDto[];
    comment?: string | undefined;
    color?: ColorIntegrationDto | undefined;
}

export interface ArticleIntegrationDtoBomComponent {
    id: number;
    componentNumber: string;
    name?: string | undefined;
    refNumber?: string | undefined;
    comment?: string | undefined;
    suppliers: SupplierArticleIntegrationDto[];
    componentTypeId?: number | undefined;
    componentType?: ComponentSubTypeIntegrationDto | undefined;
    composition: ComponentCompositionPartIntegrationDto[];
    attributes: ComponentAttributeIntegrationDto[];
    tags: ComponentTagIntegrationDto[];
}

export interface SeasonalDataIntegrationDto {
    seasonId: number;
    seasonName: string;
    customFieldValues: any;
    productCustomFieldValues: any;
    skus: SkuSeasonalDataIntegrationDto[];
    suppliers: ProductSupplierArticleIntegrationDto[];
    prices?: any | undefined;
}

export interface SkuSeasonalDataIntegrationDto {
    id: number;
    skuNumber: string;
    customFieldValues: any;
}

export interface ArticleIntegrationDtoRelatedProduct {
    productNumber: string;
}

export interface ArticleIntegrationDtoOld {
    id: number;
    articleNumber?: string | undefined;
    productArticleNumber: number;
    productId: number;
    productNumber: number;
    productName?: string | undefined;
    productCustomFields?: any | undefined;
    division?: number | undefined;
    productTypeId?: number | undefined;
    productCategoryId?: number | undefined;
    status: ArticleIntegrationStatusOld;
    color?: ColorIntegrationDtoOld | undefined;
    genders?: Gender[] | undefined;
    sizeSystem?: SizeSystemMinimalIntegrationDto | undefined;
    sizeConversionTable?: SizeConversionTableIntegrationDtoOld | undefined;
    skus?: SkuIntegrationDtoOld[] | undefined;
    comment?: string | undefined;
    description?: string | undefined;
    tags?: TagIntegrationDto[] | undefined;
    seasons?: SeasonIntegrationDto[] | undefined;
    images?: string[] | undefined;
    suppliers?: ArticleSeasonSupplierIntegrationDtoOld[] | undefined;
    tariffCodes?: TariffCodeIntegrationDto[] | undefined;
    drops?: ArticleIntegrationDtoDrop[] | undefined;
    weightUnit: WeightUnit;
    grossWeight?: number | undefined;
    netWeight?: number | undefined;
    customFields?: any | undefined;
    retailPrice?: number | undefined;
    retailPriceCurrencyId: number;
    wholesalePrice?: number | undefined;
    wholesalePriceCurrencyId: number;
    targetWholesaleMarkup?: number | undefined;
    factoryWholesaleMarkup?: number | undefined;
    targetMarkup?: number | undefined;
    factoryMarkup?: number | undefined;
    targetPrice?: number | undefined;
    targetPriceCurrencyId: number;
    factoryPrice?: number | undefined;
    factoryPriceCurrencyId: number;
    lastId?: number | undefined;
    measurementListId?: number | undefined;
    bom?: ArticleIntegrationDtoBomOld | undefined;
    createdAt?: string | undefined;
}

export enum ArticleIntegrationStatusOld {
    Idea = 0,
    InDevelopment = 1,
    ReadyToOrder = 2,
    Archive = 3,
    Other = 4,
}

export interface ColorIntegrationDtoOld extends ColorIntegrationBase {
    colorPaletteName?: string | undefined;
    group?: ColorGroupIntegrationDto | undefined;
}

export interface SizeConversionTableIntegrationDtoOld {
    id: number;
    name: string;
    columns: SizeConversionTableIntegrationDtoColumnOld[];
}

export interface SizeConversionTableIntegrationDtoColumnOld {
    sizeSystemId?: number | undefined;
    sizeSystem?: SizeSystemMinimalIntegrationDto | undefined;
    customSizeSystemName?: string | undefined;
    order: number;
    sizes: SizeConversionTableIntegrationDtoColumnSizeOld[];
}

export interface SizeConversionTableIntegrationDtoColumnSizeOld {
    value: string;
    order: number;
}

export interface SkuIntegrationDtoOld {
    id: number;
    skuNumber?: string | undefined;
    articleSkuNumber: number;
    size?: ProductSizeIntegration | undefined;
    ean?: string | undefined;
}

export interface ArticleSeasonSupplierIntegrationDtoOld {
    id: number;
    name?: string | undefined;
    countryOfOrigin?: CountryIntegrationDto | undefined;
    country?: CountryIntegrationDto | undefined;
    number?: string | undefined;
    externalNumber?: string | undefined;
}

export interface ArticleIntegrationDtoBomOld {
    version?: string | undefined;
    sections?: ArticleIntegrationDtoBomSectionOld[] | undefined;
}

export interface ArticleIntegrationDtoBomSectionOld {
    name?: string | undefined;
    components?: ArticleIntegrationDtoBomPlacementComponentOld[] | undefined;
}

export interface ArticleIntegrationDtoBomPlacementComponentOld {
    placement?: string | undefined;
    component?: ArticleIntegrationDtoBomComponentDtoOld | undefined;
    suppliers?: SupplierIntegrationOld[] | undefined;
    principal: boolean;
    componentSubType?: ComponentSubTypeDtoOld | undefined;
    composition?: ComponentCompositionPartDto[] | undefined;
    comment?: string | undefined;
    color?: ColorIntegrationDtoOld | undefined;
}

export interface ArticleIntegrationDtoBomComponentDtoOld {
    id: number;
    componentNumber?: string | undefined;
    name?: string | undefined;
    refNumber?: string | undefined;
    comment?: string | undefined;
    suppliers?: SupplierArticleIntegrationDto[] | undefined;
    componentTypeId?: number | undefined;
    componentType?: ComponentSubTypeDtoOld | undefined;
    composition: ComponentCompositionPartDto[];
    attributes: ComponentAttributeDto[];
    tags: ComponentTagIntegrationDto[];
}

export interface ComponentSubTypeDtoOld {
    id: number;
    name?: string | undefined;
    fullName: string;
}

export interface GetArticlesResponse {
    items: ArticleIntegrationDto[];
    pagination: Pagination2;
}

export interface Pagination2 {
    count: number;
    totalCount: number;
    hasMore: boolean;
    offset: number;
    limit: number;
}

export interface GetArticlesByNumberResponse {
    items: ArticleIntegrationDto[];
    pagination: Pagination2;
    notFoundCount: number;
    notFoundArticleNumbers: string[];
}

export interface GetArticlesByNumbersArgs {
    articleNumbers: string[];
    offset: number;
    limit: number;
}

export interface CustomerIntegrationDto {
    id: number;
    name: string;
    customerNumber?: string | undefined;
}

export interface CreateCustomerArgs {
    name: string;
    customerNumber?: string | undefined;
}

export interface DeliveryLocationIntegrationDto {
    id: number;
    name: string;
    locationNumber?: string | undefined;
    destinationId?: number | undefined;
}

export interface DestinationIntegrationDto {
    id: number;
    name: string;
}

export interface CreateDeliveryLocationArgs {
    name: string;
    locationNumber?: string | undefined;
    destinationId?: number | undefined;
}

export interface OrderTypeIntegrationDto {
    id: number;
    name: string;
}

export interface CustomerOrderIntegrationDto {
    id: number;
    orderNumber?: string | undefined;
    customer: CustomerIntegrationDto;
    deliveries: CustomerOrderIntegrationDtoDelivery[];
}

export interface CustomerOrderIntegrationDtoDelivery {
    id: number;
    deliveryNumber?: string | undefined;
    arrivalDate?: string | undefined;
    deliveryLocation?: DeliveryLocationIntegrationDto | undefined;
    rows: CustomerOrderIntegrationDtoRow[];
}

export interface CustomerOrderIntegrationDtoRow {
    id: number;
    rowNumber?: string | undefined;
    quantity: number;
    sku: SkuIntegrationDto;
    allocations: CustomerOrderIntegrationDtoAllocation[];
}

export interface CustomerOrderIntegrationDtoAllocation {
    id: number;
    quantity: number;
    allocationNumber?: string | undefined;
    deliveryId: number;
    deliveryNumber: string;
}

export interface CreateCustomerOrderArgs {
    orderNumber?: string | undefined;
    customerId: number;
}

export interface UpdateCustomerOrderArgs {
    orderNumber?: string | undefined;
    customerId: number;
}

export interface AddDeliveryArgs {
    deliveryLocationId?: number | undefined;
    arrivalDate?: string | undefined;
    deliveryNumber?: string | undefined;
}

export interface UpdateDeliveryArgs2 {
    deliveryLocationId?: number | undefined;
    arrivalDate?: string | undefined;
    deliveryNumber?: string | undefined;
}

export interface AddRowArgs {
    rowNumber?: string | undefined;
    skuNumber: string;
    quantity: number;
}

export interface UpdateRowArgs {
    rowNumber?: string | undefined;
    skuNumber: string;
    quantity: number;
}

export interface AddAllocationArgs {
    allocationNumber?: string | undefined;
    quantity: number;
    deliveryId: number;
}

export interface UpdateAllocationArgs {
    allocationNumber?: string | undefined;
    quantity: number;
}

export interface OrderIntegrationDto {
    id: number;
    orderNumber: string;
    externalOrderNumber?: string | undefined;
    supplier?: SupplierIntegrationOld | undefined;
    seasons: SeasonIntegrationDto[];
    tags: OrderTagIntegrationDto[];
    type?: OrderTypeIntegrationDto | undefined;
    plannedPlacement?: string | undefined;
    actualPlacement?: string | undefined;
    customFields: any;
    deliveries: OrderIntegrationDtoDelivery[];
}

export interface OrderTagIntegrationDto {
    id: number;
    name?: string | undefined;
    color?: string | undefined;
    categoryId: number;
}

export interface OrderIntegrationDtoDelivery {
    id: number;
    deliveryNumber: string;
    locked: boolean;
    status: OrderStatusIntegrationDto;
    plannedShippingDate?: string | undefined;
    actualShippingDate?: string | undefined;
    plannedDeliveryDate?: string | undefined;
    actualDeliveryDate?: string | undefined;
    modeOfTransport?: ModeOfTransportIntegrationDto | undefined;
    tags: OrderTagIntegrationDto[];
    deliveryLocation?: DeliveryLocationIntegrationDto | undefined;
    customFields: any;
    rows: OrderIntegrationDtoRow[];
    allocations: OrderIntegrationDtoAllocation[];
}

export interface OrderStatusIntegrationDto {
    id: number;
    name: string;
    state: string;
}

export interface ModeOfTransportIntegrationDto {
    id: number;
    name: string;
}

export interface OrderIntegrationDtoRow {
    id: number;
    quantity: number;
    price?: OrderIntegrationDtoPrice | undefined;
    sku: SkuIntegrationDto;
}

export interface OrderIntegrationDtoPrice {
    unitPrice: number;
    currency: CurrencyIntegrationDto;
}

export interface CurrencyIntegrationDto {
    symbol: string;
    code: string;
}

export interface OrderIntegrationDtoAllocation {
    id: number;
    quantity: number;
    allocationNumber?: string | undefined;
    customerOrderRowNumber?: string | undefined;
    customerOrderRowId: number;
    customerOrderDeliveryNumber?: string | undefined;
    customerOrderDeliveryId: number;
    customerOrderNumber?: string | undefined;
    customerOrderId: number;
    skuNumber: string;
    skuId: number;
}

export interface CreateOrderArgs {
    orderNumber?: string | undefined;
    supplierId?: number | undefined;
    seasonIds?: number[] | undefined;
    tagIds?: number[] | undefined;
    typeId?: number | undefined;
    deliveryNumber?: string | undefined;
    arrivalDate?: string | undefined;
    deliveryLocationId?: number | undefined;
    modeOfTransportId?: number | undefined;
}

export interface UpdateOrderArgs {
    supplierId?: number | undefined;
    seasonIds?: number[] | undefined;
    tagIds?: number[] | undefined;
    typeId?: number | undefined;
}

export interface AddOrderDeliveryArgs {
    deliveryNumber?: string | undefined;
    arrivalDate?: string | undefined;
    deliveryLocationId?: number | undefined;
    modeOfTransportId?: number | undefined;
    tagIds?: number[] | undefined;
}

export interface UpdateOrderDeliveryArgs {
    arrivalDate?: string | undefined;
    deliveryLocationId?: number | undefined;
    modeOfTransportId?: number | undefined;
    tagIds?: number[] | undefined;
}

export interface AddOrderRowArgs {
    rowSizeNumber?: string | undefined;
    skuNumber: string;
    quantity: number;
}

export interface UpdateOrderRowArgs {
    quantity: number;
}

export interface SupplierIntegrationDto {
    id: number;
    name: string;
    supplierNumber: string;
    externalNumber?: string | undefined;
    country: CountryIntegrationDto;
    fullAddress?: string | undefined;
    email?: string | undefined;
    customFields: any;
    manufacturerId?: string | undefined;
    oarId?: string | undefined;
    deliveryTerm?: DeliveryTermIntegrationDto | undefined;
    paymentTerm?: PaymentTermIntegrationDto | undefined;
    modeOfTransport?: ModeOfTransportIntegrationDto | undefined;
    defaultCurrency?: CurrencyIntegrationDto | undefined;
    defaultCountryOfOrigin?: CountryIntegrationDto | undefined;
    leadTimeDays?: number | undefined;
    status: string;
    internalComment: string;
}

export interface DeliveryTermIntegrationDto {
    name: string;
    fullName?: string | undefined;
}

export interface PaymentTermIntegrationDto {
    name: string;
}

export interface UpsertSupplierArgs {
    name: string;
    countryCode: string;
    supplierNumber?: string | undefined;
    externalNumber?: string | undefined;
    fullAddress?: string | undefined;
    email?: string | undefined;
    manufacturerId?: string | undefined;
    oarId?: string | undefined;
    deliveryTermName?: string | undefined;
    paymentTermName?: string | undefined;
    modeOfTransportName?: string | undefined;
    defaultCurrencyCode?: string | undefined;
    defaultCountryOfOriginCode?: string | undefined;
    leadTimeDays?: number | undefined;
    internalComment?: string | undefined;
    statusName?: string | undefined;
}

export interface NonUserFieldValues {
    fieldValues: { [key: string]: string; };
}

export interface SupplierStatusIntegrationDto {
    name: string;
}

export interface OrderTagCategoryIntegrationDto {
    id: number;
    name?: string | undefined;
    uniqueness: OrderTagCategoryUniqueness2;
    tags?: OrderTagIntegrationDto[] | undefined;
}

export enum OrderTagCategoryUniqueness2 {
    None = "None",
    Order = "Order",
    OrderDelivery = "OrderDelivery",
}

export interface AddOrderTagCategoryArgs2 {
    name: string;
    uniqueness: OrderTagCategoryUniqueness2;
}

export interface AddOrderTagArgs2 {
    name: string;
    color: RgbColorDto;
    categoryId: number;
}

export interface RgbColorDto {
    r: number;
    g: number;
    b: number;
}

export interface UpdateOrderTagArgs2 {
    name: string;
    color: RgbColorDto;
}

export interface ComponentIntegrationDto {
    id: number;
    componentNumber: string;
    name?: string | undefined;
    refNumber?: string | undefined;
    comment?: string | undefined;
    suppliers: ComponentIntegrationDtoSupplier[];
    componentType?: ComponentSubTypeIntegrationDto | undefined;
    composition: ComponentCompositionPartIntegrationDto[];
    attributes: ComponentAttributeIntegrationDto[];
    unit?: UnitIntegrationDto | undefined;
    images: ComponentIntegrationDtoImage[];
    tags: ComponentTagIntegrationDto[];
    customFields: any;
}

export interface ComponentIntegrationDtoSupplier {
    supplier: SupplierIntegrationDto;
    countryOfOrigin?: CountryIntegrationDto | undefined;
    rawMaterialOrigin?: CountryIntegrationDto | undefined;
}

export interface ComponentIntegrationDtoImage {
    url: string;
    path: string;
}

export interface GetComponentsResponse {
    items: ComponentIntegrationDto[];
    pagination: Pagination2;
}

export interface GetComponentsByNumberResponse {
    items: ComponentIntegrationDto[];
    pagination: Pagination2;
    notFoundCount: number;
    notFoundComponentNumbers: string[];
}

export interface GetComponentsByNumbersArgs {
    componentNumbers: string[];
    offset: number;
    limit: number;
}

export interface CustomFieldsByEntityIntegrationDto {
    product: CustomFieldIntegrationDto[];
    article: CustomFieldIntegrationDto[];
    sku: CustomFieldIntegrationDto[];
    brandSupplier: CustomFieldIntegrationDto[];
    component: CustomFieldIntegrationDto[];
    order: CustomFieldIntegrationDto[];
    orderDelivery: CustomFieldIntegrationDto[];
}

export interface CustomFieldIntegrationDto {
    key: string;
    type: CustomFieldType2;
    title: string;
    groupTitle: string;
    exampleValue: any;
}

export enum CustomFieldType2 {
    Text = "Text",
    PhysicalDimensions = "PhysicalDimensions",
    Money = "Money",
    NumberWithUnit = "NumberWithUnit",
    SingleSelect = "SingleSelect",
    MultiSelect = "MultiSelect",
    Files = "Files",
}

export interface BulkSetNonUserFieldArgs {
    products: { [key: string]: NonUserFieldValues; };
    articles: { [key: string]: NonUserFieldValues; };
    skus: { [key: string]: NonUserFieldValues; };
}

export interface WebhookIntegrationDto {
    id: number;
    name: string;
    enabled: boolean;
    url: string;
    httpMethod: WebhookHttpMethod;
    qa: boolean;
    prod: boolean;
    basicAuthUser?: string | undefined;
    throttleSeconds?: number | undefined;
    includeResourceInPayload: boolean;
    articlesApiVersion: number;
}

export interface IntegrationCreateWebhookArgs {
    name: string;
    url: string;
    httpMethod?: WebhookHttpMethod | undefined;
    enabled?: boolean | undefined;
    qa?: boolean | undefined;
    prod?: boolean | undefined;
    basicAuth?: IntegrationWebhookBasicAuthArgs | undefined;
    throttleSeconds?: number | undefined;
    includeResourceInPayload?: boolean | undefined;
}

export interface IntegrationWebhookBasicAuthArgs {
    user: string;
    key?: string | undefined;
}

export type FileParameter = File;
export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}